import E, { useState as ye, createContext as ua, useEffect as _e, useContext as Mt, useRef as ve, Fragment as gn, useId as Yf, useLayoutEffect as uv, useMemo as Tr, useReducer as gw, Component as Kf, isValidElement as Yr, Children as Ua, PureComponent as Pr, forwardRef as yw, useImperativeHandle as bw, useCallback as Cw, cloneElement as Rt, createElement as fv } from "react";
import Xf, { unstable_batchedUpdates as xw } from "react-dom";
var Ba = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ze(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function qe(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      if (this instanceof n) {
        var a = [null];
        a.push.apply(a, arguments);
        var i = Function.bind.apply(t, a);
        return new i();
      }
      return t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var $3 = { exports: {} }, Fo = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var v5;
function ww() {
  if (v5)
    return Fo;
  v5 = 1;
  var e = E, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, l, c) {
    var u, d = {}, p = null, h = null;
    c !== void 0 && (p = "" + c), l.key !== void 0 && (p = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      n.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps)
      for (u in l = s.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: p, ref: h, props: d, _owner: a.current };
  }
  return Fo.Fragment = r, Fo.jsx = o, Fo.jsxs = o, Fo;
}
var Wo = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var m5;
function Ow() {
  return m5 || (m5 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = E, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = Symbol.iterator, v = "@@iterator";
    function g(q) {
      if (q === null || typeof q != "object")
        return null;
      var ie = m && q[m] || q[v];
      return typeof ie == "function" ? ie : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(q) {
      {
        for (var ie = arguments.length, le = new Array(ie > 1 ? ie - 1 : 0), Ee = 1; Ee < ie; Ee++)
          le[Ee - 1] = arguments[Ee];
        w("error", q, le);
      }
    }
    function w(q, ie, le) {
      {
        var Ee = b.ReactDebugCurrentFrame, Ue = Ee.getStackAddendum();
        Ue !== "" && (ie += "%s", le = le.concat([Ue]));
        var st = le.map(function(Re) {
          return String(Re);
        });
        st.unshift("Warning: " + ie), Function.prototype.apply.call(console[q], console, st);
      }
    }
    var x = !1, y = !1, O = !1, P = !1, j = !1, T;
    T = Symbol.for("react.module.reference");
    function I(q) {
      return !!(typeof q == "string" || typeof q == "function" || q === n || q === i || j || q === a || q === c || q === u || P || q === h || x || y || O || typeof q == "object" && q !== null && (q.$$typeof === p || q.$$typeof === d || q.$$typeof === o || q.$$typeof === s || q.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      q.$$typeof === T || q.getModuleId !== void 0));
    }
    function R(q, ie, le) {
      var Ee = q.displayName;
      if (Ee)
        return Ee;
      var Ue = ie.displayName || ie.name || "";
      return Ue !== "" ? le + "(" + Ue + ")" : le;
    }
    function F(q) {
      return q.displayName || "Context";
    }
    function $(q) {
      if (q == null)
        return null;
      if (typeof q.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof q == "function")
        return q.displayName || q.name || null;
      if (typeof q == "string")
        return q;
      switch (q) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof q == "object")
        switch (q.$$typeof) {
          case s:
            var ie = q;
            return F(ie) + ".Consumer";
          case o:
            var le = q;
            return F(le._context) + ".Provider";
          case l:
            return R(q, q.render, "ForwardRef");
          case d:
            var Ee = q.displayName || null;
            return Ee !== null ? Ee : $(q.type) || "Memo";
          case p: {
            var Ue = q, st = Ue._payload, Re = Ue._init;
            try {
              return $(Re(st));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Z = Object.assign, X = 0, K, J, ee, A, _, N, M;
    function S() {
    }
    S.__reactDisabledLog = !0;
    function B() {
      {
        if (X === 0) {
          K = console.log, J = console.info, ee = console.warn, A = console.error, _ = console.group, N = console.groupCollapsed, M = console.groupEnd;
          var q = {
            configurable: !0,
            enumerable: !0,
            value: S,
            writable: !0
          };
          Object.defineProperties(console, {
            info: q,
            log: q,
            warn: q,
            error: q,
            group: q,
            groupCollapsed: q,
            groupEnd: q
          });
        }
        X++;
      }
    }
    function G() {
      {
        if (X--, X === 0) {
          var q = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Z({}, q, {
              value: K
            }),
            info: Z({}, q, {
              value: J
            }),
            warn: Z({}, q, {
              value: ee
            }),
            error: Z({}, q, {
              value: A
            }),
            group: Z({}, q, {
              value: _
            }),
            groupCollapsed: Z({}, q, {
              value: N
            }),
            groupEnd: Z({}, q, {
              value: M
            })
          });
        }
        X < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var U = b.ReactCurrentDispatcher, H;
    function k(q, ie, le) {
      {
        if (H === void 0)
          try {
            throw Error();
          } catch (Ue) {
            var Ee = Ue.stack.trim().match(/\n( *(at )?)/);
            H = Ee && Ee[1] || "";
          }
        return `
` + H + q;
      }
    }
    var L = !1, W;
    {
      var V = typeof WeakMap == "function" ? WeakMap : Map;
      W = new V();
    }
    function D(q, ie) {
      if (!q || L)
        return "";
      {
        var le = W.get(q);
        if (le !== void 0)
          return le;
      }
      var Ee;
      L = !0;
      var Ue = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var st;
      st = U.current, U.current = null, B();
      try {
        if (ie) {
          var Re = function() {
            throw Error();
          };
          if (Object.defineProperty(Re.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Re, []);
            } catch (Pn) {
              Ee = Pn;
            }
            Reflect.construct(q, [], Re);
          } else {
            try {
              Re.call();
            } catch (Pn) {
              Ee = Pn;
            }
            q.call(Re.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Pn) {
            Ee = Pn;
          }
          q();
        }
      } catch (Pn) {
        if (Pn && Ee && typeof Pn.stack == "string") {
          for (var Ne = Pn.stack.split(`
`), er = Ee.stack.split(`
`), _t = Ne.length - 1, Tt = er.length - 1; _t >= 1 && Tt >= 0 && Ne[_t] !== er[Tt]; )
            Tt--;
          for (; _t >= 1 && Tt >= 0; _t--, Tt--)
            if (Ne[_t] !== er[Tt]) {
              if (_t !== 1 || Tt !== 1)
                do
                  if (_t--, Tt--, Tt < 0 || Ne[_t] !== er[Tt]) {
                    var Er = `
` + Ne[_t].replace(" at new ", " at ");
                    return q.displayName && Er.includes("<anonymous>") && (Er = Er.replace("<anonymous>", q.displayName)), typeof q == "function" && W.set(q, Er), Er;
                  }
                while (_t >= 1 && Tt >= 0);
              break;
            }
        }
      } finally {
        L = !1, U.current = st, G(), Error.prepareStackTrace = Ue;
      }
      var ui = q ? q.displayName || q.name : "", h5 = ui ? k(ui) : "";
      return typeof q == "function" && W.set(q, h5), h5;
    }
    function Q(q, ie, le) {
      return D(q, !1);
    }
    function z(q) {
      var ie = q.prototype;
      return !!(ie && ie.isReactComponent);
    }
    function te(q, ie, le) {
      if (q == null)
        return "";
      if (typeof q == "function")
        return D(q, z(q));
      if (typeof q == "string")
        return k(q);
      switch (q) {
        case c:
          return k("Suspense");
        case u:
          return k("SuspenseList");
      }
      if (typeof q == "object")
        switch (q.$$typeof) {
          case l:
            return Q(q.render);
          case d:
            return te(q.type, ie, le);
          case p: {
            var Ee = q, Ue = Ee._payload, st = Ee._init;
            try {
              return te(st(Ue), ie, le);
            } catch {
            }
          }
        }
      return "";
    }
    var ne = Object.prototype.hasOwnProperty, ae = {}, se = b.ReactDebugCurrentFrame;
    function pe(q) {
      if (q) {
        var ie = q._owner, le = te(q.type, q._source, ie ? ie.type : null);
        se.setExtraStackFrame(le);
      } else
        se.setExtraStackFrame(null);
    }
    function ue(q, ie, le, Ee, Ue) {
      {
        var st = Function.call.bind(ne);
        for (var Re in q)
          if (st(q, Re)) {
            var Ne = void 0;
            try {
              if (typeof q[Re] != "function") {
                var er = Error((Ee || "React class") + ": " + le + " type `" + Re + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof q[Re] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw er.name = "Invariant Violation", er;
              }
              Ne = q[Re](ie, Re, Ee, le, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (_t) {
              Ne = _t;
            }
            Ne && !(Ne instanceof Error) && (pe(Ue), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ee || "React class", le, Re, typeof Ne), pe(null)), Ne instanceof Error && !(Ne.message in ae) && (ae[Ne.message] = !0, pe(Ue), C("Failed %s type: %s", le, Ne.message), pe(null));
          }
      }
    }
    var Te = Array.isArray;
    function Be(q) {
      return Te(q);
    }
    function Ye(q) {
      {
        var ie = typeof Symbol == "function" && Symbol.toStringTag, le = ie && q[Symbol.toStringTag] || q.constructor.name || "Object";
        return le;
      }
    }
    function Ct(q) {
      try {
        return It(q), !1;
      } catch {
        return !0;
      }
    }
    function It(q) {
      return "" + q;
    }
    function Wr(q) {
      if (Ct(q))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ye(q)), It(q);
    }
    var Sn = b.ReactCurrentOwner, s2 = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, o5, s5, l2;
    l2 = {};
    function rw(q) {
      if (ne.call(q, "ref")) {
        var ie = Object.getOwnPropertyDescriptor(q, "ref").get;
        if (ie && ie.isReactWarning)
          return !1;
      }
      return q.ref !== void 0;
    }
    function nw(q) {
      if (ne.call(q, "key")) {
        var ie = Object.getOwnPropertyDescriptor(q, "key").get;
        if (ie && ie.isReactWarning)
          return !1;
      }
      return q.key !== void 0;
    }
    function aw(q, ie) {
      if (typeof q.ref == "string" && Sn.current && ie && Sn.current.stateNode !== ie) {
        var le = $(Sn.current.type);
        l2[le] || (C('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', $(Sn.current.type), q.ref), l2[le] = !0);
      }
    }
    function iw(q, ie) {
      {
        var le = function() {
          o5 || (o5 = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ie));
        };
        le.isReactWarning = !0, Object.defineProperty(q, "key", {
          get: le,
          configurable: !0
        });
      }
    }
    function ow(q, ie) {
      {
        var le = function() {
          s5 || (s5 = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ie));
        };
        le.isReactWarning = !0, Object.defineProperty(q, "ref", {
          get: le,
          configurable: !0
        });
      }
    }
    var sw = function(q, ie, le, Ee, Ue, st, Re) {
      var Ne = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: q,
        key: ie,
        ref: le,
        props: Re,
        // Record the component responsible for creating this element.
        _owner: st
      };
      return Ne._store = {}, Object.defineProperty(Ne._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Ne, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ee
      }), Object.defineProperty(Ne, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ue
      }), Object.freeze && (Object.freeze(Ne.props), Object.freeze(Ne)), Ne;
    };
    function lw(q, ie, le, Ee, Ue) {
      {
        var st, Re = {}, Ne = null, er = null;
        le !== void 0 && (Wr(le), Ne = "" + le), nw(ie) && (Wr(ie.key), Ne = "" + ie.key), rw(ie) && (er = ie.ref, aw(ie, Ue));
        for (st in ie)
          ne.call(ie, st) && !s2.hasOwnProperty(st) && (Re[st] = ie[st]);
        if (q && q.defaultProps) {
          var _t = q.defaultProps;
          for (st in _t)
            Re[st] === void 0 && (Re[st] = _t[st]);
        }
        if (Ne || er) {
          var Tt = typeof q == "function" ? q.displayName || q.name || "Unknown" : q;
          Ne && iw(Re, Tt), er && ow(Re, Tt);
        }
        return sw(q, Ne, er, Ue, Ee, Sn.current, Re);
      }
    }
    var c2 = b.ReactCurrentOwner, l5 = b.ReactDebugCurrentFrame;
    function ci(q) {
      if (q) {
        var ie = q._owner, le = te(q.type, q._source, ie ? ie.type : null);
        l5.setExtraStackFrame(le);
      } else
        l5.setExtraStackFrame(null);
    }
    var u2;
    u2 = !1;
    function f2(q) {
      return typeof q == "object" && q !== null && q.$$typeof === t;
    }
    function c5() {
      {
        if (c2.current) {
          var q = $(c2.current.type);
          if (q)
            return `

Check the render method of \`` + q + "`.";
        }
        return "";
      }
    }
    function cw(q) {
      {
        if (q !== void 0) {
          var ie = q.fileName.replace(/^.*[\\\/]/, ""), le = q.lineNumber;
          return `

Check your code at ` + ie + ":" + le + ".";
        }
        return "";
      }
    }
    var u5 = {};
    function uw(q) {
      {
        var ie = c5();
        if (!ie) {
          var le = typeof q == "string" ? q : q.displayName || q.name;
          le && (ie = `

Check the top-level render call using <` + le + ">.");
        }
        return ie;
      }
    }
    function f5(q, ie) {
      {
        if (!q._store || q._store.validated || q.key != null)
          return;
        q._store.validated = !0;
        var le = uw(ie);
        if (u5[le])
          return;
        u5[le] = !0;
        var Ee = "";
        q && q._owner && q._owner !== c2.current && (Ee = " It was passed a child from " + $(q._owner.type) + "."), ci(q), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', le, Ee), ci(null);
      }
    }
    function d5(q, ie) {
      {
        if (typeof q != "object")
          return;
        if (Be(q))
          for (var le = 0; le < q.length; le++) {
            var Ee = q[le];
            f2(Ee) && f5(Ee, ie);
          }
        else if (f2(q))
          q._store && (q._store.validated = !0);
        else if (q) {
          var Ue = g(q);
          if (typeof Ue == "function" && Ue !== q.entries)
            for (var st = Ue.call(q), Re; !(Re = st.next()).done; )
              f2(Re.value) && f5(Re.value, ie);
        }
      }
    }
    function fw(q) {
      {
        var ie = q.type;
        if (ie == null || typeof ie == "string")
          return;
        var le;
        if (typeof ie == "function")
          le = ie.propTypes;
        else if (typeof ie == "object" && (ie.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ie.$$typeof === d))
          le = ie.propTypes;
        else
          return;
        if (le) {
          var Ee = $(ie);
          ue(le, q.props, "prop", Ee, q);
        } else if (ie.PropTypes !== void 0 && !u2) {
          u2 = !0;
          var Ue = $(ie);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ue || "Unknown");
        }
        typeof ie.getDefaultProps == "function" && !ie.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function dw(q) {
      {
        for (var ie = Object.keys(q.props), le = 0; le < ie.length; le++) {
          var Ee = ie[le];
          if (Ee !== "children" && Ee !== "key") {
            ci(q), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ee), ci(null);
            break;
          }
        }
        q.ref !== null && (ci(q), C("Invalid attribute `ref` supplied to `React.Fragment`."), ci(null));
      }
    }
    function p5(q, ie, le, Ee, Ue, st) {
      {
        var Re = I(q);
        if (!Re) {
          var Ne = "";
          (q === void 0 || typeof q == "object" && q !== null && Object.keys(q).length === 0) && (Ne += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var er = cw(Ue);
          er ? Ne += er : Ne += c5();
          var _t;
          q === null ? _t = "null" : Be(q) ? _t = "array" : q !== void 0 && q.$$typeof === t ? (_t = "<" + ($(q.type) || "Unknown") + " />", Ne = " Did you accidentally export a JSX literal instead of a component?") : _t = typeof q, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", _t, Ne);
        }
        var Tt = lw(q, ie, le, Ue, st);
        if (Tt == null)
          return Tt;
        if (Re) {
          var Er = ie.children;
          if (Er !== void 0)
            if (Ee)
              if (Be(Er)) {
                for (var ui = 0; ui < Er.length; ui++)
                  d5(Er[ui], q);
                Object.freeze && Object.freeze(Er);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              d5(Er, q);
        }
        return q === n ? dw(Tt) : fw(Tt), Tt;
      }
    }
    function pw(q, ie, le) {
      return p5(q, ie, le, !0);
    }
    function hw(q, ie, le) {
      return p5(q, ie, le, !1);
    }
    var vw = hw, mw = pw;
    Wo.Fragment = n, Wo.jsx = vw, Wo.jsxs = mw;
  }()), Wo;
}
process.env.NODE_ENV === "production" ? $3.exports = ww() : $3.exports = Ow();
var f = $3.exports;
const x1 = E.forwardRef((e, t) => {
  const {
    image: r,
    size: n = "sm",
    grayscale: a = !1
  } = e, i = {
    xs: "h-[24px] w-[24px] min-w-[24px]",
    sm: "h-[28px] w-[28px] min-w-[28px]",
    md: "h-[32px] w-[32px] min-w-[32px]"
  };
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: `${i[n]} flex items-center justify-center aspect-square rounded-full bg-secondary-200 border border-white overflow-hidden ${a ? "grayscale-[70%]" : ""}`, children: r.length > 2 ? /* @__PURE__ */ f.jsx(
    "img",
    {
      src: r,
      className: "h-full w-full object-cover bg-secondary-200 text-secondary-100",
      alt: ""
    }
  ) : r.length === 2 ? /* @__PURE__ */ f.jsx("span", { className: "text-secondary-500 font-bold leading-none text-xs", children: r }) : null });
});
x1.displayName = "Avatar";
const w1 = {
  light: "300",
  normal: "normal",
  medium: "500",
  semibold: "600",
  bold: "700",
  black: "900"
}, au = {
  DEFAULT: "0.25rem",
  0: "0",
  xs: "0.25rem",
  md: "0.5rem",
  lg: "1rem",
  xl: "2rem",
  full: "100%"
}, je = {
  transparent: "rgba(255, 255, 255, 0.08)",
  DEFAULT: "#E6E6E6",
  white: "#FFFFFF",
  "neutral-100": "#FFFFFF",
  "neutral-200": "#F5F5F5",
  "neutral-300": "#E6E6E6",
  "neutral-400": "#A3A3A3",
  "neutral-500": "#525252",
  "neutral-600": "#292929",
  "primary-100": "#FEF2F0",
  "primary-200": "#FDE5E1",
  "primary-300": "#FCD8D1",
  "primary-400": "#FBCBC2",
  "primary-500": "#F3765F",
  "primary-600": "#F15C41",
  "primary-700": "#CE4D37",
  "primary-800": "#A53C2B",
  "primary-850": "#7B2A1F",
  "primary-900": "#521913",
  "primary-950": "#280706",
  "secondary-100": "#EEF4F9",
  "secondary-200": "#DDE9F3",
  "secondary-300": "#CBDEED",
  "secondary-400": "#BAD3E7",
  "secondary-500": "#4A8BC0",
  "secondary-600": "#2875B4",
  "secondary-700": "#22629B",
  "secondary-800": "#165892",
  "secondary-850": "#104D85;",
  "secondary-900": "#0A4379",
  "secondary-950": "#03386C",
  "accent-100": "#FDEEF3",
  "accent-200": "#FBDEE7",
  "accent-300": "#F9CDDB",
  "accent-400": "#F7BCD0",
  "accent-500": "#E94F83",
  "accent-600": "#E52E6B",
  "accent-700": "#C4275B",
  "accent-800": "#9D1E47",
  "accent-850": "#761534",
  "accent-900": "#4F0C21",
  "accent-950": "#27040E",
  "info-50": "#EEF5FD",
  "info-100": "#DEEBFB",
  "info-200": "#CDE1F9",
  "info-300": "#BCD7F7",
  "info-400": "#4F96E9",
  "info-500": "#2E82E5",
  "info-600": "#276EC4",
  "info-700": "#0F2D59",
  "info-800": "#0B2348",
  "info-900": "#071938",
  "info-950": "#040F27",
  "success-50": "#EEFBF1",
  "success-100": "#DDF7E2",
  "success-200": "#CCF3D4",
  "success-300": "#BAEFC6",
  "success-400": "#4BD469",
  "success-500": "#29CC4D",
  "success-600": "#22AF42",
  "success-700": "#0D5120",
  "success-800": "#0A421B",
  "success-900": "#073415",
  "success-950": "#032510",
  "warning-50": "#FDF7EE",
  "warning-100": "#FBEFDE",
  "warning-200": "#F9E7CD",
  "warning-300": "#F7DFBC",
  "warning-400": "#E9AC4F",
  "warning-500": "#E59C2E",
  "warning-600": "#C48427",
  "warning-700": "#59350F",
  "warning-800": "#48290B",
  "warning-900": "#381C07",
  "warning-950": "#271004",
  "warning-1000": "#fbbf24",
  "error-50": "#FDEEEE",
  "error-100": "#FBDEDE",
  "error-200": "#F9CDCD",
  "error-300": "#F7BCBC",
  "error-400": "#E94F4F",
  "error-500": "#E52E2E",
  "error-600": "#C42727",
  "error-700": "#590F10",
  "error-800": "#480B0C",
  "error-900": "#380709",
  "error-950": "#270405"
}, Tn = E.forwardRef((e, t) => {
  const {
    mb: r,
    mt: n,
    bg: a,
    color: i,
    rounded: o,
    isHidden: s,
    spacing: l,
    spacingX: c,
    spacingY: u,
    spacingTop: d,
    spacingBottom: p,
    textAlign: h,
    border: m,
    borderTop: v,
    borderBottom: g,
    borderColor: b,
    children: C,
    className: w,
    shadow: x,
    ...y
  } = e, O = {
    textAlign: h,
    marginBottom: r !== void 0 ? `${r / 4}rem` : void 0,
    marginTop: n !== void 0 ? `${n / 4}rem` : void 0,
    backgroundColor: a !== void 0 ? je[a] : void 0,
    color: i !== void 0 ? je[i] : void 0,
    borderRadius: o !== void 0 ? au[o] : void 0,
    borderColor: b !== void 0 ? je[b] : void 0,
    padding: l !== void 0 ? `${l / 4}rem` : void 0
  };
  return m !== void 0 ? O.borderWidth = m : (O.borderTopWidth = v, O.borderBottomWidth = g), c !== void 0 && (O.paddingLeft = `${c / 4}rem`, O.paddingRight = `${c / 4}rem`), u !== void 0 && (O.paddingTop = `${u / 4}rem`, O.paddingBottom = `${u / 4}rem`), d !== void 0 && (O.paddingTop = `${d / 4}rem`), p !== void 0 && (O.paddingBottom = `${p / 4}rem`), x !== void 0 && (O.boxShadow = "0 4px 10px rgba(0,0,0,0.2)"), /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: `${s === !0 ? "hidden" : "block"}`,
      style: O,
      ...y,
      children: C
    }
  );
});
Tn.displayName = "Box";
const dv = E.forwardRef((e, t) => {
  const {
    text: r,
    variant: n,
    minHeight: a = "60vh",
    minHeigthDesktop: i = "40vh"
  } = e, o = {
    "--ck-min-h-box-status": typeof a == "number" ? `${a}px` : a,
    "--ck-min-h-box-status-desktop": typeof i == "number" ? `${i}px` : i
  }, l = r ?? {
    loading: "Cargando...",
    empty: ""
  }[n];
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: t,
      style: o,
      className: "bg-secondary-100 flex items-center justify-center p-5 rounded-md h-full w-full min-h-[var(--ck-min-h-box-status)] m:min-h-[var(--ck-min-h-box-status-desktop)]",
      children: [
        n === "loading" && /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col items-center justify-center w-full text-center animate-pulse", children: [
          /* @__PURE__ */ f.jsx("div", { className: "bg-white flex justify-center items-center w-[64px] h-[64px] rounded-md mb-4", children: /* @__PURE__ */ f.jsxs(
            "svg",
            {
              width: 36,
              height: 40,
              viewBox: "0 0 36 40",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [
                /* @__PURE__ */ f.jsx(
                  "path",
                  {
                    d: "M1.65723 39.2676H28.9346C34.1715 39.2676 37.5922 33.638 35.247 28.8537L31.8969 22.001C24.2797 31.012 13.6826 37.3071 1.65723 39.2676Z",
                    fill: "#165892"
                  }
                ),
                /* @__PURE__ */ f.jsx(
                  "path",
                  {
                    d: "M23.2922 4.46453L22.1638 2.16232C21.2292 0.255791 18.5667 0.255791 17.6322 2.16232L3.87891 30.2386C12.8715 24.1413 19.7834 15.0943 23.2922 4.46453Z",
                    fill: "#F15C41"
                  }
                ),
                /* @__PURE__ */ f.jsx(
                  "path",
                  {
                    d: "M31.28 20.7422L24.1036 6.10156C20.1363 17.181 12.5367 26.4798 2.78593 32.5051L0 38.2067C12.5014 36.57 23.5569 30.131 31.2976 20.7602L31.28 20.7422Z",
                    fill: "#2875B4"
                  }
                )
              ]
            }
          ) }),
          l !== "" && /* @__PURE__ */ f.jsx(hr, { variant: "description-3", children: l })
        ] }),
        n === "empty" && /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col items-center justify-center w-full max-w-[300px] gap-4 text-center", children: [
          /* @__PURE__ */ f.jsx("div", { className: "flex justify-center select-none", children: /* @__PURE__ */ f.jsx(
            "svg",
            {
              width: 90,
              height: 101,
              viewBox: "0 0 90 101",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2127_49432)", children: [
                /* @__PURE__ */ f.jsx(
                  "path",
                  {
                    d: "M89.9844 52.4766C89.8853 51.6849 89.314 51.0339 88.5418 50.8307L80.2566 48.6484L86.6766 41.5833C87.0783 41.1406 87.2531 40.5417 87.1566 39.9531C87.0601 39.3646 86.7001 38.8542 86.1783 38.5625L62.2618 25.276C61.3644 23.6068 60.2166 22.0573 58.834 20.6823C55.1401 16.9922 50.2253 14.9609 45.0001 14.9609C39.7748 14.9609 34.8601 16.9922 31.1661 20.6823C29.7731 22.0729 28.6357 23.6224 27.7514 25.2708L3.82441 38.5651C3.30267 38.8542 2.94267 39.3672 2.84614 39.9557C2.74962 40.5443 2.92701 41.1432 3.32875 41.5859L9.74615 48.651L1.45832 50.8333C0.686145 51.0365 0.11484 51.6875 0.0157101 52.4792C-0.0834204 53.2708 0.307884 54.0417 1.00701 54.4297L11.4027 60.2057V80.974C11.4027 81.6823 11.7888 82.3359 12.407 82.6797L44.0505 100.258C44.3479 100.422 44.674 100.505 45.0027 100.505C45.3314 100.505 45.6601 100.424 45.9548 100.258L77.5983 82.6797C78.2192 82.3359 78.6027 81.6823 78.6027 80.974V60.2057L88.9983 54.4297C89.6948 54.0417 90.0888 53.2708 89.987 52.4792L89.9844 52.4766ZM82.1192 40.7839L76.2366 47.2578L63.694 40.2917C64.2679 38.4401 64.5653 36.4896 64.5653 34.4974C64.5653 33.2578 64.4505 32.0365 64.2261 30.8438L82.1218 40.7839H82.1192ZM33.9314 23.4479C36.887 20.4974 40.8183 18.8724 45.0001 18.8724C49.1818 18.8724 53.1105 20.4974 56.0688 23.4479C59.027 26.3984 60.6522 30.3229 60.6522 34.4974C60.6522 38.6719 59.0244 42.5938 56.0688 45.5469C54.0235 47.5885 51.4644 49.0208 48.6653 49.6901C48.1435 49.8151 47.6948 50.1484 47.4261 50.612L45.0001 54.8099C44.1914 53.4089 43.3827 52.0104 42.574 50.612C42.3053 50.1484 41.8566 49.8151 41.3348 49.6875C38.5383 49.0182 35.9792 47.5859 33.934 45.5443C27.8322 39.4531 27.8322 29.5391 33.934 23.4479H33.9314ZM7.88093 40.7839L25.7896 30.8359C25.1948 33.9714 25.3696 37.2214 26.3192 40.2865L13.7661 47.2604L7.88354 40.7865L7.88093 40.7839ZM13.0957 51.8073L20.5331 55.9401C20.8357 56.1068 21.1618 56.1875 21.4827 56.1875C22.1714 56.1875 22.8366 55.8255 23.194 55.1823C23.7209 54.2396 23.3792 53.0495 22.4348 52.526L17.3818 49.7188L27.8531 43.9036C28.7218 45.4844 29.8279 46.9688 31.1661 48.3073C33.5192 50.6563 36.4148 52.3594 39.5922 53.2682C40.4348 54.7266 41.2774 56.1849 42.1227 57.6458C42.7253 58.6823 43.7975 59.2995 44.9975 59.2995H45.0235C46.2131 59.2917 47.3114 58.6484 47.8957 57.6172L50.4105 53.2682C53.5853 52.3568 56.4835 50.6536 58.8366 48.3073C60.1618 46.9818 61.2757 45.5026 62.1575 43.9063L72.6209 49.7188L45.0027 65.0599L37.8261 61.0729C36.8818 60.5495 35.6896 60.888 35.1653 61.8307C34.6383 62.7734 34.9801 63.9635 35.9244 64.487L39.8061 66.6432L33.8661 68.2057L7.15571 53.3672L13.0957 51.8047V51.8073ZM15.3157 62.375L32.6505 72.0052C33.0914 72.25 33.6105 72.3151 34.1009 72.1875L43.0461 69.8333V95.2266L15.3157 79.8229V62.3776V62.375ZM74.687 79.8203L46.9566 95.224V69.8307L55.9018 72.1849C56.0661 72.2266 56.2331 72.25 56.4001 72.25C56.7314 72.25 57.0574 72.1667 57.3496 72.0026L74.6844 62.3724V79.8177L74.687 79.8203ZM56.1392 68.2083L50.1992 66.6432L76.907 51.8073L82.847 53.3698L56.1392 68.2083Z",
                    fill: "#2875B4"
                  }
                ),
                /* @__PURE__ */ f.jsx(
                  "path",
                  {
                    d: "M35.2173 36.7422C36.2973 36.7422 37.1738 35.8672 37.1738 34.7891C37.1738 33.7109 36.2973 32.8359 35.2173 32.8359C34.1373 32.8359 33.2607 33.7109 33.2607 34.7891C33.2607 35.8672 34.1373 36.7422 35.2173 36.7422Z",
                    fill: "#2875B4"
                  }
                ),
                /* @__PURE__ */ f.jsx(
                  "path",
                  {
                    d: "M45 36.7422C46.08 36.7422 46.9565 35.8672 46.9565 34.7891C46.9565 33.7109 46.08 32.8359 45 32.8359C43.92 32.8359 43.0435 33.7109 43.0435 34.7891C43.0435 35.8672 43.92 36.7422 45 36.7422Z",
                    fill: "#2875B4"
                  }
                ),
                /* @__PURE__ */ f.jsx(
                  "path",
                  {
                    d: "M54.7827 36.7422C55.8627 36.7422 56.7392 35.8672 56.7392 34.7891C56.7392 33.7109 55.8627 32.8359 54.7827 32.8359C53.7027 32.8359 52.8262 33.7109 52.8262 34.7891C52.8262 35.8672 53.7027 36.7422 54.7827 36.7422Z",
                    fill: "#2875B4"
                  }
                ),
                /* @__PURE__ */ f.jsx(
                  "path",
                  {
                    d: "M45 8.89844C46.08 8.89844 46.9565 8.02344 46.9565 6.94531V2.45312C46.9565 1.375 46.08 0.5 45 0.5C43.92 0.5 43.0435 1.375 43.0435 2.45312V6.94531C43.0435 8.02344 43.92 8.89844 45 8.89844Z",
                    fill: "#2875B4"
                  }
                ),
                /* @__PURE__ */ f.jsx(
                  "path",
                  {
                    d: "M33.0573 10.6639C33.4199 11.2915 34.0773 11.6405 34.7529 11.6405C35.0842 11.6405 35.4207 11.5571 35.7286 11.38C36.6651 10.841 36.9859 9.64566 36.4459 8.71077L34.1973 4.82014C33.6573 3.88525 32.4599 3.56494 31.5259 4.104C30.5894 4.64306 30.2686 5.83837 30.8086 6.77327L33.0573 10.6639Z",
                    fill: "#2875B4"
                  }
                ),
                /* @__PURE__ */ f.jsx(
                  "path",
                  {
                    d: "M54.2685 11.3776C54.5764 11.5547 54.9129 11.638 55.2468 11.638C55.9225 11.638 56.5799 11.2891 56.9425 10.6615L59.1912 6.77083C59.7312 5.83593 59.4103 4.64062 58.4738 4.10156C57.5372 3.56249 56.3425 3.88281 55.8025 4.8177L53.5538 8.70833C53.0138 9.64322 53.3346 10.8359 54.2685 11.3776Z",
                    fill: "#2875B4"
                  }
                ),
                /* @__PURE__ */ f.jsx(
                  "path",
                  {
                    d: "M29.1782 56.5547C28.0982 56.5547 27.2217 57.4297 27.2217 58.5078C27.2217 59.5859 28.0982 60.4609 29.1782 60.4609C30.2582 60.4609 31.1347 59.5885 31.1347 58.5078C31.1347 57.4271 30.2582 56.5547 29.1782 56.5547Z",
                    fill: "#2875B4"
                  }
                )
              ] })
            }
          ) }),
          l !== "" && /* @__PURE__ */ f.jsx(hr, { variant: "description-3", children: l })
        ] })
      ]
    }
  );
});
dv.displayName = "BoxStatus";
const Bde = E.forwardRef((e, t) => {
  const {
    mb: r,
    mt: n,
    bg: a,
    color: i,
    borderColor: o,
    rounded: s,
    spacing: l,
    textAlign: c,
    onChangeFile: u,
    onRemoveFile: d,
    fileName: p = "",
    children: h,
    className: m,
    ...v
  } = e, [g, b] = ye(!1), [C, w] = ye(p), x = {
    textAlign: c,
    marginBottom: r !== void 0 ? `${r / 4}rem` : void 0,
    marginTop: n !== void 0 ? `${n / 4}rem` : void 0,
    backgroundColor: g ? "transparent" : a !== void 0 ? je[a] : void 0,
    color: i !== void 0 ? je[i] : void 0,
    // borderColor: borderColor !== undefined ? colors[borderColor] : undefined,
    borderRadius: s !== void 0 ? au[s] : void 0,
    padding: l !== void 0 ? `${l / 4}rem` : void 0
  }, y = (j) => {
    j.preventDefault(), b(!0);
  }, O = (j) => {
    j.preventDefault(), b(!1);
    const T = j.dataTransfer.files[0];
    u && u(T), w(T.name);
  }, P = () => {
    w(""), d && d();
  };
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: t,
      className: `border-dashed border-2 border-${o !== void 0 ? je[o] : void 0}`,
      style: x,
      ...v,
      onDragEnter: y,
      onDragLeave: () => b(!1),
      onDragOver: (j) => j.preventDefault(),
      onDrop: O,
      children: [
        /* @__PURE__ */ f.jsx(Hi, { justifyItems: "center", gapY: 6, children: C !== "" ? /* @__PURE__ */ f.jsx(
          gt,
          {
            type: "button",
            onClick: () => {
              P();
            },
            variant: "error-light",
            icon: "trash",
            size: "m",
            children: C
          }
        ) : /* @__PURE__ */ f.jsx(Ei, { children: /* @__PURE__ */ f.jsxs(hr, { variant: "description-3", color: "neutral-400", children: [
          "Arrastra aqui tu archivo",
          /* @__PURE__ */ f.jsx("br", {}),
          "(PDF,DOC,EXC, hasta 200kb)"
        ] }) }) }),
        h
      ]
    }
  );
}), Vde = E.forwardRef((e, t) => {
  const {
    mb: r,
    mt: n,
    bg: a,
    color: i,
    borderColor: o,
    rounded: s,
    spacing: l,
    textAlign: c,
    onChangeFile: u,
    onRemoveFile: d,
    files: p,
    maxFiles: h = 10,
    children: m,
    className: v,
    ...g
  } = e, [b, C] = ye(!1), [w, x] = ye([]), y = p ?? w, O = {
    textAlign: c,
    marginBottom: r !== void 0 ? `${r / 4}rem` : void 0,
    marginTop: n !== void 0 ? `${n / 4}rem` : void 0,
    backgroundColor: b ? "transparent" : a !== void 0 ? je[a] : void 0,
    color: i !== void 0 ? je[i] : void 0,
    borderRadius: s !== void 0 ? au[s] : void 0,
    padding: l !== void 0 ? `${l / 4}rem` : void 0
  }, P = ($) => {
    const Z = (K) => `${K.name}|${K.size}|${K.type}`, X = new Map(y.map((K) => [Z(K), K]));
    return $.forEach((K) => {
      X.has(Z(K)) || X.set(Z(K), K);
    }), Array.from(X.values()).slice(0, h);
  }, j = ($) => {
    p || x($), u && u($);
  }, T = ($) => {
    $.preventDefault(), C(!0);
  }, I = ($) => {
    $.preventDefault(), C(!1);
    const Z = Array.from($.dataTransfer.files || []);
    if (Z.length === 0)
      return;
    const X = P(Z);
    j(X);
  }, R = ($) => {
    const Z = [...y];
    Z.splice($, 1), p || x(Z), d && d($);
  }, F = () => {
    p || x([]), d && d();
  };
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: t,
      className: `border-dashed border-2 border-${o !== void 0 ? je[o] : void 0} ${v ?? ""}`,
      style: O,
      ...g,
      onDragEnter: T,
      onDragLeave: () => C(!1),
      onDragOver: ($) => $.preventDefault(),
      onDrop: I,
      children: [
        /* @__PURE__ */ f.jsx(Hi, { justifyItems: "center", gapY: 6, children: y.length > 0 ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          y.map(($, Z) => /* @__PURE__ */ f.jsx(
            gt,
            {
              type: "button",
              onClick: () => R(Z),
              variant: "error-light",
              icon: "trash",
              size: "m",
              children: $.name
            },
            `${$.name}-${$.size}-${Z}`
          )),
          y.length > 1 && /* @__PURE__ */ f.jsx(
            gt,
            {
              type: "button",
              onClick: F,
              variant: "error-light",
              icon: "trash",
              size: "m",
              children: "Eliminar todos"
            }
          )
        ] }) : /* @__PURE__ */ f.jsx(Ei, { children: /* @__PURE__ */ f.jsxs(hr, { variant: "description-3", color: "neutral-400", children: [
          "Arrastra aquí tus archivos",
          /* @__PURE__ */ f.jsx("br", {}),
          "(PDF,DOC,EXC, hasta 200kb) — Máximo ",
          h
        ] }) }) }),
        m
      ]
    }
  );
});
function $e(e) {
  return `${e.filter((t) => t !== void 0).join(" ").trim()}`;
}
const Sw = E.forwardRef((e, t) => {
  const {
    items: r = [],
    className: n
  } = e;
  return /* @__PURE__ */ f.jsx(
    "ul",
    {
      ref: t,
      className: $e(["m:flex flex-wrap gap-2", n]),
      children: r.map((a, i) => /* @__PURE__ */ f.jsxs(
        "li",
        {
          className: "text-neutral-400 flex gap-2 items-center",
          children: [
            /* @__PURE__ */ f.jsx(
              "div",
              {
                className: `hover:text-secondary-600 ${i + 1 === r.length ? "pointer-events-none" : "cursor-pointer"}`,
                onClick: () => {
                  i + 1 !== r.length && a.onClick !== void 0 && a.onClick();
                },
                children: /* @__PURE__ */ f.jsx(sr, { variant: "title-3", children: a.description })
              }
            ),
            i + 1 !== r.length && /* @__PURE__ */ f.jsx("span", { className: "w-[14px] min-w-[14px] -rotate-90", children: /* @__PURE__ */ f.jsx(me, { variant: "arrow-down", width: 14 }) })
          ]
        },
        a.description
      ))
    }
  );
});
Sw.displayName = "Breadcrumb";
const Pw = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_1441_2226)", children: /* @__PURE__ */ f.jsx("path", { d: "M16.4808 2.685C14.75 0.954167 12.4475 0 10 0C7.5525 0 5.25 0.954167 3.51833 2.685C-0.055837 6.25917 -0.055837 12.0742 3.54166 15.6717L6.82666 18.7067C7.68 19.5408 8.8075 20.0008 10 20.0008C11.1925 20.0008 12.3192 19.5408 13.155 18.7233L16.4808 15.65C20.055 12.0758 20.055 6.26 16.4808 2.68583V2.685ZM15.3258 14.4475L12.0067 17.515C10.9275 18.5717 9.09 18.5875 7.975 17.4983L4.69583 14.47C1.77166 11.545 1.77166 6.7875 4.69583 3.8625C6.1125 2.44667 7.99666 1.66583 9.99916 1.66583C12.0017 1.66583 13.885 2.44667 15.3017 3.8625C18.2258 6.7875 18.2258 11.545 15.325 14.4467L15.3258 14.4475ZM9.16583 9.58333V5C9.16583 4.53917 9.53833 4.16667 9.99916 4.16667C10.46 4.16667 10.8325 4.53917 10.8325 5V9.58333C10.8325 10.0442 10.46 10.4167 9.99916 10.4167C9.53833 10.4167 9.16583 10.0442 9.16583 9.58333ZM11.2492 12.9167C11.2492 13.6067 10.6892 14.1667 9.99916 14.1667C9.30916 14.1667 8.74916 13.6067 8.74916 12.9167C8.74916 12.2267 9.30916 11.6667 9.99916 11.6667C10.6892 11.6667 11.2492 12.2267 11.2492 12.9167Z", fill: "currentColor" }) }),
  /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_1441_2226", children: /* @__PURE__ */ f.jsx("rect", { width: "20", height: "20", fill: "currentColor" }) }) })
] }), Ew = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M8.021 11.9 3.453 8.62a.72.72 0 0 1 0-1.238L8.021 4.1a.716.716 0 0 1 1.079.619V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M5.232 4.293a.5.5 0 0 1-.106.7L1.114 7.945l-.042.028a.147.147 0 0 0 0 .252l.042.028 4.012 2.954a.5.5 0 1 1-.593.805L.539 9.073a1.147 1.147 0 0 1 0-1.946l3.994-2.94a.5.5 0 0 1 .699.106",
      fill: "currentColor"
    }
  )
] }), jw = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M14.043.71a.999.999 0 00-1.42 0l-4.58 4.58a1 1 0 01-1.42 0L2.043.71a1 1 0 10-1.42 1.41l4.59 4.59a3 3 0 004.24 0l4.59-4.59a1 1 0 000-1.41z",
        fill: "currentColor"
      }
    )
  }
), _w = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("path", { d: "M13.29063 3.29018C13.38436 3.38315 13.45875 3.49375 13.50952 3.61561C13.56029 3.73747 13.58643 3.86817 13.58643 4.00018C13.58643 4.1322 13.56029 4.2629 13.50952 4.38476C13.45875 4.50662 13.38436 4.61722 13.29063 4.71018L8.71063 9.29018C8.61689 9.38315 8.5425 9.49375 8.49173 9.61561C8.44096 9.73747 8.41482 9.86817 8.41482 10.0002C8.41482 10.1322 8.44096 10.2629 8.49173 10.3848C8.5425 10.5066 8.61689 10.6172 8.71063 10.7102L13.29063 15.2902C13.38436 15.3831 13.45875 15.4937 13.50952 15.6156C13.56029 15.7375 13.58643 15.8682 13.58643 16.0002C13.58643 16.1322 13.56029 16.2629 13.50952 16.3848C13.45875 16.5066 13.38436 16.6172 13.29063 16.7102C13.1033 16.8964 12.8498 17.001 12.5856 17.001C12.3214 17.001 12.0679 16.8964 11.8806 16.7102L7.29063 12.1202C6.72882 11.5577 6.41329 10.7952 6.41329 10.0002C6.41329 9.20518 6.72882 8.44269 7.29063 7.88018L11.8806 3.29018C12.0679 3.10393 12.3214 2.99939 12.5856 2.99939C12.8498 2.99939 13.1033 3.10393 13.29063 3.29018Z", fill: "currentColor" }) }), Aw = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M6.70937 3.29018C6.61564 3.38315 6.54125 3.49375 6.49048 3.61561C6.43971 3.73747 6.41357 3.86817 6.41357 4.00018C6.41357 4.1322 6.43971 4.2629 6.49048 4.38476C6.54125 4.50662 6.61564 4.61722 6.70937 4.71018L11.2894 9.29018C11.3831 9.38315 11.4575 9.49375 11.5083 9.61561C11.559 9.73747 11.5852 9.86817 11.5852 10.0002C11.5852 10.1322 11.559 10.2629 11.5083 10.3848C11.4575 10.5066 11.3831 10.6172 11.2894 10.7102L6.70937 15.2902C6.61564 15.3831 6.54125 15.4937 6.49048 15.6156C6.43971 15.7375 6.41357 15.8682 6.41357 16.0002C6.41357 16.1322 6.43971 16.2629 6.49048 16.3848C6.54125 16.5066 6.61564 16.6172 6.70937 16.7102C6.89673 16.8964 7.15019 17.001 7.41437 17.001C7.67856 17.001 7.93201 16.8964 8.11937 16.7102L12.7094 12.1202C13.2712 11.5577 13.5867 10.7952 13.5867 10.0002C13.5867 9.20518 13.2712 8.44269 12.7094 7.88018L8.11937 3.29018C7.93201 3.10393 7.67856 2.99939 7.41437 2.99939C7.15019 2.99939 6.89673 3.10393 6.70937 3.29018Z",
        fill: "currentColor"
      }
    )
  }
), Dw = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "rect",
        {
          x: "2",
          y: "2",
          width: "20",
          height: "20",
          stroke: "currentColor",
          strokeWidth: "2"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M12 16V8M12 8l-4 4M12 8l4 4",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), Mw = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M16 9.005H6l3.29-3.29a1 1 0 10-1.41-1.42l-4.29 4.3a2 2 0 00-.59 1.41 2 2 0 00.59 1.4l4.29 4.3a1 1 0 001.628-1.096 1 1 0 00-.218-.324L6 11.005h10a1 1 0 000-2z",
        fill: "currentColor"
      }
    )
  }
), Tw = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M13.426.2L15.2 2l-7.32 7.21a2.503 2.503 0 01-1.777.734 2.528 2.528 0 01-1.79-.74L.8 5.799 2.56 3.982l3.53 3.42 7.339-7.2L13.426.2z",
        fill: "currentColor"
      }
    )
  }
), $w = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2127_36415)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M14.0817 6.90667L15.2517 8.09417L10.4242 12.85C10.1017 13.1725 9.6775 13.3333 9.25167 13.3333C8.82583 13.3333 8.3975 13.1708 8.07167 12.8458L5.75333 10.5992L6.91417 9.40167L9.24167 11.6575L14.0817 6.90667ZM20.5 10C20.5 15.5142 16.0142 20 10.5 20C4.98583 20 0.5 15.5142 0.5 10C0.5 4.48583 4.98583 0 10.5 0C16.0142 0 20.5 4.48583 20.5 10ZM18.8333 10C18.8333 5.405 15.095 1.66667 10.5 1.66667C5.905 1.66667 2.16667 5.405 2.16667 10C2.16667 14.595 5.905 18.3333 10.5 18.3333C15.095 18.3333 18.8333 14.595 18.8333 10Z",
        fill: "currentColor"
      }
    ) })
  }
), Nw = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433286 8.00043 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34871 18.9426 4.80684 17.0679 2.9321C15.1932 1.05736 12.6513 0.00286757 10 0ZM10 18.3333C8.35183 18.3333 6.74066 17.8446 5.37025 16.9289C3.99984 16.0132 2.93174 14.7117 2.30101 13.189C1.67028 11.6663 1.50525 9.99075 1.82679 8.37425C2.14834 6.75774 2.94201 5.27288 4.10745 4.10744C5.27288 2.94201 6.75774 2.14833 8.37425 1.82679C9.99076 1.50525 11.6663 1.67027 13.189 2.301C14.7117 2.93173 16.0132 3.99984 16.9289 5.37025C17.8446 6.74066 18.3333 8.35182 18.3333 10C18.3309 12.2094 17.4522 14.3276 15.8899 15.8899C14.3276 17.4522 12.2094 18.3309 10 18.3333ZM10.8333 9.16667H14.1667V10.8333H10.8333V14.1667H9.16667V10.8333H5.83334V9.16667H9.16667V5.83333H10.8333V9.16667Z",
        fill: "currentColor"
      }
    )
  }
), Iw = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zm-.5-13h-1v6h4v-1.5h-2.5z",
        fill: "currentColor"
      }
    )
  }
), Lw = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M12.9998 0.999818C12.8123 0.812347 12.558 0.707031 12.2928 0.707031C12.0277 0.707031 11.7733 0.812347 11.5858 0.999818L6.99982 5.58582L2.41382 0.999818C2.22629 0.812347 1.97198 0.707031 1.70682 0.707031C1.44165 0.707031 1.18735 0.812347 0.999818 0.999818C0.812347 1.18735 0.707031 1.44165 0.707031 1.70682C0.707031 1.97198 0.812347 2.22629 0.999818 2.41382L5.58582 6.99982L0.999818 11.5858C0.812347 11.7733 0.707031 12.0277 0.707031 12.2928C0.707031 12.558 0.812347 12.8123 0.999818 12.9998C1.18735 13.1873 1.44165 13.2926 1.70682 13.2926C1.97198 13.2926 2.22629 13.1873 2.41382 12.9998L6.99982 8.41382L11.5858 12.9998C11.7733 13.1873 12.0277 13.2926 12.2928 13.2926C12.558 13.2926 12.8123 13.1873 12.9998 12.9998C13.1873 12.8123 13.2926 12.558 13.2926 12.2928C13.2926 12.0277 13.1873 11.7733 12.9998 11.5858L8.41382 6.99982L12.9998 2.41382C13.1873 2.22629 13.2926 1.97198 13.2926 1.70682C13.2926 1.44165 13.1873 1.18735 12.9998 0.999818Z",
        fill: "currentColor"
      }
    )
  }
), kw = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_1902_296)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M0.83 6.16504H19.16C19.62 6.16504 19.99 6.53504 19.99 6.99504C19.99 7.45504 19.62 7.82504 19.16 7.82504H0.83C0.37 7.83504 0 7.46504 0 7.00504C0 6.54504 0.37 6.16504 0.83 6.16504Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.83977 0.334961H19.1698C19.6298 0.334961 19.9998 0.704961 19.9998 1.16496C19.9998 1.62496 19.6298 1.99496 19.1698 1.99496H9.83977C9.37977 1.99496 9.00977 1.62496 9.00977 1.16496C9.00977 0.704961 9.37977 0.334961 9.83977 0.334961Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.83977 12.0049H19.1698C19.6298 12.0049 19.9998 12.3749 19.9998 12.8349C19.9998 13.2949 19.6298 13.6649 19.1698 13.6649H9.83977C9.37977 13.6649 9.00977 13.2949 9.00977 12.8349C9.00977 12.3749 9.37977 12.0049 9.83977 12.0049Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M2.17982 7.6749C1.80982 7.3049 1.79982 6.7049 2.17982 6.3249L6.54982 1.9649C6.91982 1.5949 6.92982 0.994902 6.54982 0.614902C6.17982 0.244902 5.57982 0.244902 5.20982 0.614902L0.839824 4.9849C-0.270176 6.1049 -0.270176 7.9049 0.839824 9.0249L5.20982 13.3949C5.38982 13.5749 5.62982 13.6749 5.87982 13.6749C6.12982 13.6749 6.37982 13.5749 6.55982 13.3949C6.92982 13.0249 6.93982 12.4249 6.55982 12.0449L2.17982 7.6749Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), Rw = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M15.8333 1.6665H4.16667C1.86917 1.6665 0 3.53567 0 5.83317V14.1665C0 16.464 1.86917 18.3332 4.16667 18.3332H15.8333C18.1308 18.3332 20 16.464 20 14.1665V5.83317C20 3.53567 18.1308 1.6665 15.8333 1.6665ZM4.16667 3.33317H15.8333C17.2117 3.33317 18.3333 4.45484 18.3333 5.83317H1.66667C1.66667 4.45484 2.78833 3.33317 4.16667 3.33317ZM1.66667 14.1665V7.49984H9.16667V16.6665H4.16667C2.78833 16.6665 1.66667 15.5448 1.66667 14.1665ZM15.8333 16.6665H10.8333V7.49984H18.3333V14.1665C18.3333 15.5448 17.2117 16.6665 15.8333 16.6665Z",
        fill: "currentColor"
      }
    )
  }
), Bw = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "currentColor", className: "bi bi-window-stack", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M4.5 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M6 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" }),
  /* @__PURE__ */ f.jsx("path", { d: "M12 1a2 2 0 0 1 2 2 2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2 2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM2 12V5a2 2 0 0 1 2-2h9a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1m1-4v5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8zm12-1V5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2z" })
] }), Vw = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.99984 6.6665C9.34057 6.6665 8.6961 6.862 8.14794 7.22827C7.59977 7.59454 7.17253 8.11514 6.92024 8.72423C6.66795 9.33331 6.60194 10.0035 6.73055 10.6501C6.85917 11.2967 7.17664 11.8907 7.64282 12.3569C8.10899 12.823 8.70293 13.1405 9.34954 13.2691C9.99614 13.3977 10.6664 13.3317 11.2755 13.0794C11.8845 12.8271 12.4051 12.3999 12.7714 11.8517C13.1377 11.3036 13.3332 10.6591 13.3332 9.99984C13.3332 9.11578 12.982 8.26794 12.3569 7.64281C11.7317 7.01769 10.8839 6.6665 9.99984 6.6665ZM9.99984 11.6665C9.6702 11.6665 9.34797 11.5688 9.07389 11.3856C8.79981 11.2025 8.58619 10.9422 8.46004 10.6376C8.33389 10.3331 8.30089 9.99799 8.3652 9.67469C8.42951 9.35139 8.58824 9.05441 8.82133 8.82133C9.05442 8.58824 9.35139 8.4295 9.67469 8.36519C9.99799 8.30089 10.3331 8.33389 10.6376 8.46004C10.9422 8.58618 11.2025 8.79981 11.3856 9.07389C11.5688 9.34797 11.6665 9.6702 11.6665 9.99984C11.6665 10.4419 11.4909 10.8658 11.1783 11.1783C10.8658 11.4909 10.4419 11.6665 9.99984 11.6665Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M17.7452 11.5833L17.3752 11.37C17.5417 10.4637 17.5417 9.53463 17.3752 8.62833L17.7452 8.415C18.0297 8.25085 18.2791 8.03226 18.4792 7.77172C18.6792 7.51118 18.826 7.21378 18.9111 6.89651C18.9962 6.57925 19.018 6.24832 18.9753 5.92263C18.9325 5.59694 18.826 5.28286 18.6618 4.99833C18.4977 4.7138 18.2791 4.46439 18.0185 4.26434C17.758 4.06428 17.4606 3.91751 17.1433 3.83239C16.8261 3.74726 16.4951 3.72547 16.1695 3.76824C15.8438 3.81101 15.5297 3.91751 15.2452 4.08167L14.8743 4.29583C14.1739 3.69743 13.369 3.23354 12.5002 2.9275V2.5C12.5002 1.83696 12.2368 1.20107 11.7679 0.732233C11.2991 0.263392 10.6632 0 10.0002 0C9.33712 0 8.70123 0.263392 8.23239 0.732233C7.76355 1.20107 7.50016 1.83696 7.50016 2.5V2.9275C6.63131 3.23464 5.8267 3.69967 5.12682 4.29917L4.75432 4.08333C4.17969 3.75181 3.49689 3.66214 2.85614 3.83405C2.21539 4.00596 1.66918 4.42536 1.33766 5C1.00614 5.57464 0.916468 6.25743 1.08838 6.89818C1.26028 7.53893 1.67969 8.08515 2.25432 8.41667L2.62432 8.63C2.45775 9.5363 2.45775 10.4654 2.62432 11.3717L2.25432 11.585C1.67969 11.9165 1.26028 12.4627 1.08838 13.1035C0.916468 13.7442 1.00614 14.427 1.33766 15.0017C1.66918 15.5763 2.21539 15.9957 2.85614 16.1676C3.49689 16.3395 4.17969 16.2499 4.75432 15.9183L5.12516 15.7042C5.8258 16.3027 6.63097 16.7666 7.50016 17.0725V17.5C7.50016 18.163 7.76355 18.7989 8.23239 19.2678C8.70123 19.7366 9.33712 20 10.0002 20C10.6632 20 11.2991 19.7366 11.7679 19.2678C12.2368 18.7989 12.5002 18.163 12.5002 17.5V17.0725C13.369 16.7654 14.1736 16.3003 14.8735 15.7008L15.246 15.9158C15.8206 16.2474 16.5034 16.337 17.1442 16.1651C17.7849 15.9932 18.3311 15.5738 18.6627 14.9992C18.9942 14.4245 19.0838 13.7417 18.9119 13.101C18.74 12.4602 18.3206 11.914 17.746 11.5825L17.7452 11.5833ZM15.6218 8.43667C15.904 9.45922 15.904 10.5391 15.6218 11.5617C15.5725 11.7396 15.5838 11.9289 15.6538 12.0998C15.7238 12.2707 15.8485 12.4135 16.0085 12.5058L16.9118 13.0275C17.1033 13.138 17.2431 13.3201 17.3004 13.5336C17.3577 13.7472 17.3277 13.9747 17.2172 14.1663C17.1067 14.3578 16.9247 14.4975 16.7111 14.5548C16.4976 14.6121 16.27 14.5822 16.0785 14.4717L15.1735 13.9483C15.0134 13.8556 14.827 13.8188 14.6437 13.8437C14.4604 13.8686 14.2906 13.9538 14.161 14.0858C13.4193 14.843 12.4848 15.3833 11.4585 15.6483C11.2794 15.6944 11.1206 15.7987 11.0073 15.9449C10.894 16.0911 10.8326 16.2709 10.8327 16.4558V17.5C10.8327 17.721 10.7449 17.933 10.5886 18.0893C10.4323 18.2455 10.2203 18.3333 9.99932 18.3333C9.77831 18.3333 9.56635 18.2455 9.41007 18.0893C9.25379 17.933 9.16599 17.721 9.16599 17.5V16.4567C9.16608 16.2717 9.10464 16.092 8.99133 15.9458C8.87802 15.7996 8.7193 15.6952 8.54016 15.6492C7.51378 15.3831 6.5796 14.8416 5.83849 14.0833C5.70893 13.9513 5.53911 13.8661 5.35579 13.8412C5.17247 13.8163 4.98608 13.8531 4.82599 13.9458L3.92266 14.4683C3.82785 14.5239 3.72298 14.5602 3.6141 14.5751C3.50521 14.59 3.39445 14.5832 3.2882 14.5551C3.18195 14.527 3.08231 14.4782 2.99501 14.4114C2.90771 14.3446 2.83447 14.2613 2.77952 14.1661C2.72457 14.0709 2.68899 13.9658 2.67482 13.8568C2.66066 13.7479 2.66819 13.6372 2.69698 13.5311C2.72578 13.425 2.77527 13.3257 2.8426 13.2389C2.90994 13.152 2.99379 13.0793 3.08932 13.025L3.99266 12.5033C4.15262 12.411 4.27739 12.2682 4.34737 12.0973C4.41736 11.9264 4.4286 11.7371 4.37932 11.5592C4.09712 10.5366 4.09712 9.45672 4.37932 8.43417C4.42771 8.25657 4.41594 8.06795 4.34584 7.89774C4.27574 7.72754 4.15125 7.58534 3.99182 7.49333L3.08849 6.97167C2.89698 6.86116 2.75722 6.6791 2.69994 6.46555C2.64266 6.25199 2.67257 6.02442 2.78307 5.83292C2.89358 5.64141 3.07564 5.50164 3.2892 5.44437C3.50275 5.38709 3.73032 5.41699 3.92182 5.5275L4.82682 6.05083C4.98647 6.14376 5.17247 6.18101 5.3556 6.15672C5.53872 6.13244 5.70858 6.048 5.83849 5.91667C6.58023 5.15945 7.51468 4.61918 8.54099 4.35417C8.72068 4.30797 8.87982 4.20313 8.99319 4.05625C9.10655 3.90938 9.16766 3.72887 9.16682 3.54333V2.5C9.16682 2.27899 9.25462 2.06702 9.4109 1.91074C9.56718 1.75446 9.77914 1.66667 10.0002 1.66667C10.2212 1.66667 10.4331 1.75446 10.5894 1.91074C10.7457 2.06702 10.8335 2.27899 10.8335 2.5V3.54333C10.8334 3.7283 10.8948 3.90804 11.0082 4.05423C11.1215 4.20043 11.2802 4.30478 11.4593 4.35083C12.486 4.61679 13.4205 5.15824 14.1618 5.91667C14.2914 6.04872 14.4612 6.13391 14.6445 6.15881C14.8278 6.1837 15.0142 6.14689 15.1743 6.05417L16.0777 5.53167C16.1725 5.47609 16.2773 5.43981 16.3862 5.42492C16.4951 5.41003 16.6059 5.41683 16.7121 5.44492C16.8184 5.47301 16.918 5.52184 17.0053 5.58859C17.0926 5.65535 17.1658 5.73872 17.2208 5.83389C17.2757 5.92907 17.3113 6.03417 17.3255 6.14316C17.3397 6.25214 17.3321 6.36285 17.3033 6.46891C17.2745 6.57497 17.225 6.67429 17.1577 6.76114C17.0904 6.848 17.0065 6.92068 16.911 6.975L16.0077 7.49667C15.8485 7.58892 15.7244 7.73123 15.6546 7.90141C15.5848 8.07159 15.5733 8.26008 15.6218 8.4375V8.43667Z",
          fill: "currentColor"
        }
      )
    ]
  }
), Hw = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_842_3882)", children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M5.83333 0H3.33333C2.44928 0 1.60143 0.35119 0.976311 0.976311C0.35119 1.60143 0 2.44928 0 3.33333L0 5.83333C0 6.71739 0.35119 7.56524 0.976311 8.19036C1.60143 8.81548 2.44928 9.16667 3.33333 9.16667H5.83333C6.71739 9.16667 7.56524 8.81548 8.19036 8.19036C8.81548 7.56524 9.16667 6.71739 9.16667 5.83333V3.33333C9.16667 2.44928 8.81548 1.60143 8.19036 0.976311C7.56524 0.35119 6.71739 0 5.83333 0ZM7.5 5.83333C7.5 6.27536 7.32441 6.69928 7.01185 7.01185C6.69928 7.32441 6.27536 7.5 5.83333 7.5H3.33333C2.89131 7.5 2.46738 7.32441 2.15482 7.01185C1.84226 6.69928 1.66667 6.27536 1.66667 5.83333V3.33333C1.66667 2.89131 1.84226 2.46738 2.15482 2.15482C2.46738 1.84226 2.89131 1.66667 3.33333 1.66667H5.83333C6.27536 1.66667 6.69928 1.84226 7.01185 2.15482C7.32441 2.46738 7.5 2.89131 7.5 3.33333V5.83333Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M16.6668 0H14.1668C13.2828 0 12.4349 0.35119 11.8098 0.976311C11.1847 1.60143 10.8335 2.44928 10.8335 3.33333V5.83333C10.8335 6.71739 11.1847 7.56524 11.8098 8.19036C12.4349 8.81548 13.2828 9.16667 14.1668 9.16667H16.6668C17.5509 9.16667 18.3987 8.81548 19.0239 8.19036C19.649 7.56524 20.0002 6.71739 20.0002 5.83333V3.33333C20.0002 2.44928 19.649 1.60143 19.0239 0.976311C18.3987 0.35119 17.5509 0 16.6668 0ZM18.3335 5.83333C18.3335 6.27536 18.1579 6.69928 17.8453 7.01185C17.5328 7.32441 17.1089 7.5 16.6668 7.5H14.1668C13.7248 7.5 13.3009 7.32441 12.9883 7.01185C12.6758 6.69928 12.5002 6.27536 12.5002 5.83333V3.33333C12.5002 2.89131 12.6758 2.46738 12.9883 2.15482C13.3009 1.84226 13.7248 1.66667 14.1668 1.66667H16.6668C17.1089 1.66667 17.5328 1.84226 17.8453 2.15482C18.1579 2.46738 18.3335 2.89131 18.3335 3.33333V5.83333Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M5.83333 10.8335H3.33333C2.44928 10.8335 1.60143 11.1847 0.976311 11.8098C0.35119 12.4349 0 13.2828 0 14.1668L0 16.6668C0 17.5509 0.35119 18.3987 0.976311 19.0239C1.60143 19.649 2.44928 20.0002 3.33333 20.0002H5.83333C6.71739 20.0002 7.56524 19.649 8.19036 19.0239C8.81548 18.3987 9.16667 17.5509 9.16667 16.6668V14.1668C9.16667 13.2828 8.81548 12.4349 8.19036 11.8098C7.56524 11.1847 6.71739 10.8335 5.83333 10.8335ZM7.5 16.6668C7.5 17.1089 7.32441 17.5328 7.01185 17.8453C6.69928 18.1579 6.27536 18.3335 5.83333 18.3335H3.33333C2.89131 18.3335 2.46738 18.1579 2.15482 17.8453C1.84226 17.5328 1.66667 17.1089 1.66667 16.6668V14.1668C1.66667 13.7248 1.84226 13.3009 2.15482 12.9883C2.46738 12.6758 2.89131 12.5002 3.33333 12.5002H5.83333C6.27536 12.5002 6.69928 12.6758 7.01185 12.9883C7.32441 13.3009 7.5 13.7248 7.5 14.1668V16.6668Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M16.6668 10.8335H14.1668C13.2828 10.8335 12.4349 11.1847 11.8098 11.8098C11.1847 12.4349 10.8335 13.2828 10.8335 14.1668V16.6668C10.8335 17.5509 11.1847 18.3987 11.8098 19.0239C12.4349 19.649 13.2828 20.0002 14.1668 20.0002H16.6668C17.5509 20.0002 18.3987 19.649 19.0239 19.0239C19.649 18.3987 20.0002 17.5509 20.0002 16.6668V14.1668C20.0002 13.2828 19.649 12.4349 19.0239 11.8098C18.3987 11.1847 17.5509 10.8335 16.6668 10.8335ZM18.3335 16.6668C18.3335 17.1089 18.1579 17.5328 17.8453 17.8453C17.5328 18.1579 17.1089 18.3335 16.6668 18.3335H14.1668C13.7248 18.3335 13.3009 18.1579 12.9883 17.8453C12.6758 17.5328 12.5002 17.1089 12.5002 16.6668V14.1668C12.5002 13.7248 12.6758 13.3009 12.9883 12.9883C13.3009 12.6758 13.7248 12.5002 14.1668 12.5002H16.6668C17.1089 12.5002 17.5328 12.6758 17.8453 12.9883C18.1579 13.3009 18.3335 13.7248 18.3335 14.1668V16.6668Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_842_3882", children: /* @__PURE__ */ f.jsx("rect", { width: 20, height: 20, fill: "white" }) }) })
    ]
  }
), Fw = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2127_30852)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M10 14.1666V17.4999C10 17.9583 9.625 18.3333 9.16667 18.3333H5.83333C5.375 18.3333 5 17.9583 5 17.4999C5 17.0416 5.375 16.6666 5.83333 16.6666H8.33333V14.9999H4.16667C1.86667 14.9999 0 13.1333 0 10.8333V4.99992C0 2.69992 1.86667 0.833252 4.16667 0.833252H14.1667C16.4667 0.833252 18.3333 2.69992 18.3333 4.99992C18.3333 5.45825 17.9583 5.83325 17.5 5.83325C17.0417 5.83325 16.6667 5.45825 16.6667 4.99992C16.6667 3.62492 15.5417 2.49992 14.1667 2.49992H4.16667C2.79167 2.49992 1.66667 3.62492 1.66667 4.99992V10.8333C1.66667 12.2083 2.79167 13.3333 4.16667 13.3333H9.16667C9.625 13.3333 10 13.7083 10 14.1666ZM20 10.8333V16.6666C20 18.5083 18.5083 19.9999 16.6667 19.9999H15C13.1583 19.9999 11.6667 18.5083 11.6667 16.6666V10.8333C11.6667 8.99158 13.1583 7.49992 15 7.49992H16.6667C18.5083 7.49992 20 8.99158 20 10.8333ZM18.3333 10.8333C18.3333 9.91658 17.5833 9.16658 16.6667 9.16658H15C14.0833 9.16658 13.3333 9.91658 13.3333 10.8333V16.6666C13.3333 17.5833 14.0833 18.3333 15 18.3333H16.6667C17.5833 18.3333 18.3333 17.5833 18.3333 16.6666V10.8333Z",
        fill: "currentColor"
      }
    ) })
  }
), Ww = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2656_4445)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M13.3333 19.1667C13.3333 19.6267 12.9608 20 12.4999 20H4.99992C2.70242 20 0.833252 18.1308 0.833252 15.8333V4.16667C0.833252 1.86917 2.70242 0 4.99992 0H8.76242C10.3199 0 11.7849 0.606667 12.8874 1.70833L15.7908 4.61333C16.0166 4.83917 16.2266 5.08667 16.4141 5.34917C16.6816 5.72333 16.5949 6.24417 16.2208 6.51167C15.8466 6.77833 15.3249 6.6925 15.0583 6.3175C14.9241 6.13 14.7741 5.9525 14.6133 5.7925L11.7091 2.8875C11.4441 2.6225 11.1499 2.39833 10.8333 2.21667V5.83333C10.8333 6.2925 11.2066 6.66667 11.6666 6.66667H14.1666C14.6274 6.66667 14.9999 7.04 14.9999 7.5C14.9999 7.96 14.6274 8.33333 14.1666 8.33333H11.6666C10.2883 8.33333 9.16659 7.21167 9.16659 5.83333V1.68583C9.03325 1.67333 8.89825 1.66667 8.76242 1.66667H4.99992C3.62159 1.66667 2.49992 2.78833 2.49992 4.16667V15.8333C2.49992 17.2117 3.62159 18.3333 4.99992 18.3333H12.4999C12.9608 18.3333 13.3333 18.7067 13.3333 19.1667ZM18.0708 13.5558L15.5366 13.1333C15.2258 13.0817 14.9999 12.815 14.9999 12.5C14.9999 12.0408 15.3733 11.6667 15.8333 11.6667H17.7233C18.0199 11.6667 18.2966 11.8267 18.4458 12.0833C18.6749 12.4817 19.1833 12.6175 19.5841 12.3875C19.9824 12.1567 20.1191 11.6475 19.8874 11.2492C19.4424 10.4783 18.6124 9.99917 17.7224 9.99917H17.4991V9.16583C17.4991 8.70583 17.1266 8.3325 16.6658 8.3325C16.2049 8.3325 15.8324 8.70583 15.8324 9.16583V9.99917C14.4541 9.99917 13.3324 11.1208 13.3324 12.4992C13.3324 13.6325 14.1441 14.5908 15.2616 14.7767L17.7958 15.1992C18.1066 15.2508 18.3324 15.5175 18.3324 15.8325C18.3324 16.2917 17.9591 16.6658 17.4991 16.6658H15.6091C15.3124 16.6658 15.0358 16.5058 14.8866 16.2492C14.6574 15.85 14.1483 15.7142 13.7483 15.945C13.3499 16.1758 13.2133 16.685 13.4449 17.0833C13.8899 17.8542 14.7199 18.3325 15.6099 18.3325H15.8333V19.1658C15.8333 19.6258 16.2058 19.9992 16.6666 19.9992C17.1274 19.9992 17.4999 19.6258 17.4999 19.1658V18.3325C18.8783 18.3325 19.9999 17.2108 19.9999 15.8325C19.9999 14.6992 19.1883 13.7417 18.0708 13.5558ZM6.24992 12.5H10.8333C11.2941 12.5 11.6666 12.1267 11.6666 11.6667C11.6666 11.2067 11.2941 10.8333 10.8333 10.8333H6.24992C5.10159 10.8333 4.16659 11.7683 4.16659 12.9167V14.5833C4.16659 15.7317 5.10159 16.6667 6.24992 16.6667H10.8333C11.2941 16.6667 11.6666 16.2933 11.6666 15.8333C11.6666 15.3733 11.2941 15 10.8333 15H6.24992C6.01992 15 5.83325 14.8133 5.83325 14.5833V12.9167C5.83325 12.6867 6.01992 12.5 6.24992 12.5ZM4.99992 9.16667H6.66659C7.12659 9.16667 7.49992 8.79333 7.49992 8.33333C7.49992 7.87333 7.12659 7.5 6.66659 7.5H4.99992C4.53992 7.5 4.16659 7.87333 4.16659 8.33333C4.16659 8.79333 4.53992 9.16667 4.99992 9.16667ZM4.99992 5.83333H6.66659C7.12659 5.83333 7.49992 5.46 7.49992 5C7.49992 4.54 7.12659 4.16667 6.66659 4.16667H4.99992C4.53992 4.16667 4.16659 4.54 4.16659 5C4.16659 5.46 4.53992 5.83333 4.99992 5.83333Z",
        fill: "currentColor"
      }
    ) })
  }
), zw = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M7.33366 3.33333C8.25413 3.33333 9.00033 2.58714 9.00033 1.66667C9.00033 0.746192 8.25413 0 7.33366 0C6.41318 0 5.66699 0.746192 5.66699 1.66667C5.66699 2.58714 6.41318 3.33333 7.33366 3.33333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M7.33366 11.6668C8.25413 11.6668 9.00033 10.9206 9.00033 10.0002C9.00033 9.07969 8.25413 8.3335 7.33366 8.3335C6.41318 8.3335 5.66699 9.07969 5.66699 10.0002C5.66699 10.9206 6.41318 11.6668 7.33366 11.6668Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M7.33366 19.9998C8.25413 19.9998 9.00033 19.2536 9.00033 18.3332C9.00033 17.4127 8.25413 16.6665 7.33366 16.6665C6.41318 16.6665 5.66699 17.4127 5.66699 18.3332C5.66699 19.2536 6.41318 19.9998 7.33366 19.9998Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M12.6667 3.33333C13.5871 3.33333 14.3333 2.58714 14.3333 1.66667C14.3333 0.746192 13.5871 0 12.6667 0C11.7462 0 11 0.746192 11 1.66667C11 2.58714 11.7462 3.33333 12.6667 3.33333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M12.6667 11.6668C13.5871 11.6668 14.3333 10.9206 14.3333 10.0002C14.3333 9.07969 13.5871 8.3335 12.6667 8.3335C11.7462 8.3335 11 9.07969 11 10.0002C11 10.9206 11.7462 11.6668 12.6667 11.6668Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M12.6667 19.9998C13.5871 19.9998 14.3333 19.2536 14.3333 18.3332C14.3333 17.4127 13.5871 16.6665 12.6667 16.6665C11.7462 16.6665 11 17.4127 11 18.3332C11 19.2536 11.7462 19.9998 12.6667 19.9998Z",
          fill: "currentColor"
        }
      )
    ]
  }
), Uw = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2127_32960)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M10.8333 4.99954H4.16667C1.86667 4.99954 0 6.86621 0 9.16621V15.8329C0 18.1329 1.86667 19.9995 4.16667 19.9995H10.8333C13.1333 19.9995 15 18.1329 15 15.8329V9.16621C15 6.86621 13.1333 4.99954 10.8333 4.99954ZM4.16667 6.66621H10.8333C12.2083 6.66621 13.3333 7.79121 13.3333 9.16621H1.66667C1.66667 7.79121 2.79167 6.66621 4.16667 6.66621ZM10.8333 18.3329H4.16667C2.79167 18.3329 1.66667 17.2079 1.66667 15.8329V10.8329H13.3333V15.8329C13.3333 17.2079 12.2083 18.3329 10.8333 18.3329ZM20 4.16621V11.2829C20 12.7662 19.2 14.1495 17.9167 14.8912C17.7833 14.9662 17.6417 14.9995 17.5 14.9995C17.2083 14.9995 16.9333 14.8495 16.775 14.5829C16.5417 14.1829 16.6833 13.6745 17.075 13.4412C17.85 12.9912 18.325 12.1662 18.325 11.2745V4.16621C18.325 2.79121 17.2 1.66621 15.825 1.66621H8.71667C7.825 1.66621 7 2.14954 6.55 2.91621C6.31667 3.31621 5.80833 3.44954 5.40833 3.21621C5.00833 2.98288 4.875 2.47454 5.10833 2.07454C5.85 0.791211 7.23333 -0.00878906 8.71667 -0.00878906H15.8333C18.1333 -0.00878906 20 1.85788 20 4.15788V4.16621Z",
        fill: "currentColor"
      }
    ) })
  }
), Zw = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2341_562)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M15.5468 0.775223L5.38676 10.9352C4.99872 11.3212 4.69108 11.7803 4.48167 12.2859C4.27225 12.7916 4.16522 13.3338 4.16676 13.8811V15.0002C4.16676 15.2212 4.25456 15.4332 4.41084 15.5895C4.56712 15.7458 4.77908 15.8336 5.0001 15.8336H6.11926C6.66657 15.8351 7.20874 15.7281 7.71439 15.5187C8.22005 15.3092 8.67914 15.0016 9.0651 14.6136L19.2251 4.45356C19.7121 3.96536 19.9856 3.30395 19.9856 2.61439C19.9856 1.92483 19.7121 1.26341 19.2251 0.775223C18.7298 0.301801 18.0711 0.0375977 17.3859 0.0375977C16.7008 0.0375977 16.042 0.301801 15.5468 0.775223ZM18.0468 3.27522L7.88676 13.4352C7.41687 13.9022 6.78177 14.1652 6.11926 14.1669H5.83343V13.8811C5.83517 13.2186 6.09807 12.5835 6.5651 12.1136L16.7251 1.95356C16.9031 1.78352 17.1398 1.68863 17.3859 1.68863C17.6321 1.68863 17.8688 1.78352 18.0468 1.95356C18.2217 2.12899 18.32 2.36663 18.32 2.61439C18.32 2.86215 18.2217 3.09979 18.0468 3.27522Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.1667 7.4825C18.9457 7.4825 18.7337 7.5703 18.5774 7.72658C18.4211 7.88286 18.3333 8.09482 18.3333 8.31583V12.5H15C14.337 12.5 13.7011 12.7634 13.2322 13.2322C12.7634 13.7011 12.5 14.337 12.5 15V18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V4.16667C1.66667 3.50363 1.93006 2.86774 2.3989 2.3989C2.86774 1.93006 3.50363 1.66667 4.16667 1.66667H11.7017C11.9227 1.66667 12.1346 1.57887 12.2909 1.42259C12.4472 1.26631 12.535 1.05435 12.535 0.833333C12.535 0.61232 12.4472 0.400358 12.2909 0.244078C12.1346 0.0877974 11.9227 0 11.7017 0L4.16667 0C3.062 0.00132321 2.00296 0.440735 1.22185 1.22185C0.440735 2.00296 0.00132321 3.062 0 4.16667L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H13.6192C14.1666 20.0016 14.7089 19.8945 15.2147 19.6851C15.7205 19.4757 16.1797 19.1681 16.5658 18.78L18.7792 16.565C19.1673 16.1791 19.475 15.72 19.6846 15.2143C19.8941 14.7087 20.0013 14.1665 20 13.6192V8.31583C20 8.09482 19.9122 7.88286 19.7559 7.72658C19.5996 7.5703 19.3877 7.4825 19.1667 7.4825ZM15.3875 17.6017C15.0525 17.9358 14.6289 18.1672 14.1667 18.2683V15C14.1667 14.779 14.2545 14.567 14.4107 14.4107C14.567 14.2545 14.779 14.1667 15 14.1667H18.2708C18.1677 14.6279 17.9367 15.0508 17.6042 15.3867L15.3875 17.6017Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), qw = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2462_9634)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M15.55 17.4167C15.2083 17.1083 14.675 17.1417 14.375 17.4917C13.9 18.0333 13.2167 18.3417 12.5 18.3417H4.16667C2.79167 18.3417 1.66667 17.2167 1.66667 15.8417V4.16667C1.66667 2.79167 2.79167 1.66667 4.16667 1.66667H7.925C8.05833 1.66667 8.2 1.66667 8.33333 1.68333V5.83333C8.33333 7.20833 9.45833 8.33333 10.8333 8.33333H15.675C15.9333 8.33333 16.175 8.21667 16.3333 8.00833C16.4917 7.8 16.5417 7.54167 16.4833 7.29167C16.225 6.275 15.7 5.35 14.9583 4.60833L12.0583 1.70833C10.9583 0.608333 9.49167 0 7.93333 0H4.16667C1.86667 0 0 1.86667 0 4.16667V15.8333C0 18.1333 1.86667 20 4.16667 20H12.5C13.6917 20 14.8333 19.4833 15.625 18.5917C15.9333 18.25 15.9 17.7167 15.55 17.4167ZM10 2.21667C10.3167 2.4 10.6083 2.625 10.875 2.89167L13.775 5.79167C14.0333 6.05 14.2583 6.35 14.4417 6.66667H10.825C10.3667 6.66667 9.99167 6.29167 9.99167 5.83333V2.21667H10ZM19.275 15.075L17.9333 16.4167C17.7667 16.5833 17.5583 16.6583 17.3417 16.6583C17.125 16.6583 16.9167 16.575 16.75 16.4167C16.425 16.0917 16.425 15.5667 16.75 15.2417L17.825 14.1667H11.6583C11.2 14.1667 10.825 13.7917 10.825 13.3333C10.825 12.875 11.2 12.5 11.6583 12.5H17.825L16.75 11.425C16.425 11.1 16.425 10.575 16.75 10.25C17.075 9.925 17.6 9.925 17.925 10.25L19.2667 11.5917C20.225 12.55 20.225 14.1167 19.2667 15.0833L19.275 15.075Z",
        fill: "currentColor"
      }
    ) })
  }
), Gw = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_842_5289)", fill: "currentColor", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M19.392 7.85C18.1 5.745 15.16 2.213 10 2.213c-5.16 0-8.1 3.532-9.393 5.637a4.09 4.09 0 000 4.301C1.9 14.256 4.84 17.788 10 17.788c5.16 0 8.1-3.532 9.392-5.637a4.09 4.09 0 000-4.301zm-1.42 3.429c-1.11 1.805-3.623 4.842-7.972 4.842-4.35 0-6.862-3.037-7.972-4.842a2.431 2.431 0 010-2.557C3.138 6.917 5.651 3.88 10 3.88s6.861 3.034 7.971 4.842a2.432 2.432 0 010 2.557z" }),
      /* @__PURE__ */ f.jsx("path", { d: "M10 5.833a4.167 4.167 0 100 8.333 4.167 4.167 0 000-8.333zm0 6.667A2.5 2.5 0 1110 7.5a2.5 2.5 0 010 4.999z" })
    ] })
  }
), Yw = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_842_5318)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M19.392 7.849a13.22 13.22 0 00-2.809-3.258l2.334-2.333a.833.833 0 00-1.179-1.178l-2.537 2.54A10.045 10.045 0 0010 2.212c-5.16 0-8.1 3.532-9.393 5.637a4.09 4.09 0 000 4.301 13.222 13.222 0 002.81 3.258l-2.334 2.333a.833.833 0 101.178 1.179l2.544-2.544A10.044 10.044 0 0010 17.787c5.159 0 8.099-3.531 9.392-5.636a4.09 4.09 0 000-4.302zM2.027 11.278a2.432 2.432 0 010-2.557C3.14 6.916 5.651 3.88 10 3.88a8.417 8.417 0 013.972.97l-1.678 1.678a4.16 4.16 0 00-5.767 5.767l-1.925 1.925a11.435 11.435 0 01-2.575-2.941zM12.5 10a2.5 2.5 0 01-2.5 2.5 2.458 2.458 0 01-1.071-.25l3.32-3.321c.164.333.25.7.25 1.07zm-5 0A2.5 2.5 0 0110 7.5a2.46 2.46 0 011.07.25l-3.32 3.32A2.46 2.46 0 017.5 10zm10.472 1.278C16.861 13.083 14.348 16.12 10 16.12a8.417 8.417 0 01-3.972-.97l1.678-1.678a4.16 4.16 0 005.766-5.767l1.925-1.925c1.021.826 1.892 1.82 2.575 2.941a2.431 2.431 0 010 2.557z",
        fill: "currentColor"
      }
    ) })
  }
), Kw = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2127_51729)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M1.2474 4.58208H3.5274C3.70626 5.24019 4.09671 5.82116 4.6385 6.23536C5.1803 6.64956 5.84333 6.87397 6.52531 6.87397C7.2073 6.87397 7.87033 6.64956 8.41212 6.23536C8.95392 5.82116 9.34437 5.24019 9.52323 4.58208H19.5807C19.8017 4.58208 20.0137 4.49429 20.17 4.33801C20.3263 4.18173 20.4141 3.96976 20.4141 3.74875C20.4141 3.52774 20.3263 3.31578 20.17 3.1595C20.0137 3.00321 19.8017 2.91542 19.5807 2.91542H9.52323C9.34437 2.25731 8.95392 1.67634 8.41212 1.26214C7.87033 0.847944 7.2073 0.623535 6.52531 0.623535C5.84333 0.623535 5.1803 0.847944 4.6385 1.26214C4.09671 1.67634 3.70626 2.25731 3.5274 2.91542H1.2474C1.02638 2.91542 0.81442 3.00321 0.65814 3.1595C0.50186 3.31578 0.414063 3.52774 0.414062 3.74875C0.414063 3.96976 0.50186 4.18173 0.65814 4.33801C0.81442 4.49429 1.02638 4.58208 1.2474 4.58208ZM6.5249 2.29042C6.81333 2.29042 7.09528 2.37595 7.3351 2.53619C7.57492 2.69643 7.76184 2.9242 7.87222 3.19067C7.9826 3.45715 8.01148 3.75037 7.95521 4.03326C7.89894 4.31615 7.76004 4.576 7.55609 4.77995C7.35214 4.9839 7.09229 5.12279 6.8094 5.17906C6.52651 5.23533 6.23329 5.20645 5.96682 5.09608C5.70034 4.9857 5.47258 4.79878 5.31234 4.55896C5.15209 4.31914 5.06656 4.03718 5.06656 3.74875C5.067 3.36211 5.22079 2.99144 5.49419 2.71804C5.76758 2.44465 6.13826 2.29086 6.5249 2.29042Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.5807 10.1667H17.3007C17.1222 9.50846 16.7319 8.92728 16.1901 8.51291C15.6484 8.09854 14.9853 7.87402 14.3032 7.87402C13.6212 7.87402 12.9581 8.09854 12.4163 8.51291C11.8746 8.92728 11.4843 9.50846 11.3057 10.1667H1.2474C1.02638 10.1667 0.81442 10.2545 0.65814 10.4108C0.50186 10.5671 0.414063 10.779 0.414062 11.0001C0.414063 11.2211 0.50186 11.433 0.65814 11.5893C0.81442 11.7456 1.02638 11.8334 1.2474 11.8334H11.3057C11.4843 12.4916 11.8746 13.0728 12.4163 13.4872C12.9581 13.9016 13.6212 14.1261 14.3032 14.1261C14.9853 14.1261 15.6484 13.9016 16.1901 13.4872C16.7319 13.0728 17.1222 12.4916 17.3007 11.8334H19.5807C19.8017 11.8334 20.0137 11.7456 20.17 11.5893C20.3263 11.433 20.4141 11.2211 20.4141 11.0001C20.4141 10.779 20.3263 10.5671 20.17 10.4108C20.0137 10.2545 19.8017 10.1667 19.5807 10.1667ZM14.3032 12.4584C14.0148 12.4584 13.7328 12.3729 13.493 12.2126C13.2532 12.0524 13.0663 11.8246 12.9559 11.5581C12.8455 11.2917 12.8166 10.9984 12.8729 10.7155C12.9292 10.4327 13.0681 10.1728 13.272 9.96885C13.476 9.7649 13.7358 9.62601 14.0187 9.56974C14.3016 9.51347 14.5948 9.54235 14.8613 9.65273C15.1278 9.76311 15.3555 9.95002 15.5158 10.1898C15.676 10.4297 15.7616 10.7116 15.7616 11.0001C15.7611 11.3867 15.6073 11.7574 15.3339 12.0308C15.0605 12.3042 14.6899 12.4579 14.3032 12.4584Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.5807 17.4179H9.52323C9.34437 16.7597 8.95392 16.1788 8.41212 15.7646C7.87033 15.3504 7.2073 15.126 6.52531 15.126C5.84333 15.126 5.1803 15.3504 4.6385 15.7646C4.09671 16.1788 3.70626 16.7597 3.5274 17.4179H1.2474C1.02638 17.4179 0.81442 17.5057 0.65814 17.6619C0.50186 17.8182 0.414063 18.0302 0.414062 18.2512C0.414063 18.4722 0.50186 18.6842 0.65814 18.8404C0.81442 18.9967 1.02638 19.0845 1.2474 19.0845H3.5274C3.70626 19.7426 4.09671 20.3236 4.6385 20.7378C5.1803 21.152 5.84333 21.3764 6.52531 21.3764C7.2073 21.3764 7.87033 21.152 8.41212 20.7378C8.95392 20.3236 9.34437 19.7426 9.52323 19.0845H19.5807C19.8017 19.0845 20.0137 18.9967 20.17 18.8404C20.3263 18.6842 20.4141 18.4722 20.4141 18.2512C20.4141 18.0302 20.3263 17.8182 20.17 17.6619C20.0137 17.5057 19.8017 17.4179 19.5807 17.4179ZM6.5249 19.7095C6.23646 19.7095 5.95451 19.624 5.71469 19.4638C5.47487 19.3035 5.28795 19.0757 5.17757 18.8093C5.06719 18.5428 5.03831 18.2496 5.09458 17.9667C5.15085 17.6838 5.28975 17.4239 5.4937 17.22C5.69765 17.016 5.9575 16.8772 6.24039 16.8209C6.52328 16.7646 6.8165 16.7935 7.08298 16.9039C7.34945 17.0142 7.57721 17.2012 7.73746 17.441C7.8977 17.6808 7.98323 17.9628 7.98323 18.2512C7.98257 18.6378 7.82871 19.0083 7.55536 19.2817C7.28202 19.555 6.91147 19.7089 6.5249 19.7095Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), Xw = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2656_4413)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M15.8333 0H4.16667C1.86667 0 0 1.86667 0 4.16667V15.8333C0 18.1333 1.86667 20 4.16667 20H8.69167C9.15 20 9.525 19.625 9.525 19.1667C9.525 18.7083 9.15 18.3333 8.69167 18.3333H4.16667C2.78333 18.3333 1.66667 17.2167 1.66667 15.8333V4.16667C1.66667 2.78333 2.78333 1.66667 4.16667 1.66667H15.8333C17.2167 1.66667 18.3333 2.78333 18.3333 4.16667V7.78333C18.3333 8.24167 18.7083 8.61667 19.1667 8.61667C19.625 8.61667 20 8.24167 20 7.78333V4.16667C20 1.86667 18.1333 0 15.8333 0Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.67511 9.6333C9.67511 10.9416 8.60844 12.0083 7.30011 12.0083V12.8C7.30011 13.2416 6.94178 13.5916 6.50844 13.5916C6.07511 13.5916 5.71678 13.2333 5.71678 12.8V12.0083H5.50844C4.65844 12.0083 3.87511 11.55 3.45011 10.8166C3.23344 10.4333 3.35844 9.94997 3.74178 9.7333C4.12511 9.5083 4.60844 9.64163 4.82511 10.025C4.96678 10.2666 5.23344 10.425 5.50844 10.425H7.30844C7.75011 10.425 8.10011 10.0666 8.10011 9.6333C8.10011 9.3333 7.88344 9.0833 7.59178 9.0333L5.18344 8.6333C4.11678 8.4583 3.35011 7.54163 3.35011 6.46663C3.35011 5.1583 4.41678 4.09163 5.72511 4.09163V3.29997C5.72511 2.8583 6.08344 2.5083 6.51678 2.5083C6.95011 2.5083 7.30844 2.86663 7.30844 3.29997V4.09163H7.51678C8.36678 4.09163 9.15011 4.54997 9.57511 5.2833C9.79178 5.6583 9.66678 6.14997 9.28344 6.36663C8.90011 6.5833 8.41678 6.4583 8.20011 6.07497C8.05844 5.8333 7.79178 5.67497 7.51678 5.67497H5.71678C5.27511 5.67497 4.92511 6.0333 4.92511 6.46663C4.92511 6.76663 5.14178 7.01663 5.43344 7.06663L7.84178 7.46663C8.90844 7.64163 9.67511 8.5583 9.67511 9.6333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.8916 11.2499C19.6583 10.8499 19.15 10.7166 18.75 10.9416L17.9416 11.4083C17.35 10.7499 16.575 10.2583 15.675 10.0833V9.16659C15.675 8.70825 15.3 8.33325 14.8416 8.33325C14.3833 8.33325 14.0083 8.70825 14.0083 9.16659V10.0833C13.1083 10.2666 12.325 10.7499 11.7416 11.4083L10.9333 10.9416C10.5333 10.7083 10.025 10.8499 9.79164 11.2499C9.55831 11.6499 9.69997 12.1583 10.1 12.3916L10.9083 12.8583C10.7666 13.2749 10.675 13.7083 10.675 14.1666C10.675 14.6249 10.7666 15.0583 10.9083 15.4749L10.1 15.9416C9.69997 16.1749 9.56664 16.6833 9.79164 17.0833C9.94997 17.3499 10.225 17.4999 10.5166 17.4999C10.6583 17.4999 10.8 17.4666 10.9333 17.3916L11.7416 16.9249C12.3333 17.5833 13.1083 18.0749 14.0083 18.2499V19.1666C14.0083 19.6249 14.3833 19.9999 14.8416 19.9999C15.3 19.9999 15.675 19.6249 15.675 19.1666V18.2499C16.575 18.0666 17.3583 17.5833 17.9416 16.9249L18.75 17.3916C18.8833 17.4666 19.025 17.4999 19.1666 17.4999C19.4583 17.4999 19.7333 17.3499 19.8916 17.0833C20.125 16.6833 19.9833 16.1749 19.5833 15.9416L18.775 15.4749C18.9166 15.0583 19.0083 14.6249 19.0083 14.1666C19.0083 13.7083 18.9166 13.2666 18.775 12.8583L19.5833 12.3916C19.9833 12.1583 20.1166 11.6499 19.8916 11.2499ZM14.8416 16.6666C13.4666 16.6666 12.3416 15.5416 12.3416 14.1666C12.3416 12.7916 13.4666 11.6666 14.8416 11.6666C16.2166 11.6666 17.3416 12.7916 17.3416 14.1666C17.3416 15.5416 16.2166 16.6666 14.8416 16.6666Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), Qw = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M50.072 28.858A14.429 14.429 0 1164.5 14.428c-.01 7.965-6.463 14.42-14.428 14.429v.002zm0-26.358A11.928 11.928 0 1062 14.43C61.992 7.844 56.657 2.507 50.072 2.5z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M50.071 18.817c-.69 0-1.25-.56-1.25-1.25v-.087a5.753 5.753 0 012.729-4.855 2.766 2.766 0 10-4.245-2.338 1.25 1.25 0 11-2.5 0 5.288 5.288 0 011.673-3.85 5.22 5.22 0 013.965-1.402 5.267 5.267 0 012.445 9.705 3.258 3.258 0 00-1.567 2.742v.087c0 .69-.56 1.25-1.25 1.25v-.002zM50.072 23.837a1.19 1.19 0 01-.477-.095 1.195 1.195 0 01-.218-.117 1.208 1.208 0 01-.46-.561 1.26 1.26 0 01-.072-.727 1.26 1.26 0 01.982-.982 1.206 1.206 0 01.723.072 1.326 1.326 0 01.405.27 1.218 1.218 0 01.27.407 1.26 1.26 0 01.072.726 1.05 1.05 0 01-.072.234c-.032.075-.07.148-.114.216a1.277 1.277 0 01-1.038.557h-.002zM53.625 64H6.36A5.866 5.866 0 01.5 58.14V31.658a5.879 5.879 0 012.392-4.723l5.033-3.698a1.251 1.251 0 011.482 2.015L4.375 28.95A3.378 3.378 0 003 31.66V58.14a3.363 3.363 0 003.36 3.36h47.265a3.363 3.363 0 003.36-3.36V31.658a3.374 3.374 0 00-1.375-2.708L54 27.765a1.25 1.25 0 011.476-2.015l1.612 1.185a5.885 5.885 0 012.392 4.724V58.14A5.866 5.866 0 0153.625 64z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M56.663 62.85c-.266 0-.526-.085-.74-.243L35.938 47.923a1.25 1.25 0 111.48-2.015l19.987 14.684a1.25 1.25 0 01-.74 2.258h-.002zM3.317 62.85a1.252 1.252 0 01-.742-2.258l19.987-14.684a1.25 1.25 0 111.48 2.015L4.055 62.607a1.24 1.24 0 01-.738.243z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M29.99 52.278a5.852 5.852 0 01-3.707-1.313L1.401 30.653a1.253 1.253 0 01-.205-1.78c.214-.261.524-.426.86-.454.337-.03.67.078.925.298l24.882 20.31a3.376 3.376 0 004.25 0L57 28.717a1.251 1.251 0 111.581 1.937l-24.875 20.31a5.852 5.852 0 01-3.716 1.314z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M51.313 36.22c-.69 0-1.25-.56-1.25-1.25V27.55a1.25 1.25 0 112.5 0v7.421c0 .69-.56 1.25-1.25 1.25zM8.665 36.22c-.69 0-1.25-.56-1.25-1.25V10.875a5.869 5.869 0 015.862-5.86H39.72a1.25 1.25 0 010 2.5H13.277a3.365 3.365 0 00-3.362 3.36V34.97c0 .69-.56 1.25-1.25 1.25z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M28.106 13.797H15.555a1.25 1.25 0 010-2.5h12.551a1.25 1.25 0 010 2.5zM37.885 20.698H15.557a1.25 1.25 0 010-2.5h22.328a1.25 1.25 0 010 2.5zM44.423 27.602H15.557a1.25 1.25 0 010-2.5h28.868a1.25 1.25 0 010 2.5h-.002zM44.423 34.5H15.557a1.25 1.25 0 010-2.5h28.868a1.25 1.25 0 010 2.5h-.002zM44.423 41.408H15.557a1.25 1.25 0 010-2.5h28.868a1.25 1.25 0 010 2.5h-.002z",
          fill: "currentColor"
        }
      )
    ]
  }
), Jw = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M11.115 0.54899C10.809 0.27352 10.4118 0.121094 10 0.121094C9.58824 0.121094 9.19105 0.27352 8.885 0.54899L0 8.54566V17.2123C0 17.9196 0.280952 18.5978 0.781049 19.0979C1.28115 19.598 1.95942 19.879 2.66667 19.879H17.3333C18.0406 19.879 18.7189 19.598 19.219 19.0979C19.719 18.5978 20 17.9196 20 17.2123V8.54566L11.115 0.54899ZM12.5 18.2098H7.5V14.0215C7.5 13.3584 7.76339 12.7226 8.23223 12.2537C8.70107 11.7849 9.33696 11.5215 10 11.5215C10.663 11.5215 11.2989 11.7849 11.7678 12.2537C12.2366 12.7226 12.5 13.3584 12.5 14.0215V18.2098ZM18.3333 17.2098C18.3333 17.475 18.228 17.7294 18.0404 17.9169C17.8529 18.1045 17.5985 18.2098 17.3333 18.2098H14.1667V14.0215C14.1667 12.9164 13.7277 11.8566 12.9463 11.0752C12.1649 10.2938 11.1051 9.85482 10 9.85482C8.89493 9.85482 7.83512 10.2938 7.05372 11.0752C6.27232 11.8566 5.83333 12.9164 5.83333 14.0215V18.2098H2.66667C2.40145 18.2098 2.1471 18.1045 1.95956 17.9169C1.77202 17.7294 1.66667 17.475 1.66667 17.2098V9.28732L10 1.78732L18.3333 9.28732V17.2098Z",
        fill: "currentColor"
      }
    )
  }
), eO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M15.8333 21.0018H4.16667C1.86917 21.0018 0 19.1326 0 16.8351V9.10513C0 7.71763 0.686667 6.42596 1.83667 5.65096L7.66917 1.7143C9.085 0.759297 10.915 0.759297 12.3308 1.7143L18.1642 5.65096C19.3133 6.42596 20 7.7168 20 9.10513V16.8351C20 19.1326 18.1308 21.0018 15.8333 21.0018ZM10 2.66596C9.51333 2.66596 9.02667 2.8093 8.60167 3.0968L2.76833 7.03263C2.07833 7.49763 1.66667 8.2718 1.66667 9.1043V16.8343C1.66667 18.2126 2.78833 19.3343 4.16667 19.3343H15.8333C17.2117 19.3343 18.3333 18.2126 18.3333 16.8343V9.10513C18.3333 8.27263 17.9217 7.49763 17.2325 7.03346L11.3983 3.0968C10.9733 2.8093 10.4867 2.66596 10 2.66596Z",
        fill: "currentColor"
      }
    )
  }
), tO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2127_30847)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M15.8334 7.02V5.83333C15.8334 4.28624 15.2188 2.80251 14.1249 1.70854C13.0309 0.614582 11.5472 0 10.0001 0C8.45298 0 6.96925 0.614582 5.87529 1.70854C4.78133 2.80251 4.16675 4.28624 4.16675 5.83333V7.02C3.42455 7.34392 2.79283 7.8771 2.34883 8.55434C1.90484 9.23158 1.66781 10.0235 1.66675 10.8333V15.8333C1.66807 16.938 2.10748 17.997 2.8886 18.7782C3.66971 19.5593 4.72875 19.9987 5.83341 20H14.1667C15.2714 19.9987 16.3305 19.5593 17.1116 18.7782C17.8927 17.997 18.3321 16.938 18.3334 15.8333V10.8333C18.3323 10.0235 18.0953 9.23158 17.6513 8.55434C17.2073 7.8771 16.5756 7.34392 15.8334 7.02ZM5.83341 5.83333C5.83341 4.72826 6.2724 3.66846 7.0538 2.88705C7.8352 2.10565 8.89501 1.66667 10.0001 1.66667C11.1052 1.66667 12.165 2.10565 12.9464 2.88705C13.7278 3.66846 14.1667 4.72826 14.1667 5.83333V6.66667H5.83341V5.83333ZM16.6667 15.8333C16.6667 16.4964 16.4034 17.1323 15.9345 17.6011C15.4657 18.0699 14.8298 18.3333 14.1667 18.3333H5.83341C5.17037 18.3333 4.53449 18.0699 4.06565 17.6011C3.59681 17.1323 3.33341 16.4964 3.33341 15.8333V10.8333C3.33341 10.1703 3.59681 9.53441 4.06565 9.06557C4.53449 8.59672 5.17037 8.33333 5.83341 8.33333H14.1667C14.8298 8.33333 15.4657 8.59672 15.9345 9.06557C16.4034 9.53441 16.6667 10.1703 16.6667 10.8333V15.8333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10.0001 11.6667C9.77907 11.6667 9.56711 11.7545 9.41083 11.9108C9.25455 12.0671 9.16675 12.2791 9.16675 12.5001V14.1667C9.16675 14.3878 9.25455 14.5997 9.41083 14.756C9.56711 14.9123 9.77907 15.0001 10.0001 15.0001C10.2211 15.0001 10.4331 14.9123 10.5893 14.756C10.7456 14.5997 10.8334 14.3878 10.8334 14.1667V12.5001C10.8334 12.2791 10.7456 12.0671 10.5893 11.9108C10.4331 11.7545 10.2211 11.6667 10.0001 11.6667Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), rO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2127_30861)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.56333 12.5C9.34232 12.5 9.13036 12.5878 8.97408 12.7441C8.8178 12.9004 8.73 13.1123 8.73 13.3333V15.8333C8.73 16.4964 8.46661 17.1323 7.99777 17.6011C7.52893 18.0699 6.89304 18.3333 6.23 18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V4.16667C1.66667 3.50363 1.93006 2.86774 2.3989 2.3989C2.86774 1.93006 3.50363 1.66667 4.16667 1.66667H6.23C6.89304 1.66667 7.52893 1.93006 7.99777 2.3989C8.46661 2.86774 8.73 3.50363 8.73 4.16667V6.66667C8.73 6.88768 8.8178 7.09964 8.97408 7.25592C9.13036 7.4122 9.34232 7.5 9.56333 7.5C9.78435 7.5 9.99631 7.4122 10.1526 7.25592C10.3089 7.09964 10.3967 6.88768 10.3967 6.66667V4.16667C10.3953 3.062 9.95593 2.00296 9.17482 1.22185C8.3937 0.440735 7.33466 0.00132321 6.23 0H4.16667C3.062 0.00132321 2.00296 0.440735 1.22185 1.22185C0.440735 2.00296 0.00132321 3.062 0 4.16667L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H6.23C7.33466 19.9987 8.3937 19.5593 9.17482 18.7782C9.95593 17.997 10.3953 16.938 10.3967 15.8333V13.3333C10.3967 13.1123 10.3089 12.9004 10.1526 12.7441C9.99631 12.5878 9.78435 12.5 9.56333 12.5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.0557 8.23232L15.234 4.41066C15.1571 4.33107 15.0652 4.26758 14.9635 4.22391C14.8618 4.18023 14.7525 4.15724 14.6418 4.15628C14.5312 4.15532 14.4215 4.1764 14.319 4.21831C14.2166 4.26021 14.1236 4.32208 14.0453 4.40033C13.9671 4.47857 13.9052 4.57161 13.8633 4.67403C13.8214 4.77644 13.8003 4.88618 13.8013 4.99682C13.8023 5.10747 13.8252 5.21682 13.8689 5.31849C13.9126 5.42016 13.9761 5.51212 14.0557 5.58899L17.6073 9.14149L4.99984 9.16649C4.77882 9.16649 4.56686 9.25429 4.41058 9.41057C4.2543 9.56685 4.1665 9.77881 4.1665 9.99982C4.1665 10.2208 4.2543 10.4328 4.41058 10.5891C4.56686 10.7454 4.77882 10.8332 4.99984 10.8332L17.6565 10.8073L14.054 14.4107C13.9744 14.4875 13.9109 14.5795 13.8673 14.6812C13.8236 14.7828 13.8006 14.8922 13.7996 15.0028C13.7987 15.1135 13.8198 15.2232 13.8617 15.3256C13.9036 15.428 13.9654 15.5211 14.0437 15.5993C14.1219 15.6776 14.215 15.7394 14.3174 15.7813C14.4198 15.8232 14.5295 15.8443 14.6402 15.8434C14.7508 15.8424 14.8602 15.8194 14.9618 15.7757C15.0635 15.7321 15.1555 15.6686 15.2323 15.589L19.054 11.7673C19.5229 11.2987 19.7865 10.6631 19.7868 10.0002C19.7871 9.33726 19.5241 8.70136 19.0557 8.23232Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), nO = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.1667 6.16699H0.833333C0.373096 6.16699 0 6.54009 0 7.00033C0 7.46056 0.373096 7.83366 0.833333 7.83366H19.1667C19.6269 7.83366 20 7.46056 20 7.00033C20 6.54009 19.6269 6.16699 19.1667 6.16699Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.1667 0.333496H0.833333C0.373096 0.333496 0 0.706592 0 1.16683C0 1.62707 0.373096 2.00016 0.833333 2.00016H19.1667C19.6269 2.00016 20 1.62707 20 1.16683C20 0.706592 19.6269 0.333496 19.1667 0.333496Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.1667 12H0.833333C0.373096 12 0 12.3731 0 12.8333C0 13.2936 0.373096 13.6667 0.833333 13.6667H19.1667C19.6269 13.6667 20 13.2936 20 12.8333C20 12.3731 19.6269 12 19.1667 12Z",
          fill: "currentColor"
        }
      )
    ]
  }
), aO = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.99992 3.33333C10.9204 3.33333 11.6666 2.58714 11.6666 1.66667C11.6666 0.746192 10.9204 0 9.99992 0C9.07944 0 8.33325 0.746192 8.33325 1.66667C8.33325 2.58714 9.07944 3.33333 9.99992 3.33333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.99992 11.6668C10.9204 11.6668 11.6666 10.9206 11.6666 10.0002C11.6666 9.07969 10.9204 8.3335 9.99992 8.3335C9.07944 8.3335 8.33325 9.07969 8.33325 10.0002C8.33325 10.9206 9.07944 11.6668 9.99992 11.6668Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.99992 19.9998C10.9204 19.9998 11.6666 19.2536 11.6666 18.3332C11.6666 17.4127 10.9204 16.6665 9.99992 16.6665C9.07944 16.6665 8.33325 17.4127 8.33325 18.3332C8.33325 19.2536 9.07944 19.9998 9.99992 19.9998Z",
          fill: "currentColor"
        }
      )
    ]
  }
), iO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M18.91 11.382l-1.583-5.696a7.767 7.767 0 00-15.065.395l-1.225 5.512a4.166 4.166 0 004.067 5.07h.928a4.166 4.166 0 008.166 0h.698a4.166 4.166 0 004.014-5.281zm-8.795 6.947a2.5 2.5 0 01-2.346-1.666h4.692a2.5 2.5 0 01-2.346 1.666zm6.77-4.32a2.48 2.48 0 01-1.99.987H5.104a2.5 2.5 0 01-2.44-3.042L3.89 6.442a6.1 6.1 0 0111.832-.31l1.583 5.696a2.48 2.48 0 01-.418 2.181z",
        fill: "currentColor"
      }
    )
  }
), oO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M15.4374 6.63908L7.48643 0.805027C6.86542 0.350291 6.13061 0.0764315 5.36347 0.0138145C4.59632 -0.0488024 3.82682 0.10227 3.1403 0.45028C2.45377 0.798291 1.87704 1.32964 1.47406 1.98541C1.07108 2.64118 0.857591 3.39575 0.857269 4.16544V15.8336C0.857407 16.6036 1.07091 17.3585 1.47407 18.0146C1.87724 18.6707 2.45431 19.2022 3.14124 19.5502C3.82816 19.8982 4.59807 20.049 5.36553 19.986C6.13299 19.923 6.86798 19.6485 7.48892 19.1931L15.4399 13.3591C15.9677 12.972 16.3969 12.4661 16.6927 11.8823C16.9886 11.2985 17.1427 10.6532 17.1427 9.99867C17.1427 9.34417 16.9886 8.69887 16.6927 8.11505C16.3969 7.53123 15.9677 7.0253 15.4399 6.63825L15.4374 6.63908ZM14.4506 12.0148L6.49964 17.8488C6.1271 18.121 5.68651 18.2849 5.22662 18.3222C4.76673 18.3595 4.30549 18.2688 3.89395 18.0602C3.48241 17.8516 3.13662 17.5331 2.89486 17.1402C2.6531 16.7472 2.52479 16.295 2.52414 15.8336V4.16544C2.51952 3.70318 2.6454 3.24898 2.88734 2.85505C3.12927 2.46112 3.47743 2.14343 3.89181 1.9385C4.24427 1.75922 4.63402 1.66557 5.02945 1.66513C5.55943 1.66716 6.07476 1.83923 6.49964 2.15603L14.4506 7.99008C14.7669 8.22236 15.0241 8.52582 15.2013 8.87592C15.3786 9.22602 15.471 9.61292 15.471 10.0053C15.471 10.3977 15.3786 10.7847 15.2013 11.1348C15.0241 11.4848 14.7669 11.7883 14.4506 12.0206V12.0148Z",
        fill: "currentColor"
      }
    )
  }
), sO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zm-2.5-5l5-3-5-3v6z",
        fill: "currentColor"
      }
    )
  }
), lO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M15.8333 8.83333H11.1667V4.16667C11.1667 3.85725 11.0437 3.5605 10.825 3.34171C10.6062 3.12292 10.3094 3 10 3C9.69058 3 9.39383 3.12292 9.17504 3.34171C8.95625 3.5605 8.83333 3.85725 8.83333 4.16667V8.83333H4.16667C3.85725 8.83333 3.5605 8.95625 3.34171 9.17504C3.12292 9.39383 3 9.69058 3 10C3 10.3094 3.12292 10.6062 3.34171 10.825C3.5605 11.0437 3.85725 11.1667 4.16667 11.1667H8.83333V15.8333C8.83333 16.1428 8.95625 16.4395 9.17504 16.6583C9.39383 16.8771 9.69058 17 10 17C10.3094 17 10.6062 16.8771 10.825 16.6583C11.0437 16.4395 11.1667 16.1428 11.1667 15.8333V11.1667H15.8333C16.1428 11.1667 16.4395 11.0437 16.6583 10.825C16.8771 10.6062 17 10.3094 17 10C17 9.69058 16.8771 9.39383 16.6583 9.17504C16.4395 8.95625 16.1428 8.83333 15.8333 8.83333Z",
        fill: "currentColor"
      }
    )
  }
), cO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_842_3889)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M15.8333 3.33333H14.9167C14.7233 2.39284 14.2115 1.54779 13.4677 0.940598C12.7239 0.333408 11.7935 0.0012121 10.8333 0L9.16667 0C8.2065 0.0012121 7.2761 0.333408 6.53229 0.940598C5.78848 1.54779 5.27675 2.39284 5.08333 3.33333H4.16667C3.062 3.33466 2.00296 3.77407 1.22185 4.55518C0.440735 5.3363 0.00132321 6.39534 0 7.5L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H15.8333C16.938 19.9987 17.997 19.5593 18.7782 18.7782C19.5593 17.997 19.9987 16.938 20 15.8333V7.5C19.9987 6.39534 19.5593 5.3363 18.7782 4.55518C17.997 3.77407 16.938 3.33466 15.8333 3.33333ZM9.16667 1.66667H10.8333C11.3485 1.6688 11.8505 1.83007 12.2706 2.12841C12.6906 2.42674 13.0083 2.84758 13.18 3.33333H6.82C6.99174 2.84758 7.30936 2.42674 7.72942 2.12841C8.14948 1.83007 8.65145 1.6688 9.16667 1.66667ZM4.16667 5H15.8333C16.4964 5 17.1323 5.26339 17.6011 5.73223C18.0699 6.20107 18.3333 6.83696 18.3333 7.5V10H1.66667V7.5C1.66667 6.83696 1.93006 6.20107 2.3989 5.73223C2.86774 5.26339 3.50363 5 4.16667 5ZM15.8333 18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V11.6667H9.16667V12.5C9.16667 12.721 9.25446 12.933 9.41074 13.0893C9.56702 13.2455 9.77899 13.3333 10 13.3333C10.221 13.3333 10.433 13.2455 10.5893 13.0893C10.7455 12.933 10.8333 12.721 10.8333 12.5V11.6667H18.3333V15.8333C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1323 18.0699 16.4964 18.3333 15.8333 18.3333Z",
        fill: "currentColor"
      }
    ) })
  }
), uO = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433286 8.00043 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34871 18.9426 4.80684 17.0679 2.9321C15.1932 1.05736 12.6513 0.00286757 10 0ZM10 18.3333C8.35183 18.3333 6.74066 17.8446 5.37025 16.9289C3.99984 16.0132 2.93174 14.7117 2.30101 13.189C1.67028 11.6663 1.50525 9.99075 1.82679 8.37425C2.14834 6.75774 2.94201 5.27288 4.10745 4.10744C5.27288 2.94201 6.75774 2.14833 8.37425 1.82679C9.99076 1.50525 11.6663 1.67027 13.189 2.301C14.7117 2.93173 16.0132 3.99984 16.9289 5.37025C17.8446 6.74066 18.3333 8.35182 18.3333 10C18.3309 12.2094 17.4522 14.3276 15.8899 15.8899C14.3276 17.4522 12.2094 18.3309 10 18.3333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10.5978 4.21903C10.1173 4.13147 9.62333 4.1506 9.15099 4.27506C8.67864 4.39952 8.23942 4.62628 7.8644 4.93928C7.48939 5.25228 7.18775 5.64388 6.98083 6.08636C6.77392 6.52884 6.66677 7.01139 6.66699 7.49986C6.66699 7.72087 6.75479 7.93284 6.91107 8.08912C7.06735 8.2454 7.27931 8.33319 7.50033 8.33319C7.72134 8.33319 7.9333 8.2454 8.08958 8.08912C8.24586 7.93284 8.33366 7.72087 8.33366 7.49986C8.33345 7.25467 8.38734 7.01246 8.49149 6.79049C8.59563 6.56852 8.74747 6.37227 8.93617 6.21572C9.12488 6.05917 9.3458 5.94618 9.58318 5.88481C9.82056 5.82345 10.0686 5.81521 10.3095 5.86069C10.6387 5.9246 10.9414 6.08518 11.1789 6.32193C11.4164 6.55869 11.5779 6.86086 11.6428 7.18986C11.7084 7.5352 11.6631 7.89242 11.5135 8.21047C11.3638 8.52852 11.1174 8.79111 10.8095 8.96069C10.2996 9.25608 9.87831 9.68279 9.58943 10.1964C9.30055 10.7099 9.15467 11.2916 9.16699 11.8807V12.4999C9.16699 12.7209 9.25479 12.9328 9.41107 13.0891C9.56735 13.2454 9.77931 13.3332 10.0003 13.3332C10.2213 13.3332 10.4333 13.2454 10.5896 13.0891C10.7459 12.9328 10.8337 12.7209 10.8337 12.4999V11.8807C10.8232 11.5907 10.8893 11.3031 11.0254 11.0468C11.1614 10.7905 11.3626 10.5745 11.6087 10.4207C12.2124 10.0891 12.6986 9.57857 13.0004 8.95936C13.3022 8.34015 13.4047 7.64266 13.2939 6.9628C13.1831 6.28294 12.8644 5.6541 12.3816 5.16277C11.8988 4.67144 11.2756 4.34175 10.5978 4.21903Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10.8337 14.9998C10.8337 14.5396 10.4606 14.1665 10.0003 14.1665C9.54009 14.1665 9.16699 14.5396 9.16699 14.9998C9.16699 15.4601 9.54009 15.8332 10.0003 15.8332C10.4606 15.8332 10.8337 15.4601 10.8337 14.9998Z",
          fill: "currentColor"
        }
      )
    ]
  }
), fO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_1353_11649)", children: /* @__PURE__ */ f.jsx("path", { d: "M19.7561 18.5773L14.782 13.6032C16.1375 11.9453 16.804 9.8299 16.6435 7.69445C16.4831 5.55901 15.508 3.56693 13.92 2.13025C12.3319 0.693577 10.2525 -0.0777715 8.11167 -0.024245C5.97088 0.0292815 3.93256 0.903588 2.41832 2.41783C0.904076 3.93207 0.0297698 5.97039 -0.0237567 8.11119C-0.0772832 10.252 0.694065 12.3314 2.13074 13.9195C3.56742 15.5075 5.5595 16.4826 7.69494 16.643C9.83038 16.8035 11.9458 16.137 13.6036 14.7815L18.5778 19.7557C18.735 19.9075 18.9455 19.9914 19.164 19.9895C19.3825 19.9876 19.5915 19.9 19.746 19.7455C19.9005 19.591 19.9881 19.382 19.99 19.1635C19.9919 18.945 19.9079 18.7345 19.7561 18.5773ZM8.33364 14.9998C7.0151 14.9998 5.72617 14.6088 4.62984 13.8763C3.53351 13.1437 2.67903 12.1025 2.17444 10.8844C1.66986 9.6662 1.53784 8.32576 1.79507 7.03255C2.05231 5.73934 2.68724 4.55146 3.61959 3.61911C4.55194 2.68676 5.73983 2.05182 7.03304 1.79458C8.32624 1.53735 9.66669 1.66937 10.8849 2.17395C12.103 2.67854 13.1442 3.53302 13.8768 4.62935C14.6093 5.72568 15.0003 7.01461 15.0003 8.33315C14.9983 10.1007 14.2953 11.7952 13.0455 13.045C11.7957 14.2948 10.1011 14.9978 8.33364 14.9998Z", fill: "currentColor" }) })
  }
), dO = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M16.743 10L8.25505 10C8.1049 9.9994 7.95831 9.95665 7.83381 9.87715C7.70931 9.79765 7.6125 9.68497 7.55561 9.55336C7.49873 9.42176 7.48433 9.27713 7.51423 9.13777C7.54413 8.99841 7.61699 8.87057 7.7236 8.77043L11.96 4.75815C12.0306 4.69075 12.1145 4.63726 12.207 4.60075C12.2996 4.56425 12.3988 4.54545 12.499 4.54545C12.5992 4.54545 12.6985 4.56425 12.791 4.60075C12.8835 4.63726 12.9675 4.69075 13.0381 4.75815L17.2744 8.77043C17.3811 8.87057 17.4539 8.99841 17.4838 9.13777C17.5137 9.27713 17.4993 9.42176 17.4424 9.55337C17.3855 9.68497 17.2887 9.79765 17.1642 9.87715C17.0397 9.95665 16.8931 9.9994 16.743 10Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M8.25505 14H16.743C16.8931 14.0006 17.0397 14.0433 17.1642 14.1228C17.2887 14.2023 17.3855 14.315 17.4424 14.4466C17.4993 14.5782 17.5137 14.7229 17.4838 14.8622C17.4539 15.0016 17.3811 15.1294 17.2744 15.2296L13.0381 19.2419C12.9675 19.3092 12.8835 19.3627 12.791 19.3992C12.6985 19.4358 12.5992 19.4545 12.499 19.4545C12.3988 19.4545 12.2996 19.4358 12.207 19.3992C12.1145 19.3627 12.0306 19.3092 11.96 19.2419L7.7236 15.2296C7.61699 15.1294 7.54413 15.0016 7.51423 14.8622C7.48433 14.7229 7.49873 14.5782 7.55561 14.4466C7.6125 14.315 7.70931 14.2023 7.83381 14.1228C7.95831 14.0433 8.1049 14.0006 8.25505 14Z",
          fill: "currentColor"
        }
      )
    ]
  }
), pO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 97 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_1300_12843)", fill: "currentColor", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M67.225 43.186c-.387 0-.778-.113-1.11-.34a29.453 29.453 0 00-7.388-3.625 1.96 1.96 0 01-1.356-1.861V20.11c0-4.326-3.537-7.845-7.885-7.845s-7.885 3.518-7.885 7.844v17.25a1.96 1.96 0 01-1.356 1.862 29.545 29.545 0 00-7.388 3.624 1.978 1.978 0 01-2.03.114 1.959 1.959 0 01-1.05-1.734V20.106C29.776 9.296 38.618.5 49.484.5 60.35.5 69.194 9.296 69.194 20.11v21.117a1.972 1.972 0 01-1.972 1.962l.003-.003zm-5.913-7.214c1.35.508 2.67 1.102 3.941 1.779V20.109c0-8.651-7.073-15.688-15.767-15.688-8.694 0-15.767 7.037-15.767 15.688v17.642a33.676 33.676 0 013.94-1.779V20.106c0-6.487 5.306-11.764 11.827-11.764s11.826 5.277 11.826 11.764v15.866z" }),
      /* @__PURE__ */ f.jsx("path", { d: "M49.486 100.5c-18.476 0-33.51-14.952-33.51-33.332 0-18.38 15.032-33.332 33.51-33.332 18.478 0 33.507 14.953 33.507 33.332 0 18.38-15.031 33.332-33.507 33.332zm0-62.744c-16.303 0-29.565 13.194-29.565 29.412 0 16.218 13.262 29.412 29.565 29.412s29.565-13.194 29.565-29.412c0-16.218-13.262-29.412-29.565-29.412z" }),
      /* @__PURE__ */ f.jsx("path", { d: "M53.427 88.736h-7.885a1.967 1.967 0 01-1.972-1.962v-2.966a17.763 17.763 0 01-1.732-.716l-2.109 2.098a1.979 1.979 0 01-2.789 0l-5.575-5.547a1.959 1.959 0 010-2.775l2.108-2.097c-.27-.564-.51-1.138-.72-1.726h-2.981a1.967 1.967 0 01-1.972-1.962V63.24c0-1.082.881-1.962 1.972-1.962h2.982c.209-.585.449-1.162.72-1.725l-2.11-2.098a1.964 1.964 0 01-.577-1.388c0-.521.21-1.018.578-1.387l5.575-5.546a1.979 1.979 0 012.79 0l2.108 2.097c.566-.269 1.144-.508 1.732-.716v-2.966c0-1.082.882-1.962 1.972-1.962h7.885c1.088 0 1.972.877 1.972 1.962v2.966c.589.208 1.169.447 1.735.716l2.109-2.097a1.977 1.977 0 012.786 0l5.575 5.546c.77.766.77 2.006 0 2.772l-2.108 2.098c.27.563.51 1.137.72 1.726h2.981c1.088 0 1.972.876 1.972 1.961v7.844a1.967 1.967 0 01-1.972 1.962h-2.981c-.21.586-.45 1.163-.72 1.723l2.109 2.098c.77.766.77 2.006 0 2.775l-5.576 5.543a1.977 1.977 0 01-2.786 0l-2.11-2.097c-.565.269-1.143.507-1.734.716v2.966a1.965 1.965 0 01-1.972 1.962v.008zm-5.913-3.92h3.944v-2.457c0-.896.608-1.675 1.478-1.897 1.244-.32 2.44-.813 3.556-1.468a1.978 1.978 0 012.396.302l1.746 1.737 2.79-2.775-1.75-1.736a1.953 1.953 0 01-.303-2.384c.658-1.11 1.154-2.3 1.475-3.538a1.97 1.97 0 011.908-1.47h2.468v-3.92h-2.468a1.968 1.968 0 01-1.908-1.471 13.609 13.609 0 00-1.475-3.538 1.953 1.953 0 01.304-2.384l1.749-1.737-2.79-2.771-1.746 1.736a1.979 1.979 0 01-2.396.303 13.76 13.76 0 00-3.556-1.468 1.961 1.961 0 01-1.478-1.898v-2.455h-3.944v2.455c0 .896-.608 1.676-1.481 1.898-1.244.32-2.44.813-3.556 1.468a1.975 1.975 0 01-2.396-.303l-1.746-1.736-2.787 2.771 1.746 1.737c.636.633.762 1.615.305 2.384a13.646 13.646 0 00-1.476 3.538 1.968 1.968 0 01-1.908 1.47h-2.468v3.92h2.468c.901 0 1.685.606 1.908 1.471.32 1.238.817 2.428 1.476 3.538.457.771.331 1.751-.305 2.384l-1.746 1.736 2.787 2.775 1.746-1.737a1.98 1.98 0 012.396-.302 13.796 13.796 0 003.556 1.468 1.96 1.96 0 011.481 1.897v2.456z" }),
      /* @__PURE__ */ f.jsx("path", { d: "M49.483 77.287c-1.632 0-3.3-.374-4.892-1.143-1.584-.766-3.361-2.53-4.13-4.11-2.043-4.18-1.326-8.903 1.82-12.033 3.147-3.13 7.894-3.84 12.097-1.812 1.584.766 3.361 2.533 4.13 4.11 2.043 4.178 1.326 8.904-1.82 12.03-1.956 1.946-4.527 2.956-7.205 2.956v.002zm.011-16.334a6.296 6.296 0 00-4.426 1.82c-1.545 1.537-2.636 4.326-1.063 7.547.388.794 1.51 1.91 2.307 2.295 3.235 1.565 6.041.48 7.584-1.057 1.545-1.538 2.635-4.326 1.062-7.548-.387-.793-1.509-1.909-2.306-2.294-1.116-.538-2.179-.763-3.158-.763zM92.847 52.46a2.949 2.949 0 01-2.957 2.94 2.95 2.95 0 01-2.956-2.94 2.95 2.95 0 012.956-2.942 2.95 2.95 0 012.957 2.941zM6.122 25.01a2.949 2.949 0 01-2.956 2.94 2.949 2.949 0 01-2.957-2.94 2.949 2.949 0 012.957-2.942 2.949 2.949 0 012.956 2.941zM14.005 87.754a2.949 2.949 0 01-2.957 2.94 2.95 2.95 0 01-2.956-2.94 2.95 2.95 0 012.956-2.942 2.95 2.95 0 012.957 2.942zM21.89 8.345a1.967 1.967 0 01-1.972 1.961 1.965 1.965 0 01-1.972-1.961c0-1.085.881-1.962 1.972-1.962 1.09 0 1.972.877 1.972 1.962zM21.89 37.754a1.967 1.967 0 01-1.972 1.961 1.965 1.965 0 01-1.972-1.962c0-1.084.881-1.961 1.972-1.961 1.09 0 1.972.877 1.972 1.962zM92.847 86.774a1.967 1.967 0 01-1.972 1.962 1.965 1.965 0 01-1.972-1.962c0-1.085.881-1.962 1.972-1.962 1.09 0 1.972.877 1.972 1.962zM81.02 35.795c-8.696 0-15.77-7.037-15.77-15.689 0-8.651 7.074-15.685 15.77-15.685 8.697 0 15.768 7.037 15.768 15.686 0 8.648-7.074 15.688-15.768 15.688zm0-27.45c-6.52 0-11.826 5.277-11.826 11.764 0 6.487 5.305 11.765 11.826 11.765 6.522 0 11.827-5.277 11.827-11.765 0-6.487-5.305-11.764-11.827-11.764z" }),
      /* @__PURE__ */ f.jsx("path", { d: "M79.288 25.992c-.504 0-1.01-.192-1.394-.575l-2.62-2.605a1.956 1.956 0 010-2.775 1.98 1.98 0 012.79 0l1.224 1.218 5.576-5.546a1.977 1.977 0 012.786 0c.77.765.77 2.006 0 2.774l-6.967 6.931c-.385.383-.89.575-1.395.575v.003z" })
    ] })
  }
), hO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2648_4382)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M4.16667 18.3333C2.78333 18.3333 1.66667 17.2167 1.66667 15.8333V5.83333H7.5C7.5 7.21667 8.61667 8.33333 10 8.33333C11.3833 8.33333 12.5 7.21667 12.5 5.83333H18.3333V7.96667C18.3333 8.425 18.7083 8.8 19.1667 8.8C19.625 8.8 20 8.425 20 7.96667V4.16667C20 1.86667 18.1333 0 15.8333 0H4.16667C1.86667 0 0 1.86667 0 4.16667V15.8333C0 18.1333 1.86667 20 4.16667 20H9.30833C9.76667 20 10.1417 19.625 10.1417 19.1667C10.1417 18.7083 9.76667 18.3333 9.30833 18.3333H4.16667ZM12.5 1.66667H15.8333C17.2167 1.66667 18.3333 2.78333 18.3333 4.16667H12.5V1.66667ZM9.16667 1.66667H10.8333V5.83333C10.8333 6.29167 10.4583 6.66667 10 6.66667C9.54167 6.66667 9.16667 6.29167 9.16667 5.83333V1.66667ZM4.16667 1.66667H7.5V4.16667H1.66667C1.66667 2.78333 2.78333 1.66667 4.16667 1.66667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.5833 15.9499L18.775 15.4832C18.9166 15.0666 19.0083 14.6332 19.0083 14.1749C19.0083 13.7166 18.9166 13.2749 18.775 12.8666L19.5833 12.3999C19.9833 12.1666 20.1166 11.6582 19.8916 11.2582C19.6583 10.8582 19.15 10.7249 18.75 10.9499L17.9416 11.4166C17.35 10.7582 16.575 10.2666 15.675 10.0916V9.17489C15.675 8.71655 15.3 8.34155 14.8416 8.34155C14.3833 8.34155 14.0083 8.71655 14.0083 9.17489V10.0916C13.1083 10.2749 12.325 10.7582 11.7416 11.4166L10.9333 10.9499C10.5333 10.7166 10.025 10.8582 9.79164 11.2582C9.55831 11.6582 9.69997 12.1666 10.1 12.3999L10.9083 12.8666C10.7666 13.2832 10.675 13.7166 10.675 14.1749C10.675 14.6332 10.7666 15.0666 10.9083 15.4832L10.1 15.9499C9.69997 16.1832 9.56664 16.6916 9.79164 17.0916C9.94997 17.3582 10.225 17.5082 10.5166 17.5082C10.6583 17.5082 10.8 17.4749 10.9333 17.3999L11.7416 16.9332C12.3333 17.5916 13.1083 18.0832 14.0083 18.2582V19.1749C14.0083 19.6332 14.3833 20.0082 14.8416 20.0082C15.3 20.0082 15.675 19.6332 15.675 19.1749V18.2582C16.575 18.0749 17.3583 17.5916 17.9416 16.9332L18.75 17.3999C18.8833 17.4749 19.025 17.5082 19.1666 17.5082C19.4583 17.5082 19.7333 17.3582 19.8916 17.0916C20.125 16.6916 19.9833 16.1832 19.5833 15.9499ZM14.8333 16.6749C13.4583 16.6749 12.3333 15.5499 12.3333 14.1749C12.3333 12.7999 13.4583 11.6749 14.8333 11.6749C16.2083 11.6749 17.3333 12.7999 17.3333 14.1749C17.3333 15.5499 16.2083 16.6749 14.8333 16.6749Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), vO = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M15.8333 3.33333H13.25C13.0566 2.39284 12.5448 1.54779 11.801 0.940598C11.0572 0.333408 10.1268 0.0012121 9.16667 0L7.5 0C6.53983 0.0012121 5.60943 0.333408 4.86562 0.940598C4.12182 1.54779 3.61008 2.39284 3.41667 3.33333H0.833333C0.61232 3.33333 0.400358 3.42113 0.244078 3.57741C0.0877973 3.73369 0 3.94565 0 4.16667C0 4.38768 0.0877973 4.59964 0.244078 4.75592C0.400358 4.9122 0.61232 5 0.833333 5H1.66667V15.8333C1.66799 16.938 2.1074 17.997 2.88852 18.7782C3.66963 19.5593 4.72867 19.9987 5.83333 20H10.8333C11.938 19.9987 12.997 19.5593 13.7782 18.7782C14.5593 17.997 14.9987 16.938 15 15.8333V5H15.8333C16.0543 5 16.2663 4.9122 16.4226 4.75592C16.5789 4.59964 16.6667 4.38768 16.6667 4.16667C16.6667 3.94565 16.5789 3.73369 16.4226 3.57741C16.2663 3.42113 16.0543 3.33333 15.8333 3.33333ZM7.5 1.66667H9.16667C9.68356 1.6673 10.1876 1.82781 10.6097 2.1262C11.0317 2.42459 11.3512 2.84624 11.5242 3.33333H5.1425C5.31549 2.84624 5.63492 2.42459 6.05699 2.1262C6.47906 1.82781 6.9831 1.6673 7.5 1.66667ZM13.3333 15.8333C13.3333 16.4964 13.0699 17.1323 12.6011 17.6011C12.1323 18.0699 11.4964 18.3333 10.8333 18.3333H5.83333C5.17029 18.3333 4.53441 18.0699 4.06557 17.6011C3.59673 17.1323 3.33333 16.4964 3.33333 15.8333V5H13.3333V15.8333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M6.66683 15.0002C6.88784 15.0002 7.0998 14.9124 7.25608 14.7561C7.41237 14.5998 7.50016 14.3878 7.50016 14.1668V9.16683C7.50016 8.94582 7.41237 8.73385 7.25608 8.57757C7.0998 8.42129 6.88784 8.3335 6.66683 8.3335C6.44582 8.3335 6.23385 8.42129 6.07757 8.57757C5.92129 8.73385 5.8335 8.94582 5.8335 9.16683V14.1668C5.8335 14.3878 5.92129 14.5998 6.07757 14.7561C6.23385 14.9124 6.44582 15.0002 6.66683 15.0002Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.99984 15.0002C10.2209 15.0002 10.4328 14.9124 10.5891 14.7561C10.7454 14.5998 10.8332 14.3878 10.8332 14.1668V9.16683C10.8332 8.94582 10.7454 8.73385 10.5891 8.57757C10.4328 8.42129 10.2209 8.3335 9.99984 8.3335C9.77882 8.3335 9.56686 8.42129 9.41058 8.57757C9.2543 8.73385 9.1665 8.94582 9.1665 9.16683V14.1668C9.1665 14.3878 9.2543 14.5998 9.41058 14.7561C9.56686 14.9124 9.77882 15.0002 9.99984 15.0002Z",
          fill: "currentColor"
        }
      )
    ]
  }
), mO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2127_30842)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10 10C10.9889 10 11.9556 9.70676 12.7779 9.15735C13.6001 8.60794 14.241 7.82705 14.6194 6.91342C14.9978 5.99979 15.0969 4.99446 14.9039 4.02455C14.711 3.05465 14.2348 2.16373 13.5355 1.46447C12.8363 0.765206 11.9454 0.289002 10.9755 0.0960758C10.0055 -0.0968503 9.00021 0.00216643 8.08658 0.380605C7.17295 0.759043 6.39206 1.39991 5.84265 2.22215C5.29324 3.0444 5 4.0111 5 5C5.00132 6.32568 5.52853 7.59668 6.46593 8.53407C7.40332 9.47147 8.67432 9.99868 10 10ZM10 1.66667C10.6593 1.66667 11.3037 1.86217 11.8519 2.22844C12.4001 2.59471 12.8273 3.1153 13.0796 3.72439C13.3319 4.33348 13.3979 5.0037 13.2693 5.6503C13.1407 6.29691 12.8232 6.89085 12.357 7.35703C11.8908 7.8232 11.2969 8.14067 10.6503 8.26929C10.0037 8.3979 9.33348 8.33189 8.72439 8.0796C8.1153 7.82731 7.59471 7.40007 7.22843 6.8519C6.86216 6.30374 6.66667 5.65927 6.66667 5C6.66667 4.11595 7.01786 3.2681 7.64298 2.64298C8.2681 2.01786 9.11594 1.66667 10 1.66667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10 11.6667C8.01155 11.669 6.10518 12.4598 4.69914 13.8659C3.29309 15.2719 2.50221 17.1783 2.5 19.1667C2.5 19.3878 2.5878 19.5997 2.74408 19.756C2.90036 19.9123 3.11232 20.0001 3.33333 20.0001C3.55435 20.0001 3.76631 19.9123 3.92259 19.756C4.07887 19.5997 4.16667 19.3878 4.16667 19.1667C4.16667 17.6197 4.78125 16.1359 5.87521 15.042C6.96917 13.948 8.4529 13.3334 10 13.3334C11.5471 13.3334 13.0308 13.948 14.1248 15.042C15.2188 16.1359 15.8333 17.6197 15.8333 19.1667C15.8333 19.3878 15.9211 19.5997 16.0774 19.756C16.2337 19.9123 16.4457 20.0001 16.6667 20.0001C16.8877 20.0001 17.0996 19.9123 17.2559 19.756C17.4122 19.5997 17.5 19.3878 17.5 19.1667C17.4978 17.1783 16.7069 15.2719 15.3009 13.8659C13.8948 12.4598 11.9884 11.669 10 11.6667Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), gO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2127_30857)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M5.83333 11.6667C7.675 11.6667 9.16667 10.175 9.16667 8.33333C9.16667 6.49167 7.675 5 5.83333 5C3.99167 5 2.5 6.49167 2.5 8.33333C2.5 10.175 3.99167 11.6667 5.83333 11.6667ZM5.83333 6.66667C6.75 6.66667 7.5 7.41667 7.5 8.33333C7.5 9.25 6.75 10 5.83333 10C4.91667 10 4.16667 9.25 4.16667 8.33333C4.16667 7.41667 4.91667 6.66667 5.83333 6.66667ZM11.6667 19.1667C11.6667 19.625 11.2917 20 10.8333 20C10.375 20 10 19.625 10 19.1667C10 16.8667 8.13333 15 5.83333 15C3.53333 15 1.66667 16.8667 1.66667 19.1667C1.66667 19.625 1.29167 20 0.833333 20C0.375 20 0 19.625 0 19.1667C0 15.95 2.61667 13.3333 5.83333 13.3333C9.05 13.3333 11.6667 15.95 11.6667 19.1667ZM20 4.16667V10.8333C20 13.1333 18.1333 15 15.8333 15H12.5C12.0417 15 11.6667 14.625 11.6667 14.1667C11.6667 13.7083 12.0417 13.3333 12.5 13.3333H15.8333C17.2083 13.3333 18.3333 12.2083 18.3333 10.8333V4.16667C18.3333 2.79167 17.2083 1.66667 15.8333 1.66667H7.88333C6.99167 1.66667 6.16667 2.15 5.71667 2.91667C5.48333 3.31667 4.975 3.45 4.575 3.225C4.175 2.99167 4.04167 2.48333 4.275 2.08333C5.025 0.8 6.40833 0 7.88333 0H15.8333C18.1333 0 20 1.86667 20 4.16667ZM11.3917 9.1L13.825 6.66667H12.5C12.0417 6.66667 11.6667 6.29167 11.6667 5.83333C11.6667 5.375 12.0417 5 12.5 5H15C15.9167 5 16.6667 5.75 16.6667 6.66667V9.16667C16.6667 9.625 16.2917 10 15.8333 10C15.375 10 15 9.625 15 9.16667V7.84167L12.5667 10.275C12.1833 10.6583 11.6667 10.8667 11.1417 10.8667C10.9583 10.8667 10.775 10.8417 10.5917 10.7917C10.15 10.6667 9.89167 10.2083 10.0167 9.76667C10.1417 9.325 10.6 9.06667 11.05 9.19167C11.15 9.21667 11.2833 9.20833 11.3917 9.1Z",
        fill: "currentColor"
      }
    ) })
  }
), yO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2656_4398)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M12.4999 5C12.4999 2.2425 10.2574 0 7.49986 0C4.74236 0 2.49986 2.2425 2.49986 5C2.49986 7.7575 4.74236 10 7.49986 10C10.2574 10 12.4999 7.7575 12.4999 5ZM7.49986 8.33333C5.66152 8.33333 4.16652 6.83833 4.16652 5C4.16652 3.16167 5.66152 1.66667 7.49986 1.66667C9.33819 1.66667 10.8332 3.16167 10.8332 5C10.8332 6.83833 9.33819 8.33333 7.49986 8.33333ZM7.49319 12.4483C7.54986 12.905 7.22652 13.3208 6.76902 13.3783C3.85986 13.7417 1.66569 16.2292 1.66569 19.1667C1.66569 19.6267 1.29236 20 0.832357 20C0.372357 20 -0.000976562 19.6267 -0.000976562 19.1667C-0.000976562 15.3908 2.82069 12.1917 6.56236 11.725C7.01402 11.6675 7.43486 11.9917 7.49236 12.4492L7.49319 12.4483ZM18.9132 15.9442L18.1015 15.4758C18.2399 15.0617 18.3332 14.6267 18.3332 14.1658C18.3332 13.705 18.2407 13.27 18.1015 12.8558L18.9132 12.3875C19.3115 12.1575 19.4482 11.6475 19.2182 11.2492C18.9874 10.85 18.479 10.7125 18.0799 10.9442L17.269 11.4125C16.6815 10.7508 15.899 10.2667 14.9999 10.0842V9.16667C14.9999 8.70667 14.6265 8.33333 14.1665 8.33333C13.7065 8.33333 13.3332 8.70667 13.3332 9.16667V10.0842C12.434 10.2675 11.6515 10.7517 11.064 11.4125L10.2532 10.9442C9.85319 10.7133 9.34486 10.85 9.11486 11.2492C8.88486 11.6483 9.02152 12.1575 9.41986 12.3875L10.2315 12.8558C10.0932 13.27 9.99986 13.705 9.99986 14.1658C9.99986 14.6267 10.0924 15.0617 10.2315 15.4758L9.41986 15.9442C9.02152 16.1742 8.88486 16.6842 9.11486 17.0825C9.26986 17.35 9.54902 17.4992 9.83736 17.4992C9.97819 17.4992 10.1215 17.4633 10.2532 17.3875L11.064 16.9192C11.6515 17.5808 12.434 18.065 13.3332 18.2475V19.165C13.3332 19.625 13.7065 19.9983 14.1665 19.9983C14.6265 19.9983 14.9999 19.625 14.9999 19.165V18.2475C15.899 18.0642 16.6815 17.58 17.269 16.9192L18.0799 17.3875C18.2115 17.4633 18.3549 17.4992 18.4957 17.4992C18.784 17.4992 19.064 17.35 19.2182 17.0825C19.4482 16.6833 19.3115 16.1742 18.9132 15.9442ZM14.1665 16.6658C12.7882 16.6658 11.6665 15.5442 11.6665 14.1658C11.6665 12.7875 12.7882 11.6658 14.1665 11.6658C15.5449 11.6658 16.6665 12.7875 16.6665 14.1658C16.6665 15.5442 15.5449 16.6658 14.1665 16.6658Z",
        fill: "currentColor"
      }
    ) })
  }
), bO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2127_42419)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M9.13972 12.5022C9.25472 12.9481 8.98639 13.4022 8.54055 13.5164C5.96472 14.1797 4.16555 16.5022 4.16555 19.1664C4.16555 19.6264 3.79222 19.9997 3.33222 19.9997C2.87222 19.9997 2.49889 19.6264 2.49889 19.1664C2.49889 15.7422 4.81222 12.7556 8.12389 11.9031C8.57305 11.7889 9.02389 12.0564 9.13889 12.5022H9.13972ZM19.7556 19.7556C19.5931 19.9181 19.3797 19.9997 19.1664 19.9997C18.9531 19.9997 18.7397 19.9181 18.5772 19.7556L0.243887 1.42222C-0.0819466 1.09639 -0.0819466 0.56972 0.243887 0.243887C0.56972 -0.0819466 1.09639 -0.0819466 1.42222 0.243887L5.11555 3.93722C5.60472 1.68972 7.60722 -0.000279957 9.99972 -0.000279957C12.7572 -0.000279957 14.9997 2.24222 14.9997 4.99972C14.9997 7.39222 13.3097 9.39472 11.0622 9.88389L19.7556 18.5772C20.0814 18.9031 20.0814 19.4297 19.7556 19.7556ZM6.72055 5.54222L9.45722 8.27889C9.63639 8.30805 9.81722 8.33305 9.99972 8.33305C11.8381 8.33305 13.3331 6.83805 13.3331 4.99972C13.3331 3.16139 11.8381 1.66639 9.99972 1.66639C8.16139 1.66639 6.66639 3.16139 6.66639 4.99972C6.66639 5.18139 6.69139 5.36305 6.72055 5.54222Z",
        fill: "currentColor"
      }
    ) })
  }
), CO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2364_27217)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.8333 9.1665H18.1667V7.49984C18.1667 7.27882 18.0789 7.06686 17.9226 6.91058C17.7663 6.7543 17.5543 6.6665 17.3333 6.6665C17.1123 6.6665 16.9004 6.7543 16.7441 6.91058C16.5878 7.06686 16.5 7.27882 16.5 7.49984V9.1665H14.8333C14.6123 9.1665 14.4004 9.2543 14.2441 9.41058C14.0878 9.56686 14 9.77882 14 9.99984C14 10.2209 14.0878 10.4328 14.2441 10.5891C14.4004 10.7454 14.6123 10.8332 14.8333 10.8332H16.5V12.4998C16.5 12.7209 16.5878 12.9328 16.7441 13.0891C16.9004 13.2454 17.1123 13.3332 17.3333 13.3332C17.5543 13.3332 17.7663 13.2454 17.9226 13.0891C18.0789 12.9328 18.1667 12.7209 18.1667 12.4998V10.8332H19.8333C20.0543 10.8332 20.2663 10.7454 20.4226 10.5891C20.5789 10.4328 20.6667 10.2209 20.6667 9.99984C20.6667 9.77882 20.5789 9.56686 20.4226 9.41058C20.2663 9.2543 20.0543 9.1665 19.8333 9.1665Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M8.16699 10C9.1559 10 10.1226 9.70676 10.9448 9.15735C11.7671 8.60794 12.408 7.82705 12.7864 6.91342C13.1648 5.99979 13.2638 4.99446 13.0709 4.02455C12.878 3.05465 12.4018 2.16373 11.7025 1.46447C11.0033 0.765206 10.1123 0.289002 9.14244 0.0960758C8.17254 -0.0968503 7.16721 0.00216643 6.25358 0.380605C5.33994 0.759043 4.55905 1.39991 4.00964 2.22215C3.46024 3.0444 3.16699 4.0111 3.16699 5C3.16832 6.32568 3.69553 7.59668 4.63292 8.53407C5.57032 9.47147 6.84132 9.99868 8.16699 10ZM8.16699 1.66667C8.82626 1.66667 9.47073 1.86217 10.0189 2.22844C10.5671 2.59471 10.9943 3.1153 11.2466 3.72439C11.4989 4.33348 11.5649 5.0037 11.4363 5.6503C11.3077 6.29691 10.9902 6.89085 10.524 7.35703C10.0578 7.8232 9.4639 8.14067 8.81729 8.26929C8.17069 8.3979 7.50047 8.33189 6.89138 8.0796C6.28229 7.82731 5.7617 7.40007 5.39543 6.8519C5.02916 6.30374 4.83366 5.65927 4.83366 5C4.83366 4.11595 5.18485 3.2681 5.80997 2.64298C6.43509 2.01786 7.28294 1.66667 8.16699 1.66667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M8.16699 11.6665C6.17855 11.6687 4.27217 12.4596 2.86613 13.8656C1.46008 15.2717 0.669198 17.1781 0.666992 19.1665C0.666992 19.3875 0.75479 19.5995 0.91107 19.7558C1.06735 19.912 1.27931 19.9998 1.50033 19.9998C1.72134 19.9998 1.9333 19.912 2.08958 19.7558C2.24586 19.5995 2.33366 19.3875 2.33366 19.1665C2.33366 17.6194 2.94824 16.1357 4.0422 15.0417C5.13616 13.9478 6.6199 13.3332 8.16699 13.3332C9.71409 13.3332 11.1978 13.9478 12.2918 15.0417C13.3857 16.1357 14.0003 17.6194 14.0003 19.1665C14.0003 19.3875 14.0881 19.5995 14.2444 19.7558C14.4007 19.912 14.6126 19.9998 14.8337 19.9998C15.0547 19.9998 15.2666 19.912 15.4229 19.7558C15.5792 19.5995 15.667 19.3875 15.667 19.1665C15.6648 17.1781 14.8739 15.2717 13.4679 13.8656C12.0618 12.4596 10.1554 11.6687 8.16699 11.6665Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), xO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_842_3895)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M10 13.3333C9.34073 13.3333 8.69626 13.1378 8.1481 12.7716C7.59994 12.4053 7.17269 11.8847 6.9204 11.2756C6.66811 10.6665 6.6021 9.9963 6.73072 9.3497C6.85933 8.7031 7.1768 8.10915 7.64298 7.64298C8.10915 7.1768 8.7031 6.85933 9.3497 6.73072C9.9963 6.6021 10.6665 6.66811 11.2756 6.9204C11.8847 7.1727 12.4053 7.59994 12.7716 8.1481C13.1378 8.69627 13.3333 9.34073 13.3333 10C13.3333 10.8841 12.9821 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333ZM10 8.33333C9.67036 8.33333 9.34813 8.43108 9.07405 8.61422C8.79997 8.79735 8.58635 9.05765 8.4602 9.3622C8.33405 9.66674 8.30105 10.0019 8.36536 10.3252C8.42967 10.6485 8.5884 10.9454 8.82149 11.1785C9.05458 11.4116 9.35155 11.5703 9.67485 11.6346C9.99815 11.699 10.3333 11.6659 10.6378 11.5398C10.9423 11.4137 11.2026 11.2 11.3858 10.926C11.5689 10.6519 11.6667 10.3296 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.8659 8.50893 10.442 8.33333 10 8.33333ZM15 19.1667C15 17.8406 14.4732 16.5688 13.5355 15.6311C12.5979 14.6935 11.3261 14.1667 10 14.1667C8.67392 14.1667 7.40215 14.6935 6.46447 15.6311C5.52678 16.5688 5 17.8406 5 19.1667C5 19.3877 5.0878 19.5996 5.24408 19.7559C5.40036 19.9122 5.61232 20 5.83333 20C6.05435 20 6.26631 19.9122 6.42259 19.7559C6.57887 19.5996 6.66667 19.3877 6.66667 19.1667C6.66667 18.2826 7.01786 17.4348 7.64298 16.8096C8.2681 16.1845 9.11594 15.8333 10 15.8333C10.8841 15.8333 11.7319 16.1845 12.357 16.8096C12.9821 17.4348 13.3333 18.2826 13.3333 19.1667C13.3333 19.3877 13.4211 19.5996 13.5774 19.7559C13.7337 19.9122 13.9457 20 14.1667 20C14.3877 20 14.5996 19.9122 14.7559 19.7559C14.9122 19.5996 15 19.3877 15 19.1667ZM15 6.66667C14.3407 6.66667 13.6963 6.47117 13.1481 6.1049C12.5999 5.73863 12.1727 5.21803 11.9204 4.60895C11.6681 3.99986 11.6021 3.32964 11.7307 2.68303C11.8593 2.03643 12.1768 1.44249 12.643 0.976312C13.1092 0.510137 13.7031 0.192668 14.3497 0.0640506C14.9963 -0.0645668 15.6665 0.00144427 16.2756 0.253736C16.8847 0.506029 17.4053 0.93327 17.7716 1.48143C18.1378 2.0296 18.3333 2.67406 18.3333 3.33334C18.3333 4.21739 17.9821 5.06524 17.357 5.69036C16.7319 6.31548 15.8841 6.66667 15 6.66667ZM15 1.66667C14.6704 1.66667 14.3481 1.76442 14.074 1.94755C13.8 2.13069 13.5863 2.39099 13.4602 2.69553C13.3341 3.00007 13.301 3.33518 13.3654 3.65849C13.4297 3.98179 13.5884 4.27876 13.8215 4.51185C14.0546 4.74493 14.3515 4.90367 14.6748 4.96798C14.9982 5.03229 15.3333 4.99928 15.6378 4.87313C15.9423 4.74699 16.2026 4.53337 16.3858 4.25929C16.5689 3.9852 16.6667 3.66297 16.6667 3.33334C16.6667 2.89131 16.4911 2.46738 16.1785 2.15482C15.8659 1.84226 15.442 1.66667 15 1.66667ZM20 12.5C19.9987 11.1743 19.4715 9.90333 18.5341 8.96593C17.5967 8.02853 16.3257 7.50133 15 7.5C14.779 7.5 14.567 7.5878 14.4107 7.74408C14.2545 7.90036 14.1667 8.11232 14.1667 8.33333C14.1667 8.55435 14.2545 8.76631 14.4107 8.92259C14.567 9.07887 14.779 9.16667 15 9.16667C15.8841 9.16667 16.7319 9.51786 17.357 10.143C17.9821 10.7681 18.3333 11.6159 18.3333 12.5C18.3333 12.721 18.4211 12.933 18.5774 13.0893C18.7337 13.2455 18.9457 13.3333 19.1667 13.3333C19.3877 13.3333 19.5996 13.2455 19.7559 13.0893C19.9122 12.933 20 12.721 20 12.5ZM5 6.66667C4.34073 6.66667 3.69626 6.47117 3.1481 6.1049C2.59994 5.73863 2.17269 5.21803 1.9204 4.60895C1.66811 3.99986 1.6021 3.32964 1.73072 2.68303C1.85933 2.03643 2.1768 1.44249 2.64298 0.976312C3.10915 0.510137 3.7031 0.192668 4.3497 0.0640506C4.9963 -0.0645668 5.66652 0.00144427 6.27561 0.253736C6.8847 0.506029 7.40529 0.93327 7.77156 1.48143C8.13784 2.0296 8.33333 2.67406 8.33333 3.33334C8.33333 4.21739 7.98214 5.06524 7.35702 5.69036C6.7319 6.31548 5.88405 6.66667 5 6.66667ZM5 1.66667C4.67036 1.66667 4.34813 1.76442 4.07405 1.94755C3.79997 2.13069 3.58635 2.39099 3.4602 2.69553C3.33405 3.00007 3.30105 3.33518 3.36536 3.65849C3.42967 3.98179 3.5884 4.27876 3.82149 4.51185C4.05458 4.74493 4.35155 4.90367 4.67485 4.96798C4.99815 5.03229 5.33326 4.99928 5.63781 4.87313C5.94235 4.74699 6.20265 4.53337 6.38578 4.25929C6.56892 3.9852 6.66667 3.66297 6.66667 3.33334C6.66667 2.89131 6.49107 2.46738 6.17851 2.15482C5.86595 1.84226 5.44203 1.66667 5 1.66667ZM1.66667 12.5C1.66667 11.6159 2.01786 10.7681 2.64298 10.143C3.2681 9.51786 4.11594 9.16667 5 9.16667C5.22101 9.16667 5.43297 9.07887 5.58926 8.92259C5.74554 8.76631 5.83333 8.55435 5.83333 8.33333C5.83333 8.11232 5.74554 7.90036 5.58926 7.74408C5.43297 7.5878 5.22101 7.5 5 7.5C3.67432 7.50133 2.40332 8.02853 1.46593 8.96593C0.528533 9.90333 0.00132369 11.1743 0 12.5C0 12.721 0.0877974 12.933 0.244078 13.0893C0.400358 13.2455 0.61232 13.3333 0.833333 13.3333C1.05435 13.3333 1.26631 13.2455 1.42259 13.0893C1.57887 12.933 1.66667 12.721 1.66667 12.5Z",
        fill: "currentColor"
      }
    ) })
  }
), wO = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.3925 6.34919C18.1 4.24419 15.16 0.712524 10 0.712524C4.84 0.712524 1.9 4.24419 0.607497 6.34919C0.207937 6.99545 -0.00370789 7.74023 -0.00370789 8.50002C-0.00370789 9.25982 0.207937 10.0046 0.607497 10.6509C1.9 12.7559 4.84 16.2875 10 16.2875C15.16 16.2875 18.1 12.7559 19.3925 10.6509C19.7921 10.0046 20.0037 9.25982 20.0037 8.50002C20.0037 7.74023 19.7921 6.99545 19.3925 6.34919ZM17.9717 9.77836C16.8617 11.5834 14.3492 14.6209 10 14.6209C5.65083 14.6209 3.13833 11.5834 2.02833 9.77836C1.79094 9.39423 1.66521 8.95159 1.66521 8.50002C1.66521 8.04846 1.79094 7.60582 2.02833 7.22169C3.13833 5.41669 5.65083 2.37919 10 2.37919C14.3492 2.37919 16.8617 5.41336 17.9717 7.22169C18.2091 7.60582 18.3348 8.04846 18.3348 8.50002C18.3348 8.95159 18.2091 9.39423 17.9717 9.77836Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10 4.33331C9.17591 4.33331 8.37033 4.57768 7.68512 5.03552C6.99992 5.49336 6.46586 6.14411 6.1505 6.90547C5.83513 7.66682 5.75262 8.5046 5.91339 9.31286C6.07416 10.1211 6.471 10.8635 7.05372 11.4463C7.63644 12.029 8.37887 12.4258 9.18712 12.5866C9.99537 12.7474 10.8332 12.6648 11.5945 12.3495C12.3559 12.0341 13.0066 11.5001 13.4645 10.8149C13.9223 10.1297 14.1667 9.32407 14.1667 8.49998C14.1653 7.39532 13.7259 6.33628 12.9448 5.55516C12.1637 4.77405 11.1047 4.33464 10 4.33331ZM10 11C9.50554 11 9.02219 10.8534 8.61107 10.5787C8.19995 10.304 7.87952 9.9135 7.6903 9.45669C7.50108 8.99987 7.45157 8.49721 7.54803 8.01225C7.6445 7.5273 7.8826 7.08184 8.23223 6.73221C8.58186 6.38258 9.02732 6.14448 9.51227 6.04802C9.99722 5.95155 10.4999 6.00106 10.9567 6.19028C11.4135 6.3795 11.804 6.69993 12.0787 7.11105C12.3534 7.52218 12.5 8.00553 12.5 8.49998C12.5 9.16302 12.2366 9.79891 11.7678 10.2677C11.2989 10.7366 10.663 11 10 11Z",
          fill: "currentColor"
        }
      )
    ]
  }
), OO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M11.0833 1.16669H5.83333C4.22333 1.16669 2.91667 2.47335 2.91667 4.08335V7.58335C2.91667 9.19335 4.22333 10.5 5.83333 10.5H11.0833C12.6933 10.5 14 9.19335 14 7.58335V4.08335C14 2.47335 12.6933 1.16669 11.0833 1.16669ZM5.83333 2.33335H11.0833C11.8417 2.33335 12.4833 2.82335 12.7283 3.50002H4.18833C4.4275 2.82335 5.06917 2.33335 5.83333 2.33335ZM11.0833 9.33335H5.83333C4.87083 9.33335 4.08333 8.54585 4.08333 7.58335V4.66669H12.8333V7.58335C12.8333 8.54585 12.0458 9.33335 11.0833 9.33335ZM9.91667 12.25C9.91667 12.5709 9.65417 12.8334 9.33333 12.8334H2.91667C1.30667 12.8334 0 11.5267 0 9.91669V5.62919C0 4.91752 0.256667 4.23502 0.729167 3.69835C0.945 3.45919 1.3125 3.43585 1.55167 3.64585C1.79667 3.86169 1.81417 4.22919 1.60417 4.46835C1.32417 4.78919 1.16667 5.19752 1.16667 5.62335V9.91085C1.16667 10.8734 1.95417 11.6609 2.91667 11.6609H9.33333C9.65417 11.6609 9.91667 11.9234 9.91667 12.2442V12.25Z",
        fill: "currentColor"
      }
    )
  }
), SO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M19.275 10.741L14.7667 6.08268C14.45 5.74935 13.9167 5.74102 13.5917 6.06602C13.2583 6.38268 13.25 6.91602 13.575 7.24102L17.8583 11.6577H4.16667C2.79167 11.6577 1.66667 10.5327 1.66667 9.15768V2.49935C1.66667 2.04102 1.29167 1.66602 0.833333 1.66602C0.375 1.66602 0 2.04102 0 2.49935V9.16602C0 11.466 1.86667 13.3327 4.16667 13.3327H17.85L13.5667 17.7493C13.25 18.0827 13.2583 18.6077 13.5833 18.9243C13.7417 19.0827 13.95 19.1577 14.1667 19.1577C14.3833 19.1577 14.6 19.0744 14.7667 18.9077L19.2667 14.2577C20.2417 13.2827 20.2417 11.6993 19.275 10.7327V10.741Z",
        fill: "currentColor"
      }
    )
  }
), PO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M16.6667 38.3333C16.6667 39.255 15.9217 40 15 40H8.33333C3.73833 40 0 36.2617 0 31.6667V8.33333C0 3.73833 3.73833 0 8.33333 0H21.6667C26.2617 0 30 3.73833 30 8.33333V11.6667C30 12.5883 29.255 13.3333 28.3333 13.3333C27.4117 13.3333 26.6667 12.5883 26.6667 11.6667V8.33333C26.6667 5.57667 24.4233 3.33333 21.6667 3.33333H8.33333C5.57667 3.33333 3.33333 5.57667 3.33333 8.33333V31.6667C3.33333 34.4233 5.57667 36.6667 8.33333 36.6667H15C15.9217 36.6667 16.6667 37.4117 16.6667 38.3333ZM23.3333 10C23.3333 9.07833 22.5883 8.33333 21.6667 8.33333H8.33333C7.41167 8.33333 6.66667 9.07833 6.66667 10C6.66667 10.9217 7.41167 11.6667 8.33333 11.6667H21.6667C22.5883 11.6667 23.3333 10.9217 23.3333 10ZM16.6667 18.3333C16.6667 17.4117 15.9217 16.6667 15 16.6667H8.33333C7.41167 16.6667 6.66667 17.4117 6.66667 18.3333C6.66667 19.255 7.41167 20 8.33333 20H15C15.9217 20 16.6667 19.255 16.6667 18.3333ZM8.33333 25C7.41167 25 6.66667 25.745 6.66667 26.6667C6.66667 27.5883 7.41167 28.3333 8.33333 28.3333H11.6667C12.5883 28.3333 13.3333 27.5883 13.3333 26.6667C13.3333 25.745 12.5883 25 11.6667 25H8.33333ZM40 28.3333C40 34.765 34.765 40 28.3333 40C21.9017 40 16.6667 34.765 16.6667 28.3333C16.6667 21.9017 21.9017 16.6667 28.3333 16.6667C34.765 16.6667 40 21.9017 40 28.3333ZM36.6667 28.3333C36.6667 23.7383 32.9283 20 28.3333 20C23.7383 20 20 23.7383 20 28.3333C20 32.9283 23.7383 36.6667 28.3333 36.6667C32.9283 36.6667 36.6667 32.9283 36.6667 28.3333ZM31.3467 26.265L27.6417 29.8217C27.4017 30.0567 27.01 30.0617 26.7717 29.825L24.8867 27.9783C24.2267 27.3317 23.1733 27.3417 22.53 28.0017C21.885 28.66 21.895 29.7133 22.5533 30.3583L24.44 32.2067C25.2067 32.955 26.21 33.33 27.2117 33.33C28.2133 33.33 29.2133 32.955 29.9667 32.2117L33.655 28.6717C34.3183 28.0333 34.34 26.9783 33.7033 26.315C33.065 25.6483 32.0083 25.63 31.3467 26.2667V26.265Z",
        fill: "currentColor"
      }
    )
  }
), EO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M20 0C16.0444 0 12.1776 1.17298 8.8886 3.3706C5.59962 5.56824 3.03618 8.6918 1.52242 12.3463C0.00866604 16.0009 -0.387402 20.0222 0.384304 23.9018C1.15601 27.7814 3.06082 31.345 5.85788 34.1422C8.65492 36.9392 12.2186 38.844 16.0982 39.6158C19.9778 40.3874 23.9992 39.9914 27.6536 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C39.9942 14.6974 37.8852 9.61368 34.1358 5.8642C30.3864 2.11472 25.3026 0.00573514 20 0ZM20 3.33334C23.8442 3.33026 27.5698 4.66292 30.54 7.10334L7.10334 30.54C5.10428 28.0998 3.83944 25.1418 3.45604 22.0108C3.07264 18.8796 3.58644 15.7039 4.93766 12.8534C6.28886 10.0029 8.4219 7.5948 11.0885 5.9094C13.755 4.22402 16.8455 3.33066 20 3.33334ZM20 36.6666C16.1559 36.6698 12.4301 35.337 9.46 32.8966L32.8966 9.46C34.8958 11.9003 36.1606 14.8581 36.544 17.9893C36.9274 21.1204 36.4136 24.2962 35.0624 27.1466C33.7112 29.9972 31.5782 32.4052 28.9116 34.0906C26.245 35.776 23.1546 36.6694 20 36.6666Z",
        fill: "currentColor"
      }
    )
  }
), jO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_16_25)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M20 0C16.0444 0 12.1776 1.17298 8.8886 3.37061C5.59962 5.56824 3.03617 8.69181 1.52242 12.3463C0.00866572 16.0009 -0.387401 20.0222 0.384303 23.9018C1.15601 27.7814 3.06082 31.3451 5.85787 34.1421C8.65492 36.9392 12.2186 38.844 16.0982 39.6157C19.9778 40.3874 23.9992 39.9913 27.6537 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C39.9943 14.6974 37.8853 9.61368 34.1358 5.8642C30.3863 2.11471 25.3026 0.00573514 20 0ZM20 36.6667C16.7037 36.6667 13.4813 35.6892 10.7405 33.8578C7.99969 32.0265 5.86348 29.4235 4.60202 26.3781C3.34056 23.3326 3.0105 19.9815 3.65359 16.7485C4.29667 13.5155 5.88402 10.5458 8.2149 8.21489C10.5458 5.88401 13.5155 4.29667 16.7485 3.65358C19.9815 3.01049 23.3326 3.34055 26.3781 4.60201C29.4235 5.86347 32.0265 7.99968 33.8578 10.7405C35.6892 13.4813 36.6667 16.7036 36.6667 20C36.6618 24.4188 34.9043 28.6552 31.7798 31.7798C28.6552 34.9043 24.4188 36.6618 20 36.6667Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M20 8.33331C19.558 8.33331 19.134 8.50891 18.8215 8.82147C18.5089 9.13403 18.3333 9.55795 18.3333 9.99998V23.3333C18.3333 23.7753 18.5089 24.1993 18.8215 24.5118C19.134 24.8244 19.558 25 20 25C20.442 25 20.8659 24.8244 21.1785 24.5118C21.4911 24.1993 21.6666 23.7753 21.6666 23.3333V9.99998C21.6666 9.55795 21.4911 9.13403 21.1785 8.82147C20.8659 8.50891 20.442 8.33331 20 8.33331Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M21.6666 30C21.6666 29.0795 20.9205 28.3333 20 28.3333C19.0795 28.3333 18.3333 29.0795 18.3333 30C18.3333 30.9205 19.0795 31.6666 20 31.6666C20.9205 31.6666 21.6666 30.9205 21.6666 30Z", fill: "currentColor" })
    ] })
  }
), _O = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M18.3295 20.0111V10.0055C18.3295 9.08836 19.0799 8.33794 19.9971 8.33794C20.9142 8.33794 21.6647 9.08836 21.6647 10.0055V20.0111C21.6647 20.9282 20.9142 21.6787 19.9971 21.6787C19.0799 21.6787 18.3295 20.9282 18.3295 20.0111ZM19.9971 23.3462C18.613 23.3462 17.4957 24.4635 17.4957 25.8476C17.4957 27.2317 18.613 28.349 19.9971 28.349C21.3812 28.349 22.4984 27.2317 22.4984 25.8476C22.4984 24.4635 21.3812 23.3462 19.9971 23.3462ZM39.3077 31.4841C38.1404 33.7353 35.6891 35.0194 32.6207 35.0194H7.39009C4.30505 35.0194 1.87037 33.7353 0.703061 31.4841C-0.480927 29.2162 -0.147409 26.3145 1.53686 23.8799L14.9443 2.66814C16.1283 0.967201 17.996 0 19.9971 0C21.9982 0 23.8659 0.967201 24.9998 2.61811L38.4739 23.9132C40.1582 26.3479 40.4751 29.2328 39.2911 31.4841H39.3077ZM35.7224 25.7809C35.7224 25.7809 35.6891 25.7476 35.6891 25.7142L22.2316 4.45246C21.748 3.76875 20.9142 3.33518 19.9971 3.33518C19.0799 3.33518 18.2461 3.76875 17.7291 4.51917L4.30505 25.7142C3.27115 27.1817 3.03769 28.7826 3.63802 29.9332C4.22167 31.0672 5.55574 31.6842 7.37342 31.6842H32.5874C34.405 31.6842 35.7391 31.0672 36.3228 29.9332C36.9231 28.7826 36.6896 27.1817 35.7057 25.7809H35.7224Z", fill: "currentColor" })
  }
), AO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_16_33)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M20 16.6667C18.6814 16.6667 17.3925 17.0577 16.2962 17.7902C15.1999 18.5228 14.3454 19.564 13.8408 20.7821C13.3362 22.0003 13.2042 23.3407 13.4614 24.634C13.7186 25.9272 14.3536 27.115 15.2859 28.0474C16.2183 28.9797 17.4062 29.6147 18.6994 29.8719C19.9926 30.1292 21.333 29.9971 22.5512 29.4926C23.7694 28.988 24.8106 28.1335 25.5431 27.0372C26.2757 25.9408 26.6666 24.6519 26.6666 23.3334C26.6666 21.5652 25.9643 19.8696 24.714 18.6193C23.4638 17.3691 21.7681 16.6667 20 16.6667ZM20 26.6667C19.3407 26.6667 18.6962 26.4712 18.1481 26.1049C17.5999 25.7386 17.1727 25.2181 16.9204 24.609C16.6681 23.9999 16.6021 23.3297 16.7307 22.6831C16.8593 22.0364 17.1768 21.4425 17.643 20.9763C18.1091 20.5102 18.7031 20.1927 19.3497 20.0641C19.9963 19.9355 20.6665 20.0015 21.2756 20.2538C21.8847 20.506 22.4053 20.9333 22.7715 21.4815C23.1378 22.0296 23.3333 22.6741 23.3333 23.3334C23.3333 24.2174 22.9821 25.0653 22.357 25.6904C21.7319 26.3155 20.884 26.6667 20 26.6667Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M37.56 6.87003L33.13 2.44003C32.3581 1.66394 31.4399 1.04867 30.4286 0.629836C29.4173 0.211008 28.3329 -0.0030576 27.2383 3.29938e-05H8.33333C6.12401 0.00267942 4.00593 0.881503 2.4437 2.44373C0.88147 4.00596 0.00264643 6.12404 0 8.33337L0 31.6667C0.00264643 33.876 0.88147 35.9941 2.4437 37.5563C4.00593 39.1186 6.12401 39.9974 8.33333 40H31.6667C33.876 39.9974 35.9941 39.1186 37.5563 37.5563C39.1185 35.9941 39.9974 33.876 40 31.6667V12.7617C40.0031 11.6671 39.789 10.5828 39.3702 9.57144C38.9514 8.56013 38.3361 7.64194 37.56 6.87003ZM28.3333 3.4667V5.00003C28.3333 6.32612 27.8066 7.59789 26.8689 8.53557C25.9312 9.47325 24.6594 10 23.3333 10H16.6667C15.3406 10 14.0688 9.47325 13.1311 8.53557C12.1935 7.59789 11.6667 6.32612 11.6667 5.00003V3.33337H27.2383C27.6072 3.33664 27.9745 3.38136 28.3333 3.4667ZM36.6667 31.6667C36.6667 32.9928 36.1399 34.2646 35.2022 35.2022C34.2645 36.1399 32.9928 36.6667 31.6667 36.6667H8.33333C7.00725 36.6667 5.73548 36.1399 4.7978 35.2022C3.86012 34.2646 3.33333 32.9928 3.33333 31.6667V8.33337C3.33333 7.00728 3.86012 5.73551 4.7978 4.79783C5.73548 3.86015 7.00725 3.33337 8.33333 3.33337V5.00003C8.33598 7.20936 9.2148 9.32744 10.777 10.8897C12.3393 12.4519 14.4573 13.3307 16.6667 13.3334H23.3333C25.4292 13.3269 27.4453 12.5295 28.9785 11.1006C30.5118 9.67181 31.4492 7.71685 31.6033 5.6267L35.2033 9.2267C36.1374 10.1665 36.6632 11.4367 36.6667 12.7617V31.6667Z", fill: "currentColor" })
    ] })
  }
), DO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_16_33)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M31.6667 3.33333H30V1.66667C30 1.22464 29.8244 0.800716 29.5118 0.488155C29.1993 0.175595 28.7754 0 28.3333 0C27.8913 0 27.4674 0.175595 27.1548 0.488155C26.8423 0.800716 26.6667 1.22464 26.6667 1.66667V3.33333H13.3333V1.66667C13.3333 1.22464 13.1577 0.800716 12.8452 0.488155C12.5326 0.175595 12.1087 0 11.6667 0C11.2246 0 10.8007 0.175595 10.4882 0.488155C10.1756 0.800716 10 1.22464 10 1.66667V3.33333H8.33333C6.12401 3.33598 4.00593 4.2148 2.4437 5.77703C0.88147 7.33926 0.00264643 9.45734 0 11.6667V31.6667C0.00264643 33.876 0.88147 35.9941 2.4437 37.5563C4.00593 39.1185 6.12401 39.9974 8.33333 40H31.6667C33.876 39.9974 35.9941 39.1185 37.5563 37.5563C39.1185 35.9941 39.9974 33.876 40 31.6667V11.6667C39.9974 9.45734 39.1185 7.33926 37.5563 5.77703C35.9941 4.2148 33.876 3.33598 31.6667 3.33333ZM3.33333 11.6667C3.33333 10.3406 3.86012 9.06881 4.7978 8.13113C5.73548 7.19345 7.00725 6.66667 8.33333 6.66667H31.6667C32.9927 6.66667 34.2645 7.19345 35.2022 8.13113C36.1399 9.06881 36.6667 10.3406 36.6667 11.6667V13.3333H3.33333V11.6667ZM31.6667 36.6667H8.33333C7.00725 36.6667 5.73548 36.1399 4.7978 35.2022C3.86012 34.2645 3.33333 32.9927 3.33333 31.6667V16.6667H36.6667V31.6667C36.6667 32.9927 36.1399 34.2645 35.2022 35.2022C34.2645 36.1399 32.9927 36.6667 31.6667 36.6667Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M20 27.5C21.3807 27.5 22.5 26.3807 22.5 25C22.5 23.6193 21.3807 22.5 20 22.5C18.6193 22.5 17.5 23.6193 17.5 25C17.5 26.3807 18.6193 27.5 20 27.5Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M11.6667 27.5C13.0474 27.5 14.1667 26.3807 14.1667 25C14.1667 23.6193 13.0474 22.5 11.6667 22.5C10.286 22.5 9.16667 23.6193 9.16667 25C9.16667 26.3807 10.286 27.5 11.6667 27.5Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M28.3333 27.5C29.714 27.5 30.8333 26.3807 30.8333 25C30.8333 23.6193 29.714 22.5 28.3333 22.5C26.9526 22.5 25.8333 23.6193 25.8333 25C25.8333 26.3807 26.9526 27.5 28.3333 27.5Z", fill: "currentColor" })
    ] })
  }
), MO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M36.201 13.7825L38.1094 8.62045C38.1094 8.62045 38.1125 8.61375 38.1135 8.60974C38.1156 8.60439 38.1177 8.59903 38.1187 8.59368L39.274 5.4673C39.8333 3.95095 39.2531 2.08128 37.9771 1.29968L36.4062 0.341422C35.7646 -0.0520521 35.026 -0.108263 34.3802 0.187512C33.7938 0.455182 33.3302 0.983829 33.074 1.67709L30.4063 8.89615C28.9156 8.22831 27.3573 7.88971 25.7646 7.88971H14.2333C10.4458 7.88971 6.875 9.79953 4.18021 13.2659C1.48438 16.7335 0 21.324 0 26.1943V26.9545C0 32.1995 1.75833 37.1781 4.83229 40.6685L4.52708 47.8822C4.50417 48.443 4.68958 48.7401 4.85 48.8913C4.95417 48.989 5.10833 49.0827 5.31875 49.0827C5.43854 49.0827 5.57708 49.0533 5.73438 48.977C5.75625 48.9663 5.77708 48.9543 5.79792 48.9409L11.2854 45.3139C11.3146 45.2952 11.3469 45.2738 11.3687 45.2591C11.3896 45.2591 11.4177 45.2591 11.4427 45.2591H17.5281C17.8521 45.2591 18.1135 44.9218 18.1135 44.5069C18.1135 44.092 17.851 43.7548 17.5281 43.7548H11.4469C11.1312 43.7508 11.0427 43.7815 10.75 43.9756L5.725 47.2974L6.01146 40.5133C6.06354 40.1158 5.9 39.8669 5.79479 39.7504C2.85625 36.5357 1.17083 31.8716 1.17083 26.9545V26.1943C1.17083 16.9316 7.03021 9.39535 14.2333 9.39535H25.7646C27.1823 9.39535 28.5708 9.68711 29.901 10.2653L27.924 15.6133C27.7854 15.9894 27.9094 16.4377 28.2021 16.6171C28.4948 16.7951 28.8438 16.6358 28.9833 16.2597L32.7219 6.14584L36.8062 8.6432L29.7073 27.8485L25.6229 25.3511L27.8385 19.358C27.9771 18.9819 27.8531 18.5336 27.5604 18.3543C27.2677 18.1763 26.9188 18.3355 26.7792 18.7116L24.3125 25.3846C24.2812 25.4703 24.2625 25.5639 24.2573 25.659L23.8406 33.9286H8.98542C8.66146 33.9286 8.4 34.2659 8.4 34.6808C8.4 35.0957 8.66146 35.4329 8.98542 35.4329H24C24.0771 35.5574 24.1729 35.6578 24.2885 35.7287C24.401 35.7969 24.5208 35.8317 24.6406 35.8317C24.8396 35.8317 25.0406 35.7394 25.2187 35.5614C25.2312 35.5494 25.2437 35.5346 25.2563 35.5212L30.3833 29.4037C30.4375 29.3394 30.4813 29.2605 30.5135 29.1748L35.6573 15.2587C37.7073 18.3154 38.8281 22.1578 38.8281 26.1943V26.9545C38.8281 36.2172 32.9688 43.7534 25.7656 43.7534H20.1292C19.8052 43.7534 19.5437 44.0907 19.5437 44.5056C19.5437 44.9205 19.8062 45.2577 20.1292 45.2577H25.7656C29.5521 45.2577 33.1219 43.3479 35.8188 39.8816C38.5156 36.4139 40 31.8234 40 26.9531V26.193C40 21.573 38.6542 17.1859 36.2031 13.7811L36.201 13.7825ZM33.2229 4.78474L34.1323 2.32352C34.2542 1.99428 34.4813 1.74 34.7719 1.60616C35.1271 1.44422 35.5385 1.47768 35.9021 1.69985L37.474 2.65944C38.1667 3.0837 38.499 4.054 38.2156 4.82087L37.3063 7.28076L33.2219 4.7834L33.2229 4.78474ZM25.0229 33.7412L25.1437 31.3523L26.3875 32.1125L25.0229 33.7412ZM27.3115 31.0097L25.225 29.7329L25.3698 26.8621L28.9521 29.053L27.3125 31.0097H27.3115Z", fill: "currentColor" })
  }
), TO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M5.57407 17.7786C5.57407 17.4105 5.81724 17.113 6.11806 17.113H22.4116C22.7114 17.113 22.9556 17.4118 22.9556 17.7786C22.9556 18.1454 22.7124 18.4442 22.4116 18.4442H6.11806C5.81724 18.4442 5.57407 18.1466 5.57407 17.7786ZM14.4708 22.725H6.11806C5.81724 22.725 5.57407 23.0225 5.57407 23.3906C5.57407 23.7586 5.81724 24.0562 6.11806 24.0562H14.4708C14.7716 24.0562 15.0148 23.7586 15.0148 23.3906C15.0148 23.0225 14.7716 22.725 14.4708 22.725ZM14.4708 28.337H6.11806C5.81724 28.337 5.57407 28.6345 5.57407 29.0026C5.57407 29.3706 5.81724 29.6682 6.11806 29.6682H14.4708C14.7716 29.6682 15.0148 29.3706 15.0148 29.0026C15.0148 28.6345 14.7716 28.337 14.4708 28.337ZM14.4708 33.949H6.11806C5.81724 33.949 5.57407 34.2465 5.57407 34.6146C5.57407 34.9826 5.81724 35.2802 6.11806 35.2802H14.4708C14.7716 35.2802 15.0148 34.9826 15.0148 34.6146C15.0148 34.2465 14.7716 33.949 14.4708 33.949ZM39.879 33.477C39.7333 33.8682 39.4723 34.1644 39.1443 34.3132L37.4494 35.0839C37.3006 35.1506 37.1475 35.1852 36.9935 35.1852C36.8069 35.1852 36.6214 35.1365 36.4463 35.0378C36.3227 34.9685 36.2147 34.8723 36.1172 34.7646C36.0753 35.234 35.9306 35.6841 35.678 36.0227C35.3311 36.4869 34.8636 36.669 34.3647 36.5498C34.3521 36.8563 34.2861 37.1654 34.1593 37.4539C33.7872 38.3042 33.0126 38.7235 32.2757 38.5491C32.2621 38.8543 32.1929 39.1531 32.0724 39.4289C32.0032 39.5892 31.9131 39.729 31.8156 39.8598V41.7604C31.8156 44.1021 30.2905 46.013 28.3913 46.0912C27.9689 47.9097 26.6031 49.246 24.9837 49.246H3.5459C1.59109 49.246 0 47.3005 0 44.9088V7.48565C0 5.1439 1.52611 3.23305 3.42536 3.15482C3.85405 1.3222 5.24181 0 6.8329 0H28.2718C30.2266 0 31.8166 1.94676 31.8166 4.33724V25.0475C31.89 25.0834 31.9602 25.1206 32.0305 25.1565C32.5713 25.4335 32.912 25.5848 33.1813 25.5707C33.1216 25.2347 33.1478 24.8859 33.2673 24.5666C33.414 24.1767 33.674 23.8792 34.002 23.7304L35.698 22.9597C36.026 22.8109 36.3824 22.8276 36.701 23.0058C37.0197 23.1841 37.2628 23.5047 37.3844 23.9048L39.9178 32.2497C40.0394 32.6511 40.0258 33.0872 39.879 33.477ZM31.6102 26.3825C30.5861 25.858 29.5264 25.3155 28.0538 26.5595C27.7414 26.8237 27.4207 27.1571 27.0989 27.5534C26.905 27.7919 26.7069 28.0318 26.513 28.2639C26.1189 28.7371 25.6525 29.2988 25.4009 29.681C26.144 30.6287 26.9186 30.3402 28.1397 29.7785C29.1344 29.3206 30.2591 28.8012 31.2548 29.7297C31.5284 29.9208 31.9319 30.1645 32.3585 30.4222C33.5723 31.1545 34.5942 31.8022 35.2525 32.4562L33.5492 26.8442C33.4203 26.8801 33.2903 26.9019 33.1625 26.9019C32.6269 26.9019 32.0986 26.6313 31.6102 26.3812V26.3825ZM4.57833 3.14713H24.9837C26.9385 3.14713 28.5286 5.09388 28.5286 7.48437V24.7564C29.3535 24.3832 30.0851 24.4178 30.7276 24.6012V4.33724C30.7276 2.67903 29.625 1.3299 28.2697 1.3299H6.8329C5.8403 1.3299 4.9609 2.07244 4.57833 3.14585V3.14713ZM17.2044 10.8033L20.1381 8.38336C20.3216 8.23204 20.5626 8.23204 20.7461 8.38336L23.3696 10.5469V4.47831H17.2044V10.8033ZM27.4417 44.9088V43.2801C27.3274 43.3147 27.2132 43.3339 27.0989 43.3339C26.8327 43.3339 26.5717 43.2467 26.339 43.0941C25.9575 42.844 25.6388 42.4106 25.469 41.9053C25.4586 41.9091 25.447 41.9143 25.4355 41.9181C24.9995 42.0797 24.5404 42.0245 24.14 41.7629C23.8434 41.5821 23.5991 41.282 23.4409 40.9063C23.3644 40.9499 23.2857 40.987 23.204 41.0178C22.768 41.1781 22.3078 41.1243 21.9085 40.8627C21.5269 40.6292 21.2345 40.2035 21.0962 39.6713C21.0228 39.3866 20.9987 39.0877 21.0238 38.7966C20.7765 38.7838 20.527 38.7056 20.2943 38.5517C19.9138 38.3196 19.6204 37.8938 19.482 37.3616C19.3405 36.8178 19.3824 36.2253 19.5962 35.7354L19.7922 35.2878C19.679 35.3263 19.5638 35.3507 19.4474 35.3507C19.3122 35.3507 19.1759 35.325 19.0449 35.2725L17.3239 34.594C16.6363 34.3222 16.2568 33.4155 16.478 32.5742L18.7127 24.101C18.8196 23.6945 19.0512 23.3624 19.3636 23.1674C19.6759 22.9712 20.0312 22.9366 20.3635 23.0674L22.0856 23.7471C22.5269 23.9215 22.8392 24.3588 22.9482 24.8705C23.3476 24.8872 23.7459 24.791 24.1892 24.6833C25.1179 24.4576 26.1545 24.2075 27.4438 24.9859V7.48565C27.4438 5.82745 26.3411 4.47831 24.9858 4.47831H24.4586V11.7972C24.4586 12.0435 24.3475 12.2692 24.1704 12.3846C23.9922 12.5 23.7784 12.4859 23.6107 12.3487L20.4442 9.73635L17.2033 12.409C17.1132 12.4834 17.0073 12.5231 16.8994 12.5231H16.6635C16.3627 12.5231 16.1195 12.2256 16.1195 11.8575V4.47703H3.54904C2.19378 4.47703 1.09113 5.82616 1.09113 7.48437V44.9075C1.09113 46.5657 2.19378 47.9136 3.54904 47.9136H24.9869C26.3421 47.9136 27.4448 46.5644 27.4448 44.9075L27.4417 44.9088ZM29.0516 39.8803C29.1344 40.3035 29.0652 40.7229 28.9615 41.0717L29.017 41.1063C29.3556 41.3192 29.5285 40.9986 29.5726 40.8947C29.6218 40.778 29.7371 40.3997 29.365 40.0855L29.0527 39.879L29.0516 39.8803ZM28.5129 42.2874L28.4709 42.2605C28.4668 42.2695 28.4615 42.2785 28.4573 42.2874H28.5129ZM26.7593 40.1842L26.4784 40.8267C26.2992 41.2371 26.5759 41.7398 26.8516 41.9207C26.9553 41.9899 27.2719 42.1951 27.5601 41.5359L27.7645 41.0691C27.7645 41.0691 27.7645 41.0691 27.7645 41.0678C28.1502 40.1855 28.0381 40.0573 27.6282 39.7892C27.4521 39.6738 27.2624 39.7277 27.166 39.77C26.991 39.8457 26.8421 39.997 26.7604 40.1855L26.7593 40.1842ZM25.8631 37.8181C25.5665 37.6232 25.1934 37.7604 25.033 38.1259C25.033 38.1259 25.033 38.1272 25.033 38.1285L24.401 39.5738C24.3245 39.7495 24.3119 39.9662 24.3643 40.1688C24.3926 40.2766 24.4649 40.4741 24.6389 40.5805C24.7961 40.6831 24.9617 40.7023 25.119 40.6434C25.2762 40.5856 25.4061 40.4561 25.4827 40.2817L25.5194 40.1971C25.5194 40.1971 25.5194 40.1958 25.5204 40.1945L25.7971 39.5597C25.7971 39.5597 25.7971 39.5571 25.7971 39.5558L26.1137 38.8325C26.273 38.467 26.1598 38.0118 25.861 37.8156L25.8631 37.8181ZM24.2752 36.5703C24.228 36.3766 24.1222 36.2189 23.9796 36.1253C23.6819 35.9304 23.3088 36.0689 23.1484 36.4331C23.1484 36.4331 23.1484 36.4331 23.1484 36.4344L22.595 37.7014L22.1695 38.6735C22.0929 38.8492 22.0804 39.0659 22.1328 39.2686C22.1611 39.3763 22.2344 39.5751 22.4084 39.6802C22.7208 39.8841 23.0929 39.7444 23.2522 39.3814L23.443 38.9454C23.443 38.9454 23.443 38.9454 23.444 38.9428L24.075 37.5001C24.075 37.5001 24.075 37.5001 24.075 37.4988L24.2312 37.141C24.3087 36.9653 24.3245 36.7627 24.2762 36.569L24.2752 36.5703ZM22.0772 34.394C21.941 34.3145 21.7848 34.3004 21.637 34.3555C21.4798 34.4132 21.3509 34.5427 21.2733 34.7184L21.0406 35.2507L20.5543 36.3638C20.4777 36.5395 20.4641 36.7563 20.5176 36.9589C20.5459 37.0666 20.6182 37.2641 20.7932 37.3705C21.1035 37.5745 21.4766 37.4372 21.6359 37.0717C21.6359 37.0717 21.637 37.0692 21.637 37.0679L22.1894 35.8034L22.355 35.4238C22.4168 35.2814 22.6044 34.8518 22.0762 34.3914L22.0772 34.394ZM21.8938 25.3579C21.9305 25.2168 21.8655 25.059 21.7491 25.0142L20.027 24.3345C20.0029 24.3255 19.9809 24.3216 19.96 24.3216C19.9149 24.3216 19.8771 24.3396 19.8562 24.3524C19.8258 24.3716 19.7692 24.4191 19.7451 24.5102L17.5104 32.9833C17.4737 33.1244 17.5398 33.2821 17.6551 33.327L19.3772 34.0067C19.4526 34.0362 19.5166 34.008 19.547 33.9887C19.5784 33.9695 19.634 33.922 19.6581 33.8297L20.0459 32.3562C20.0595 32.2972 20.0721 32.2369 20.0868 32.1779C20.0931 32.1574 20.1004 32.1394 20.1077 32.1202L21.8917 25.3553L21.8938 25.3579ZM30.7297 41.7617V40.542C30.7297 40.542 30.7224 40.5446 30.7182 40.5446C30.7276 40.8845 30.6626 41.2205 30.5358 41.5141C30.2633 42.1515 29.7623 42.5068 29.2298 42.5068C28.9971 42.5068 28.7592 42.4375 28.5307 42.2964V44.751C29.7654 44.592 30.7297 43.3121 30.7297 41.7604V41.7617ZM34.9192 33.9246C34.5471 33.2321 32.9413 32.2613 31.8774 31.6188C31.3984 31.3302 30.9844 31.0801 30.6794 30.8634C30.6574 30.848 30.6354 30.8288 30.6144 30.8095C30.1176 30.3286 29.496 30.5787 28.5234 31.0276C27.3075 31.588 25.642 32.3536 24.2941 30.1363C24.1809 29.949 24.1547 29.7028 24.228 29.4861C24.4094 28.9461 24.9251 28.31 25.751 27.3161C25.9407 27.0879 26.1357 26.8545 26.3254 26.6198C26.4805 26.4287 26.6356 26.2492 26.7908 26.0812C25.9103 25.6195 25.1986 25.7926 24.3978 25.9875C23.8947 26.1106 23.3769 26.2338 22.8141 26.1914L21.0878 32.7396C21.049 32.9063 21.0175 33.0756 20.9987 33.2449C21.0993 33.1782 21.2073 33.1231 21.3205 33.082C21.7565 32.9192 22.2166 32.9756 22.616 33.2372C22.6411 33.2526 22.6642 33.2718 22.6872 33.2924C23.1359 33.6784 23.4115 34.1811 23.4954 34.7197C23.8276 34.6736 24.1746 34.7441 24.4922 34.9518C24.8915 35.2135 25.185 35.6508 25.316 36.1843C25.3349 36.2612 25.3506 36.3382 25.3621 36.4164C25.6996 36.3625 26.0539 36.4344 26.3767 36.6447C26.7719 36.9037 27.0476 37.3282 27.1817 37.8117C27.3368 37.5373 27.6366 37.4424 27.884 37.604L29.6879 38.7889C29.7182 38.8005 29.7497 38.8159 29.779 38.8351C29.779 38.8351 29.7801 38.8351 29.7811 38.8351L30.2318 39.1301C30.3849 39.2301 30.561 39.2506 30.7287 39.1891C30.8964 39.1262 31.0337 38.9903 31.1144 38.803C31.1961 38.6158 31.214 38.4003 31.1626 38.1952C31.1123 37.9912 31.0001 37.8232 30.8482 37.7232H30.8471C30.8282 37.7104 30.8125 37.6937 30.7957 37.6796L28.712 36.3164C28.4468 36.1432 28.3473 35.7406 28.4888 35.4161C28.6303 35.0916 28.9604 34.9685 29.2246 35.1429L31.3628 36.5421C31.3817 36.5536 31.3963 36.569 31.4131 36.5831L32.2988 37.1628C32.6227 37.3731 33.0273 37.2243 33.2002 36.8281C33.3679 36.4459 33.2568 35.9727 32.957 35.7495L30.0201 33.7989C29.756 33.6232 29.6585 33.2193 29.8011 32.8961C29.9446 32.5729 30.2748 32.4536 30.5389 32.6281L33.413 34.5363C33.4214 34.5415 33.4308 34.544 33.4392 34.5504L34.3322 35.134C34.6907 35.3674 34.8238 35.1917 34.8731 35.125C35.0617 34.8711 35.1215 34.3029 34.916 33.922L34.9192 33.9246ZM38.899 32.7153L36.3656 24.3704C36.3373 24.278 36.2807 24.2344 36.2482 24.2178C36.2283 24.2062 36.1948 24.1921 36.1539 24.1921C36.1308 24.1921 36.1057 24.1972 36.0784 24.2088L34.3825 24.9795C34.3081 25.0129 34.2725 25.0834 34.2578 25.1232C34.2431 25.1616 34.2232 25.2411 34.2505 25.3309L36.7838 33.6771C36.8111 33.7681 36.8687 33.8117 36.9002 33.831C36.9316 33.8477 36.9966 33.872 37.071 33.84L38.7669 33.0692C38.8414 33.0359 38.877 32.9653 38.8917 32.9269C38.9063 32.8884 38.9263 32.8089 38.899 32.7178V32.7153Z", fill: "currentColor" })
  }
), $O = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 33 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M5.44355 49.8668H23.4943C26.359 49.8642 28.6809 47.5423 28.6835 44.6762V34.1782H29.9731C31.5924 34.1756 32.904 32.864 32.9066 31.2447V18.0663C32.9066 17.8858 32.8352 17.7144 32.708 17.5858L28.6848 13.5718V5.18926C28.6822 2.32452 26.3603 0.00259723 23.4956 0H5.44485C2.5788 0.00259723 0.258182 2.32452 0.255585 5.18926V44.6762C0.258182 47.541 2.5801 49.8629 5.44485 49.8668H5.44355ZM29.9744 32.8251H26.3382V22.0648C26.3382 21.8842 26.2668 21.7128 26.1396 21.5856L20.4399 15.8963C20.4399 15.8963 20.4373 15.8937 20.436 15.8924C20.3088 15.7613 20.1348 15.686 19.9517 15.686C19.9335 15.686 19.9153 15.6873 19.8984 15.6886C19.8802 15.6873 19.8621 15.686 19.8452 15.686H16.9155V14.6198C16.9155 13.7484 17.6232 13.042 18.4946 13.0407H25.8435V15.8197C25.8461 17.4391 27.1577 18.7507 28.777 18.7533H31.5561V31.2434C31.5548 32.1147 30.8483 32.8212 29.977 32.8225L29.9744 32.8251ZM19.2712 17.0417V19.8207C19.2725 21.4401 20.5854 22.7517 22.2048 22.7543H24.9838V35.2444C24.9838 36.1158 24.276 36.8222 23.4047 36.8235H11.9223C11.051 36.8222 10.3445 36.1158 10.3432 35.2444V18.6208C10.3432 17.7482 11.051 17.0417 11.9223 17.0404H19.2712V17.0417ZM24.0371 21.3999H22.2061C21.3334 21.3986 20.6282 20.6921 20.6269 19.8207V17.9975L24.0384 21.4012L24.0371 21.3999ZM27.3317 14.1328V14.1964H27.3953L30.6068 17.4001H28.7757C27.9044 17.4001 27.1966 16.6924 27.1966 15.821V13.9978L27.333 14.1341L27.3317 14.1328ZM5.44355 1.35445H23.4943C25.6123 1.35705 27.3278 3.07252 27.3304 5.19056V6.76967H25.7513C25.3773 6.76967 25.0747 7.07355 25.0747 7.44625C25.0747 7.81895 25.3786 8.12283 25.7513 8.12283H27.3304V12.2213L27.007 11.8992C27.007 11.8992 27.0044 11.8966 27.0018 11.8953C26.8746 11.7641 26.6993 11.6888 26.5175 11.6888C26.4993 11.6888 26.4811 11.6888 26.4642 11.6914C26.446 11.6888 26.4291 11.6888 26.411 11.6888H18.492C16.8727 11.6914 15.5611 13.003 15.5585 14.6224V15.6886H11.9223C10.303 15.6899 8.99136 17.0028 8.98876 18.6221V35.2457C8.99006 36.8651 10.303 38.1767 11.9223 38.1793H23.4047C25.024 38.178 26.3356 36.8651 26.3382 35.2457V34.1795H27.3317V40.3908H1.60874V8.12283H19.9984C20.3724 8.12283 20.675 7.81895 20.675 7.44625C20.675 7.07355 20.3724 6.76967 19.9984 6.76967H1.60874V5.19056C1.61134 3.07252 3.3281 1.35705 5.44485 1.35445H5.44355ZM1.60744 41.7439H27.3304V44.6775C27.3278 46.7956 25.6123 48.511 23.4943 48.5136H5.44355C3.32551 48.511 1.61004 46.7956 1.60744 44.6775V41.7439Z", fill: "currentColor" })
  }
), NO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M20.0001 20C21.3186 20 22.6076 19.609 23.7039 18.8765C24.8002 18.1439 25.6547 17.1027 26.1593 15.8846C26.6639 14.6664 26.7959 13.3259 26.5387 12.0327C26.2814 10.7395 25.6465 9.55164 24.7141 8.61929C23.7818 7.68694 22.5939 7.052 21.3007 6.79476C20.0075 6.53753 18.667 6.66955 17.4489 7.17414C16.2307 7.67872 15.1895 8.5332 14.457 9.62953C13.7244 10.7259 13.3334 12.0148 13.3334 13.3333C13.3334 15.1014 14.0358 16.7971 15.286 18.0474C16.5363 19.2976 18.232 20 20.0001 20ZM20.0001 10C20.6594 10 21.3038 10.1955 21.852 10.5618C22.4002 10.928 22.8274 11.4486 23.0797 12.0577C23.332 12.6668 23.398 13.337 23.2694 13.9836C23.1408 14.6302 22.8233 15.2242 22.3571 15.6904C21.8909 16.1565 21.297 16.474 20.6504 16.6026C20.0038 16.7312 19.3336 16.6652 18.7245 16.4129C18.1154 16.1606 17.5948 15.7334 17.2285 15.1852C16.8623 14.6371 16.6668 13.9926 16.6668 13.3333C16.6668 12.4493 17.0179 11.6014 17.6431 10.9763C18.2682 10.3512 19.116 10 20.0001 10ZM34.4334 15.2617L33.2351 14.8633C33.4507 12.9965 33.2693 11.1052 32.7028 9.31347C32.1362 7.52171 31.1973 5.86994 29.9476 4.46649C28.6979 3.06303 27.1656 1.9396 25.4513 1.16986C23.737 0.400112 21.8793 0.0014458 20.0001 0C18.0964 0.000734949 16.2149 0.40949 14.4825 1.19872C12.75 1.98796 11.2069 3.13934 9.95696 4.57529C8.70706 6.01124 7.77944 7.69841 7.23661 9.52312C6.69378 11.3478 6.54834 13.2677 6.81009 15.1533C5.21515 15.4507 3.7403 16.2032 2.56343 17.32C1.74872 18.0946 1.10104 19.0276 0.660223 20.0617C0.219405 21.0958 -0.00524229 22.2092 9.28451e-05 23.3333V30.125C0.0035955 31.9272 0.589746 33.68 1.67108 35.1218C2.75241 36.5635 4.27095 37.617 6.00009 38.125L10.7834 39.625C11.5869 39.875 12.4236 40.0015 13.2651 40C14.0284 39.999 14.7881 39.8947 15.5234 39.69L25.1568 36.84C26.015 36.6058 26.9202 36.6058 27.7784 36.84L31.7568 38.1733C32.7373 38.412 33.7591 38.4249 34.7454 38.2112C35.7316 37.9975 36.6564 37.5627 37.4502 36.9395C38.2439 36.3164 38.8858 35.5212 39.3275 34.6139C39.7692 33.7065 39.9992 32.7108 40.0001 31.7017V23.12C39.9963 21.3957 39.4593 19.7147 38.4627 18.3076C37.4661 16.9004 36.0587 15.8376 34.4334 15.2617ZM12.9301 6.27C13.8572 5.33915 14.959 4.60054 16.1722 4.09655C17.3855 3.59257 18.6863 3.33313 20.0001 3.33313C21.3139 3.33313 22.6147 3.59257 23.828 4.09655C25.0412 4.60054 26.143 5.33915 27.0701 6.27C28.9404 8.1519 29.9916 10.6964 29.9951 13.3496C29.9985 16.0028 28.9538 18.5499 27.0884 20.4367L21.1668 26.195C20.8577 26.498 20.4421 26.6678 20.0093 26.6678C19.5764 26.6678 19.1608 26.498 18.8518 26.195L12.9301 20.4617C11.0559 18.5756 10.0039 16.0247 10.0039 13.3658C10.0039 10.7069 11.0559 8.15602 12.9301 6.27ZM36.6668 31.7017C36.6678 32.2065 36.5536 32.7048 36.333 33.1589C36.1123 33.6129 35.791 34.0106 35.3934 34.3217C35.0178 34.6237 34.5802 34.8392 34.1118 34.953C33.6435 35.0668 33.1558 35.076 32.6834 34.98L28.7751 33.6667C27.2968 33.242 25.73 33.2327 24.2468 33.64L14.6068 36.4867C13.6806 36.7422 12.7003 36.7254 11.7834 36.4383L6.96009 34.9383C5.91618 34.6365 4.99836 34.0041 4.34442 33.1362C3.69049 32.2683 3.33574 31.2117 3.33343 30.125V23.3333C3.32968 22.6596 3.46377 21.9923 3.72746 21.3723C3.99115 20.7524 4.37886 20.1929 4.86676 19.7283C5.63052 19.0004 6.60346 18.5306 7.64843 18.385C8.32027 20.0503 9.32073 21.5632 10.5901 22.8333L16.5351 28.5883C17.4643 29.4982 18.713 30.0077 20.0134 30.0077C21.3139 30.0077 22.5626 29.4982 23.4918 28.5883L29.4301 22.8167C30.7597 21.4817 31.7897 19.879 32.4518 18.115L33.3468 18.4117C34.3174 18.7595 35.1571 19.3983 35.7512 20.2409C36.3454 21.0835 36.6651 22.089 36.6668 23.12V31.7017Z", fill: "currentColor" })
  }
), IO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M21.6667 1.66664C21.6667 1.22462 21.8423 0.800692 22.1548 0.488131C22.4674 0.175571 22.8913 -2.39338e-05 23.3333 -2.39338e-05C27.7521 0.00482873 31.9885 1.76233 35.1131 4.88689C38.2376 8.01145 39.9951 12.2479 40 16.6666C40 17.1087 39.8244 17.5326 39.5118 17.8452C39.1993 18.1577 38.7754 18.3333 38.3333 18.3333C37.8913 18.3333 37.4674 18.1577 37.1548 17.8452C36.8423 17.5326 36.6667 17.1087 36.6667 16.6666C36.6627 13.1316 35.2567 9.74256 32.757 7.24294C30.2574 4.74331 26.8683 3.33728 23.3333 3.33331C22.8913 3.33331 22.4674 3.15771 22.1548 2.84515C21.8423 2.53259 21.6667 2.10867 21.6667 1.66664ZM23.3333 9.99998C25.1014 9.99998 26.7971 10.7024 28.0474 11.9526C29.2976 13.2028 30 14.8985 30 16.6666C30 17.1087 30.1756 17.5326 30.4881 17.8452C30.8007 18.1577 31.2246 18.3333 31.6667 18.3333C32.1087 18.3333 32.5326 18.1577 32.8452 17.8452C33.1577 17.5326 33.3333 17.1087 33.3333 16.6666C33.3307 14.0153 32.2763 11.4733 30.4015 9.5985C28.5267 7.72371 25.9847 6.66929 23.3333 6.66664C22.8913 6.66664 22.4674 6.84224 22.1548 7.1548C21.8423 7.46736 21.6667 7.89128 21.6667 8.33331C21.6667 8.77534 21.8423 9.19926 22.1548 9.51182C22.4674 9.82438 22.8913 9.99998 23.3333 9.99998ZM38.4883 27.8983C39.4542 28.8668 39.9966 30.1788 39.9966 31.5466C39.9966 32.9145 39.4542 34.2265 38.4883 35.195L36.9717 36.9433C23.3217 50.0116 -9.895 16.8033 2.97166 3.10998L4.88833 1.44331C5.85794 0.504438 7.15822 -0.0149421 8.50784 -0.00246586C9.85746 0.0100104 11.1479 0.55334 12.1 1.50998C12.1517 1.56164 15.24 5.57331 15.24 5.57331C16.1564 6.53602 16.6665 7.81486 16.6643 9.14398C16.6622 10.4731 16.1479 11.7503 15.2283 12.71L13.2983 15.1366C14.3664 17.7318 15.9368 20.0904 17.9192 22.0768C19.9016 24.0632 22.257 25.6383 24.85 26.7116L27.2917 24.77C28.2515 23.8512 29.5284 23.3375 30.8572 23.3356C32.1859 23.3337 33.4642 23.8439 34.4267 24.76C34.4267 24.76 38.4367 27.8466 38.4883 27.8983ZM36.195 30.3216C36.195 30.3216 32.2067 27.2533 32.155 27.2016C31.8116 26.8612 31.3477 26.6702 30.8642 26.6702C30.3806 26.6702 29.9167 26.8612 29.5733 27.2016C29.5283 27.2483 26.1667 29.9266 26.1667 29.9266C25.9401 30.107 25.6705 30.2252 25.3844 30.2696C25.0983 30.314 24.8055 30.2831 24.535 30.18C21.1758 28.9293 18.1246 26.9712 15.5881 24.4384C13.0516 21.9057 11.089 18.8574 9.83333 15.5C9.72199 15.2257 9.6857 14.9268 9.72817 14.6339C9.77064 14.341 9.89035 14.0646 10.075 13.8333C10.075 13.8333 12.7533 10.47 12.7983 10.4266C13.1388 10.0833 13.3298 9.61934 13.3298 9.13581C13.3298 8.65228 13.1388 8.18833 12.7983 7.84498C12.7467 7.79498 9.67833 3.80331 9.67833 3.80331C9.32983 3.49082 8.875 3.32347 8.40708 3.33555C7.93915 3.34764 7.49357 3.53825 7.16166 3.86831L5.245 5.53498C-4.15834 16.8416 24.6267 44.03 34.535 34.6666L36.0533 32.9166C36.4091 32.5871 36.6228 32.1321 36.6493 31.6478C36.6757 31.1635 36.5128 30.688 36.195 30.3216Z", fill: "currentColor" })
  }
), LO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M31.6667 0H8.33333C6.12401 0.00264643 4.00593 0.88147 2.4437 2.4437C0.88147 4.00593 0.00264643 6.12401 0 8.33333L0 28.3333C0.00264643 30.5427 0.88147 32.6607 2.4437 34.223C4.00593 35.7852 6.12401 36.664 8.33333 36.6667H31.6667C33.876 36.664 35.9941 35.7852 37.5563 34.223C39.1185 32.6607 39.9974 30.5427 40 28.3333V8.33333C39.9974 6.12401 39.1185 4.00593 37.5563 2.4437C35.9941 0.88147 33.876 0.00264643 31.6667 0ZM8.33333 3.33333H31.6667C32.6646 3.3353 33.6392 3.63586 34.4649 4.19634C35.2906 4.75682 35.9298 5.55158 36.3 6.47833L23.5367 19.2433C22.5974 20.1789 21.3257 20.7041 20 20.7041C18.6743 20.7041 17.4026 20.1789 16.4633 19.2433L3.7 6.47833C4.07025 5.55158 4.70936 4.75682 5.53508 4.19634C6.3608 3.63586 7.33536 3.3353 8.33333 3.33333ZM31.6667 33.3333H8.33333C7.00725 33.3333 5.73548 32.8066 4.7978 31.8689C3.86012 30.9312 3.33333 29.6594 3.33333 28.3333V10.8333L14.1067 21.6C15.671 23.1604 17.7904 24.0367 20 24.0367C22.2096 24.0367 24.329 23.1604 25.8933 21.6L36.6667 10.8333V28.3333C36.6667 29.6594 36.1399 30.9312 35.2022 31.8689C34.2645 32.8066 32.9927 33.3333 31.6667 33.3333Z", fill: "currentColor" })
  }
), kO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M34.1737 5.81333C30.4124 2.06667 25.4118 0.00166667 20.0846 0C9.10697 0 0.172493 8.89 0.167469 19.82C0.165794 23.3133 1.08353 26.7233 2.82688 29.73L0 40L10.5573 37.2433C13.4662 38.8233 16.7419 39.655 20.0745 39.6567H20.0829C31.0588 39.6567 39.995 30.765 40 19.835C40.0033 14.54 37.9334 9.55833 34.1737 5.81333ZM20.0846 36.3083H20.0779C17.107 36.3083 14.1947 35.5133 11.6525 34.0117L11.0479 33.655L4.78292 35.29L6.45593 29.21L6.06238 28.5867C4.40444 25.9633 3.53025 22.9317 3.53192 19.82C3.53527 10.7367 10.9625 3.34667 20.0929 3.34667C24.5141 3.34667 28.6707 5.06333 31.7957 8.17667C34.9207 11.2917 36.6406 15.43 36.6389 19.8317C36.6339 28.9183 29.2083 36.3083 20.0846 36.3083ZM29.1647 23.97C28.6674 23.7217 26.2206 22.5233 25.7634 22.3583C25.3079 22.1933 24.9763 22.11 24.6431 22.605C24.3098 23.1 23.3586 24.2167 23.0672 24.5483C22.7775 24.8783 22.4861 24.92 21.9887 24.6717C21.4913 24.4233 19.887 23.9017 17.9862 22.2133C16.5074 20.9 15.5076 19.2783 15.2179 18.7817C14.9282 18.285 15.1878 18.0183 15.4356 17.7717C15.66 17.55 15.933 17.1933 16.1825 16.9033C16.4337 16.6167 16.5158 16.41 16.6833 16.0783C16.8491 15.7483 16.767 15.4583 16.6414 15.21C16.5158 14.9633 15.521 12.525 15.1074 11.5333C14.7038 10.5667 14.2935 10.6983 13.987 10.6833C13.6973 10.6683 13.3657 10.6667 13.0324 10.6667C12.7009 10.6667 12.1616 10.79 11.7061 11.2867C11.2506 11.7833 9.96441 12.9817 9.96441 15.4183C9.96441 17.8567 11.748 20.2117 11.9958 20.5417C12.2437 20.8717 15.5043 25.875 20.4965 28.02C21.6839 28.53 22.6117 28.835 23.3335 29.0633C24.5259 29.44 25.6111 29.3867 26.4685 29.26C27.4247 29.1183 29.4126 28.0617 29.8279 26.905C30.2432 25.7483 30.2432 24.755 30.1176 24.55C29.9937 24.3417 29.6621 24.2183 29.1647 23.97Z", fill: "currentColor" })
  }
), RO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M31.6667 4H20.7867C20.53 4 20.27 3.94 20.0417 3.825L14.7867 1.19834C14.095 0.851669 13.3217 0.668336 12.5467 0.668336H8.33333C3.73833 0.666669 0 4.405 0 9V29C0 33.595 3.73833 37.3333 8.33333 37.3333H13.3333C14.2533 37.3333 15 36.5883 15 35.6667C15 34.745 14.2533 34 13.3333 34H8.33333C5.57667 34 3.33333 31.7567 3.33333 29V14H36.6667V29C36.6667 31.7567 34.4233 34 31.6667 34H26.6667C25.7467 34 25 34.745 25 35.6667C25 36.5883 25.7467 37.3333 26.6667 37.3333H31.6667C36.2617 37.3333 40 33.595 40 29V12.3333C40 7.73834 36.2617 4 31.6667 4ZM3.33333 9C3.33333 6.24333 5.57667 4 8.33333 4H12.5467C12.8033 4 13.06 4.06 13.2917 4.17667L18.5517 6.805C19.2433 7.15 20.015 7.33167 20.7867 7.33167H31.6667C33.8367 7.33167 35.67 8.73 36.36 10.665H3.33333V9ZM23.8217 25.4933L21.6667 23.3383V35.6667C21.6667 36.5883 20.92 37.3333 20 37.3333C19.08 37.3333 18.3333 36.5883 18.3333 35.6667V23.3383L16.1783 25.4933C15.8533 25.8183 15.4267 25.9817 15 25.9817C14.5733 25.9817 14.1467 25.8183 13.8217 25.4933C13.17 24.8417 13.17 23.7883 13.8217 23.1367L16.51 20.4483C18.3733 18.5833 21.625 18.5833 23.49 20.4483L26.1783 23.1367C26.83 23.7883 26.83 24.8417 26.1783 25.4933C25.5267 26.145 24.4733 26.145 23.8217 25.4933Z", fill: "currentColor" })
  }
), BO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M32.2017 5.43333L28.2333 1.465C27.29 0.52 26.0333 0 24.6983 0H17C12.9767 0 9.60834 2.86833 8.835 6.66667H8.66667C4.07167 6.66667 0.333336 10.405 0.333336 15V31.6667C0.333336 36.2617 4.07167 40 8.66667 40H18.6667C23.2617 40 27 36.2617 27 31.6667V31.4983C30.7983 30.7233 33.6667 27.3567 33.6667 23.3333V8.96833C33.6667 7.63333 33.1467 6.37667 32.2017 5.43333ZM18.6667 36.6667H8.66667C5.91 36.6667 3.66667 34.4233 3.66667 31.6667V15C3.66667 12.2433 5.91 10 8.66667 10V23.3333C8.66667 27.9283 12.405 31.6667 17 31.6667H23.6667C23.6667 34.4233 21.4233 36.6667 18.6667 36.6667ZM25.3333 28.3333H17C14.2433 28.3333 12 26.09 12 23.3333V8.33333C12 5.57667 14.2433 3.33333 17 3.33333H23.6667V6.66667C23.6667 8.50833 25.1583 10 27 10H30.3333V23.3333C30.3333 26.09 28.09 28.3333 25.3333 28.3333ZM27 18.3333C27 19.2533 26.2533 20 25.3333 20H22.8333V22.5C22.8333 23.42 22.0867 24.1667 21.1667 24.1667C20.2467 24.1667 19.5 23.42 19.5 22.5V20H17C16.08 20 15.3333 19.2533 15.3333 18.3333C15.3333 17.4133 16.08 16.6667 17 16.6667H19.5V14.1667C19.5 13.2467 20.2467 12.5 21.1667 12.5C22.0867 12.5 22.8333 13.2467 22.8333 14.1667V16.6667H25.3333C26.2533 16.6667 27 17.4133 27 18.3333Z", fill: "currentColor" })
  }
), VO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { id: "Vector", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M23.71 20.3C23.52 20.11 23.27 20.01 23 20.01C22.73 20.01 22.48 20.12 22.29 20.3C22.1 20.48 22 20.74 22 21.01C22 21.28 21.63 21.69 21 21.89V23.28C21 23.52 20.95 23.75 20.86 23.96C22.62 23.72 24 22.47 24 21.01C24 20.74 23.89 20.49 23.71 20.3Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M15 23.28V21.99C14.92 21.99 14.83 22.01 14.75 22.01C13.66 22.01 13 21.32 13 21.01V11.39L14.99 12.04C15.83 11.4 16.87 11 18 11C18.71 11 19.39 11.15 20 11.42V9C20 7.94 19.58 6.92 18.83 6.17C18.08 5.42 17.06 5 16 5V4C16 2.94 15.58 1.92 14.83 1.17C14.08 0.42 13.06 0 12 0C10.94 0 9.92 0.42 9.17 1.17C8.42 1.92 8 2.94 8 4V5C6.94 5 5.92 5.42 5.17 6.17C4.42 6.92 4 7.94 4 9V11.57C3.32 11.8 2.75 12.27 2.39 12.89C2.03 13.51 1.9 14.24 2.03 14.94C2.47 17.27 3.58 19.42 5.22 21.12C5.27 21.18 5.31 21.24 5.35 21.31C5.15 21.54 4.91 21.72 4.63 21.83C4.35 21.95 4.05 22 3.75 21.99C2.66 21.99 2 21.3 2 20.99C2 20.72 1.89 20.47 1.71 20.28C1.52 20.09 1.27 19.99 1 19.99C0.73 19.99 0.48 20.1 0.29 20.28C0.1 20.47 0 20.72 0 20.99C0 22.62 1.72 23.99 3.75 23.99C4.76 23.99 5.74 23.64 6.51 22.99C7.28 23.63 8.25 23.99 9.25 23.99C10.25 23.99 11.22 23.65 12 23.01C12.78 23.65 13.75 23.99 14.75 23.99C14.88 23.99 15.01 23.97 15.15 23.95C15.06 23.74 15 23.5 15 23.26V23.28ZM10 4.01C10 3.48 10.21 2.97 10.59 2.6C10.97 2.22 11.47 2.01 12 2.01C12.53 2.01 13.04 2.22 13.41 2.6C13.79 2.98 14 3.48 14 4.01V5.01H10V4.01ZM11 21.01C11 21.35 10.32 22.01 9.25 22.01C8.92 22.03 8.58 21.96 8.28 21.81C7.98 21.66 7.72 21.44 7.54 21.16C7.33 20.66 7.05 20.2 6.69 19.79C5.31 18.36 4.38 16.57 4 14.62C3.95 14.38 4 14.13 4.12 13.92C4.24 13.71 4.44 13.55 4.67 13.47L11.01 11.4V21.02L11 21.01ZM11.06 9.27L6 10.92V9.01C6 8.48 6.21 7.97 6.59 7.6C6.97 7.22 7.47 7.01 8 7.01H16C16.53 7.01 17.04 7.22 17.41 7.6C17.79 7.98 18 8.48 18 9.01V10.93L12.95 9.27C12.34 9.07 11.67 9.07 11.06 9.27Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M18 12.01C15.79 12.01 14 13.8 14 16.01C14 17.49 14.81 18.78 16 19.47V23.28C16 23.92 16.78 24.24 17.23 23.79L18 23.02L18.77 23.79C19.22 24.24 20 23.92 20 23.28V19.47C21.19 18.78 22 17.48 22 16.01C22 13.8 20.21 12.01 18 12.01ZM18 18.01C16.9 18.01 16 17.11 16 16.01C16 14.91 16.9 14.01 18 14.01C19.1 14.01 20 14.91 20 16.01C20 17.11 19.1 18.01 18 18.01Z", fill: "currentColor" })
    ] })
  }
), HO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M19.5 0H12.5C10.019 0 8 2.019 8 4.5V15.5C8 17.43 9.57 19 11.5 19H19.5C21.981 19 24 16.981 24 14.5V4.5C24 2.019 21.981 0 19.5 0ZM12.5 2H19.5C20.878 2 22 3.121 22 4.5V12H11.5C10.964 12 10.455 12.122 10 12.338V4.5C10 3.121 11.122 2 12.5 2ZM19.5 17H11.5C10.673 17 10 16.327 10 15.5C10 14.673 10.673 14 11.5 14H22V14.5C22 15.879 20.878 17 19.5 17ZM14.663 21.3C15.05 21.695 15.044 22.327 14.649 22.714C13.803 23.543 12.685 24 11.5 24H3.5C1.57 24 0 22.43 0 20.5V9.5C0 7.019 2.019 5 4.5 5H5C5.552 5 6 5.447 6 6C6 6.553 5.552 7 5 7H4.5C3.122 7 2 8.121 2 9.5V17.338C2.455 17.121 2.964 17 3.5 17H5C5.552 17 6 17.447 6 18C6 18.553 5.552 19 5 19H3.5C2.673 19 2 19.673 2 20.5C2 21.327 2.673 22 3.5 22H11.5C12.158 22 12.78 21.746 13.249 21.286C13.644 20.898 14.276 20.906 14.663 21.3Z",
        fill: "currentColor"
      }
    )
  }
), FO = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M22.61 16.1623C21.46 15.7473 20.019 15.2563 18.385 14.7613L21.462 3.22227C21.664 2.46527 21.506 1.67527 21.029 1.05427C20.551 0.434271 19.83 0.0772705 19.047 0.0772705H18.749C17.34 0.0772705 15.994 0.75027 15.149 1.87827L9.298 9.67827C8.124 11.2433 6.342 12.0773 5.506 12.0773H1C0.447 12.0773 0 12.5243 0 13.0773C0 13.6303 0.447 14.0773 1 14.0773H3.008C9.909 14.0773 17.826 16.5613 21.932 18.0433C21.961 18.0543 22.001 18.0683 22 18.1393C22 18.2103 21.96 18.2243 21.931 18.2343C17.827 19.6703 9.91 22.0783 3.008 22.0783H1C0.447 22.0783 0 22.5253 0 23.0783C0 23.6313 0.447 24.0783 1 24.0783H3.008C10.204 24.0783 18.366 21.5993 22.591 20.1223C23.444 19.8243 23.996 19.0503 24 18.1493C24.004 17.2483 23.459 16.4683 22.61 16.1633V16.1623ZM10.899 10.8773L16.75 3.07727C17.22 2.45127 17.968 2.07727 18.75 2.07727H19.048C19.262 2.07727 19.388 2.19927 19.444 2.27227C19.5 2.34527 19.586 2.49927 19.531 2.70627L16.465 14.2043C14.219 13.5823 11.72 12.9983 9.173 12.6003C9.796 12.1313 10.392 11.5563 10.9 10.8783L10.899 10.8773ZM8 19.0773C7.447 19.0773 7 18.6303 7 18.0773C7 17.5243 7.447 17.0773 8 17.0773H13C13.553 17.0773 14 17.5243 14 18.0773C14 18.6303 13.553 19.0773 13 19.0773H8Z",
    fill: "currentColor"
  }
) }), WO = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M21 24.0773C19.346 24.0773 18 22.7313 18 21.0773V13.0773C18 12.5263 17.552 12.0773 17 12.0773H7C6.448 12.0773 6 12.5263 6 13.0773V21.0773C6 22.7313 4.654 24.0773 3 24.0773C1.346 24.0773 0 22.7313 0 21.0773V9.80125C0 8.13625 0.824 6.58725 2.203 5.65625L9.203 0.932254C10.902 -0.213746 13.098 -0.213746 14.797 0.932254L21.797 5.65625C23.176 6.58725 24 8.13625 24 9.80125V21.0773C24 22.7313 22.654 24.0773 21 24.0773ZM7 10.0773H17C18.654 10.0773 20 11.4233 20 13.0773V21.0773C20 21.6283 20.448 22.0773 21 22.0773C21.552 22.0773 22 21.6283 22 21.0773V9.80125C22 8.80225 21.506 7.87225 20.678 7.31425L13.678 2.59025C12.658 1.90225 11.342 1.90225 10.323 2.59025L3.322 7.31425C2.494 7.87225 2 8.80225 2 9.80125V21.0773C2 21.6283 2.448 22.0773 3 22.0773C3.552 22.0773 4 21.6283 4 21.0773V13.0773C4 11.4233 5.346 10.0773 7 10.0773ZM11 23.0773V21.0773C11 20.5253 10.553 20.0773 10 20.0773H9C8.447 20.0773 8 20.5253 8 21.0773V23.0773C8 23.6293 8.447 24.0773 9 24.0773H10C10.553 24.0773 11 23.6293 11 23.0773ZM11 17.0773V15.0773C11 14.5253 10.553 14.0773 10 14.0773H9C8.447 14.0773 8 14.5253 8 15.0773V17.0773C8 17.6293 8.447 18.0773 9 18.0773H10C10.553 18.0773 11 17.6293 11 17.0773ZM16 23.0773V21.0773C16 20.5253 15.553 20.0773 15 20.0773H14C13.447 20.0773 13 20.5253 13 21.0773V23.0773C13 23.6293 13.447 24.0773 14 24.0773H15C15.553 24.0773 16 23.6293 16 23.0773Z",
    fill: "currentColor"
  }
) }), zO = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 14 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M1 5.00513H11L7.71 1.71513C7.61627 1.62216 7.54188 1.51156 7.49111 1.3897C7.44034 1.26784 7.4142 1.13714 7.4142 1.00513C7.4142 0.873114 7.44034 0.742408 7.49111 0.620549C7.54188 0.49869 7.61627 0.388089 7.71 0.295126C7.89736 0.108875 8.15081 0.0043335 8.415 0.0043335C8.67919 0.0043335 8.93264 0.108875 9.12 0.295126L13.41 4.59513C13.7856 4.96848 13.9978 5.47555 14 6.00513C13.9951 6.53123 13.7832 7.03423 13.41 7.40513L9.12 11.7051C9.02676 11.7977 8.9162 11.871 8.79463 11.9209C8.67306 11.9707 8.54286 11.9961 8.41146 11.9957C8.28007 11.9952 8.15005 11.9689 8.02884 11.9182C7.90762 11.8675 7.79758 11.7934 7.705 11.7001C7.61242 11.6069 7.53911 11.4963 7.48925 11.3748C7.4394 11.2532 7.41398 11.123 7.41444 10.9916C7.41491 10.8602 7.44125 10.7302 7.49196 10.609C7.54267 10.4877 7.61676 10.3777 7.71 10.2851L11 7.00513H1C0.734783 7.00513 0.480429 6.89977 0.292892 6.71223C0.105356 6.5247 0 6.27034 0 6.00513C0 5.73991 0.105356 5.48556 0.292892 5.29802C0.480429 5.11048 0.734783 5.00513 1 5.00513Z",
    fill: "currentColor"
  }
) }), UO = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 20 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M17.949 5.536L14.465 2.05C13.142 0.728 11.384 0 9.515 0H5C2.243 0 0 2.243 0 5V19C0 21.757 2.243 24 5 24H15C17.757 24 20 21.757 20 19V10.485C20 8.614 19.271 6.858 17.949 5.536ZM16.535 6.951C16.853 7.268 17.122 7.621 17.34 8.001H12.999C12.447 8.001 11.999 7.552 11.999 7.001V2.659C12.379 2.877 12.732 3.146 13.05 3.464L16.535 6.951ZM18 19.001C18 20.655 16.654 22.001 15 22.001H5C3.346 22.001 2 20.655 2 19.001V5C2 3.346 3.346 2 5 2H9.515C9.678 2 9.84 2.008 10 2.023V7C10 8.654 11.346 10 13 10H17.977C17.992 10.16 18 10.322 18 10.485V19.001ZM13.707 16.106C14.098 16.496 14.098 17.129 13.707 17.52L12.094 19.134C11.517 19.711 10.758 20 10 20C9.242 20 8.483 19.711 7.906 19.134L6.293 17.52C5.902 17.129 5.902 16.496 6.293 16.106C6.684 15.715 7.316 15.715 7.707 16.106L9 17.399V13.001C9 12.449 9.447 12.001 10 12.001C10.553 12.001 11 12.449 11 13.001V17.399L12.293 16.106C12.684 15.715 13.316 15.715 13.707 16.106Z",
    fill: "currentColor"
  }
) }), ZO = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 25 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M18.86 5.14152C18.528 5.07552 18.257 4.86852 18.118 4.57252C16.566 1.30152 12.975 -0.527481 9.38301 0.134519C6.11101 0.734519 3.54601 3.34652 2.99901 6.63552C2.83701 7.60652 2.84901 8.57852 3.03201 9.52552C3.09201 9.83452 2.95901 10.1785 2.68601 10.4265C1.54101 11.4675 0.88501 12.9505 0.88501 14.4965C0.88501 17.5285 3.35201 19.9965 6.38501 19.9965H17.385C21.521 19.9965 24.885 16.6325 24.885 12.4965C24.885 8.93152 22.351 5.83852 18.859 5.14252L18.86 5.14152ZM17.386 17.9955H6.38601C4.45601 17.9955 2.88601 16.4255 2.88601 14.4955C2.88601 13.5125 3.30401 12.5675 4.03201 11.9055C4.81801 11.1905 5.18701 10.1325 4.99501 9.14252C4.85701 8.43052 4.84901 7.69752 4.97101 6.96152C5.37401 4.53952 7.33601 2.54052 9.74201 2.09952C10.127 2.02952 10.51 1.99552 10.887 1.99552C13.199 1.99552 15.293 3.28452 16.309 5.42952C16.723 6.30152 17.509 6.91052 18.467 7.10252C21.026 7.61352 22.884 9.88052 22.884 12.4965C22.884 15.5285 20.417 17.9965 17.384 17.9965L17.386 17.9955ZM16.007 11.2885C16.398 11.6795 16.398 12.3115 16.007 12.7025L13.3 15.4095C12.913 15.7965 12.404 15.9915 11.895 15.9935L11.886 15.9955L11.877 15.9935C11.368 15.9915 10.859 15.7965 10.472 15.4095L7.76501 12.7025C7.37401 12.3115 7.37401 11.6795 7.76501 11.2885C8.15601 10.8975 8.78801 10.8975 9.17901 11.2885L10.886 12.9955V7.99552C10.886 7.44252 11.334 6.99552 11.886 6.99552C12.438 6.99552 12.886 7.44252 12.886 7.99552V12.9955L14.593 11.2885C14.984 10.8975 15.616 10.8975 16.007 11.2885Z",
    fill: "currentColor"
  }
) }), qO = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M16.885 8C16.6975 7.81253 16.4432 7.70721 16.178 7.70721C15.9128 7.70721 15.6585 7.81253 15.471 8L12.885 10.586L10.299 8C10.1104 7.81784 9.85781 7.71705 9.59561 7.71933C9.33341 7.7216 9.0826 7.82677 8.89719 8.01218C8.71178 8.19759 8.60661 8.4484 8.60434 8.7106C8.60206 8.9728 8.70285 9.2254 8.88501 9.414L11.471 12L8.88501 14.586C8.70285 14.7746 8.60206 15.0272 8.60434 15.2894C8.60661 15.5516 8.71178 15.8024 8.89719 15.9878C9.0826 16.1732 9.33341 16.2784 9.59561 16.2807C9.85781 16.283 10.1104 16.1822 10.299 16L12.885 13.414L15.471 16C15.6596 16.1822 15.9122 16.283 16.1744 16.2807C16.4366 16.2784 16.6874 16.1732 16.8728 15.9878C17.0582 15.8024 17.1634 15.5516 17.1657 15.2894C17.168 15.0272 17.0672 14.7746 16.885 14.586L14.299 12L16.885 9.414C17.0725 9.22647 17.1778 8.97216 17.1778 8.707C17.1778 8.44184 17.0725 8.18753 16.885 8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M12.885 0C10.5116 0 8.19156 0.703788 6.21817 2.02236C4.24478 3.34094 2.70671 5.21509 1.79846 7.4078C0.890209 9.60051 0.652569 12.0133 1.11559 14.3411C1.57861 16.6689 2.7215 18.8071 4.39973 20.4853C6.07796 22.1635 8.21616 23.3064 10.5439 23.7694C12.8717 24.2324 15.2845 23.9948 17.4772 23.0866C19.6699 22.1783 21.5441 20.6402 22.8626 18.6668C24.1812 16.6935 24.885 14.3734 24.885 12C24.8816 8.81846 23.6162 5.76821 21.3665 3.51852C19.1168 1.26883 16.0666 0.00344108 12.885 0ZM12.885 22C10.9072 22 8.9738 21.4135 7.32931 20.3147C5.68482 19.2159 4.4031 17.6541 3.64622 15.8268C2.88934 13.9996 2.69131 11.9889 3.07716 10.0491C3.46301 8.10929 4.41542 6.32746 5.81395 4.92893C7.21247 3.53041 8.9943 2.578 10.9341 2.19215C12.8739 1.8063 14.8846 2.00433 16.7119 2.7612C18.5391 3.51808 20.1009 4.79981 21.1997 6.4443C22.2985 8.08879 22.885 10.0222 22.885 12C22.8821 14.6513 21.8276 17.1931 19.9529 19.0679C18.0781 20.9426 15.5363 21.9971 12.885 22Z",
      fill: "currentColor"
    }
  )
] }), GO = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 25 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M4.88501 14V21C4.88501 21.552 4.43701 22 3.88501 22C3.33301 22 2.88501 21.552 2.88501 21V14C2.88501 13.448 3.33301 13 3.88501 13C4.43701 13 4.88501 13.448 4.88501 14ZM18.885 13C18.333 13 17.885 13.448 17.885 14V21C17.885 21.552 18.333 22 18.885 22C19.437 22 19.885 21.552 19.885 21V14C19.885 13.448 19.437 13 18.885 13ZM10.885 13C10.333 13 9.88501 13.448 9.88501 14V21C9.88501 21.552 10.333 22 10.885 22C11.437 22 11.885 21.552 11.885 21V14C11.885 13.448 11.437 13 10.885 13ZM7.38501 13C6.55601 13 5.88501 13.671 5.88501 14.5V20.5C5.88501 21.329 6.55601 22 7.38501 22C8.21401 22 8.88501 21.329 8.88501 20.5V14.5C8.88501 13.671 8.21401 13 7.38501 13ZM15.385 13C14.556 13 13.885 13.671 13.885 14.5V20.5C13.885 21.329 14.556 22 15.385 22C16.214 22 16.885 21.329 16.885 20.5V14.5C16.885 13.671 16.214 13 15.385 13ZM21.885 13C21.333 13 20.885 13.448 20.885 14V21C20.885 21.552 21.333 22 21.885 22C22.437 22 22.885 21.552 22.885 21V14C22.885 13.448 22.437 13 21.885 13ZM23.885 9H22.885V1C22.885 0.448 22.437 0 21.885 0C21.333 0 20.885 0.448 20.885 1V9H19.885V1C19.885 0.448 19.437 0 18.885 0C18.333 0 17.885 0.448 17.885 1V9H16.885V1.5C16.885 0.671 16.214 0 15.385 0C14.556 0 13.885 0.671 13.885 1.5V9H11.885V1C11.885 0.448 11.437 0 10.885 0C10.333 0 9.88501 0.448 9.88501 1V9H8.88501V1.5C8.88501 0.671 8.21401 0 7.38501 0C6.55601 0 5.88501 0.671 5.88501 1.5V9H4.88501V1C4.88501 0.448 4.43701 0 3.88501 0C3.33301 0 2.88501 0.448 2.88501 1V9H1.88501C1.33301 9 0.88501 9.448 0.88501 10C0.88501 10.552 1.33301 11 1.88501 11H23.885C24.437 11 24.885 10.552 24.885 10C24.885 9.448 24.437 9 23.885 9Z",
    fill: "currentColor"
  }
) }), YO = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M18.885 19C19.0828 19 19.2761 18.9413 19.4405 18.8314C19.6049 18.7215 19.733 18.5654 19.8087 18.3827C19.8844 18.2 19.9042 17.9989 19.8656 17.805C19.827 17.611 19.7318 17.4328 19.592 17.293L13.42 11.122C12.4824 10.1846 11.2108 9.65807 9.88501 9.65807C8.55919 9.65807 7.28765 10.1846 6.35001 11.122L4.17801 13.293C3.99585 13.4816 3.89506 13.7342 3.89734 13.9964C3.89961 14.2586 4.00478 14.5094 4.19019 14.6948C4.3756 14.8802 4.62641 14.9854 4.88861 14.9877C5.15081 14.99 5.40341 14.8892 5.59201 14.707L7.76401 12.536C8.33523 11.9901 9.09491 11.6855 9.88501 11.6855C10.6751 11.6855 11.4348 11.9901 12.006 12.536L18.178 18.707C18.3655 18.8946 18.6198 18.9999 18.885 19Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M16.885 10.5C17.5772 10.5 18.2539 10.2947 18.8295 9.91014C19.4051 9.52556 19.8537 8.97893 20.1186 8.33939C20.3835 7.69985 20.4528 6.99612 20.3178 6.31718C20.1827 5.63825 19.8494 5.01461 19.3599 4.52513C18.8704 4.03564 18.2468 3.7023 17.5678 3.56725C16.8889 3.4322 16.1852 3.50151 15.5456 3.76642C14.9061 4.03133 14.3595 4.47993 13.9749 5.0555C13.5903 5.63108 13.385 6.30777 13.385 7C13.385 7.92826 13.7538 8.8185 14.4101 9.47487C15.0665 10.1313 15.9568 10.5 16.885 10.5ZM16.885 5.5C17.1817 5.5 17.4717 5.58797 17.7184 5.7528C17.965 5.91762 18.1573 6.15189 18.2708 6.42597C18.3844 6.70006 18.4141 7.00166 18.3562 7.29264C18.2983 7.58361 18.1554 7.85088 17.9457 8.06066C17.7359 8.27044 17.4686 8.4133 17.1776 8.47118C16.8867 8.52906 16.5851 8.49935 16.311 8.38582C16.0369 8.27229 15.8026 8.08003 15.6378 7.83335C15.473 7.58668 15.385 7.29667 15.385 7C15.385 6.60218 15.543 6.22064 15.8243 5.93934C16.1057 5.65804 16.4872 5.5 16.885 5.5Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M23.885 16C23.6198 16 23.3654 16.1054 23.1779 16.2929C22.9904 16.4804 22.885 16.7348 22.885 17V19C22.885 19.7957 22.5689 20.5587 22.0063 21.1213C21.4437 21.6839 20.6807 22 19.885 22H17.885C17.6198 22 17.3654 22.1054 17.1779 22.2929C16.9904 22.4804 16.885 22.7348 16.885 23C16.885 23.2652 16.9904 23.5196 17.1779 23.7071C17.3654 23.8946 17.6198 24 17.885 24H19.885C21.2106 23.9984 22.4815 23.4711 23.4188 22.5338C24.3561 21.5964 24.8834 20.3256 24.885 19V17C24.885 16.7348 24.7797 16.4804 24.5921 16.2929C24.4046 16.1054 24.1502 16 23.885 16Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M1.88501 8C2.15023 8 2.40458 7.89464 2.59212 7.70711C2.77965 7.51957 2.88501 7.26522 2.88501 7V5C2.88501 4.20435 3.20108 3.44129 3.76369 2.87868C4.3263 2.31607 5.08936 2 5.88501 2H7.88501C8.15023 2 8.40458 1.89464 8.59212 1.70711C8.77965 1.51957 8.88501 1.26522 8.88501 1C8.88501 0.734784 8.77965 0.48043 8.59212 0.292893C8.40458 0.105357 8.15023 0 7.88501 0H5.88501C4.55941 0.00158786 3.28857 0.528882 2.35123 1.46622C1.41389 2.40356 0.886598 3.67441 0.88501 5V7C0.88501 7.26522 0.990367 7.51957 1.1779 7.70711C1.36544 7.89464 1.61979 8 1.88501 8Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M7.88501 22H5.88501C5.08936 22 4.3263 21.6839 3.76369 21.1213C3.20108 20.5587 2.88501 19.7957 2.88501 19V17C2.88501 16.7348 2.77965 16.4804 2.59212 16.2929C2.40458 16.1054 2.15023 16 1.88501 16C1.61979 16 1.36544 16.1054 1.1779 16.2929C0.990367 16.4804 0.88501 16.7348 0.88501 17V19C0.886598 20.3256 1.41389 21.5964 2.35123 22.5338C3.28857 23.4711 4.55941 23.9984 5.88501 24H7.88501C8.15023 24 8.40458 23.8946 8.59212 23.7071C8.77965 23.5196 8.88501 23.2652 8.88501 23C8.88501 22.7348 8.77965 22.4804 8.59212 22.2929C8.40458 22.1054 8.15023 22 7.88501 22Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M19.885 0H17.885C17.6198 0 17.3654 0.105357 17.1779 0.292893C16.9904 0.48043 16.885 0.734784 16.885 1C16.885 1.26522 16.9904 1.51957 17.1779 1.70711C17.3654 1.89464 17.6198 2 17.885 2H19.885C20.6807 2 21.4437 2.31607 22.0063 2.87868C22.5689 3.44129 22.885 4.20435 22.885 5V7C22.885 7.26522 22.9904 7.51957 23.1779 7.70711C23.3654 7.89464 23.6198 8 23.885 8C24.1502 8 24.4046 7.89464 24.5921 7.70711C24.7797 7.51957 24.885 7.26522 24.885 7V5C24.8834 3.67441 24.3561 2.40356 23.4188 1.46622C22.4815 0.528882 21.2106 0.00158786 19.885 0Z", fill: "currentColor" })
] }), KO = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M24.3294 22.7398L21.8994 15.5698C21.5834 14.6528 20.7924 14.0608 19.8814 14.0608C18.9704 14.0608 18.1794 14.6538 17.8634 15.5738L15.4344 22.7398C15.2574 23.2628 15.5374 23.8308 16.0604 24.0088C16.5844 24.1868 17.1504 23.9048 17.3284 23.3828L17.7974 21.9998H21.9654L22.4344 23.3828C22.5764 23.7988 22.9644 24.0618 23.3814 24.0618C23.4874 24.0618 23.5964 24.0448 23.7024 24.0088C24.2254 23.8308 24.5064 23.2638 24.3284 22.7398H24.3294ZM18.4754 19.9998L19.7564 16.2208C19.8314 15.9998 19.9334 16.0038 20.0064 16.2168L21.2884 19.9998H18.4754ZM16.5404 9.55077C16.0344 8.59677 15.0504 8.00377 13.9714 8.00377L10.1384 8.00077L11.3434 2.77377C11.6524 1.69577 11.2044 0.601772 10.2794 0.173772C9.3994 -0.233228 8.4144 0.087772 7.8064 0.999772L1.3874 11.4608C0.781404 12.3548 0.719404 13.5028 1.2244 14.4568C1.7294 15.4108 2.7144 16.0038 3.7944 16.0038H7.6244L6.4204 21.2298C6.1114 22.3088 6.5594 23.4018 7.4844 23.8298C7.7374 23.9468 7.9994 24.0038 8.2574 24.0038C8.8994 24.0038 9.5244 23.6538 9.9564 23.0038L16.3764 12.5468C16.9824 11.6528 17.0444 10.5048 16.5394 9.55177L16.5404 9.55077ZM14.6974 11.4608L8.3334 21.8258C8.3384 21.7968 9.8554 15.2278 9.8554 15.2278C9.9234 14.9308 9.8534 14.6198 9.6634 14.3798C9.4734 14.1418 9.1854 14.0028 8.8804 14.0028H3.7944C3.3004 14.0028 3.0684 13.6648 2.9914 13.5198C2.9144 13.3738 2.7644 12.9918 3.0664 12.5448L9.4304 2.17677C9.4254 2.20577 7.9084 8.77577 7.9084 8.77577C7.8404 9.07277 7.9104 9.38377 8.1004 9.62277C8.2904 9.86177 8.5784 10.0008 8.8824 10.0008L13.9704 10.0048C14.4644 10.0048 14.6964 10.3428 14.7734 10.4878C14.8504 10.6328 14.9994 11.0138 14.6974 11.4608Z",
    fill: "currentColor"
  }
) }), XO = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M12.3361 2.00028C13.6626 2.00463 14.9751 2.27201 16.1976 2.78696C17.4201 3.30191 18.5283 4.05419 19.4581 5.00028H16.3361C16.0709 5.00028 15.8166 5.10563 15.629 5.29317C15.4415 5.48071 15.3361 5.73506 15.3361 6.00028C15.3361 6.26549 15.4415 6.51985 15.629 6.70738C15.8166 6.89492 16.0709 7.00028 16.3361 7.00028H20.4791C20.9716 7.00001 21.4437 6.80428 21.7919 6.45608C22.1401 6.10788 22.3359 5.6357 22.3361 5.14328V1.00028C22.3361 0.735059 22.2308 0.480706 22.0432 0.293169C21.8557 0.105633 21.6014 0.000275954 21.3361 0.000275954C21.0709 0.000275954 20.8166 0.105633 20.629 0.293169C20.4415 0.480706 20.3361 0.735059 20.3361 1.00028V3.07828C18.6833 1.58973 16.6487 0.590686 14.4602 0.193025C12.2717 -0.204636 10.0158 0.0147879 7.94493 0.826723C5.87408 1.63866 4.07016 3.01105 2.73515 4.7902C1.40015 6.56935 0.586782 8.68502 0.38614 10.9003C0.373223 11.0395 0.389456 11.18 0.433803 11.3126C0.47815 11.4452 0.54964 11.5672 0.643716 11.6707C0.737793 11.7741 0.852394 11.8569 0.980218 11.9136C1.10804 11.9704 1.24629 11.9999 1.38614 12.0003C1.63073 12.0034 1.86767 11.9151 2.0506 11.7527C2.23352 11.5903 2.34925 11.3655 2.37514 11.1223C2.59775 8.63302 3.74311 6.31698 5.58622 4.62911C7.42933 2.94125 9.83696 2.00357 12.3361 2.00028Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M23.2869 12.0003C23.0423 11.9972 22.8054 12.0855 22.6225 12.2479C22.4396 12.4103 22.3238 12.6351 22.2979 12.8783C22.1326 14.7816 21.4249 16.5974 20.2586 18.1105C19.0923 19.6236 17.5165 20.7704 15.7181 21.4149C13.9197 22.0593 11.9741 22.1744 10.1123 21.7464C8.25044 21.3184 6.55043 20.3654 5.21394 19.0003H8.33594C8.60115 19.0003 8.85551 18.895 9.04305 18.7074C9.23058 18.5199 9.33594 18.2655 9.33594 18.0003C9.33594 17.7351 9.23058 17.4808 9.04305 17.2932C8.85551 17.1057 8.60115 17.0003 8.33594 17.0003H4.19294C3.94904 17.0002 3.7075 17.0481 3.48214 17.1414C3.25678 17.2347 3.05201 17.3715 2.87955 17.5439C2.70708 17.7164 2.5703 17.9212 2.47703 18.1465C2.38375 18.3719 2.33581 18.6134 2.33594 18.8573V23.0003C2.33594 23.2655 2.44129 23.5199 2.62883 23.7074C2.81637 23.895 3.07072 24.0003 3.33594 24.0003C3.60115 24.0003 3.85551 23.895 4.04304 23.7074C4.23058 23.5199 4.33594 23.2655 4.33594 23.0003V20.9223C5.98877 22.4109 8.02335 23.4099 10.2118 23.8076C12.4003 24.2052 14.6563 23.9858 16.7272 23.1739C18.798 22.3619 20.6019 20.9896 21.9369 19.2104C23.2719 17.4312 24.0853 15.3156 24.2859 13.1003C24.2989 12.9611 24.2826 12.8206 24.2383 12.688C24.1939 12.5554 24.1224 12.4334 24.0284 12.3299C23.9343 12.2265 23.8197 12.1437 23.6919 12.087C23.564 12.0302 23.4268 12.0007 23.2869 12.0003Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M12.3359 11.167C11.4151 11.167 10.6693 11.9128 10.6693 12.8336C10.6693 13.7545 11.4151 14.5003 12.3359 14.5003C13.2568 14.5003 14.0026 13.7545 14.0026 12.8336C14.0026 11.9128 13.2568 11.167 12.3359 11.167ZM14.8359 17.0003H9.83594C8.4576 17.0003 7.33594 15.8786 7.33594 14.5003V11.167C7.33594 9.80114 8.43677 8.68864 9.79677 8.6678L10.3768 7.76531C10.6834 7.28697 11.2076 7.00031 11.7784 7.00031H12.8934C13.4643 7.00031 13.9876 7.28697 14.2959 7.76614L14.8751 8.6678C16.2359 8.68864 17.3359 9.80114 17.3359 11.167V14.5003C17.3359 15.8786 16.2143 17.0003 14.8359 17.0003ZM15.6693 11.167C15.6693 10.707 15.2959 10.3336 14.8359 10.3336H9.83594C9.37594 10.3336 9.0026 10.707 9.0026 11.167V14.5003C9.0026 14.9603 9.37594 15.3336 9.83594 15.3336H14.8359C15.2959 15.3336 15.6693 14.9603 15.6693 14.5003V11.167Z", fill: "currentColor" })
] }), QO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M33.1018 6.06516C29.5133 2.47661 24.7418 0.5 19.667 0.5C14.5922 0.5 9.8207 2.47661 6.23215 6.06516C2.6436 9.65371 0.666992 14.4252 0.666992 19.5C0.666992 22.492 1.34323 25.3563 2.67527 28.0122C3.94602 30.5445 5.80619 32.801 8.0535 34.5386C8.16484 34.6244 8.29764 34.6663 8.42839 34.6663C8.61124 34.6663 8.79307 34.5846 8.91361 34.4283C9.12097 34.1606 9.07194 33.7755 8.80328 33.5682C4.57425 30.2983 2.0828 25.4206 1.90404 20.1129H17.4493C17.718 21.0854 18.6108 21.8015 19.668 21.8015C20.7253 21.8015 21.617 21.0854 21.8857 20.1129H37.43C37.2553 25.2664 34.8803 30.0501 30.8504 33.3159C30.5879 33.5294 30.547 33.9155 30.7605 34.178C30.974 34.4405 31.3591 34.4814 31.6227 34.2679C36.0999 30.6395 38.668 25.2562 38.668 19.5C38.668 14.4252 36.6914 9.65371 33.1029 6.06516H33.1018ZM37.4289 18.8871H30.9526C30.8658 17.2752 30.4408 15.7521 29.7462 14.3884L35.3532 11.1512C36.5933 13.4721 37.3339 16.0994 37.4289 18.8871ZM34.7383 10.0899L29.1302 13.3281C28.2722 12.0165 27.1495 10.8938 25.8379 10.0358L29.0761 4.42769C31.3653 5.86188 33.3051 7.80172 34.7393 10.0899H34.7383ZM14.5544 9.42081L11.3172 3.81376C13.6381 2.57366 16.2654 1.83306 19.0531 1.73806V8.21339C17.4411 8.30022 15.9181 8.72618 14.5544 9.42081ZM20.2799 1.73704C23.0676 1.83204 25.6949 2.57263 28.0158 3.81274L24.7776 9.42081C23.4139 8.72618 21.8908 8.30022 20.2789 8.21339V1.73704H20.2799ZM10.2569 4.42769L13.494 10.0358C12.1824 10.8938 11.0598 12.0165 10.2017 13.3281L4.59366 10.0899C6.02785 7.80172 7.96769 5.86188 10.2559 4.42769H10.2569ZM9.5878 14.3884C8.89318 15.7521 8.46721 17.2762 8.3814 18.8871H1.90404C1.99904 16.0994 2.73963 13.4721 3.97973 11.1512L9.58678 14.3884H9.5878ZM17.4493 18.8871H9.60925C9.92694 13.6151 14.3163 9.42285 19.668 9.42285C25.0197 9.42285 29.4081 13.6151 29.7258 18.8871H21.8857C21.8346 18.7022 21.7611 18.5275 21.6691 18.3651L24.1831 15.8512C24.4221 15.6122 24.4221 15.224 24.1831 14.9849C23.944 14.7459 23.5559 14.7459 23.3168 14.9849L20.8029 17.4989C20.4679 17.3078 20.0807 17.1985 19.669 17.1985C18.6118 17.1985 17.72 17.9146 17.4503 18.8871H17.4493ZM19.668 20.5756C19.0745 20.5756 18.5924 20.0925 18.5924 19.5C18.5924 18.9075 19.0745 18.4244 19.668 18.4244C20.2615 18.4244 20.7437 18.9065 20.7437 19.5C20.7437 20.0935 20.2615 20.5756 19.668 20.5756ZM18.4963 28.5475H15.7618C15.4237 28.5475 15.1489 28.8212 15.1489 29.1604V37.8871C15.1489 38.2252 15.4237 38.5 15.7618 38.5H18.4963C18.8345 38.5 19.1092 38.2252 19.1092 37.8871V29.1604C19.1092 28.8212 18.8345 28.5475 18.4963 28.5475ZM17.8834 37.2742H16.3747V29.7733H17.8834V37.2742ZM23.5732 29.6865H20.8397C20.5005 29.6865 20.2268 29.9612 20.2268 30.2994V37.8871C20.2268 38.2252 20.5005 38.5 20.8397 38.5H23.5732C23.9113 38.5 24.1861 38.2252 24.1861 37.8871V30.2994C24.1861 29.9612 23.9113 29.6865 23.5732 29.6865ZM22.9603 37.2742H21.4526V30.9123H22.9603V37.2742ZM28.6501 24.961H25.9155C25.5774 24.961 25.3026 25.2358 25.3026 25.5739V37.8871C25.3026 38.2252 25.5774 38.5 25.9155 38.5H28.6501C28.9893 38.5 29.263 38.2252 29.263 37.8871V25.5739C29.263 25.2358 28.9893 24.961 28.6501 24.961ZM28.0372 37.2742H26.5284V26.1868H28.0372V37.2742ZM13.4195 31.9327H10.6849C10.3468 31.9327 10.072 32.2075 10.072 32.5456V37.8871C10.072 38.2252 10.3468 38.5 10.6849 38.5H13.4195C13.7586 38.5 14.0324 38.2252 14.0324 37.8871V32.5456C14.0324 32.2075 13.7586 31.9327 13.4195 31.9327ZM12.8066 37.2742H11.2978V33.1585H12.8066V37.2742ZM22.0216 25.7608L25.652 22.0997C25.3261 22.111 25.0483 21.8689 25.0197 21.542C24.9901 21.2049 25.2393 20.9066 25.5764 20.878L27.2292 20.733C27.412 20.7166 27.5929 20.784 27.7216 20.9158C27.8493 21.0476 27.9126 21.2294 27.8922 21.4123L27.7083 23.061C27.6736 23.3746 27.408 23.6054 27.1005 23.6054C27.078 23.6054 27.0545 23.6044 27.031 23.6013C26.7205 23.5666 26.4906 23.3041 26.4866 22.9997L22.6273 26.8926C22.4649 27.0571 22.2228 27.1153 22.0032 27.0438L17.2501 25.5024L12.4296 29.2554C12.3173 29.3422 12.1855 29.3851 12.0537 29.3851C11.8709 29.3851 11.6901 29.3044 11.5695 29.1491C11.3622 28.8815 11.4091 28.4964 11.6768 28.289L16.7537 24.3358C16.914 24.2112 17.1255 24.1734 17.3196 24.2367L22.0226 25.7628L22.0216 25.7608Z",
        fill: "currentColor"
      }
    )
  }
), JO = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_2383_69933)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M30.0156 7.9375C27.8143 7.9375 26.0312 9.72051 26.0312 11.9219V13.25H21.2294C22.8298 10.5134 23.6406 8.46078 23.6406 7.14062C23.6406 3.47898 20.6616 0.5 17 0.5C13.3384 0.5 10.3594 3.47898 10.3594 7.14062C10.3594 8.46078 11.1702 10.5134 12.7706 13.25H7.96875V11.9219C7.96875 9.72449 6.18176 7.9375 3.98438 7.9375C1.78699 7.9375 0 9.72051 0 11.9219V15.6406C0 16.0072 0.2975 16.3047 0.664062 16.3047C1.03062 16.3047 1.32812 16.0072 1.32812 15.6406V11.9219C1.32812 10.455 2.5168 9.26562 3.98438 9.26562C5.45195 9.26562 6.64062 10.4576 6.64062 11.9219V27.5486C5.93539 26.9164 5.00371 26.5312 3.98438 26.5312C2.96504 26.5312 2.03336 26.9171 1.32812 27.5493V20.9531C1.32812 20.5866 1.03062 20.2891 0.664062 20.2891C0.2975 20.2891 0 20.5866 0 20.9531V30.5156C0 32.794 1.96695 34.5 4.17363 34.5H30.0156C32.213 34.5 34 32.713 34 30.5156V11.9219C34 9.72449 32.213 7.9375 30.0156 7.9375ZM27.3594 11.9219C27.3594 10.455 28.548 9.26562 30.0156 9.26562C31.4832 9.26562 32.6719 10.4576 32.6719 11.9219V27.53C32.215 27.1236 31.6658 26.8208 31.0662 26.6667C29.7354 26.3227 28.3661 26.6468 27.3594 27.5453V11.9219ZM26.0312 21.2188H17.5312C15.306 19.0997 11.0553 15.0516 10.5586 14.5781H13.5754C15.0251 16.8944 16.4535 18.8075 16.4681 18.8275C16.5936 18.9948 16.7908 19.0938 17 19.0938C17.2092 19.0938 17.4064 18.9955 17.5319 18.8275C17.5465 18.8075 18.9749 16.8937 20.4246 14.5781H26.0312V21.2188ZM17 1.82812C19.9292 1.82812 22.3125 4.21145 22.3125 7.14062C22.3125 9.60629 18.4231 15.3079 17 17.3001C15.5543 15.2761 11.6875 9.58371 11.6875 7.14062C11.6875 4.21145 14.0708 1.82812 17 1.82812ZM1.32812 30.5156C1.32812 29.0514 2.51945 27.8594 3.98438 27.8594C5.4493 27.8594 6.64062 29.0514 6.64062 30.5156C6.64062 30.8822 6.93813 31.1797 7.30469 31.1797C7.67125 31.1797 7.96875 30.8822 7.96875 30.5156V19.4477L14.709 25.8672L7.03906 33.1719H4.17363C2.68414 33.1719 1.32812 32.0589 1.32812 30.5156ZM16.1294 26.348C16.2609 26.2225 16.3359 26.0485 16.3359 25.8672C16.3359 25.6859 16.2616 25.5113 16.1294 25.3864L7.96875 17.6142V14.5781H8.63281C8.67797 14.6213 16.4913 22.0628 16.8074 22.3636C16.9309 22.4811 17.095 22.5469 17.265 22.5469H26.0306V25.2031H20.9837C20.8077 25.2031 20.6384 25.2729 20.5142 25.3977L12.7394 33.1719H8.96418L16.1287 26.348H16.1294ZM30.0156 33.1719H14.6187L21.2593 26.5312H26.0312V30.5156C26.0312 30.8822 26.3288 31.1797 26.6953 31.1797C27.0619 31.1797 27.3594 30.8822 27.3594 30.5156C27.3594 28.7984 28.9677 27.4961 30.7341 27.9523C31.8126 28.2312 32.6719 29.2267 32.6719 30.5156C32.6719 31.9805 31.4799 33.1719 30.0156 33.1719Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M17 10.4609C18.8308 10.4609 20.3203 8.97145 20.3203 7.14062C20.3203 5.3098 18.8308 3.82031 17 3.82031C15.1692 3.82031 13.6797 5.3098 13.6797 7.14062C13.6797 8.97145 15.1692 10.4609 17 10.4609ZM17 5.14844C18.0984 5.14844 18.9922 6.04227 18.9922 7.14062C18.9922 8.23898 18.0984 9.13281 17 9.13281C15.9016 9.13281 15.0078 8.23898 15.0078 7.14062C15.0078 6.04227 15.9016 5.14844 17 5.14844Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M0.664062 18.9609C1.03062 18.9609 1.32812 18.6634 1.32812 18.2969C1.32812 17.9303 1.03062 17.6328 0.664062 17.6328C0.2975 17.6328 0 17.9303 0 18.2969C0 18.6634 0.2975 18.9609 0.664062 18.9609Z", fill: "currentColor" })
    ] })
  }
), eS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 40 41", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_106_18)", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M13.75 24.3719C13.94 26.8166 15.825 28.7205 19.205 28.946V30.75H20.705V28.9332C24.205 28.6821 26.25 26.7653 26.25 23.9824C26.25 21.4533 24.685 20.1489 21.8875 19.4724L20.705 19.1854V14.2731C22.205 14.4474 23.16 15.2879 23.39 16.4513H26.02C25.83 14.0963 23.86 12.2539 20.705 12.054V10.25H19.205V12.0924C16.2175 12.3922 14.18 14.2347 14.18 16.8408C14.18 19.147 15.695 20.6128 18.2125 21.2149L19.205 21.4661V26.6782C17.6675 26.4399 16.65 25.5763 16.42 24.3719H13.75ZM19.1925 18.8216C17.7175 18.4705 16.9175 17.7556 16.9175 16.6793C16.9175 15.4749 17.78 14.5729 19.205 14.309V18.819L19.1925 18.8216ZM20.9225 21.8786C22.715 22.304 23.5425 22.9933 23.5425 24.2105C23.5425 25.5994 22.5125 26.5526 20.705 26.7269V21.8274L20.9225 21.8786Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M20 38.4375C15.3587 38.4375 10.9075 36.5477 7.62563 33.1837C4.34374 29.8198 2.5 25.2573 2.5 20.5C2.5 15.7427 4.34374 11.1802 7.62563 7.81627C10.9075 4.45234 15.3587 2.5625 20 2.5625C24.6413 2.5625 29.0925 4.45234 32.3744 7.81627C35.6563 11.1802 37.5 15.7427 37.5 20.5C37.5 25.2573 35.6563 29.8198 32.3744 33.1837C29.0925 36.5477 24.6413 38.4375 20 38.4375ZM20 41C25.3043 41 30.3914 38.8402 34.1421 34.9957C37.8929 31.1512 40 25.9369 40 20.5C40 15.0631 37.8929 9.84881 34.1421 6.00431C30.3914 2.15982 25.3043 0 20 0C14.6957 0 9.60859 2.15982 5.85786 6.00431C2.10714 9.84881 0 15.0631 0 20.5C0 25.9369 2.10714 31.1512 5.85786 34.9957C9.60859 38.8402 14.6957 41 20 41Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M20 34.5938C16.3533 34.5938 12.8559 33.1089 10.2773 30.4658C7.69866 27.8227 6.25 24.2379 6.25 20.5C6.25 16.7621 7.69866 13.1773 10.2773 10.5342C12.8559 7.89112 16.3533 6.40625 20 6.40625C23.6467 6.40625 27.1441 7.89112 29.7227 10.5342C32.3013 13.1773 33.75 16.7621 33.75 20.5C33.75 24.2379 32.3013 27.8227 29.7227 30.4658C27.1441 33.1089 23.6467 34.5938 20 34.5938ZM20 35.875C21.9698 35.875 23.9204 35.4773 25.7403 34.7046C27.5601 33.932 29.2137 32.7995 30.6066 31.3718C31.9995 29.9441 33.1044 28.2491 33.8582 26.3838C34.612 24.5184 35 22.5191 35 20.5C35 18.4809 34.612 16.4816 33.8582 14.6162C33.1044 12.7509 31.9995 11.0559 30.6066 9.62823C29.2137 8.20053 27.5601 7.06802 25.7403 6.29535C23.9204 5.52269 21.9698 5.125 20 5.125C16.0218 5.125 12.2064 6.74486 9.3934 9.62823C6.58035 12.5116 5 16.4223 5 20.5C5 24.5777 6.58035 28.4884 9.3934 31.3718C12.2064 34.2551 16.0218 35.875 20 35.875Z", fill: "currentColor" })
] }) }), tS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M39.6339 0.366153C39.9874 0.719731 40.0963 1.25 39.9106 1.71427L32.9106 19.2143C32.6542 19.8553 31.9267 20.167 31.2857 19.9106C30.6448 19.6542 30.333 18.9268 30.5894 18.2858L35.3277 6.44013L16.5929 25.1749L20.0318 30.5789C20.4025 31.1614 20.2308 31.934 19.6484 32.3046C19.0659 32.6752 18.2933 32.5036 17.9227 31.9211L14.0945 25.9055L1.6077 17.9593C0.318659 17.139 0.499343 15.204 1.91798 14.6365L38.2857 0.0894406C38.75 -0.0962678 39.2803 0.0125747 39.6339 0.366153ZM14.8251 23.4071L33.5599 4.67237L3.97869 16.5048L14.8251 23.4071Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M31.25 40C36.0825 40 40 36.0825 40 31.25C40 26.4175 36.0825 22.5 31.25 22.5C26.4175 22.5 22.5 26.4175 22.5 31.25C22.5 36.0825 26.4175 40 31.25 40ZM32.1339 26.6161C31.893 26.3752 31.5642 26.2431 31.2236 26.2503C30.8829 26.2575 30.56 26.4034 30.3295 26.6543L27.4584 29.7793C26.9914 30.2877 27.0248 31.0784 27.5332 31.5455C28.0416 32.0126 28.8323 31.9791 29.2994 31.4707L30 30.7081V35C30 35.6904 30.5596 36.25 31.25 36.25C31.9404 36.25 32.5 35.6904 32.5 35V30.5178L33.4911 31.5089C33.9793 31.997 34.7707 31.997 35.2589 31.5089C35.747 31.0207 35.747 30.2293 35.2589 29.7411L32.1339 26.6161Z", fill: "currentColor" })
] }), rS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("path", { d: "M7.78684 24.0628C5.97659 24.0616 4.22784 23.4057 2.86329 22.2162C1.49874 21.0267 0.610474 19.3837 0.362401 17.5906C0.114327 15.7974 0.523189 13.975 1.51354 12.4597C2.50389 10.9443 4.00889 9.83835 5.75084 9.34576C7.01696 8.98319 8.35713 8.96661 9.63184 9.29776L17.5398 1.39176C17.9596 0.969046 18.4592 0.633898 19.0096 0.405759C19.5599 0.177621 20.1501 0.0610343 20.7458 0.0627631C21.6834 0.0635575 22.5823 0.436354 23.2453 1.09931C23.9082 1.76227 24.281 2.6612 24.2818 3.59876C24.2834 4.19455 24.1668 4.78474 23.9389 5.3352C23.7109 5.88567 23.3761 6.38549 22.9538 6.80576L22.2818 7.47776C21.9058 7.8512 21.3978 8.06139 20.8678 8.06276H19.2818V9.06276C19.2818 9.5932 19.0711 10.1019 18.6961 10.477C18.321 10.852 17.8123 11.0628 17.2818 11.0628H16.2818V12.6488C16.2825 12.9115 16.2311 13.1718 16.1305 13.4145C16.0299 13.6572 15.8822 13.8776 15.6958 14.0628L15.0458 14.7128C15.3788 15.9869 15.3626 17.3271 14.9988 18.5928C14.5896 20.0348 13.7591 21.3218 12.614 22.289C11.4688 23.2562 10.061 23.8595 8.57084 24.0218C8.31038 24.0488 8.0487 24.0625 7.78684 24.0628ZM7.78684 11.0628C6.76299 11.0618 5.75918 11.3466 4.88842 11.8851C4.01767 12.4237 3.31452 13.1946 2.85814 14.1111C2.40176 15.0277 2.21027 16.0534 2.30521 17.0728C2.40016 18.0922 2.77778 19.0649 3.39556 19.8814C4.01334 20.6979 4.84676 21.3257 5.80199 21.6942C6.75723 22.0627 7.79637 22.1572 8.80243 21.9672C9.80848 21.7771 10.7415 21.31 11.4965 20.6185C12.2515 19.9269 12.7985 19.0383 13.0758 18.0528C13.3878 16.9693 13.3529 15.8153 12.9758 14.7528C12.9143 14.5753 12.904 14.3841 12.9461 14.2011C12.9882 14.018 13.081 13.8505 13.2138 13.7178L14.2818 12.6488V11.0628C14.2818 10.5323 14.4926 10.0236 14.8676 9.64855C15.2427 9.27348 15.7514 9.06276 16.2818 9.06276H17.2818V8.06276C17.2818 7.53233 17.4926 7.02362 17.8676 6.64855C18.2427 6.27348 18.7514 6.06276 19.2818 6.06276H20.8678L21.5398 5.39076C21.7758 5.15592 21.9629 4.87663 22.0902 4.56904C22.2176 4.26145 22.2827 3.93167 22.2818 3.59876C22.2816 3.19164 22.1198 2.80126 21.832 2.51329C21.5442 2.22532 21.154 2.06329 20.7468 2.06276C20.4137 2.06194 20.0837 2.12719 19.7759 2.25472C19.4682 2.38226 19.1888 2.56955 18.9538 2.80576L10.6228 11.1358C10.4899 11.2686 10.3222 11.3614 10.1389 11.4033C9.95569 11.4452 9.76434 11.4346 9.58684 11.3728C9.00691 11.1686 8.39666 11.0638 7.78184 11.0628H7.78684ZM5.28184 18.0628C5.28184 18.2605 5.34049 18.4539 5.45037 18.6183C5.56025 18.7828 5.71643 18.911 5.89915 18.9866C6.08188 19.0623 6.28295 19.0821 6.47693 19.0435C6.67091 19.005 6.84909 18.9097 6.98894 18.7699C7.1288 18.63 7.22404 18.4518 7.26262 18.2579C7.30121 18.0639 7.2814 17.8628 7.20572 17.6801C7.13003 17.4974 7.00186 17.3412 6.83741 17.2313C6.67296 17.1214 6.47962 17.0628 6.28184 17.0628C6.01662 17.0628 5.76227 17.1681 5.57473 17.3557C5.3872 17.5432 5.28184 17.7975 5.28184 18.0628Z", fill: "currentColor" }) }), nS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 25 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M16.1462 0.0727539H9.82088C4.94887 0.0727539 0.984497 4.02038 0.984497 8.87182C0.984497 13.7233 4.94887 17.6709 9.82088 17.6709H10.8279C11.4486 17.6709 11.9531 17.1686 11.9531 16.5505V8.94091C11.9531 8.32281 11.4486 7.82049 10.8279 7.82049H7.07545C6.45473 7.82049 5.95027 8.32281 5.95027 8.94091C5.95027 9.55901 6.45473 10.0613 7.07545 10.0613H9.70273V15.43C6.12467 15.3665 3.23485 12.4497 3.23485 8.87182C3.23485 5.29393 6.19031 2.3136 9.82088 2.3136H16.1462C19.7787 2.3136 22.7323 5.25658 22.7323 8.87182C22.7323 12.4871 19.8424 15.3647 16.2663 15.43V10.0613H18.8935C19.5143 10.0613 20.0187 9.55901 20.0187 8.94091C20.0187 8.32281 19.5143 7.82049 18.8935 7.82049H15.1411C14.5204 7.82049 14.0159 8.32281 14.0159 8.94091V16.5505C14.0159 17.1686 14.5204 17.6709 15.1411 17.6709H16.1444C21.0164 17.6709 24.9807 13.7233 24.9807 8.87182C24.9807 4.02038 21.0201 0.0727539 16.1462 0.0727539Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M10.8279 7.82236H7.07545C6.45473 7.82236 5.95027 8.32468 5.95027 8.94278C5.95027 9.56088 6.45473 10.0632 7.07545 10.0632H9.70273V12.6383C10.4266 12.8437 11.1786 12.9838 11.9531 13.0491V8.94091C11.9531 8.32281 11.4486 7.82049 10.8279 7.82049V7.82236Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M18.8954 7.82236H15.143C14.5222 7.82236 14.0178 8.32468 14.0178 8.94278V13.0529C14.7904 12.9875 15.5424 12.8512 16.2681 12.6476V10.0632H18.8954C19.5161 10.0632 20.0206 9.56088 20.0206 8.94278C20.0206 8.32468 19.5161 7.82236 18.8954 7.82236Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M16.1462 0.0727539H9.82088C6.21844 0.0727539 3.11295 2.23331 1.74024 5.32008C2.1228 6.33966 2.64226 7.29389 3.27611 8.15848C3.63429 4.87564 6.4341 2.3136 9.82275 2.3136H16.1481C19.5518 2.3136 22.3591 4.89618 22.7004 8.1977C23.338 7.3331 23.8612 6.37888 24.2475 5.35742C22.8804 2.25011 19.7656 0.0727539 16.1462 0.0727539Z", fill: "currentColor" })
] }), aS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("path", { d: "M12.9835 24.0728C11.3665 24.0728 9.84748 23.3648 8.80748 22.1528C7.22048 22.2768 5.64148 21.7018 4.49748 20.5578C3.35348 19.4128 2.78048 17.8388 2.90248 16.2478C1.69048 15.2088 0.982483 13.6898 0.982483 12.0728C0.982483 10.4558 1.69048 8.93675 2.90248 7.89775C2.78048 6.30675 3.35348 4.73175 4.49748 3.58775C5.64148 2.44475 7.22048 1.87575 8.80748 1.99275C9.84748 0.780754 11.3665 0.0727539 12.9835 0.0727539C14.6005 0.0727539 16.1195 0.780754 17.1595 1.99275C18.7465 1.87375 20.3265 2.44475 21.4695 3.58775C22.6135 4.73275 23.1865 6.30675 23.0645 7.89775C24.2765 8.93675 24.9845 10.4558 24.9845 12.0728C24.9845 13.6898 24.2765 15.2088 23.0645 16.2478C23.1865 17.8388 22.6135 19.4138 21.4695 20.5578C20.3265 21.7018 18.7475 22.2768 17.1595 22.1528C16.1195 23.3648 14.6005 24.0728 12.9835 24.0728ZM9.70948 19.9778L10.0795 20.5268C10.7325 21.4948 11.8185 22.0728 12.9835 22.0728C14.1485 22.0728 15.2345 21.4948 15.8875 20.5268L16.2575 19.9778L16.9065 20.1038C18.0545 20.3268 19.2295 19.9678 20.0535 19.1438C20.8775 18.3188 21.2365 17.1428 21.0135 15.9978L20.8865 15.3478L21.4365 14.9778C22.4045 14.3248 22.9825 13.2388 22.9825 12.0738C22.9825 10.9088 22.4045 9.82275 21.4365 9.16975L20.8865 8.79975L21.0135 8.14975C21.2365 7.00475 20.8775 5.82775 20.0535 5.00375C19.2295 4.17975 18.0535 3.82175 16.9065 4.04375L16.2575 4.16975L15.8875 3.62075C15.2345 2.65275 14.1485 2.07475 12.9835 2.07475C11.8185 2.07475 10.7325 2.65275 10.0795 3.62075L9.70948 4.16975L9.06048 4.04375C7.91348 3.82375 6.73748 4.17975 5.91348 5.00375C5.08948 5.82875 4.73048 7.00475 4.95348 8.14975L5.08048 8.79975L4.53048 9.16975C3.56248 9.82275 2.98448 10.9088 2.98448 12.0738C2.98448 13.2388 3.56248 14.3248 4.53048 14.9778L5.08048 15.3478L4.95348 15.9978C4.73048 17.1428 5.08948 18.3198 5.91348 19.1438C6.73748 19.9668 7.91148 20.3258 9.06048 20.1038L9.70948 19.9778ZM12.8935 15.4928L18.6865 9.78575L17.2825 8.36075L11.4735 14.0618L8.68048 11.3548L7.28748 12.7918L10.0695 15.4878C10.4605 15.8788 10.9725 16.0728 11.4855 16.0728C11.9985 16.0728 12.5075 15.8798 12.8935 15.4928Z", fill: "currentColor" }) }), iS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("g", { "clip-path": "url(#clip0_135_74)", children: /* @__PURE__ */ f.jsx("path", { d: "M22.853 1.22522C22.1732 0.546421 21.2517 0.165161 20.291 0.165161C19.3303 0.165161 18.4089 0.546421 17.729 1.22522L1.46502 17.4892C0.999266 17.9524 0.629977 18.5032 0.378513 19.11C0.127049 19.7168 -0.00159798 20.3674 1.49812e-05 21.0242V23.0772C1.49812e-05 23.3424 0.105372 23.5968 0.292908 23.7843C0.480445 23.9719 0.734799 24.0772 1.00002 24.0772H3.05301C3.70978 24.0791 4.36038 23.9506 4.96717 23.6993C5.57396 23.448 6.12487 23.0789 6.58801 22.6132L22.853 6.34822C23.5315 5.66842 23.9126 4.74719 23.9126 3.78672C23.9126 2.82626 23.5315 1.90503 22.853 1.22522ZM5.17401 21.1992C4.61002 21.7595 3.84798 22.0749 3.05301 22.0772H2.00002V21.0242C1.999 20.6301 2.07617 20.2397 2.22705 19.8757C2.37793 19.5116 2.59953 19.1811 2.87901 18.9032L15.222 6.56022L17.522 8.86022L5.17401 21.1992ZM21.438 4.93422L18.932 7.44122L16.632 5.14622L19.139 2.63922C19.29 2.48853 19.4693 2.36906 19.6664 2.28763C19.8636 2.20621 20.0749 2.16441 20.2883 2.16465C20.5016 2.16488 20.7128 2.20713 20.9098 2.28899C21.1069 2.37084 21.2858 2.4907 21.4365 2.64172C21.5872 2.79274 21.7067 2.97197 21.7881 3.16916C21.8695 3.36635 21.9113 3.57765 21.9111 3.79099C21.9109 4.00433 21.8686 4.21554 21.7868 4.41256C21.7049 4.60957 21.585 4.78853 21.434 4.93922L21.438 4.93422Z", fill: "currentColor" }) }) }), oS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 41 41", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M2.74817 40.0772H33.0565C38.8752 40.0772 42.676 34.2334 40.0703 29.2671L36.3479 22.1537C27.8843 31.5075 16.1097 38.0421 2.74817 40.0772Z", fill: "#204585" }),
  /* @__PURE__ */ f.jsx("path", { d: "M26.7877 3.95137L25.5338 1.56156C24.4955 -0.417493 21.5371 -0.417493 20.4988 1.56156L5.21725 30.706C15.209 24.3767 22.889 14.9855 26.7877 3.95137Z", fill: "#F15C41" }),
  /* @__PURE__ */ f.jsx("path", { d: "M35.6623 20.8473L27.6885 5.64966C23.2803 17.1506 14.8363 26.8032 4.0021 33.0577L0.906616 38.9762C14.7971 37.2772 27.0811 30.5932 35.6819 20.866L35.6623 20.8473Z", fill: "#2875B4" })
] }), sS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 79 61", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsxs("g", { children: [
  /* @__PURE__ */ f.jsx("path", { d: "M58.1699 46.1411H39.6543V57.0898H58.1699V46.1411Z", fill: "#293939" }),
  /* @__PURE__ */ f.jsx("path", { d: "M25.459 61.0001H2.31445C1.03533 61.0001 0 59.9506 0 58.6539V7.03854C0 5.7419 1.03533 4.69238 2.31445 4.69238H25.459C26.7366 4.69238 27.7734 5.7419 27.7734 7.03854V58.6539C27.7734 59.9506 26.7366 61.0001 25.459 61.0001Z", fill: "#3E5959" }),
  /* @__PURE__ */ f.jsx("path", { d: "M27.7734 7.03854V58.6539C27.7734 59.949 26.7366 61.0001 25.459 61.0001H13.8867V4.69238H25.459C26.7366 4.69238 27.7734 5.74346 27.7734 7.03854Z", fill: "#293939" }),
  /* @__PURE__ */ f.jsx("path", { d: "M27.7734 16.4231H0V25.8077H27.7734V16.4231Z", fill: "#547983" }),
  /* @__PURE__ */ f.jsx("path", { d: "M27.7734 16.4231H13.8867V25.8077H27.7734V16.4231Z", fill: "#3E5959" }),
  /* @__PURE__ */ f.jsx("path", { d: "M16.2012 54.4309C16.2012 55.7275 15.1658 56.777 13.8867 56.777C12.6076 56.777 11.5723 55.7275 11.5723 54.4309C11.5723 53.1342 12.6076 52.0847 13.8867 52.0847C15.1658 52.0847 16.2012 53.1342 16.2012 54.4309Z", fill: "#81E885" }),
  /* @__PURE__ */ f.jsx("mask", { id: "mask0_168_181", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "79", height: "61", children: /* @__PURE__ */ f.jsx("path", { d: "M79 0H0V61H79V0Z", fill: "white" }) }),
  /* @__PURE__ */ f.jsxs("g", { mask: "url(#mask0_168_181)", children: [
    /* @__PURE__ */ f.jsx("path", { d: "M16.2012 54.4309C16.2012 55.7259 15.1643 56.777 13.8867 56.777V52.0847C15.1643 52.0847 16.2012 53.1358 16.2012 54.4309Z", fill: "#5DC983" }),
    /* @__PURE__ */ f.jsx("path", { d: "M74.3711 46.9231H23.4531C20.9011 46.9231 18.8242 44.8178 18.8242 42.2308V4.69231C18.8242 2.10528 20.9011 0 23.4531 0H74.3711C76.9232 0 79 2.10528 79 4.69231V42.2308C79 44.8178 76.9232 46.9231 74.3711 46.9231Z", fill: "#547983" })
  ] }),
  /* @__PURE__ */ f.jsx("path", { d: "M74.3711 4.69238H23.4531V42.2308H74.3711V4.69238Z", fill: "#F3765F" }),
  /* @__PURE__ */ f.jsx("path", { d: "M62.7988 60.9999H35.0254C33.7463 60.9999 32.7109 59.9504 32.7109 58.6538C32.7109 57.3571 33.7463 56.3076 35.0254 56.3076H62.7988C64.0779 56.3076 65.1133 57.3571 65.1133 58.6538C65.1133 59.9504 64.0779 60.9999 62.7988 60.9999Z", fill: "#547983" }),
  /* @__PURE__ */ f.jsx("path", { opacity: "0.15", d: "M54.9991 42.2308H51.3747L31.5984 4.69238H35.2229L54.9991 42.2308Z", fill: "white" }),
  /* @__PURE__ */ f.jsx("path", { opacity: "0.15", d: "M62.7989 42.2308H59.1744L39.3982 4.69238H43.0226L62.7989 42.2308Z", fill: "white" })
] }) }), lS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 42 42", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("path", { d: "M21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0ZM5.3561 11.3562C6.20942 14.844 12.0011 18.0215 15.1108 19.7276C16.3725 20.4198 17.1927 20.8698 17.0625 21C16.8507 21.2119 16.6365 21.4157 16.4266 21.6155C15.3363 22.6534 14.3626 23.5803 14.4375 24.9375C14.5294 26.6027 16.0592 27.0996 17.6248 27.6081C19.1402 28.1004 20.6891 28.6035 21 30.1875C21.2151 31.2833 20.8043 32.7813 20.4218 34.1768C19.8586 36.2308 19.3564 38.0625 21 38.0625C24.9375 36.75 30.9708 29.7003 31.5 24.9375C31.8624 21.6756 26.25 19.6875 22.3125 18.375C21.0578 17.9568 20.3293 18.5878 19.713 19.1217C19.2611 19.5131 18.8695 19.8524 18.375 19.6875C17.2061 19.2979 11.8125 14.4375 14.4375 13.125C16.487 12.1003 16.9363 12.6757 17.6596 13.602C17.8626 13.8621 18.0873 14.1498 18.375 14.4375C19.9723 15.2362 20.1117 14.0909 20.2717 12.7761C20.3746 11.9301 20.4861 11.0139 21 10.5C22.1383 9.36176 24.3201 8.42297 26.3227 7.56133C28.1932 6.75649 29.9073 6.01896 30.4683 5.24905C35.8054 8.46421 39.375 14.3152 39.375 21C39.375 31.1482 31.1482 39.375 21 39.375C10.8518 39.375 2.625 31.1482 2.625 21C2.625 17.463 3.62435 14.1594 5.3561 11.3562Z", fill: "currentColor" }) }), cS = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 54 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx("path", { d: "M46.5542 12.7677L44.7664 13.0693C43.8107 13.2328 42.8286 13.1168 41.9394 12.7338L41.8089 12.6774C40.0076 11.8991 37.9453 11.9857 36.2097 12.9139L29.9367 16.2493L17.5845 15.6324C17.4547 15.6257 17.3246 15.6543 17.2093 15.7156L14.0342 17.4039C13.777 17.5406 13.6281 17.8172 13.6552 18.1056C13.6823 18.3941 13.8819 18.6368 14.1593 18.7218L21.2433 20.8717L13.5902 24.941L4.81596 20.2326C4.60383 20.1196 4.34881 20.12 4.13607 20.2331L1.59598 21.5837C1.39171 21.6923 1.25227 21.8922 1.2201 22.1202C1.18743 22.3499 1.26833 22.5786 1.43546 22.7372L7.29022 28.2921L6.8637 28.5188C6.03499 28.9595 5.5939 29.8917 5.78195 30.8071C5.96951 31.7241 6.7398 32.4042 7.67434 32.4792L8.96799 32.5837L8.61643 36.0588C8.58938 36.3219 8.71 36.5769 8.92936 36.7239C9.14872 36.8709 9.43194 36.8853 9.6664 36.762L10.9364 36.0867C11.074 36.0135 11.1839 35.8983 11.2502 35.7576L14.3128 29.2618C14.445 28.982 14.3826 28.6501 14.1585 28.438C13.9344 28.2259 13.5996 28.1809 13.3265 28.3261L9.51636 30.3519C9.30468 30.4645 9.16175 30.6757 9.13787 30.9142L9.11299 31.1559L7.79455 31.0457C7.49819 31.0194 7.25361 30.802 7.19431 30.5117C7.13445 30.2204 7.27326 29.9249 7.53567 29.7826L36.8833 14.1782C37.6887 13.75 38.5954 13.5478 39.5057 13.5951L39.3437 13.6812C38.4664 14.1477 38.1322 15.2326 38.5969 16.1064C39.0615 16.9802 40.1477 17.3099 41.0251 16.8434L45.6459 14.3864C45.6544 14.3819 45.6606 14.3732 45.6675 14.3682L46.7882 14.1779C47.0934 14.1265 47.3974 14.2745 47.541 14.547L47.5808 14.6218C47.7254 14.8937 47.6796 15.229 47.4657 15.4523L46.3304 16.6414C45.5309 17.4816 44.5996 18.1863 43.5751 18.731L34.0074 23.8183L34.1105 23.6012C34.2427 23.3213 34.1803 22.9895 33.9562 22.7774C33.7321 22.5653 33.3973 22.5202 33.1242 22.6654L26.139 26.3795C25.9612 26.4741 25.83 26.6385 25.7804 26.8338L25.3689 28.4114L21.5419 30.4463C19.7151 31.4176 17.6501 31.8463 15.5909 31.6784L15.0488 31.6341C14.8587 31.6189 14.6705 31.6784 14.5244 31.802C14.3794 31.9251 14.2882 32.1007 14.2722 32.2903C14.2563 32.48 14.3154 32.6676 14.4388 32.8129C14.5622 32.9582 14.7373 33.0476 14.9274 33.0628L15.4695 33.1072C17.8041 33.2977 20.1458 32.8124 22.2154 31.7106L24.8783 30.2947L22.8319 38.1349C22.7596 38.41 22.8575 38.7013 23.0813 38.8771C23.3051 39.0528 23.6111 39.0794 23.8636 38.9465L27.6737 36.9206C27.8113 36.8475 27.9211 36.7323 27.9875 36.5916L32.9897 25.9818L44.2497 19.9948C45.4097 19.378 46.4641 18.578 47.3704 17.627L48.5051 16.4369C49.1468 15.7645 49.2867 14.7612 48.8524 13.9443L48.8126 13.8695C48.3777 13.0542 47.4683 12.6103 46.5558 12.7656L46.5542 12.7677ZM10.5286 31.4362L12.094 30.6039L10.2075 34.6084L10.5286 31.4362ZM8.6285 27.5791L3.14908 22.3803L4.46887 21.6786L12.065 25.7519L8.62956 27.5786L8.6285 27.5791ZM23.0393 19.9168L16.2403 17.8533L17.7072 17.0733L27.4697 17.5611L23.0393 19.9168ZM39.8669 15.4311C39.7739 15.2561 39.8406 15.0395 40.0163 14.9461L41.57 14.12C41.8879 14.243 42.2138 14.3401 42.5466 14.4119L40.3525 15.5785C40.1769 15.6719 39.9599 15.6061 39.8669 15.4311ZM26.7879 35.7705L24.632 36.9168L27.0904 27.4975L31.8912 24.9448L26.7869 35.7711L26.7879 35.7705Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M36.5617 18.406L36.2255 17.7735C36.0399 17.4246 35.6045 17.2925 35.2542 17.4788C34.9038 17.665 34.7699 18.0999 34.9554 18.4488L35.2917 19.0813C35.4772 19.4302 35.9126 19.5623 36.263 19.376C36.6133 19.1898 36.7472 18.7549 36.5617 18.406Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M33.722 20.7256C34.0723 20.5394 34.2062 20.1045 34.0207 19.7556L33.6844 19.1231C33.4989 18.7743 33.0635 18.6421 32.7131 18.8284C32.3628 19.0146 32.2289 19.4496 32.4144 19.7984L32.7507 20.4309C32.9362 20.7798 33.3716 20.9119 33.722 20.7256Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M31.4807 21.1071L31.1444 20.4747C30.9589 20.1258 30.5234 19.9937 30.1731 20.1799C29.8228 20.3662 29.6888 20.8011 29.8744 21.15L30.2106 21.7824C30.3961 22.1313 30.8316 22.2635 31.1819 22.0772C31.5322 21.8909 31.6662 21.456 31.4807 21.1071Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M28.9406 22.4567L28.6044 21.8243C28.4189 21.4754 27.9834 21.3433 27.6331 21.5295C27.2827 21.7158 27.1488 22.1507 27.3343 22.4996L27.6706 23.132C27.8561 23.4809 28.2916 23.6131 28.6419 23.4268C28.9922 23.2406 29.1261 22.8056 28.9406 22.4567Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M26.4006 23.8083L26.0643 23.1759C25.8788 22.827 25.4434 22.6948 25.093 22.8811C24.7427 23.0674 24.6088 23.5023 24.7943 23.8512L25.1305 24.4836C25.3161 24.8325 25.7515 24.9647 26.1018 24.7784C26.4522 24.5921 26.5861 24.1572 26.4006 23.8083Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M23.8606 25.1579L23.5243 24.5255C23.3388 24.1766 22.9033 24.0444 22.553 24.2307C22.2027 24.417 22.0687 24.8519 22.2542 25.2008L22.5905 25.8332C22.776 26.1821 23.2115 26.3143 23.5618 26.128C23.9121 25.9417 24.0461 25.5068 23.8606 25.1579Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M21.3205 26.5095L20.9842 25.8771C20.7987 25.5282 20.3633 25.396 20.013 25.5823C19.6626 25.7685 19.5287 26.2035 19.7142 26.5523L20.0505 27.1848C20.236 27.5337 20.6714 27.6658 21.0218 27.4796C21.3721 27.2933 21.506 26.8584 21.3205 26.5095Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M18.7805 27.8591L18.4442 27.2267C18.2587 26.8778 17.8232 26.7456 17.4729 26.9319C17.1226 27.1182 16.9887 27.5531 17.1742 27.902L17.5104 28.5344C17.6959 28.8833 18.1314 29.0154 18.4817 28.8292C18.832 28.6429 18.966 28.208 18.7805 27.8591Z", fill: "currentColor" })
    ]
  }
), uS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_2676_51189)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M23.3023 19.6547C23.3023 19.6547 27.8473 22.4595 27.8501 22.4609C28.1771 22.6627 28.6165 22.5587 28.8176 22.2317C29.0187 21.9047 28.9161 21.466 28.5891 21.2642C28.5891 21.2642 24.0469 18.4615 24.0413 18.458C23.7143 18.2562 23.2742 18.3624 23.0731 18.6872C22.8713 19.0121 22.9782 19.4551 23.3023 19.6547Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M20.9115 18.1735C21.0198 18.2424 21.1456 18.2832 21.2771 18.2832C21.5232 18.2832 21.7475 18.1588 21.8762 17.9492C22.1504 17.5027 21.8059 16.877 21.2785 16.877C20.8292 16.877 20.491 17.3045 20.5937 17.7411C20.6345 17.9155 20.754 18.0737 20.9115 18.1735Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M8.88406 22.5684C9.01625 22.572 9.14774 22.5417 9.25813 22.4721C9.25813 22.4721 13.7757 19.6231 13.7785 19.6209C14.1034 19.4156 14.2025 18.9769 13.9979 18.6513C13.7996 18.3356 13.3426 18.233 13.0283 18.432C13.0283 18.432 8.51563 21.2775 8.50789 21.2824C8.18305 21.4877 8.0832 21.9265 8.28852 22.252C8.41156 22.4475 8.64922 22.5621 8.88477 22.5684H8.88406Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M15.7823 18.2285C16.1079 18.2285 16.3961 17.9993 16.4679 17.6808C16.5663 17.2448 16.2267 16.8223 15.7809 16.8223C15.4547 16.8223 15.1685 17.0515 15.0961 17.37C14.9976 17.8031 15.3408 18.2285 15.7823 18.2285Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M36.162 32.5251C35.9075 32.2319 35.4631 32.2009 35.1699 32.4562C34.4204 33.108 33.7264 33.7837 32.7428 34.0558C31.6494 34.3581 30.6102 34.1198 29.6202 33.6248L33.2821 21.3046C33.3735 20.998 33.2462 20.669 32.9727 20.503L29.585 18.4499V12.4558C29.585 12.0677 29.27 11.7527 28.8819 11.7527H27.4756V9.64328C27.4756 9.25516 27.1606 8.94016 26.7725 8.94016H24.5577V6.83078C24.5577 6.44266 24.2427 6.12766 23.8545 6.12766H20.4444V1.20508C20.4444 0.816953 20.1294 0.501953 19.7413 0.501953H16.9288C16.5406 0.501953 16.2256 0.816953 16.2256 1.20508V6.12695H12.8155C12.4274 6.12695 12.1124 6.44195 12.1124 6.83008V8.93945H9.89752C9.50939 8.93945 9.19439 9.25445 9.19439 9.64258V11.752H7.78814C7.40002 11.752 7.08502 12.067 7.08502 12.4551V18.4492L3.69736 20.5016C3.42385 20.6676 3.29658 20.9966 3.38799 21.3032C3.38799 21.3032 7.04072 33.5931 7.04213 33.5988C6.97955 33.3892 5.85455 33.2507 5.65557 33.2247C3.60807 32.9596 2.05135 33.9855 0.576894 35.2673C0.283691 35.5218 0.252754 35.9662 0.507285 36.2594C0.750566 36.5392 1.20338 36.5863 1.49939 36.3283C3.01885 35.0078 4.73166 34.0009 6.74189 35.0057C8.56017 35.9148 10.4431 36.3051 12.3374 35.308C13.8646 34.5044 15.3383 33.8097 17.0434 34.6218L18.7963 35.4564C20.296 36.1708 22.0074 36.1539 23.4931 35.4114C24.4086 34.9537 25.3388 34.3448 26.3844 34.273C27.4095 34.2027 28.3995 34.5845 29.3003 35.0345C30.4899 35.6294 31.8828 35.7482 33.1597 35.384C34.336 35.0486 35.1924 34.2991 36.0938 33.5158C36.387 33.2612 36.418 32.8169 36.1635 32.5237L36.162 32.5251ZM28.3208 33.0609C28.3285 32.8436 26.3492 32.845 26.217 32.8591C24.9964 32.9884 23.941 33.6163 22.8638 34.1549C21.5912 34.7912 20.282 34.6084 19.0388 34.0157V13.7031L31.7802 21.4234L28.3215 33.0609H28.3208ZM28.1788 17.5977L20.8522 13.1589H28.1788V17.5977ZM17.6312 1.9082H19.0374V6.12695H17.6312V1.9082ZM13.5179 7.5332H23.1507V8.93945H13.5179V7.5332ZM10.5999 10.3457H26.0687V11.752H10.5999V10.3457ZM8.49057 13.1582H15.8171L8.49057 17.597V13.1582ZM17.6312 13.7031V33.3456C17.6312 33.2205 16.6285 32.9905 16.4978 32.9617C15.2743 32.6966 13.9602 32.8647 12.8506 33.449C12.0456 33.8723 11.2693 34.3666 10.3482 34.4854C10.3468 34.4854 10.3447 34.4854 10.3433 34.4854C9.80541 34.5508 9.25486 34.5114 8.73455 34.3595L4.88916 21.4227L17.6305 13.7024L17.6312 13.7031Z", fill: "currentColor" })
    ] })
  }
), fS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_2383_69953)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M26.8439 29.5664C25.492 29.5664 24.3926 30.6658 24.3926 32.0177C24.3926 33.3695 25.492 34.4689 26.8439 34.4689C28.1958 34.4689 29.2952 33.3695 29.2952 32.0177C29.2952 30.6658 28.1958 29.5664 26.8439 29.5664ZM26.8439 33.384C26.0904 33.384 25.4766 32.7711 25.4766 32.0167C25.4766 31.2622 26.0894 30.6494 26.8439 30.6494C27.5984 30.6494 28.2112 31.2622 28.2112 32.0167C28.2112 32.7711 27.5984 33.384 26.8439 33.384Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M20.7339 23.437C21.0336 23.437 21.2754 23.1942 21.2754 22.8955V5.2251C21.2754 4.92544 21.0326 4.68359 20.7339 4.68359C20.4352 4.68359 20.1924 4.92641 20.1924 5.2251V22.8945C20.1924 23.1942 20.4352 23.436 20.7339 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M23.3628 23.437C23.6615 23.437 23.9053 23.1942 23.9053 22.8955V5.2251C23.9053 4.92544 23.6625 4.68359 23.3628 4.68359C23.0631 4.68359 22.8213 4.92641 22.8213 5.2251V22.8945C22.8213 23.1942 23.0641 23.436 23.3628 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M25.9907 23.437C26.2904 23.437 26.5323 23.1942 26.5323 22.8955V5.2251C26.5323 4.92544 26.2894 4.68359 25.9907 4.68359C25.692 4.68359 25.4492 4.92641 25.4492 5.2251V22.8945C25.4492 23.1942 25.692 23.436 25.9907 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M28.6196 23.437C28.9193 23.437 29.1612 23.1942 29.1612 22.8955V5.2251C29.1612 4.92544 28.9184 4.68359 28.6196 4.68359C28.3209 4.68359 28.0781 4.92641 28.0781 5.2251V22.8945C28.0781 23.1942 28.3209 23.436 28.6196 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M31.2466 23.437C31.5463 23.437 31.7881 23.1942 31.7881 22.8955V5.2251C31.7881 4.92544 31.5453 4.68359 31.2466 4.68359C30.9479 4.68359 30.7051 4.92641 30.7051 5.2251V22.8945C30.7051 23.1942 30.9479 23.436 31.2466 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M33.8745 23.437C34.1742 23.437 34.4161 23.1942 34.4161 22.8955V5.2251C34.4161 4.92544 34.1732 4.68359 33.8745 4.68359C33.5758 4.68359 33.333 4.92641 33.333 5.2251V22.8945C33.333 23.1942 33.5758 23.436 33.8745 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M16.0483 18.9138C15.8884 18.6614 15.553 18.5862 15.3006 18.7462L11.8279 20.9459C11.5754 21.1059 11.5003 21.4412 11.6602 21.6936C11.8202 21.9461 12.1555 22.0222 12.4079 21.8613L15.8806 19.6615C16.1331 19.5016 16.2083 19.1663 16.0483 18.9138Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M15.3004 23.4497L13.9543 24.3024C13.7018 24.4624 13.6257 24.7977 13.7866 25.0501C13.9466 25.3036 14.2819 25.3778 14.5343 25.2178L15.8805 24.3651C16.1329 24.2051 16.209 23.8698 16.0481 23.6174C15.8882 23.3649 15.5528 23.2888 15.3004 23.4497Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M16.0484 21.2654C15.8885 21.0129 15.5531 20.9378 15.3007 21.0977L12.8908 22.624C12.6384 22.7839 12.5622 23.1192 12.7231 23.3717C12.8831 23.6241 13.2184 23.6993 13.4709 23.5393L15.8808 22.0131C16.1332 21.8531 16.2084 21.5178 16.0484 21.2654Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M2.17802 19.7725L7.35045 20.1387C8.10589 20.1917 8.60212 19.3678 8.20802 18.7261L7.60098 17.7366L12.943 14.4547C13.3882 14.1811 13.5279 13.5991 13.2542 13.154L12.2984 11.5988C12.0247 11.1546 11.4408 11.0149 10.9976 11.2885L5.65554 14.5704L5.04753 13.5808C4.6515 12.9372 3.69275 13.0104 3.39983 13.707L1.38886 18.4862C1.14219 19.072 1.54496 19.7282 2.17899 19.7735L2.17802 19.7725ZM4.28053 14.4056L4.8683 15.3624C5.1063 15.7488 5.61025 15.8682 5.99568 15.6312L11.4456 12.2829L12.2569 13.603L6.807 16.9513C6.42157 17.1873 6.30113 17.6932 6.5372 18.0786L7.12594 19.0354L2.47095 18.7068L4.28149 14.4056H4.28053Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M36.2076 0H28.5703C28.2707 0 28.0288 0.242812 28.0288 0.54151C28.0288 0.840208 28.2716 1.08302 28.5703 1.08302H36.0842V2.62469H17.8372V1.08398H26.041C26.3407 1.08398 26.5825 0.841172 26.5825 0.542474C26.5825 0.243776 26.3397 0.000963542 26.041 0.000963542H17.7138C17.1839 0.000963542 16.7532 0.431667 16.7532 0.961614V2.74995C16.7532 3.18547 17.0451 3.55354 17.4431 3.67109V24.4508C17.1752 24.5298 16.9565 24.7226 16.8418 24.9721L13.8827 26.8472L12.79 25.1224C12.6301 24.87 12.2947 24.7948 12.0423 24.9548C11.7898 25.1147 11.7147 25.45 11.8746 25.7025L12.9673 27.4272C11.9989 28.041 7.66287 30.789 6.95947 31.2342L3.52146 25.8056L5.15375 24.7717L6.49599 26.8915C6.73978 27.2769 7.25143 27.3916 7.63686 27.1478L8.98489 26.2941C9.37031 26.0503 9.48498 25.5387 9.24119 25.1533L7.89895 23.0335L9.53123 21.9996L10.5227 23.5653C10.6827 23.8178 11.018 23.8929 11.2705 23.733C11.5229 23.573 11.599 23.2377 11.4381 22.9853L10.4042 21.3521C10.1074 20.8828 9.4869 20.7441 9.01765 21.0409L2.87491 24.9316C2.40662 25.2284 2.26786 25.8499 2.56368 26.3182L6.04504 31.8142L0.609564 35.2589C-0.185378 35.7628 0.170178 37 1.11447 37H3.51279C3.77199 37 4.02348 36.9268 4.24317 36.788L17.922 28.12H18.1195V31.2929C18.1195 31.9915 18.688 32.559 19.3866 32.559H21.8957C22.1665 35.0527 24.2834 36.999 26.8475 36.999C29.4115 36.999 31.5285 35.0527 31.7993 32.559H35.9041C36.6026 32.559 37.1702 31.9915 37.1702 31.2929V0.960651C37.1702 0.430703 36.7395 0 36.2095 0H36.2076ZM6.9797 23.6135L8.18416 25.5155L7.27166 26.0937L6.06721 24.1916C6.62704 23.8371 6.41987 23.9681 6.9797 23.6135ZM3.65925 35.8727C3.61397 35.9016 3.56193 35.916 3.50894 35.916H1.59433C2.30159 35.468 16.1442 26.6949 16.7522 26.3105V27.1593C16.7522 27.2827 16.7792 27.4176 16.8264 27.5284L3.66022 35.8717L3.65925 35.8727ZM21.8909 31.477H19.3818C19.2816 31.477 19.1997 31.3951 19.1997 31.2949V28.1219H23.7438C22.681 28.9689 22.0297 30.1935 21.8899 31.4779L21.8909 31.477ZM26.8436 35.917C24.6949 35.917 22.946 34.1681 22.946 32.0195C22.946 29.8708 24.6949 28.1219 26.8436 28.1219C28.9924 28.1219 30.7413 29.8698 30.7413 32.0195C30.7413 34.1691 28.9934 35.917 26.8436 35.917ZM36.0833 31.2949C36.0833 31.3951 36.0014 31.477 35.9012 31.477H31.7973C31.6547 30.1646 30.9822 28.9477 29.9434 28.121H36.0833V31.2949ZM36.0833 27.037H17.8362V25.4953H36.0833V27.037ZM36.0833 24.4113H18.5261V3.70964H36.0833V24.4104V24.4113Z", fill: "currentColor" })
    ] })
  }
), dS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_2383_69969)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M2.15098 30.25H15.351C15.6552 30.25 15.901 30.0034 15.901 29.7C15.901 29.3966 15.6552 29.15 15.351 29.15H2.15098C1.84676 29.15 1.60098 28.9042 1.60098 28.6V8.8H7.65098C8.56277 8.8 9.30098 8.0618 9.30098 7.15V1.1H24.151C24.4543 1.1 24.701 1.34578 24.701 1.65V14.85C24.701 15.1542 24.9468 15.4 25.251 15.4C25.5552 15.4 25.801 15.1542 25.801 14.85V1.65C25.801 0.739063 25.0628 0 24.151 0H8.75098C8.60574 0 8.46566 0.0584375 8.36254 0.161563L0.662539 7.86156C0.559414 7.96469 0.500977 8.10477 0.500977 8.25V28.6C0.500977 29.5109 1.24004 30.25 2.15098 30.25ZM7.65098 7.7H2.37871L8.20098 1.87773V7.15C8.20098 7.45422 7.95434 7.7 7.65098 7.7Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M3.25117 24.1992C2.94695 24.1992 2.70117 24.445 2.70117 24.7492V27.4992C2.70117 27.8034 2.94695 28.0492 3.25117 28.0492H6.00117C6.30539 28.0492 6.55117 27.8034 6.55117 27.4992C6.55117 27.195 6.30539 26.9492 6.00117 26.9492H3.80117V24.7492C3.80117 24.445 3.55539 24.1992 3.25117 24.1992Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M23.601 5.49922V2.74922C23.601 2.445 23.3543 2.19922 23.051 2.19922H20.301C19.9976 2.19922 19.751 2.445 19.751 2.74922C19.751 3.05344 19.9976 3.29922 20.301 3.29922H22.501V5.49922C22.501 5.80344 22.7476 6.04922 23.051 6.04922C23.3543 6.04922 23.601 5.80344 23.601 5.49922Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M31.301 16.5H19.201C17.9858 16.5 17.001 17.4848 17.001 18.7V30.8C17.001 32.0152 17.9858 33 19.201 33H31.301C32.5161 33 33.501 32.0152 33.501 30.8V18.7C33.501 17.4848 32.5161 16.5 31.301 16.5ZM28.551 17.6V22.8937C28.551 22.9668 28.5149 23.0347 28.4547 23.0759C28.3946 23.1172 28.3181 23.1249 28.2502 23.0983L25.7417 22.0945C25.4271 21.9691 25.0757 21.9691 24.7611 22.0945L22.2535 23.1009C22.1856 23.1284 22.1082 23.1198 22.0472 23.0785C21.9871 23.0373 21.951 22.9677 21.9518 22.8946V17.6009H28.5518L28.551 17.6ZM32.401 30.8C32.401 31.4076 31.9086 31.9 31.301 31.9H19.201C18.5934 31.9 18.101 31.4076 18.101 30.8V18.7C18.101 18.0924 18.5934 17.6 19.201 17.6H20.851V22.8937C20.851 23.332 21.0684 23.7411 21.4311 23.9869C21.7937 24.2327 22.2552 24.2816 22.6617 24.1192L25.1693 23.1155C25.2226 23.094 25.2811 23.094 25.3343 23.1155L27.8429 24.1192C28.2493 24.2816 28.71 24.2309 29.0718 23.986C29.4336 23.7402 29.651 23.3312 29.651 22.8937V17.6H31.301C31.9086 17.6 32.401 18.0924 32.401 18.7V30.8Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M22.501 29.1504H20.301C19.9976 29.1504 19.751 29.397 19.751 29.7004C19.751 30.0037 19.9976 30.2504 20.301 30.2504H22.501C22.8043 30.2504 23.051 30.0037 23.051 29.7004C23.051 29.397 22.8052 29.1504 22.501 29.1504Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.051 10.4492H3.80098C3.49762 10.4492 3.25098 10.695 3.25098 10.9992C3.25098 11.3034 3.49762 11.5492 3.80098 11.5492H12.051C12.3552 11.5492 12.601 11.3034 12.601 10.9992C12.601 10.695 12.3543 10.4492 12.051 10.4492Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M22.5012 10.4492H14.2512C13.947 10.4492 13.7012 10.695 13.7012 10.9992C13.7012 11.3034 13.947 11.5492 14.2512 11.5492H22.5012C22.8045 11.5492 23.0512 11.3034 23.0512 10.9992C23.0512 10.695 22.8054 10.4492 22.5012 10.4492Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.051 12.6504H3.80098C3.49762 12.6504 3.25098 12.897 3.25098 13.2004C3.25098 13.5038 3.49762 13.7504 3.80098 13.7504H12.051C12.3552 13.7504 12.601 13.5038 12.601 13.2004C12.601 12.897 12.3543 12.6504 12.051 12.6504Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M22.5012 12.6504H14.2512C13.947 12.6504 13.7012 12.897 13.7012 13.2004C13.7012 13.5038 13.947 13.7504 14.2512 13.7504H22.5012C22.8045 13.7504 23.0512 13.5038 23.0512 13.2004C23.0512 12.897 22.8054 12.6504 22.5012 12.6504Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.051 14.8496H3.80098C3.49762 14.8496 3.25098 15.0954 3.25098 15.3996C3.25098 15.7038 3.49762 15.9496 3.80098 15.9496H12.051C12.3552 15.9496 12.601 15.703 12.601 15.3996C12.601 15.0962 12.3543 14.8496 12.051 14.8496Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.051 17.0508H3.80098C3.49762 17.0508 3.25098 17.2974 3.25098 17.6008C3.25098 17.9041 3.49762 18.1508 3.80098 18.1508H12.051C12.3552 18.1508 12.601 17.905 12.601 17.6008C12.601 17.2966 12.3543 17.0508 12.051 17.0508Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.051 19.25H3.80098C3.49762 19.25 3.25098 19.4966 3.25098 19.8C3.25098 20.1034 3.49762 20.35 3.80098 20.35H12.051C12.3552 20.35 12.601 20.1034 12.601 19.8C12.601 19.4966 12.3543 19.25 12.051 19.25Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.601 21.9992C12.601 21.695 12.3543 21.4492 12.051 21.4492H3.80098C3.49762 21.4492 3.25098 21.695 3.25098 21.9992C3.25098 22.3034 3.49762 22.5492 3.80098 22.5492H12.051C12.3552 22.5492 12.601 22.3034 12.601 21.9992Z", fill: "currentColor" })
    ] })
  }
), pS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M0.525597 18.8546C0.654764 19.4617 1.18435 19.875 1.79143 19.875C2.83768 19.875 4.87851 18.7383 6.00226 17.6663C7.46185 19.0225 9.11518 19.875 10.8331 19.875C16.1806 19.875 18.5831 15.3412 18.5831 12.125C18.5831 9.99375 16.8393 8.25 14.7081 8.25C12.5768 8.25 10.8331 9.99375 10.8331 12.125C10.8331 13.6233 11.621 15.4317 12.8739 16.9171C12.2927 17.1496 11.621 17.2917 10.8331 17.2917C9.79976 17.2917 8.70185 16.6717 7.66851 15.6771C9.73518 12.6546 10.8331 8.65042 10.8331 5.66667C10.8331 2.68292 8.52101 0.5 5.66643 0.5C2.81185 0.5 0.499764 2.81208 0.499764 5.66667C0.499764 8.52125 1.9981 12.7192 4.28435 15.7417C3.4706 16.5425 2.5406 17.0979 1.52018 17.3175C0.82268 17.4596 0.370597 18.1442 0.525597 18.8417V18.8546ZM14.7081 10.8333C15.4185 10.8333 15.9998 11.4146 15.9998 12.125C15.9998 12.9646 15.6898 14.2433 14.9018 15.3154C13.9331 14.1917 13.4164 12.9129 13.4164 12.125C13.4164 11.4146 13.9977 10.8333 14.7081 10.8333ZM3.0831 5.66667C3.0831 4.24583 4.2456 3.08333 5.66643 3.08333C7.08726 3.08333 8.24976 4.24583 8.24976 5.66667C8.24976 8.03042 7.41018 11.1692 5.93768 13.6104C4.28435 11.195 3.0831 8.05625 3.0831 5.66667ZM18.906 5.48583C19.3839 4.95625 20.1977 4.90458 20.7273 5.3825C21.4377 6.02833 22.0448 6.76458 22.5356 7.60417C22.8973 8.22417 22.6777 9.01208 22.0706 9.37375C21.8639 9.49 21.6443 9.54167 21.4248 9.54167C20.9727 9.54167 20.5464 9.30917 20.301 8.89583C19.9523 8.30167 19.526 7.77208 19.0093 7.30708C18.4798 6.82917 18.4281 6.01542 18.906 5.48583ZM28.9164 19.2808V17.2917C28.9164 14.4371 26.6043 12.125 23.7498 12.125C20.8952 12.125 18.5831 14.4371 18.5831 17.2917V19.2808C17.046 20.1721 15.9998 21.8512 15.9998 23.75V26.3333C15.9998 29.1879 18.3118 31.5 21.1664 31.5H26.3331C29.1877 31.5 31.4998 29.1879 31.4998 26.3333V23.75C31.4998 21.8383 30.4535 20.1721 28.9164 19.2808ZM21.1664 17.2917C21.1664 15.8708 22.3289 14.7083 23.7498 14.7083C25.1706 14.7083 26.3331 15.8708 26.3331 17.2917V18.5833H21.1664V17.2917ZM28.9164 26.3333C28.9164 27.7542 27.7539 28.9167 26.3331 28.9167H21.1664C19.7456 28.9167 18.5831 27.7542 18.5831 26.3333V23.75C18.5831 22.3292 19.7456 21.1667 21.1664 21.1667H26.3331C27.7539 21.1667 28.9164 22.3292 28.9164 23.75V26.3333ZM13.4164 23.75C13.4164 24.4604 12.8352 25.0417 12.1248 25.0417H1.79143C1.08101 25.0417 0.499764 24.4604 0.499764 23.75C0.499764 23.0396 1.08101 22.4583 1.79143 22.4583H12.1248C12.8352 22.4583 13.4164 23.0396 13.4164 23.75ZM25.6873 25.0417C25.6873 26.1137 24.8218 26.9792 23.7498 26.9792C22.6777 26.9792 21.8123 26.1137 21.8123 25.0417C21.8123 23.9696 22.6777 23.1042 23.7498 23.1042C24.8218 23.1042 25.6873 23.9696 25.6873 25.0417Z", fill: "currentColor" })
  }
), hS = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M11.9543 2.06241C13.2808 2.06676 14.5933 2.33415 15.8158 2.8491C17.0383 3.36404 18.1465 4.11633 19.0763 5.06241H15.9543C15.6891 5.06241 15.4347 5.16777 15.2472 5.3553C15.0597 5.54284 14.9543 5.79719 14.9543 6.06241C14.9543 6.32763 15.0597 6.58198 15.2472 6.76952C15.4347 6.95705 15.6891 7.06241 15.9543 7.06241H20.0973C20.5897 7.06214 21.0619 6.86641 21.4101 6.51821C21.7583 6.17002 21.954 5.69784 21.9543 5.20541V1.06241C21.9543 0.797193 21.8489 0.542839 21.6614 0.355303C21.4739 0.167767 21.2195 0.0624097 20.9543 0.0624097C20.6891 0.0624097 20.4347 0.167767 20.2472 0.355303C20.0597 0.542839 19.9543 0.797193 19.9543 1.06241V3.14041C18.3015 1.65186 16.2669 0.652819 14.0784 0.255159C11.8899 -0.142502 9.63393 0.0769217 7.56309 0.888857C5.49225 1.70079 3.68832 3.07318 2.35332 4.85233C1.01831 6.63149 0.204946 8.74715 0.00430406 10.9624C-0.00861256 11.1017 0.00761984 11.2421 0.051967 11.3747C0.0963141 11.5074 0.167804 11.6293 0.26188 11.7328C0.355957 11.8363 0.470558 11.919 0.598382 11.9758C0.726206 12.0325 0.864449 12.062 1.0043 12.0624C1.24889 12.0655 1.48584 11.9772 1.66876 11.8149C1.85169 11.6525 1.96742 11.4276 1.9933 11.1844C2.21592 8.69516 3.36128 6.37911 5.20438 4.69125C7.04749 3.00338 9.45512 2.0657 11.9543 2.06241Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M22.9051 12.0625C22.6605 12.0593 22.4236 12.1476 22.2406 12.31C22.0577 12.4724 21.942 12.6972 21.9161 12.9405C21.7508 14.8437 21.043 16.6596 19.8768 18.1727C18.7105 19.6858 17.1347 20.8326 15.3362 21.477C13.5378 22.1215 11.5923 22.2365 9.73045 21.8086C7.86861 21.3806 6.1686 20.4275 4.8321 19.0625H7.9541C8.21932 19.0625 8.47367 18.9571 8.66121 18.7696C8.84875 18.582 8.9541 18.3277 8.9541 18.0625C8.9541 17.7972 8.84875 17.5429 8.66121 17.3554C8.47367 17.1678 8.21932 17.0625 7.9541 17.0625H3.8111C3.5672 17.0623 3.32566 17.1103 3.1003 17.2035C2.87494 17.2968 2.67018 17.4336 2.49771 17.6061C2.32525 17.7785 2.18847 17.9833 2.09519 18.2087C2.00191 18.434 1.95397 18.6756 1.9541 18.9195V23.0625C1.9541 23.3277 2.05946 23.582 2.24699 23.7696C2.43453 23.9571 2.68889 24.0625 2.9541 24.0625C3.21932 24.0625 3.47367 23.9571 3.66121 23.7696C3.84875 23.582 3.9541 23.3277 3.9541 23.0625V20.9845C5.60693 22.473 7.64151 23.472 9.83 23.8697C12.0185 24.2674 14.2745 24.0479 16.3453 23.236C18.4162 22.4241 20.2201 21.0517 21.5551 19.2725C22.8901 17.4934 23.7035 15.3777 23.9041 13.1625C23.917 13.0232 23.9008 12.8828 23.8564 12.7501C23.8121 12.6175 23.7406 12.4956 23.6465 12.3921C23.5524 12.2886 23.4378 12.2058 23.31 12.1491C23.1822 12.0923 23.045 12.0628 22.9051 12.0625Z", fill: "currentColor" })
] }), vS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 41 41", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M20.5 41C31.8218 41 41 31.8218 41 20.5C41 9.17816 31.8218 0 20.5 0C9.17816 0 0 9.17816 0 20.5C0 31.8218 9.17816 41 20.5 41Z", fill: "#77B3D4" }),
  /* @__PURE__ */ f.jsx("path", { opacity: "0.2", d: "M7.6875 16.0156V32.0312C7.6875 33.4406 8.84062 34.5938 10.25 34.5938H30.75C32.1594 34.5938 33.3125 33.4406 33.3125 32.0312V16.0156H7.6875Z", fill: "#007AFF" }),
  /* @__PURE__ */ f.jsx("path", { d: "M7.6875 14.7344V30.75C7.6875 32.1594 8.84062 33.3125 10.25 33.3125H30.75C32.1594 33.3125 33.3125 32.1594 33.3125 30.75V14.7344H7.6875Z", fill: "white" }),
  /* @__PURE__ */ f.jsx("path", { opacity: "0.2", d: "M30.75 8.96875H10.25C8.84062 8.96875 7.6875 10.1219 7.6875 11.5312V16.0156H33.3125V11.5312C33.3125 10.1219 32.1594 8.96875 30.75 8.96875Z", fill: "#007AFF" }),
  /* @__PURE__ */ f.jsx("path", { d: "M30.75 7.6875H10.25C8.84062 7.6875 7.6875 8.84062 7.6875 10.25V14.7344H33.3125V10.25C33.3125 8.84062 32.1594 7.6875 30.75 7.6875Z", fill: "#C75C5C" }),
  /* @__PURE__ */ f.jsx("path", { d: "M20.5 30.75C19.7953 30.75 19.2188 30.1734 19.2188 29.4688C19.2188 25.9453 20.3719 23.3828 21.4609 21.7812H17.2969C16.5922 21.7812 16.0156 21.2047 16.0156 20.5C16.0156 19.7953 16.5922 19.2188 17.2969 19.2188H24.3438C24.9203 19.2188 25.3688 19.6031 25.5609 20.1156C25.7531 20.6281 25.5609 21.2047 25.1125 21.525C24.9844 21.6531 21.7812 24.0234 21.7812 29.4688C21.7812 30.1734 21.2047 30.75 20.5 30.75Z", fill: "white", "fill-opacity": "0.3" }),
  /* @__PURE__ */ f.jsx("path", { opacity: "0.2", d: "M12.8125 13.4531C12.1078 13.4531 11.5312 12.8766 11.5312 12.1719V7.6875C11.5312 6.98281 12.1078 6.40625 12.8125 6.40625C13.5172 6.40625 14.0938 6.98281 14.0938 7.6875V12.1719C14.0938 12.8766 13.5172 13.4531 12.8125 13.4531Z", fill: "#007AFF" }),
  /* @__PURE__ */ f.jsx("path", { opacity: "0.2", d: "M28.8281 13.4531C28.1234 13.4531 27.5469 12.8766 27.5469 12.1719V7.6875C27.5469 6.98281 28.1234 6.40625 28.8281 6.40625C29.5328 6.40625 30.1094 6.98281 30.1094 7.6875V12.1719C30.1094 12.8766 29.5328 13.4531 28.8281 13.4531Z", fill: "#007AFF" }),
  /* @__PURE__ */ f.jsx("path", { d: "M12.8125 12.1719C12.1078 12.1719 11.5312 11.5953 11.5312 10.8906V6.40625C11.5312 5.70156 12.1078 5.125 12.8125 5.125C13.5172 5.125 14.0938 5.70156 14.0938 6.40625V10.8906C14.0938 11.5953 13.5172 12.1719 12.8125 12.1719Z", fill: "#E0E0D1" }),
  /* @__PURE__ */ f.jsx("path", { d: "M28.8281 12.1719C28.1234 12.1719 27.5469 11.5953 27.5469 10.8906V6.40625C27.5469 5.70156 28.1234 5.125 28.8281 5.125C29.5328 5.125 30.1094 5.70156 30.1094 6.40625V10.8906C30.1094 11.5953 29.5328 12.1719 28.8281 12.1719Z", fill: "#E0E0D1" })
] }), mS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("g", { "clip-path": "url(#clip0_280_423)", children: /* @__PURE__ */ f.jsx("path", { d: "M19 2H18V1C18 0.448 17.553 0 17 0C16.447 0 16 0.448 16 1V2H8V1C8 0.448 7.553 0 7 0C6.447 0 6 0.448 6 1V2H5C2.243 2 0 4.243 0 7V19C0 21.757 2.243 24 5 24H19C21.757 24 24 21.757 24 19V7C24 4.243 21.757 2 19 2ZM5 4H19C20.654 4 22 5.346 22 7V8H2V7C2 5.346 3.346 4 5 4ZM19 22H5C3.346 22 2 20.654 2 19V10H22V19C22 20.654 20.654 22 19 22ZM17.832 13.152C18.216 13.549 18.204 14.183 17.807 14.566L13.067 19.134C12.514 19.687 11.76 20 10.959 20C10.158 20 9.404 19.688 8.838 19.121L6.586 17.029C6.182 16.653 6.158 16.02 6.534 15.616C6.912 15.211 7.544 15.189 7.947 15.564L10.225 17.681C10.658 18.111 11.288 18.083 11.664 17.707L16.418 13.125C16.816 12.742 17.448 12.754 17.832 13.151V13.152Z", fill: "currentColor" }) }),
  /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_280_423", children: /* @__PURE__ */ f.jsx("rect", { width: "24", height: "24", fill: "currentColor" }) }) })
] }), gS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("g", { "clip-path": "url(#clip0_280_421)", children: /* @__PURE__ */ f.jsx("path", { d: "M15.707 13.707L13.414 16L15.707 18.293C16.098 18.684 16.098 19.316 15.707 19.707C15.512 19.902 15.256 20 15 20C14.744 20 14.488 19.902 14.293 19.707L12 17.414L9.707 19.707C9.512 19.902 9.256 20 9 20C8.744 20 8.488 19.902 8.293 19.707C7.902 19.316 7.902 18.684 8.293 18.293L10.586 16L8.293 13.707C7.902 13.316 7.902 12.684 8.293 12.293C8.684 11.902 9.316 11.902 9.707 12.293L12 14.586L14.293 12.293C14.684 11.902 15.316 11.902 15.707 12.293C16.098 12.684 16.098 13.316 15.707 13.707ZM24 7V19C24 21.757 21.757 24 19 24H5C2.243 24 0 21.757 0 19V7C0 4.243 2.243 2 5 2H6V1C6 0.447 6.448 0 7 0C7.552 0 8 0.447 8 1V2H16V1C16 0.447 16.448 0 17 0C17.552 0 18 0.447 18 1V2H19C21.757 2 24 4.243 24 7ZM2 7V8H22V7C22 5.346 20.654 4 19 4H5C3.346 4 2 5.346 2 7ZM22 19V10H2V19C2 20.654 3.346 22 5 22H19C20.654 22 22 20.654 22 19Z", fill: "currentColor" }) }),
  /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_280_421", children: /* @__PURE__ */ f.jsx("rect", { width: "24", height: "24", fill: "currentColor" }) }) })
] }), yS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("g", { "clip-path": "url(#clip0_280_419)", children: /* @__PURE__ */ f.jsx("path", { d: "M19 2H18V1C18 0.448 17.552 0 17 0C16.448 0 16 0.448 16 1V2H8V1C8 0.448 7.552 0 7 0C6.448 0 6 0.448 6 1V2H5C2.243 2 0 4.243 0 7V19C0 21.757 2.243 24 5 24H19C21.757 24 24 21.757 24 19V7C24 4.243 21.757 2 19 2ZM19 22H5C3.346 22 2 20.654 2 19V10H8C8.552 10 9 9.552 9 9C9 8.448 8.552 8 8 8H2V7C2 5.346 3.346 4 5 4H19C20.654 4 22 5.346 22 7V8H16C15.448 8 15 8.448 15 9C15 9.552 15.448 10 16 10H22V19C22 20.654 20.654 22 19 22ZM13 9V16C13 16.552 12.552 17 12 17C11.448 17 11 16.552 11 16V9C11 8.448 11.448 8 12 8C12.552 8 13 8.448 13 9ZM13 19C13 19.552 12.552 20 12 20C11.448 20 11 19.552 11 19C11 18.448 11.448 18 12 18C12.552 18 13 18.448 13 19Z", fill: "currentColor" }) }),
  /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_280_419", children: /* @__PURE__ */ f.jsx("rect", { width: "24", height: "24", fill: "currentColor" }) }) })
] }), bS = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsxs("g", { children: [
    /* @__PURE__ */ f.jsx("path", { d: "M19.1666 13.3334C18.9456 13.3334 18.7337 13.4212 18.5774 13.5775C18.4211 13.7337 18.3333 13.9457 18.3333 14.1667V15.8334C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1322 18.07 16.4964 18.3334 15.8333 18.3334H14.1666C13.9456 18.3334 13.7337 18.4212 13.5774 18.5775C13.4211 18.7337 13.3333 18.9457 13.3333 19.1667C13.3333 19.3877 13.4211 19.5997 13.5774 19.756C13.7337 19.9122 13.9456 20 14.1666 20H15.8333C16.938 19.9987 17.997 19.5593 18.7781 18.7782C19.5592 17.9971 19.9987 16.938 20 15.8334V14.1667C20 13.9457 19.9122 13.7337 19.7559 13.5775C19.5996 13.4212 19.3877 13.3334 19.1666 13.3334Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M0.833333 6.66667C1.05435 6.66667 1.26631 6.57887 1.42259 6.42259C1.57887 6.26631 1.66667 6.05435 1.66667 5.83333V4.16667C1.66667 3.50363 1.93006 2.86774 2.3989 2.3989C2.86774 1.93006 3.50363 1.66667 4.16667 1.66667H5.83333C6.05435 1.66667 6.26631 1.57887 6.42259 1.42259C6.57887 1.26631 6.66667 1.05435 6.66667 0.833333C6.66667 0.61232 6.57887 0.400358 6.42259 0.244078C6.26631 0.0877974 6.05435 0 5.83333 0L4.16667 0C3.062 0.00132321 2.00296 0.440735 1.22185 1.22185C0.440735 2.00296 0.00132321 3.062 0 4.16667L0 5.83333C0 6.05435 0.0877974 6.26631 0.244078 6.42259C0.400358 6.57887 0.61232 6.66667 0.833333 6.66667Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M5.83333 18.3334H4.16667C3.50363 18.3334 2.86774 18.07 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8334V14.1667C1.66667 13.9457 1.57887 13.7337 1.42259 13.5775C1.26631 13.4212 1.05435 13.3334 0.833333 13.3334C0.61232 13.3334 0.400358 13.4212 0.244078 13.5775C0.0877974 13.7337 0 13.9457 0 14.1667L0 15.8334C0.00132321 16.938 0.440735 17.9971 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H5.83333C6.05435 20 6.26631 19.9122 6.42259 19.756C6.57887 19.5997 6.66667 19.3877 6.66667 19.1667C6.66667 18.9457 6.57887 18.7337 6.42259 18.5775C6.26631 18.4212 6.05435 18.3334 5.83333 18.3334Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M15.8333 0H14.1666C13.9456 0 13.7337 0.0877974 13.5774 0.244078C13.4211 0.400358 13.3333 0.61232 13.3333 0.833333C13.3333 1.05435 13.4211 1.26631 13.5774 1.42259C13.7337 1.57887 13.9456 1.66667 14.1666 1.66667H15.8333C16.4964 1.66667 17.1322 1.93006 17.6011 2.3989C18.0699 2.86774 18.3333 3.50363 18.3333 4.16667V5.83333C18.3333 6.05435 18.4211 6.26631 18.5774 6.42259C18.7337 6.57887 18.9456 6.66667 19.1666 6.66667C19.3877 6.66667 19.5996 6.57887 19.7559 6.42259C19.9122 6.26631 20 6.05435 20 5.83333V4.16667C19.9987 3.062 19.5592 2.00296 18.7781 1.22185C17.997 0.440735 16.938 0.00132321 15.8333 0Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M10 9.16667C10.6593 9.16667 11.3038 8.97117 11.8519 8.6049C12.4001 8.23863 12.8273 7.71803 13.0796 7.10895C13.3319 6.49986 13.3979 5.82964 13.2693 5.18303C13.1407 4.53643 12.8232 3.94249 12.357 3.47631C11.8909 3.01014 11.2969 2.69267 10.6503 2.56405C10.0037 2.43543 9.3335 2.50144 8.72441 2.75374C8.11532 3.00603 7.59473 3.43327 7.22846 3.98143C6.86218 4.5296 6.66669 5.17406 6.66669 5.83334C6.66669 6.71739 7.01788 7.56524 7.643 8.19036C8.26812 8.81548 9.11597 9.16667 10 9.16667ZM10 4.16667C10.3297 4.16667 10.6519 4.26442 10.926 4.44755C11.2001 4.63069 11.4137 4.89099 11.5398 5.19553C11.666 5.50007 11.699 5.83518 11.6347 6.15849C11.5704 6.48179 11.4116 6.77876 11.1785 7.01185C10.9454 7.24493 10.6485 7.40367 10.3252 7.46798C10.0019 7.53229 9.66676 7.49928 9.36222 7.37313C9.05767 7.24699 8.79737 7.03337 8.61424 6.75929C8.4311 6.4852 8.33335 6.16297 8.33335 5.83334C8.33335 5.39131 8.50895 4.96738 8.82151 4.65482C9.13407 4.34226 9.55799 4.16667 10 4.16667Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M15 16.6667C15.221 16.6667 15.433 16.5789 15.5893 16.4226C15.7456 16.2664 15.8334 16.0544 15.8334 15.8334C15.832 14.5077 15.3048 13.2367 14.3674 12.2993C13.43 11.3619 12.159 10.8347 10.8334 10.8334H9.16669C7.84101 10.8347 6.57001 11.3619 5.63262 12.2993C4.69522 13.2367 4.16801 14.5077 4.16669 15.8334C4.16669 16.0544 4.25448 16.2664 4.41076 16.4226C4.56705 16.5789 4.77901 16.6667 5.00002 16.6667C5.22103 16.6667 5.433 16.5789 5.58928 16.4226C5.74556 16.2664 5.83335 16.0544 5.83335 15.8334C5.83335 14.9493 6.18454 14.1015 6.80966 13.4764C7.43479 12.8512 8.28263 12.5 9.16669 12.5H10.8334C11.7174 12.5 12.5653 12.8512 13.1904 13.4764C13.8155 14.1015 14.1667 14.9493 14.1667 15.8334C14.1667 16.0544 14.2545 16.2664 14.4108 16.4226C14.567 16.5789 14.779 16.6667 15 16.6667Z", fill: "currentColor" })
  ] }),
  /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_213_175", children: /* @__PURE__ */ f.jsx("rect", { width: "20", height: "20", fill: "currentColor" }) }) })
] }), CS = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0" }),
  /* @__PURE__ */ f.jsx("path", { d: "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2" }),
  /* @__PURE__ */ f.jsx("path", { d: "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z" })
] }), xS = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z", fill: "currentColor" })
] }), wS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M5.5 10.3125C2.84213 10.3125 0.6875 8.15787 0.6875 5.5C0.6875 2.84213 2.84213 0.6875 5.5 0.6875C8.15787 0.6875 10.3125 2.84213 10.3125 5.5C10.3125 8.15787 8.15787 10.3125 5.5 10.3125ZM5.5 11C8.53757 11 11 8.53757 11 5.5C11 2.46243 8.53757 0 5.5 0C2.46243 0 0 2.46243 0 5.5C0 8.53757 2.46243 11 5.5 11Z",
    fill: "currentColor"
  }
) }), OS = () => /* @__PURE__ */ f.jsx("svg", { width: "21", height: "21", viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M11.8773 0.570516C11.1167 -0.190171 9.88334 -0.190173 9.12265 0.570515L0.570516 9.12265C-0.190171 9.88334 -0.190173 11.1167 0.570515 11.8773L9.12265 20.4295C9.88334 21.1902 11.1167 21.1902 11.8773 20.4295L20.4295 11.8773C21.1902 11.1167 21.1902 9.88334 20.4295 9.12265L11.8773 0.570516ZM10.5 5.24996C11.2027 5.24996 11.7518 5.85671 11.6819 6.55595L11.2215 11.1595C11.1845 11.5302 10.8725 11.8125 10.5 11.8125C10.1275 11.8125 9.81552 11.5302 9.77845 11.1595L9.3181 6.55595C9.24817 5.85671 9.79727 5.24996 10.5 5.24996ZM10.502 13.125C11.2269 13.125 11.8145 13.7126 11.8145 14.4375C11.8145 15.1623 11.2269 15.75 10.502 15.75C9.77715 15.75 9.18952 15.1623 9.18952 14.4375C9.18952 13.7126 9.77715 13.125 10.502 13.125Z",
    fill: "#E52E2E"
  }
) }), SS = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16",
    children: [
      /* @__PURE__ */ f.jsx("path", { d: "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4.5a.5.5 0 0 1-1 0V5.383l-7 4.2-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h5.5a.5.5 0 0 1 0 1H2a2 2 0 0 1-2-1.99zm1 7.105 4.708-2.897L1 5.383zM1 4v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.354-5.354 1.25 1.25a.5.5 0 0 1-.708.708L13 12.207V14a.5.5 0 0 1-1 0v-1.717l-.28.305a.5.5 0 0 1-.737-.676l1.149-1.25a.5.5 0 0 1 .722-.016" })
    ]
  }
), PS = () => /* @__PURE__ */ f.jsx("svg", { fill: "none", viewBox: "0 0 25 25", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M10.5426 23.0627C10.5426 23.6157 10.0956 24.0627 9.54257 24.0627H5.54257C2.78557 24.0627 0.542572 21.8197 0.542572 19.0627V5.06274C0.542572 2.30574 2.78557 0.0627441 5.54257 0.0627441H13.5426C16.2996 0.0627441 18.5426 2.30574 18.5426 5.06274V7.06274C18.5426 7.61574 18.0956 8.06274 17.5426 8.06274C16.9896 8.06274 16.5426 7.61574 16.5426 7.06274V5.06274C16.5426 3.40874 15.1966 2.06274 13.5426 2.06274H5.54257C3.88857 2.06274 2.54257 3.40874 2.54257 5.06274V19.0627C2.54257 20.7167 3.88857 22.0627 5.54257 22.0627H9.54257C10.0956 22.0627 10.5426 22.5097 10.5426 23.0627ZM14.5426 6.06274C14.5426 5.50974 14.0956 5.06274 13.5426 5.06274H5.54257C4.98957 5.06274 4.54257 5.50974 4.54257 6.06274C4.54257 6.61574 4.98957 7.06274 5.54257 7.06274H13.5426C14.0956 7.06274 14.5426 6.61574 14.5426 6.06274ZM10.5426 11.0627C10.5426 10.5097 10.0956 10.0627 9.54257 10.0627H5.54257C4.98957 10.0627 4.54257 10.5097 4.54257 11.0627C4.54257 11.6157 4.98957 12.0627 5.54257 12.0627H9.54257C10.0956 12.0627 10.5426 11.6157 10.5426 11.0627ZM5.54257 15.0627C4.98957 15.0627 4.54257 15.5097 4.54257 16.0627C4.54257 16.6157 4.98957 17.0627 5.54257 17.0627H7.54257C8.09557 17.0627 8.54257 16.6157 8.54257 16.0627C8.54257 15.5097 8.09557 15.0627 7.54257 15.0627H5.54257ZM24.5426 17.0627C24.5426 20.9217 21.4016 24.0627 17.5426 24.0627C13.6836 24.0627 10.5426 20.9217 10.5426 17.0627C10.5426 13.2037 13.6836 10.0627 17.5426 10.0627C21.4016 10.0627 24.5426 13.2037 24.5426 17.0627ZM22.5426 17.0627C22.5426 14.3057 20.2996 12.0627 17.5426 12.0627C14.7856 12.0627 12.5426 14.3057 12.5426 17.0627C12.5426 19.8197 14.7856 22.0627 17.5426 22.0627C20.2996 22.0627 22.5426 19.8197 22.5426 17.0627ZM19.3506 15.8217L17.1276 17.9557C16.9836 18.0967 16.7486 18.0997 16.6056 17.9577L15.4746 16.8497C15.0786 16.4617 14.4466 16.4677 14.0606 16.8637C13.6736 17.2587 13.6796 17.8907 14.0746 18.2777L15.2066 19.3867C15.6666 19.8357 16.2686 20.0607 16.8696 20.0607C17.4706 20.0607 18.0706 19.8357 18.5226 19.3897L20.7356 17.2657C21.1336 16.8827 21.1466 16.2497 20.7646 15.8517C20.3816 15.4517 19.7476 15.4407 19.3506 15.8227V15.8217Z",
    fill: "currentColor"
  }
) }), ES = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z", fill: "currentColor" })
] }), jS = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1", fill: "currentColor" })
] }), _S = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    fill: "currentColor",
    className: "bi bi-power",
    viewBox: "0 0 16 16",
    children: [
      /* @__PURE__ */ f.jsx("path", { d: "M7.5 1v7h1V1z" }),
      /* @__PURE__ */ f.jsx("path", { d: "M3 8.812a5 5 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812" })
    ]
  }
), AS = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z", fill: "currentColor" })
] }), DS = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsxs("g", { children: [
    /* @__PURE__ */ f.jsx("path", { d: "M19.1666 13.3334C18.9456 13.3334 18.7337 13.4212 18.5774 13.5775C18.4211 13.7337 18.3333 13.9457 18.3333 14.1667V15.8334C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1322 18.07 16.4964 18.3334 15.8333 18.3334H14.1666C13.9456 18.3334 13.7337 18.4212 13.5774 18.5775C13.4211 18.7337 13.3333 18.9457 13.3333 19.1667C13.3333 19.3877 13.4211 19.5997 13.5774 19.756C13.7337 19.9122 13.9456 20 14.1666 20H15.8333C16.938 19.9987 17.997 19.5593 18.7781 18.7782C19.5592 17.9971 19.9987 16.938 20 15.8334V14.1667C20 13.9457 19.9122 13.7337 19.7559 13.5775C19.5996 13.4212 19.3877 13.3334 19.1666 13.3334Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M0.833333 6.66667C1.05435 6.66667 1.26631 6.57887 1.42259 6.42259C1.57887 6.26631 1.66667 6.05435 1.66667 5.83333V4.16667C1.66667 3.50363 1.93006 2.86774 2.3989 2.3989C2.86774 1.93006 3.50363 1.66667 4.16667 1.66667H5.83333C6.05435 1.66667 6.26631 1.57887 6.42259 1.42259C6.57887 1.26631 6.66667 1.05435 6.66667 0.833333C6.66667 0.61232 6.57887 0.400358 6.42259 0.244078C6.26631 0.0877974 6.05435 0 5.83333 0L4.16667 0C3.062 0.00132321 2.00296 0.440735 1.22185 1.22185C0.440735 2.00296 0.00132321 3.062 0 4.16667L0 5.83333C0 6.05435 0.0877974 6.26631 0.244078 6.42259C0.400358 6.57887 0.61232 6.66667 0.833333 6.66667Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M5.83333 18.3334H4.16667C3.50363 18.3334 2.86774 18.07 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8334V14.1667C1.66667 13.9457 1.57887 13.7337 1.42259 13.5775C1.26631 13.4212 1.05435 13.3334 0.833333 13.3334C0.61232 13.3334 0.400358 13.4212 0.244078 13.5775C0.0877974 13.7337 0 13.9457 0 14.1667L0 15.8334C0.00132321 16.938 0.440735 17.9971 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H5.83333C6.05435 20 6.26631 19.9122 6.42259 19.756C6.57887 19.5997 6.66667 19.3877 6.66667 19.1667C6.66667 18.9457 6.57887 18.7337 6.42259 18.5775C6.26631 18.4212 6.05435 18.3334 5.83333 18.3334Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M15.8333 0H14.1666C13.9456 0 13.7337 0.0877974 13.5774 0.244078C13.4211 0.400358 13.3333 0.61232 13.3333 0.833333C13.3333 1.05435 13.4211 1.26631 13.5774 1.42259C13.7337 1.57887 13.9456 1.66667 14.1666 1.66667H15.8333C16.4964 1.66667 17.1322 1.93006 17.6011 2.3989C18.0699 2.86774 18.3333 3.50363 18.3333 4.16667V5.83333C18.3333 6.05435 18.4211 6.26631 18.5774 6.42259C18.7337 6.57887 18.9456 6.66667 19.1666 6.66667C19.3877 6.66667 19.5996 6.57887 19.7559 6.42259C19.9122 6.26631 20 6.05435 20 5.83333V4.16667C19.9987 3.062 19.5592 2.00296 18.7781 1.22185C17.997 0.440735 16.938 0.00132321 15.8333 0Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M10 9.16667C10.6593 9.16667 11.3038 8.97117 11.8519 8.6049C12.4001 8.23863 12.8273 7.71803 13.0796 7.10895C13.3319 6.49986 13.3979 5.82964 13.2693 5.18303C13.1407 4.53643 12.8232 3.94249 12.357 3.47631C11.8909 3.01014 11.2969 2.69267 10.6503 2.56405C10.0037 2.43543 9.3335 2.50144 8.72441 2.75374C8.11532 3.00603 7.59473 3.43327 7.22846 3.98143C6.86218 4.5296 6.66669 5.17406 6.66669 5.83334C6.66669 6.71739 7.01788 7.56524 7.643 8.19036C8.26812 8.81548 9.11597 9.16667 10 9.16667ZM10 4.16667C10.3297 4.16667 10.6519 4.26442 10.926 4.44755C11.2001 4.63069 11.4137 4.89099 11.5398 5.19553C11.666 5.50007 11.699 5.83518 11.6347 6.15849C11.5704 6.48179 11.4116 6.77876 11.1785 7.01185C10.9454 7.24493 10.6485 7.40367 10.3252 7.46798C10.0019 7.53229 9.66676 7.49928 9.36222 7.37313C9.05767 7.24699 8.79737 7.03337 8.61424 6.75929C8.4311 6.4852 8.33335 6.16297 8.33335 5.83334C8.33335 5.39131 8.50895 4.96738 8.82151 4.65482C9.13407 4.34226 9.55799 4.16667 10 4.16667Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M15 16.6667C15.221 16.6667 15.433 16.5789 15.5893 16.4226C15.7456 16.2664 15.8334 16.0544 15.8334 15.8334C15.832 14.5077 15.3048 13.2367 14.3674 12.2993C13.43 11.3619 12.159 10.8347 10.8334 10.8334H9.16669C7.84101 10.8347 6.57001 11.3619 5.63262 12.2993C4.69522 13.2367 4.16801 14.5077 4.16669 15.8334C4.16669 16.0544 4.25448 16.2664 4.41076 16.4226C4.56705 16.5789 4.77901 16.6667 5.00002 16.6667C5.22103 16.6667 5.433 16.5789 5.58928 16.4226C5.74556 16.2664 5.83335 16.0544 5.83335 15.8334C5.83335 14.9493 6.18454 14.1015 6.80966 13.4764C7.43479 12.8512 8.28263 12.5 9.16669 12.5H10.8334C11.7174 12.5 12.5653 12.8512 13.1904 13.4764C13.8155 14.1015 14.1667 14.9493 14.1667 15.8334C14.1667 16.0544 14.2545 16.2664 14.4108 16.4226C14.567 16.5789 14.779 16.6667 15 16.6667Z", fill: "currentColor" })
  ] }),
  /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_213_175", children: /* @__PURE__ */ f.jsx("rect", { width: "20", height: "20", fill: "currentColor" }) }) })
] }), MS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 25 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M10 1.25C11.3807 1.25 12.5 2.36929 12.5 3.75V6.25H7.50002V3.75C7.50002 2.36929 8.6193 1.25 10 1.25ZM13.75 6.25V3.75C13.75 1.67893 12.0711 0 10 0C7.92895 0 6.25002 1.67893 6.25002 3.75V6.25H4.2015C3.27338 6.25 2.48492 6.92901 2.34724 7.84686L1.06256 16.4114C0.77915 18.3008 2.24246 20 4.15298 20H15.847C17.7576 20 19.2209 18.3008 18.9375 16.4114L17.6528 7.84686C17.5151 6.92901 16.7266 6.25 15.7985 6.25H13.75ZM12.5 7.5V9.375C12.5 9.72018 12.7798 10 13.125 10C13.4702 10 13.75 9.72018 13.75 9.375V7.5H15.7985C16.1079 7.5 16.3707 7.72634 16.4166 8.03229L17.7013 16.5969C17.8713 17.7305 16.9934 18.75 15.847 18.75H4.15298C3.00667 18.75 2.12868 17.7305 2.29873 16.5969L3.58342 8.03229C3.62931 7.72634 3.89213 7.5 4.2015 7.5H6.25002V9.375C6.25002 9.72018 6.52984 10 6.87502 10C7.22019 10 7.50002 9.72018 7.50002 9.375V7.5H12.5Z",
    fill: "currentColor"
  }
) }), TS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zm-.5-13h-1v6h4v-1.5h-2.5z",
        fill: "currentColor"
      }
    )
  }
), $S = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("path", { d: "M27.5 32.5C34.4036 32.5 40 26.9036 40 20C40 13.0964 34.4036 7.5 27.5 7.5C21.0183 7.5 15.6889 12.4333 15.0617 18.75H10C10 16.6789 8.32107 15 6.25 15H3.75C1.67893 15 0 16.6789 0 18.75V21.25C0 23.3211 1.67893 25 3.75 25H6.25C8.32107 25 10 23.3211 10 21.25H15.0617C15.6889 27.5667 21.0183 32.5 27.5 32.5ZM28.75 13.75V18.75H33.75C34.4404 18.75 35 19.3096 35 20C35 20.6904 34.4404 21.25 33.75 21.25H28.75V26.25C28.75 26.9404 28.1904 27.5 27.5 27.5C26.8096 27.5 26.25 26.9404 26.25 26.25V21.25H21.25C20.5596 21.25 20 20.6904 20 20C20 19.3096 20.5596 18.75 21.25 18.75H26.25V13.75C26.25 13.0596 26.8096 12.5 27.5 12.5C28.1904 12.5 28.75 13.0596 28.75 13.75Z", fill: "currentColor" }) }), NS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.6 26.6 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.93.93 0 0 1-.765.935c-.845.147-2.34.346-4.235.346s-3.39-.2-4.235-.346A.93.93 0 0 1 3 9.219zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a25 25 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a25 25 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.135",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2zM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5",
      fill: "currentColor"
    }
  )
] }), IS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 42 43", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M39.3165 20.6978H38.0635V20.3025C38.0635 19.4986 37.424 18.8445 36.6378 18.8445H35.7683C34.9823 18.8445 34.3428 19.4986 34.3428 20.3025V20.6978H31.0829V20.3025C31.0829 19.5536 30.5277 18.9353 29.8163 18.8542V1.15577C29.8163 0.793593 29.5296 0.5 29.1761 0.5H1.39019C1.03662 0.5 0.75 0.793593 0.75 1.15577V41.8442C0.75 42.2064 1.03662 42.5 1.39019 42.5H39.3165C40.6583 42.5 41.75 41.4526 41.75 40.1654V23.0301C41.7499 21.744 40.6583 20.6978 39.3165 20.6978ZM35.6231 20.3024C35.6231 20.223 35.6896 20.1559 35.7683 20.1559H36.6378C36.7165 20.1559 36.7831 20.223 36.7831 20.3024V22.8905C36.7831 22.9699 36.7165 23.037 36.6378 23.037H35.7683C35.6897 23.037 35.6231 22.9699 35.6231 22.8905V20.3024ZM34.3427 22.0093V22.8905C34.3427 23.6944 34.9821 24.3485 35.7682 24.3485H36.6377C37.4238 24.3485 38.0634 23.6944 38.0634 22.8905V22.0093H39.3164C39.9522 22.0093 40.4695 22.4672 40.4695 23.0301V25.4321H18.3318V23.0301C18.3318 22.4672 18.8491 22.0093 19.485 22.0093H20.3816V22.8905C20.3816 23.6944 21.0212 24.3485 21.8073 24.3485H22.6767C23.4628 24.3485 24.1023 23.6944 24.1023 22.8905V22.0093H27.3621V22.8905C27.3621 23.6944 28.0016 24.3485 28.7878 24.3485H29.6571C30.4432 24.3485 31.0829 23.6944 31.0829 22.8905V22.0093H34.3427ZM21.6621 22.8905V20.3024C21.6621 20.223 21.7285 20.1559 21.8073 20.1559H22.6767C22.7554 20.1559 22.8219 20.223 22.8219 20.3024V22.8905C22.8219 22.9699 22.7555 23.037 22.6767 23.037H21.8073C21.7285 23.037 21.6621 22.9699 21.6621 22.8905ZM29.6571 20.156C29.7359 20.156 29.8024 20.2231 29.8024 20.3025V22.8906C29.8024 22.97 29.7359 23.037 29.6571 23.037H28.7878C28.7091 23.037 28.6426 22.97 28.6426 22.8906V20.3025C28.6426 20.2231 28.7091 20.156 28.7878 20.156H29.6571ZM2.03038 1.81153H28.5358V18.8687C27.8697 18.991 27.3622 19.5866 27.3622 20.3025V20.6978H24.1024V20.3025C24.1024 19.4986 23.4629 18.8445 22.6768 18.8445H21.8073C21.0213 18.8445 20.3817 19.4986 20.3817 20.3025V20.6978H19.4851C18.1432 20.6978 17.0514 21.744 17.0514 23.0301V40.1654C17.0514 40.5322 17.1403 40.8794 17.2981 41.1886H2.03038V1.81153ZM39.3165 41.1885H19.485C18.8599 41.1885 18.3318 40.72 18.3318 40.1654V26.7437H40.4696V40.1654C40.4695 40.7295 39.9523 41.1885 39.3165 41.1885ZM24.9264 28.7549H21.6392C21.2857 28.7549 20.9991 29.0485 20.9991 29.4107V32.7755C20.9991 33.1377 21.2857 33.4313 21.6392 33.4313H24.9264C25.2799 33.4313 25.5665 33.1377 25.5665 32.7755V29.4107C25.5665 29.0486 25.2799 28.7549 24.9264 28.7549ZM24.2862 32.1197H22.2794V30.0665H24.2862V32.1197ZM30.9875 28.7549H27.7026C27.349 28.7549 27.0624 29.0485 27.0624 29.4107V32.7755C27.0624 33.1377 27.349 33.4313 27.7026 33.4313H30.9875C31.3411 33.4313 31.6277 33.1377 31.6277 32.7755V29.4107C31.6277 29.0486 31.3411 28.7549 30.9875 28.7549ZM30.3473 32.1197H28.3429V30.0665H30.3473V32.1197ZM24.9264 34.5008H21.6392C21.2857 34.5008 20.9991 34.7944 20.9991 35.1566V38.5214C20.9991 38.8835 21.2857 39.1771 21.6392 39.1771H24.9264C25.2799 39.1771 25.5665 38.8835 25.5665 38.5214V35.1566C25.5665 34.7944 25.2799 34.5008 24.9264 34.5008ZM24.2862 37.8656H22.2794V35.8124H24.2862V37.8656ZM30.9875 34.5008H27.7026C27.349 34.5008 27.0624 34.7944 27.0624 35.1566V38.5214C27.0624 38.8835 27.349 39.1771 27.7026 39.1771H30.9875C31.3411 39.1771 31.6277 38.8835 31.6277 38.5214V35.1566C31.6277 34.7944 31.3411 34.5008 30.9875 34.5008ZM30.3473 37.8656H28.3429V35.8124H30.3473V37.8656ZM37.1644 28.7549H33.8774C33.5238 28.7549 33.2372 29.0485 33.2372 29.4107V32.7755C33.2372 33.1377 33.5238 33.4313 33.8774 33.4313H37.1644C37.518 33.4313 37.8046 33.1377 37.8046 32.7755V29.4107C37.8046 29.0486 37.518 28.7549 37.1644 28.7549ZM36.5242 32.1197H34.5176V30.0665H36.5242V32.1197ZM37.1644 34.5008H33.8774C33.5238 34.5008 33.2372 34.7944 33.2372 35.1566V38.5214C33.2372 38.8835 33.5238 39.1771 33.8774 39.1771H37.1644C37.518 39.1771 37.8046 38.8835 37.8046 38.5214V35.1566C37.8046 34.7944 37.518 34.5008 37.1644 34.5008ZM36.5242 37.8656H34.5176V35.8124H36.5242V37.8656ZM4.67938 12.2289V5.18084C4.67938 4.81867 4.966 4.52507 5.31957 4.52507H12.7588C13.1123 4.52507 13.399 4.81867 13.399 5.18084C13.399 5.54301 13.1123 5.83661 12.7588 5.83661H5.95976V11.5732H12.1185V9.57752L10.9279 10.6845C10.8056 10.7982 10.6515 10.8548 10.4977 10.8548C10.3337 10.8548 10.1699 10.7905 10.0453 10.6631L8.58562 9.17015C8.33544 8.91429 8.33512 8.49904 8.58498 8.24277C8.8346 7.98651 9.24006 7.98618 9.49032 8.24204L10.5187 9.29377L13.6087 6.42076C13.8705 6.17737 14.2752 6.1973 14.513 6.46555C14.7506 6.73371 14.7311 7.14838 14.4693 7.39185L13.399 8.38699V12.2289C13.399 12.5911 13.1123 12.8846 12.7588 12.8846H5.31957C4.966 12.8846 4.67938 12.5911 4.67938 12.2289ZM4.67938 25.0229V17.9771C4.67938 17.615 4.966 17.3214 5.31957 17.3214H12.7588C13.1123 17.3214 13.399 17.615 13.399 17.9771C13.399 18.3393 13.1123 18.6329 12.7588 18.6329H5.95976V24.3671H12.1185V22.3737L10.9279 23.4808C10.8056 23.5945 10.6515 23.651 10.4977 23.651C10.3335 23.651 10.1696 23.5867 10.045 23.4588L8.5853 21.9636C8.33528 21.7075 8.33528 21.2924 8.5853 21.0363C8.83524 20.7802 9.2407 20.7802 9.49065 21.0363L10.519 22.0896L13.6087 19.217C13.8705 18.9735 14.2752 18.9935 14.513 19.2618C14.7506 19.5299 14.7311 19.9446 14.4693 20.1881L13.399 21.1832V25.0229C13.399 25.385 13.1123 25.6786 12.7588 25.6786H5.31957C4.966 25.6786 4.67938 25.385 4.67938 25.0229ZM14.5132 32.0583C14.7507 32.3265 14.731 32.7412 14.469 32.9845L13.399 33.9787V37.8191C13.399 38.1813 13.1123 38.4748 12.7588 38.4748H5.31957C4.966 38.4748 4.67938 38.1813 4.67938 37.8191V30.7733C4.67938 30.4112 4.966 30.1176 5.31957 30.1176H12.7588C13.1123 30.1176 13.399 30.4112 13.399 30.7733C13.399 31.1355 13.1123 31.4291 12.7588 31.4291H5.95976V37.1632H12.1185V35.1683L10.9277 36.2747C10.8055 36.3884 10.6515 36.4448 10.4977 36.4448C10.3337 36.4448 10.1699 36.3806 10.0453 36.253L8.58562 34.7601C8.33544 34.5042 8.33512 34.089 8.58498 33.8327C8.8346 33.5765 9.24006 33.5761 9.49032 33.8321L10.5188 34.884L13.6089 32.0129C13.8707 31.7697 14.2755 31.7899 14.5132 32.0583ZM17.0513 5.18084C17.0513 4.81867 17.338 4.52507 17.6915 4.52507H26.016C26.3695 4.52507 26.6562 4.81867 26.6562 5.18084C26.6562 5.54301 26.3695 5.83661 26.016 5.83661H17.6915C17.338 5.83661 17.0513 5.54301 17.0513 5.18084ZM17.0513 8.70371C17.0513 8.34154 17.338 8.04795 17.6915 8.04795H26.016C26.3695 8.04795 26.6562 8.34154 26.6562 8.70371C26.6562 9.06589 26.3695 9.35948 26.016 9.35948H17.6915C17.338 9.35948 17.0513 9.06589 17.0513 8.70371Z",
    fill: "currentColor"
  }
) }), LS = () => /* @__PURE__ */ f.jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M11 23C11 23.55 10.55 24 10 24H6C3.24 24 1 21.76 1 19V5C1 2.24 3.24 0 6 0H14C16.76 0 19 2.24 19 5V8C19 8.55 18.55 9 18 9C17.45 9 17 8.55 17 8V5C17 3.35 15.65 2 14 2H6C4.35 2 3 3.35 3 5V19C3 20.65 4.35 22 6 22H10C10.55 22 11 22.45 11 23Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M15 6C15 5.45 14.55 5 14 5H6C5.45 5 5 5.45 5 6C5 6.55 5.45 7 6 7H14C14.55 7 15 6.55 15 6Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M10 11C10 10.45 9.55 10 9 10H6C5.45 10 5 10.45 5 11C5 11.55 5.45 12 6 12H9C9.55 12 10 11.55 10 11Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M6 15C5.45 15 5 15.45 5 16C5 16.55 5.45 17 6 17H8C8.55 17 9 16.55 9 16C9 15.45 8.55 15 8 15H6Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M18.74 24C17.84 24 16.96 23.63 16.32 22.99L15.64 22.31H14.32C13.95 22.31 13.59 22.22 13.26 22.06C12.76 21.81 12.37 21.42 12.13 20.94C11.96 20.59 11.87 20.22 11.87 19.86V18.53L11.19 17.85C10.66 17.32 10.32 16.63 10.22 15.89C10.1 14.98 10.33 14.08 10.88 13.36C11.43 12.63 12.24 12.16 13.14 12.04L20.83 10.42C21.63 10.23 22.51 10.48 23.1 11.08C23.71 11.68 23.95 12.57 23.75 13.4L22.12 21.14C21.95 22.36 21.07 23.41 19.83 23.82C19.48 23.94 19.11 24 18.74 24ZM15.86 20.31C16.26 20.31 16.63 20.46 16.91 20.74L17.74 21.57C18.12 21.95 18.69 22.09 19.2 21.92C19.72 21.75 20.08 21.32 20.15 20.79L21.8 12.95C21.85 12.76 21.8 12.6 21.69 12.49C21.58 12.37 21.43 12.33 21.28 12.36L13.49 14C13.04 14.06 12.71 14.26 12.48 14.56C12.25 14.86 12.15 15.24 12.2 15.61C12.24 15.92 12.39 16.2 12.6 16.42L13.43 17.25C13.71 17.53 13.87 17.9 13.87 18.3V19.84C13.87 19.9 13.89 19.97 13.91 20.02C13.96 20.12 14.03 20.19 14.12 20.23C14.19 20.27 14.26 20.28 14.32 20.28H15.85L15.86 20.31Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M21.6975 11.0789L12.5409 20.1086L13.9452 21.5327L23.1019 12.503L21.6975 11.0789Z", fill: "currentColor" })
] }), kS = () => /* @__PURE__ */ f.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("g", { children: /* @__PURE__ */ f.jsx("path", { d: "M23.61 10.836L21.892 7.24396C21.674 6.78896 21.15 6.56596 20.673 6.72696L11.996 9.62296L3.30701 6.72796C2.83001 6.56896 2.30601 6.78996 2.08801 7.24596L0.436012 10.719C-0.0409879 11.511 -0.130988 12.462 0.189012 13.328C0.499012 14.168 1.15301 14.819 1.99001 15.123L1.98401 17.438C1.98401 19.595 3.35701 21.503 5.40301 22.185L9.76801 23.641C10.482 23.878 11.232 23.997 11.982 23.997C12.732 23.997 13.482 23.878 14.196 23.64L18.565 22.184C20.609 21.502 21.983 19.598 21.984 17.446L21.99 15.124C22.836 14.828 23.498 14.179 23.809 13.336C24.125 12.478 24.036 11.536 23.61 10.836ZM2.19401 11.666L3.51201 8.90296L10.577 11.257L8.95701 14.513C8.71501 14.919 8.22801 15.097 7.78301 14.949L2.70201 13.254C2.40401 13.155 2.17201 12.93 2.06301 12.636C1.95501 12.343 1.98601 12.02 2.19401 11.666ZM6.03601 20.289C4.80801 19.879 3.98301 18.734 3.98401 17.441L3.98801 15.791L7.15201 16.846C8.49801 17.292 9.94501 16.756 10.711 15.474L10.988 14.919L10.984 21.898C10.787 21.858 10.593 21.807 10.402 21.744L6.03701 20.289H6.03601ZM17.932 20.287L13.563 21.743C13.373 21.806 13.179 21.858 12.983 21.898L12.987 14.903L13.306 15.543C13.863 16.471 14.838 17.003 15.868 17.003C16.186 17.003 16.511 16.952 16.828 16.846L19.988 15.793L19.984 17.444C19.984 18.736 19.159 19.878 17.932 20.287ZM21.932 12.642C21.827 12.927 21.601 13.146 21.313 13.243L16.195 14.948C15.757 15.095 15.26 14.912 15.059 14.583L13.405 11.261L20.469 8.90396L21.851 11.784C22.007 12.045 22.038 12.357 21.932 12.642ZM5.21401 5.89596C4.82301 5.50496 4.82301 4.87296 5.21401 4.48196L9.11101 0.585959C9.89001 -0.193041 11.16 -0.193041 11.939 0.585959L13.535 2.18196C14.288 1.79696 15.273 1.91196 15.888 2.52696L18.143 4.78196C18.534 5.17296 18.534 5.80496 18.143 6.19596C17.752 6.58696 17.12 6.58696 16.729 6.19596L14.474 3.94096L11.323 7.09196C11.128 7.28696 10.872 7.38496 10.616 7.38496C10.36 7.38496 10.104 7.28696 9.90901 7.09196C9.51801 6.70096 9.51801 6.06896 9.90901 5.67796L12.056 3.53096L10.526 2.00096L6.62901 5.89696C6.43401 6.09196 6.17801 6.18996 5.92201 6.18996C5.66601 6.18996 5.41001 6.09196 5.21501 5.89696L5.21401 5.89596Z", fill: "currentColor" }) }) }), RS = () => /* @__PURE__ */ f.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsxs("g", { children: [
  /* @__PURE__ */ f.jsx("path", { d: "M16 0H8C6.67441 0.00158786 5.40356 0.528882 4.46622 1.46622C3.52888 2.40356 3.00159 3.67441 3 5V23C3.00014 23.1819 3.04989 23.3603 3.14388 23.516C3.23788 23.6717 3.37256 23.7989 3.53344 23.8837C3.69431 23.9686 3.87529 24.008 4.05688 23.9976C4.23847 23.9873 4.4138 23.9276 4.564 23.825L6.67 22.386L8.776 23.825C8.94239 23.9389 9.13934 23.9999 9.341 23.9999C9.54266 23.9999 9.73961 23.9389 9.906 23.825L12.006 22.386L14.106 23.825C14.2725 23.9392 14.4696 24.0003 14.6715 24.0003C14.8734 24.0003 15.0705 23.9392 15.237 23.825L17.337 22.387L19.437 23.824C19.5871 23.9263 19.7623 23.9857 19.9436 23.996C20.125 24.0062 20.3057 23.9669 20.4664 23.8821C20.627 23.7974 20.7616 23.6706 20.8556 23.5151C20.9496 23.3597 20.9996 23.1816 21 23V5C20.9984 3.67441 20.4711 2.40356 19.5338 1.46622C18.5964 0.528882 17.3256 0.00158786 16 0ZM19 21.1L17.9 20.348C17.7334 20.2336 17.5361 20.1724 17.334 20.1724C17.1319 20.1724 16.9346 20.2336 16.768 20.348L14.668 21.787L12.568 20.348C12.4015 20.2338 12.2044 20.1727 12.0025 20.1727C11.8006 20.1727 11.6035 20.2338 11.437 20.348L9.337 21.787L7.237 20.348C7.07071 20.2343 6.87396 20.1734 6.6725 20.1734C6.47105 20.1734 6.27429 20.2343 6.108 20.348L5 21.1V5C5 4.20435 5.31607 3.44129 5.87868 2.87868C6.44129 2.31607 7.20435 2 8 2H16C16.7956 2 17.5587 2.31607 18.1213 2.87868C18.6839 3.44129 19 4.20435 19 5V21.1Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M16 8H8C7.44772 8 7 8.44772 7 9C7 9.55228 7.44772 10 8 10H16C16.5523 10 17 9.55228 17 9C17 8.44772 16.5523 8 16 8Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M14 12H8C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14H14C14.5523 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12Z", fill: "currentColor" })
] }) }), BS = () => /* @__PURE__ */ f.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("g", { children: /* @__PURE__ */ f.jsx("path", { d: "M19 2H5C2.24 2 0 4.24 0 7V17C0 19.76 2.24 22 5 22H12C12.55 22 13 21.55 13 21C13 20.45 12.55 20 12 20H5C3.35 20 2 18.65 2 17V9H22V14C22 14.55 22.45 15 23 15C23.55 15 24 14.55 24 14V7C24 4.24 21.76 2 19 2ZM2 7C2 5.35 3.35 4 5 4H19C20.65 4 22 5.35 22 7H2ZM16.41 12.17C15.65 11.41 14.65 11 13.58 11H11.99C11.44 11 10.99 11.45 10.99 12V13.59C10.99 14.66 11.41 15.66 12.16 16.42L18.87 23.13C19.44 23.7 20.19 24.01 20.99 24.01C21.79 24.01 22.54 23.7 23.11 23.13C23.68 22.56 23.99 21.81 23.99 21.01C23.99 20.21 23.68 19.46 23.11 18.89L16.4 12.18L16.41 12.17ZM21.7 21.71C21.32 22.09 20.66 22.09 20.29 21.71L13.58 15C13.2 14.62 12.99 14.12 12.99 13.59V13H13.58C14.11 13 14.62 13.21 14.99 13.59L21.7 20.3C21.89 20.49 21.99 20.74 21.99 21.01C21.99 21.28 21.89 21.53 21.7 21.72V21.71Z", fill: "currentColor" }) }) }), VS = () => /* @__PURE__ */ f.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("g", { children: /* @__PURE__ */ f.jsx("path", { d: "M21 15H10.26C9.46 15 8.71 14.69 8.14 14.12L6.72 12.71C6.53 12.52 6.43 12.27 6.43 12C6.43 11.73 6.54 11.48 6.72 11.29L8.14 9.88C8.71 9.31 9.46 9 10.26 9H21C22.65 9 24 10.35 24 12C24 13.65 22.65 15 21 15ZM8.85 12L9.56 12.71C9.75 12.9 10 13 10.27 13H21.01C21.56 13 22.01 12.55 22.01 12C22.01 11.45 21.56 11 21.01 11H10.26C10 11 9.74 11.11 9.55 11.29L8.84 12H8.85ZM18 6H10.26C9.46 6 8.71 5.69 8.14 5.12L6.72 3.71C6.53 3.52 6.43 3.27 6.43 3C6.43 2.73 6.54 2.48 6.72 2.29L8.14 0.88C8.71 0.31 9.46 0 10.26 0H18C19.65 0 21 1.35 21 3C21 4.65 19.65 6 18 6ZM8.85 3L9.56 3.71C9.75 3.9 10 4 10.27 4H18.01C18.56 4 19.01 3.55 19.01 3C19.01 2.45 18.56 2 18.01 2H10.27C10.01 2 9.75 2.11 9.56 2.29L8.85 3ZM16 24H10.26C9.46 24 8.71 23.69 8.14 23.12L6.72 21.71C6.53 21.52 6.43 21.27 6.43 21C6.43 20.73 6.54 20.48 6.72 20.29L8.14 18.88C8.71 18.31 9.46 18 10.26 18H16C17.65 18 19 19.35 19 21C19 22.65 17.65 24 16 24ZM8.85 21L9.56 21.71C9.75 21.9 10 22 10.27 22H16.01C16.56 22 17.01 21.55 17.01 21C17.01 20.45 16.56 20 16.01 20H10.27C10.01 20 9.75 20.11 9.56 20.29L8.85 21ZM2 19C0.9 19 0 19.9 0 21C0 22.1 0.9 23 2 23C3.1 23 4 22.1 4 21C4 19.9 3.1 19 2 19ZM2 10C0.9 10 0 10.9 0 12C0 13.1 0.9 14 2 14C3.1 14 4 13.1 4 12C4 10.9 3.1 10 2 10ZM2 1C0.9 1 0 1.9 0 3C0 4.1 0.9 5 2 5C3.1 5 4 4.1 4 3C4 1.9 3.1 1 2 1Z", fill: "currentColor" }) }) }), HS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16",
    children: /* @__PURE__ */ f.jsx("path", { d: "M8 0c-.787 0-1.292.592-1.572 1.151A4.35 4.35 0 0 0 6 3v3.691l-2 1V7.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.191l-1.17.585A1.5 1.5 0 0 0 0 10.618V12a.5.5 0 0 0 .582.493l1.631-.272.313.937a.5.5 0 0 0 .948 0l.405-1.214 2.21-.369.375 2.253-1.318 1.318A.5.5 0 0 0 5.5 16h5a.5.5 0 0 0 .354-.854l-1.318-1.318.375-2.253 2.21.369.405 1.214a.5.5 0 0 0 .948 0l.313-.937 1.63.272A.5.5 0 0 0 16 12v-1.382a1.5 1.5 0 0 0-.83-1.342L14 8.691V7.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v.191l-2-1V3c0-.568-.14-1.271-.428-1.849C9.292.591 8.787 0 8 0M7 3c0-.432.11-.979.322-1.401C7.542 1.159 7.787 1 8 1s.458.158.678.599C8.889 2.02 9 2.569 9 3v4a.5.5 0 0 0 .276.447l5.448 2.724a.5.5 0 0 1 .276.447v.792l-5.418-.903a.5.5 0 0 0-.575.41l-.5 3a.5.5 0 0 0 .14.437l.646.646H6.707l.647-.646a.5.5 0 0 0 .14-.436l-.5-3a.5.5 0 0 0-.576-.411L1 11.41v-.792a.5.5 0 0 1 .276-.447l5.448-2.724A.5.5 0 0 0 7 7z" })
  }
), FS = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", d: "M6 8V1h1v6.117L8.743 6.07a.5.5 0 0 1 .514 0L11 7.117V1h1v7a.5.5 0 0 1-.757.429L9 7.083 6.757 8.43A.5.5 0 0 1 6 8" }),
  /* @__PURE__ */ f.jsx("path", { d: "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2" }),
  /* @__PURE__ */ f.jsx("path", { d: "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z" })
] }), WS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        "fill-rule": "evenodd",
        d: "M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5"
      }
    )
  }
), zS = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2z" }),
  /* @__PURE__ */ f.jsx("path", { d: "M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0M7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0" })
] }), US = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    "fill-rule": "evenodd",
    fill: "currentColor",
    d: "M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"
  }
) }), ZS = () => /* @__PURE__ */ f.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", children: /* @__PURE__ */ f.jsx("path", { d: "M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783" }) }), qS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5",
      fill: "currentColor"
    }
  )
] }), GS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx(
    "path",
    {
      "fill-rule": "evenodd",
      fill: "currentColor",
      d: "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0M8 1c-1.573 0-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4s.875 1.755 1.904 2.223C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777C13.125 5.755 14 5.007 14 4s-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1"
    }
  ),
  /* @__PURE__ */ f.jsx(
    "path",
    {
      "fill-rule": "evenodd",
      fill: "currentColor",
      d: "M2 7v-.839c.457.432 1.004.751 1.49.972C4.722 7.693 6.318 8 8 8s3.278-.307 4.51-.867c.486-.22 1.033-.54 1.49-.972V7c0 .424-.155.802-.411 1.133a4.51 4.51 0 0 0-4.815 1.843A12 12 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777C2.875 8.755 2 8.007 2 7m6.257 3.998L8 11c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13h.027a4.55 4.55 0 0 1 .23-2.002m-.002 3L8 14c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.5 4.5 0 0 1-1.3-1.905"
    }
  )
] }), YS = () => /* @__PURE__ */ f.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", className: "bi bi-star-fill", viewBox: "0 0 16 16", children: /* @__PURE__ */ f.jsx("path", { d: "M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" }) }), KS = {
  alert: /* @__PURE__ */ f.jsx(Pw, {}),
  AccessAlarm: /* @__PURE__ */ f.jsx(TS, {}),
  "arrow-down": /* @__PURE__ */ f.jsx(jw, {}),
  "arrow-left": /* @__PURE__ */ f.jsx(_w, {}),
  "arrow-right": /* @__PURE__ */ f.jsx(Aw, {}),
  "ArrowUpInBox ": /* @__PURE__ */ f.jsx(Dw, {}),
  "back-arrow": /* @__PURE__ */ f.jsx(Mw, {}),
  "check-mark": /* @__PURE__ */ f.jsx(Tw, {}),
  "circle-check": /* @__PURE__ */ f.jsx($w, {}),
  "circle-plus": /* @__PURE__ */ f.jsx(Nw, {}),
  close: /* @__PURE__ */ f.jsx(Lw, {}),
  clock: /* @__PURE__ */ f.jsx(Iw, {}),
  "collect-menu": /* @__PURE__ */ f.jsx(kw, {}),
  "column-actions": /* @__PURE__ */ f.jsx(Rw, {}),
  "column-order": /* @__PURE__ */ f.jsx(Bw, {}),
  config: /* @__PURE__ */ f.jsx(Vw, {}),
  dashboard: /* @__PURE__ */ f.jsx(Hw, {}),
  "devices-linked": /* @__PURE__ */ f.jsx(Fw, {}),
  "doc-config": /* @__PURE__ */ f.jsx(Ww, {}),
  drag: /* @__PURE__ */ f.jsx(zw, {}),
  duplicate: /* @__PURE__ */ f.jsx(Uw, {}),
  edit: /* @__PURE__ */ f.jsx(Zw, {}),
  export: /* @__PURE__ */ f.jsx(qw, {}),
  eye: /* @__PURE__ */ f.jsx(Gw, {}),
  "eye-hide": /* @__PURE__ */ f.jsx(Yw, {}),
  filter: /* @__PURE__ */ f.jsx(Kw, {}),
  "financing-config": /* @__PURE__ */ f.jsx(Xw, {}),
  "help-card": /* @__PURE__ */ f.jsx(Qw, {}),
  home: /* @__PURE__ */ f.jsx(Jw, {}),
  "home-2": /* @__PURE__ */ f.jsx(eO, {}),
  lock: /* @__PURE__ */ f.jsx(tO, {}),
  logout: /* @__PURE__ */ f.jsx(rO, {}),
  menu: /* @__PURE__ */ f.jsx(nO, {}),
  "menu-context": /* @__PURE__ */ f.jsx(aO, {}),
  notification: /* @__PURE__ */ f.jsx(iO, {}),
  play: /* @__PURE__ */ f.jsx(oO, {}),
  PlayCircleOutline: /* @__PURE__ */ f.jsx(sO, {}),
  plus: /* @__PURE__ */ f.jsx(lO, {}),
  projects: /* @__PURE__ */ f.jsx(cO, {}),
  question: /* @__PURE__ */ f.jsx(uO, {}),
  search: /* @__PURE__ */ f.jsx(fO, {}),
  sort: /* @__PURE__ */ f.jsx(dO, {}),
  "success-password": /* @__PURE__ */ f.jsx(pO, {}),
  "traffic-config": /* @__PURE__ */ f.jsx(hO, {}),
  SiacoLogo: /* @__PURE__ */ f.jsx(DS, {}),
  trash: /* @__PURE__ */ f.jsx(vO, {}),
  user: /* @__PURE__ */ f.jsx(mO, {}),
  "user-change": /* @__PURE__ */ f.jsx(gO, {}),
  "user-config": /* @__PURE__ */ f.jsx(yO, {}),
  "user-inactive": /* @__PURE__ */ f.jsx(bO, {}),
  "user-plus": /* @__PURE__ */ f.jsx(CO, {}),
  "user-team": /* @__PURE__ */ f.jsx(xO, {}),
  "user-profile": /* @__PURE__ */ f.jsx(bS, {}),
  view: /* @__PURE__ */ f.jsx(wO, {}),
  viewvalue: /* @__PURE__ */ f.jsx(OO, {}),
  "arrow-turn-down-right": /* @__PURE__ */ f.jsx(SO, {}),
  "memo-circle-check": /* @__PURE__ */ f.jsx(PO, {}),
  "circle-forbidden": /* @__PURE__ */ f.jsx(EO, {}),
  "circle-exclamation": /* @__PURE__ */ f.jsx(jO, {}),
  "triangle-exclamation": /* @__PURE__ */ f.jsx(_O, {}),
  "floppy-disk": /* @__PURE__ */ f.jsx(AO, {}),
  calendar: /* @__PURE__ */ f.jsx(DO, {}),
  "comment-pen": /* @__PURE__ */ f.jsx(MO, {}),
  "files-client": /* @__PURE__ */ f.jsx(TO, {}),
  "files-included": /* @__PURE__ */ f.jsx($O, {}),
  "map-location": /* @__PURE__ */ f.jsx(NO, {}),
  "phone-volume": /* @__PURE__ */ f.jsx(IO, {}),
  envelope: /* @__PURE__ */ f.jsx(LO, {}),
  whatsapp: /* @__PURE__ */ f.jsx(kO, {}),
  "folder-arrow-up": /* @__PURE__ */ f.jsx(RO, {}),
  "files-plus": /* @__PURE__ */ f.jsx(BO, {}),
  boat: /* @__PURE__ */ f.jsx(VO, {}),
  clone: /* @__PURE__ */ f.jsx(HO, {}),
  plane: /* @__PURE__ */ f.jsx(FO, {}),
  deposit: /* @__PURE__ */ f.jsx(WO, {}),
  "in-arrow": /* @__PURE__ */ f.jsx(zO, {}),
  "file-donwload": /* @__PURE__ */ f.jsx(UO, {}),
  "cloud-donwload": /* @__PURE__ */ f.jsx(ZO, {}),
  "circle-close": /* @__PURE__ */ f.jsx(qO, {}),
  "bar-code": /* @__PURE__ */ f.jsx(GO, {}),
  camera: /* @__PURE__ */ f.jsx(YO, {}),
  flash: /* @__PURE__ */ f.jsx(KO, {}),
  "camera-circle": /* @__PURE__ */ f.jsx(XO, {}),
  indicator: /* @__PURE__ */ f.jsx(QO, {}),
  airplane: /* @__PURE__ */ f.jsx(cS, {}),
  "boat-front": /* @__PURE__ */ f.jsx(uS, {}),
  "lower-limit": /* @__PURE__ */ f.jsx(fS, {}),
  "upper-limit": /* @__PURE__ */ f.jsx(dS, {}),
  signature: /* @__PURE__ */ f.jsx(pS, {}),
  map: /* @__PURE__ */ f.jsx(JO, {}),
  coin: /* @__PURE__ */ f.jsx(eS, {}),
  "send-arrow-up": /* @__PURE__ */ f.jsx(tS, {}),
  key: /* @__PURE__ */ f.jsx(rS, {}),
  genio: /* @__PURE__ */ f.jsx(nS, {}),
  "patch-check": /* @__PURE__ */ f.jsx(aS, {}),
  pencil: /* @__PURE__ */ f.jsx(iS, {}),
  cima: /* @__PURE__ */ f.jsx(oS, {}),
  computer: /* @__PURE__ */ f.jsx(sS, {}),
  world: /* @__PURE__ */ f.jsx(lS, {}),
  "refresh-circle": /* @__PURE__ */ f.jsx(hS, {}),
  "calendar-icon": /* @__PURE__ */ f.jsx(vS, {}),
  "calendar-check": /* @__PURE__ */ f.jsx(mS, {}),
  "calendar-close": /* @__PURE__ */ f.jsx(gS, {}),
  "calendar-exclamation": /* @__PURE__ */ f.jsx(yS, {}),
  "journal-check": /* @__PURE__ */ f.jsx(CS, {}),
  "clipboard-check": /* @__PURE__ */ f.jsx(xS, {}),
  circle: /* @__PURE__ */ f.jsx(wS, {}),
  "exclamation-diamond-fill": /* @__PURE__ */ f.jsx(OS, {}),
  "envelope-arrow-up": /* @__PURE__ */ f.jsx(SS, {}),
  "file-text-check": /* @__PURE__ */ f.jsx(PS, {}),
  "pencil-square": /* @__PURE__ */ f.jsx(ES, {}),
  power: /* @__PURE__ */ f.jsx(_S, {}),
  printer: /* @__PURE__ */ f.jsx(jS, {}),
  "file-earmark-check": /* @__PURE__ */ f.jsx(AS, {}),
  "hand-bag": /* @__PURE__ */ f.jsx(MS, {}),
  "node-fill-plus": /* @__PURE__ */ f.jsx($S, {}),
  "robot-icon": /* @__PURE__ */ f.jsx(NS, {}),
  "list-calendar": /* @__PURE__ */ f.jsx(IS, {}),
  "file-send": /* @__PURE__ */ f.jsx(LS, {}),
  "box-open": /* @__PURE__ */ f.jsx(kS, {}),
  invoice: /* @__PURE__ */ f.jsx(RS, {}),
  register: /* @__PURE__ */ f.jsx(BS, {}),
  list: /* @__PURE__ */ f.jsx(VS, {}),
  "airplane-engines": /* @__PURE__ */ f.jsx(HS, {}),
  "journal-bookmark": /* @__PURE__ */ f.jsx(FS, {}),
  "arrow-return-left": /* @__PURE__ */ f.jsx(WS, {}),
  "card-checklist": /* @__PURE__ */ f.jsx(zS, {}),
  ReturnArrowIcon: /* @__PURE__ */ f.jsx(Ew, {}),
  ArrowLeftRight: /* @__PURE__ */ f.jsx(US, {}),
  DatabaseFillAdd: /* @__PURE__ */ f.jsx(GS, {}),
  ClockHistory: /* @__PURE__ */ f.jsx(qS, {}),
  book: /* @__PURE__ */ f.jsx(ZS, {}),
  "start-fill": /* @__PURE__ */ f.jsx(YS, {})
}, pv = E.forwardRef((e, t) => {
  const {
    color: r,
    width: n = 20,
    widthFull: a = !1,
    isContain: i = !1,
    variant: o
  } = e, s = {
    width: a || i ? "100%" : n,
    height: i ? "100%" : void 0,
    color: r !== void 0 ? je[r] : void 0
  };
  return /* @__PURE__ */ f.jsx("i", { ref: t, className: `block pointer-events-none ${i ? "codeicon-contain" : ""}`, style: s, children: KS[o] });
});
pv.displayName = "CodeIcon";
const me = pv, hv = E.forwardRef((e, t) => {
  const {
    variant: r,
    size: n,
    icon: a,
    children: i,
    isFull: o = !1,
    asSpan: s = !1,
    isLoading: l = !1,
    onlyIcon: c = !1,
    onlyIconMobile: u = !1,
    hideIconDesktop: d = !1,
    unroundedRight: p = !1,
    unroundedLeft: h = !1,
    minWidth: m,
    active: v = !1,
    inactive: g = !1,
    tooltip: b,
    tooltipDirection: C = "top",
    ...w
  } = e, x = "bg-neutral-200 hover:bg-neutral-300 text-neutral-600", y = {
    primary: "bg-primary-100 text-primary-600 hover:bg-primary-300",
    "primary-bold": v ? "bg-primary-500 text-white " : "bg-primary-600 text-white hover:bg-primary-500",
    secondary: v ? "bg-secondary-600 text-white" : "bg-secondary-100 text-secondary-600 hover:bg-secondary-200",
    "secondary-light": v ? "bg-secondary-600 text-white" : "bg-secondary-200 text-secondary-600 hover:bg-secondary-300",
    "secondary-light-bold": "bg-secondary-300 text-secondary-600 hover:bg-secondary-400",
    "secondary-bold": "bg-secondary-600 text-white hover:bg-secondary-500",
    terciary: "bg-secondary-800 text-white hover:bg-secondary-700",
    accent: "bg-accent-600 text-white hover:bg-accent-500",
    info: "bg-info-500 text-white hover:bg-info-400",
    warning: "bg-warning-500 text-white hover:bg-warning-400",
    success: "bg-success-500 text-white hover:bg-success-400",
    error: "bg-error-500 text-white hover:bg-error-400",
    "error-light": v ? "bg-error-100 text-error-500" : "bg-error-50 text-error-500 hover:bg-error-100",
    "error-light-bold": "bg-error-200 text-error-500 hover:bg-error-300",
    "white-secondary": "bg-white text-secondary-600 hover:bg-secondary-100",
    completo: "bg-success-300 text-secondary-600 hover:bg-success-200",
    "completo-activo": "bg-success-400 text-secondary-600 hover:bg-success-300",
    pendiente: "bg-error-200 text-secondary-600 hover:bg-error-300",
    "pendiente-activo": "bg-primary-500 text-secondary-800 hover:bg-primary-400"
  }, O = `h-[3rem] ${u ? "px-0 m:px-[1rem]" : `${c ? "px-0" : "px-[1rem]"}`}`, P = "fill-neutral-200", j = {
    primary: "fill-primary-100",
    "primary-bold": "fill-primary-600",
    secondary: "fill-secondary-100",
    "secondary-light": "fill-secondary-200",
    "secondary-light-bold": "fill-secondary-300",
    "secondary-bold": "fill-secondary-600",
    terciary: "fill-secondary-800",
    accent: "fill-accent-600",
    info: "fill-info-500",
    warning: "fill-warning-500",
    success: "fill-success-500",
    error: "fill-error-500",
    "error-light": "fill-error-50",
    "error-light-bold": "fill-error-200",
    "white-secondary": "fill-white",
    completo: "fill-success-300",
    "completo-activo": "fill-success-400",
    pendiente: "fill-error-50",
    "pendiente-activo": "fill-primary-500"
  }, T = {
    xs: `h-[16px] ${u ? "px-0 m:px-[1rem]" : `${c ? "px-0" : "px-[1rem]"}`}`,
    s: `h-[32px] ${u ? "px-0 m:px-[1rem]" : `${c ? "px-0" : "px-[1rem]"}`}`,
    m: `h-10 ${u ? "px-0 m:px-[1rem]" : `${c ? "px-0" : "px-[1rem]"}`}`,
    l: `h-10 ${u ? "px-0 m:px-[1.25rem]" : `${c ? "px-0" : "px-[1.25rem]"}`}`,
    "2l": `h-10 ${u ? "px-0 m:px-[1.5rem]" : `${c ? "px-0" : "px-[1.5rem]"}`}`,
    xl: `h-[64px] ${u ? "px-0 m:px-[1.5rem]" : `${c ? "px-0" : "px-[1.5rem]"}`}`
  }, I = {
    top: "after:left-1/2 after:-translate-x-1/2 after:bottom-[calc(100%+15px)] before:left-1/2 before:-translate-x-1/2 before:bottom-[calc(100%+6px)] before:border-t-info-500 before:border-t-[9px] before:border-x-transparent before:border-x-[6px]",
    bottom: "after:left-1/2 after:-translate-x-1/2 after:top-[calc(100%+15px)] before:left-1/2 before:-translate-x-1/2 before:top-[calc(100%+6px)] before:border-b-info-500 before:border-b-[9px] before:border-x-transparent before:border-x-[6px]",
    left: "after:left-0 after:-translate-x-[calc(100%+15px)] after:top-1/2 after:-translate-y-1/2 before:left-0 before:-translate-x-[calc(100%+6px)] before:top-1/2 before:-translate-y-1/2 before:border-l-info-500 before:border-l-[9px] before:border-y-transparent before:border-y-[6px]",
    right: "after:right-0 after:translate-x-[calc(100%+15px)] after:top-1/2 after:-translate-y-1/2 before:right-0 before:translate-x-[calc(100%+6px)] before:top-1/2 before:-translate-y-1/2 before:border-r-info-500 before:border-r-[9px] before:border-y-transparent before:border-y-[6px]"
  }, R = $e([
    "cursor-pointer border border-transparent flex items-center font-bold relative leading-[100%]",
    "disabled:opacity-50 disabled:pointer-events-none",
    h ? void 0 : "rounded-l-md",
    p ? void 0 : "rounded-r-md",
    r !== void 0 ? g ? "bg-neutral-300 text-neutral-400 pointer-events-none" : y[r] : x,
    a !== void 0 ? c ? "aspect-square justify-center" : u ? d ? "gap-[10px] justify-center aspect-square m:aspect-auto" : "gap-[10px] justify-center m:max-w-[fit-content] aspect-square m:aspect-auto" : "gap-[10px] justify-center max-w-[fit-content]" : "justify-center",
    n !== void 0 ? T[n] : O,
    l ? "pointer-events-none" : void 0,
    o ? "w-full max-w-full" : void 0,
    m !== void 0 ? u ? "m:w-[var(--ck-button-min-width)]" : "w-[var(--ck-button-min-width)]" : void 0,
    b !== void 0 && !v ? `${I[C]}
        relative
        after:content-[attr(data-title)]
        after:absolute after:z-[10]
        after:bg-info-500 after:px-3 after:py-2 after:rounded-md
        after:text-s after:leading-[120%] after:text-white
        after:w-auto after:min-w-[240px] after:max-w-[360px]
        after:whitespace-pre-line after:break-normal after:text-left
        after:hidden hover:after:block
        before:absolute before:z-[10] before:hidden hover:before:block` : void 0
  ]), F = {};
  return m !== void 0 && (F["--ck-button-min-width"] = `${m}px`), s ? /* @__PURE__ */ f.jsxs(
    "span",
    {
      ref: t,
      className: R,
      style: F,
      "data-title": b,
      ...w,
      children: [
        a !== void 0 && /* @__PURE__ */ f.jsx("span", { className: `${a === "close" ? "w-[14px]" : "w-5"} aspect-square ${d ? "block m:hidden" : "block"}`, children: /* @__PURE__ */ f.jsx(me, { variant: a, isContain: !0 }) }),
        /* @__PURE__ */ f.jsx("p", { className: `${u ? "hidden m:block" : "block"}`, children: i })
      ]
    }
  ) : /* @__PURE__ */ f.jsxs(
    "button",
    {
      ref: t,
      className: R,
      style: F,
      "data-title": b,
      ...w,
      children: [
        a !== void 0 && /* @__PURE__ */ f.jsx("span", { className: `${a === "close" ? "w-[14px]" : "w-5"} aspect-square ${d ? "block m:hidden" : "block"}`, children: /* @__PURE__ */ f.jsx(me, { variant: a, isContain: !0 }) }),
        /* @__PURE__ */ f.jsx("p", { className: `${u ? "hidden m:block" : "block"}`, children: i }),
        l && /* @__PURE__ */ f.jsxs("div", { className: `absolute top-0 left-0 w-full h-full flex items-center justify-center ${r !== void 0 ? y[r] : x}`, children: [
          /* @__PURE__ */ f.jsxs(
            "svg",
            {
              "aria-hidden": "true",
              className: `h-[65%] aspect-square animate-spin ${r !== void 0 ? j[r] : P}`,
              viewBox: "0 0 100 101",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [
                /* @__PURE__ */ f.jsx("path", { d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z", fill: "currentColor" }),
                /* @__PURE__ */ f.jsx("path", { d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z", fill: "currentFill" })
              ]
            }
          ),
          /* @__PURE__ */ f.jsx("span", { className: "sr-only", children: "Loading..." })
        ] })
      ]
    }
  );
});
hv.displayName = "Button";
const gt = hv, yn = ua(null), XS = ({ children: e }) => {
  const [t, r] = ye(() => ({
    isCollapsedMenu: window.localStorage.getItem("cima-is-collapsed-menu") === "true",
    isOpenMenuUser: !1,
    isOpenNotifications: !1,
    isOpenMenu: !1
  })), n = () => {
    r((u) => ({
      ...u,
      isOpenMenu: !1,
      isOpenNotifications: !u.isOpenNotifications
    }));
  }, a = () => {
    r((u) => ({
      ...u,
      isOpenNotifications: !1
    }));
  }, i = () => {
    r((u) => ({
      ...u,
      isOpenNotifications: !1,
      isOpenMenu: !u.isOpenMenu
    }));
  }, o = () => {
    r((u) => ({
      ...u,
      isOpenMenu: !1
    }));
  }, s = () => {
    r((u) => {
      const d = !u.isCollapsedMenu;
      return window.localStorage.setItem("cima-is-collapsed-menu", d ? "true" : "false"), {
        ...u,
        isCollapsedMenu: d
      };
    });
  }, l = () => {
    r((u) => ({
      ...u,
      isOpenMenuUser: !u.isOpenMenuUser
    }));
  }, c = () => {
    r((u) => ({
      ...u,
      isOpenMenuUser: !1
    }));
  };
  return _e(() => {
    t.isOpenMenu ? document.body.classList.add("overflow-y-hidden-dashboard") : document.body.classList.remove("overflow-y-hidden-dashboard");
  }, [t.isOpenMenu]), /* @__PURE__ */ f.jsx(
    yn.Provider,
    {
      value: {
        isOpenMenu: t.isOpenMenu,
        isCollapsedMenu: t.isCollapsedMenu,
        isOpenNotifications: t.isOpenNotifications,
        isOpenMenuUser: t.isOpenMenuUser,
        toggleOpenMenu: i,
        closeMenu: o,
        toggleCollapsedMenu: s,
        toggleOpenNotifications: n,
        closeNotifications: a,
        toggleOpenMenuUser: l,
        closeMenuUser: c
      },
      children: e
    }
  );
};
XS.displayName = "Dashboard";
const QS = E.forwardRef((e, t) => {
  const {
    isPadding: r = !1,
    children: n,
    ...a
  } = e, i = Mt(yn), o = (i == null ? void 0 : i.isCollapsedMenu) ?? !1;
  return /* @__PURE__ */ f.jsx("main", { ref: t, className: `${r ? "px-4 py-4" : "px-0"} bg-white pb-[4.5rem] 2s:pb-4 2s:pt-[4.5rem] l:pt-[5rem] ${o ? "l:ml-[130px]" : "l:ml-72"}`, ...a, children: n });
});
QS.displayName = "DashboardMain";
const JS = E.forwardRef((e, t) => {
  const {
    text: r,
    color: n,
    children: a
  } = e, i = {
    color: n !== void 0 ? je[n] : void 0,
    fontWeight: n !== void 0 ? 600 : void 0
  }, o = {
    backgroundColor: n !== void 0 ? je[n] : je["neutral-300"]
  };
  return /* @__PURE__ */ f.jsxs("div", { ref: t, className: "flex flex-col 2s:flex-row 2s:justify-between gap-4 items-center", children: [
    /* @__PURE__ */ f.jsxs("div", { className: "relative text-center 2s:text-left 2s:flex-grow 2s:flex 2s:gap-4 2s:justify-between 2s:items-center", children: [
      r !== void 0 && /* @__PURE__ */ f.jsx("p", { className: "leading-[120%]", style: i, children: r }),
      /* @__PURE__ */ f.jsx("span", { className: "hidden 2s:block h-[1px] 2s:flex-grow", style: o })
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: "w-full 2s:w-auto", children: a })
  ] });
});
JS.displayName = "Divider";
const Hde = () => {
  const e = new CustomEvent("codekit:closeDropdown");
  document.dispatchEvent(e);
}, eP = {
  actions: "bg-white w-full min-w-[148px] max-w-[240px] p-4 shadow-l",
  box: "bg-white w-[287px] p-8 shadow-l text-center",
  "box-danger": "bg-error-100 w-[287px] p-8 text-center"
}, vv = E.forwardRef((e, t) => {
  const {
    button: r,
    variant: n = "box",
    children: a
  } = e, [i, o] = ye(!1), s = ve(null), l = ve(null), c = () => E.Children.map(r, (p) => E.cloneElement(p, {
    ref: s,
    active: i,
    onClick: () => {
      o((h) => !h);
    }
  })), u = () => E.Children.map(a, (p) => E.cloneElement(p, {
    closeDropdown: () => {
      o(!1);
    }
  })), d = (p) => {
    if (s.current !== null && !s.current.contains(p.target)) {
      if (l.current !== null) {
        if (l.current.contains(p.target))
          return;
        o(!1);
        return;
      }
      o(!1);
    }
  };
  return _e(() => {
    const p = () => {
      o(!1);
    };
    return document.addEventListener("codekit:closeDropdown", p, !0), () => {
      document.removeEventListener("codekit:closeDropdown", p, !0);
    };
  }, []), _e(() => (document.addEventListener("click", d, !0), () => {
    document.removeEventListener("click", d, !0);
  }), []), /* @__PURE__ */ f.jsxs("div", { ref: t, className: "relative max-w-[fit-content]", children: [
    c(),
    i && /* @__PURE__ */ f.jsx("div", { ref: l, className: "w-[max-content] absolute top-[calc(100%+5px)] z-[2] right-0 pb-[80px] pointer-events-none", children: /* @__PURE__ */ f.jsx(
      "div",
      {
        className: $e([
          eP[n],
          "rounded-md pointer-events-auto"
        ]),
        children: u()
      }
    ) })
  ] });
});
vv.displayName = "Dropdown";
const N3 = E.forwardRef((e, t) => {
  const {
    icon: r,
    children: n,
    onClick: a,
    closeDropdown: i,
    ...o
  } = e, s = (l) => {
    i !== void 0 && i(), a !== void 0 && a(l);
  };
  return /* @__PURE__ */ f.jsxs(
    "button",
    {
      ref: t,
      onClick: s,
      className: "text-secondary-600 gap-2 px-2 py-[10px] flex items-center hover:bg-secondary-200 w-full outline-none shadow-transparent rounded-md",
      ...o,
      children: [
        /* @__PURE__ */ f.jsx("span", { className: `${r === "close" ? "w-[14px]" : "w-5"} aspect-square block`, children: /* @__PURE__ */ f.jsx(me, { variant: r, isContain: !0 }) }),
        /* @__PURE__ */ f.jsx("div", { className: "flex-grow", children: /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] font-bold text-left", children: n }) })
      ]
    }
  );
});
N3.displayName = "DropdownAction";
const tP = E.forwardRef((e, t) => {
  const {
    children: r,
    columns: n,
    classxx: a
  } = e, i = "px-4 py-2 min-h-[40px] h-full leading-[120%] font-bold text-neutral-400 flex items-center";
  return /* @__PURE__ */ f.jsxs("div", { ref: t, className: "grid gap-2", children: [
    /* @__PURE__ */ f.jsx("div", { className: `hidden m:grid ${a || "grid-cols-export-table"}`, children: n.map((o) => /* @__PURE__ */ f.jsx("div", { className: i, style: { gridArea: o.key }, children: o.label }, o.key)) }),
    r
  ] });
});
tP.displayName = "ExportTable";
const rP = E.forwardRef((e, t) => {
  const {
    name: r,
    date: n,
    type: a,
    user: i,
    classxx: o,
    children: s
  } = e, l = "m:border-r m:border-white m:h-full m:flex m:items-center m:px-4 m:py-2 m:min-h-[48px]";
  return /* @__PURE__ */ f.jsxs("div", { ref: t, className: `grid ${o || "grid-cols-export-table"} items-center p-4 m:p-0 rounded-md bg-secondary-100 border border-neutral-100 leading-[120%]`, children: [
    /* @__PURE__ */ f.jsx("div", { style: { gridArea: "name" }, className: `font-bold pr-3 ${l}`, children: r }),
    /* @__PURE__ */ f.jsx("div", { style: { gridArea: "date" }, className: `mt-2 m:mt-0 ${l}`, children: n }),
    /* @__PURE__ */ f.jsx("div", { style: { gridArea: "type" }, className: `mt-2 m:mt-0 ${l}`, children: a }),
    i && /* @__PURE__ */ f.jsx(
      "div",
      {
        style: { gridArea: "user" },
        className: `mt-3 pt-3 border-t border-secondary-200 m:mt-0 m:border-r-none ${l}`,
        children: /* @__PURE__ */ f.jsxs("div", { className: "flex gap-2 items-center", children: [
          /* @__PURE__ */ f.jsx("div", { className: "w-[14px] min-w-[24px]", children: /* @__PURE__ */ f.jsx(x1, { size: "xs", image: i.image }) }),
          /* @__PURE__ */ f.jsx("div", { className: "flex-grow", children: /* @__PURE__ */ f.jsx("p", { children: i.name }) })
        ] })
      }
    ),
    /* @__PURE__ */ f.jsx("div", { style: { gridArea: "actions" }, className: "s:flex s:px-4 s:h-full s:items-center s:justify-center", children: /* @__PURE__ */ f.jsx("div", { className: "flex gap-2 items-center", children: s }) })
  ] });
});
rP.displayName = "ExportTableCol";
const nP = {
  normal: "normal",
  start: "flex-start",
  end: "flex-end",
  center: "center",
  between: "space-between",
  around: "space-around",
  evenly: "space-evenly",
  stretch: "stretch"
}, aP = {
  start: "flex-start",
  end: "flex-end",
  center: "center",
  baseline: "baseline",
  stretch: "stretch"
}, Qr = E.forwardRef((e, t) => {
  const {
    direction: r = "row",
    gap: n,
    gapY: a,
    gapX: i,
    justifyContent: o,
    alignItems: s,
    wrap: l = !1,
    minHeight: c,
    children: u,
    ...d
  } = e, p = {
    justifyContent: o !== void 0 ? nP[o] : void 0,
    alignItems: s !== void 0 ? aP[s] : void 0,
    flexWrap: l ? "wrap" : void 0,
    flexDirection: r,
    minHeight: c
  };
  return n !== void 0 ? p.gap = n !== void 0 ? `${n / 4}rem` : void 0 : (p.columnGap = i !== void 0 ? `${i / 4}rem` : void 0, p.rowGap = a !== void 0 ? `${a / 4}rem` : void 0), /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: "flex",
      style: p,
      ...d,
      children: u
    }
  );
});
Qr.displayName = "Flexbox";
const os = E.forwardRef((e, t) => {
  const {
    grow: r = !1,
    minWidth: n,
    children: a,
    ...i
  } = e, o = {
    flexGrow: r ? 1 : void 0
  };
  return n !== void 0 && (o.minWidth = `${n}px`), /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: "block",
      style: o,
      ...i,
      children: a
    }
  );
});
os.displayName = "FlexboxRow";
function mv(e, t = 500) {
  const [r, n] = ye(e);
  return _e(() => {
    const a = setTimeout(() => {
      n(e);
    }, t);
    return () => {
      clearTimeout(a);
    };
  }, [e, t]), r;
}
const iP = E.forwardRef((e, t) => {
  const {
    icon: r,
    variant: n = "default",
    isWarning: a = !1,
    isInvalid: i = !1,
    isSuccess: o = !1,
    selected: s = null,
    placeholder: l = "Search...",
    textLoading: c = "Cargando...",
    textNoResults: u = "No hay resultados",
    minLengthToSearch: d = 5,
    searchResults: p = [],
    disabled: h,
    readOnly: m,
    onChangeSearch: v,
    onItemClick: g,
    onResetSelected: b
  } = e, [C, w] = ye(""), [x, y] = ye(!1), [O, P] = ye(!1), j = ve(!0), T = mv(C), I = () => {
    P(!1);
  };
  return _e(() => {
    if (j.current) {
      j.current = !1;
      return;
    }
    if (!(h === !0 || m === !0)) {
      if (T.trim().length < d) {
        y(!1);
        return;
      }
      y(!0), v(T.trim(), I);
    }
  }, [T]), /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: $e([
        "relative flex w-full text-neutral-600 h-10"
      ]),
      children: [
        /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          s === null || s === "" ? /* @__PURE__ */ f.jsx(
            "input",
            {
              ref: t,
              type: "text",
              placeholder: l,
              value: C,
              onChange: (R) => {
                w(R.target.value), P(!0);
              },
              className: $e([
                "w-full h-full flex items-center border rounded-md outline-none shadow-transparent placeholder:text-neutral-400",
                m === !0 || h === !0 ? "cursor-default pointer-events-none" : "hover:border-secondary-400 focus:border-secondary-600",
                h === !0 ? "bg-neutral-300" : n === "default" ? "bg-neutral-200" : "bg-white",
                h === !0 ? "border-neutral-300" : i ? "border-error-500" : o ? "border-success-500" : n === "default" ? "border-neutral-300" : "border-secondary-300",
                r !== void 0 ? "pl-4 pr-[2.75rem]" : "px-4"
              ])
            }
          ) : /* @__PURE__ */ f.jsx(
            "div",
            {
              className: $e([
                "w-full h-full flex items-center border rounded-md",
                m === !0 || h === !0 ? "cursor-default pointer-events-none" : "hover:border-secondary-400",
                h === !0 ? "bg-neutral-300 border-neutral-300" : n === "default" ? "bg-neutral-200 border-neutral-300" : "bg-white border-secondary-300",
                r !== void 0 ? "pl-4 pr-[2.75rem]" : "px-4"
              ]),
              children: /* @__PURE__ */ f.jsxs(
                "div",
                {
                  className: $e([
                    "h-8 flex gap-2 items-center pr-2 overflow-hidden rounded-[24px] border",
                    m === !0 || h === !0 ? "pl-2" : "pl-4",
                    a ? "border-warning-1000 text-warning-1000 font-bold" : h === !0 ? "border-neutral-400 text-neutral-400" : m === !0 ? "border-secondary-400 text-secondary-400" : "border-secondary-600 text-secondary-600"
                  ]),
                  children: [
                    /* @__PURE__ */ f.jsx("div", { className: "flex-grow cursor-default overflow-hidden", children: /* @__PURE__ */ f.jsx("p", { className: "font-bold leading-[120%] text-ellipsis overflow-hidden whitespace-nowrap", children: s }) }),
                    m !== !0 && h !== !0 && /* @__PURE__ */ f.jsx("div", { className: "w-[20px] min-w-[20px] h-[20px]", children: /* @__PURE__ */ f.jsx(
                      "button",
                      {
                        type: "button",
                        className: "w-full h-full rounded-full bg-secondary-600 flex items-center justify-center text-white",
                        onClick: () => {
                          w(""), P(!1), y(!1), b();
                        },
                        children: /* @__PURE__ */ f.jsx(me, { variant: "close", width: 10 })
                      }
                    ) })
                  ]
                }
              )
            }
          ),
          r !== void 0 && /* @__PURE__ */ f.jsx("span", { className: "absolute right-[1rem] top-1/2 -translate-y-1/2 z-[1]", children: /* @__PURE__ */ f.jsx(me, { variant: r, width: 18 }) })
        ] }),
        x && /* @__PURE__ */ f.jsx("div", { className: "absolute top-[calc(100%+4px)] left-0 w-full pointer-events-none min-w-[280px] z-[1] pb-[80px]", children: /* @__PURE__ */ f.jsx("div", { className: "bg-white rounded-lg p-4 shadow-l w-full pointer-events-auto overflow-y-scroll table-main-scrollbar", style: { maxHeight: "250px" }, children: /* @__PURE__ */ f.jsx(f.Fragment, { children: O ? /* @__PURE__ */ f.jsxs("div", { className: "p-4 flex flex-col gap-4 items-center justify-center", children: [
          /* @__PURE__ */ f.jsxs(
            "svg",
            {
              "aria-hidden": "true",
              className: "w-[45px] aspect-square animate-spin fill-white text-secondary-600",
              viewBox: "0 0 100 101",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [
                /* @__PURE__ */ f.jsx("path", { d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z", fill: "currentColor" }),
                /* @__PURE__ */ f.jsx("path", { d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z", fill: "currentFill" })
              ]
            }
          ),
          /* @__PURE__ */ f.jsx("span", { children: c })
        ] }) : /* @__PURE__ */ f.jsx(f.Fragment, { children: p.length > 0 ? /* @__PURE__ */ f.jsx("ul", { children: p.map((R) => /* @__PURE__ */ f.jsxs(
          "li",
          {
            className: "flex gap-2 items-center cursor-pointer p-4 rounded-md hover:bg-secondary-100",
            onClick: () => {
              y(!1), g({ item: R });
            },
            children: [
              R.image !== void 0 && /* @__PURE__ */ f.jsx(x1, { size: "md", image: R.image }),
              /* @__PURE__ */ f.jsx("div", { className: "flex-grow", children: /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] font-bold", children: R.label }) })
            ]
          },
          R.id
        )) }) : /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col gap-4 items-center justify-center p-4", children: [
          /* @__PURE__ */ f.jsx(me, { variant: "search", width: 45, color: "secondary-600" }),
          /* @__PURE__ */ f.jsx("span", { className: "block mx-auto text-center w-[90%] max-w-[500px]", children: u })
        ] }) }) }) }) })
      ]
    }
  );
});
iP.displayName = "Autocomplete";
const gv = E.forwardRef((e, t) => {
  const {
    disabled: r,
    readOnly: n,
    checked: a = !1,
    type: i = "default",
    variant: o = "default",
    isBold: s = !1,
    variantSize: l = "sm",
    children: c,
    onChange: u,
    ...d
  } = e, p = (h) => {
    n === !0 || r === !0 || u !== void 0 && u(h);
  };
  return /* @__PURE__ */ f.jsxs("label", { className: `flex items-center ${l === "sm" ? "gap-4" : "gap-2"} select-none`, children: [
    /* @__PURE__ */ f.jsx("input", { ref: t, type: "checkbox", className: "hidden", checked: a, onChange: p, ...d }),
    i === "default" && /* @__PURE__ */ f.jsx(
      "span",
      {
        className: $e([
          "flex w-6 min-w-[24px] h-6 justify-center items-center border text-white overflow-hidden rounded-xs transition-colors",
          n === !0 || r === !0 ? "cursor-default pointer-events-none" : "cursor-pointer hover:border-secondary-400",
          r === !0 ? a ? "bg-neutral-400 border-neutral-400" : "bg-neutral-300 border-neutral-300" : a ? "bg-secondary-600 border-secondary-600 hover:border-secondary-600" : o === "default" ? "bg-neutral-200 border-neutral-300" : "bg-white border-secondary-300"
        ]),
        children: a && /* @__PURE__ */ f.jsx(me, { variant: "check-mark", width: 16 })
      }
    ),
    i === "switch" && /* @__PURE__ */ f.jsx(
      "div",
      {
        className: $e([
          "relative border rounded-[200px]",
          l === "xs" ? "h-5 w-[37px] min-w-[37px]" : "h-6 w-[54px] min-w-[54px]",
          n === !0 || r === !0 ? "cursor-default pointer-events-none" : "cursor-pointer",
          r === !0 ? a ? "bg-neutral-400 border-neutral-400" : "bg-neutral-300 border-neutral-300" : a ? "bg-secondary-600 border-secondary-600" : o === "white" ? "bg-white border-secondary-300 hover:border-secondary-400" : "bg-neutral-200 border-neutral-300 hover:border-secondary-400"
        ]),
        children: /* @__PURE__ */ f.jsx(
          "span",
          {
            className: $e([
              "block absolute transition-all rounded-full top-1/2 -translate-y-1/2",
              l === "sm" ? "w-5 h-5" : "w-4 h-4",
              a ? l === "sm" ? "left-[31px]" : "left-[17px]" : "left-[2px]",
              o === "default" || a || r === !0 ? "bg-white" : "bg-secondary-400"
            ])
          }
        )
      }
    ),
    /* @__PURE__ */ f.jsx("span", { className: "flex-grow", children: s ? /* @__PURE__ */ f.jsx(sr, { variant: "title-2", children: c }) : /* @__PURE__ */ f.jsx(hr, { variant: "description-2", children: c }) })
  ] });
});
gv.displayName = "Checkbox";
const oP = E.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e;
  return /* @__PURE__ */ f.jsx("span", { ref: t, ...n, className: "block text-s mt-1.5 leading-[120%] text-error-500", children: r });
});
oP.displayName = "FieldError";
const Qf = E.forwardRef((e, t) => {
  const {
    variant: r = "default",
    type: n = "text",
    isInvalid: a = !1,
    isSuccess: i = !1,
    isOtp: o = !1,
    iconLeft: s,
    iconRight: l,
    isWarning: c = !1,
    isBold: u = !1,
    disabled: d,
    readOnly: p,
    ...h
  } = e, [m, v] = ye(!1), g = d ? c ? "disabled:text-warning-1000" : "disabled:text-neutral-400" : "", b = d && u ? "disabled:font-bold" : "", C = p ? c ? "read-only:text-warning-1000" : "read-only:text-neutral-400" : "", w = p && u ? "read-only:font-bold" : "";
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: `relative w-full block text-neutral-600 ${o ? "h-[4.9rem]" : "h-10"}`,
      children: [
        /* @__PURE__ */ f.jsx(
          "input",
          {
            ref: t,
            disabled: d,
            readOnly: p,
            type: n === "password" ? m ? "text" : "password" : n,
            step: n === "number" ? "any" : "",
            className: $e([
              `
            flex items-center w-full h-full outline-none shadow-transparent
            border rounded-md text-neutral-600 leading-none
            hover:border-secondary-400
            focus:border-secondary-600
            placeholder:text-neutral-400
            disabled:bg-neutral-300 disabled:pointer-events-none
            read-only:hover:border-neutral-300 read-only:focus:border-neutral-300
          `,
              r === "white" ? "bg-white" : "bg-neutral-200",
              a ? "border-error-500" : i ? "border-success-500" : r === "white" ? "border-secondary-300" : "border-neutral-300",
              u ? "font-bold" : "",
              c ? "text-warning-1000" : "",
              g,
              b,
              C,
              w,
              o ? "text-center" : void 0,
              n === "password" ? "pl-[1rem] pr-[2.75rem]" : o ? "px-4" : `${l !== void 0 ? "pr-[2.75rem]" : "pr-4"} ${s !== void 0 ? "pl-[2.75rem]" : "pl-4"}`
            ]),
            ...h,
            onWheel: (x) => {
              n === "number" && x.currentTarget.blur();
            },
            max: n === "date" ? "3000-01-01" : ""
          }
        ),
        n === "password" ? /* @__PURE__ */ f.jsx(
          "button",
          {
            onClick: () => {
              v((x) => !x);
            },
            type: "button",
            className: "absolute right-[1rem] top-1/2 -translate-y-1/2 z-[1]",
            children: m ? /* @__PURE__ */ f.jsx(me, { variant: "eye-hide" }) : /* @__PURE__ */ f.jsx(me, { variant: "eye" })
          }
        ) : l !== void 0 ? /* @__PURE__ */ f.jsx("span", { className: "absolute right-[1rem] top-1/2 -translate-y-1/2 z-[1]", children: /* @__PURE__ */ f.jsx(me, { variant: l, width: 18 }) }) : s !== void 0 ? /* @__PURE__ */ f.jsx("span", { className: "absolute left-[1rem] top-1/2 -translate-y-1/2 z-[1]", children: /* @__PURE__ */ f.jsx(me, { variant: s, width: 18 }) }) : null
      ]
    }
  );
});
Qf.displayName = "Input";
const Jf = E.forwardRef((e, t) => {
  const {
    alignment: r,
    children: n,
    weight: a = "bold",
    color: i,
    icon: o,
    isHyperLink: s,
    tooltip: l,
    ...c
  } = e, u = {
    textAlign: r,
    fontWeight: a !== void 0 ? w1[a] : void 0,
    color: i !== void 0 ? je[i] : void 0
  }, d = l || (typeof n == "string" ? n : "");
  return /* @__PURE__ */ f.jsxs(
    "label",
    {
      ref: t,
      ...c,
      className: `block text-[1rem] mb-2 leading-[120%] ${s ? "underline text-secondary-600" : ""}`,
      style: u,
      title: d,
      children: [
        o !== void 0 && /* @__PURE__ */ f.jsx("span", { className: "inline-block w-7", children: /* @__PURE__ */ f.jsx(me, { variant: o }) }),
        n
      ]
    }
  );
});
Jf.displayName = "Label";
const sP = E.forwardRef((e, t) => {
  const {
    value: r,
    readOnly: n,
    disabled: a,
    checked: i = !1,
    isBold: o = !1,
    variant: s = "default",
    children: l,
    onChange: c,
    ...u
  } = e, d = (p) => {
    n === !0 || a === !0 || c !== void 0 && c(p);
  };
  return /* @__PURE__ */ f.jsxs("label", { className: "flex items-center gap-3 select-none", children: [
    /* @__PURE__ */ f.jsx("input", { ref: t, type: "radio", className: "hidden", checked: i, onChange: d, ...u }),
    /* @__PURE__ */ f.jsx(
      "span",
      {
        className: $e([
          "flex w-6 min-w-[24px] h-6 justify-center items-center overflow-hidden rounded-full border",
          n === !0 || a === !0 ? "cursor-default pointer-events-none" : "cursor-pointer",
          a === !0 ? `${i ? "bg-white" : "bg-neutral-300"} border-neutral-300` : s === "white" ? `bg-white ${i ? "border-secondary-600" : "border-secondary-300"}` : `bg-neutral-200 ${i ? "border-secondary-600" : "border-neutral-300"}`,
          i ? void 0 : "hover:border-secondary-400"
        ]),
        children: /* @__PURE__ */ f.jsx("span", { className: `block w-[18px] h-[18px] overflow-hidden ${a === !0 ? "bg-neutral-300" : "bg-secondary-600"} rounded-full transition-opacity ${i ? "opacity-100" : "opacity-0"}` })
      }
    ),
    /* @__PURE__ */ f.jsx("span", { className: "flex-grow", children: o ? /* @__PURE__ */ f.jsx(sr, { variant: "title-2", children: l }) : /* @__PURE__ */ f.jsx(hr, { variant: "description-2", children: l }) })
  ] });
});
sP.displayName = "Radio";
const I3 = E.forwardRef((e, t) => {
  const {
    options: r = [],
    value: n = "",
    variant: a = "default",
    readOnly: i = !1,
    disabled: o = !1,
    isInvalid: s = !1,
    isSuccess: l = !1,
    placeholder: c = "Seleccione una opción",
    onChangeValue: u
  } = e, [d, p] = ye(!1), h = ve(null), m = ve(null), v = r.find((C) => C.value === n), g = (v == null ? void 0 : v.text) ?? c, b = (C) => {
    if (h.current !== null && !h.current.contains(C.target)) {
      if (m.current !== null) {
        if (m.current.contains(C.target))
          return;
        p(!1);
        return;
      }
      p(!1);
    }
  };
  return _e(() => (document.addEventListener("click", b, !0), () => {
    document.removeEventListener("click", b, !0);
  }), []), /* @__PURE__ */ f.jsx("div", { ref: t, className: `w-full block text-neutral-600 ${a === "no-border" ? "h-[38px]" : "h-10"}`, children: /* @__PURE__ */ f.jsxs("div", { className: "relative w-full h-full", children: [
    /* @__PURE__ */ f.jsxs(
      "div",
      {
        ref: h,
        onClick: () => {
          !i && !o && r.length > 0 && p((C) => !C);
        },
        className: $e([
          "rounded-md flex items-center w-full gap-3 h-full px-4 leading-none",
          i ? "" : "cursor-pointer select-none",
          o ? "bg-neutral-300 text-neutral-400 pointer-events-none" : a === "white" ? "bg-white text-neutral-600" : "bg-neutral-200 text-neutral-600",
          d ? "border-secondary-600" : i ? "" : "hover:border-secondary-400",
          o ? "border border-neutral-300" : a !== "no-border" ? s ? d ? "border border-secondary-600" : "border border-error-500" : l ? d ? "border border-secondary-600" : "border border-success-500" : a === "white" ? "border border-secondary-300" : "border border-neutral-300" : void 0
        ]),
        children: [
          /* @__PURE__ */ f.jsx("div", { className: "flex-grow overflow-hidden", children: /* @__PURE__ */ f.jsx("div", { className: "w-full pointer-events-none text-clamp-1 leading-[32px] break-all", children: g }) }),
          r.length > 0 && /* @__PURE__ */ f.jsx("span", { className: `w-[14px] min-w-[14px] ${d ? "rotate-180" : ""}`, children: /* @__PURE__ */ f.jsx(me, { variant: "arrow-down", width: 14 }) })
        ]
      }
    ),
    d && r.length > 0 && !i && !o && /* @__PURE__ */ f.jsx("div", { ref: m, className: "absolute top-[calc(100%+8px)] left-0 w-full min-w-[250px] z-[1500] overflow-y-scroll table-main-scrollbar", style: { maxHeight: "250px" }, children: /* @__PURE__ */ f.jsx("ul", { className: "bg-white shadow-l rounded-md p-4 pointer-events-auto", children: r.map((C) => /* @__PURE__ */ f.jsx(
      "li",
      {
        className: `font-bold leading-[120%] p-4 cursor-pointer rounded-md ${n === C.value ? "bg-secondary-600 text-white" : "bg-white hover:bg-secondary-100"}`,
        onClick: () => {
          p(!1), n !== C.value && u !== void 0 && u({ option: C });
        },
        children: C.text
      },
      C.value
    )) }) })
  ] }) });
});
I3.displayName = "Select";
var L3 = { exports: {} }, d2, g5;
function lP() {
  if (g5)
    return d2;
  g5 = 1;
  function e(A) {
    return A && typeof A == "object" && "default" in A ? A.default : A;
  }
  var t = e(E), r = Xf;
  function n(A, _) {
    for (var N = Object.getOwnPropertyNames(_), M = 0; M < N.length; M++) {
      var S = N[M], B = Object.getOwnPropertyDescriptor(_, S);
      B && B.configurable && A[S] === void 0 && Object.defineProperty(A, S, B);
    }
    return A;
  }
  function a() {
    return (a = Object.assign || function(A) {
      for (var _ = 1; _ < arguments.length; _++) {
        var N = arguments[_];
        for (var M in N)
          Object.prototype.hasOwnProperty.call(N, M) && (A[M] = N[M]);
      }
      return A;
    }).apply(this, arguments);
  }
  function i(A, _) {
    A.prototype = Object.create(_.prototype), n(A.prototype.constructor = A, _);
  }
  function o(A, _) {
    if (A == null)
      return {};
    var N, M, S = {}, B = Object.keys(A);
    for (M = 0; M < B.length; M++)
      N = B[M], 0 <= _.indexOf(N) || (S[N] = A[N]);
    return S;
  }
  function s(A) {
    if (A === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return A;
  }
  var l = function(A, _, N, M, S, B, G, U) {
    if (!A) {
      var H;
      if (_ === void 0)
        H = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      else {
        var k = [N, M, S, B, G, U], L = 0;
        (H = new Error(_.replace(/%s/g, function() {
          return k[L++];
        }))).name = "Invariant Violation";
      }
      throw H.framesToPop = 1, H;
    }
  }, c = l;
  function u(A, _, N) {
    if ("selectionStart" in A && "selectionEnd" in A)
      A.selectionStart = _, A.selectionEnd = N;
    else {
      var M = A.createTextRange();
      M.collapse(!0), M.moveStart("character", _), M.moveEnd("character", N - _), M.select();
    }
  }
  function d(A) {
    var _ = 0, N = 0;
    if ("selectionStart" in A && "selectionEnd" in A)
      _ = A.selectionStart, N = A.selectionEnd;
    else {
      var M = document.selection.createRange();
      M.parentElement() === A && (_ = -M.moveStart("character", -A.value.length), N = -M.moveEnd("character", -A.value.length));
    }
    return { start: _, end: N, length: N - _ };
  }
  var p = { 9: "[0-9]", a: "[A-Za-z]", "*": "[A-Za-z0-9]" }, h = "_";
  function m(A, _, N) {
    var M = "", S = "", B = null, G = [];
    if (_ === void 0 && (_ = h), N == null && (N = p), !A || typeof A != "string")
      return { maskChar: _, formatChars: N, mask: null, prefix: null, lastEditablePosition: null, permanents: [] };
    var U = !1;
    return A.split("").forEach(function(H) {
      U = !U && H === "\\" || (U || !N[H] ? (G.push(M.length), M.length === G.length - 1 && (S += H)) : B = M.length + 1, M += H, !1);
    }), { maskChar: _, formatChars: N, prefix: S, mask: M, lastEditablePosition: B, permanents: G };
  }
  function v(A, _) {
    return A.permanents.indexOf(_) !== -1;
  }
  function g(A, _, N) {
    var M = A.mask, S = A.formatChars;
    if (!N)
      return !1;
    if (v(A, _))
      return M[_] === N;
    var B = S[M[_]];
    return new RegExp(B).test(N);
  }
  function b(A, _) {
    return _.split("").every(function(N, M) {
      return v(A, M) || !g(A, M, N);
    });
  }
  function C(A, _) {
    var N = A.maskChar, M = A.prefix;
    if (!N) {
      for (; _.length > M.length && v(A, _.length - 1); )
        _ = _.slice(0, _.length - 1);
      return _.length;
    }
    for (var S = M.length, B = _.length; B >= M.length; B--) {
      var G = _[B];
      if (!v(A, B) && g(A, B, G)) {
        S = B + 1;
        break;
      }
    }
    return S;
  }
  function w(A, _) {
    return C(A, _) === A.mask.length;
  }
  function x(A, _) {
    var N = A.maskChar, M = A.mask, S = A.prefix;
    if (!N) {
      for ((_ = O(A, "", _, 0)).length < S.length && (_ = S); _.length < M.length && v(A, _.length); )
        _ += M[_.length];
      return _;
    }
    if (_)
      return O(A, x(A, ""), _, 0);
    for (var B = 0; B < M.length; B++)
      v(A, B) ? _ += M[B] : _ += N;
    return _;
  }
  function y(A, _, N, M) {
    var S = N + M, B = A.maskChar, G = A.mask, U = A.prefix, H = _.split("");
    if (B)
      return H.map(function(L, W) {
        return W < N || S <= W ? L : v(A, W) ? G[W] : B;
      }).join("");
    for (var k = S; k < H.length; k++)
      v(A, k) && (H[k] = "");
    return N = Math.max(U.length, N), H.splice(N, S - N), _ = H.join(""), x(A, _);
  }
  function O(A, _, N, M) {
    var S = A.mask, B = A.maskChar, G = A.prefix, U = N.split(""), H = w(A, _);
    return !B && M > _.length && (_ += S.slice(_.length, M)), U.every(function(k) {
      for (; D = k, v(A, V = M) && D !== S[V]; ) {
        if (M >= _.length && (_ += S[M]), L = k, W = M, B && v(A, W) && L === B)
          return !0;
        if (++M >= S.length)
          return !1;
      }
      var L, W, V, D;
      return !g(A, M, k) && k !== B || (M < _.length ? _ = B || H || M < G.length ? _.slice(0, M) + k + _.slice(M + 1) : (_ = _.slice(0, M) + k + _.slice(M), x(A, _)) : B || (_ += k), ++M < S.length);
    }), _;
  }
  function P(A, _, N, M) {
    var S = A.mask, B = A.maskChar, G = N.split(""), U = M;
    return G.every(function(H) {
      for (; L = H, v(A, k = M) && L !== S[k]; )
        if (++M >= S.length)
          return !1;
      var k, L;
      return (g(A, M, H) || H === B) && M++, M < S.length;
    }), M - U;
  }
  function j(A, _) {
    for (var N = _; 0 <= N; --N)
      if (!v(A, N))
        return N;
    return null;
  }
  function T(A, _) {
    for (var N = A.mask, M = _; M < N.length; ++M)
      if (!v(A, M))
        return M;
    return null;
  }
  function I(A) {
    return A || A === 0 ? A + "" : "";
  }
  function R(A, _, N, M, S) {
    var B = A.mask, G = A.prefix, U = A.lastEditablePosition, H = _, k = "", L = 0, W = 0, V = Math.min(S.start, N.start);
    return N.end > S.start ? W = (L = P(A, M, k = H.slice(S.start, N.end), V)) ? S.length : 0 : H.length < M.length && (W = M.length - H.length), H = M, W && (W === 1 && !S.length && (V = S.start === N.start ? T(A, N.start) : j(A, N.start)), H = y(A, H, V, W)), H = O(A, H, k, V), (V += L) >= B.length ? V = B.length : V < G.length && !L ? V = G.length : V >= G.length && V < U && L && (V = T(A, V)), k || (k = null), { value: H = x(A, H), enteredString: k, selection: { start: V, end: V } };
  }
  function F() {
    var A = new RegExp("windows", "i"), _ = new RegExp("phone", "i"), N = navigator.userAgent;
    return A.test(N) && _.test(N);
  }
  function $(A) {
    return typeof A == "function";
  }
  function Z() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  }
  function X() {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
  }
  function K(A) {
    return (X() ? Z() : function() {
      return setTimeout(A, 1e3 / 60);
    })(A);
  }
  function J(A) {
    (X() || clearTimeout)(A);
  }
  var ee = function(A) {
    function _(M) {
      var S = A.call(this, M) || this;
      S.focused = !1, S.mounted = !1, S.previousSelection = null, S.selectionDeferId = null, S.saveSelectionLoopDeferId = null, S.saveSelectionLoop = function() {
        S.previousSelection = S.getSelection(), S.saveSelectionLoopDeferId = K(S.saveSelectionLoop);
      }, S.runSaveSelectionLoop = function() {
        S.saveSelectionLoopDeferId === null && S.saveSelectionLoop();
      }, S.stopSaveSelectionLoop = function() {
        S.saveSelectionLoopDeferId !== null && (J(S.saveSelectionLoopDeferId), S.saveSelectionLoopDeferId = null, S.previousSelection = null);
      }, S.getInputDOMNode = function() {
        if (!S.mounted)
          return null;
        var Q = r.findDOMNode(s(s(S))), z = typeof window < "u" && Q instanceof window.Element;
        if (Q && !z)
          return null;
        if (Q.nodeName !== "INPUT" && (Q = Q.querySelector("input")), !Q)
          throw new Error("react-input-mask: inputComponent doesn't contain input node");
        return Q;
      }, S.getInputValue = function() {
        var Q = S.getInputDOMNode();
        return Q ? Q.value : null;
      }, S.setInputValue = function(Q) {
        var z = S.getInputDOMNode();
        z && (S.value = Q, z.value = Q);
      }, S.setCursorToEnd = function() {
        var Q = C(S.maskOptions, S.value), z = T(S.maskOptions, Q);
        z !== null && S.setCursorPosition(z);
      }, S.setSelection = function(Q, z, te) {
        te === void 0 && (te = {});
        var ne = S.getInputDOMNode(), ae = S.isFocused();
        ne && ae && (te.deferred || u(ne, Q, z), S.selectionDeferId !== null && J(S.selectionDeferId), S.selectionDeferId = K(function() {
          S.selectionDeferId = null, u(ne, Q, z);
        }), S.previousSelection = { start: Q, end: z, length: Math.abs(z - Q) });
      }, S.getSelection = function() {
        return d(S.getInputDOMNode());
      }, S.getCursorPosition = function() {
        return S.getSelection().start;
      }, S.setCursorPosition = function(Q) {
        S.setSelection(Q, Q);
      }, S.isFocused = function() {
        return S.focused;
      }, S.getBeforeMaskedValueChangeConfig = function() {
        var Q = S.maskOptions, z = Q.mask, te = Q.maskChar, ne = Q.permanents, ae = Q.formatChars;
        return { mask: z, maskChar: te, permanents: ne, alwaysShowMask: !!S.props.alwaysShowMask, formatChars: ae };
      }, S.isInputAutofilled = function(Q, z, te, ne) {
        var ae = S.getInputDOMNode();
        try {
          if (ae.matches(":-webkit-autofill"))
            return !0;
        } catch {
        }
        return !S.focused || ne.end < te.length && z.end === Q.length;
      }, S.onChange = function(Q) {
        var z = s(s(S)).beforePasteState, te = s(s(S)).previousSelection, ne = S.props.beforeMaskedValueChange, ae = S.getInputValue(), se = S.value, pe = S.getSelection();
        S.isInputAutofilled(ae, pe, se, te) && (se = x(S.maskOptions, ""), te = { start: 0, end: 0, length: 0 }), z && (te = z.selection, se = z.value, pe = { start: te.start + ae.length, end: te.start + ae.length, length: 0 }, ae = se.slice(0, te.start) + ae + se.slice(te.end), S.beforePasteState = null);
        var ue = R(S.maskOptions, ae, pe, se, te), Te = ue.enteredString, Be = ue.selection, Ye = ue.value;
        if ($(ne)) {
          var Ct = ne({ value: Ye, selection: Be }, { value: se, selection: te }, Te, S.getBeforeMaskedValueChangeConfig());
          Ye = Ct.value, Be = Ct.selection;
        }
        S.setInputValue(Ye), $(S.props.onChange) && S.props.onChange(Q), S.isWindowsPhoneBrowser ? S.setSelection(Be.start, Be.end, { deferred: !0 }) : S.setSelection(Be.start, Be.end);
      }, S.onFocus = function(Q) {
        var z = S.props.beforeMaskedValueChange, te = S.maskOptions, ne = te.mask, ae = te.prefix;
        if (S.focused = !0, S.mounted = !0, ne) {
          if (S.value)
            C(S.maskOptions, S.value) < S.maskOptions.mask.length && S.setCursorToEnd();
          else {
            var se = x(S.maskOptions, ae), pe = x(S.maskOptions, se), ue = C(S.maskOptions, pe), Te = T(S.maskOptions, ue), Be = { start: Te, end: Te };
            if ($(z)) {
              var Ye = z({ value: pe, selection: Be }, { value: S.value, selection: null }, null, S.getBeforeMaskedValueChangeConfig());
              pe = Ye.value, Be = Ye.selection;
            }
            var Ct = pe !== S.getInputValue();
            Ct && S.setInputValue(pe), Ct && $(S.props.onChange) && S.props.onChange(Q), S.setSelection(Be.start, Be.end);
          }
          S.runSaveSelectionLoop();
        }
        $(S.props.onFocus) && S.props.onFocus(Q);
      }, S.onBlur = function(Q) {
        var z = S.props.beforeMaskedValueChange, te = S.maskOptions.mask;
        if (S.stopSaveSelectionLoop(), S.focused = !1, te && !S.props.alwaysShowMask && b(S.maskOptions, S.value)) {
          var ne = "";
          $(z) && (ne = z({ value: ne, selection: null }, { value: S.value, selection: S.previousSelection }, null, S.getBeforeMaskedValueChangeConfig()).value);
          var ae = ne !== S.getInputValue();
          ae && S.setInputValue(ne), ae && $(S.props.onChange) && S.props.onChange(Q);
        }
        $(S.props.onBlur) && S.props.onBlur(Q);
      }, S.onMouseDown = function(Q) {
        if (!S.focused && document.addEventListener) {
          S.mouseDownX = Q.clientX, S.mouseDownY = Q.clientY, S.mouseDownTime = (/* @__PURE__ */ new Date()).getTime();
          var z = function te(ne) {
            if (document.removeEventListener("mouseup", te), S.focused) {
              var ae = Math.abs(ne.clientX - S.mouseDownX), se = Math.abs(ne.clientY - S.mouseDownY), pe = Math.max(ae, se), ue = (/* @__PURE__ */ new Date()).getTime() - S.mouseDownTime;
              (pe <= 10 && ue <= 200 || pe <= 5 && ue <= 300) && S.setCursorToEnd();
            }
          };
          document.addEventListener("mouseup", z);
        }
        $(S.props.onMouseDown) && S.props.onMouseDown(Q);
      }, S.onPaste = function(Q) {
        $(S.props.onPaste) && S.props.onPaste(Q), Q.defaultPrevented || (S.beforePasteState = { value: S.getInputValue(), selection: S.getSelection() }, S.setInputValue(""));
      }, S.handleRef = function(Q) {
        S.props.children == null && $(S.props.inputRef) && S.props.inputRef(Q);
      };
      var B = M.mask, G = M.maskChar, U = M.formatChars, H = M.alwaysShowMask, k = M.beforeMaskedValueChange, L = M.defaultValue, W = M.value;
      S.maskOptions = m(B, G, U), L == null && (L = ""), W == null && (W = L);
      var V = I(W);
      if (S.maskOptions.mask && (H || V) && (V = x(S.maskOptions, V), $(k))) {
        var D = M.value;
        M.value == null && (D = L), V = k({ value: V, selection: null }, { value: D = I(D), selection: null }, null, S.getBeforeMaskedValueChangeConfig()).value;
      }
      return S.value = V, S;
    }
    i(_, A);
    var N = _.prototype;
    return N.componentDidMount = function() {
      this.mounted = !0, this.getInputDOMNode() && (this.isWindowsPhoneBrowser = F(), this.maskOptions.mask && this.getInputValue() !== this.value && this.setInputValue(this.value));
    }, N.componentDidUpdate = function() {
      var M = this.previousSelection, S = this.props, B = S.beforeMaskedValueChange, G = S.alwaysShowMask, U = S.mask, H = S.maskChar, k = S.formatChars, L = this.maskOptions, W = G || this.isFocused(), V = this.props.value != null, D = V ? I(this.props.value) : this.value, Q = M ? M.start : null;
      if (this.maskOptions = m(U, H, k), this.maskOptions.mask) {
        !L.mask && this.isFocused() && this.runSaveSelectionLoop();
        var z = this.maskOptions.mask && this.maskOptions.mask !== L.mask;
        if (L.mask || V || (D = this.getInputValue()), (z || this.maskOptions.mask && (D || W)) && (D = x(this.maskOptions, D)), z) {
          var te = C(this.maskOptions, D);
          (Q === null || te < Q) && (Q = w(this.maskOptions, D) ? te : T(this.maskOptions, te));
        }
        !this.maskOptions.mask || !b(this.maskOptions, D) || W || V && this.props.value || (D = "");
        var ne = { start: Q, end: Q };
        if ($(B)) {
          var ae = B({ value: D, selection: ne }, { value: this.value, selection: this.previousSelection }, null, this.getBeforeMaskedValueChangeConfig());
          D = ae.value, ne = ae.selection;
        }
        this.value = D;
        var se = this.getInputValue() !== this.value;
        se ? (this.setInputValue(this.value), this.forceUpdate()) : z && this.forceUpdate();
        var pe = !1;
        ne.start != null && ne.end != null && (pe = !M || M.start !== ne.start || M.end !== ne.end), (pe || se) && this.setSelection(ne.start, ne.end);
      } else
        L.mask && (this.stopSaveSelectionLoop(), this.forceUpdate());
    }, N.componentWillUnmount = function() {
      this.mounted = !1, this.selectionDeferId !== null && J(this.selectionDeferId), this.stopSaveSelectionLoop();
    }, N.render = function() {
      var M, S = this.props, B = (S.mask, S.alwaysShowMask, S.maskChar, S.formatChars, S.inputRef, S.beforeMaskedValueChange, S.children), G = o(S, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]);
      if (B) {
        $(B) || c(!1);
        var U = ["onChange", "onPaste", "onMouseDown", "onFocus", "onBlur", "value", "disabled", "readOnly"], H = a({}, G);
        U.forEach(function(L) {
          return delete H[L];
        }), M = B(H), U.filter(function(L) {
          return M.props[L] != null && M.props[L] !== G[L];
        }).length && c(!1);
      } else
        M = t.createElement("input", a({ ref: this.handleRef }, G));
      var k = { onFocus: this.onFocus, onBlur: this.onBlur };
      return this.maskOptions.mask && (G.disabled || G.readOnly || (k.onChange = this.onChange, k.onPaste = this.onPaste, k.onMouseDown = this.onMouseDown), G.value != null && (k.value = this.value)), M = t.cloneElement(M, k);
    }, _;
  }(t.Component);
  return d2 = ee, d2;
}
var p2, y5;
function cP() {
  if (y5)
    return p2;
  y5 = 1;
  var e = function(t, r, n, a, i, o, s, l) {
    if (process.env.NODE_ENV !== "production" && r === void 0)
      throw new Error("invariant requires an error message argument");
    if (!t) {
      var c;
      if (r === void 0)
        c = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      else {
        var u = [n, a, i, o, s, l], d = 0;
        c = new Error(
          r.replace(/%s/g, function() {
            return u[d++];
          })
        ), c.name = "Invariant Violation";
      }
      throw c.framesToPop = 1, c;
    }
  };
  return p2 = e, p2;
}
var h2, b5;
function uP() {
  if (b5)
    return h2;
  b5 = 1;
  var e = process.env.NODE_ENV !== "production", t = function() {
  };
  if (e) {
    var r = function(a, i) {
      var o = arguments.length;
      i = new Array(o > 1 ? o - 1 : 0);
      for (var s = 1; s < o; s++)
        i[s - 1] = arguments[s];
      var l = 0, c = "Warning: " + a.replace(/%s/g, function() {
        return i[l++];
      });
      typeof console < "u" && console.error(c);
      try {
        throw new Error(c);
      } catch {
      }
    };
    t = function(n, a, i) {
      var o = arguments.length;
      i = new Array(o > 2 ? o - 2 : 0);
      for (var s = 2; s < o; s++)
        i[s - 2] = arguments[s];
      if (a === void 0)
        throw new Error(
          "`warning(condition, format, ...args)` requires a warning message argument"
        );
      n || r.apply(null, [a].concat(i));
    };
  }
  return h2 = t, h2;
}
var v2, C5;
function fP() {
  if (C5)
    return v2;
  C5 = 1;
  function e(A) {
    return A && typeof A == "object" && "default" in A ? A.default : A;
  }
  var t = e(E), r = Xf, n = e(cP()), a = e(uP());
  function i(A, _) {
    for (var N = Object.getOwnPropertyNames(_), M = 0; M < N.length; M++) {
      var S = N[M], B = Object.getOwnPropertyDescriptor(_, S);
      B && B.configurable && A[S] === void 0 && Object.defineProperty(A, S, B);
    }
    return A;
  }
  function o() {
    return o = Object.assign || function(A) {
      for (var _ = 1; _ < arguments.length; _++) {
        var N = arguments[_];
        for (var M in N)
          Object.prototype.hasOwnProperty.call(N, M) && (A[M] = N[M]);
      }
      return A;
    }, o.apply(this, arguments);
  }
  function s(A, _) {
    A.prototype = Object.create(_.prototype), A.prototype.constructor = A, i(A, _);
  }
  function l(A, _) {
    if (A == null)
      return {};
    var N = {}, M = Object.keys(A), S, B;
    for (B = 0; B < M.length; B++)
      S = M[B], !(_.indexOf(S) >= 0) && (N[S] = A[S]);
    return N;
  }
  function c(A) {
    if (A === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return A;
  }
  function u(A, _, N) {
    if ("selectionStart" in A && "selectionEnd" in A)
      A.selectionStart = _, A.selectionEnd = N;
    else {
      var M = A.createTextRange();
      M.collapse(!0), M.moveStart("character", _), M.moveEnd("character", N - _), M.select();
    }
  }
  function d(A) {
    var _ = 0, N = 0;
    if ("selectionStart" in A && "selectionEnd" in A)
      _ = A.selectionStart, N = A.selectionEnd;
    else {
      var M = document.selection.createRange();
      M.parentElement() === A && (_ = -M.moveStart("character", -A.value.length), N = -M.moveEnd("character", -A.value.length));
    }
    return {
      start: _,
      end: N,
      length: N - _
    };
  }
  var p = {
    9: "[0-9]",
    a: "[A-Za-z]",
    "*": "[A-Za-z0-9]"
  }, h = "_";
  function m(A, _, N) {
    var M = "", S = "", B = null, G = [];
    if (_ === void 0 && (_ = h), N == null && (N = p), !A || typeof A != "string")
      return {
        maskChar: _,
        formatChars: N,
        mask: null,
        prefix: null,
        lastEditablePosition: null,
        permanents: []
      };
    var U = !1;
    return A.split("").forEach(function(H) {
      !U && H === "\\" ? U = !0 : (U || !N[H] ? (G.push(M.length), M.length === G.length - 1 && (S += H)) : B = M.length + 1, M += H, U = !1);
    }), {
      maskChar: _,
      formatChars: N,
      prefix: S,
      mask: M,
      lastEditablePosition: B,
      permanents: G
    };
  }
  function v(A, _) {
    return A.permanents.indexOf(_) !== -1;
  }
  function g(A, _, N) {
    var M = A.mask, S = A.formatChars;
    if (!N)
      return !1;
    if (v(A, _))
      return M[_] === N;
    var B = M[_], G = S[B];
    return new RegExp(G).test(N);
  }
  function b(A, _) {
    return _.split("").every(function(N, M) {
      return v(A, M) || !g(A, M, N);
    });
  }
  function C(A, _) {
    var N = A.maskChar, M = A.prefix;
    if (!N) {
      for (; _.length > M.length && v(A, _.length - 1); )
        _ = _.slice(0, _.length - 1);
      return _.length;
    }
    for (var S = M.length, B = _.length; B >= M.length; B--) {
      var G = _[B], U = !v(A, B) && g(A, B, G);
      if (U) {
        S = B + 1;
        break;
      }
    }
    return S;
  }
  function w(A, _) {
    return C(A, _) === A.mask.length;
  }
  function x(A, _) {
    var N = A.maskChar, M = A.mask, S = A.prefix;
    if (!N) {
      for (_ = O(A, "", _, 0), _.length < S.length && (_ = S); _.length < M.length && v(A, _.length); )
        _ += M[_.length];
      return _;
    }
    if (_) {
      var B = x(A, "");
      return O(A, B, _, 0);
    }
    for (var G = 0; G < M.length; G++)
      v(A, G) ? _ += M[G] : _ += N;
    return _;
  }
  function y(A, _, N, M) {
    var S = N + M, B = A.maskChar, G = A.mask, U = A.prefix, H = _.split("");
    if (!B) {
      for (var k = S; k < H.length; k++)
        v(A, k) && (H[k] = "");
      return N = Math.max(U.length, N), H.splice(N, S - N), _ = H.join(""), x(A, _);
    }
    return H.map(function(L, W) {
      return W < N || W >= S ? L : v(A, W) ? G[W] : B;
    }).join("");
  }
  function O(A, _, N, M) {
    var S = A.mask, B = A.maskChar, G = A.prefix, U = N.split(""), H = w(A, _), k = function(V, D) {
      return !v(A, V) || D === S[V];
    }, L = function(V, D) {
      return !B || !v(A, D) || V !== B;
    };
    return !B && M > _.length && (_ += S.slice(_.length, M)), U.every(function(W) {
      for (; !k(M, W); ) {
        if (M >= _.length && (_ += S[M]), !L(W, M))
          return !0;
        if (M++, M >= S.length)
          return !1;
      }
      var V = g(A, M, W) || W === B;
      return V ? (M < _.length ? B || H || M < G.length ? _ = _.slice(0, M) + W + _.slice(M + 1) : (_ = _.slice(0, M) + W + _.slice(M), _ = x(A, _)) : B || (_ += W), M++, M < S.length) : !0;
    }), _;
  }
  function P(A, _, N, M) {
    var S = A.mask, B = A.maskChar, G = N.split(""), U = M, H = function(L, W) {
      return !v(A, L) || W === S[L];
    };
    return G.every(function(k) {
      for (; !H(M, k); )
        if (M++, M >= S.length)
          return !1;
      var L = g(A, M, k) || k === B;
      return L && M++, M < S.length;
    }), M - U;
  }
  function j(A, _) {
    for (var N = _; N >= 0; --N)
      if (!v(A, N))
        return N;
    return null;
  }
  function T(A, _) {
    for (var N = A.mask, M = _; M < N.length; ++M)
      if (!v(A, M))
        return M;
    return null;
  }
  function I(A) {
    return !A && A !== 0 ? "" : A + "";
  }
  function R(A, _, N, M, S) {
    var B = A.mask, G = A.prefix, U = A.lastEditablePosition, H = _, k = "", L = 0, W = 0, V = Math.min(S.start, N.start);
    if (N.end > S.start ? (k = H.slice(S.start, N.end), L = P(A, M, k, V), L ? W = S.length : W = 0) : H.length < M.length && (W = M.length - H.length), H = M, W) {
      if (W === 1 && !S.length) {
        var D = S.start === N.start;
        V = D ? T(A, N.start) : j(A, N.start);
      }
      H = y(A, H, V, W);
    }
    return H = O(A, H, k, V), V = V + L, V >= B.length ? V = B.length : V < G.length && !L ? V = G.length : V >= G.length && V < U && L && (V = T(A, V)), H = x(A, H), k || (k = null), {
      value: H,
      enteredString: k,
      selection: {
        start: V,
        end: V
      }
    };
  }
  function F() {
    var A = new RegExp("windows", "i"), _ = new RegExp("phone", "i"), N = navigator.userAgent;
    return A.test(N) && _.test(N);
  }
  function $(A) {
    return typeof A == "function";
  }
  function Z() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  }
  function X() {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
  }
  function K(A) {
    var _ = !!X(), N;
    return _ ? N = Z() : N = function() {
      return setTimeout(A, 1e3 / 60);
    }, N(A);
  }
  function J(A) {
    var _ = X() || clearTimeout;
    _(A);
  }
  var ee = /* @__PURE__ */ function(A) {
    s(_, A);
    function _(M) {
      var S;
      S = A.call(this, M) || this, S.focused = !1, S.mounted = !1, S.previousSelection = null, S.selectionDeferId = null, S.saveSelectionLoopDeferId = null, S.saveSelectionLoop = function() {
        S.previousSelection = S.getSelection(), S.saveSelectionLoopDeferId = K(S.saveSelectionLoop);
      }, S.runSaveSelectionLoop = function() {
        S.saveSelectionLoopDeferId === null && S.saveSelectionLoop();
      }, S.stopSaveSelectionLoop = function() {
        S.saveSelectionLoopDeferId !== null && (J(S.saveSelectionLoopDeferId), S.saveSelectionLoopDeferId = null, S.previousSelection = null);
      }, S.getInputDOMNode = function() {
        if (!S.mounted)
          return null;
        var z = r.findDOMNode(c(c(S))), te = typeof window < "u" && z instanceof window.Element;
        if (z && !te)
          return null;
        if (z.nodeName !== "INPUT" && (z = z.querySelector("input")), !z)
          throw new Error("react-input-mask: inputComponent doesn't contain input node");
        return z;
      }, S.getInputValue = function() {
        var z = S.getInputDOMNode();
        return z ? z.value : null;
      }, S.setInputValue = function(z) {
        var te = S.getInputDOMNode();
        te && (S.value = z, te.value = z);
      }, S.setCursorToEnd = function() {
        var z = C(S.maskOptions, S.value), te = T(S.maskOptions, z);
        te !== null && S.setCursorPosition(te);
      }, S.setSelection = function(z, te, ne) {
        ne === void 0 && (ne = {});
        var ae = S.getInputDOMNode(), se = S.isFocused();
        if (!(!ae || !se)) {
          var pe = ne, ue = pe.deferred;
          ue || u(ae, z, te), S.selectionDeferId !== null && J(S.selectionDeferId), S.selectionDeferId = K(function() {
            S.selectionDeferId = null, u(ae, z, te);
          }), S.previousSelection = {
            start: z,
            end: te,
            length: Math.abs(te - z)
          };
        }
      }, S.getSelection = function() {
        var z = S.getInputDOMNode();
        return d(z);
      }, S.getCursorPosition = function() {
        return S.getSelection().start;
      }, S.setCursorPosition = function(z) {
        S.setSelection(z, z);
      }, S.isFocused = function() {
        return S.focused;
      }, S.getBeforeMaskedValueChangeConfig = function() {
        var z = S.maskOptions, te = z.mask, ne = z.maskChar, ae = z.permanents, se = z.formatChars, pe = S.props.alwaysShowMask;
        return {
          mask: te,
          maskChar: ne,
          permanents: ae,
          alwaysShowMask: !!pe,
          formatChars: se
        };
      }, S.isInputAutofilled = function(z, te, ne, ae) {
        var se = S.getInputDOMNode();
        try {
          if (se.matches(":-webkit-autofill"))
            return !0;
        } catch {
        }
        return S.focused ? ae.end < ne.length && te.end === z.length : !0;
      }, S.onChange = function(z) {
        var te = c(c(S)), ne = te.beforePasteState, ae = c(c(S)), se = ae.previousSelection, pe = S.props.beforeMaskedValueChange, ue = S.getInputValue(), Te = S.value, Be = S.getSelection();
        S.isInputAutofilled(ue, Be, Te, se) && (Te = x(S.maskOptions, ""), se = {
          start: 0,
          end: 0,
          length: 0
        }), ne && (se = ne.selection, Te = ne.value, Be = {
          start: se.start + ue.length,
          end: se.start + ue.length,
          length: 0
        }, ue = Te.slice(0, se.start) + ue + Te.slice(se.end), S.beforePasteState = null);
        var Ye = R(S.maskOptions, ue, Be, Te, se), Ct = Ye.enteredString, It = Ye.selection, Wr = Ye.value;
        if ($(pe)) {
          var Sn = pe({
            value: Wr,
            selection: It
          }, {
            value: Te,
            selection: se
          }, Ct, S.getBeforeMaskedValueChangeConfig());
          Wr = Sn.value, It = Sn.selection;
        }
        S.setInputValue(Wr), $(S.props.onChange) && S.props.onChange(z), S.isWindowsPhoneBrowser ? S.setSelection(It.start, It.end, {
          deferred: !0
        }) : S.setSelection(It.start, It.end);
      }, S.onFocus = function(z) {
        var te = S.props.beforeMaskedValueChange, ne = S.maskOptions, ae = ne.mask, se = ne.prefix;
        if (S.focused = !0, S.mounted = !0, ae) {
          if (S.value)
            C(S.maskOptions, S.value) < S.maskOptions.mask.length && S.setCursorToEnd();
          else {
            var pe = x(S.maskOptions, se), ue = x(S.maskOptions, pe), Te = C(S.maskOptions, ue), Be = T(S.maskOptions, Te), Ye = {
              start: Be,
              end: Be
            };
            if ($(te)) {
              var Ct = te({
                value: ue,
                selection: Ye
              }, {
                value: S.value,
                selection: null
              }, null, S.getBeforeMaskedValueChangeConfig());
              ue = Ct.value, Ye = Ct.selection;
            }
            var It = ue !== S.getInputValue();
            It && S.setInputValue(ue), It && $(S.props.onChange) && S.props.onChange(z), S.setSelection(Ye.start, Ye.end);
          }
          S.runSaveSelectionLoop();
        }
        $(S.props.onFocus) && S.props.onFocus(z);
      }, S.onBlur = function(z) {
        var te = S.props.beforeMaskedValueChange, ne = S.maskOptions.mask;
        if (S.stopSaveSelectionLoop(), S.focused = !1, ne && !S.props.alwaysShowMask && b(S.maskOptions, S.value)) {
          var ae = "";
          if ($(te)) {
            var se = te({
              value: ae,
              selection: null
            }, {
              value: S.value,
              selection: S.previousSelection
            }, null, S.getBeforeMaskedValueChangeConfig());
            ae = se.value;
          }
          var pe = ae !== S.getInputValue();
          pe && S.setInputValue(ae), pe && $(S.props.onChange) && S.props.onChange(z);
        }
        $(S.props.onBlur) && S.props.onBlur(z);
      }, S.onMouseDown = function(z) {
        if (!S.focused && document.addEventListener) {
          S.mouseDownX = z.clientX, S.mouseDownY = z.clientY, S.mouseDownTime = (/* @__PURE__ */ new Date()).getTime();
          var te = function ne(ae) {
            if (document.removeEventListener("mouseup", ne), !!S.focused) {
              var se = Math.abs(ae.clientX - S.mouseDownX), pe = Math.abs(ae.clientY - S.mouseDownY), ue = Math.max(se, pe), Te = (/* @__PURE__ */ new Date()).getTime() - S.mouseDownTime;
              (ue <= 10 && Te <= 200 || ue <= 5 && Te <= 300) && S.setCursorToEnd();
            }
          };
          document.addEventListener("mouseup", te);
        }
        $(S.props.onMouseDown) && S.props.onMouseDown(z);
      }, S.onPaste = function(z) {
        $(S.props.onPaste) && S.props.onPaste(z), z.defaultPrevented || (S.beforePasteState = {
          value: S.getInputValue(),
          selection: S.getSelection()
        }, S.setInputValue(""));
      }, S.handleRef = function(z) {
        S.props.children == null && $(S.props.inputRef) && S.props.inputRef(z);
      };
      var B = M.mask, G = M.maskChar, U = M.formatChars, H = M.alwaysShowMask, k = M.beforeMaskedValueChange, L = M.defaultValue, W = M.value;
      S.maskOptions = m(B, G, U), L == null && (L = ""), W == null && (W = L);
      var V = I(W);
      if (S.maskOptions.mask && (H || V) && (V = x(S.maskOptions, V), $(k))) {
        var D = M.value;
        M.value == null && (D = L), D = I(D);
        var Q = k({
          value: V,
          selection: null
        }, {
          value: D,
          selection: null
        }, null, S.getBeforeMaskedValueChangeConfig());
        V = Q.value;
      }
      return S.value = V, S;
    }
    var N = _.prototype;
    return N.componentDidMount = function() {
      this.mounted = !0, this.getInputDOMNode() && (this.isWindowsPhoneBrowser = F(), this.maskOptions.mask && this.getInputValue() !== this.value && this.setInputValue(this.value));
    }, N.componentDidUpdate = function() {
      var S = this.previousSelection, B = this.props, G = B.beforeMaskedValueChange, U = B.alwaysShowMask, H = B.mask, k = B.maskChar, L = B.formatChars, W = this.maskOptions, V = U || this.isFocused(), D = this.props.value != null, Q = D ? I(this.props.value) : this.value, z = S ? S.start : null;
      if (this.maskOptions = m(H, k, L), this.maskOptions.mask)
        !W.mask && this.isFocused() && this.runSaveSelectionLoop();
      else {
        W.mask && (this.stopSaveSelectionLoop(), this.forceUpdate());
        return;
      }
      var te = this.maskOptions.mask && this.maskOptions.mask !== W.mask;
      if (!W.mask && !D && (Q = this.getInputValue()), (te || this.maskOptions.mask && (Q || V)) && (Q = x(this.maskOptions, Q)), te) {
        var ne = C(this.maskOptions, Q);
        (z === null || ne < z) && (w(this.maskOptions, Q) ? z = ne : z = T(this.maskOptions, ne));
      }
      this.maskOptions.mask && b(this.maskOptions, Q) && !V && (!D || !this.props.value) && (Q = "");
      var ae = {
        start: z,
        end: z
      };
      if ($(G)) {
        var se = G({
          value: Q,
          selection: ae
        }, {
          value: this.value,
          selection: this.previousSelection
        }, null, this.getBeforeMaskedValueChangeConfig());
        Q = se.value, ae = se.selection;
      }
      this.value = Q;
      var pe = this.getInputValue() !== this.value;
      pe ? (this.setInputValue(this.value), this.forceUpdate()) : te && this.forceUpdate();
      var ue = !1;
      ae.start != null && ae.end != null && (ue = !S || S.start !== ae.start || S.end !== ae.end), (ue || pe) && this.setSelection(ae.start, ae.end);
    }, N.componentWillUnmount = function() {
      this.mounted = !1, this.selectionDeferId !== null && J(this.selectionDeferId), this.stopSaveSelectionLoop();
    }, N.render = function() {
      var S = this.props, B = S.mask;
      S.alwaysShowMask;
      var G = S.maskChar, U = S.formatChars, H = S.inputRef;
      S.beforeMaskedValueChange;
      var k = S.children, L = l(S, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]), W;
      if (process.env.NODE_ENV !== "production" && a(
        // parse mask to test against actual mask prop as this.maskOptions
        // will be updated later in componentDidUpdate
        !L.maxLength || !m(B, G, U).mask,
        "react-input-mask: maxLength property shouldn't be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length."
      ), k) {
        $(k) || (process.env.NODE_ENV !== "production" ? n(!1, "react-input-mask: children must be a function") : n(!1));
        var V = ["onChange", "onPaste", "onMouseDown", "onFocus", "onBlur", "value", "disabled", "readOnly"], D = o({}, L);
        V.forEach(function(te) {
          return delete D[te];
        }), W = k(D);
        var Q = V.filter(function(te) {
          return W.props[te] != null && W.props[te] !== L[te];
        });
        Q.length && (process.env.NODE_ENV !== "production" ? n(!1, "react-input-mask: the following props should be passed to the react-input-mask's component and should not be altered in children's function: " + Q.join(", ")) : n(!1)), process.env.NODE_ENV !== "production" && a(!H, "react-input-mask: inputRef is ignored when children is passed, attach ref to the children instead");
      } else
        W = t.createElement("input", o({
          ref: this.handleRef
        }, L));
      var z = {
        onFocus: this.onFocus,
        onBlur: this.onBlur
      };
      return this.maskOptions.mask && (!L.disabled && !L.readOnly && (z.onChange = this.onChange, z.onPaste = this.onPaste, z.onMouseDown = this.onMouseDown), L.value != null && (z.value = this.value)), W = t.cloneElement(W, z), W;
    }, _;
  }(t.Component);
  return v2 = ee, v2;
}
process.env.NODE_ENV === "production" ? L3.exports = lP() : L3.exports = fP();
var dP = L3.exports;
const pP = /* @__PURE__ */ Ze(dP), hP = E.forwardRef((e, t) => {
  const {
    variant: r = "default",
    mask: n = "",
    maskChar: a = "",
    isInvalid: i = !1,
    isSuccess: o = !1,
    ...s
  } = e, l = ve(null);
  return /* @__PURE__ */ f.jsx("div", { className: "relative w-full block text-neutral-600 h-10", ref: t, children: /* @__PURE__ */ f.jsx(
    pP,
    {
      inputRef: l,
      mask: n,
      maskChar: a,
      className: $e([
        `
            flex items-center w-full h-full outline-none shadow-transparent
            border rounded-md text-neutral-600 leading-none
            hover:border-secondary-400
            focus:border-secondary-600
            placeholder:text-neutral-400
            disabled:text-neutral-400 disabled:bg-neutral-300 disabled:pointer-events-none
            read-only:hover:border-neutral-300 read-only:focus:border-neutral-300 read-only:text-neutral-400 pl-4
          `,
        r === "white" ? "bg-white" : "bg-neutral-200",
        i ? "border-error-500" : o ? "border-success-500" : r === "white" ? "border-secondary-300" : "border-neutral-300"
      ]),
      ...s
    }
  ) });
});
hP.displayName = "InputMask";
const vP = E.forwardRef((e, t) => {
  const {
    variant: r = "default",
    isInvalid: n = !1,
    isSuccess: a = !1,
    ...i
  } = e;
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      className: "relative w-full block text-neutral-600",
      children: /* @__PURE__ */ f.jsx(
        "textarea",
        {
          ref: t,
          className: $e([
            `
            flex items-center w-full h-full outline-none shadow-transparent
            border rounded-md text-neutral-600 leading-none
            hover:border-secondary-400
            focus:border-secondary-600
            placeholder:text-neutral-400
            disabled:text-neutral-400 disabled:bg-neutral-300 disabled:pointer-events-none
            read-only:hover:border-neutral-300 read-only:focus:border-neutral-300 read-only:text-neutral-400
            p-2 resize-none
          `,
            r === "white" ? "bg-white" : "bg-neutral-200",
            n ? "border-error-500" : a ? "border-success-500" : r === "white" ? "border-secondary-300" : "border-neutral-300"
          ]),
          ...i,
          style: { height: "100px" }
        }
      )
    }
  );
});
vP.displayName = "Textarea";
const mP = E.forwardRef((e, t) => {
  const {
    options: r = [],
    value: n = "",
    variant: a = "default",
    readOnly: i = !1,
    disabled: o = !1,
    isInvalid: s = !1,
    isSuccess: l = !1,
    placeholder: c = "Seleccione una opción",
    onChangeValue: u
  } = e, [d, p] = ye(!1), h = ve(null), m = ve(null);
  let v = {};
  r.forEach((C) => {
    const { options: w } = C, x = w.find((y) => y.value === n);
    if (x !== void 0) {
      v = x;
      return;
    }
  });
  const g = (v == null ? void 0 : v.text) ?? c, b = (C) => {
    if (h.current !== null && !h.current.contains(C.target)) {
      if (m.current !== null) {
        if (m.current.contains(C.target))
          return;
        p(!1);
        return;
      }
      p(!1);
    }
  };
  return _e(() => (document.addEventListener("click", b, !0), () => {
    document.removeEventListener("click", b, !0);
  }), []), /* @__PURE__ */ f.jsx("div", { ref: t, className: `w-full block text-neutral-600 ${a === "no-border" ? "h-[38px]" : "h-10"}`, children: /* @__PURE__ */ f.jsxs("div", { className: "relative w-full h-full", children: [
    /* @__PURE__ */ f.jsxs(
      "div",
      {
        ref: h,
        onClick: () => {
          !i && !o && r.length > 0 && p((C) => !C);
        },
        className: $e([
          "rounded-md flex items-center w-full gap-3 h-full px-4 leading-none",
          i ? "" : "cursor-pointer select-none",
          o ? "bg-neutral-300 text-neutral-400 pointer-events-none" : a === "white" ? "bg-white text-neutral-600" : "bg-neutral-200 text-neutral-600",
          d ? "border-secondary-600" : i ? "" : "hover:border-secondary-400",
          o ? "border border-neutral-300" : a !== "no-border" ? s ? d ? "border border-secondary-600" : "border border-error-500" : l ? d ? "border border-secondary-600" : "border border-success-500" : a === "white" ? "border border-secondary-300" : "border border-neutral-300" : void 0
        ]),
        children: [
          /* @__PURE__ */ f.jsx("div", { className: "flex-grow overflow-hidden", children: /* @__PURE__ */ f.jsx("div", { className: "w-full pointer-events-none text-clamp-1 leading-[32px] break-all", children: g }) }),
          r.length > 0 && /* @__PURE__ */ f.jsx("span", { className: `w-[14px] min-w-[14px] ${d ? "rotate-180" : ""}`, children: /* @__PURE__ */ f.jsx(me, { variant: "arrow-down", width: 14 }) })
        ]
      }
    ),
    d && r.length > 0 && !i && !o && /* @__PURE__ */ f.jsx(
      "div",
      {
        ref: m,
        className: "absolute top-[calc(100%+8px)] left-0 w-full min-w-[250px] z-[1500] overflow-y-scroll table-main-scrollbar",
        style: { maxHeight: "250px" },
        children: /* @__PURE__ */ f.jsx("div", { className: "bg-white rounded-md p-4 pointer-events-auto", children: r.map((C, w) => {
          const { label: x, options: y } = C;
          return /* @__PURE__ */ f.jsxs(gn, { children: [
            /* @__PURE__ */ f.jsx(Jf, { className: "text-xl font-bold mb-4", children: x }),
            /* @__PURE__ */ f.jsx("ul", { className: "bg-white rounded-md p-4 pointer-events-auto", children: y.map((O) => /* @__PURE__ */ f.jsx(
              "li",
              {
                className: `font-bold leading-[120%] p-4 cursor-pointer rounded-md ${n === O.value ? "bg-secondary-600 text-white" : "bg-white hover:bg-secondary-100"}`,
                onClick: () => {
                  p(!1), n !== O.value && u !== void 0 && u({ option: O });
                },
                children: O.text
              },
              O.value
            )) })
          ] }, `${w}-${x}`);
        }) })
      }
    )
  ] }) });
});
mP.displayName = "SelectGroup";
var yv = {}, O1 = {}, k3 = { exports: {} }, U1 = { exports: {} }, Ke = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var x5;
function gP() {
  if (x5)
    return Ke;
  x5 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
  function w(y) {
    if (typeof y == "object" && y !== null) {
      var O = y.$$typeof;
      switch (O) {
        case t:
          switch (y = y.type, y) {
            case l:
            case c:
            case n:
            case i:
            case a:
            case d:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case u:
                case m:
                case h:
                case o:
                  return y;
                default:
                  return O;
              }
          }
        case r:
          return O;
      }
    }
  }
  function x(y) {
    return w(y) === c;
  }
  return Ke.AsyncMode = l, Ke.ConcurrentMode = c, Ke.ContextConsumer = s, Ke.ContextProvider = o, Ke.Element = t, Ke.ForwardRef = u, Ke.Fragment = n, Ke.Lazy = m, Ke.Memo = h, Ke.Portal = r, Ke.Profiler = i, Ke.StrictMode = a, Ke.Suspense = d, Ke.isAsyncMode = function(y) {
    return x(y) || w(y) === l;
  }, Ke.isConcurrentMode = x, Ke.isContextConsumer = function(y) {
    return w(y) === s;
  }, Ke.isContextProvider = function(y) {
    return w(y) === o;
  }, Ke.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === t;
  }, Ke.isForwardRef = function(y) {
    return w(y) === u;
  }, Ke.isFragment = function(y) {
    return w(y) === n;
  }, Ke.isLazy = function(y) {
    return w(y) === m;
  }, Ke.isMemo = function(y) {
    return w(y) === h;
  }, Ke.isPortal = function(y) {
    return w(y) === r;
  }, Ke.isProfiler = function(y) {
    return w(y) === i;
  }, Ke.isStrictMode = function(y) {
    return w(y) === a;
  }, Ke.isSuspense = function(y) {
    return w(y) === d;
  }, Ke.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === c || y === i || y === a || y === d || y === p || typeof y == "object" && y !== null && (y.$$typeof === m || y.$$typeof === h || y.$$typeof === o || y.$$typeof === s || y.$$typeof === u || y.$$typeof === g || y.$$typeof === b || y.$$typeof === C || y.$$typeof === v);
  }, Ke.typeOf = w, Ke;
}
var Xe = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var w5;
function yP() {
  return w5 || (w5 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
    function w(D) {
      return typeof D == "string" || typeof D == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      D === n || D === c || D === i || D === a || D === d || D === p || typeof D == "object" && D !== null && (D.$$typeof === m || D.$$typeof === h || D.$$typeof === o || D.$$typeof === s || D.$$typeof === u || D.$$typeof === g || D.$$typeof === b || D.$$typeof === C || D.$$typeof === v);
    }
    function x(D) {
      if (typeof D == "object" && D !== null) {
        var Q = D.$$typeof;
        switch (Q) {
          case t:
            var z = D.type;
            switch (z) {
              case l:
              case c:
              case n:
              case i:
              case a:
              case d:
                return z;
              default:
                var te = z && z.$$typeof;
                switch (te) {
                  case s:
                  case u:
                  case m:
                  case h:
                  case o:
                    return te;
                  default:
                    return Q;
                }
            }
          case r:
            return Q;
        }
      }
    }
    var y = l, O = c, P = s, j = o, T = t, I = u, R = n, F = m, $ = h, Z = r, X = i, K = a, J = d, ee = !1;
    function A(D) {
      return ee || (ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), _(D) || x(D) === l;
    }
    function _(D) {
      return x(D) === c;
    }
    function N(D) {
      return x(D) === s;
    }
    function M(D) {
      return x(D) === o;
    }
    function S(D) {
      return typeof D == "object" && D !== null && D.$$typeof === t;
    }
    function B(D) {
      return x(D) === u;
    }
    function G(D) {
      return x(D) === n;
    }
    function U(D) {
      return x(D) === m;
    }
    function H(D) {
      return x(D) === h;
    }
    function k(D) {
      return x(D) === r;
    }
    function L(D) {
      return x(D) === i;
    }
    function W(D) {
      return x(D) === a;
    }
    function V(D) {
      return x(D) === d;
    }
    Xe.AsyncMode = y, Xe.ConcurrentMode = O, Xe.ContextConsumer = P, Xe.ContextProvider = j, Xe.Element = T, Xe.ForwardRef = I, Xe.Fragment = R, Xe.Lazy = F, Xe.Memo = $, Xe.Portal = Z, Xe.Profiler = X, Xe.StrictMode = K, Xe.Suspense = J, Xe.isAsyncMode = A, Xe.isConcurrentMode = _, Xe.isContextConsumer = N, Xe.isContextProvider = M, Xe.isElement = S, Xe.isForwardRef = B, Xe.isFragment = G, Xe.isLazy = U, Xe.isMemo = H, Xe.isPortal = k, Xe.isProfiler = L, Xe.isStrictMode = W, Xe.isSuspense = V, Xe.isValidElementType = w, Xe.typeOf = x;
  }()), Xe;
}
var O5;
function bv() {
  return O5 || (O5 = 1, process.env.NODE_ENV === "production" ? U1.exports = gP() : U1.exports = yP()), U1.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var m2, S5;
function bP() {
  if (S5)
    return m2;
  S5 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(o).map(function(u) {
        return o[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return m2 = a() ? Object.assign : function(i, o) {
    for (var s, l = n(i), c, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var d in s)
        t.call(s, d) && (l[d] = s[d]);
      if (e) {
        c = e(s);
        for (var p = 0; p < c.length; p++)
          r.call(s, c[p]) && (l[c[p]] = s[c[p]]);
      }
    }
    return l;
  }, m2;
}
var g2, P5;
function ed() {
  if (P5)
    return g2;
  P5 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return g2 = e, g2;
}
var y2, E5;
function Cv() {
  return E5 || (E5 = 1, y2 = Function.call.bind(Object.prototype.hasOwnProperty)), y2;
}
var b2, j5;
function CP() {
  if (j5)
    return b2;
  j5 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = ed(), r = {}, n = Cv();
    e = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (n(i, u)) {
          var d;
          try {
            if (typeof i[u] != "function") {
              var p = Error(
                (l || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            d = i[u](o, u, l, s, null, t);
          } catch (m) {
            d = m;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in r)) {
            r[d.message] = !0;
            var h = c ? c() : "";
            e(
              "Failed " + s + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, b2 = a, b2;
}
var C2, _5;
function xP() {
  if (_5)
    return C2;
  _5 = 1;
  var e = bv(), t = bP(), r = ed(), n = Cv(), a = CP(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return C2 = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(_) {
      var N = _ && (c && _[c] || _[u]);
      if (typeof N == "function")
        return N;
    }
    var p = "<<anonymous>>", h = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: C(),
      arrayOf: w,
      element: x(),
      elementType: y(),
      instanceOf: O,
      node: I(),
      objectOf: j,
      oneOf: P,
      oneOfType: T,
      shape: F,
      exact: $
    };
    function m(_, N) {
      return _ === N ? _ !== 0 || 1 / _ === 1 / N : _ !== _ && N !== N;
    }
    function v(_, N) {
      this.message = _, this.data = N && typeof N == "object" ? N : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function g(_) {
      if (process.env.NODE_ENV !== "production")
        var N = {}, M = 0;
      function S(G, U, H, k, L, W, V) {
        if (k = k || p, W = W || H, V !== r) {
          if (l) {
            var D = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw D.name = "Invariant Violation", D;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Q = k + ":" + H;
            !N[Q] && // Avoid spamming the console because they are often not actionable except for lib authors
            M < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + W + "` prop on `" + k + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), N[Q] = !0, M++);
          }
        }
        return U[H] == null ? G ? U[H] === null ? new v("The " + L + " `" + W + "` is marked as required " + ("in `" + k + "`, but its value is `null`.")) : new v("The " + L + " `" + W + "` is marked as required in " + ("`" + k + "`, but its value is `undefined`.")) : null : _(U, H, k, L, W);
      }
      var B = S.bind(null, !1);
      return B.isRequired = S.bind(null, !0), B;
    }
    function b(_) {
      function N(M, S, B, G, U, H) {
        var k = M[S], L = K(k);
        if (L !== _) {
          var W = J(k);
          return new v(
            "Invalid " + G + " `" + U + "` of type " + ("`" + W + "` supplied to `" + B + "`, expected ") + ("`" + _ + "`."),
            { expectedType: _ }
          );
        }
        return null;
      }
      return g(N);
    }
    function C() {
      return g(o);
    }
    function w(_) {
      function N(M, S, B, G, U) {
        if (typeof _ != "function")
          return new v("Property `" + U + "` of component `" + B + "` has invalid PropType notation inside arrayOf.");
        var H = M[S];
        if (!Array.isArray(H)) {
          var k = K(H);
          return new v("Invalid " + G + " `" + U + "` of type " + ("`" + k + "` supplied to `" + B + "`, expected an array."));
        }
        for (var L = 0; L < H.length; L++) {
          var W = _(H, L, B, G, U + "[" + L + "]", r);
          if (W instanceof Error)
            return W;
        }
        return null;
      }
      return g(N);
    }
    function x() {
      function _(N, M, S, B, G) {
        var U = N[M];
        if (!s(U)) {
          var H = K(U);
          return new v("Invalid " + B + " `" + G + "` of type " + ("`" + H + "` supplied to `" + S + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(_);
    }
    function y() {
      function _(N, M, S, B, G) {
        var U = N[M];
        if (!e.isValidElementType(U)) {
          var H = K(U);
          return new v("Invalid " + B + " `" + G + "` of type " + ("`" + H + "` supplied to `" + S + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(_);
    }
    function O(_) {
      function N(M, S, B, G, U) {
        if (!(M[S] instanceof _)) {
          var H = _.name || p, k = A(M[S]);
          return new v("Invalid " + G + " `" + U + "` of type " + ("`" + k + "` supplied to `" + B + "`, expected ") + ("instance of `" + H + "`."));
        }
        return null;
      }
      return g(N);
    }
    function P(_) {
      if (!Array.isArray(_))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function N(M, S, B, G, U) {
        for (var H = M[S], k = 0; k < _.length; k++)
          if (m(H, _[k]))
            return null;
        var L = JSON.stringify(_, function(V, D) {
          var Q = J(D);
          return Q === "symbol" ? String(D) : D;
        });
        return new v("Invalid " + G + " `" + U + "` of value `" + String(H) + "` " + ("supplied to `" + B + "`, expected one of " + L + "."));
      }
      return g(N);
    }
    function j(_) {
      function N(M, S, B, G, U) {
        if (typeof _ != "function")
          return new v("Property `" + U + "` of component `" + B + "` has invalid PropType notation inside objectOf.");
        var H = M[S], k = K(H);
        if (k !== "object")
          return new v("Invalid " + G + " `" + U + "` of type " + ("`" + k + "` supplied to `" + B + "`, expected an object."));
        for (var L in H)
          if (n(H, L)) {
            var W = _(H, L, B, G, U + "." + L, r);
            if (W instanceof Error)
              return W;
          }
        return null;
      }
      return g(N);
    }
    function T(_) {
      if (!Array.isArray(_))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var N = 0; N < _.length; N++) {
        var M = _[N];
        if (typeof M != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ee(M) + " at index " + N + "."
          ), o;
      }
      function S(B, G, U, H, k) {
        for (var L = [], W = 0; W < _.length; W++) {
          var V = _[W], D = V(B, G, U, H, k, r);
          if (D == null)
            return null;
          D.data && n(D.data, "expectedType") && L.push(D.data.expectedType);
        }
        var Q = L.length > 0 ? ", expected one of type [" + L.join(", ") + "]" : "";
        return new v("Invalid " + H + " `" + k + "` supplied to " + ("`" + U + "`" + Q + "."));
      }
      return g(S);
    }
    function I() {
      function _(N, M, S, B, G) {
        return Z(N[M]) ? null : new v("Invalid " + B + " `" + G + "` supplied to " + ("`" + S + "`, expected a ReactNode."));
      }
      return g(_);
    }
    function R(_, N, M, S, B) {
      return new v(
        (_ || "React class") + ": " + N + " type `" + M + "." + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + B + "`."
      );
    }
    function F(_) {
      function N(M, S, B, G, U) {
        var H = M[S], k = K(H);
        if (k !== "object")
          return new v("Invalid " + G + " `" + U + "` of type `" + k + "` " + ("supplied to `" + B + "`, expected `object`."));
        for (var L in _) {
          var W = _[L];
          if (typeof W != "function")
            return R(B, G, U, L, J(W));
          var V = W(H, L, B, G, U + "." + L, r);
          if (V)
            return V;
        }
        return null;
      }
      return g(N);
    }
    function $(_) {
      function N(M, S, B, G, U) {
        var H = M[S], k = K(H);
        if (k !== "object")
          return new v("Invalid " + G + " `" + U + "` of type `" + k + "` " + ("supplied to `" + B + "`, expected `object`."));
        var L = t({}, M[S], _);
        for (var W in L) {
          var V = _[W];
          if (n(_, W) && typeof V != "function")
            return R(B, G, U, W, J(V));
          if (!V)
            return new v(
              "Invalid " + G + " `" + U + "` key `" + W + "` supplied to `" + B + "`.\nBad object: " + JSON.stringify(M[S], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(_), null, "  ")
            );
          var D = V(H, W, B, G, U + "." + W, r);
          if (D)
            return D;
        }
        return null;
      }
      return g(N);
    }
    function Z(_) {
      switch (typeof _) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !_;
        case "object":
          if (Array.isArray(_))
            return _.every(Z);
          if (_ === null || s(_))
            return !0;
          var N = d(_);
          if (N) {
            var M = N.call(_), S;
            if (N !== _.entries) {
              for (; !(S = M.next()).done; )
                if (!Z(S.value))
                  return !1;
            } else
              for (; !(S = M.next()).done; ) {
                var B = S.value;
                if (B && !Z(B[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function X(_, N) {
      return _ === "symbol" ? !0 : N ? N["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && N instanceof Symbol : !1;
    }
    function K(_) {
      var N = typeof _;
      return Array.isArray(_) ? "array" : _ instanceof RegExp ? "object" : X(N, _) ? "symbol" : N;
    }
    function J(_) {
      if (typeof _ > "u" || _ === null)
        return "" + _;
      var N = K(_);
      if (N === "object") {
        if (_ instanceof Date)
          return "date";
        if (_ instanceof RegExp)
          return "regexp";
      }
      return N;
    }
    function ee(_) {
      var N = J(_);
      switch (N) {
        case "array":
        case "object":
          return "an " + N;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + N;
        default:
          return N;
      }
    }
    function A(_) {
      return !_.constructor || !_.constructor.name ? p : _.constructor.name;
    }
    return h.checkPropTypes = a, h.resetWarningCache = a.resetWarningCache, h.PropTypes = h, h;
  }, C2;
}
var x2, A5;
function wP() {
  if (A5)
    return x2;
  A5 = 1;
  var e = ed();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, x2 = function() {
    function n(o, s, l, c, u, d) {
      if (d !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    n.isRequired = n;
    function a() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: a,
      element: n,
      elementType: n,
      instanceOf: a,
      node: n,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, x2;
}
if (process.env.NODE_ENV !== "production") {
  var OP = bv(), SP = !0;
  k3.exports = xP()(OP.isElement, SP);
} else
  k3.exports = wP()();
var tn = k3.exports;
const Pe = /* @__PURE__ */ Ze(tn);
var S1 = {}, kn = {}, xv = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var i = "", o = 0; o < arguments.length; o++) {
        var s = arguments[o];
        s && (i = a(i, n(s)));
      }
      return i;
    }
    function n(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return r.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var o = "";
      for (var s in i)
        t.call(i, s) && i[s] && (o = a(o, s));
      return o;
    }
    function a(i, o) {
      return o ? i ? i + " " + o : i + o : i;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(xv);
var ti = xv.exports;
function Jr(e) {
  "@babel/helpers - typeof";
  return Jr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Jr(e);
}
function Ae(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Se(e) {
  Ae(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Jr(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function PP(e) {
  Ae(1, arguments);
  var t = Se(e);
  return t.setHours(23, 59, 59, 999), t;
}
const EP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: PP
}, Symbol.toStringTag, { value: "Module" })), td = /* @__PURE__ */ qe(EP);
function jP(e, t) {
  Ae(2, arguments);
  var r = Se(e), n = Se(t);
  return r.getTime() < n.getTime();
}
const _P = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jP
}, Symbol.toStringTag, { value: "Module" })), rd = /* @__PURE__ */ qe(_P);
function AP(e, t) {
  Ae(2, arguments);
  var r = Se(e), n = Se(t);
  return r.getTime() > n.getTime();
}
const DP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: AP
}, Symbol.toStringTag, { value: "Module" })), wv = /* @__PURE__ */ qe(DP);
function $s(e) {
  Ae(1, arguments);
  var t = Se(e);
  return t.setHours(0, 0, 0, 0), t;
}
const MP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $s
}, Symbol.toStringTag, { value: "Module" }));
function TP(e, t) {
  Ae(2, arguments);
  var r = $s(e), n = $s(t);
  return r.getTime() === n.getTime();
}
const $P = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: TP
}, Symbol.toStringTag, { value: "Module" })), iu = /* @__PURE__ */ qe($P);
function NP(e) {
  return Ae(1, arguments), e instanceof Date || Jr(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Ov(e) {
  if (Ae(1, arguments), !NP(e) && typeof e != "number")
    return !1;
  var t = Se(e);
  return !isNaN(Number(t));
}
const IP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ov
}, Symbol.toStringTag, { value: "Module" }));
function Et(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function LP(e, t) {
  Ae(2, arguments);
  var r = Se(e).getTime(), n = Et(t);
  return new Date(r + n);
}
function Sv(e, t) {
  Ae(2, arguments);
  var r = Et(t);
  return LP(e, -r);
}
var kP = 864e5;
function RP(e) {
  Ae(1, arguments);
  var t = Se(e), r = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var n = t.getTime(), a = r - n;
  return Math.floor(a / kP) + 1;
}
function ki(e) {
  Ae(1, arguments);
  var t = 1, r = Se(e), n = r.getUTCDay(), a = (n < t ? 7 : 0) + n - t;
  return r.setUTCDate(r.getUTCDate() - a), r.setUTCHours(0, 0, 0, 0), r;
}
function Pv(e) {
  Ae(1, arguments);
  var t = Se(e), r = t.getUTCFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(r + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var a = ki(n), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(r, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = ki(i);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function BP(e) {
  Ae(1, arguments);
  var t = Pv(e), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var n = ki(r);
  return n;
}
var VP = 6048e5;
function Ev(e) {
  Ae(1, arguments);
  var t = Se(e), r = ki(t).getTime() - BP(t).getTime();
  return Math.round(r / VP) + 1;
}
var HP = {};
function fa() {
  return HP;
}
function Ka(e, t) {
  var r, n, a, i, o, s, l, c;
  Ae(1, arguments);
  var u = fa(), d = Et((r = (n = (a = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : u.weekStartsOn) !== null && n !== void 0 ? n : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = Se(e), h = p.getUTCDay(), m = (h < d ? 7 : 0) + h - d;
  return p.setUTCDate(p.getUTCDate() - m), p.setUTCHours(0, 0, 0, 0), p;
}
function nd(e, t) {
  var r, n, a, i, o, s, l, c;
  Ae(1, arguments);
  var u = Se(e), d = u.getUTCFullYear(), p = fa(), h = Et((r = (n = (a = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : p.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = p.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(d + 1, 0, h), m.setUTCHours(0, 0, 0, 0);
  var v = Ka(m, t), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(d, 0, h), g.setUTCHours(0, 0, 0, 0);
  var b = Ka(g, t);
  return u.getTime() >= v.getTime() ? d + 1 : u.getTime() >= b.getTime() ? d : d - 1;
}
function FP(e, t) {
  var r, n, a, i, o, s, l, c;
  Ae(1, arguments);
  var u = fa(), d = Et((r = (n = (a = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : u.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), p = nd(e, t), h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(p, 0, d), h.setUTCHours(0, 0, 0, 0);
  var m = Ka(h, t);
  return m;
}
var WP = 6048e5;
function jv(e, t) {
  Ae(1, arguments);
  var r = Se(e), n = Ka(r, t).getTime() - FP(r, t).getTime();
  return Math.round(n / WP) + 1;
}
function rt(e, t) {
  for (var r = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return r + n;
}
var zP = {
  // Year
  y: function(t, r) {
    var n = t.getUTCFullYear(), a = n > 0 ? n : 1 - n;
    return rt(r === "yy" ? a % 100 : a, r.length);
  },
  // Month
  M: function(t, r) {
    var n = t.getUTCMonth();
    return r === "M" ? String(n + 1) : rt(n + 1, 2);
  },
  // Day of the month
  d: function(t, r) {
    return rt(t.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(t, r) {
    var n = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, r) {
    return rt(t.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(t, r) {
    return rt(t.getUTCHours(), r.length);
  },
  // Minute
  m: function(t, r) {
    return rt(t.getUTCMinutes(), r.length);
  },
  // Second
  s: function(t, r) {
    return rt(t.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(t, r) {
    var n = r.length, a = t.getUTCMilliseconds(), i = Math.floor(a * Math.pow(10, n - 3));
    return rt(i, r.length);
  }
};
const Un = zP;
var fi = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, UP = {
  // Era
  G: function(t, r, n) {
    var a = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, {
          width: "abbreviated"
        });
      case "GGGGG":
        return n.era(a, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return n.era(a, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, r, n) {
    if (r === "yo") {
      var a = t.getUTCFullYear(), i = a > 0 ? a : 1 - a;
      return n.ordinalNumber(i, {
        unit: "year"
      });
    }
    return Un.y(t, r);
  },
  // Local week-numbering year
  Y: function(t, r, n, a) {
    var i = nd(t, a), o = i > 0 ? i : 1 - i;
    if (r === "YY") {
      var s = o % 100;
      return rt(s, 2);
    }
    return r === "Yo" ? n.ordinalNumber(o, {
      unit: "year"
    }) : rt(o, r.length);
  },
  // ISO week-numbering year
  R: function(t, r) {
    var n = Pv(t);
    return rt(n, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, r) {
    var n = t.getUTCFullYear();
    return rt(n, r.length);
  },
  // Quarter
  Q: function(t, r, n) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(a);
      case "QQ":
        return rt(a, 2);
      case "Qo":
        return n.ordinalNumber(a, {
          unit: "quarter"
        });
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, r, n) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(a);
      case "qq":
        return rt(a, 2);
      case "qo":
        return n.ordinalNumber(a, {
          unit: "quarter"
        });
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, r, n) {
    var a = t.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return Un.M(t, r);
      case "Mo":
        return n.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, r, n) {
    var a = t.getUTCMonth();
    switch (r) {
      case "L":
        return String(a + 1);
      case "LL":
        return rt(a + 1, 2);
      case "Lo":
        return n.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, r, n, a) {
    var i = jv(t, a);
    return r === "wo" ? n.ordinalNumber(i, {
      unit: "week"
    }) : rt(i, r.length);
  },
  // ISO week of year
  I: function(t, r, n) {
    var a = Ev(t);
    return r === "Io" ? n.ordinalNumber(a, {
      unit: "week"
    }) : rt(a, r.length);
  },
  // Day of the month
  d: function(t, r, n) {
    return r === "do" ? n.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : Un.d(t, r);
  },
  // Day of year
  D: function(t, r, n) {
    var a = RP(t);
    return r === "Do" ? n.ordinalNumber(a, {
      unit: "dayOfYear"
    }) : rt(a, r.length);
  },
  // Day of week
  E: function(t, r, n) {
    var a = t.getUTCDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, r, n, a) {
    var i = t.getUTCDay(), o = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(o);
      case "ee":
        return rt(o, 2);
      case "eo":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, r, n, a) {
    var i = t.getUTCDay(), o = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(o);
      case "cc":
        return rt(o, r.length);
      case "co":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, r, n) {
    var a = t.getUTCDay(), i = a === 0 ? 7 : a;
    switch (r) {
      case "i":
        return String(i);
      case "ii":
        return rt(i, r.length);
      case "io":
        return n.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, r, n) {
    var a = t.getUTCHours(), i = a / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, r, n) {
    var a = t.getUTCHours(), i;
    switch (a === 12 ? i = fi.noon : a === 0 ? i = fi.midnight : i = a / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, r, n) {
    var a = t.getUTCHours(), i;
    switch (a >= 17 ? i = fi.evening : a >= 12 ? i = fi.afternoon : a >= 4 ? i = fi.morning : i = fi.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, r, n) {
    if (r === "ho") {
      var a = t.getUTCHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, {
        unit: "hour"
      });
    }
    return Un.h(t, r);
  },
  // Hour [0-23]
  H: function(t, r, n) {
    return r === "Ho" ? n.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : Un.H(t, r);
  },
  // Hour [0-11]
  K: function(t, r, n) {
    var a = t.getUTCHours() % 12;
    return r === "Ko" ? n.ordinalNumber(a, {
      unit: "hour"
    }) : rt(a, r.length);
  },
  // Hour [1-24]
  k: function(t, r, n) {
    var a = t.getUTCHours();
    return a === 0 && (a = 24), r === "ko" ? n.ordinalNumber(a, {
      unit: "hour"
    }) : rt(a, r.length);
  },
  // Minute
  m: function(t, r, n) {
    return r === "mo" ? n.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : Un.m(t, r);
  },
  // Second
  s: function(t, r, n) {
    return r === "so" ? n.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : Un.s(t, r);
  },
  // Fraction of second
  S: function(t, r) {
    return Un.S(t, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (r) {
      case "X":
        return M5(o);
      case "XXXX":
      case "XX":
        return Da(o);
      case "XXXXX":
      case "XXX":
      default:
        return Da(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "x":
        return M5(o);
      case "xxxx":
      case "xx":
        return Da(o);
      case "xxxxx":
      case "xxx":
      default:
        return Da(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + D5(o, ":");
      case "OOOO":
      default:
        return "GMT" + Da(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + D5(o, ":");
      case "zzzz":
      default:
        return "GMT" + Da(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, r, n, a) {
    var i = a._originalDate || t, o = Math.floor(i.getTime() / 1e3);
    return rt(o, r.length);
  },
  // Milliseconds timestamp
  T: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTime();
    return rt(o, r.length);
  }
};
function D5(e, t) {
  var r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.floor(n / 60), i = n % 60;
  if (i === 0)
    return r + String(a);
  var o = t || "";
  return r + String(a) + o + rt(i, 2);
}
function M5(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + rt(Math.abs(e) / 60, 2);
  }
  return Da(e, t);
}
function Da(e, t) {
  var r = t || "", n = e > 0 ? "-" : "+", a = Math.abs(e), i = rt(Math.floor(a / 60), 2), o = rt(a % 60, 2);
  return n + i + r + o;
}
const ZP = UP;
var T5 = function(t, r) {
  switch (t) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    case "PPPP":
    default:
      return r.date({
        width: "full"
      });
  }
}, _v = function(t, r) {
  switch (t) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    case "pppp":
    default:
      return r.time({
        width: "full"
      });
  }
}, qP = function(t, r) {
  var n = t.match(/(P+)(p+)?/) || [], a = n[1], i = n[2];
  if (!i)
    return T5(t, r);
  var o;
  switch (a) {
    case "P":
      o = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = r.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = r.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", T5(a, r)).replace("{{time}}", _v(i, r));
}, GP = {
  p: _v,
  P: qP
};
const R3 = GP;
function Pl(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var YP = ["D", "DD"], KP = ["YY", "YYYY"];
function Av(e) {
  return YP.indexOf(e) !== -1;
}
function Dv(e) {
  return KP.indexOf(e) !== -1;
}
function El(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var XP = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, QP = function(t, r, n) {
  var a, i = XP[t];
  return typeof i == "string" ? a = i : r === 1 ? a = i.one : a = i.other.replace("{{count}}", r.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
const JP = QP;
function Mi(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.width ? String(t.width) : e.defaultWidth, n = e.formats[r] || e.formats[e.defaultWidth];
    return n;
  };
}
var eE = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, tE = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, rE = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, nE = {
  date: Mi({
    formats: eE,
    defaultWidth: "full"
  }),
  time: Mi({
    formats: tE,
    defaultWidth: "full"
  }),
  dateTime: Mi({
    formats: rE,
    defaultWidth: "full"
  })
};
const aE = nE;
var iE = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, oE = function(t, r, n, a) {
  return iE[t];
};
const sE = oE;
function ln(e) {
  return function(t, r) {
    var n = r != null && r.context ? String(r.context) : "standalone", a;
    if (n === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth, o = r != null && r.width ? String(r.width) : i;
      a = e.formattingValues[o] || e.formattingValues[i];
    } else {
      var s = e.defaultWidth, l = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[l] || e.values[s];
    }
    var c = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[c];
  };
}
var lE = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, cE = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, uE = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, fE = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, dE = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, pE = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, hE = function(t, r) {
  var n = Number(t), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, vE = {
  ordinalNumber: hE,
  era: ln({
    values: lE,
    defaultWidth: "wide"
  }),
  quarter: ln({
    values: cE,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: ln({
    values: uE,
    defaultWidth: "wide"
  }),
  day: ln({
    values: fE,
    defaultWidth: "wide"
  }),
  dayPeriod: ln({
    values: dE,
    defaultWidth: "wide",
    formattingValues: pE,
    defaultFormattingWidth: "wide"
  })
};
const mE = vE;
function cn(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    var o = i[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? yE(s, function(d) {
      return d.test(o);
    }) : gE(s, function(d) {
      return d.test(o);
    }), c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = r.valueCallback ? r.valueCallback(c) : c;
    var u = t.slice(o.length);
    return {
      value: c,
      rest: u
    };
  };
}
function gE(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r) && t(e[r]))
      return r;
}
function yE(e, t) {
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function Mv(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.match(e.matchPattern);
    if (!n)
      return null;
    var a = n[0], i = t.match(e.parsePattern);
    if (!i)
      return null;
    var o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    var s = t.slice(a.length);
    return {
      value: o,
      rest: s
    };
  };
}
var bE = /^(\d+)(th|st|nd|rd)?/i, CE = /\d+/i, xE = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, wE = {
  any: [/^b/i, /^(a|c)/i]
}, OE = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, SE = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, PE = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, EE = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, jE = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, _E = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, AE = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, DE = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, ME = {
  ordinalNumber: Mv({
    matchPattern: bE,
    parsePattern: CE,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: cn({
    matchPatterns: xE,
    defaultMatchWidth: "wide",
    parsePatterns: wE,
    defaultParseWidth: "any"
  }),
  quarter: cn({
    matchPatterns: OE,
    defaultMatchWidth: "wide",
    parsePatterns: SE,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: cn({
    matchPatterns: PE,
    defaultMatchWidth: "wide",
    parsePatterns: EE,
    defaultParseWidth: "any"
  }),
  day: cn({
    matchPatterns: jE,
    defaultMatchWidth: "wide",
    parsePatterns: _E,
    defaultParseWidth: "any"
  }),
  dayPeriod: cn({
    matchPatterns: AE,
    defaultMatchWidth: "any",
    parsePatterns: DE,
    defaultParseWidth: "any"
  })
};
const TE = ME;
var $E = {
  code: "en-US",
  formatDistance: JP,
  formatLong: aE,
  formatRelative: sE,
  localize: mE,
  match: TE,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const ad = $E, NE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ad
}, Symbol.toStringTag, { value: "Module" }));
var IE = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, LE = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, kE = /^'([^]*?)'?$/, RE = /''/g, BE = /[a-zA-Z]/;
function B3(e, t, r) {
  var n, a, i, o, s, l, c, u, d, p, h, m, v, g, b, C, w, x;
  Ae(2, arguments);
  var y = String(t), O = fa(), P = (n = (a = r == null ? void 0 : r.locale) !== null && a !== void 0 ? a : O.locale) !== null && n !== void 0 ? n : ad, j = Et((i = (o = (s = (l = r == null ? void 0 : r.firstWeekContainsDate) !== null && l !== void 0 ? l : r == null || (c = r.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && s !== void 0 ? s : O.firstWeekContainsDate) !== null && o !== void 0 ? o : (d = O.locale) === null || d === void 0 || (p = d.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(j >= 1 && j <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var T = Et((h = (m = (v = (g = r == null ? void 0 : r.weekStartsOn) !== null && g !== void 0 ? g : r == null || (b = r.locale) === null || b === void 0 || (C = b.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && v !== void 0 ? v : O.weekStartsOn) !== null && m !== void 0 ? m : (w = O.locale) === null || w === void 0 || (x = w.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(T >= 0 && T <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!P.localize)
    throw new RangeError("locale must contain localize property");
  if (!P.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var I = Se(e);
  if (!Ov(I))
    throw new RangeError("Invalid time value");
  var R = Pl(I), F = Sv(I, R), $ = {
    firstWeekContainsDate: j,
    weekStartsOn: T,
    locale: P,
    _originalDate: I
  }, Z = y.match(LE).map(function(X) {
    var K = X[0];
    if (K === "p" || K === "P") {
      var J = R3[K];
      return J(X, P.formatLong);
    }
    return X;
  }).join("").match(IE).map(function(X) {
    if (X === "''")
      return "'";
    var K = X[0];
    if (K === "'")
      return VE(X);
    var J = ZP[K];
    if (J)
      return !(r != null && r.useAdditionalWeekYearTokens) && Dv(X) && El(X, t, String(e)), !(r != null && r.useAdditionalDayOfYearTokens) && Av(X) && El(X, t, String(e)), J(F, X, P.localize, $);
    if (K.match(BE))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + K + "`");
    return X;
  }).join("");
  return Z;
}
function VE(e) {
  var t = e.match(kE);
  return t ? t[1].replace(RE, "'") : e;
}
const HE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: B3
}, Symbol.toStringTag, { value: "Module" })), ou = /* @__PURE__ */ qe(HE), id = /* @__PURE__ */ qe(MP);
function cs(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? cs = function(r) {
    return typeof r;
  } : cs = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, cs(e);
}
Object.defineProperty(kn, "__esModule", {
  value: !0
});
kn.default = kn.rangeShape = void 0;
var xa = WE(E), Ve = da(tn), w2 = da(ti), $5 = da(td), O2 = da(rd), N5 = da(wv), zo = da(iu), FE = da(ou), I5 = da(id);
function da(e) {
  return e && e.__esModule ? e : { default: e };
}
function Tv(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (Tv = function(a) {
    return a ? r : t;
  })(e);
}
function WE(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || cs(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = Tv(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function V3() {
  return V3 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, V3.apply(this, arguments);
}
function L5(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function zE(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? L5(Object(r), !0).forEach(function(n) {
      Ot(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : L5(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function UE(e) {
  return YE(e) || GE(e) || qE(e) || ZE();
}
function ZE() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qE(e, t) {
  if (e) {
    if (typeof e == "string")
      return H3(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return H3(e, t);
  }
}
function GE(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function YE(e) {
  if (Array.isArray(e))
    return H3(e);
}
function H3(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function KE(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function k5(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function XE(e, t, r) {
  return t && k5(e.prototype, t), r && k5(e, r), e;
}
function QE(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && F3(e, t);
}
function F3(e, t) {
  return F3 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, F3(e, t);
}
function JE(e) {
  var t = tj();
  return function() {
    var n = jl(e), a;
    if (t) {
      var i = jl(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return ej(this, a);
  };
}
function ej(e, t) {
  return t && (cs(t) === "object" || typeof t == "function") ? t : xi(e);
}
function xi(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function tj() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function jl(e) {
  return jl = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, jl(e);
}
function Ot(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var od = /* @__PURE__ */ function(e) {
  QE(r, e);
  var t = JE(r);
  function r(n, a) {
    var i;
    return KE(this, r), i = t.call(this, n, a), Ot(xi(i), "handleKeyEvent", function(o) {
      var s = i.props, l = s.day, c = s.onMouseDown, u = s.onMouseUp;
      [
        13,
        32
        /* enter */
      ].includes(o.keyCode) && (o.type === "keydown" ? c(l) : u(l));
    }), Ot(xi(i), "handleMouseEvent", function(o) {
      var s = i.props, l = s.day, c = s.disabled, u = s.onPreviewChange, d = s.onMouseEnter, p = s.onMouseDown, h = s.onMouseUp, m = {};
      if (c) {
        u();
        return;
      }
      switch (o.type) {
        case "mouseenter":
          d(l), u(l), m.hover = !0;
          break;
        case "blur":
        case "mouseleave":
          m.hover = !1;
          break;
        case "mousedown":
          m.active = !0, p(l);
          break;
        case "mouseup":
          o.stopPropagation(), m.active = !1, h(l);
          break;
        case "focus":
          u(l);
          break;
      }
      Object.keys(m).length && i.setState(m);
    }), Ot(xi(i), "getClassNames", function() {
      var o, s = i.props, l = s.isPassive, c = s.isToday, u = s.isWeekend, d = s.isStartOfWeek, p = s.isEndOfWeek, h = s.isStartOfMonth, m = s.isEndOfMonth, v = s.disabled, g = s.styles;
      return (0, w2.default)(g.day, (o = {}, Ot(o, g.dayPassive, l), Ot(o, g.dayDisabled, v), Ot(o, g.dayToday, c), Ot(o, g.dayWeekend, u), Ot(o, g.dayStartOfWeek, d), Ot(o, g.dayEndOfWeek, p), Ot(o, g.dayStartOfMonth, h), Ot(o, g.dayEndOfMonth, m), Ot(o, g.dayHovered, i.state.hover), Ot(o, g.dayActive, i.state.active), o));
    }), Ot(xi(i), "renderPreviewPlaceholder", function() {
      var o, s = i.props, l = s.preview, c = s.day, u = s.styles;
      if (!l)
        return null;
      var d = l.startDate ? (0, $5.default)(l.startDate) : null, p = l.endDate ? (0, I5.default)(l.endDate) : null, h = (!d || (0, N5.default)(c, d)) && (!p || (0, O2.default)(c, p)), m = !h && (0, zo.default)(c, d), v = !h && (0, zo.default)(c, p);
      return /* @__PURE__ */ xa.default.createElement("span", {
        className: (0, w2.default)((o = {}, Ot(o, u.dayStartPreview, m), Ot(o, u.dayInPreview, h), Ot(o, u.dayEndPreview, v), o)),
        style: {
          color: l.color
        }
      });
    }), Ot(xi(i), "renderSelectionPlaceholders", function() {
      var o = i.props, s = o.styles, l = o.ranges, c = o.day;
      if (i.props.displayMode === "date") {
        var u = (0, zo.default)(i.props.day, i.props.date);
        return u ? /* @__PURE__ */ xa.default.createElement("span", {
          className: s.selected,
          style: {
            color: i.props.color
          }
        }) : null;
      }
      var d = l.reduce(function(p, h) {
        var m = h.startDate, v = h.endDate;
        if (m && v && (0, O2.default)(v, m)) {
          var g = [v, m];
          m = g[0], v = g[1];
        }
        m = m ? (0, $5.default)(m) : null, v = v ? (0, I5.default)(v) : null;
        var b = (!m || (0, N5.default)(c, m)) && (!v || (0, O2.default)(c, v)), C = !b && (0, zo.default)(c, m), w = !b && (0, zo.default)(c, v);
        return b || C || w ? [].concat(UE(p), [zE({
          isStartEdge: C,
          isEndEdge: w,
          isInRange: b
        }, h)]) : p;
      }, []);
      return d.map(function(p, h) {
        var m;
        return /* @__PURE__ */ xa.default.createElement("span", {
          key: h,
          className: (0, w2.default)((m = {}, Ot(m, s.startEdge, p.isStartEdge), Ot(m, s.endEdge, p.isEndEdge), Ot(m, s.inRange, p.isInRange), m)),
          style: {
            color: p.color || i.props.color
          }
        });
      });
    }), i.state = {
      hover: !1,
      active: !1
    }, i;
  }
  return XE(r, [{
    key: "render",
    value: function() {
      var a = this.props.dayContentRenderer;
      return /* @__PURE__ */ xa.default.createElement("button", V3({
        type: "button",
        onMouseEnter: this.handleMouseEvent,
        onMouseLeave: this.handleMouseEvent,
        onFocus: this.handleMouseEvent,
        onMouseDown: this.handleMouseEvent,
        onMouseUp: this.handleMouseEvent,
        onBlur: this.handleMouseEvent,
        onPauseCapture: this.handleMouseEvent,
        onKeyDown: this.handleKeyEvent,
        onKeyUp: this.handleKeyEvent,
        className: this.getClassNames(this.props.styles)
      }, this.props.disabled || this.props.isPassive ? {
        tabIndex: -1
      } : {}, {
        style: {
          color: this.props.color
        }
      }), this.renderSelectionPlaceholders(), this.renderPreviewPlaceholder(), /* @__PURE__ */ xa.default.createElement("span", {
        className: this.props.styles.dayNumber
      }, (a == null ? void 0 : a(this.props.day)) || /* @__PURE__ */ xa.default.createElement("span", null, (0, FE.default)(this.props.day, this.props.dayDisplayFormat))));
    }
  }]), r;
}(xa.Component);
od.defaultProps = {};
var $v = Ve.default.shape({
  startDate: Ve.default.object,
  endDate: Ve.default.object,
  color: Ve.default.string,
  key: Ve.default.string,
  autoFocus: Ve.default.bool,
  disabled: Ve.default.bool,
  showDateDisplay: Ve.default.bool
});
kn.rangeShape = $v;
od.propTypes = {
  day: Ve.default.object.isRequired,
  dayDisplayFormat: Ve.default.string,
  date: Ve.default.object,
  ranges: Ve.default.arrayOf($v),
  preview: Ve.default.shape({
    startDate: Ve.default.object,
    endDate: Ve.default.object,
    color: Ve.default.string
  }),
  onPreviewChange: Ve.default.func,
  previewColor: Ve.default.string,
  disabled: Ve.default.bool,
  isPassive: Ve.default.bool,
  isToday: Ve.default.bool,
  isWeekend: Ve.default.bool,
  isStartOfWeek: Ve.default.bool,
  isEndOfWeek: Ve.default.bool,
  isStartOfMonth: Ve.default.bool,
  isEndOfMonth: Ve.default.bool,
  color: Ve.default.string,
  displayMode: Ve.default.oneOf(["dateRange", "date"]),
  styles: Ve.default.object,
  onMouseDown: Ve.default.func,
  onMouseUp: Ve.default.func,
  onMouseEnter: Ve.default.func,
  dayContentRenderer: Ve.default.func
};
var rj = od;
kn.default = rj;
var su = {};
function nj(e, t) {
  var r;
  Ae(1, arguments);
  var n = e || {}, a = Se(n.start), i = Se(n.end), o = i.getTime();
  if (!(a.getTime() <= o))
    throw new RangeError("Invalid interval");
  var s = [], l = a;
  l.setHours(0, 0, 0, 0);
  var c = Number((r = t == null ? void 0 : t.step) !== null && r !== void 0 ? r : 1);
  if (c < 1 || isNaN(c))
    throw new RangeError("`options.step` must be a number greater than 1");
  for (; l.getTime() <= o; )
    s.push(Se(l)), l.setDate(l.getDate() + c), l.setHours(0, 0, 0, 0);
  return s;
}
const aj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: nj
}, Symbol.toStringTag, { value: "Module" })), Nv = /* @__PURE__ */ qe(aj);
function ij(e, t) {
  Ae(2, arguments);
  var r = Se(e).getTime(), n = Se(t.start).getTime(), a = Se(t.end).getTime();
  if (!(n <= a))
    throw new RangeError("Invalid interval");
  return r >= n && r <= a;
}
const oj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ij
}, Symbol.toStringTag, { value: "Module" })), Iv = /* @__PURE__ */ qe(oj);
function sj(e) {
  Ae(1, arguments);
  var t = Se(e), r = t.getDay();
  return r === 0 || r === 6;
}
const lj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sj
}, Symbol.toStringTag, { value: "Module" })), cj = /* @__PURE__ */ qe(lj);
function uj(e, t) {
  var r, n, a, i, o, s, l, c;
  Ae(1, arguments);
  var u = fa(), d = Et((r = (n = (a = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : u.weekStartsOn) !== null && n !== void 0 ? n : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = Se(e), h = p.getDay(), m = (h < d ? -7 : 0) + 6 - (h - d);
  return p.setDate(p.getDate() + m), p.setHours(23, 59, 59, 999), p;
}
const fj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uj
}, Symbol.toStringTag, { value: "Module" })), lu = /* @__PURE__ */ qe(fj);
function dj(e, t) {
  var r, n, a, i, o, s, l, c;
  Ae(1, arguments);
  var u = fa(), d = Et((r = (n = (a = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : u.weekStartsOn) !== null && n !== void 0 ? n : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = Se(e), h = p.getDay(), m = (h < d ? 7 : 0) + h - d;
  return p.setDate(p.getDate() - m), p.setHours(0, 0, 0, 0), p;
}
const pj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dj
}, Symbol.toStringTag, { value: "Module" })), cu = /* @__PURE__ */ qe(pj);
var Hn = {};
function hj(e, t) {
  Ae(2, arguments);
  var r = Se(e), n = Et(t);
  return isNaN(n) ? /* @__PURE__ */ new Date(NaN) : (n && r.setDate(r.getDate() + n), r);
}
const vj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hj
}, Symbol.toStringTag, { value: "Module" })), uu = /* @__PURE__ */ qe(vj);
function mj(e, t) {
  Ae(2, arguments);
  var r = Se(e), n = Se(t), a = r.getFullYear() - n.getFullYear(), i = r.getMonth() - n.getMonth();
  return a * 12 + i;
}
const gj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mj
}, Symbol.toStringTag, { value: "Module" })), Lv = /* @__PURE__ */ qe(gj);
var yj = 864e5;
function kv(e, t) {
  Ae(2, arguments);
  var r = $s(e), n = $s(t), a = r.getTime() - Pl(r), i = n.getTime() - Pl(n);
  return Math.round((a - i) / yj);
}
const bj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kv
}, Symbol.toStringTag, { value: "Module" })), sd = /* @__PURE__ */ qe(bj);
function Cj(e) {
  Ae(1, arguments);
  var t = Se(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(23, 59, 59, 999), t;
}
const xj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Cj
}, Symbol.toStringTag, { value: "Module" })), ld = /* @__PURE__ */ qe(xj);
function wj(e) {
  Ae(1, arguments);
  var t = Se(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
const Oj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wj
}, Symbol.toStringTag, { value: "Module" })), cd = /* @__PURE__ */ qe(Oj);
Object.defineProperty(Hn, "__esModule", {
  value: !0
});
Hn.calcFocusDate = Dj;
Hn.findNextRangeIndex = Mj;
Hn.getMonthDisplayRange = Tj;
Hn.generateStyles = $j;
var Sj = pa(ti), Pj = pa(uu), Ej = pa(Lv), jj = pa(sd), _j = pa(lu), Aj = pa(cu), Rv = pa(ld), Bv = pa(cd);
function pa(e) {
  return e && e.__esModule ? e : { default: e };
}
function Dj(e, t) {
  var r = t.shownDate, n = t.date, a = t.months, i = t.ranges, o = t.focusedRange, s = t.displayMode, l;
  if (s === "dateRange") {
    var c = i[o[0]] || {};
    l = {
      start: c.startDate,
      end: c.endDate
    };
  } else
    l = {
      start: n,
      end: n
    };
  l.start = (0, Bv.default)(l.start || /* @__PURE__ */ new Date()), l.end = (0, Rv.default)(l.end || l.start);
  var u = l.start || l.end || r || /* @__PURE__ */ new Date();
  return e ? (0, Ej.default)(l.start, l.end) > a ? e : u : r || u;
}
function Mj(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, r = e.findIndex(function(n, a) {
    return a > t && n.autoFocus !== !1 && !n.disabled;
  });
  return r !== -1 ? r : e.findIndex(function(n) {
    return n.autoFocus !== !1 && !n.disabled;
  });
}
function Tj(e, t, r) {
  var n = (0, Bv.default)(e, t), a = (0, Rv.default)(e, t), i = (0, Aj.default)(n, t), o = (0, _j.default)(a, t);
  return r && (0, jj.default)(o, i) <= 34 && (o = (0, Pj.default)(o, 7)), {
    start: i,
    end: o,
    startDateOfMonth: n,
    endDateOfMonth: a
  };
}
function $j(e) {
  if (!e.length)
    return {};
  var t = e.filter(function(r) {
    return !!r;
  }).reduce(function(r, n) {
    return Object.keys(n).forEach(function(a) {
      r[a] = (0, Sj.default)(r[a], n[a]);
    }), r;
  }, {});
  return t;
}
function us(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? us = function(r) {
    return typeof r;
  } : us = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, us(e);
}
Object.defineProperty(su, "__esModule", {
  value: !0
});
su.default = void 0;
var La = Zv(E), lt = Hr(tn), Vv = Zv(kn), Hv = Hr(Nv), Nj = Hr(Iv), Ij = Hr(cj), Lj = Hr(wv), di = Hr(iu), kj = Hr(rd), Fv = Hr(lu), Wv = Hr(cu), Rj = Hr(td), Bj = Hr(id), zv = Hr(ou), Vj = Hn;
function Hr(e) {
  return e && e.__esModule ? e : { default: e };
}
function Uv(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (Uv = function(a) {
    return a ? r : t;
  })(e);
}
function Zv(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || us(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = Uv(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function W3() {
  return W3 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, W3.apply(this, arguments);
}
function R5(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function B5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? R5(Object(r), !0).forEach(function(n) {
      Hj(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : R5(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Hj(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Fj(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function V5(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Wj(e, t, r) {
  return t && V5(e.prototype, t), r && V5(e, r), e;
}
function zj(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && z3(e, t);
}
function z3(e, t) {
  return z3 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, z3(e, t);
}
function Uj(e) {
  var t = Gj();
  return function() {
    var n = _l(e), a;
    if (t) {
      var i = _l(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return Zj(this, a);
  };
}
function Zj(e, t) {
  return t && (us(t) === "object" || typeof t == "function") ? t : qj(e);
}
function qj(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Gj() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _l(e) {
  return _l = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, _l(e);
}
function Yj(e, t, r) {
  var n = /* @__PURE__ */ new Date();
  return /* @__PURE__ */ La.default.createElement("div", {
    className: e.weekDays
  }, (0, Hv.default)({
    start: (0, Wv.default)(n, t),
    end: (0, Fv.default)(n, t)
  }).map(function(a, i) {
    return /* @__PURE__ */ La.default.createElement("span", {
      className: e.weekDay,
      key: i
    }, (0, zv.default)(a, r, t));
  }));
}
var ud = /* @__PURE__ */ function(e) {
  zj(r, e);
  var t = Uj(r);
  function r() {
    return Fj(this, r), t.apply(this, arguments);
  }
  return Wj(r, [{
    key: "render",
    value: function() {
      var a = this, i = /* @__PURE__ */ new Date(), o = this.props, s = o.displayMode, l = o.focusedRange, c = o.drag, u = o.styles, d = o.disabledDates, p = o.disabledDay, h = this.props.minDate && (0, Bj.default)(this.props.minDate), m = this.props.maxDate && (0, Rj.default)(this.props.maxDate), v = (0, Vj.getMonthDisplayRange)(this.props.month, this.props.dateOptions, this.props.fixedHeight), g = this.props.ranges;
      if (s === "dateRange" && c.status) {
        var b = c.range, C = b.startDate, w = b.endDate;
        g = g.map(function(y, O) {
          return O !== l[0] ? y : B5(B5({}, y), {}, {
            startDate: C,
            endDate: w
          });
        });
      }
      var x = this.props.showPreview && !c.disablePreview;
      return /* @__PURE__ */ La.default.createElement("div", {
        className: u.month,
        style: this.props.style
      }, this.props.showMonthName ? /* @__PURE__ */ La.default.createElement("div", {
        className: u.monthName
      }, (0, zv.default)(this.props.month, this.props.monthDisplayFormat, this.props.dateOptions)) : null, this.props.showWeekDays && Yj(u, this.props.dateOptions, this.props.weekdayDisplayFormat), /* @__PURE__ */ La.default.createElement("div", {
        className: u.days,
        onMouseLeave: this.props.onMouseLeave
      }, (0, Hv.default)({
        start: v.start,
        end: v.end
      }).map(function(y, O) {
        var P = (0, di.default)(y, v.startDateOfMonth), j = (0, di.default)(y, v.endDateOfMonth), T = h && (0, kj.default)(y, h) || m && (0, Lj.default)(y, m), I = d.some(function(F) {
          return (0, di.default)(F, y);
        }), R = p(y);
        return /* @__PURE__ */ La.default.createElement(Vv.default, W3({}, a.props, {
          ranges: g,
          day: y,
          preview: x ? a.props.preview : null,
          isWeekend: (0, Ij.default)(y, a.props.dateOptions),
          isToday: (0, di.default)(y, i),
          isStartOfWeek: (0, di.default)(y, (0, Wv.default)(y, a.props.dateOptions)),
          isEndOfWeek: (0, di.default)(y, (0, Fv.default)(y, a.props.dateOptions)),
          isStartOfMonth: P,
          isEndOfMonth: j,
          key: O,
          disabled: T || I || R,
          isPassive: !(0, Nj.default)(y, {
            start: v.startDateOfMonth,
            end: v.endDateOfMonth
          }),
          styles: u,
          onMouseDown: a.props.onDragSelectionStart,
          onMouseUp: a.props.onDragSelectionEnd,
          onMouseEnter: a.props.onDragSelectionMove,
          dragRange: c.range,
          drag: c.status
        }));
      })));
    }
  }]), r;
}(La.PureComponent);
ud.defaultProps = {};
ud.propTypes = {
  style: lt.default.object,
  styles: lt.default.object,
  month: lt.default.object,
  drag: lt.default.object,
  dateOptions: lt.default.object,
  disabledDates: lt.default.array,
  disabledDay: lt.default.func,
  preview: lt.default.shape({
    startDate: lt.default.object,
    endDate: lt.default.object
  }),
  showPreview: lt.default.bool,
  displayMode: lt.default.oneOf(["dateRange", "date"]),
  minDate: lt.default.object,
  maxDate: lt.default.object,
  ranges: lt.default.arrayOf(Vv.rangeShape),
  focusedRange: lt.default.arrayOf(lt.default.number),
  onDragSelectionStart: lt.default.func,
  onDragSelectionEnd: lt.default.func,
  onDragSelectionMove: lt.default.func,
  onMouseLeave: lt.default.func,
  monthDisplayFormat: lt.default.string,
  weekdayDisplayFormat: lt.default.string,
  dayDisplayFormat: lt.default.string,
  showWeekDays: lt.default.bool,
  showMonthName: lt.default.bool,
  fixedHeight: lt.default.bool
};
var Kj = ud;
su.default = Kj;
var fu = {};
function Xj(e, t) {
  Ae(2, arguments);
  var r = Se(e), n = Se(t);
  return r.getTime() === n.getTime();
}
const Qj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xj
}, Symbol.toStringTag, { value: "Module" })), Jj = /* @__PURE__ */ qe(Qj), e_ = /* @__PURE__ */ qe(IP);
function H5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function t_(e, t) {
  if (e) {
    if (typeof e == "string")
      return H5(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? H5(e, t) : void 0;
  }
}
function F5(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = t_(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, a = function() {
      };
      return {
        s: a,
        n: function() {
          return n >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[n++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: a
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, o = !0, s = !1;
  return {
    s: function() {
      r = r.call(e);
    },
    n: function() {
      var c = r.next();
      return o = c.done, c;
    },
    e: function(c) {
      s = !0, i = c;
    },
    f: function() {
      try {
        o || r.return == null || r.return();
      } finally {
        if (s)
          throw i;
      }
    }
  };
}
function r_(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  return e;
}
function fe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Al(e, t) {
  return Al = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, Al(e, t);
}
function Fe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Al(e, t);
}
function Dl(e) {
  return Dl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Dl(e);
}
function qv() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (qv = function() {
    return !!e;
  })();
}
function n_(e, t) {
  if (t && (Jr(t) == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return fe(e);
}
function We(e) {
  var t = qv();
  return function() {
    var r, n = Dl(e);
    if (t) {
      var a = Dl(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else
      r = n.apply(this, arguments);
    return n_(this, r);
  };
}
function Le(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function a_(e, t) {
  if (Jr(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Jr(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Gv(e) {
  var t = a_(e, "string");
  return Jr(t) == "symbol" ? t : t + "";
}
function W5(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Gv(n.key), n);
  }
}
function ke(e, t, r) {
  return t && W5(e.prototype, t), r && W5(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function ce(e, t, r) {
  return (t = Gv(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var i_ = 10, Yv = /* @__PURE__ */ function() {
  function e() {
    Le(this, e), ce(this, "priority", void 0), ce(this, "subPriority", 0);
  }
  return ke(e, [{
    key: "validate",
    value: function(r, n) {
      return !0;
    }
  }]), e;
}(), o_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r(n, a, i, o, s) {
    var l;
    return Le(this, r), l = t.call(this), l.value = n, l.validateValue = a, l.setValue = i, l.priority = o, s && (l.subPriority = s), l;
  }
  return ke(r, [{
    key: "validate",
    value: function(a, i) {
      return this.validateValue(a, this.value, i);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return this.setValue(a, i, this.value, o);
    }
  }]), r;
}(Yv), s_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", i_), ce(fe(n), "subPriority", -1), n;
  }
  return ke(r, [{
    key: "set",
    value: function(a, i) {
      if (i.timestampIsSet)
        return a;
      var o = /* @__PURE__ */ new Date(0);
      return o.setFullYear(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()), o.setHours(a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds(), a.getUTCMilliseconds()), o;
    }
  }]), r;
}(Yv), Ge = /* @__PURE__ */ function() {
  function e() {
    Le(this, e), ce(this, "incompatibleTokens", void 0), ce(this, "priority", void 0), ce(this, "subPriority", void 0);
  }
  return ke(e, [{
    key: "run",
    value: function(r, n, a, i) {
      var o = this.parse(r, n, a, i);
      return o ? {
        setter: new o_(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(r, n, a) {
      return !0;
    }
  }]), e;
}(), l_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 140), ce(fe(n), "incompatibleTokens", ["R", "u", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "G":
        case "GG":
        case "GGG":
          return o.era(a, {
            width: "abbreviated"
          }) || o.era(a, {
            width: "narrow"
          });
        case "GGGGG":
          return o.era(a, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return o.era(a, {
            width: "wide"
          }) || o.era(a, {
            width: "abbreviated"
          }) || o.era(a, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return i.era = o, a.setUTCFullYear(o, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ge), c_ = 6e4, u_ = 36e5, f_ = 1e3, At = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, un = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Dt(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function wt(e, t) {
  var r = t.match(e);
  return r ? {
    value: parseInt(r[0], 10),
    rest: t.slice(r[0].length)
  } : null;
}
function fn(e, t) {
  var r = t.match(e);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var n = r[1] === "+" ? 1 : -1, a = r[2] ? parseInt(r[2], 10) : 0, i = r[3] ? parseInt(r[3], 10) : 0, o = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: n * (a * u_ + i * c_ + o * f_),
    rest: t.slice(r[0].length)
  };
}
function Kv(e) {
  return wt(At.anyDigitsSigned, e);
}
function jt(e, t) {
  switch (e) {
    case 1:
      return wt(At.singleDigit, t);
    case 2:
      return wt(At.twoDigits, t);
    case 3:
      return wt(At.threeDigits, t);
    case 4:
      return wt(At.fourDigits, t);
    default:
      return wt(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function Ml(e, t) {
  switch (e) {
    case 1:
      return wt(At.singleDigitSigned, t);
    case 2:
      return wt(At.twoDigitsSigned, t);
    case 3:
      return wt(At.threeDigitsSigned, t);
    case 4:
      return wt(At.fourDigitsSigned, t);
    default:
      return wt(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function fd(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Xv(e, t) {
  var r = t > 0, n = r ? t : 1 - t, a;
  if (n <= 50)
    a = e || 100;
  else {
    var i = n + 50, o = Math.floor(i / 100) * 100, s = e >= i % 100;
    a = e + o - (s ? 100 : 0);
  }
  return r ? a : 1 - a;
}
function Qv(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var d_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 130), ce(fe(n), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(c) {
        return {
          year: c,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return Dt(jt(4, a), s);
        case "yo":
          return Dt(o.ordinalNumber(a, {
            unit: "year"
          }), s);
        default:
          return Dt(jt(i.length, a), s);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = a.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var l = Xv(o.year, s);
        return a.setUTCFullYear(l, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
      }
      var c = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return a.setUTCFullYear(c, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ge), p_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 130), ce(fe(n), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(c) {
        return {
          year: c,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return Dt(jt(4, a), s);
        case "Yo":
          return Dt(o.ordinalNumber(a, {
            unit: "year"
          }), s);
        default:
          return Dt(jt(i.length, a), s);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      var l = nd(a, s);
      if (o.isTwoDigitYear) {
        var c = Xv(o.year, l);
        return a.setUTCFullYear(c, 0, s.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), Ka(a, s);
      }
      var u = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return a.setUTCFullYear(u, 0, s.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), Ka(a, s);
    }
  }]), r;
}(Ge), h_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 130), ce(fe(n), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i) {
      return Ml(i === "R" ? 4 : i.length, a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = /* @__PURE__ */ new Date(0);
      return s.setUTCFullYear(o, 0, 4), s.setUTCHours(0, 0, 0, 0), ki(s);
    }
  }]), r;
}(Ge), v_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 130), ce(fe(n), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i) {
      return Ml(i === "u" ? 4 : i.length, a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCFullYear(o, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ge), m_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 120), ce(fe(n), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "Q":
        case "QQ":
          return jt(i.length, a);
        case "Qo":
          return o.ordinalNumber(a, {
            unit: "quarter"
          });
        case "QQQ":
          return o.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return o.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return o.quarter(a, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth((o - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ge), g_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 120), ce(fe(n), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "q":
        case "qq":
          return jt(i.length, a);
        case "qo":
          return o.ordinalNumber(a, {
            unit: "quarter"
          });
        case "qqq":
          return o.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return o.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return o.quarter(a, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth((o - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ge), y_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), ce(fe(n), "priority", 110), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(c) {
        return c - 1;
      };
      switch (i) {
        case "M":
          return Dt(wt(At.month, a), s);
        case "MM":
          return Dt(jt(2, a), s);
        case "Mo":
          return Dt(o.ordinalNumber(a, {
            unit: "month"
          }), s);
        case "MMM":
          return o.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return o.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return o.month(a, {
            width: "wide",
            context: "formatting"
          }) || o.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth(o, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ge), b_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 110), ce(fe(n), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(c) {
        return c - 1;
      };
      switch (i) {
        case "L":
          return Dt(wt(At.month, a), s);
        case "LL":
          return Dt(jt(2, a), s);
        case "Lo":
          return Dt(o.ordinalNumber(a, {
            unit: "month"
          }), s);
        case "LLL":
          return o.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return o.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return o.month(a, {
            width: "wide",
            context: "standalone"
          }) || o.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth(o, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ge);
function C_(e, t, r) {
  Ae(2, arguments);
  var n = Se(e), a = Et(t), i = jv(n, r) - a;
  return n.setUTCDate(n.getUTCDate() - i * 7), n;
}
var x_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 100), ce(fe(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "w":
          return wt(At.week, a);
        case "wo":
          return o.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return jt(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      return Ka(C_(a, o, s), s);
    }
  }]), r;
}(Ge);
function w_(e, t) {
  Ae(2, arguments);
  var r = Se(e), n = Et(t), a = Ev(r) - n;
  return r.setUTCDate(r.getUTCDate() - a * 7), r;
}
var O_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 100), ce(fe(n), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "I":
          return wt(At.week, a);
        case "Io":
          return o.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return jt(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return ki(w_(a, o));
    }
  }]), r;
}(Ge), S_ = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], P_ = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], E_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 90), ce(fe(n), "subPriority", 1), ce(fe(n), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "d":
          return wt(At.date, a);
        case "do":
          return o.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return jt(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      var o = a.getUTCFullYear(), s = Qv(o), l = a.getUTCMonth();
      return s ? i >= 1 && i <= P_[l] : i >= 1 && i <= S_[l];
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCDate(o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ge), j_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 90), ce(fe(n), "subpriority", 1), ce(fe(n), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "D":
        case "DD":
          return wt(At.dayOfYear, a);
        case "Do":
          return o.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return jt(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      var o = a.getUTCFullYear(), s = Qv(o);
      return s ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth(0, o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ge);
function dd(e, t, r) {
  var n, a, i, o, s, l, c, u;
  Ae(2, arguments);
  var d = fa(), p = Et((n = (a = (i = (o = r == null ? void 0 : r.weekStartsOn) !== null && o !== void 0 ? o : r == null || (s = r.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && i !== void 0 ? i : d.weekStartsOn) !== null && a !== void 0 ? a : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = Se(e), m = Et(t), v = h.getUTCDay(), g = m % 7, b = (g + 7) % 7, C = (b < p ? 7 : 0) + m - v;
  return h.setUTCDate(h.getUTCDate() + C), h;
}
var __ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 90), ce(fe(n), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "E":
        case "EE":
        case "EEE":
          return o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return o.day(a, {
            width: "wide",
            context: "formatting"
          }) || o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      return a = dd(a, o, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ge), A_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 90), ce(fe(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o, s) {
      var l = function(u) {
        var d = Math.floor((u - 1) / 7) * 7;
        return (u + s.weekStartsOn + 6) % 7 + d;
      };
      switch (i) {
        case "e":
        case "ee":
          return Dt(jt(i.length, a), l);
        case "eo":
          return Dt(o.ordinalNumber(a, {
            unit: "day"
          }), l);
        case "eee":
          return o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return o.day(a, {
            width: "wide",
            context: "formatting"
          }) || o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      return a = dd(a, o, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ge), D_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 90), ce(fe(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o, s) {
      var l = function(u) {
        var d = Math.floor((u - 1) / 7) * 7;
        return (u + s.weekStartsOn + 6) % 7 + d;
      };
      switch (i) {
        case "c":
        case "cc":
          return Dt(jt(i.length, a), l);
        case "co":
          return Dt(o.ordinalNumber(a, {
            unit: "day"
          }), l);
        case "ccc":
          return o.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(a, {
            width: "short",
            context: "standalone"
          }) || o.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return o.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return o.day(a, {
            width: "short",
            context: "standalone"
          }) || o.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return o.day(a, {
            width: "wide",
            context: "standalone"
          }) || o.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(a, {
            width: "short",
            context: "standalone"
          }) || o.day(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      return a = dd(a, o, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ge);
function M_(e, t) {
  Ae(2, arguments);
  var r = Et(t);
  r % 7 === 0 && (r = r - 7);
  var n = 1, a = Se(e), i = a.getUTCDay(), o = r % 7, s = (o + 7) % 7, l = (s < n ? 7 : 0) + r - i;
  return a.setUTCDate(a.getUTCDate() + l), a;
}
var T_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 90), ce(fe(n), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(c) {
        return c === 0 ? 7 : c;
      };
      switch (i) {
        case "i":
        case "ii":
          return jt(i.length, a);
        case "io":
          return o.ordinalNumber(a, {
            unit: "day"
          });
        case "iii":
          return Dt(o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiii":
          return Dt(o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiiii":
          return Dt(o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiii":
        default:
          return Dt(o.day(a, {
            width: "wide",
            context: "formatting"
          }) || o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a = M_(a, o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Ge), $_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 80), ce(fe(n), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return o.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(fd(o), 0, 0, 0), a;
    }
  }]), r;
}(Ge), N_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 80), ce(fe(n), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return o.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(fd(o), 0, 0, 0), a;
    }
  }]), r;
}(Ge), I_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 80), ce(fe(n), "incompatibleTokens", ["a", "b", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return o.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(fd(o), 0, 0, 0), a;
    }
  }]), r;
}(Ge), L_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 70), ce(fe(n), "incompatibleTokens", ["H", "K", "k", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "h":
          return wt(At.hour12h, a);
        case "ho":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return jt(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = a.getUTCHours() >= 12;
      return s && o < 12 ? a.setUTCHours(o + 12, 0, 0, 0) : !s && o === 12 ? a.setUTCHours(0, 0, 0, 0) : a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), r;
}(Ge), k_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 70), ce(fe(n), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "H":
          return wt(At.hour23h, a);
        case "Ho":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return jt(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), r;
}(Ge), R_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 70), ce(fe(n), "incompatibleTokens", ["h", "H", "k", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "K":
          return wt(At.hour11h, a);
        case "Ko":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return jt(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = a.getUTCHours() >= 12;
      return s && o < 12 ? a.setUTCHours(o + 12, 0, 0, 0) : a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), r;
}(Ge), B_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 70), ce(fe(n), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "k":
          return wt(At.hour24h, a);
        case "ko":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return jt(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = o <= 24 ? o % 24 : o;
      return a.setUTCHours(s, 0, 0, 0), a;
    }
  }]), r;
}(Ge), V_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 60), ce(fe(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "m":
          return wt(At.minute, a);
        case "mo":
          return o.ordinalNumber(a, {
            unit: "minute"
          });
        default:
          return jt(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMinutes(o, 0, 0), a;
    }
  }]), r;
}(Ge), H_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 50), ce(fe(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "s":
          return wt(At.second, a);
        case "so":
          return o.ordinalNumber(a, {
            unit: "second"
          });
        default:
          return jt(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCSeconds(o, 0), a;
    }
  }]), r;
}(Ge), F_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 30), ce(fe(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i) {
      var o = function(l) {
        return Math.floor(l * Math.pow(10, -i.length + 3));
      };
      return Dt(jt(i.length, a), o);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMilliseconds(o), a;
    }
  }]), r;
}(Ge), W_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 10), ce(fe(n), "incompatibleTokens", ["t", "T", "x"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i) {
      switch (i) {
        case "X":
          return fn(un.basicOptionalMinutes, a);
        case "XX":
          return fn(un.basic, a);
        case "XXXX":
          return fn(un.basicOptionalSeconds, a);
        case "XXXXX":
          return fn(un.extendedOptionalSeconds, a);
        case "XXX":
        default:
          return fn(un.extended, a);
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return i.timestampIsSet ? a : new Date(a.getTime() - o);
    }
  }]), r;
}(Ge), z_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 10), ce(fe(n), "incompatibleTokens", ["t", "T", "X"]), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a, i) {
      switch (i) {
        case "x":
          return fn(un.basicOptionalMinutes, a);
        case "xx":
          return fn(un.basic, a);
        case "xxxx":
          return fn(un.basicOptionalSeconds, a);
        case "xxxxx":
          return fn(un.extendedOptionalSeconds, a);
        case "xxx":
        default:
          return fn(un.extended, a);
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return i.timestampIsSet ? a : new Date(a.getTime() - o);
    }
  }]), r;
}(Ge), U_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 40), ce(fe(n), "incompatibleTokens", "*"), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a) {
      return Kv(a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(Ge), Z_ = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = We(r);
  function r() {
    var n;
    Le(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), ce(fe(n), "priority", 20), ce(fe(n), "incompatibleTokens", "*"), n;
  }
  return ke(r, [{
    key: "parse",
    value: function(a) {
      return Kv(a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return [new Date(o), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(Ge), q_ = {
  G: new l_(),
  y: new d_(),
  Y: new p_(),
  R: new h_(),
  u: new v_(),
  Q: new m_(),
  q: new g_(),
  M: new y_(),
  L: new b_(),
  w: new x_(),
  I: new O_(),
  d: new E_(),
  D: new j_(),
  E: new __(),
  e: new A_(),
  c: new D_(),
  i: new T_(),
  a: new $_(),
  b: new N_(),
  B: new I_(),
  h: new L_(),
  H: new k_(),
  K: new R_(),
  k: new B_(),
  m: new V_(),
  s: new H_(),
  S: new F_(),
  X: new W_(),
  x: new z_(),
  t: new U_(),
  T: new Z_()
}, G_ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Y_ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, K_ = /^'([^]*?)'?$/, X_ = /''/g, Q_ = /\S/, J_ = /[a-zA-Z]/;
function eA(e, t, r, n) {
  var a, i, o, s, l, c, u, d, p, h, m, v, g, b, C, w, x, y;
  Ae(3, arguments);
  var O = String(e), P = String(t), j = fa(), T = (a = (i = n == null ? void 0 : n.locale) !== null && i !== void 0 ? i : j.locale) !== null && a !== void 0 ? a : ad;
  if (!T.match)
    throw new RangeError("locale must contain match property");
  var I = Et((o = (s = (l = (c = n == null ? void 0 : n.firstWeekContainsDate) !== null && c !== void 0 ? c : n == null || (u = n.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && l !== void 0 ? l : j.firstWeekContainsDate) !== null && s !== void 0 ? s : (p = j.locale) === null || p === void 0 || (h = p.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(I >= 1 && I <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var R = Et((m = (v = (g = (b = n == null ? void 0 : n.weekStartsOn) !== null && b !== void 0 ? b : n == null || (C = n.locale) === null || C === void 0 || (w = C.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && g !== void 0 ? g : j.weekStartsOn) !== null && v !== void 0 ? v : (x = j.locale) === null || x === void 0 || (y = x.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && m !== void 0 ? m : 0);
  if (!(R >= 0 && R <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (P === "")
    return O === "" ? Se(r) : /* @__PURE__ */ new Date(NaN);
  var F = {
    firstWeekContainsDate: I,
    weekStartsOn: R,
    locale: T
  }, $ = [new s_()], Z = P.match(Y_).map(function(k) {
    var L = k[0];
    if (L in R3) {
      var W = R3[L];
      return W(k, T.formatLong);
    }
    return k;
  }).join("").match(G_), X = [], K = F5(Z), J;
  try {
    var ee = function() {
      var L = J.value;
      !(n != null && n.useAdditionalWeekYearTokens) && Dv(L) && El(L, P, e), !(n != null && n.useAdditionalDayOfYearTokens) && Av(L) && El(L, P, e);
      var W = L[0], V = q_[W];
      if (V) {
        var D = V.incompatibleTokens;
        if (Array.isArray(D)) {
          var Q = X.find(function(te) {
            return D.includes(te.token) || te.token === W;
          });
          if (Q)
            throw new RangeError("The format string mustn't contain `".concat(Q.fullToken, "` and `").concat(L, "` at the same time"));
        } else if (V.incompatibleTokens === "*" && X.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(L, "` and any other token at the same time"));
        X.push({
          token: W,
          fullToken: L
        });
        var z = V.run(O, L, T.match, F);
        if (!z)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        $.push(z.setter), O = z.rest;
      } else {
        if (W.match(J_))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + W + "`");
        if (L === "''" ? L = "'" : W === "'" && (L = tA(L)), O.indexOf(L) === 0)
          O = O.slice(L.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (K.s(); !(J = K.n()).done; ) {
      var A = ee();
      if (Jr(A) === "object")
        return A.v;
    }
  } catch (k) {
    K.e(k);
  } finally {
    K.f();
  }
  if (O.length > 0 && Q_.test(O))
    return /* @__PURE__ */ new Date(NaN);
  var _ = $.map(function(k) {
    return k.priority;
  }).sort(function(k, L) {
    return L - k;
  }).filter(function(k, L, W) {
    return W.indexOf(k) === L;
  }).map(function(k) {
    return $.filter(function(L) {
      return L.priority === k;
    }).sort(function(L, W) {
      return W.subPriority - L.subPriority;
    });
  }).map(function(k) {
    return k[0];
  }), N = Se(r);
  if (isNaN(N.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var M = Sv(N, Pl(N)), S = {}, B = F5(_), G;
  try {
    for (B.s(); !(G = B.n()).done; ) {
      var U = G.value;
      if (!U.validate(M, F))
        return /* @__PURE__ */ new Date(NaN);
      var H = U.set(M, S, F);
      Array.isArray(H) ? (M = H[0], r_(S, H[1])) : M = H;
    }
  } catch (k) {
    B.e(k);
  } finally {
    B.f();
  }
  return M;
}
function tA(e) {
  return e.match(K_)[1].replace(X_, "'");
}
const rA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: eA
}, Symbol.toStringTag, { value: "Module" })), nA = /* @__PURE__ */ qe(rA);
function fs(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? fs = function(r) {
    return typeof r;
  } : fs = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, fs(e);
}
Object.defineProperty(fu, "__esModule", {
  value: !0
});
fu.default = void 0;
var Z1 = lA(E), nn = wo(tn), aA = wo(ti), iA = wo(Jj), z5 = wo(e_), oA = wo(nA), sA = wo(ou);
function wo(e) {
  return e && e.__esModule ? e : { default: e };
}
function Jv(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (Jv = function(a) {
    return a ? r : t;
  })(e);
}
function lA(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || fs(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = Jv(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function cA(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function U5(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function uA(e, t, r) {
  return t && U5(e.prototype, t), r && U5(e, r), e;
}
function fA(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && U3(e, t);
}
function U3(e, t) {
  return U3 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, U3(e, t);
}
function dA(e) {
  var t = hA();
  return function() {
    var n = Tl(e), a;
    if (t) {
      var i = Tl(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return pA(this, a);
  };
}
function pA(e, t) {
  return t && (fs(t) === "object" || typeof t == "function") ? t : yl(e);
}
function yl(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function hA() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Tl(e) {
  return Tl = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Tl(e);
}
function S2(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var pd = /* @__PURE__ */ function(e) {
  fA(r, e);
  var t = dA(r);
  function r(n, a) {
    var i;
    return cA(this, r), i = t.call(this, n, a), S2(yl(i), "onKeyDown", function(o) {
      var s = i.state.value;
      o.key === "Enter" && i.update(s);
    }), S2(yl(i), "onChange", function(o) {
      i.setState({
        value: o.target.value,
        changed: !0,
        invalid: !1
      });
    }), S2(yl(i), "onBlur", function() {
      var o = i.state.value;
      i.update(o);
    }), i.state = {
      invalid: !1,
      changed: !1,
      value: i.formatDate(n)
    }, i;
  }
  return uA(r, [{
    key: "componentDidUpdate",
    value: function(a) {
      var i = a.value;
      (0, iA.default)(i, this.props.value) || this.setState({
        value: this.formatDate(this.props)
      });
    }
  }, {
    key: "formatDate",
    value: function(a) {
      var i = a.value, o = a.dateDisplayFormat, s = a.dateOptions;
      return i && (0, z5.default)(i) ? (0, sA.default)(i, o, s) : "";
    }
  }, {
    key: "update",
    value: function(a) {
      var i = this.state, o = i.invalid, s = i.changed;
      if (!(o || !s || !a)) {
        var l = this.props, c = l.onChange, u = l.dateDisplayFormat, d = l.dateOptions, p = (0, oA.default)(a, u, /* @__PURE__ */ new Date(), d);
        (0, z5.default)(p) ? this.setState({
          changed: !1
        }, function() {
          return c(p);
        }) : this.setState({
          invalid: !0
        });
      }
    }
  }, {
    key: "render",
    value: function() {
      var a = this.props, i = a.className, o = a.readOnly, s = a.placeholder, l = a.ariaLabel, c = a.disabled, u = a.onFocus, d = this.state, p = d.value, h = d.invalid;
      return /* @__PURE__ */ Z1.default.createElement("span", {
        className: (0, aA.default)("rdrDateInput", i)
      }, /* @__PURE__ */ Z1.default.createElement("input", {
        readOnly: o,
        disabled: c,
        value: p,
        placeholder: s,
        "aria-label": l,
        onKeyDown: this.onKeyDown,
        onChange: this.onChange,
        onBlur: this.onBlur,
        onFocus: u
      }), h && /* @__PURE__ */ Z1.default.createElement("span", {
        className: "rdrWarning"
      }, "⚠"));
    }
  }]), r;
}(Z1.PureComponent);
pd.propTypes = {
  value: nn.default.object,
  placeholder: nn.default.string,
  disabled: nn.default.bool,
  readOnly: nn.default.bool,
  dateOptions: nn.default.object,
  dateDisplayFormat: nn.default.string,
  ariaLabel: nn.default.string,
  className: nn.default.string,
  onFocus: nn.default.func.isRequired,
  onChange: nn.default.func.isRequired
};
pd.defaultProps = {
  readOnly: !0,
  disabled: !1,
  dateDisplayFormat: "MMM D, YYYY"
};
var vA = pd;
fu.default = vA;
var em = { exports: {} };
(function(e, t) {
  (function(r, n) {
    n(tn, E);
  })(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : Ba, function(r, n) {
    r = l(r), n = s(n);
    var a, i;
    function o() {
      if (typeof WeakMap != "function")
        return null;
      var B = /* @__PURE__ */ new WeakMap();
      return o = function() {
        return B;
      }, B;
    }
    function s(B) {
      if (B && B.__esModule)
        return B;
      if (B === null || c(B) !== "object" && typeof B != "function")
        return { default: B };
      var G = o();
      if (G && G.has(B))
        return G.get(B);
      var U = {}, H = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var k in B)
        if (Object.prototype.hasOwnProperty.call(B, k)) {
          var L = H ? Object.getOwnPropertyDescriptor(B, k) : null;
          L && (L.get || L.set) ? Object.defineProperty(U, k, L) : U[k] = B[k];
        }
      return U.default = B, G && G.set(B, U), U;
    }
    function l(B) {
      return B && B.__esModule ? B : { default: B };
    }
    function c(B) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? c = function(U) {
        return typeof U;
      } : c = function(U) {
        return U && typeof Symbol == "function" && U.constructor === Symbol && U !== Symbol.prototype ? "symbol" : typeof U;
      }, c(B);
    }
    function u(B, G) {
      if (!(B instanceof G))
        throw new TypeError("Cannot call a class as a function");
    }
    function d(B, G) {
      for (var U = 0; U < G.length; U++) {
        var H = G[U];
        H.enumerable = H.enumerable || !1, H.configurable = !0, "value" in H && (H.writable = !0), Object.defineProperty(B, H.key, H);
      }
    }
    function p(B, G, U) {
      return G && d(B.prototype, G), U && d(B, U), B;
    }
    function h(B, G) {
      if (typeof G != "function" && G !== null)
        throw new TypeError("Super expression must either be null or a function");
      B.prototype = Object.create(G && G.prototype, { constructor: { value: B, writable: !0, configurable: !0 } }), G && m(B, G);
    }
    function m(B, G) {
      return m = Object.setPrototypeOf || function(H, k) {
        return H.__proto__ = k, H;
      }, m(B, G);
    }
    function v(B) {
      var G = C();
      return function() {
        var H = w(B), k;
        if (G) {
          var L = w(this).constructor;
          k = Reflect.construct(H, arguments, L);
        } else
          k = H.apply(this, arguments);
        return g(this, k);
      };
    }
    function g(B, G) {
      return G && (c(G) === "object" || typeof G == "function") ? G : b(B);
    }
    function b(B) {
      if (B === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return B;
    }
    function C() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function w(B) {
      return w = Object.setPrototypeOf ? Object.getPrototypeOf : function(U) {
        return U.__proto__ || Object.getPrototypeOf(U);
      }, w(B);
    }
    function x(B, G) {
      var U = Object.keys(B);
      if (Object.getOwnPropertySymbols) {
        var H = Object.getOwnPropertySymbols(B);
        G && (H = H.filter(function(k) {
          return Object.getOwnPropertyDescriptor(B, k).enumerable;
        })), U.push.apply(U, H);
      }
      return U;
    }
    function y(B) {
      for (var G = 1; G < arguments.length; G++) {
        var U = arguments[G] != null ? arguments[G] : {};
        G % 2 ? x(Object(U), !0).forEach(function(H) {
          O(B, H, U[H]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(B, Object.getOwnPropertyDescriptors(U)) : x(Object(U)).forEach(function(H) {
          Object.defineProperty(B, H, Object.getOwnPropertyDescriptor(U, H));
        });
      }
      return B;
    }
    function O(B, G, U) {
      return G in B ? Object.defineProperty(B, G, { value: U, enumerable: !0, configurable: !0, writable: !0 }) : B[G] = U, B;
    }
    var P = {
      x: "clientWidth",
      y: "clientHeight"
    }, j = {
      x: "clientTop",
      y: "clientLeft"
    }, T = {
      x: "innerWidth",
      y: "innerHeight"
    }, I = {
      x: "offsetWidth",
      y: "offsetHeight"
    }, R = {
      x: "offsetLeft",
      y: "offsetTop"
    }, F = {
      x: "overflowX",
      y: "overflowY"
    }, $ = {
      x: "scrollWidth",
      y: "scrollHeight"
    }, Z = {
      x: "scrollLeft",
      y: "scrollTop"
    }, X = {
      x: "width",
      y: "height"
    }, K = function() {
    }, J = function() {
      if (typeof window > "u")
        return !1;
      var B = !1;
      try {
        document.createElement("div").addEventListener("test", K, {
          get passive() {
            return B = !0, !1;
          }
        });
      } catch {
      }
      return B;
    }() ? {
      passive: !0
    } : !1, ee = "ReactList failed to reach a stable state.", A = 40, _ = function(G, U) {
      for (var H in U)
        if (G[H] !== U[H])
          return !1;
      return !0;
    }, N = function(G) {
      for (var U = G.props.axis, H = G.getEl(), k = F[U]; H = H.parentElement; )
        switch (window.getComputedStyle(H)[k]) {
          case "auto":
          case "scroll":
          case "overlay":
            return H;
        }
      return window;
    }, M = function(G) {
      var U = G.props.axis, H = G.scrollParent;
      return H === window ? window[T[U]] : H[P[U]];
    }, S = function(G, U) {
      var H = G.length, k = G.minSize, L = G.type, W = U.from, V = U.size, D = U.itemsPerRow;
      V = Math.max(V, k);
      var Q = V % D;
      return Q && (V += D - Q), V > H && (V = H), W = L === "simple" || !W ? 0 : Math.max(Math.min(W, H - V), 0), (Q = W % D) && (W -= Q, V += Q), W === U.from && V == U.size ? U : y(y({}, U), {}, {
        from: W,
        size: V
      });
    };
    e.exports = (i = a = /* @__PURE__ */ function(B) {
      h(U, B);
      var G = v(U);
      p(U, null, [{
        key: "getDerivedStateFromProps",
        value: function(k, L) {
          var W = S(k, L);
          return W === L ? null : W;
        }
      }]);
      function U(H) {
        var k;
        return u(this, U), k = G.call(this, H), k.state = S(H, {
          itemsPerRow: 1,
          from: H.initialIndex,
          size: 0
        }), k.cache = {}, k.cachedScrollPosition = null, k.prevPrevState = {}, k.unstable = !1, k.updateCounter = 0, k;
      }
      return p(U, [{
        key: "componentDidMount",
        value: function() {
          this.updateFrameAndClearCache = this.updateFrameAndClearCache.bind(this), window.addEventListener("resize", this.updateFrameAndClearCache), this.updateFrame(this.scrollTo.bind(this, this.props.initialIndex));
        }
      }, {
        key: "componentDidUpdate",
        value: function(k) {
          var L = this;
          if (this.props.axis !== k.axis && this.clearSizeCache(), !this.unstable) {
            if (++this.updateCounter > A)
              return this.unstable = !0, console.error(ee);
            this.updateCounterTimeoutId || (this.updateCounterTimeoutId = setTimeout(function() {
              L.updateCounter = 0, delete L.updateCounterTimeoutId;
            }, 0)), this.updateFrame();
          }
        }
      }, {
        key: "maybeSetState",
        value: function(k, L) {
          if (_(this.state, k))
            return L();
          this.setState(k, L);
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          window.removeEventListener("resize", this.updateFrameAndClearCache), this.scrollParent.removeEventListener("scroll", this.updateFrameAndClearCache, J), this.scrollParent.removeEventListener("mousewheel", K, J);
        }
      }, {
        key: "getOffset",
        value: function(k) {
          var L = this.props.axis, W = k[j[L]] || 0, V = R[L];
          do
            W += k[V] || 0;
          while (k = k.offsetParent);
          return W;
        }
      }, {
        key: "getEl",
        value: function() {
          return this.el || this.items;
        }
      }, {
        key: "getScrollPosition",
        value: function() {
          if (typeof this.cachedScrollPosition == "number")
            return this.cachedScrollPosition;
          var k = this.scrollParent, L = this.props.axis, W = Z[L], V = k === window ? (
            // Firefox always returns document.body[scrollKey] as 0 and Chrome/Safari
            // always return document.documentElement[scrollKey] as 0, so take
            // whichever has a value.
            document.body[W] || document.documentElement[W]
          ) : k[W], D = this.getScrollSize() - this.props.scrollParentViewportSizeGetter(this), Q = Math.max(0, Math.min(V, D)), z = this.getEl();
          return this.cachedScrollPosition = this.getOffset(k) + Q - this.getOffset(z), this.cachedScrollPosition;
        }
      }, {
        key: "setScroll",
        value: function(k) {
          var L = this.scrollParent, W = this.props.axis;
          if (k += this.getOffset(this.getEl()), L === window)
            return window.scrollTo(0, k);
          k -= this.getOffset(this.scrollParent), L[Z[W]] = k;
        }
      }, {
        key: "getScrollSize",
        value: function() {
          var k = this.scrollParent, L = document, W = L.body, V = L.documentElement, D = $[this.props.axis];
          return k === window ? Math.max(W[D], V[D]) : k[D];
        }
      }, {
        key: "hasDeterminateSize",
        value: function() {
          var k = this.props, L = k.itemSizeGetter, W = k.type;
          return W === "uniform" || L;
        }
      }, {
        key: "getStartAndEnd",
        value: function() {
          var k = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props.threshold, L = this.getScrollPosition(), W = Math.max(0, L - k), V = L + this.props.scrollParentViewportSizeGetter(this) + k;
          return this.hasDeterminateSize() && (V = Math.min(V, this.getSpaceBefore(this.props.length))), {
            start: W,
            end: V
          };
        }
      }, {
        key: "getItemSizeAndItemsPerRow",
        value: function() {
          var k = this.props, L = k.axis, W = k.useStaticSize, V = this.state, D = V.itemSize, Q = V.itemsPerRow;
          if (W && D && Q)
            return {
              itemSize: D,
              itemsPerRow: Q
            };
          var z = this.items.children;
          if (!z.length)
            return {};
          var te = z[0], ne = te[I[L]], ae = Math.abs(ne - D);
          if ((isNaN(ae) || ae >= 1) && (D = ne), !D)
            return {};
          var se = R[L], pe = te[se];
          Q = 1;
          for (var ue = z[Q]; ue && ue[se] === pe; ue = z[Q])
            ++Q;
          return {
            itemSize: D,
            itemsPerRow: Q
          };
        }
      }, {
        key: "clearSizeCache",
        value: function() {
          this.cachedScrollPosition = null;
        }
        // Called by 'scroll' and 'resize' events, clears scroll position cache.
      }, {
        key: "updateFrameAndClearCache",
        value: function(k) {
          return this.clearSizeCache(), this.updateFrame(k);
        }
      }, {
        key: "updateFrame",
        value: function(k) {
          switch (this.updateScrollParent(), typeof k != "function" && (k = K), this.props.type) {
            case "simple":
              return this.updateSimpleFrame(k);
            case "variable":
              return this.updateVariableFrame(k);
            case "uniform":
              return this.updateUniformFrame(k);
          }
        }
      }, {
        key: "updateScrollParent",
        value: function() {
          var k = this.scrollParent;
          this.scrollParent = this.props.scrollParentGetter(this), k !== this.scrollParent && (k && (k.removeEventListener("scroll", this.updateFrameAndClearCache), k.removeEventListener("mousewheel", K)), this.clearSizeCache(), this.scrollParent.addEventListener("scroll", this.updateFrameAndClearCache, J), this.scrollParent.addEventListener("mousewheel", K, J));
        }
      }, {
        key: "updateSimpleFrame",
        value: function(k) {
          var L = this.getStartAndEnd(), W = L.end, V = this.items.children, D = 0;
          if (V.length) {
            var Q = this.props.axis, z = V[0], te = V[V.length - 1];
            D = this.getOffset(te) + te[I[Q]] - this.getOffset(z);
          }
          if (D > W)
            return k();
          var ne = this.props, ae = ne.pageSize, se = ne.length, pe = Math.min(this.state.size + ae, se);
          this.maybeSetState({
            size: pe
          }, k);
        }
      }, {
        key: "updateVariableFrame",
        value: function(k) {
          this.props.itemSizeGetter || this.cacheSizes();
          for (var L = this.getStartAndEnd(), W = L.start, V = L.end, D = this.props, Q = D.length, z = D.pageSize, te = 0, ne = 0, ae = 0, se = Q - 1; ne < se; ) {
            var pe = this.getSizeOfItem(ne);
            if (pe == null || te + pe > W)
              break;
            te += pe, ++ne;
          }
          for (var ue = Q - ne; ae < ue && te < V; ) {
            var Te = this.getSizeOfItem(ne + ae);
            if (Te == null) {
              ae = Math.min(ae + z, ue);
              break;
            }
            te += Te, ++ae;
          }
          this.maybeSetState(S(this.props, {
            from: ne,
            itemsPerRow: 1,
            size: ae
          }), k);
        }
      }, {
        key: "updateUniformFrame",
        value: function(k) {
          var L = this.getItemSizeAndItemsPerRow(), W = L.itemSize, V = L.itemsPerRow;
          if (!W || !V)
            return k();
          var D = this.getStartAndEnd(), Q = D.start, z = D.end, te = S(this.props, {
            from: Math.floor(Q / W) * V,
            size: (Math.ceil((z - Q) / W) + 1) * V,
            itemsPerRow: V
          }), ne = te.from, ae = te.size;
          return this.maybeSetState({
            itemsPerRow: V,
            from: ne,
            itemSize: W,
            size: ae
          }, k);
        }
      }, {
        key: "getSpaceBefore",
        value: function(k) {
          var L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          if (L[k] != null)
            return L[k];
          var W = this.state, V = W.itemSize, D = W.itemsPerRow;
          if (V)
            return L[k] = Math.floor(k / D) * V;
          for (var Q = k; Q > 0 && L[--Q] == null; )
            ;
          for (var z = L[Q] || 0, te = Q; te < k; ++te) {
            L[te] = z;
            var ne = this.getSizeOfItem(te);
            if (ne == null)
              break;
            z += ne;
          }
          return L[k] = z;
        }
      }, {
        key: "cacheSizes",
        value: function() {
          for (var k = this.cache, L = this.state.from, W = this.items.children, V = I[this.props.axis], D = 0, Q = W.length; D < Q; ++D)
            k[L + D] = W[D][V];
        }
      }, {
        key: "getSizeOfItem",
        value: function(k) {
          var L = this.cache, W = this.items, V = this.props, D = V.axis, Q = V.itemSizeGetter, z = V.itemSizeEstimator, te = V.type, ne = this.state, ae = ne.from, se = ne.itemSize, pe = ne.size;
          if (se)
            return se;
          if (Q)
            return Q(k);
          if (k in L)
            return L[k];
          if (te === "simple" && k >= ae && k < ae + pe && W) {
            var ue = W.children[k - ae];
            if (ue)
              return ue[I[D]];
          }
          if (z)
            return z(k, L);
        }
      }, {
        key: "scrollTo",
        value: function(k) {
          k != null && this.setScroll(this.getSpaceBefore(k));
        }
      }, {
        key: "scrollAround",
        value: function(k) {
          var L = this.getScrollPosition(), W = this.getSpaceBefore(k), V = W - this.props.scrollParentViewportSizeGetter(this) + this.getSizeOfItem(k), D = Math.min(V, W), Q = Math.max(V, W);
          if (L <= D)
            return this.setScroll(D);
          if (L > Q)
            return this.setScroll(Q);
        }
      }, {
        key: "getVisibleRange",
        value: function() {
          for (var k = this.state, L = k.from, W = k.size, V = this.getStartAndEnd(0), D = V.start, Q = V.end, z = {}, te, ne, ae = L; ae < L + W; ++ae) {
            var se = this.getSpaceBefore(ae, z), pe = se + this.getSizeOfItem(ae);
            te == null && pe > D && (te = ae), te != null && se < Q && (ne = ae);
          }
          return [te, ne];
        }
      }, {
        key: "renderItems",
        value: function() {
          for (var k = this, L = this.props, W = L.itemRenderer, V = L.itemsRenderer, D = this.state, Q = D.from, z = D.size, te = [], ne = 0; ne < z; ++ne)
            te.push(W(Q + ne, ne));
          return V(te, function(ae) {
            return k.items = ae;
          });
        }
      }, {
        key: "render",
        value: function() {
          var k = this, L = this.props, W = L.axis, V = L.length, D = L.type, Q = L.useTranslate3d, z = this.state, te = z.from, ne = z.itemsPerRow, ae = this.renderItems();
          if (D === "simple")
            return ae;
          var se = {
            position: "relative"
          }, pe = {}, ue = Math.ceil(V / ne) * ne, Te = this.getSpaceBefore(ue, pe);
          Te && (se[X[W]] = Te, W === "x" && (se.overflowX = "hidden"));
          var Be = this.getSpaceBefore(te, pe), Ye = W === "x" ? Be : 0, Ct = W === "y" ? Be : 0, It = Q ? "translate3d(".concat(Ye, "px, ").concat(Ct, "px, 0)") : "translate(".concat(Ye, "px, ").concat(Ct, "px)"), Wr = {
            msTransform: It,
            WebkitTransform: It,
            transform: It
          };
          return /* @__PURE__ */ n.default.createElement("div", {
            style: se,
            ref: function(s2) {
              return k.el = s2;
            }
          }, /* @__PURE__ */ n.default.createElement("div", {
            style: Wr
          }, ae));
        }
      }]), U;
    }(n.Component), O(a, "displayName", "ReactList"), O(a, "propTypes", {
      axis: r.default.oneOf(["x", "y"]),
      initialIndex: r.default.number,
      itemRenderer: r.default.func,
      itemSizeEstimator: r.default.func,
      itemSizeGetter: r.default.func,
      itemsRenderer: r.default.func,
      length: r.default.number,
      minSize: r.default.number,
      pageSize: r.default.number,
      scrollParentGetter: r.default.func,
      scrollParentViewportSizeGetter: r.default.func,
      threshold: r.default.number,
      type: r.default.oneOf(["simple", "variable", "uniform"]),
      useStaticSize: r.default.bool,
      useTranslate3d: r.default.bool
    }), O(a, "defaultProps", {
      axis: "y",
      itemRenderer: function(G, U) {
        return /* @__PURE__ */ n.default.createElement("div", {
          key: U
        }, G);
      },
      itemsRenderer: function(G, U) {
        return /* @__PURE__ */ n.default.createElement("div", {
          ref: U
        }, G);
      },
      length: 0,
      minSize: 1,
      pageSize: 10,
      scrollParentGetter: N,
      scrollParentViewportSizeGetter: M,
      threshold: 100,
      type: "simple",
      useStaticSize: !1,
      useTranslate3d: !1
    }), i);
  });
})(em);
var mA = em.exports;
function gA(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  var r = Object.keys(e), n = Object.keys(t), a = r.length;
  if (n.length !== a)
    return !1;
  for (var i = 0; i < a; i++) {
    var o = r[i];
    if (e[o] !== t[o] || !Object.prototype.hasOwnProperty.call(t, o))
      return !1;
  }
  return !0;
}
function yA(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  var r = e.length;
  if (t.length !== r)
    return !1;
  for (var n = 0; n < r; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
const bA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  shallowEqualArrays: yA,
  shallowEqualObjects: gA
}, Symbol.toStringTag, { value: "Module" })), CA = /* @__PURE__ */ qe(bA);
function xA(e) {
  Ae(1, arguments);
  var t;
  if (e && typeof e.forEach == "function")
    t = e;
  else if (Jr(e) === "object" && e !== null)
    t = Array.prototype.slice.call(e);
  else
    return /* @__PURE__ */ new Date(NaN);
  var r;
  return t.forEach(function(n) {
    var a = Se(n);
    (r === void 0 || r < a || isNaN(Number(a))) && (r = a);
  }), r || /* @__PURE__ */ new Date(NaN);
}
const wA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xA
}, Symbol.toStringTag, { value: "Module" })), tm = /* @__PURE__ */ qe(wA);
function OA(e) {
  Ae(1, arguments);
  var t;
  if (e && typeof e.forEach == "function")
    t = e;
  else if (Jr(e) === "object" && e !== null)
    t = Array.prototype.slice.call(e);
  else
    return /* @__PURE__ */ new Date(NaN);
  var r;
  return t.forEach(function(n) {
    var a = Se(n);
    (r === void 0 || r > a || isNaN(a.getDate())) && (r = a);
  }), r || /* @__PURE__ */ new Date(NaN);
}
const SA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: OA
}, Symbol.toStringTag, { value: "Module" })), rm = /* @__PURE__ */ qe(SA);
function Z5(e, t) {
  var r = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function PA(e, t) {
  Ae(2, arguments);
  var r = Se(e), n = Se(t), a = Z5(r, n), i = Math.abs(kv(r, n));
  r.setDate(r.getDate() - a * i);
  var o = +(Z5(r, n) === -a), s = a * (i - o);
  return s === 0 ? 0 : s;
}
const EA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: PA
}, Symbol.toStringTag, { value: "Module" })), jA = /* @__PURE__ */ qe(EA);
function _A(e, t) {
  Ae(2, arguments);
  var r = Se(e), n = Se(t);
  return r.getFullYear() === n.getFullYear() && r.getMonth() === n.getMonth();
}
const AA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _A
}, Symbol.toStringTag, { value: "Module" })), DA = /* @__PURE__ */ qe(AA);
function MA(e) {
  Ae(1, arguments);
  var t = Se(e), r = t.getFullYear(), n = t.getMonth(), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(r, n + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function TA(e, t) {
  Ae(2, arguments);
  var r = Se(e), n = Et(t), a = r.getFullYear(), i = r.getDate(), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(a, n, 15), o.setHours(0, 0, 0, 0);
  var s = MA(o);
  return r.setMonth(n, Math.min(i, s)), r;
}
const $A = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: TA
}, Symbol.toStringTag, { value: "Module" })), NA = /* @__PURE__ */ qe($A);
function IA(e, t) {
  Ae(2, arguments);
  var r = Se(e), n = Et(t);
  return isNaN(r.getTime()) ? /* @__PURE__ */ new Date(NaN) : (r.setFullYear(n), r);
}
const LA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: IA
}, Symbol.toStringTag, { value: "Module" })), kA = /* @__PURE__ */ qe(LA);
function hd(e, t) {
  Ae(2, arguments);
  var r = Se(e), n = Et(t);
  if (isNaN(n))
    return /* @__PURE__ */ new Date(NaN);
  if (!n)
    return r;
  var a = r.getDate(), i = new Date(r.getTime());
  i.setMonth(r.getMonth() + n + 1, 0);
  var o = i.getDate();
  return a >= o ? i : (r.setFullYear(i.getFullYear(), i.getMonth(), a), r);
}
const RA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hd
}, Symbol.toStringTag, { value: "Module" }));
function BA(e, t) {
  Ae(2, arguments);
  var r = Et(t);
  return hd(e, r * 12);
}
const VA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: BA
}, Symbol.toStringTag, { value: "Module" })), HA = /* @__PURE__ */ qe(VA);
function FA(e, t) {
  Ae(2, arguments);
  var r = Et(t);
  return hd(e, -r);
}
const WA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FA
}, Symbol.toStringTag, { value: "Module" })), zA = /* @__PURE__ */ qe(WA), nm = /* @__PURE__ */ qe(RA), UA = /* @__PURE__ */ qe(NE);
var ri = {};
Object.defineProperty(ri, "__esModule", {
  value: !0
});
ri.default = void 0;
var ZA = {
  dateRangeWrapper: "rdrDateRangeWrapper",
  calendarWrapper: "rdrCalendarWrapper",
  dateDisplay: "rdrDateDisplay",
  dateDisplayItem: "rdrDateDisplayItem",
  dateDisplayItemActive: "rdrDateDisplayItemActive",
  monthAndYearWrapper: "rdrMonthAndYearWrapper",
  monthAndYearPickers: "rdrMonthAndYearPickers",
  nextPrevButton: "rdrNextPrevButton",
  month: "rdrMonth",
  weekDays: "rdrWeekDays",
  weekDay: "rdrWeekDay",
  days: "rdrDays",
  day: "rdrDay",
  dayNumber: "rdrDayNumber",
  dayPassive: "rdrDayPassive",
  dayToday: "rdrDayToday",
  dayStartOfWeek: "rdrDayStartOfWeek",
  dayEndOfWeek: "rdrDayEndOfWeek",
  daySelected: "rdrDaySelected",
  dayDisabled: "rdrDayDisabled",
  dayStartOfMonth: "rdrDayStartOfMonth",
  dayEndOfMonth: "rdrDayEndOfMonth",
  dayWeekend: "rdrDayWeekend",
  dayStartPreview: "rdrDayStartPreview",
  dayInPreview: "rdrDayInPreview",
  dayEndPreview: "rdrDayEndPreview",
  dayHovered: "rdrDayHovered",
  dayActive: "rdrDayActive",
  inRange: "rdrInRange",
  endEdge: "rdrEndEdge",
  startEdge: "rdrStartEdge",
  prevButton: "rdrPprevButton",
  nextButton: "rdrNextButton",
  selected: "rdrSelected",
  months: "rdrMonths",
  monthPicker: "rdrMonthPicker",
  yearPicker: "rdrYearPicker",
  dateDisplayWrapper: "rdrDateDisplayWrapper",
  definedRangesWrapper: "rdrDefinedRangesWrapper",
  staticRanges: "rdrStaticRanges",
  staticRange: "rdrStaticRange",
  inputRanges: "rdrInputRanges",
  inputRange: "rdrInputRange",
  inputRangeInput: "rdrInputRangeInput",
  dateRangePickerWrapper: "rdrDateRangePickerWrapper",
  staticRangeLabel: "rdrStaticRangeLabel",
  staticRangeSelected: "rdrStaticRangeSelected",
  monthName: "rdrMonthName",
  infiniteMonths: "rdrInfiniteMonths",
  monthsVertical: "rdrMonthsVertical",
  monthsHorizontal: "rdrMonthsHorizontal"
};
ri.default = ZA;
var du = {};
Object.defineProperty(du, "__esModule", {
  value: !0
});
du.ariaLabelsShape = void 0;
var En = qA(tn);
function qA(e) {
  return e && e.__esModule ? e : { default: e };
}
var GA = En.default.shape({
  dateInput: En.default.objectOf(En.default.shape({
    startDate: En.default.string,
    endDate: En.default.string
  })),
  monthPicker: En.default.string,
  yearPicker: En.default.string,
  prevButton: En.default.string,
  nextButton: En.default.string
});
du.ariaLabelsShape = GA;
function ds(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ds = function(r) {
    return typeof r;
  } : ds = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, ds(e);
}
Object.defineProperty(S1, "__esModule", {
  value: !0
});
S1.default = void 0;
var nt = mD(E), be = yt(tn), YA = kn, q5 = yt(su), G5 = yt(fu), q1 = Hn, wa = yt(ti), KA = yt(mA), XA = CA, QA = yt(tm), JA = yt(rm), eD = yt(jA), tD = yt(DA), rD = yt(uu), nD = yt(ld), aD = yt(cd), P2 = yt(Lv), iD = yt(NA), oD = yt(kA), Y5 = yt(HA), sD = yt(iu), lD = yt(lu), cD = yt(cu), uD = yt(Nv), fD = yt(ou), dD = yt(zA), Uo = yt(nm), pD = yt(UA), hD = yt(ri), vD = du;
function yt(e) {
  return e && e.__esModule ? e : { default: e };
}
function am(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (am = function(a) {
    return a ? r : t;
  })(e);
}
function mD(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || ds(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = am(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function $l() {
  return $l = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $l.apply(this, arguments);
}
function gD(e) {
  return xD(e) || CD(e) || bD(e) || yD();
}
function yD() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bD(e, t) {
  if (e) {
    if (typeof e == "string")
      return Z3(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Z3(e, t);
  }
}
function CD(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function xD(e) {
  if (Array.isArray(e))
    return Z3(e);
}
function Z3(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function K5(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function G1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? K5(Object(r), !0).forEach(function(n) {
      nr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : K5(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function wD(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function X5(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function OD(e, t, r) {
  return t && X5(e.prototype, t), r && X5(e, r), e;
}
function SD(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && q3(e, t);
}
function q3(e, t) {
  return q3 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, q3(e, t);
}
function PD(e) {
  var t = jD();
  return function() {
    var n = Nl(e), a;
    if (t) {
      var i = Nl(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return ED(this, a);
  };
}
function ED(e, t) {
  return t && (ds(t) === "object" || typeof t == "function") ? t : ur(e);
}
function ur(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function jD() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Nl(e) {
  return Nl = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Nl(e);
}
function nr(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var vd = /* @__PURE__ */ function(e) {
  SD(r, e);
  var t = PD(r);
  function r(n, a) {
    var i;
    return wD(this, r), i = t.call(this, n, a), nr(ur(i), "focusToDate", function(o) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : i.props, l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
      if (!s.scroll.enabled) {
        if (l && s.preventSnapRefocus) {
          var c = (0, P2.default)(o, i.state.focusedDate), u = s.calendarFocus === "forwards" && c >= 0, d = s.calendarFocus === "backwards" && c <= 0;
          if ((u || d) && Math.abs(c) < s.months)
            return;
        }
        i.setState({
          focusedDate: o
        });
        return;
      }
      var p = (0, P2.default)(o, s.minDate, i.dateOptions), h = i.list.getVisibleRange();
      l && h.includes(p) || (i.isFirstRender = !0, i.list.scrollTo(p), i.setState({
        focusedDate: o
      }));
    }), nr(ur(i), "updateShownDate", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i.props, s = o.scroll.enabled ? G1(G1({}, o), {}, {
        months: i.list.getVisibleRange().length
      }) : o, l = (0, q1.calcFocusDate)(i.state.focusedDate, s);
      i.focusToDate(l, s);
    }), nr(ur(i), "updatePreview", function(o) {
      if (!o) {
        i.setState({
          preview: null
        });
        return;
      }
      var s = {
        startDate: o,
        endDate: o,
        color: i.props.color
      };
      i.setState({
        preview: s
      });
    }), nr(ur(i), "changeShownDate", function(o) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "set", l = i.state.focusedDate, c = i.props, u = c.onShownDateChange, d = c.minDate, p = c.maxDate, h = {
        monthOffset: function() {
          return (0, Uo.default)(l, o);
        },
        setMonth: function(v) {
          function g() {
            return v.apply(this, arguments);
          }
          return g.toString = function() {
            return v.toString();
          }, g;
        }(function() {
          return (0, iD.default)(l, o);
        }),
        setYear: function(v) {
          function g() {
            return v.apply(this, arguments);
          }
          return g.toString = function() {
            return v.toString();
          }, g;
        }(function() {
          return (0, oD.default)(l, o);
        }),
        set: function() {
          return o;
        }
      }, m = (0, JA.default)([(0, QA.default)([h[s](), d]), p]);
      i.focusToDate(m, i.props, !1), u && u(m);
    }), nr(ur(i), "handleRangeFocusChange", function(o, s) {
      i.props.onRangeFocusChange && i.props.onRangeFocusChange([o, s]);
    }), nr(ur(i), "handleScroll", function() {
      var o = i.props, s = o.onShownDateChange, l = o.minDate, c = i.state.focusedDate, u = ur(i), d = u.isFirstRender, p = i.list.getVisibleRange();
      if (p[0] !== void 0) {
        var h = (0, Uo.default)(l, p[0] || 0), m = !(0, tD.default)(h, c);
        m && !d && (i.setState({
          focusedDate: h
        }), s && s(h)), i.isFirstRender = !1;
      }
    }), nr(ur(i), "renderMonthAndYear", function(o, s, l) {
      var c = l.showMonthArrow, u = l.minDate, d = l.maxDate, p = l.showMonthAndYearPickers, h = l.ariaLabels, m = (d || r.defaultProps.maxDate).getFullYear(), v = (u || r.defaultProps.minDate).getFullYear(), g = i.styles;
      return /* @__PURE__ */ nt.default.createElement("div", {
        onMouseUp: function(C) {
          return C.stopPropagation();
        },
        className: g.monthAndYearWrapper
      }, c ? /* @__PURE__ */ nt.default.createElement("button", {
        type: "button",
        className: (0, wa.default)(g.nextPrevButton, g.prevButton),
        onClick: function() {
          return s(-1, "monthOffset");
        },
        "aria-label": h.prevButton
      }, /* @__PURE__ */ nt.default.createElement("i", null)) : null, p ? /* @__PURE__ */ nt.default.createElement("span", {
        className: g.monthAndYearPickers
      }, /* @__PURE__ */ nt.default.createElement("span", {
        className: g.monthPicker
      }, /* @__PURE__ */ nt.default.createElement("select", {
        value: o.getMonth(),
        onChange: function(C) {
          return s(C.target.value, "setMonth");
        },
        "aria-label": h.monthPicker
      }, i.state.monthNames.map(function(b, C) {
        return /* @__PURE__ */ nt.default.createElement("option", {
          key: C,
          value: C
        }, b);
      }))), /* @__PURE__ */ nt.default.createElement("span", {
        className: g.monthAndYearDivider
      }), /* @__PURE__ */ nt.default.createElement("span", {
        className: g.yearPicker
      }, /* @__PURE__ */ nt.default.createElement("select", {
        value: o.getFullYear(),
        onChange: function(C) {
          return s(C.target.value, "setYear");
        },
        "aria-label": h.yearPicker
      }, new Array(m - v + 1).fill(m).map(function(b, C) {
        var w = b - C;
        return /* @__PURE__ */ nt.default.createElement("option", {
          key: w,
          value: w
        }, w);
      })))) : /* @__PURE__ */ nt.default.createElement("span", {
        className: g.monthAndYearPickers
      }, i.state.monthNames[o.getMonth()], " ", o.getFullYear()), c ? /* @__PURE__ */ nt.default.createElement("button", {
        type: "button",
        className: (0, wa.default)(g.nextPrevButton, g.nextButton),
        onClick: function() {
          return s(1, "monthOffset");
        },
        "aria-label": h.nextButton
      }, /* @__PURE__ */ nt.default.createElement("i", null)) : null);
    }), nr(ur(i), "renderDateDisplay", function() {
      var o = i.props, s = o.focusedRange, l = o.color, c = o.ranges, u = o.rangeColors, d = o.dateDisplayFormat, p = o.editableDateInputs, h = o.startDatePlaceholder, m = o.endDatePlaceholder, v = o.ariaLabels, g = u[s[0]] || l, b = i.styles;
      return /* @__PURE__ */ nt.default.createElement("div", {
        className: b.dateDisplayWrapper
      }, c.map(function(C, w) {
        return C.showDateDisplay === !1 || C.disabled && !C.showDateDisplay ? null : /* @__PURE__ */ nt.default.createElement("div", {
          className: b.dateDisplay,
          key: w,
          style: {
            color: C.color || g
          }
        }, /* @__PURE__ */ nt.default.createElement(G5.default, {
          className: (0, wa.default)(b.dateDisplayItem, nr({}, b.dateDisplayItemActive, s[0] === w && s[1] === 0)),
          readOnly: !p,
          disabled: C.disabled,
          value: C.startDate,
          placeholder: h,
          dateOptions: i.dateOptions,
          dateDisplayFormat: d,
          ariaLabel: v.dateInput && v.dateInput[C.key] && v.dateInput[C.key].startDate,
          onChange: i.onDragSelectionEnd,
          onFocus: function() {
            return i.handleRangeFocusChange(w, 0);
          }
        }), /* @__PURE__ */ nt.default.createElement(G5.default, {
          className: (0, wa.default)(b.dateDisplayItem, nr({}, b.dateDisplayItemActive, s[0] === w && s[1] === 1)),
          readOnly: !p,
          disabled: C.disabled,
          value: C.endDate,
          placeholder: m,
          dateOptions: i.dateOptions,
          dateDisplayFormat: d,
          ariaLabel: v.dateInput && v.dateInput[C.key] && v.dateInput[C.key].endDate,
          onChange: i.onDragSelectionEnd,
          onFocus: function() {
            return i.handleRangeFocusChange(w, 1);
          }
        }));
      }));
    }), nr(ur(i), "onDragSelectionStart", function(o) {
      var s = i.props, l = s.onChange, c = s.dragSelectionEnabled;
      c ? i.setState({
        drag: {
          status: !0,
          range: {
            startDate: o,
            endDate: o
          },
          disablePreview: !0
        }
      }) : l && l(o);
    }), nr(ur(i), "onDragSelectionEnd", function(o) {
      var s = i.props, l = s.updateRange, c = s.displayMode, u = s.onChange, d = s.dragSelectionEnabled;
      if (d) {
        if (c === "date" || !i.state.drag.status) {
          u && u(o);
          return;
        }
        var p = {
          startDate: i.state.drag.range.startDate,
          endDate: o
        };
        c !== "dateRange" || (0, sD.default)(p.startDate, o) ? i.setState({
          drag: {
            status: !1,
            range: {}
          }
        }, function() {
          return u && u(o);
        }) : i.setState({
          drag: {
            status: !1,
            range: {}
          }
        }, function() {
          l && l(p);
        });
      }
    }), nr(ur(i), "onDragSelectionMove", function(o) {
      var s = i.state.drag;
      !s.status || !i.props.dragSelectionEnabled || i.setState({
        drag: {
          status: s.status,
          range: {
            startDate: s.range.startDate,
            endDate: o
          },
          disablePreview: !0
        }
      });
    }), nr(ur(i), "estimateMonthSize", function(o, s) {
      var l = i.props, c = l.direction, u = l.minDate, d = i.state.scrollArea;
      if (s && (i.listSizeCache = s, s[o]))
        return s[o];
      if (c === "horizontal")
        return d.monthWidth;
      var p = (0, Uo.default)(u, o), h = (0, q1.getMonthDisplayRange)(p, i.dateOptions), m = h.start, v = h.end, g = (0, eD.default)(v, m, i.dateOptions) + 1 > 7 * 5;
      return g ? d.longMonthHeight : d.monthHeight;
    }), i.dateOptions = {
      locale: n.locale
    }, n.weekStartsOn !== void 0 && (i.dateOptions.weekStartsOn = n.weekStartsOn), i.styles = (0, q1.generateStyles)([hD.default, n.classNames]), i.listSizeCache = {}, i.isFirstRender = !0, i.state = {
      monthNames: i.getMonthNames(),
      focusedDate: (0, q1.calcFocusDate)(null, n),
      drag: {
        status: !1,
        range: {
          startDate: null,
          endDate: null
        },
        disablePreview: !1
      },
      scrollArea: i.calcScrollArea(n)
    }, i;
  }
  return OD(r, [{
    key: "getMonthNames",
    value: function() {
      var a = this;
      return gD(Array(12).keys()).map(function(i) {
        return a.props.locale.localize.month(i);
      });
    }
  }, {
    key: "calcScrollArea",
    value: function(a) {
      var i = a.direction, o = a.months, s = a.scroll;
      if (!s.enabled)
        return {
          enabled: !1
        };
      var l = s.longMonthHeight || s.monthHeight;
      return i === "vertical" ? {
        enabled: !0,
        monthHeight: s.monthHeight || 220,
        longMonthHeight: l || 260,
        calendarWidth: "auto",
        calendarHeight: (s.calendarHeight || l || 240) * o
      } : {
        enabled: !0,
        monthWidth: s.monthWidth || 332,
        calendarWidth: (s.calendarWidth || s.monthWidth || 332) * o,
        monthHeight: l || 300,
        calendarHeight: l || 300
      };
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var a = this;
      this.props.scroll.enabled && setTimeout(function() {
        return a.focusToDate(a.state.focusedDate);
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      var i = {
        dateRange: "ranges",
        date: "date"
      }, o = i[this.props.displayMode];
      this.props[o] !== a[o] && this.updateShownDate(this.props), (a.locale !== this.props.locale || a.weekStartsOn !== this.props.weekStartsOn) && (this.dateOptions = {
        locale: this.props.locale
      }, this.props.weekStartsOn !== void 0 && (this.dateOptions.weekStartsOn = this.props.weekStartsOn), this.setState({
        monthNames: this.getMonthNames()
      })), (0, XA.shallowEqualObjects)(a.scroll, this.props.scroll) || this.setState({
        scrollArea: this.calcScrollArea(this.props)
      });
    }
  }, {
    key: "renderWeekdays",
    value: function() {
      var a = this, i = /* @__PURE__ */ new Date();
      return /* @__PURE__ */ nt.default.createElement("div", {
        className: this.styles.weekDays
      }, (0, uD.default)({
        start: (0, cD.default)(i, this.dateOptions),
        end: (0, lD.default)(i, this.dateOptions)
      }).map(function(o, s) {
        return /* @__PURE__ */ nt.default.createElement("span", {
          className: a.styles.weekDay,
          key: s
        }, (0, fD.default)(o, a.props.weekdayDisplayFormat, a.dateOptions));
      }));
    }
  }, {
    key: "render",
    value: function() {
      var a = this, i = this.props, o = i.showDateDisplay, s = i.onPreviewChange, l = i.scroll, c = i.direction, u = i.disabledDates, d = i.disabledDay, p = i.maxDate, h = i.minDate, m = i.rangeColors, v = i.color, g = i.navigatorRenderer, b = i.className, C = i.preview, w = this.state, x = w.scrollArea, y = w.focusedDate, O = c === "vertical", P = g || this.renderMonthAndYear, j = this.props.ranges.map(function(T, I) {
        return G1(G1({}, T), {}, {
          color: T.color || m[I] || v
        });
      });
      return /* @__PURE__ */ nt.default.createElement("div", {
        className: (0, wa.default)(this.styles.calendarWrapper, b),
        onMouseUp: function() {
          return a.setState({
            drag: {
              status: !1,
              range: {}
            }
          });
        },
        onMouseLeave: function() {
          a.setState({
            drag: {
              status: !1,
              range: {}
            }
          });
        }
      }, o && this.renderDateDisplay(), P(y, this.changeShownDate, this.props), l.enabled ? /* @__PURE__ */ nt.default.createElement("div", null, O && this.renderWeekdays(this.dateOptions), /* @__PURE__ */ nt.default.createElement("div", {
        className: (0, wa.default)(this.styles.infiniteMonths, O ? this.styles.monthsVertical : this.styles.monthsHorizontal),
        onMouseLeave: function() {
          return s && s();
        },
        style: {
          width: x.calendarWidth + 11,
          height: x.calendarHeight + 11
        },
        onScroll: this.handleScroll
      }, /* @__PURE__ */ nt.default.createElement(KA.default, {
        length: (0, P2.default)((0, nD.default)(p), (0, rD.default)((0, aD.default)(h), -1), this.dateOptions),
        treshold: 500,
        type: "variable",
        ref: function(I) {
          return a.list = I;
        },
        itemSizeEstimator: this.estimateMonthSize,
        axis: O ? "y" : "x",
        itemRenderer: function(I, R) {
          var F = (0, Uo.default)(h, I);
          return /* @__PURE__ */ nt.default.createElement(q5.default, $l({}, a.props, {
            onPreviewChange: s || a.updatePreview,
            preview: C || a.state.preview,
            ranges: j,
            key: R,
            drag: a.state.drag,
            dateOptions: a.dateOptions,
            disabledDates: u,
            disabledDay: d,
            month: F,
            onDragSelectionStart: a.onDragSelectionStart,
            onDragSelectionEnd: a.onDragSelectionEnd,
            onDragSelectionMove: a.onDragSelectionMove,
            onMouseLeave: function() {
              return s && s();
            },
            styles: a.styles,
            style: O ? {
              height: a.estimateMonthSize(I)
            } : {
              height: x.monthHeight,
              width: a.estimateMonthSize(I)
            },
            showMonthName: !0,
            showWeekDays: !O
          }));
        }
      }))) : /* @__PURE__ */ nt.default.createElement("div", {
        className: (0, wa.default)(this.styles.months, O ? this.styles.monthsVertical : this.styles.monthsHorizontal)
      }, new Array(this.props.months).fill(null).map(function(T, I) {
        var R = (0, Uo.default)(a.state.focusedDate, I);
        return a.props.calendarFocus === "backwards" && (R = (0, dD.default)(a.state.focusedDate, a.props.months - 1 - I)), /* @__PURE__ */ nt.default.createElement(q5.default, $l({}, a.props, {
          onPreviewChange: s || a.updatePreview,
          preview: C || a.state.preview,
          ranges: j,
          key: I,
          drag: a.state.drag,
          dateOptions: a.dateOptions,
          disabledDates: u,
          disabledDay: d,
          month: R,
          onDragSelectionStart: a.onDragSelectionStart,
          onDragSelectionEnd: a.onDragSelectionEnd,
          onDragSelectionMove: a.onDragSelectionMove,
          onMouseLeave: function() {
            return s && s();
          },
          styles: a.styles,
          showWeekDays: !O || I === 0,
          showMonthName: !O || I > 0
        }));
      })));
    }
  }]), r;
}(nt.PureComponent);
vd.defaultProps = {
  showMonthArrow: !0,
  showMonthAndYearPickers: !0,
  disabledDates: [],
  disabledDay: function() {
  },
  classNames: {},
  locale: pD.default,
  ranges: [],
  focusedRange: [0, 0],
  dateDisplayFormat: "MMM d, yyyy",
  monthDisplayFormat: "MMM yyyy",
  weekdayDisplayFormat: "E",
  dayDisplayFormat: "d",
  showDateDisplay: !0,
  showPreview: !0,
  displayMode: "date",
  months: 1,
  color: "#3d91ff",
  scroll: {
    enabled: !1
  },
  direction: "vertical",
  maxDate: (0, Y5.default)(/* @__PURE__ */ new Date(), 20),
  minDate: (0, Y5.default)(/* @__PURE__ */ new Date(), -100),
  rangeColors: ["#3d91ff", "#3ecf8e", "#fed14c"],
  startDatePlaceholder: "Early",
  endDatePlaceholder: "Continuous",
  editableDateInputs: !1,
  dragSelectionEnabled: !0,
  fixedHeight: !1,
  calendarFocus: "forwards",
  preventSnapRefocus: !1,
  ariaLabels: {}
};
vd.propTypes = {
  showMonthArrow: be.default.bool,
  showMonthAndYearPickers: be.default.bool,
  disabledDates: be.default.array,
  disabledDay: be.default.func,
  minDate: be.default.object,
  maxDate: be.default.object,
  date: be.default.object,
  onChange: be.default.func,
  onPreviewChange: be.default.func,
  onRangeFocusChange: be.default.func,
  classNames: be.default.object,
  locale: be.default.object,
  shownDate: be.default.object,
  onShownDateChange: be.default.func,
  ranges: be.default.arrayOf(YA.rangeShape),
  preview: be.default.shape({
    startDate: be.default.object,
    endDate: be.default.object,
    color: be.default.string
  }),
  dateDisplayFormat: be.default.string,
  monthDisplayFormat: be.default.string,
  weekdayDisplayFormat: be.default.string,
  weekStartsOn: be.default.number,
  dayDisplayFormat: be.default.string,
  focusedRange: be.default.arrayOf(be.default.number),
  initialFocusedRange: be.default.arrayOf(be.default.number),
  months: be.default.number,
  className: be.default.string,
  showDateDisplay: be.default.bool,
  showPreview: be.default.bool,
  displayMode: be.default.oneOf(["dateRange", "date"]),
  color: be.default.string,
  updateRange: be.default.func,
  scroll: be.default.shape({
    enabled: be.default.bool,
    monthHeight: be.default.number,
    longMonthHeight: be.default.number,
    monthWidth: be.default.number,
    calendarWidth: be.default.number,
    calendarHeight: be.default.number
  }),
  direction: be.default.oneOf(["vertical", "horizontal"]),
  startDatePlaceholder: be.default.string,
  endDatePlaceholder: be.default.string,
  navigatorRenderer: be.default.func,
  rangeColors: be.default.arrayOf(be.default.string),
  editableDateInputs: be.default.bool,
  dragSelectionEnabled: be.default.bool,
  fixedHeight: be.default.bool,
  calendarFocus: be.default.string,
  preventSnapRefocus: be.default.bool,
  ariaLabels: vD.ariaLabelsShape
};
var _D = vd;
S1.default = _D;
function ps(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ps = function(r) {
    return typeof r;
  } : ps = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, ps(e);
}
Object.defineProperty(O1, "__esModule", {
  value: !0
});
O1.default = void 0;
var Q5 = ID(E), pi = bn(tn), im = bn(S1), AD = kn, E2 = Hn, DD = bn(tm), MD = bn(Iv), J5 = bn(rm), j2 = bn(uu), TD = bn(sd), e7 = bn(rd), $D = bn(ti), ND = bn(ri);
function bn(e) {
  return e && e.__esModule ? e : { default: e };
}
function om(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (om = function(a) {
    return a ? r : t;
  })(e);
}
function ID(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || ps(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = om(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function G3() {
  return G3 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, G3.apply(this, arguments);
}
function t7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Si(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? t7(Object(r), !0).forEach(function(n) {
      wi(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : t7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function LD(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function r7(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function kD(e, t, r) {
  return t && r7(e.prototype, t), r && r7(e, r), e;
}
function RD(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Y3(e, t);
}
function Y3(e, t) {
  return Y3 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, Y3(e, t);
}
function BD(e) {
  var t = HD();
  return function() {
    var n = Il(e), a;
    if (t) {
      var i = Il(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return VD(this, a);
  };
}
function VD(e, t) {
  return t && (ps(t) === "object" || typeof t == "function") ? t : ss(e);
}
function ss(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function HD() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Il(e) {
  return Il = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Il(e);
}
function wi(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var md = /* @__PURE__ */ function(e) {
  RD(r, e);
  var t = BD(r);
  function r(n, a) {
    var i;
    return LD(this, r), i = t.call(this, n, a), wi(ss(i), "calcNewSelection", function(o) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, l = i.props.focusedRange || i.state.focusedRange, c = i.props, u = c.ranges, d = c.onChange, p = c.maxDate, h = c.moveRangeOnFirstSelection, m = c.retainEndDateOnFirstSelection, v = c.disabledDates, g = l[0], b = u[g];
      if (!b || !d)
        return {};
      var C = b.startDate, w = b.endDate, x = /* @__PURE__ */ new Date(), y;
      if (!s)
        C = o.startDate, w = o.endDate;
      else if (l[1] === 0) {
        var O = (0, TD.default)(w || x, C), P = function() {
          return h ? (0, j2.default)(o, O) : m ? !w || (0, e7.default)(o, w) ? w : o : o || x;
        };
        C = o, w = P(), p && (w = (0, J5.default)([w, p])), y = [l[0], 1];
      } else
        w = o;
      var j = l[1] === 0;
      if ((0, e7.default)(w, C)) {
        j = !j;
        var T = [w, C];
        C = T[0], w = T[1];
      }
      var I = v.filter(function(F) {
        return (0, MD.default)(F, {
          start: C,
          end: w
        });
      });
      if (I.length > 0 && (j ? C = (0, j2.default)((0, DD.default)(I), 1) : w = (0, j2.default)((0, J5.default)(I), -1)), !y) {
        var R = (0, E2.findNextRangeIndex)(i.props.ranges, l[0]);
        y = [R, 0];
      }
      return {
        wasValid: !(I.length > 0),
        range: {
          startDate: C,
          endDate: w
        },
        nextFocusRange: y
      };
    }), wi(ss(i), "setSelection", function(o, s) {
      var l = i.props, c = l.onChange, u = l.ranges, d = l.onRangeFocusChange, p = i.props.focusedRange || i.state.focusedRange, h = p[0], m = u[h];
      if (m) {
        var v = i.calcNewSelection(o, s);
        c(wi({}, m.key || "range".concat(h + 1), Si(Si({}, m), v.range))), i.setState({
          focusedRange: v.nextFocusRange,
          preview: null
        }), d && d(v.nextFocusRange);
      }
    }), wi(ss(i), "handleRangeFocusChange", function(o) {
      i.setState({
        focusedRange: o
      }), i.props.onRangeFocusChange && i.props.onRangeFocusChange(o);
    }), wi(ss(i), "updatePreview", function(o) {
      var s;
      if (!o) {
        i.setState({
          preview: null
        });
        return;
      }
      var l = i.props, c = l.rangeColors, u = l.ranges, d = i.props.focusedRange || i.state.focusedRange, p = ((s = u[d[0]]) === null || s === void 0 ? void 0 : s.color) || c[d[0]] || p;
      i.setState({
        preview: Si(Si({}, o.range), {}, {
          color: p
        })
      });
    }), i.state = {
      focusedRange: n.initialFocusedRange || [(0, E2.findNextRangeIndex)(n.ranges), 0],
      preview: null
    }, i.styles = (0, E2.generateStyles)([ND.default, n.classNames]), i;
  }
  return kD(r, [{
    key: "render",
    value: function() {
      var a = this;
      return /* @__PURE__ */ Q5.default.createElement(im.default, G3({
        focusedRange: this.state.focusedRange,
        onRangeFocusChange: this.handleRangeFocusChange,
        preview: this.state.preview,
        onPreviewChange: function(o) {
          a.updatePreview(o ? a.calcNewSelection(o) : null);
        }
      }, this.props, {
        displayMode: "dateRange",
        className: (0, $D.default)(this.styles.dateRangeWrapper, this.props.className),
        onChange: this.setSelection,
        updateRange: function(o) {
          return a.setSelection(o, !1);
        },
        ref: function(o) {
          a.calendar = o;
        }
      }));
    }
  }]), r;
}(Q5.Component);
md.defaultProps = {
  classNames: {},
  ranges: [],
  moveRangeOnFirstSelection: !1,
  retainEndDateOnFirstSelection: !1,
  rangeColors: ["#3d91ff", "#3ecf8e", "#fed14c"],
  disabledDates: []
};
md.propTypes = Si(Si({}, im.default.propTypes), {}, {
  onChange: pi.default.func,
  onRangeFocusChange: pi.default.func,
  className: pi.default.string,
  ranges: pi.default.arrayOf(AD.rangeShape),
  moveRangeOnFirstSelection: pi.default.bool,
  retainEndDateOnFirstSelection: pi.default.bool
});
var FD = md;
O1.default = FD;
var pu = {}, P1 = {}, ia = {};
Object.defineProperty(ia, "__esModule", {
  value: !0
});
ia.createStaticRanges = sm;
ia.defaultInputRanges = ia.defaultStaticRanges = void 0;
var n7 = Cn(sd), Ll = Cn(iu), a7 = Cn(lu), i7 = Cn(cu), o7 = Cn(nm), s7 = Cn(ld), l7 = Cn(cd), c7 = Cn(id), u7 = Cn(td), Pi = Cn(uu);
function Cn(e) {
  return e && e.__esModule ? e : { default: e };
}
function f7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function d7(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? f7(Object(r), !0).forEach(function(n) {
      WD(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : f7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function WD(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var Ft = {
  startOfWeek: (0, i7.default)(/* @__PURE__ */ new Date()),
  endOfWeek: (0, a7.default)(/* @__PURE__ */ new Date()),
  startOfLastWeek: (0, i7.default)((0, Pi.default)(/* @__PURE__ */ new Date(), -7)),
  endOfLastWeek: (0, a7.default)((0, Pi.default)(/* @__PURE__ */ new Date(), -7)),
  startOfToday: (0, c7.default)(/* @__PURE__ */ new Date()),
  endOfToday: (0, u7.default)(/* @__PURE__ */ new Date()),
  startOfYesterday: (0, c7.default)((0, Pi.default)(/* @__PURE__ */ new Date(), -1)),
  endOfYesterday: (0, u7.default)((0, Pi.default)(/* @__PURE__ */ new Date(), -1)),
  startOfMonth: (0, l7.default)(/* @__PURE__ */ new Date()),
  endOfMonth: (0, s7.default)(/* @__PURE__ */ new Date()),
  startOfLastMonth: (0, l7.default)((0, o7.default)(/* @__PURE__ */ new Date(), -1)),
  endOfLastMonth: (0, s7.default)((0, o7.default)(/* @__PURE__ */ new Date(), -1))
}, zD = {
  range: {},
  isSelected: function(t) {
    var r = this.range();
    return (0, Ll.default)(t.startDate, r.startDate) && (0, Ll.default)(t.endDate, r.endDate);
  }
};
function sm(e) {
  return e.map(function(t) {
    return d7(d7({}, zD), t);
  });
}
var UD = sm([{
  label: "Today",
  range: function() {
    return {
      startDate: Ft.startOfToday,
      endDate: Ft.endOfToday
    };
  }
}, {
  label: "Yesterday",
  range: function() {
    return {
      startDate: Ft.startOfYesterday,
      endDate: Ft.endOfYesterday
    };
  }
}, {
  label: "This Week",
  range: function() {
    return {
      startDate: Ft.startOfWeek,
      endDate: Ft.endOfWeek
    };
  }
}, {
  label: "Last Week",
  range: function() {
    return {
      startDate: Ft.startOfLastWeek,
      endDate: Ft.endOfLastWeek
    };
  }
}, {
  label: "This Month",
  range: function() {
    return {
      startDate: Ft.startOfMonth,
      endDate: Ft.endOfMonth
    };
  }
}, {
  label: "Last Month",
  range: function() {
    return {
      startDate: Ft.startOfLastMonth,
      endDate: Ft.endOfLastMonth
    };
  }
}]);
ia.defaultStaticRanges = UD;
var ZD = [{
  label: "days up to today",
  range: function(t) {
    return {
      startDate: (0, Pi.default)(Ft.startOfToday, (Math.max(Number(t), 1) - 1) * -1),
      endDate: Ft.endOfToday
    };
  },
  getCurrentValue: function(t) {
    return (0, Ll.default)(t.endDate, Ft.endOfToday) ? t.startDate ? (0, n7.default)(Ft.endOfToday, t.startDate) + 1 : "∞" : "-";
  }
}, {
  label: "days starting today",
  range: function(t) {
    var r = /* @__PURE__ */ new Date();
    return {
      startDate: r,
      endDate: (0, Pi.default)(r, Math.max(Number(t), 1) - 1)
    };
  },
  getCurrentValue: function(t) {
    return (0, Ll.default)(t.startDate, Ft.startOfToday) ? t.endDate ? (0, n7.default)(t.endDate, Ft.startOfToday) + 1 : "∞" : "-";
  }
}];
ia.defaultInputRanges = ZD;
var hu = {};
function hs(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? hs = function(r) {
    return typeof r;
  } : hs = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, hs(e);
}
Object.defineProperty(hu, "__esModule", {
  value: !0
});
hu.default = void 0;
var Y1 = GD(E), cr = qD(tn);
function qD(e) {
  return e && e.__esModule ? e : { default: e };
}
function lm(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (lm = function(a) {
    return a ? r : t;
  })(e);
}
function GD(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || hs(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = lm(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function YD(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function p7(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function KD(e, t, r) {
  return t && p7(e.prototype, t), r && p7(e, r), e;
}
function XD(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && K3(e, t);
}
function K3(e, t) {
  return K3 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, K3(e, t);
}
function QD(e) {
  var t = eM();
  return function() {
    var n = kl(e), a;
    if (t) {
      var i = kl(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return JD(this, a);
  };
}
function JD(e, t) {
  return t && (hs(t) === "object" || typeof t == "function") ? t : cm(e);
}
function cm(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function eM() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function kl(e) {
  return kl = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, kl(e);
}
function tM(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var h7 = 0, v7 = 99999, gd = /* @__PURE__ */ function(e) {
  XD(r, e);
  var t = QD(r);
  function r(n, a) {
    var i;
    return YD(this, r), i = t.call(this, n, a), tM(cm(i), "onChange", function(o) {
      var s = i.props.onChange, l = parseInt(o.target.value, 10);
      l = isNaN(l) ? 0 : Math.max(Math.min(v7, l), h7), s(l);
    }), i;
  }
  return KD(r, [{
    key: "shouldComponentUpdate",
    value: function(a) {
      var i = this.props, o = i.value, s = i.label, l = i.placeholder;
      return o !== a.value || s !== a.label || l !== a.placeholder;
    }
  }, {
    key: "render",
    value: function() {
      var a = this.props, i = a.label, o = a.placeholder, s = a.value, l = a.styles, c = a.onBlur, u = a.onFocus;
      return /* @__PURE__ */ Y1.default.createElement("div", {
        className: l.inputRange
      }, /* @__PURE__ */ Y1.default.createElement("input", {
        className: l.inputRangeInput,
        placeholder: o,
        value: s,
        min: h7,
        max: v7,
        onChange: this.onChange,
        onFocus: u,
        onBlur: c
      }), /* @__PURE__ */ Y1.default.createElement("span", {
        className: l.inputRangeLabel
      }, i));
    }
  }]), r;
}(Y1.Component);
gd.propTypes = {
  value: cr.default.oneOfType([cr.default.string, cr.default.number]),
  label: cr.default.oneOfType([cr.default.element, cr.default.node]).isRequired,
  placeholder: cr.default.string,
  styles: cr.default.shape({
    inputRange: cr.default.string,
    inputRangeInput: cr.default.string,
    inputRangeLabel: cr.default.string
  }).isRequired,
  onBlur: cr.default.func.isRequired,
  onFocus: cr.default.func.isRequired,
  onChange: cr.default.func.isRequired
};
gd.defaultProps = {
  value: "",
  placeholder: "-"
};
var rM = gd;
hu.default = rM;
function vs(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? vs = function(r) {
    return typeof r;
  } : vs = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, vs(e);
}
Object.defineProperty(P1, "__esModule", {
  value: !0
});
P1.default = void 0;
var Oa = iM(E), mr = vu(tn), Sa = vu(ri), m7 = ia, nM = kn, aM = vu(hu), g7 = vu(ti);
function vu(e) {
  return e && e.__esModule ? e : { default: e };
}
function um(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (um = function(a) {
    return a ? r : t;
  })(e);
}
function iM(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || vs(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = um(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function y7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function b7(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? y7(Object(r), !0).forEach(function(n) {
      bl(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : y7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function oM(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function C7(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function sM(e, t, r) {
  return t && C7(e.prototype, t), r && C7(e, r), e;
}
function lM(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && X3(e, t);
}
function X3(e, t) {
  return X3 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, X3(e, t);
}
function cM(e) {
  var t = fM();
  return function() {
    var n = Rl(e), a;
    if (t) {
      var i = Rl(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return uM(this, a);
  };
}
function uM(e, t) {
  return t && (vs(t) === "object" || typeof t == "function") ? t : fm(e);
}
function fm(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function fM() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Rl(e) {
  return Rl = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Rl(e);
}
function bl(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var yd = /* @__PURE__ */ function(e) {
  lM(r, e);
  var t = cM(r);
  function r(n) {
    var a;
    return oM(this, r), a = t.call(this, n), bl(fm(a), "handleRangeChange", function(i) {
      var o = a.props, s = o.onChange, l = o.ranges, c = o.focusedRange, u = l[c[0]];
      !s || !u || s(bl({}, u.key || "range".concat(c[0] + 1), b7(b7({}, u), i)));
    }), a.state = {
      rangeOffset: 0,
      focusedInput: -1
    }, a;
  }
  return sM(r, [{
    key: "getRangeOptionValue",
    value: function(a) {
      var i = this.props, o = i.ranges, s = o === void 0 ? [] : o, l = i.focusedRange, c = l === void 0 ? [] : l;
      if (typeof a.getCurrentValue != "function")
        return "";
      var u = s[c[0]] || {};
      return a.getCurrentValue(u) || "";
    }
  }, {
    key: "getSelectedRange",
    value: function(a, i) {
      var o = a.findIndex(function(l) {
        return !l.startDate || !l.endDate || l.disabled ? !1 : i.isSelected(l);
      }), s = a[o];
      return {
        selectedRange: s,
        focusedRangeIndex: o
      };
    }
  }, {
    key: "render",
    value: function() {
      var a = this, i = this.props, o = i.headerContent, s = i.footerContent, l = i.onPreviewChange, c = i.inputRanges, u = i.staticRanges, d = i.ranges, p = i.renderStaticRangeLabel, h = i.rangeColors, m = i.className;
      return /* @__PURE__ */ Oa.default.createElement("div", {
        className: (0, g7.default)(Sa.default.definedRangesWrapper, m)
      }, o, /* @__PURE__ */ Oa.default.createElement("div", {
        className: Sa.default.staticRanges
      }, u.map(function(v, g) {
        var b = a.getSelectedRange(d, v), C = b.selectedRange, w = b.focusedRangeIndex, x;
        return v.hasCustomRendering ? x = p(v) : x = v.label, /* @__PURE__ */ Oa.default.createElement("button", {
          type: "button",
          className: (0, g7.default)(Sa.default.staticRange, bl({}, Sa.default.staticRangeSelected, !!C)),
          style: {
            color: C ? C.color || h[w] : null
          },
          key: g,
          onClick: function() {
            return a.handleRangeChange(v.range(a.props));
          },
          onFocus: function() {
            return l && l(v.range(a.props));
          },
          onMouseOver: function() {
            return l && l(v.range(a.props));
          },
          onMouseLeave: function() {
            l && l();
          }
        }, /* @__PURE__ */ Oa.default.createElement("span", {
          tabIndex: -1,
          className: Sa.default.staticRangeLabel
        }, x));
      })), /* @__PURE__ */ Oa.default.createElement("div", {
        className: Sa.default.inputRanges
      }, c.map(function(v, g) {
        return /* @__PURE__ */ Oa.default.createElement(aM.default, {
          key: g,
          styles: Sa.default,
          label: v.label,
          onFocus: function() {
            return a.setState({
              focusedInput: g,
              rangeOffset: 0
            });
          },
          onBlur: function() {
            return a.setState({
              rangeOffset: 0
            });
          },
          onChange: function(C) {
            return a.handleRangeChange(v.range(C, a.props));
          },
          value: a.getRangeOptionValue(v)
        });
      })), s);
    }
  }]), r;
}(Oa.Component);
yd.propTypes = {
  inputRanges: mr.default.array,
  staticRanges: mr.default.array,
  ranges: mr.default.arrayOf(nM.rangeShape),
  focusedRange: mr.default.arrayOf(mr.default.number),
  onPreviewChange: mr.default.func,
  onChange: mr.default.func,
  footerContent: mr.default.any,
  headerContent: mr.default.any,
  rangeColors: mr.default.arrayOf(mr.default.string),
  className: mr.default.string,
  renderStaticRangeLabel: mr.default.func
};
yd.defaultProps = {
  inputRanges: m7.defaultInputRanges,
  staticRanges: m7.defaultStaticRanges,
  ranges: [],
  rangeColors: ["#3d91ff", "#3ecf8e", "#fed14c"],
  focusedRange: [0, 0]
};
var dM = yd;
P1.default = dM;
function ms(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ms = function(r) {
    return typeof r;
  } : ms = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, ms(e);
}
Object.defineProperty(pu, "__esModule", {
  value: !0
});
pu.default = void 0;
var K1 = mM(E), pM = E1(tn), dm = E1(O1), pm = E1(P1), x7 = Hn, hM = E1(ti), vM = E1(ri);
function E1(e) {
  return e && e.__esModule ? e : { default: e };
}
function hm(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (hm = function(a) {
    return a ? r : t;
  })(e);
}
function mM(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || ms(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = hm(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function w7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? w7(Object(r), !0).forEach(function(n) {
      gM(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : w7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function gM(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Bl() {
  return Bl = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bl.apply(this, arguments);
}
function yM(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function O7(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function bM(e, t, r) {
  return t && O7(e.prototype, t), r && O7(e, r), e;
}
function CM(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Q3(e, t);
}
function Q3(e, t) {
  return Q3 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, Q3(e, t);
}
function xM(e) {
  var t = SM();
  return function() {
    var n = Vl(e), a;
    if (t) {
      var i = Vl(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return wM(this, a);
  };
}
function wM(e, t) {
  return t && (ms(t) === "object" || typeof t == "function") ? t : OM(e);
}
function OM(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function SM() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Vl(e) {
  return Vl = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Vl(e);
}
var bd = /* @__PURE__ */ function(e) {
  CM(r, e);
  var t = xM(r);
  function r(n) {
    var a;
    return yM(this, r), a = t.call(this, n), a.state = {
      focusedRange: [(0, x7.findNextRangeIndex)(n.ranges), 0]
    }, a.styles = (0, x7.generateStyles)([vM.default, n.classNames]), a;
  }
  return bM(r, [{
    key: "render",
    value: function() {
      var a = this, i = this.state.focusedRange;
      return /* @__PURE__ */ K1.default.createElement("div", {
        className: (0, hM.default)(this.styles.dateRangePickerWrapper, this.props.className)
      }, /* @__PURE__ */ K1.default.createElement(pm.default, Bl({
        focusedRange: i,
        onPreviewChange: function(s) {
          return a.dateRange.updatePreview(s ? a.dateRange.calcNewSelection(s, typeof s == "string") : null);
        }
      }, this.props, {
        range: this.props.ranges[i[0]],
        className: void 0
      })), /* @__PURE__ */ K1.default.createElement(dm.default, Bl({
        onRangeFocusChange: function(s) {
          return a.setState({
            focusedRange: s
          });
        },
        focusedRange: i
      }, this.props, {
        ref: function(s) {
          return a.dateRange = s;
        },
        className: void 0
      })));
    }
  }]), r;
}(K1.Component);
bd.defaultProps = {};
bd.propTypes = _2(_2(_2({}, dm.default.propTypes), pm.default.propTypes), {}, {
  className: pM.default.string
});
var PM = bd;
pu.default = PM;
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "DateRange", {
    enumerable: !0,
    get: function() {
      return t.default;
    }
  }), Object.defineProperty(e, "Calendar", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  }), Object.defineProperty(e, "DateRangePicker", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  }), Object.defineProperty(e, "DefinedRange", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  }), Object.defineProperty(e, "defaultInputRanges", {
    enumerable: !0,
    get: function() {
      return i.defaultInputRanges;
    }
  }), Object.defineProperty(e, "defaultStaticRanges", {
    enumerable: !0,
    get: function() {
      return i.defaultStaticRanges;
    }
  }), Object.defineProperty(e, "createStaticRanges", {
    enumerable: !0,
    get: function() {
      return i.createStaticRanges;
    }
  });
  var t = o(O1), r = o(S1), n = o(pu), a = o(P1), i = ia;
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
})(yv);
var EM = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
}, jM = function(t, r, n) {
  var a, i = EM[t];
  return typeof i == "string" ? a = i : r === 1 ? a = i.one : a = i.other.replace("{{count}}", r.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "en " + a : "hace " + a : a;
};
const _M = jM;
var AM = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, DM = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, MM = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, TM = {
  date: Mi({
    formats: AM,
    defaultWidth: "full"
  }),
  time: Mi({
    formats: DM,
    defaultWidth: "full"
  }),
  dateTime: Mi({
    formats: MM,
    defaultWidth: "full"
  })
};
const $M = TM;
var NM = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, IM = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, LM = function(t, r, n, a) {
  return r.getUTCHours() !== 1 ? IM[t] : NM[t];
};
const kM = LM;
var RM = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
}, BM = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, VM = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
  wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
}, HM = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"]
}, FM = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, WM = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, zM = function(t, r) {
  var n = Number(t);
  return n + "º";
}, UM = {
  ordinalNumber: zM,
  era: ln({
    values: RM,
    defaultWidth: "wide"
  }),
  quarter: ln({
    values: BM,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return Number(t) - 1;
    }
  }),
  month: ln({
    values: VM,
    defaultWidth: "wide"
  }),
  day: ln({
    values: HM,
    defaultWidth: "wide"
  }),
  dayPeriod: ln({
    values: FM,
    defaultWidth: "wide",
    formattingValues: WM,
    defaultFormattingWidth: "wide"
  })
};
const ZM = UM;
var qM = /^(\d+)(º)?/i, GM = /\d+/i, YM = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, KM = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
}, XM = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, QM = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, JM = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, eT = {
  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
}, tT = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, rT = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, nT = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, aT = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, iT = {
  ordinalNumber: Mv({
    matchPattern: qM,
    parsePattern: GM,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: cn({
    matchPatterns: YM,
    defaultMatchWidth: "wide",
    parsePatterns: KM,
    defaultParseWidth: "any"
  }),
  quarter: cn({
    matchPatterns: XM,
    defaultMatchWidth: "wide",
    parsePatterns: QM,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: cn({
    matchPatterns: JM,
    defaultMatchWidth: "wide",
    parsePatterns: eT,
    defaultParseWidth: "any"
  }),
  day: cn({
    matchPatterns: tT,
    defaultMatchWidth: "wide",
    parsePatterns: rT,
    defaultParseWidth: "any"
  }),
  dayPeriod: cn({
    matchPatterns: nT,
    defaultMatchWidth: "any",
    parsePatterns: aT,
    defaultParseWidth: "any"
  })
};
const oT = iT;
var sT = {
  code: "es",
  formatDistance: _M,
  formatLong: $M,
  formatRelative: kM,
  localize: ZM,
  match: oT,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const lT = sT;
const vm = E.forwardRef((e) => {
  const { onChangeValueFilterDate: t, valueFilterDate: r } = e, n = /* @__PURE__ */ new Date(), [a, i] = ye([
    {
      startDate: void 0,
      endDate: void 0,
      key: "selection"
    }
  ]), [o, s] = ye(!1), l = ve(null);
  _e(() => (document.addEventListener("keydown", c, !0), document.addEventListener("click", u, !0), () => {
    document.removeEventListener("keydown", c, !0), document.removeEventListener("click", u, !0);
  }), []);
  const c = (v) => {
    v.key === "Escape" && s(!1);
  }, u = (v) => {
    l.current != null && !l.current.contains(v.target) && s(!1);
  }, d = (v, g) => v != null && g != null ? `${v} - ${g}` : "", p = () => {
    i([
      {
        startDate: n,
        endDate: n,
        key: "selection"
      }
    ]), s(!0);
  }, h = () => {
    s(!1), t != null && t({ option: a[0] });
  }, m = () => {
    s(!1);
  };
  return /* @__PURE__ */ f.jsxs("div", { className: "block relative w-full", children: [
    /* @__PURE__ */ f.jsx(
      Qf,
      {
        iconRight: "calendar",
        placeholder: "dd/mm/aaaa",
        value: r != null && r.length === 2 ? d(r[0], r[1]) : "",
        readOnly: !0,
        onClick: p
      }
    ),
    /* @__PURE__ */ f.jsx("div", { ref: l, children: o && /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsxs("div", { className: "absolute mb-8 left-2/4 -translate-x-1/2 2s:right-0 2s:left-auto 2s:-translate-x-0 top-10 text-[13px] z-20", children: [
      /* @__PURE__ */ f.jsx(
        yv.DateRangePicker,
        {
          onChange: (v) => {
            i([v.selection]);
          },
          editableDateInputs: !0,
          moveRangeOnFirstSelection: !1,
          ranges: a,
          months: 1,
          direction: "horizontal",
          className: "w-[334px] sm:w-auto border rounded-tr-md rounded-tl-md",
          locale: lT
        }
      ),
      /* @__PURE__ */ f.jsxs("div", { className: "flex justify-end gap-4 p-2 border-l border-b border-r rounded-bl-md rounded-br-md bg-[#fff]", children: [
        /* @__PURE__ */ f.jsx("button", { className: "bg-neutral-300 hover:bg-neutral-200 rounded-md px-5 py-1", onClick: m, children: "Cancelar" }),
        /* @__PURE__ */ f.jsx("button", { className: "bg-secondary-500 hover:bg-secondary-600 rounded-md px-5 py-1 text-white", onClick: h, children: "Aplicar" })
      ] })
    ] }) }) })
  ] });
});
vm.displayName = "DateRangeInput";
const cT = E.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e;
  return /* @__PURE__ */ f.jsxs("div", { ref: t, ...n, className: "flex gap-16 flex-grow items-center", children: [
    /* @__PURE__ */ f.jsxs("svg", { className: "w-[100px] flex-shrink-0", viewBox: "0 0 100 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
      /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_1353_11639)", children: [
        /* @__PURE__ */ f.jsx("path", { d: "M41.9066 29.5001C38.8579 29.5001 36.5455 28.742 34.9695 27.2121C33.3935 25.6822 32.6055 23.4754 32.6055 20.5781C32.6055 14.4857 35.6671 11.4395 41.8032 11.4395C43.7797 11.4395 45.5237 11.7915 47.0222 12.509L45.95 15.5688C45.0586 15.3251 44.374 15.1491 43.8831 15.0678C43.3922 14.9866 42.7075 14.9325 41.842 14.9189C40.2789 14.8918 39.0258 15.3386 38.0957 16.2592C37.1656 17.1934 36.7005 18.5473 36.7005 20.3344C36.7005 22.1215 37.2044 23.5296 38.212 24.5043C39.2196 25.4791 40.5889 25.9665 42.32 25.9665C43.6893 25.9665 44.994 25.8041 46.2084 25.4656L47.061 28.6472C45.6012 29.2158 43.8831 29.4866 41.8937 29.4866L41.9066 29.5001Z", fill: "white" }),
        /* @__PURE__ */ f.jsx("path", { d: "M50.8975 29.2427V11.6694H54.9279V29.2427H50.8975Z", fill: "white" }),
        /* @__PURE__ */ f.jsx("path", { d: "M59.8115 29.2427V11.6694H64.7204L69.3969 25.4654L74.7579 11.6694H79.4343V29.2427H75.4038V22.7035L75.5201 18.5742L71.5413 29.2292H67.0328L63.5966 18.2763L63.8549 22.7035V29.2427H59.8244H59.8115Z", fill: "white" }),
        /* @__PURE__ */ f.jsx("path", { d: "M82.7158 29.2427L89.162 11.6694H94.3551L100 29.2427H95.8278L94.2389 24.098H88.5678L86.7463 29.2427H82.7158ZM89.64 21.0382H93.2959L91.6165 14.2824L89.6529 21.0382H89.64Z", fill: "white" }),
        /* @__PURE__ */ f.jsx("path", { d: "M1.22754 29.5001H21.212C25.0488 29.5001 27.5549 25.2625 25.8368 21.6612L23.3823 16.5029C17.8016 23.2858 10.0378 28.0244 1.22754 29.5001Z", fill: "#204585" }),
        /* @__PURE__ */ f.jsx("path", { d: "M17.0775 3.30245L16.2507 1.56949C15.566 0.134387 13.6154 0.134387 12.9307 1.56949L2.85449 22.7035C9.44279 18.1138 14.5067 11.3039 17.0775 3.30245Z", fill: "#F15C41" }),
        /* @__PURE__ */ f.jsx("path", { d: "M22.9296 15.5552L17.6719 4.53467C14.7653 12.8745 9.19755 19.8741 2.05378 24.4096L0.0126953 28.7013C9.17172 27.4693 17.2714 22.6224 22.9425 15.5687L22.9296 15.5552Z", fill: "#2875B4" })
      ] }),
      /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_1353_11639", children: /* @__PURE__ */ f.jsx("rect", { width: "100", height: "29", fill: "white", transform: "translate(0 0.5)" }) }) })
    ] }),
    r
  ] });
});
cT.displayName = "HedaerBoxLeft";
const uT = E.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e, a = Mt(yn), i = (a == null ? void 0 : a.isOpenMenu) ?? !1;
  return /* @__PURE__ */ f.jsxs("div", { ref: t, ...n, className: "flex gap-4 items-center", children: [
    r,
    /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        className: "l:hidden flex items-center justify-center rounded-[0.5rem] bg-secondary-800 hover:bg-primary-600 min-w-[40px] aspect-square text-white",
        children: /* @__PURE__ */ f.jsx(me, { variant: "search", width: 18 })
      }
    ),
    /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        onClick: a == null ? void 0 : a.toggleOpenMenu,
        className: `l:hidden flex items-center justify-center rounded-[0.5rem] ${i ? "bg-primary-600" : "bg-secondary-800"} hover:bg-primary-600 min-w-[40px] aspect-square text-white`,
        children: i ? /* @__PURE__ */ f.jsx(me, { variant: "close", width: 14 }) : /* @__PURE__ */ f.jsx(me, { variant: "menu" })
      }
    )
  ] });
});
uT.displayName = "HeaderBoxRight";
const fT = E.forwardRef((e, t) => {
  const {
    image: r,
    mb: n,
    mt: a,
    bg: i,
    rounded: o,
    spacing: s,
    children: l,
    onMarkAsRead: c,
    isRead: u,
    section: d,
    ...p
  } = e, h = {
    marginBottom: n !== void 0 ? `${n / 4}rem` : void 0,
    marginTop: a !== void 0 ? `${a / 4}rem` : void 0,
    backgroundColor: i !== void 0 ? je[i] : void 0,
    padding: s !== void 0 ? `${s / 4}rem` : void 0,
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
  };
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: t,
      className: "flex justify-between gap-2 cursor-pointer select-none p-4 rounded-md hover:bg-primary-200 ",
      ...p,
      style: h,
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "justify-start", children: l }),
        /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col justify-between gap-4", children: [
          /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx(me, { variant: d === "URGENTE" ? "exclamation-diamond-fill" : "menu", color: d === "URGENTE" ? "error-600" : "secondary-200", width: 20 }) }),
          /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx(
            gt,
            {
              size: "xs",
              variant: "secondary",
              icon: u ? "circle-check" : "circle",
              onlyIcon: !0,
              tooltip: u ? "Marcar como no leído" : "Marcar como leído",
              tooltipDirection: "left",
              onClick: () => c && c(u)
            }
          ) })
        ] })
      ]
    }
  );
});
fT.displayName = "HeaderNotificationItem";
const dT = E.forwardRef((e, t) => {
  const { children: r, quantity: n, isAusent: a, unRead: i, section: o, onSetSection: s, onMarkMasive: l, ...c } = e, u = Mt(yn), d = (u == null ? void 0 : u.isOpenNotifications) ?? !1, p = ve(null), h = ve(null), m = (x) => {
    if (p.current !== null && !p.current.contains(x.target)) {
      if (h.current !== null) {
        if (h.current.contains(x.target))
          return;
        u == null || u.closeNotifications();
        return;
      }
      u == null || u.closeNotifications();
    }
  };
  _e(() => (document.addEventListener("click", m, !0), () => {
    document.removeEventListener("click", m, !0);
  }), []);
  const [v, g] = ye(o), b = (x) => {
    g(x), s && s(x);
  }, C = a ? "bg-error-500" : d ? "bg-primary-600" : "bg-secondary-800", w = a ? "hover:bg-error-500" : "hover:bg-primary-600";
  return /* @__PURE__ */ f.jsxs("div", { ref: t, className: "relative", ...c, children: [
    /* @__PURE__ */ f.jsx(
      "button",
      {
        ref: p,
        type: "button",
        className: `flex items-center justify-center rounded-[0.5rem] ${C} ${w} min-w-[40px] aspect-square text-white`,
        onClick: u == null ? void 0 : u.toggleOpenNotifications,
        children: /* @__PURE__ */ f.jsxs("div", { className: "relative", children: [
          Number.isInteger(i) && /* @__PURE__ */ f.jsx("div", { className: "absolute top-0 right-0 bg-error-500 w-[19px] aspect-square rounded-full overflow-hidden inline-flex items-center justify-center text-xs translate-x-1/2 -translate-y-1/2", children: i }),
          /* @__PURE__ */ f.jsx(me, { variant: "notification", width: 18 })
        ] })
      }
    ),
    /* @__PURE__ */ f.jsx(
      "aside",
      {
        ref: h,
        className: `fixed z-[1] w-full right-0 top-0 bottom-[4.5rem] 2s:bottom-0 2s:top-[4.5rem] l:top-[5rem] ${d && n > 0 ? "block" : "hidden"} bg-secondary-100`,
        style: { maxWidth: "450px" },
        children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col h-full w-full", children: [
          /* @__PURE__ */ f.jsxs("div", { className: "pt-2 px-4 pb-4 border-b border-neutral-300 bg-secondary-100", children: [
            /* @__PURE__ */ f.jsxs("div", { className: "flex items-center justify-between px-4 text-white border-b pb-2", children: [
              /* @__PURE__ */ f.jsxs("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ f.jsx(me, { variant: "notification", color: "neutral-600" }),
                /* @__PURE__ */ f.jsx($n, { variant: "heading-6", color: "neutral-600", children: "Notificaciones" })
              ] }),
              /* @__PURE__ */ f.jsx(
                "button",
                {
                  type: "button",
                  onClick: u == null ? void 0 : u.closeNotifications,
                  children: /* @__PURE__ */ f.jsx(me, { variant: "circle-close", color: "neutral-600" })
                }
              )
            ] }),
            /* @__PURE__ */ f.jsxs("div", { className: "flex items-center justify-center px-2 text-white pt-2 gap-2", children: [
              /* @__PURE__ */ f.jsx(hr, { variant: "description-2", color: "secondary-950", children: "Marcar todo como leido" }),
              /* @__PURE__ */ f.jsx(
                "button",
                {
                  type: "button",
                  onClick: () => l && l(),
                  children: /* @__PURE__ */ f.jsx(me, { variant: "circle-check", color: "secondary-800" })
                }
              )
            ] }),
            /* @__PURE__ */ f.jsxs("div", { className: "flex items-center px-2 pt-2 text-white gap-4", children: [
              /* @__PURE__ */ f.jsx(
                gt,
                {
                  type: "button",
                  variant: v === "URGENTE" ? "secondary-light-bold" : "white-secondary",
                  icon: "exclamation-diamond-fill",
                  onClick: () => b("URGENTE"),
                  isFull: !0,
                  children: "Urgente"
                }
              ),
              /* @__PURE__ */ f.jsx(
                gt,
                {
                  type: "button",
                  variant: v !== "URGENTE" ? "secondary-light-bold" : "white-secondary",
                  icon: "menu",
                  onClick: () => b(""),
                  isFull: !0,
                  children: "General"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ f.jsx("div", { className: "flex-grow max-h-[calc(90%-72px-56px-32px)] l:max-h-[calc(90%-56px-56px-32px)] w-full max-w-[600px] my-4 mx-auto", children: /* @__PURE__ */ f.jsx("div", { className: "h-full overflow-y-auto menu-wrapper-scrollbar", id: "scrollableDiv", children: /* @__PURE__ */ f.jsx("div", { className: "flex flex-col gap-4 p-2", children: r }) }) })
        ] })
      }
    )
  ] });
});
dT.displayName = "HeaderNotifications";
const pT = E.forwardRef((e, t) => {
  const {
    ...r
  } = e;
  return /* @__PURE__ */ f.jsxs(
    "button",
    {
      type: "button",
      ref: t,
      className: "hidden l:flex h-10 items-center justify-between w-[240px] rounded-md bg-secondary-800 hover:bg-primary-600 text-white px-4",
      ...r,
      children: [
        /* @__PURE__ */ f.jsx("p", { className: "font-semibold", children: "Plataforma tradicional" }),
        /* @__PURE__ */ f.jsx("span", { className: "rotate-180", children: /* @__PURE__ */ f.jsx(me, { variant: "back-arrow" }) })
      ]
    }
  );
});
pT.displayName = "HeaderOldButton";
const hT = E.forwardRef((e, t) => {
  const {
    ...r
  } = e, n = Yf();
  return /* @__PURE__ */ f.jsx("form", { ref: t, ...r, className: "hidden w-full max-w-[416px] l:block", children: /* @__PURE__ */ f.jsxs("div", { className: "h-10 bg-white rounded-md relative", children: [
    /* @__PURE__ */ f.jsx(
      "input",
      {
        id: n,
        type: "text",
        className: "h-full pl-4 pr-12 w-full outline-none shadow-transparent rounded-md border border-transparent focus:border-secondary-400",
        placeholder: "Busca cotizaciones, clientes y más",
        style: { textTransform: "none" }
      }
    ),
    /* @__PURE__ */ f.jsx("label", { htmlFor: n, className: "absolute top-1/2 right-4 cursor-pointer -translate-y-1/2", children: /* @__PURE__ */ f.jsx(me, { variant: "search" }) })
  ] }) });
});
hT.displayName = "HeaderSearch";
const vT = E.forwardRef((e, t) => {
  const {
    image: r,
    name: n,
    email: a,
    isInsideMenu: i = !1,
    isReplace: o = !1,
    isAusent: s = !1,
    children: l,
    ...c
  } = e, u = Mt(yn), d = (u == null ? void 0 : u.isOpenMenuUser) ?? !1, p = ve(null), h = ve(null), m = (g) => {
    if (!i && !(window.innerWidth < 1280) && p.current !== null && !p.current.contains(g.target)) {
      if (h.current !== null) {
        if (h.current.contains(g.target))
          return;
        u == null || u.closeMenuUser();
        return;
      }
      u == null || u.closeMenuUser();
    }
  };
  _e(() => (document.addEventListener("click", m, !0), () => {
    document.removeEventListener("click", m, !0);
  }), []);
  const v = s ? "bg-error-500" : o ? "bg-accent-600" : "bg-primary-600";
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: t,
      className: `w-full relative ${i ? "block l:hidden max-w-none px-4" : "hidden l:block w-[350px]"}`,
      ...c,
      children: [
        /* @__PURE__ */ f.jsxs(
          "div",
          {
            ref: p,
            className: `h-10 w-full ${d || o || s ? v : "bg-secondary-800"} hover:${v} cursor-pointer flex gap-2 items-center rounded-md text-white px-2 select-none`,
            onClick: u == null ? void 0 : u.toggleOpenMenuUser,
            children: [
              /* @__PURE__ */ f.jsx(x1, { size: "sm", image: r }),
              /* @__PURE__ */ f.jsxs("div", { className: "flex-grow max-w-[calc(100%-28px-15px-16px)]", children: [
                /* @__PURE__ */ f.jsx("p", { className: "font-bold leading-none text-ellipsis whitespace-nowrap overflow-hidden w-full", children: n }),
                /* @__PURE__ */ f.jsx("p", { className: "text-s leading-none text-ellipsis whitespace-nowrap overflow-hidden w-full", children: a })
              ] }),
              /* @__PURE__ */ f.jsx("span", { className: `flex-shrink ${d ? "-rotate-180" : ""}`, children: /* @__PURE__ */ f.jsx(me, { variant: "arrow-down", width: 14 }) })
            ]
          }
        ),
        d && /* @__PURE__ */ f.jsx("div", { ref: h, className: "relative mt-3 w-full l:absolute l:top-[100%] l:z-[1]", children: /* @__PURE__ */ f.jsx("ul", { className: "bg-secondary-800 l:bg-white px-4 py-3 rounded-md l:shadow-l", children: l }) })
      ]
    }
  );
});
vT.displayName = "HeaderUser";
const mT = E.forwardRef((e, t) => {
  const {
    icon: r,
    children: n,
    onClick: a,
    ...i
  } = e, o = Mt(yn), s = (l) => {
    o == null || o.closeMenu(), o == null || o.closeMenuUser(), a !== void 0 && a(l);
  };
  return /* @__PURE__ */ f.jsxs(
    "li",
    {
      ref: t,
      onClick: s,
      className: "flex justify-between gap-2 items-center text-white l:text-secondary-600 p-2 cursor-pointer rounded-md hover:bg-secondary-600 l:hover:bg-secondary-200",
      ...i,
      children: [
        /* @__PURE__ */ f.jsx("span", { className: "w-[20px] min-w-[20px]", children: /* @__PURE__ */ f.jsx(me, { variant: r, width: 20 }) }),
        /* @__PURE__ */ f.jsx("span", { className: "flex-grow font-bold", children: n })
      ]
    }
  );
});
mT.displayName = "HeaderUserItem";
const gT = E.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e;
  return /* @__PURE__ */ f.jsx("header", { ref: t, ...n, className: "w-full bg-secondary-850 px-6 flex items-center justify-between gap-4 fixed bottom-0 2s:top-0 h-[4.5rem] l:h-[5rem] z-[1600]", children: r });
});
gT.displayName = "HeaderWrapper";
const mm = ({ width: e = 130 }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    width: e,
    viewBox: "0 0 410 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_1111_2402)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M171.818 119c-12.5 0-21.981-3.111-28.442-9.389-6.462-6.278-9.693-15.333-9.693-27.222 0-25 12.553-37.5 37.711-37.5 8.104 0 15.254 1.444 21.398 4.389l-4.396 12.555c-3.655-1-6.462-1.722-8.475-2.055-2.012-.334-4.819-.556-8.368-.611-6.409-.111-11.546 1.722-15.36 5.5-3.813 3.833-5.72 9.389-5.72 16.722 0 7.333 2.066 13.111 6.197 17.111s9.745 6 16.843 6c5.614 0 10.963-.667 15.942-2.056l3.496 13.056c-5.985 2.333-13.03 3.444-21.186 3.444l.053.056zM208.681 117.944v-72.11h16.525v72.11h-16.525zM245.227 117.944v-72.11h20.126l19.173 56.61 21.981-56.61h19.173v72.11h-16.525V91.111l.477-16.944-16.313 43.722h-18.485l-14.089-44.945 1.06 18.167v26.833h-16.578zM339.133 117.944l26.43-72.11h21.292L410 117.943h-17.107l-6.515-21.11h-23.252l-7.468 21.11h-16.525zm28.389-33.666h14.989l-6.885-27.722-8.051 27.722h-.053z",
          fill: "#2875B4"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M5.032 119h81.936c15.731 0 26.006-17.389 18.962-32.167L95.866 65.667C72.986 93.5 41.154 112.944 5.032 119z",
          fill: "#204585"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M70.02 11.5l-3.39-7.111c-2.808-5.889-10.805-5.889-13.612 0L11.705 91.11C38.717 72.278 59.48 44.333 70.02 11.5z",
          fill: "#F15C41"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M94.012 61.778L72.456 16.556C60.538 50.778 37.71 79.5 8.42 98.11L.053 115.722c37.552-5.055 70.76-24.944 94.012-53.889l-.053-.055z",
          fill: "#2875B4"
        }
      )
    ] })
  }
), yT = ({ width: e = 63 }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    width: e,
    viewBox: "0 0 63 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M29.086 29.927c-1.06 0-1.926-.18-2.586-.546l.525-1.33c.67.235 1.35.35 2.041.35.9 0 1.35-.25 1.35-.75 0-.19-.09-.36-.274-.51a2.08 2.08 0 00-.676-.376c-.27-.1-.565-.22-.885-.37a8.16 8.16 0 01-.886-.476 1.961 1.961 0 01-.675-.72c-.18-.31-.275-.67-.275-1.08 0-.691.275-1.216.82-1.581.545-.366 1.196-.546 1.951-.546.38 0 .73.03 1.05.085.326.06.566.115.721.175.155.06.37.145.64.26l-.535 1.286c-.735-.21-1.34-.315-1.82-.315-.676 0-1.016.205-1.016.62 0 .16.095.31.28.446.185.135.415.26.69.365.275.105.576.235.896.395.32.155.62.325.895.505.276.18.506.426.69.73.186.306.28.651.28 1.036 0 .406-.09.766-.274 1.076-.18.31-.425.555-.736.736-.31.18-.65.315-1.02.405-.37.085-.766.13-1.176.13h.005zM34.103 29.806v-7.714h1.857v7.714h-1.857zM37.47 29.806l2.967-7.714h2.391l2.597 7.714h-1.921l-.73-2.256h-2.607l-.84 2.256H37.47zm3.187-3.602h1.681l-.775-2.966-.906 2.966zM50.508 29.918c-1.405 0-2.466-.335-3.191-1.006-.726-.67-1.086-1.64-1.086-2.911 0-2.677 1.41-4.013 4.232-4.013.911 0 1.711.155 2.402.47l-.49 1.341c-.406-.11-.726-.18-.951-.22a6.929 6.929 0 00-.94-.065c-.721-.015-1.296.18-1.727.59-.43.406-.645 1.006-.645 1.792 0 .785.235 1.405.7 1.83.466.43 1.096.646 1.887.646.63 0 1.23-.075 1.79-.22l.39 1.396c-.67.245-1.46.37-2.376.37h.005zM58.298 29.937c-1.33 0-2.336-.35-3.017-1.05-.68-.7-1.02-1.686-1.02-2.952s.38-2.186 1.14-2.897c.76-.71 1.796-1.065 3.102-1.065 1.306 0 2.352.36 3.017 1.08.665.72 1 1.686 1 2.902 0 1.216-.365 2.216-1.09 2.922-.725.705-1.771 1.06-3.132 1.06zm.035-1.46c.806 0 1.39-.226 1.756-.68.365-.456.546-1.072.546-1.852s-.186-1.37-.55-1.826c-.366-.455-.926-.68-1.677-.68-.75 0-1.35.225-1.716.675-.365.45-.55 1.055-.55 1.811 0 .755.18 1.37.54 1.846.36.47.91.71 1.651.71v-.005z",
          fill: "#2875B4"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M15.873 27.485l-1.22-1.42c-.186.014-.381.014-.581.014h-.796v3.703l4.998 4.997 1.736-4.807c-1.946-.18-3.057-1.231-4.137-2.492v.005z",
          fill: "#F15C41"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10.665 19.006h4.202c2.427 0 4.168 1.116 4.168 3.527 0 1.206-.58 2.261-1.741 2.917l1.1 1.19c.576.62 1.231 1.041 2.337 1.346L30.84 0 .48 16.985 10.665 27.17v-8.165z",
          fill: "#F15C41"
        }
      )
    ]
  }
);
function gm(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Al(e, t);
}
function Ce() {
  return Ce = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ce.apply(null, arguments);
}
function S7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function P7(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? S7(Object(r), !0).forEach(function(n) {
      ce(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : S7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function fr(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var E7 = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), A2 = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, j7 = {
  INIT: "@@redux/INIT" + A2(),
  REPLACE: "@@redux/REPLACE" + A2(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + A2();
  }
};
function bT(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function CT(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (OT(e))
    return "date";
  if (wT(e))
    return "error";
  var r = xT(e);
  switch (r) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return r;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function xT(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function wT(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function OT(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function Ma(e) {
  var t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = CT(e)), t;
}
function ym(e, t, r) {
  var n;
  if (typeof t == "function" && typeof r == "function" || typeof r == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? fr(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof r > "u" && (r = t, t = void 0), typeof r < "u") {
    if (typeof r != "function")
      throw new Error(process.env.NODE_ENV === "production" ? fr(1) : "Expected the enhancer to be a function. Instead, received: '" + Ma(r) + "'");
    return r(ym)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? fr(2) : "Expected the root reducer to be a function. Instead, received: '" + Ma(e) + "'");
  var a = e, i = t, o = [], s = o, l = !1;
  function c() {
    s === o && (s = o.slice());
  }
  function u() {
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? fr(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return i;
  }
  function d(v) {
    if (typeof v != "function")
      throw new Error(process.env.NODE_ENV === "production" ? fr(4) : "Expected the listener to be a function. Instead, received: '" + Ma(v) + "'");
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? fr(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var g = !0;
    return c(), s.push(v), function() {
      if (g) {
        if (l)
          throw new Error(process.env.NODE_ENV === "production" ? fr(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        g = !1, c();
        var C = s.indexOf(v);
        s.splice(C, 1), o = null;
      }
    };
  }
  function p(v) {
    if (!bT(v))
      throw new Error(process.env.NODE_ENV === "production" ? fr(7) : "Actions must be plain objects. Instead, the actual type was: '" + Ma(v) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof v.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? fr(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? fr(9) : "Reducers may not dispatch actions.");
    try {
      l = !0, i = a(i, v);
    } finally {
      l = !1;
    }
    for (var g = o = s, b = 0; b < g.length; b++) {
      var C = g[b];
      C();
    }
    return v;
  }
  function h(v) {
    if (typeof v != "function")
      throw new Error(process.env.NODE_ENV === "production" ? fr(10) : "Expected the nextReducer to be a function. Instead, received: '" + Ma(v));
    a = v, p({
      type: j7.REPLACE
    });
  }
  function m() {
    var v, g = d;
    return v = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(C) {
        if (typeof C != "object" || C === null)
          throw new Error(process.env.NODE_ENV === "production" ? fr(11) : "Expected the observer to be an object. Instead, received: '" + Ma(C) + "'");
        function w() {
          C.next && C.next(u());
        }
        w();
        var x = g(w);
        return {
          unsubscribe: x
        };
      }
    }, v[E7] = function() {
      return this;
    }, v;
  }
  return p({
    type: j7.INIT
  }), n = {
    dispatch: p,
    subscribe: d,
    getState: u,
    replaceReducer: h
  }, n[E7] = m, n;
}
function _7(e, t) {
  return function() {
    return t(e.apply(this, arguments));
  };
}
function A7(e, t) {
  if (typeof e == "function")
    return _7(e, t);
  if (typeof e != "object" || e === null)
    throw new Error(process.env.NODE_ENV === "production" ? fr(16) : "bindActionCreators expected an object or a function, but instead received: '" + Ma(e) + `'. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?`);
  var r = {};
  for (var n in e) {
    var a = e[n];
    typeof a == "function" && (r[n] = _7(a, t));
  }
  return r;
}
function bm() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return t.length === 0 ? function(n) {
    return n;
  } : t.length === 1 ? t[0] : t.reduce(function(n, a) {
    return function() {
      return n(a.apply(void 0, arguments));
    };
  });
}
function ST() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return function(n) {
    return function() {
      var a = n.apply(void 0, arguments), i = function() {
        throw new Error(process.env.NODE_ENV === "production" ? fr(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, o = {
        getState: a.getState,
        dispatch: function() {
          return i.apply(void 0, arguments);
        }
      }, s = t.map(function(l) {
        return l(o);
      });
      return i = bm.apply(void 0, s)(a.dispatch), P7(P7({}, a), {}, {
        dispatch: i
      });
    };
  };
}
var Cd = /* @__PURE__ */ E.createContext(null);
process.env.NODE_ENV !== "production" && (Cd.displayName = "ReactRedux");
function PT(e) {
  e();
}
var Cm = PT, ET = function(t) {
  return Cm = t;
}, jT = function() {
  return Cm;
};
function _T() {
  var e = jT(), t = null, r = null;
  return {
    clear: function() {
      t = null, r = null;
    },
    notify: function() {
      e(function() {
        for (var a = t; a; )
          a.callback(), a = a.next;
      });
    },
    get: function() {
      for (var a = [], i = t; i; )
        a.push(i), i = i.next;
      return a;
    },
    subscribe: function(a) {
      var i = !0, o = r = {
        callback: a,
        next: null,
        prev: r
      };
      return o.prev ? o.prev.next = o : t = o, function() {
        !i || t === null || (i = !1, o.next ? o.next.prev = o.prev : r = o.prev, o.prev ? o.prev.next = o.next : t = o.next);
      };
    }
  };
}
var D7 = {
  notify: function() {
  },
  get: function() {
    return [];
  }
};
function xm(e, t) {
  var r, n = D7;
  function a(d) {
    return l(), n.subscribe(d);
  }
  function i() {
    n.notify();
  }
  function o() {
    u.onStateChange && u.onStateChange();
  }
  function s() {
    return !!r;
  }
  function l() {
    r || (r = t ? t.addNestedSub(o) : e.subscribe(o), n = _T());
  }
  function c() {
    r && (r(), r = void 0, n.clear(), n = D7);
  }
  var u = {
    addNestedSub: a,
    notifyNestedSubs: i,
    handleChangeWrapper: o,
    isSubscribed: s,
    trySubscribe: l,
    tryUnsubscribe: c,
    getListeners: function() {
      return n;
    }
  };
  return u;
}
var wm = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? uv : _e;
function Om(e) {
  var t = e.store, r = e.context, n = e.children, a = Tr(function() {
    var s = xm(t);
    return {
      store: t,
      subscription: s
    };
  }, [t]), i = Tr(function() {
    return t.getState();
  }, [t]);
  wm(function() {
    var s = a.subscription;
    return s.onStateChange = s.notifyNestedSubs, s.trySubscribe(), i !== t.getState() && s.notifyNestedSubs(), function() {
      s.tryUnsubscribe(), s.onStateChange = null;
    };
  }, [a, i]);
  var o = r || Cd;
  return /* @__PURE__ */ E.createElement(o.Provider, {
    value: a
  }, n);
}
process.env.NODE_ENV !== "production" && (Om.propTypes = {
  store: Pe.shape({
    subscribe: Pe.func.isRequired,
    dispatch: Pe.func.isRequired,
    getState: Pe.func.isRequired
  }),
  context: Pe.object,
  children: Pe.any
});
function Hl(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if ({}.hasOwnProperty.call(e, n)) {
      if (t.includes(n))
        continue;
      r[n] = e[n];
    }
  return r;
}
var J3 = { exports: {} }, Qe = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var M7;
function AT() {
  if (M7)
    return Qe;
  M7 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
  function w(y) {
    if (typeof y == "object" && y !== null) {
      var O = y.$$typeof;
      switch (O) {
        case t:
          switch (y = y.type, y) {
            case l:
            case c:
            case n:
            case i:
            case a:
            case d:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case u:
                case m:
                case h:
                case o:
                  return y;
                default:
                  return O;
              }
          }
        case r:
          return O;
      }
    }
  }
  function x(y) {
    return w(y) === c;
  }
  return Qe.AsyncMode = l, Qe.ConcurrentMode = c, Qe.ContextConsumer = s, Qe.ContextProvider = o, Qe.Element = t, Qe.ForwardRef = u, Qe.Fragment = n, Qe.Lazy = m, Qe.Memo = h, Qe.Portal = r, Qe.Profiler = i, Qe.StrictMode = a, Qe.Suspense = d, Qe.isAsyncMode = function(y) {
    return x(y) || w(y) === l;
  }, Qe.isConcurrentMode = x, Qe.isContextConsumer = function(y) {
    return w(y) === s;
  }, Qe.isContextProvider = function(y) {
    return w(y) === o;
  }, Qe.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === t;
  }, Qe.isForwardRef = function(y) {
    return w(y) === u;
  }, Qe.isFragment = function(y) {
    return w(y) === n;
  }, Qe.isLazy = function(y) {
    return w(y) === m;
  }, Qe.isMemo = function(y) {
    return w(y) === h;
  }, Qe.isPortal = function(y) {
    return w(y) === r;
  }, Qe.isProfiler = function(y) {
    return w(y) === i;
  }, Qe.isStrictMode = function(y) {
    return w(y) === a;
  }, Qe.isSuspense = function(y) {
    return w(y) === d;
  }, Qe.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === c || y === i || y === a || y === d || y === p || typeof y == "object" && y !== null && (y.$$typeof === m || y.$$typeof === h || y.$$typeof === o || y.$$typeof === s || y.$$typeof === u || y.$$typeof === g || y.$$typeof === b || y.$$typeof === C || y.$$typeof === v);
  }, Qe.typeOf = w, Qe;
}
var Je = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var T7;
function DT() {
  return T7 || (T7 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
    function w(D) {
      return typeof D == "string" || typeof D == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      D === n || D === c || D === i || D === a || D === d || D === p || typeof D == "object" && D !== null && (D.$$typeof === m || D.$$typeof === h || D.$$typeof === o || D.$$typeof === s || D.$$typeof === u || D.$$typeof === g || D.$$typeof === b || D.$$typeof === C || D.$$typeof === v);
    }
    function x(D) {
      if (typeof D == "object" && D !== null) {
        var Q = D.$$typeof;
        switch (Q) {
          case t:
            var z = D.type;
            switch (z) {
              case l:
              case c:
              case n:
              case i:
              case a:
              case d:
                return z;
              default:
                var te = z && z.$$typeof;
                switch (te) {
                  case s:
                  case u:
                  case m:
                  case h:
                  case o:
                    return te;
                  default:
                    return Q;
                }
            }
          case r:
            return Q;
        }
      }
    }
    var y = l, O = c, P = s, j = o, T = t, I = u, R = n, F = m, $ = h, Z = r, X = i, K = a, J = d, ee = !1;
    function A(D) {
      return ee || (ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), _(D) || x(D) === l;
    }
    function _(D) {
      return x(D) === c;
    }
    function N(D) {
      return x(D) === s;
    }
    function M(D) {
      return x(D) === o;
    }
    function S(D) {
      return typeof D == "object" && D !== null && D.$$typeof === t;
    }
    function B(D) {
      return x(D) === u;
    }
    function G(D) {
      return x(D) === n;
    }
    function U(D) {
      return x(D) === m;
    }
    function H(D) {
      return x(D) === h;
    }
    function k(D) {
      return x(D) === r;
    }
    function L(D) {
      return x(D) === i;
    }
    function W(D) {
      return x(D) === a;
    }
    function V(D) {
      return x(D) === d;
    }
    Je.AsyncMode = y, Je.ConcurrentMode = O, Je.ContextConsumer = P, Je.ContextProvider = j, Je.Element = T, Je.ForwardRef = I, Je.Fragment = R, Je.Lazy = F, Je.Memo = $, Je.Portal = Z, Je.Profiler = X, Je.StrictMode = K, Je.Suspense = J, Je.isAsyncMode = A, Je.isConcurrentMode = _, Je.isContextConsumer = N, Je.isContextProvider = M, Je.isElement = S, Je.isForwardRef = B, Je.isFragment = G, Je.isLazy = U, Je.isMemo = H, Je.isPortal = k, Je.isProfiler = L, Je.isStrictMode = W, Je.isSuspense = V, Je.isValidElementType = w, Je.typeOf = x;
  }()), Je;
}
process.env.NODE_ENV === "production" ? J3.exports = AT() : J3.exports = DT();
var MT = J3.exports, xd = MT, TT = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, $T = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, NT = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Sm = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, wd = {};
wd[xd.ForwardRef] = NT;
wd[xd.Memo] = Sm;
function $7(e) {
  return xd.isMemo(e) ? Sm : wd[e.$$typeof] || TT;
}
var IT = Object.defineProperty, LT = Object.getOwnPropertyNames, N7 = Object.getOwnPropertySymbols, kT = Object.getOwnPropertyDescriptor, RT = Object.getPrototypeOf, I7 = Object.prototype;
function Pm(e, t, r) {
  if (typeof t != "string") {
    if (I7) {
      var n = RT(t);
      n && n !== I7 && Pm(e, n, r);
    }
    var a = LT(t);
    N7 && (a = a.concat(N7(t)));
    for (var i = $7(e), o = $7(t), s = 0; s < a.length; ++s) {
      var l = a[s];
      if (!$T[l] && !(r && r[l]) && !(o && o[l]) && !(i && i[l])) {
        var c = kT(t, l);
        try {
          IT(e, l, c);
        } catch {
        }
      }
    }
  }
  return e;
}
var BT = Pm;
const L7 = /* @__PURE__ */ Ze(BT);
var e0 = { exports: {} }, at = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var k7;
function VT() {
  if (k7)
    return at;
  k7 = 1;
  var e = 60103, t = 60106, r = 60107, n = 60108, a = 60114, i = 60109, o = 60110, s = 60112, l = 60113, c = 60120, u = 60115, d = 60116, p = 60121, h = 60122, m = 60117, v = 60129, g = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var b = Symbol.for;
    e = b("react.element"), t = b("react.portal"), r = b("react.fragment"), n = b("react.strict_mode"), a = b("react.profiler"), i = b("react.provider"), o = b("react.context"), s = b("react.forward_ref"), l = b("react.suspense"), c = b("react.suspense_list"), u = b("react.memo"), d = b("react.lazy"), p = b("react.block"), h = b("react.server.block"), m = b("react.fundamental"), v = b("react.debug_trace_mode"), g = b("react.legacy_hidden");
  }
  function C($) {
    if (typeof $ == "object" && $ !== null) {
      var Z = $.$$typeof;
      switch (Z) {
        case e:
          switch ($ = $.type, $) {
            case r:
            case a:
            case n:
            case l:
            case c:
              return $;
            default:
              switch ($ = $ && $.$$typeof, $) {
                case o:
                case s:
                case d:
                case u:
                case i:
                  return $;
                default:
                  return Z;
              }
          }
        case t:
          return Z;
      }
    }
  }
  var w = i, x = e, y = s, O = r, P = d, j = u, T = t, I = a, R = n, F = l;
  return at.ContextConsumer = o, at.ContextProvider = w, at.Element = x, at.ForwardRef = y, at.Fragment = O, at.Lazy = P, at.Memo = j, at.Portal = T, at.Profiler = I, at.StrictMode = R, at.Suspense = F, at.isAsyncMode = function() {
    return !1;
  }, at.isConcurrentMode = function() {
    return !1;
  }, at.isContextConsumer = function($) {
    return C($) === o;
  }, at.isContextProvider = function($) {
    return C($) === i;
  }, at.isElement = function($) {
    return typeof $ == "object" && $ !== null && $.$$typeof === e;
  }, at.isForwardRef = function($) {
    return C($) === s;
  }, at.isFragment = function($) {
    return C($) === r;
  }, at.isLazy = function($) {
    return C($) === d;
  }, at.isMemo = function($) {
    return C($) === u;
  }, at.isPortal = function($) {
    return C($) === t;
  }, at.isProfiler = function($) {
    return C($) === a;
  }, at.isStrictMode = function($) {
    return C($) === n;
  }, at.isSuspense = function($) {
    return C($) === l;
  }, at.isValidElementType = function($) {
    return typeof $ == "string" || typeof $ == "function" || $ === r || $ === a || $ === v || $ === n || $ === l || $ === c || $ === g || typeof $ == "object" && $ !== null && ($.$$typeof === d || $.$$typeof === u || $.$$typeof === i || $.$$typeof === o || $.$$typeof === s || $.$$typeof === m || $.$$typeof === p || $[0] === h);
  }, at.typeOf = C, at;
}
var it = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var R7;
function HT() {
  return R7 || (R7 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, r = 60107, n = 60108, a = 60114, i = 60109, o = 60110, s = 60112, l = 60113, c = 60120, u = 60115, d = 60116, p = 60121, h = 60122, m = 60117, v = 60129, g = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var b = Symbol.for;
      e = b("react.element"), t = b("react.portal"), r = b("react.fragment"), n = b("react.strict_mode"), a = b("react.profiler"), i = b("react.provider"), o = b("react.context"), s = b("react.forward_ref"), l = b("react.suspense"), c = b("react.suspense_list"), u = b("react.memo"), d = b("react.lazy"), p = b("react.block"), h = b("react.server.block"), m = b("react.fundamental"), b("react.scope"), b("react.opaque.id"), v = b("react.debug_trace_mode"), b("react.offscreen"), g = b("react.legacy_hidden");
    }
    var C = !1;
    function w(V) {
      return !!(typeof V == "string" || typeof V == "function" || V === r || V === a || V === v || V === n || V === l || V === c || V === g || C || typeof V == "object" && V !== null && (V.$$typeof === d || V.$$typeof === u || V.$$typeof === i || V.$$typeof === o || V.$$typeof === s || V.$$typeof === m || V.$$typeof === p || V[0] === h));
    }
    function x(V) {
      if (typeof V == "object" && V !== null) {
        var D = V.$$typeof;
        switch (D) {
          case e:
            var Q = V.type;
            switch (Q) {
              case r:
              case a:
              case n:
              case l:
              case c:
                return Q;
              default:
                var z = Q && Q.$$typeof;
                switch (z) {
                  case o:
                  case s:
                  case d:
                  case u:
                  case i:
                    return z;
                  default:
                    return D;
                }
            }
          case t:
            return D;
        }
      }
    }
    var y = o, O = i, P = e, j = s, T = r, I = d, R = u, F = t, $ = a, Z = n, X = l, K = !1, J = !1;
    function ee(V) {
      return K || (K = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function A(V) {
      return J || (J = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function _(V) {
      return x(V) === o;
    }
    function N(V) {
      return x(V) === i;
    }
    function M(V) {
      return typeof V == "object" && V !== null && V.$$typeof === e;
    }
    function S(V) {
      return x(V) === s;
    }
    function B(V) {
      return x(V) === r;
    }
    function G(V) {
      return x(V) === d;
    }
    function U(V) {
      return x(V) === u;
    }
    function H(V) {
      return x(V) === t;
    }
    function k(V) {
      return x(V) === a;
    }
    function L(V) {
      return x(V) === n;
    }
    function W(V) {
      return x(V) === l;
    }
    it.ContextConsumer = y, it.ContextProvider = O, it.Element = P, it.ForwardRef = j, it.Fragment = T, it.Lazy = I, it.Memo = R, it.Portal = F, it.Profiler = $, it.StrictMode = Z, it.Suspense = X, it.isAsyncMode = ee, it.isConcurrentMode = A, it.isContextConsumer = _, it.isContextProvider = N, it.isElement = M, it.isForwardRef = S, it.isFragment = B, it.isLazy = G, it.isMemo = U, it.isPortal = H, it.isProfiler = k, it.isStrictMode = L, it.isSuspense = W, it.isValidElementType = w, it.typeOf = x;
  }()), it;
}
process.env.NODE_ENV === "production" ? e0.exports = VT() : e0.exports = HT();
var B7 = e0.exports, FT = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"], WT = ["reactReduxForwardedRef"], zT = [], UT = [null, null], ZT = function(t) {
  try {
    return JSON.stringify(t);
  } catch {
    return String(t);
  }
};
function qT(e, t) {
  var r = e[1];
  return [t.payload, r + 1];
}
function V7(e, t, r) {
  wm(function() {
    return e.apply(void 0, t);
  }, r);
}
function GT(e, t, r, n, a, i, o) {
  e.current = n, t.current = a, r.current = !1, i.current && (i.current = null, o());
}
function YT(e, t, r, n, a, i, o, s, l, c) {
  if (e) {
    var u = !1, d = null, p = function() {
      if (!u) {
        var v = t.getState(), g, b;
        try {
          g = n(v, a.current);
        } catch (C) {
          b = C, d = C;
        }
        b || (d = null), g === i.current ? o.current || l() : (i.current = g, s.current = g, o.current = !0, c({
          type: "STORE_UPDATED",
          payload: {
            error: b
          }
        }));
      }
    };
    r.onStateChange = p, r.trySubscribe(), p();
    var h = function() {
      if (u = !0, r.tryUnsubscribe(), r.onStateChange = null, d)
        throw d;
    };
    return h;
  }
}
var KT = function() {
  return [null, 0];
};
function XT(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.getDisplayName, a = n === void 0 ? function(O) {
    return "ConnectAdvanced(" + O + ")";
  } : n, i = r.methodName, o = i === void 0 ? "connectAdvanced" : i, s = r.renderCountProp, l = s === void 0 ? void 0 : s, c = r.shouldHandleStateChanges, u = c === void 0 ? !0 : c, d = r.storeKey, p = d === void 0 ? "store" : d, h = r.withRef, m = h === void 0 ? !1 : h, v = r.forwardRef, g = v === void 0 ? !1 : v, b = r.context, C = b === void 0 ? Cd : b, w = Hl(r, FT);
  if (process.env.NODE_ENV !== "production") {
    if (l !== void 0)
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    if (m)
      throw new Error("withRef is removed. To access the wrapped instance, use a ref on the connected component");
    var x = "To use a custom Redux store for specific components, create a custom React context with React.createContext(), and pass the context object to React Redux's Provider and specific components like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. You may also pass a {context : MyContext} option to connect";
    if (p !== "store")
      throw new Error("storeKey has been removed and does not do anything. " + x);
  }
  var y = C;
  return function(P) {
    if (process.env.NODE_ENV !== "production" && !B7.isValidElementType(P))
      throw new Error("You must pass a component to the function returned by " + (o + ". Instead received " + ZT(P)));
    var j = P.displayName || P.name || "Component", T = a(j), I = Ce({}, w, {
      getDisplayName: a,
      methodName: o,
      renderCountProp: l,
      shouldHandleStateChanges: u,
      storeKey: p,
      displayName: T,
      wrappedComponentName: j,
      WrappedComponent: P
    }), R = w.pure;
    function F(J) {
      return e(J.dispatch, I);
    }
    var $ = R ? Tr : function(J) {
      return J();
    };
    function Z(J) {
      var ee = Tr(function() {
        var Ye = J.reactReduxForwardedRef, Ct = Hl(J, WT);
        return [J.context, Ye, Ct];
      }, [J]), A = ee[0], _ = ee[1], N = ee[2], M = Tr(function() {
        return A && A.Consumer && B7.isContextConsumer(/* @__PURE__ */ E.createElement(A.Consumer, null)) ? A : y;
      }, [A, y]), S = Mt(M), B = !!J.store && !!J.store.getState && !!J.store.dispatch, G = !!S && !!S.store;
      if (process.env.NODE_ENV !== "production" && !B && !G)
        throw new Error('Could not find "store" in the context of ' + ('"' + T + '". Either wrap the root component in a <Provider>, ') + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + T + " in connect options."));
      var U = B ? J.store : S.store, H = Tr(function() {
        return F(U);
      }, [U]), k = Tr(function() {
        if (!u)
          return UT;
        var Ye = xm(U, B ? null : S.subscription), Ct = Ye.notifyNestedSubs.bind(Ye);
        return [Ye, Ct];
      }, [U, B, S]), L = k[0], W = k[1], V = Tr(function() {
        return B ? S : Ce({}, S, {
          subscription: L
        });
      }, [B, S, L]), D = gw(qT, zT, KT), Q = D[0], z = Q[0], te = D[1];
      if (z && z.error)
        throw z.error;
      var ne = ve(), ae = ve(N), se = ve(), pe = ve(!1), ue = $(function() {
        return se.current && N === ae.current ? se.current : H(U.getState(), N);
      }, [U, z, N]);
      V7(GT, [ae, ne, pe, N, ue, se, W]), V7(YT, [u, U, L, H, ae, ne, pe, se, W, te], [U, L, H]);
      var Te = Tr(function() {
        return /* @__PURE__ */ E.createElement(P, Ce({}, ue, {
          ref: _
        }));
      }, [_, P, ue]), Be = Tr(function() {
        return u ? /* @__PURE__ */ E.createElement(M.Provider, {
          value: V
        }, Te) : Te;
      }, [M, Te, V]);
      return Be;
    }
    var X = R ? E.memo(Z) : Z;
    if (X.WrappedComponent = P, X.displayName = Z.displayName = T, g) {
      var K = E.forwardRef(function(ee, A) {
        return /* @__PURE__ */ E.createElement(X, Ce({}, ee, {
          reactReduxForwardedRef: A
        }));
      });
      return K.displayName = T, K.WrappedComponent = P, L7(K, P);
    }
    return L7(X, P);
  };
}
function H7(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function D2(e, t) {
  if (H7(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  var r = Object.keys(e), n = Object.keys(t);
  if (r.length !== n.length)
    return !1;
  for (var a = 0; a < r.length; a++)
    if (!Object.prototype.hasOwnProperty.call(t, r[a]) || !H7(e[r[a]], t[r[a]]))
      return !1;
  return !0;
}
function QT(e, t) {
  var r = {}, n = function(o) {
    var s = e[o];
    typeof s == "function" && (r[o] = function() {
      return t(s.apply(void 0, arguments));
    });
  };
  for (var a in e)
    n(a);
  return r;
}
function JT(e) {
  if (typeof e != "object" || e === null)
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t === null)
    return !0;
  for (var r = t; Object.getPrototypeOf(r) !== null; )
    r = Object.getPrototypeOf(r);
  return t === r;
}
function Em(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function jm(e, t, r) {
  JT(e) || Em(r + "() in " + t + " must return a plain object. Instead received " + e + ".");
}
function Od(e) {
  return function(r, n) {
    var a = e(r, n);
    function i() {
      return a;
    }
    return i.dependsOnOwnProps = !1, i;
  };
}
function F7(e) {
  return e.dependsOnOwnProps !== null && e.dependsOnOwnProps !== void 0 ? !!e.dependsOnOwnProps : e.length !== 1;
}
function _m(e, t) {
  return function(n, a) {
    var i = a.displayName, o = function(l, c) {
      return o.dependsOnOwnProps ? o.mapToProps(l, c) : o.mapToProps(l);
    };
    return o.dependsOnOwnProps = !0, o.mapToProps = function(l, c) {
      o.mapToProps = e, o.dependsOnOwnProps = F7(e);
      var u = o(l, c);
      return typeof u == "function" && (o.mapToProps = u, o.dependsOnOwnProps = F7(u), u = o(l, c)), process.env.NODE_ENV !== "production" && jm(u, i, t), u;
    }, o;
  };
}
function e$(e) {
  return typeof e == "function" ? _m(e, "mapDispatchToProps") : void 0;
}
function t$(e) {
  return e ? void 0 : Od(function(t) {
    return {
      dispatch: t
    };
  });
}
function r$(e) {
  return e && typeof e == "object" ? Od(function(t) {
    return QT(e, t);
  }) : void 0;
}
const n$ = [e$, t$, r$];
function a$(e) {
  return typeof e == "function" ? _m(e, "mapStateToProps") : void 0;
}
function i$(e) {
  return e ? void 0 : Od(function() {
    return {};
  });
}
const o$ = [a$, i$];
function s$(e, t, r) {
  return Ce({}, r, e, t);
}
function l$(e) {
  return function(r, n) {
    var a = n.displayName, i = n.pure, o = n.areMergedPropsEqual, s = !1, l;
    return function(u, d, p) {
      var h = e(u, d, p);
      return s ? (!i || !o(h, l)) && (l = h) : (s = !0, l = h, process.env.NODE_ENV !== "production" && jm(l, a, "mergeProps")), l;
    };
  };
}
function c$(e) {
  return typeof e == "function" ? l$(e) : void 0;
}
function u$(e) {
  return e ? void 0 : function() {
    return s$;
  };
}
const f$ = [c$, u$];
function M2(e, t, r) {
  if (e)
    (t === "mapStateToProps" || t === "mapDispatchToProps") && (Object.prototype.hasOwnProperty.call(e, "dependsOnOwnProps") || Em("The selector for " + t + " of " + r + " did not specify a value for dependsOnOwnProps."));
  else
    throw new Error("Unexpected value for " + t + " in " + r + ".");
}
function d$(e, t, r, n) {
  M2(e, "mapStateToProps", n), M2(t, "mapDispatchToProps", n), M2(r, "mergeProps", n);
}
var p$ = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function h$(e, t, r, n) {
  return function(i, o) {
    return r(e(i, o), t(n, o), o);
  };
}
function v$(e, t, r, n, a) {
  var i = a.areStatesEqual, o = a.areOwnPropsEqual, s = a.areStatePropsEqual, l = !1, c, u, d, p, h;
  function m(w, x) {
    return c = w, u = x, d = e(c, u), p = t(n, u), h = r(d, p, u), l = !0, h;
  }
  function v() {
    return d = e(c, u), t.dependsOnOwnProps && (p = t(n, u)), h = r(d, p, u), h;
  }
  function g() {
    return e.dependsOnOwnProps && (d = e(c, u)), t.dependsOnOwnProps && (p = t(n, u)), h = r(d, p, u), h;
  }
  function b() {
    var w = e(c, u), x = !s(w, d);
    return d = w, x && (h = r(d, p, u)), h;
  }
  function C(w, x) {
    var y = !o(x, u), O = !i(w, c, x, u);
    return c = w, u = x, y && O ? v() : y ? g() : O ? b() : h;
  }
  return function(x, y) {
    return l ? C(x, y) : m(x, y);
  };
}
function m$(e, t) {
  var r = t.initMapStateToProps, n = t.initMapDispatchToProps, a = t.initMergeProps, i = Hl(t, p$), o = r(e, i), s = n(e, i), l = a(e, i);
  process.env.NODE_ENV !== "production" && d$(o, s, l, i.displayName);
  var c = i.pure ? v$ : h$;
  return c(o, s, l, e, i);
}
var g$ = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
function T2(e, t, r) {
  for (var n = t.length - 1; n >= 0; n--) {
    var a = t[n](e);
    if (a)
      return a;
  }
  return function(i, o) {
    throw new Error("Invalid value of type " + typeof e + " for " + r + " argument when connecting component " + o.wrappedComponentName + ".");
  };
}
function y$(e, t) {
  return e === t;
}
function b$(e) {
  var t = e === void 0 ? {} : e, r = t.connectHOC, n = r === void 0 ? XT : r, a = t.mapStateToPropsFactories, i = a === void 0 ? o$ : a, o = t.mapDispatchToPropsFactories, s = o === void 0 ? n$ : o, l = t.mergePropsFactories, c = l === void 0 ? f$ : l, u = t.selectorFactory, d = u === void 0 ? m$ : u;
  return function(h, m, v, g) {
    g === void 0 && (g = {});
    var b = g, C = b.pure, w = C === void 0 ? !0 : C, x = b.areStatesEqual, y = x === void 0 ? y$ : x, O = b.areOwnPropsEqual, P = O === void 0 ? D2 : O, j = b.areStatePropsEqual, T = j === void 0 ? D2 : j, I = b.areMergedPropsEqual, R = I === void 0 ? D2 : I, F = Hl(b, g$), $ = T2(h, i, "mapStateToProps"), Z = T2(m, s, "mapDispatchToProps"), X = T2(v, c, "mergeProps");
    return n(d, Ce({
      // used in error messages
      methodName: "connect",
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function(J) {
        return "Connect(" + J + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: !!h,
      // passed through to selectorFactory
      initMapStateToProps: $,
      initMapDispatchToProps: Z,
      initMergeProps: X,
      pure: w,
      areStatesEqual: y,
      areOwnPropsEqual: P,
      areStatePropsEqual: T,
      areMergedPropsEqual: R
    }, F));
  };
}
const Am = /* @__PURE__ */ b$();
ET(xw);
function C$(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function Dm(e, t) {
  var r = ye(function() {
    return {
      inputs: t,
      result: e()
    };
  })[0], n = ve(!0), a = ve(r), i = n.current || !!(t && a.current.inputs && C$(t, a.current.inputs)), o = i ? a.current : {
    inputs: t,
    result: e()
  };
  return _e(function() {
    n.current = !1, a.current = o;
  }, [o]), o.result;
}
function x$(e, t) {
  return Dm(function() {
    return e;
  }, t);
}
var He = Dm, ge = x$, w$ = process.env.NODE_ENV === "production", $2 = "Invariant failed";
function Qt(e, t) {
  if (!e) {
    if (w$)
      throw new Error($2);
    var r = typeof t == "function" ? t() : t, n = r ? "".concat($2, ": ").concat(r) : $2;
    throw new Error(n);
  }
}
var Gr = function(t) {
  var r = t.top, n = t.right, a = t.bottom, i = t.left, o = n - i, s = a - r, l = {
    top: r,
    right: n,
    bottom: a,
    left: i,
    width: o,
    height: s,
    x: i,
    y: r,
    center: {
      x: (n + i) / 2,
      y: (a + r) / 2
    }
  };
  return l;
}, Sd = function(t, r) {
  return {
    top: t.top - r.top,
    left: t.left - r.left,
    bottom: t.bottom + r.bottom,
    right: t.right + r.right
  };
}, W7 = function(t, r) {
  return {
    top: t.top + r.top,
    left: t.left + r.left,
    bottom: t.bottom - r.bottom,
    right: t.right - r.right
  };
}, O$ = function(t, r) {
  return {
    top: t.top + r.y,
    left: t.left + r.x,
    bottom: t.bottom + r.y,
    right: t.right + r.x
  };
}, N2 = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, Pd = function(t) {
  var r = t.borderBox, n = t.margin, a = n === void 0 ? N2 : n, i = t.border, o = i === void 0 ? N2 : i, s = t.padding, l = s === void 0 ? N2 : s, c = Gr(Sd(r, a)), u = Gr(W7(r, o)), d = Gr(W7(u, l));
  return {
    marginBox: c,
    borderBox: Gr(r),
    paddingBox: u,
    contentBox: d,
    margin: a,
    border: o,
    padding: l
  };
}, jr = function(t) {
  var r = t.slice(0, -2), n = t.slice(-2);
  if (n !== "px")
    return 0;
  var a = Number(r);
  return isNaN(a) && (process.env.NODE_ENV !== "production" ? Qt(!1, "Could not parse value [raw: " + t + ", without suffix: " + r + "]") : Qt(!1)), a;
}, S$ = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
}, Fl = function(t, r) {
  var n = t.borderBox, a = t.border, i = t.margin, o = t.padding, s = O$(n, r);
  return Pd({
    borderBox: s,
    border: a,
    margin: i,
    padding: o
  });
}, Wl = function(t, r) {
  return r === void 0 && (r = S$()), Fl(t, r);
}, Mm = function(t, r) {
  var n = {
    top: jr(r.marginTop),
    right: jr(r.marginRight),
    bottom: jr(r.marginBottom),
    left: jr(r.marginLeft)
  }, a = {
    top: jr(r.paddingTop),
    right: jr(r.paddingRight),
    bottom: jr(r.paddingBottom),
    left: jr(r.paddingLeft)
  }, i = {
    top: jr(r.borderTopWidth),
    right: jr(r.borderRightWidth),
    bottom: jr(r.borderBottomWidth),
    left: jr(r.borderLeftWidth)
  };
  return Pd({
    borderBox: t,
    margin: n,
    padding: a,
    border: i
  });
}, Tm = function(t) {
  var r = t.getBoundingClientRect(), n = window.getComputedStyle(t);
  return Mm(r, n);
}, z7 = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function P$(e, t) {
  return !!(e === t || z7(e) && z7(t));
}
function E$(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (!P$(e[r], t[r]))
      return !1;
  return !0;
}
function Ut(e, t) {
  t === void 0 && (t = E$);
  var r, n = [], a, i = !1;
  function o() {
    for (var s = [], l = 0; l < arguments.length; l++)
      s[l] = arguments[l];
    return i && r === this && t(s, n) || (a = e.apply(this, s), i = !0, r = this, n = s), a;
  }
  return o;
}
var j$ = function(t) {
  var r = [], n = null, a = function() {
    for (var o = arguments.length, s = new Array(o), l = 0; l < o; l++)
      s[l] = arguments[l];
    r = s, !n && (n = requestAnimationFrame(function() {
      n = null, t.apply(void 0, r);
    }));
  };
  return a.cancel = function() {
    n && (cancelAnimationFrame(n), n = null);
  }, a;
};
const Ns = j$;
var _$ = process.env.NODE_ENV === "production", A$ = /[ \t]{2,}/g, D$ = /^[ \t]*/gm, U7 = function(t) {
  return t.replace(A$, " ").replace(D$, "").trim();
}, M$ = function(t) {
  return U7(`
  %creact-beautiful-dnd

  %c` + U7(t) + `

  %c👷‍ This is a development only message. It will be removed in production builds.
`);
}, T$ = function(t) {
  return [M$(t), "color: #00C584; font-size: 1.2em; font-weight: bold;", "line-height: 1.5", "color: #723874;"];
}, $$ = "__react-beautiful-dnd-disable-dev-warnings";
function $m(e, t) {
  var r;
  _$ || typeof window < "u" && window[$$] || (r = console)[e].apply(r, T$(t));
}
var pt = $m.bind(null, "warn"), t0 = $m.bind(null, "error");
function ea() {
}
function N$(e, t) {
  return Ce({}, e, {}, t);
}
function Nr(e, t, r) {
  var n = t.map(function(a) {
    var i = N$(r, a.options);
    return e.addEventListener(a.eventName, a.fn, i), function() {
      e.removeEventListener(a.eventName, a.fn, i);
    };
  });
  return function() {
    n.forEach(function(i) {
      i();
    });
  };
}
var I$ = process.env.NODE_ENV === "production", Z7 = "Invariant failed";
function Is(e) {
  this.message = e;
}
Is.prototype.toString = function() {
  return this.message;
};
function Y(e, t) {
  if (!e)
    throw I$ ? new Is(Z7) : new Is(Z7 + ": " + (t || ""));
}
var L$ = function(e) {
  gm(t, e);
  function t() {
    for (var n, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(i)) || this, n.callbacks = null, n.unbind = ea, n.onWindowError = function(s) {
      var l = n.getCallbacks();
      l.isDragging() && (l.tryAbort(), process.env.NODE_ENV !== "production" && pt(`
        An error was caught by our window 'error' event listener while a drag was occurring.
        The active drag has been aborted.
      `));
      var c = s.error;
      c instanceof Is && (s.preventDefault(), process.env.NODE_ENV !== "production" && t0(c.message));
    }, n.getCallbacks = function() {
      if (!n.callbacks)
        throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
      return n.callbacks;
    }, n.setCallbacks = function(s) {
      n.callbacks = s;
    }, n;
  }
  var r = t.prototype;
  return r.componentDidMount = function() {
    this.unbind = Nr(window, [{
      eventName: "error",
      fn: this.onWindowError
    }]);
  }, r.componentDidCatch = function(a) {
    if (a instanceof Is) {
      process.env.NODE_ENV !== "production" && t0(a.message), this.setState({});
      return;
    }
    throw a;
  }, r.componentWillUnmount = function() {
    this.unbind();
  }, r.render = function() {
    return this.props.children(this.setCallbacks);
  }, t;
}(E.Component), k$ = `
  Press space bar to start a drag.
  When dragging you can use the arrow keys to move the item around and escape to cancel.
  Some screen readers may require you to be in focus mode or to use your pass through key
`, zl = function(t) {
  return t + 1;
}, R$ = function(t) {
  return `
  You have lifted an item in position ` + zl(t.source.index) + `
`;
}, Nm = function(t, r) {
  var n = t.droppableId === r.droppableId, a = zl(t.index), i = zl(r.index);
  return n ? `
      You have moved the item from position ` + a + `
      to position ` + i + `
    ` : `
    You have moved the item from position ` + a + `
    in list ` + t.droppableId + `
    to list ` + r.droppableId + `
    in position ` + i + `
  `;
}, Im = function(t, r, n) {
  var a = r.droppableId === n.droppableId;
  return a ? `
      The item ` + t + `
      has been combined with ` + n.draggableId : `
      The item ` + t + `
      in list ` + r.droppableId + `
      has been combined with ` + n.draggableId + `
      in list ` + n.droppableId + `
    `;
}, B$ = function(t) {
  var r = t.destination;
  if (r)
    return Nm(t.source, r);
  var n = t.combine;
  return n ? Im(t.draggableId, t.source, n) : "You are over an area that cannot be dropped on";
}, q7 = function(t) {
  return `
  The item has returned to its starting position
  of ` + zl(t.index) + `
`;
}, V$ = function(t) {
  if (t.reason === "CANCEL")
    return `
      Movement cancelled.
      ` + q7(t.source) + `
    `;
  var r = t.destination, n = t.combine;
  return r ? `
      You have dropped the item.
      ` + Nm(t.source, r) + `
    ` : n ? `
      You have dropped the item.
      ` + Im(t.draggableId, t.source, n) + `
    ` : `
    The item has been dropped while not over a drop area.
    ` + q7(t.source) + `
  `;
}, Cl = {
  dragHandleUsageInstructions: k$,
  onDragStart: R$,
  onDragUpdate: B$,
  onDragEnd: V$
}, Zt = {
  x: 0,
  y: 0
}, Yt = function(t, r) {
  return {
    x: t.x + r.x,
    y: t.y + r.y
  };
}, xr = function(t, r) {
  return {
    x: t.x - r.x,
    y: t.y - r.y
  };
}, ta = function(t, r) {
  return t.x === r.x && t.y === r.y;
}, Oo = function(t) {
  return {
    x: t.x !== 0 ? -t.x : 0,
    y: t.y !== 0 ? -t.y : 0
  };
}, Xa = function(t, r, n) {
  var a;
  return n === void 0 && (n = 0), a = {}, a[t] = r, a[t === "x" ? "y" : "x"] = n, a;
}, Ls = function(t, r) {
  return Math.sqrt(Math.pow(r.x - t.x, 2) + Math.pow(r.y - t.y, 2));
}, G7 = function(t, r) {
  return Math.min.apply(Math, r.map(function(n) {
    return Ls(t, n);
  }));
}, Lm = function(t) {
  return function(r) {
    return {
      x: t(r.x),
      y: t(r.y)
    };
  };
}, H$ = function(e, t) {
  var r = Gr({
    top: Math.max(t.top, e.top),
    right: Math.min(t.right, e.right),
    bottom: Math.min(t.bottom, e.bottom),
    left: Math.max(t.left, e.left)
  });
  return r.width <= 0 || r.height <= 0 ? null : r;
}, j1 = function(t, r) {
  return {
    top: t.top + r.y,
    left: t.left + r.x,
    bottom: t.bottom + r.y,
    right: t.right + r.x
  };
}, Y7 = function(t) {
  return [{
    x: t.left,
    y: t.top
  }, {
    x: t.right,
    y: t.top
  }, {
    x: t.left,
    y: t.bottom
  }, {
    x: t.right,
    y: t.bottom
  }];
}, F$ = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, W$ = function(t, r) {
  return r ? j1(t, r.scroll.diff.displacement) : t;
}, z$ = function(t, r, n) {
  if (n && n.increasedBy) {
    var a;
    return Ce({}, t, (a = {}, a[r.end] = t[r.end] + n.increasedBy[r.line], a));
  }
  return t;
}, U$ = function(t, r) {
  return r && r.shouldClipSubject ? H$(r.pageMarginBox, t) : Gr(t);
}, Ri = function(e) {
  var t = e.page, r = e.withPlaceholder, n = e.axis, a = e.frame, i = W$(t.marginBox, a), o = z$(i, n, r), s = U$(o, a);
  return {
    page: t,
    withPlaceholder: r,
    active: s
  };
}, Ed = function(e, t) {
  e.frame || (process.env.NODE_ENV, Y(!1));
  var r = e.frame, n = xr(t, r.scroll.initial), a = Oo(n), i = Ce({}, r, {
    scroll: {
      initial: r.scroll.initial,
      current: t,
      diff: {
        value: n,
        displacement: a
      },
      max: r.scroll.max
    }
  }), o = Ri({
    page: e.subject.page,
    withPlaceholder: e.subject.withPlaceholder,
    axis: e.axis,
    frame: i
  }), s = Ce({}, e, {
    frame: i,
    subject: o
  });
  return s;
};
function Z$(e) {
  return Number.isInteger ? Number.isInteger(e) : typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
function Ul(e) {
  return Object.values ? Object.values(e) : Object.keys(e).map(function(t) {
    return e[t];
  });
}
function jd(e, t) {
  if (e.findIndex)
    return e.findIndex(t);
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
  return -1;
}
function ha(e, t) {
  if (e.find)
    return e.find(t);
  var r = jd(e, t);
  if (r !== -1)
    return e[r];
}
function km(e) {
  return Array.prototype.slice.call(e);
}
var Rm = Ut(function(e) {
  return e.reduce(function(t, r) {
    return t[r.descriptor.id] = r, t;
  }, {});
}), Bm = Ut(function(e) {
  return e.reduce(function(t, r) {
    return t[r.descriptor.id] = r, t;
  }, {});
}), mu = Ut(function(e) {
  return Ul(e);
}), q$ = Ut(function(e) {
  return Ul(e);
}), ni = Ut(function(e, t) {
  var r = q$(t).filter(function(n) {
    return e === n.descriptor.droppableId;
  }).sort(function(n, a) {
    return n.descriptor.index - a.descriptor.index;
  });
  return r;
});
function _d(e) {
  return e.at && e.at.type === "REORDER" ? e.at.destination : null;
}
function gu(e) {
  return e.at && e.at.type === "COMBINE" ? e.at.combine : null;
}
var yu = Ut(function(e, t) {
  return t.filter(function(r) {
    return r.descriptor.id !== e.descriptor.id;
  });
}), G$ = function(e) {
  var t = e.isMovingForward, r = e.draggable, n = e.destination, a = e.insideDestination, i = e.previousImpact;
  if (!n.isCombineEnabled)
    return null;
  var o = _d(i);
  if (!o)
    return null;
  function s(v) {
    var g = {
      type: "COMBINE",
      combine: {
        draggableId: v,
        droppableId: n.descriptor.id
      }
    };
    return Ce({}, i, {
      at: g
    });
  }
  var l = i.displaced.all, c = l.length ? l[0] : null;
  if (t)
    return c ? s(c) : null;
  var u = yu(r, a);
  if (!c) {
    if (!u.length)
      return null;
    var d = u[u.length - 1];
    return s(d.descriptor.id);
  }
  var p = jd(u, function(v) {
    return v.descriptor.id === c;
  });
  p === -1 && (process.env.NODE_ENV !== "production" ? Y(!1, "Could not find displaced item in set") : Y(!1));
  var h = p - 1;
  if (h < 0)
    return null;
  var m = u[h];
  return s(m.descriptor.id);
}, So = function(e, t) {
  return e.descriptor.droppableId === t.descriptor.id;
}, Vm = {
  point: Zt,
  value: 0
}, ks = {
  invisible: {},
  visible: {},
  all: []
}, Y$ = {
  displaced: ks,
  displacedBy: Vm,
  at: null
}, Lr = function(e, t) {
  return function(r) {
    return e <= r && r <= t;
  };
}, Hm = function(e) {
  var t = Lr(e.top, e.bottom), r = Lr(e.left, e.right);
  return function(n) {
    var a = t(n.top) && t(n.bottom) && r(n.left) && r(n.right);
    if (a)
      return !0;
    var i = t(n.top) || t(n.bottom), o = r(n.left) || r(n.right), s = i && o;
    if (s)
      return !0;
    var l = n.top < e.top && n.bottom > e.bottom, c = n.left < e.left && n.right > e.right, u = l && c;
    if (u)
      return !0;
    var d = l && o || c && i;
    return d;
  };
}, K$ = function(e) {
  var t = Lr(e.top, e.bottom), r = Lr(e.left, e.right);
  return function(n) {
    var a = t(n.top) && t(n.bottom) && r(n.left) && r(n.right);
    return a;
  };
}, Ad = {
  direction: "vertical",
  line: "y",
  crossAxisLine: "x",
  start: "top",
  end: "bottom",
  size: "height",
  crossAxisStart: "left",
  crossAxisEnd: "right",
  crossAxisSize: "width"
}, Fm = {
  direction: "horizontal",
  line: "x",
  crossAxisLine: "y",
  start: "left",
  end: "right",
  size: "width",
  crossAxisStart: "top",
  crossAxisEnd: "bottom",
  crossAxisSize: "height"
}, X$ = function(e) {
  return function(t) {
    var r = Lr(t.top, t.bottom), n = Lr(t.left, t.right);
    return function(a) {
      return e === Ad ? r(a.top) && r(a.bottom) : n(a.left) && n(a.right);
    };
  };
}, Q$ = function(t, r) {
  var n = r.frame ? r.frame.scroll.diff.displacement : Zt;
  return j1(t, n);
}, J$ = function(t, r, n) {
  return r.subject.active ? n(r.subject.active)(t) : !1;
}, eN = function(t, r, n) {
  return n(r)(t);
}, Dd = function(t) {
  var r = t.target, n = t.destination, a = t.viewport, i = t.withDroppableDisplacement, o = t.isVisibleThroughFrameFn, s = i ? Q$(r, n) : r;
  return J$(s, n, o) && eN(s, a, o);
}, tN = function(t) {
  return Dd(Ce({}, t, {
    isVisibleThroughFrameFn: Hm
  }));
}, Wm = function(t) {
  return Dd(Ce({}, t, {
    isVisibleThroughFrameFn: K$
  }));
}, rN = function(t) {
  return Dd(Ce({}, t, {
    isVisibleThroughFrameFn: X$(t.destination.axis)
  }));
}, nN = function(t, r, n) {
  if (typeof n == "boolean")
    return n;
  if (!r)
    return !0;
  var a = r.invisible, i = r.visible;
  if (a[t])
    return !1;
  var o = i[t];
  return o ? o.shouldAnimate : !0;
};
function aN(e, t) {
  var r = e.page.marginBox, n = {
    top: t.point.y,
    right: 0,
    bottom: 0,
    left: t.point.x
  };
  return Gr(Sd(r, n));
}
function Rs(e) {
  var t = e.afterDragging, r = e.destination, n = e.displacedBy, a = e.viewport, i = e.forceShouldAnimate, o = e.last;
  return t.reduce(function(l, c) {
    var u = aN(c, n), d = c.descriptor.id;
    l.all.push(d);
    var p = tN({
      target: u,
      destination: r,
      viewport: a,
      withDroppableDisplacement: !0
    });
    if (!p)
      return l.invisible[c.descriptor.id] = !0, l;
    var h = nN(d, o, i), m = {
      draggableId: d,
      shouldAnimate: h
    };
    return l.visible[d] = m, l;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}
function iN(e, t) {
  if (!e.length)
    return 0;
  var r = e[e.length - 1].descriptor.index;
  return t.inHomeList ? r : r + 1;
}
function K7(e) {
  var t = e.insideDestination, r = e.inHomeList, n = e.displacedBy, a = e.destination, i = iN(t, {
    inHomeList: r
  });
  return {
    displaced: ks,
    displacedBy: n,
    at: {
      type: "REORDER",
      destination: {
        droppableId: a.descriptor.id,
        index: i
      }
    }
  };
}
function Zl(e) {
  var t = e.draggable, r = e.insideDestination, n = e.destination, a = e.viewport, i = e.displacedBy, o = e.last, s = e.index, l = e.forceShouldAnimate, c = So(t, n);
  if (s == null)
    return K7({
      insideDestination: r,
      inHomeList: c,
      displacedBy: i,
      destination: n
    });
  var u = ha(r, function(v) {
    return v.descriptor.index === s;
  });
  if (!u)
    return K7({
      insideDestination: r,
      inHomeList: c,
      displacedBy: i,
      destination: n
    });
  var d = yu(t, r), p = r.indexOf(u), h = d.slice(p), m = Rs({
    afterDragging: h,
    destination: n,
    displacedBy: i,
    last: o,
    viewport: a.frame,
    forceShouldAnimate: l
  });
  return {
    displaced: m,
    displacedBy: i,
    at: {
      type: "REORDER",
      destination: {
        droppableId: n.descriptor.id,
        index: s
      }
    }
  };
}
function oa(e, t) {
  return !!t.effected[e];
}
var oN = function(e) {
  var t = e.isMovingForward, r = e.destination, n = e.draggables, a = e.combine, i = e.afterCritical;
  if (!r.isCombineEnabled)
    return null;
  var o = a.draggableId, s = n[o], l = s.descriptor.index, c = oa(o, i);
  return c ? t ? l : l - 1 : t ? l + 1 : l;
}, sN = function(e) {
  var t = e.isMovingForward, r = e.isInHomeList, n = e.insideDestination, a = e.location;
  if (!n.length)
    return null;
  var i = a.index, o = t ? i + 1 : i - 1, s = n[0].descriptor.index, l = n[n.length - 1].descriptor.index, c = r ? l : l + 1;
  return o < s || o > c ? null : o;
}, lN = function(e) {
  var t = e.isMovingForward, r = e.isInHomeList, n = e.draggable, a = e.draggables, i = e.destination, o = e.insideDestination, s = e.previousImpact, l = e.viewport, c = e.afterCritical, u = s.at;
  if (u || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot move in direction without previous impact location") : Y(!1)), u.type === "REORDER") {
    var d = sN({
      isMovingForward: t,
      isInHomeList: r,
      location: u.destination,
      insideDestination: o
    });
    return d == null ? null : Zl({
      draggable: n,
      insideDestination: o,
      destination: i,
      viewport: l,
      last: s.displaced,
      displacedBy: s.displacedBy,
      index: d
    });
  }
  var p = oN({
    isMovingForward: t,
    destination: i,
    displaced: s.displaced,
    draggables: a,
    combine: u.combine,
    afterCritical: c
  });
  return p == null ? null : Zl({
    draggable: n,
    insideDestination: o,
    destination: i,
    viewport: l,
    last: s.displaced,
    displacedBy: s.displacedBy,
    index: p
  });
}, cN = function(e) {
  var t = e.displaced, r = e.afterCritical, n = e.combineWith, a = e.displacedBy, i = !!(t.visible[n] || t.invisible[n]);
  return oa(n, r) ? i ? Zt : Oo(a.point) : i ? a.point : Zt;
}, uN = function(e) {
  var t = e.afterCritical, r = e.impact, n = e.draggables, a = gu(r);
  a || (process.env.NODE_ENV, Y(!1));
  var i = a.draggableId, o = n[i].page.borderBox.center, s = cN({
    displaced: r.displaced,
    afterCritical: t,
    combineWith: i,
    displacedBy: r.displacedBy
  });
  return Yt(o, s);
}, zm = function(t, r) {
  return r.margin[t.start] + r.borderBox[t.size] / 2;
}, fN = function(t, r) {
  return r.margin[t.end] + r.borderBox[t.size] / 2;
}, Md = function(t, r, n) {
  return r[t.crossAxisStart] + n.margin[t.crossAxisStart] + n.borderBox[t.crossAxisSize] / 2;
}, X7 = function(t) {
  var r = t.axis, n = t.moveRelativeTo, a = t.isMoving;
  return Xa(r.line, n.marginBox[r.end] + zm(r, a), Md(r, n.marginBox, a));
}, Q7 = function(t) {
  var r = t.axis, n = t.moveRelativeTo, a = t.isMoving;
  return Xa(r.line, n.marginBox[r.start] - fN(r, a), Md(r, n.marginBox, a));
}, dN = function(t) {
  var r = t.axis, n = t.moveInto, a = t.isMoving;
  return Xa(r.line, n.contentBox[r.start] + zm(r, a), Md(r, n.contentBox, a));
}, pN = function(e) {
  var t = e.impact, r = e.draggable, n = e.draggables, a = e.droppable, i = e.afterCritical, o = ni(a.descriptor.id, n), s = r.page, l = a.axis;
  if (!o.length)
    return dN({
      axis: l,
      moveInto: a.page,
      isMoving: s
    });
  var c = t.displaced, u = t.displacedBy, d = c.all[0];
  if (d) {
    var p = n[d];
    if (oa(d, i))
      return Q7({
        axis: l,
        moveRelativeTo: p.page,
        isMoving: s
      });
    var h = Fl(p.page, u.point);
    return Q7({
      axis: l,
      moveRelativeTo: h,
      isMoving: s
    });
  }
  var m = o[o.length - 1];
  if (m.descriptor.id === r.descriptor.id)
    return s.borderBox.center;
  if (oa(m.descriptor.id, i)) {
    var v = Fl(m.page, Oo(i.displacedBy.point));
    return X7({
      axis: l,
      moveRelativeTo: v,
      isMoving: s
    });
  }
  return X7({
    axis: l,
    moveRelativeTo: m.page,
    isMoving: s
  });
}, r0 = function(e, t) {
  var r = e.frame;
  return r ? Yt(t, r.scroll.diff.displacement) : t;
}, hN = function(t) {
  var r = t.impact, n = t.draggable, a = t.droppable, i = t.draggables, o = t.afterCritical, s = n.page.borderBox.center, l = r.at;
  return !a || !l ? s : l.type === "REORDER" ? pN({
    impact: r,
    draggable: n,
    draggables: i,
    droppable: a,
    afterCritical: o
  }) : uN({
    impact: r,
    draggables: i,
    afterCritical: o
  });
}, bu = function(e) {
  var t = hN(e), r = e.droppable, n = r ? r0(r, t) : t;
  return n;
}, Um = function(e, t) {
  var r = xr(t, e.scroll.initial), n = Oo(r), a = Gr({
    top: t.y,
    bottom: t.y + e.frame.height,
    left: t.x,
    right: t.x + e.frame.width
  }), i = {
    frame: a,
    scroll: {
      initial: e.scroll.initial,
      max: e.scroll.max,
      current: t,
      diff: {
        value: r,
        displacement: n
      }
    }
  };
  return i;
};
function J7(e, t) {
  return e.map(function(r) {
    return t[r];
  });
}
function vN(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r].visible[e];
    if (n)
      return n;
  }
  return null;
}
var mN = function(e) {
  var t = e.impact, r = e.viewport, n = e.destination, a = e.draggables, i = e.maxScrollChange, o = Um(r, Yt(r.scroll.current, i)), s = n.frame ? Ed(n, Yt(n.frame.scroll.current, i)) : n, l = t.displaced, c = Rs({
    afterDragging: J7(l.all, a),
    destination: n,
    displacedBy: t.displacedBy,
    viewport: o.frame,
    last: l,
    forceShouldAnimate: !1
  }), u = Rs({
    afterDragging: J7(l.all, a),
    destination: s,
    displacedBy: t.displacedBy,
    viewport: r.frame,
    last: l,
    forceShouldAnimate: !1
  }), d = {}, p = {}, h = [l, c, u];
  l.all.forEach(function(v) {
    var g = vN(v, h);
    if (g) {
      p[v] = g;
      return;
    }
    d[v] = !0;
  });
  var m = Ce({}, t, {
    displaced: {
      all: l.all,
      invisible: d,
      visible: p
    }
  });
  return m;
}, gN = function(e, t) {
  return Yt(e.scroll.diff.displacement, t);
}, Td = function(e) {
  var t = e.pageBorderBoxCenter, r = e.draggable, n = e.viewport, a = gN(n, t), i = xr(a, r.page.borderBox.center);
  return Yt(r.client.borderBox.center, i);
}, Zm = function(e) {
  var t = e.draggable, r = e.destination, n = e.newPageBorderBoxCenter, a = e.viewport, i = e.withDroppableDisplacement, o = e.onlyOnMainAxis, s = o === void 0 ? !1 : o, l = xr(n, t.page.borderBox.center), c = j1(t.page.borderBox, l), u = {
    target: c,
    destination: r,
    withDroppableDisplacement: i,
    viewport: a
  };
  return s ? rN(u) : Wm(u);
}, yN = function(e) {
  var t = e.isMovingForward, r = e.draggable, n = e.destination, a = e.draggables, i = e.previousImpact, o = e.viewport, s = e.previousPageBorderBoxCenter, l = e.previousClientSelection, c = e.afterCritical;
  if (!n.isEnabled)
    return null;
  var u = ni(n.descriptor.id, a), d = So(r, n), p = G$({
    isMovingForward: t,
    draggable: r,
    destination: n,
    insideDestination: u,
    previousImpact: i
  }) || lN({
    isMovingForward: t,
    isInHomeList: d,
    draggable: r,
    draggables: a,
    destination: n,
    insideDestination: u,
    previousImpact: i,
    viewport: o,
    afterCritical: c
  });
  if (!p)
    return null;
  var h = bu({
    impact: p,
    draggable: r,
    droppable: n,
    draggables: a,
    afterCritical: c
  }), m = Zm({
    draggable: r,
    destination: n,
    newPageBorderBoxCenter: h,
    viewport: o.frame,
    withDroppableDisplacement: !1,
    onlyOnMainAxis: !0
  });
  if (m) {
    var v = Td({
      pageBorderBoxCenter: h,
      draggable: r,
      viewport: o
    });
    return {
      clientSelection: v,
      impact: p,
      scrollJumpRequest: null
    };
  }
  var g = xr(h, s), b = mN({
    impact: p,
    viewport: o,
    destination: n,
    draggables: a,
    maxScrollChange: g
  });
  return {
    clientSelection: l,
    impact: b,
    scrollJumpRequest: g
  };
}, tr = function(t) {
  var r = t.subject.active;
  return r || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot get clipped area from droppable") : Y(!1)), r;
}, bN = function(e) {
  var t = e.isMovingForward, r = e.pageBorderBoxCenter, n = e.source, a = e.droppables, i = e.viewport, o = n.subject.active;
  if (!o)
    return null;
  var s = n.axis, l = Lr(o[s.start], o[s.end]), c = mu(a).filter(function(d) {
    return d !== n;
  }).filter(function(d) {
    return d.isEnabled;
  }).filter(function(d) {
    return !!d.subject.active;
  }).filter(function(d) {
    return Hm(i.frame)(tr(d));
  }).filter(function(d) {
    var p = tr(d);
    return t ? o[s.crossAxisEnd] < p[s.crossAxisEnd] : p[s.crossAxisStart] < o[s.crossAxisStart];
  }).filter(function(d) {
    var p = tr(d), h = Lr(p[s.start], p[s.end]);
    return l(p[s.start]) || l(p[s.end]) || h(o[s.start]) || h(o[s.end]);
  }).sort(function(d, p) {
    var h = tr(d)[s.crossAxisStart], m = tr(p)[s.crossAxisStart];
    return t ? h - m : m - h;
  }).filter(function(d, p, h) {
    return tr(d)[s.crossAxisStart] === tr(h[0])[s.crossAxisStart];
  });
  if (!c.length)
    return null;
  if (c.length === 1)
    return c[0];
  var u = c.filter(function(d) {
    var p = Lr(tr(d)[s.start], tr(d)[s.end]);
    return p(r[s.line]);
  });
  return u.length === 1 ? u[0] : u.length > 1 ? u.sort(function(d, p) {
    return tr(d)[s.start] - tr(p)[s.start];
  })[0] : c.sort(function(d, p) {
    var h = G7(r, Y7(tr(d))), m = G7(r, Y7(tr(p)));
    return h !== m ? h - m : tr(d)[s.start] - tr(p)[s.start];
  })[0];
}, ep = function(t, r) {
  var n = t.page.borderBox.center;
  return oa(t.descriptor.id, r) ? xr(n, r.displacedBy.point) : n;
}, CN = function(t, r) {
  var n = t.page.borderBox;
  return oa(t.descriptor.id, r) ? j1(n, Oo(r.displacedBy.point)) : n;
}, xN = function(e) {
  var t = e.pageBorderBoxCenter, r = e.viewport, n = e.destination, a = e.insideDestination, i = e.afterCritical, o = a.filter(function(s) {
    return Wm({
      target: CN(s, i),
      destination: n,
      viewport: r.frame,
      withDroppableDisplacement: !0
    });
  }).sort(function(s, l) {
    var c = Ls(t, r0(n, ep(s, i))), u = Ls(t, r0(n, ep(l, i)));
    return c < u ? -1 : u < c ? 1 : s.descriptor.index - l.descriptor.index;
  });
  return o[0] || null;
}, _1 = Ut(function(t, r) {
  var n = r[t.line];
  return {
    value: n,
    point: Xa(t.line, n)
  };
}), wN = function(t, r, n) {
  var a = t.axis;
  if (t.descriptor.mode === "virtual")
    return Xa(a.line, r[a.line]);
  var i = t.subject.page.contentBox[a.size], o = ni(t.descriptor.id, n), s = o.reduce(function(u, d) {
    return u + d.client.marginBox[a.size];
  }, 0), l = s + r[a.line], c = l - i;
  return c <= 0 ? null : Xa(a.line, c);
}, qm = function(t, r) {
  return Ce({}, t, {
    scroll: Ce({}, t.scroll, {
      max: r
    })
  });
}, Gm = function(t, r, n) {
  var a = t.frame;
  So(r, t) && (process.env.NODE_ENV !== "production" ? Y(!1, "Should not add placeholder space to home list") : Y(!1)), t.subject.withPlaceholder && (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot add placeholder size to a subject when it already has one") : Y(!1));
  var i = _1(t.axis, r.displaceBy).point, o = wN(t, i, n), s = {
    placeholderSize: i,
    increasedBy: o,
    oldFrameMaxScroll: t.frame ? t.frame.scroll.max : null
  };
  if (!a) {
    var l = Ri({
      page: t.subject.page,
      withPlaceholder: s,
      axis: t.axis,
      frame: t.frame
    });
    return Ce({}, t, {
      subject: l
    });
  }
  var c = o ? Yt(a.scroll.max, o) : a.scroll.max, u = qm(a, c), d = Ri({
    page: t.subject.page,
    withPlaceholder: s,
    axis: t.axis,
    frame: u
  });
  return Ce({}, t, {
    subject: d,
    frame: u
  });
}, ON = function(t) {
  var r = t.subject.withPlaceholder;
  r || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot remove placeholder form subject when there was none") : Y(!1));
  var n = t.frame;
  if (!n) {
    var a = Ri({
      page: t.subject.page,
      axis: t.axis,
      frame: null,
      withPlaceholder: null
    });
    return Ce({}, t, {
      subject: a
    });
  }
  var i = r.oldFrameMaxScroll;
  i || (process.env.NODE_ENV !== "production" ? Y(!1, "Expected droppable with frame to have old max frame scroll when removing placeholder") : Y(!1));
  var o = qm(n, i), s = Ri({
    page: t.subject.page,
    axis: t.axis,
    frame: o,
    withPlaceholder: null
  });
  return Ce({}, t, {
    subject: s,
    frame: o
  });
}, SN = function(e) {
  var t = e.previousPageBorderBoxCenter, r = e.moveRelativeTo, n = e.insideDestination, a = e.draggable, i = e.draggables, o = e.destination, s = e.viewport, l = e.afterCritical;
  if (!r) {
    if (n.length)
      return null;
    var c = {
      displaced: ks,
      displacedBy: Vm,
      at: {
        type: "REORDER",
        destination: {
          droppableId: o.descriptor.id,
          index: 0
        }
      }
    }, u = bu({
      impact: c,
      draggable: a,
      droppable: o,
      draggables: i,
      afterCritical: l
    }), d = So(a, o) ? o : Gm(o, a, i), p = Zm({
      draggable: a,
      destination: d,
      newPageBorderBoxCenter: u,
      viewport: s.frame,
      withDroppableDisplacement: !1,
      onlyOnMainAxis: !0
    });
    return p ? c : null;
  }
  var h = t[o.axis.line] <= r.page.borderBox.center[o.axis.line], m = function() {
    var g = r.descriptor.index;
    return r.descriptor.id === a.descriptor.id || h ? g : g + 1;
  }(), v = _1(o.axis, a.displaceBy);
  return Zl({
    draggable: a,
    insideDestination: n,
    destination: o,
    viewport: s,
    displacedBy: v,
    last: ks,
    index: m
  });
}, PN = function(e) {
  var t = e.isMovingForward, r = e.previousPageBorderBoxCenter, n = e.draggable, a = e.isOver, i = e.draggables, o = e.droppables, s = e.viewport, l = e.afterCritical, c = bN({
    isMovingForward: t,
    pageBorderBoxCenter: r,
    source: a,
    droppables: o,
    viewport: s
  });
  if (!c)
    return null;
  var u = ni(c.descriptor.id, i), d = xN({
    pageBorderBoxCenter: r,
    viewport: s,
    destination: c,
    insideDestination: u,
    afterCritical: l
  }), p = SN({
    previousPageBorderBoxCenter: r,
    destination: c,
    draggable: n,
    draggables: i,
    moveRelativeTo: d,
    insideDestination: u,
    viewport: s,
    afterCritical: l
  });
  if (!p)
    return null;
  var h = bu({
    impact: p,
    draggable: n,
    droppable: c,
    draggables: i,
    afterCritical: l
  }), m = Td({
    pageBorderBoxCenter: h,
    draggable: n,
    viewport: s
  });
  return {
    clientSelection: m,
    impact: p,
    scrollJumpRequest: null
  };
}, wr = function(e) {
  var t = e.at;
  return t ? t.type === "REORDER" ? t.destination.droppableId : t.combine.droppableId : null;
}, EN = function(t, r) {
  var n = wr(t);
  return n ? r[n] : null;
}, jN = function(e) {
  var t = e.state, r = e.type, n = EN(t.impact, t.dimensions.droppables), a = !!n, i = t.dimensions.droppables[t.critical.droppable.id], o = n || i, s = o.axis.direction, l = s === "vertical" && (r === "MOVE_UP" || r === "MOVE_DOWN") || s === "horizontal" && (r === "MOVE_LEFT" || r === "MOVE_RIGHT");
  if (l && !a)
    return null;
  var c = r === "MOVE_DOWN" || r === "MOVE_RIGHT", u = t.dimensions.draggables[t.critical.draggable.id], d = t.current.page.borderBoxCenter, p = t.dimensions, h = p.draggables, m = p.droppables;
  return l ? yN({
    isMovingForward: c,
    previousPageBorderBoxCenter: d,
    draggable: u,
    destination: o,
    draggables: h,
    viewport: t.viewport,
    previousClientSelection: t.current.client.selection,
    previousImpact: t.impact,
    afterCritical: t.afterCritical
  }) : PN({
    isMovingForward: c,
    previousPageBorderBoxCenter: d,
    draggable: u,
    isOver: o,
    draggables: h,
    droppables: m,
    viewport: t.viewport,
    afterCritical: t.afterCritical
  });
};
function Ta(e) {
  return e.phase === "DRAGGING" || e.phase === "COLLECTING";
}
function Ym(e) {
  var t = Lr(e.top, e.bottom), r = Lr(e.left, e.right);
  return function(a) {
    return t(a.y) && r(a.x);
  };
}
function _N(e, t) {
  return e.left < t.right && e.right > t.left && e.top < t.bottom && e.bottom > t.top;
}
function AN(e) {
  var t = e.pageBorderBox, r = e.draggable, n = e.candidates, a = r.page.borderBox.center, i = n.map(function(o) {
    var s = o.axis, l = Xa(o.axis.line, t.center[s.line], o.page.borderBox.center[s.crossAxisLine]);
    return {
      id: o.descriptor.id,
      distance: Ls(a, l)
    };
  }).sort(function(o, s) {
    return s.distance - o.distance;
  });
  return i[0] ? i[0].id : null;
}
function DN(e) {
  var t = e.pageBorderBox, r = e.draggable, n = e.droppables, a = mu(n).filter(function(i) {
    if (!i.isEnabled)
      return !1;
    var o = i.subject.active;
    if (!o || !_N(t, o))
      return !1;
    if (Ym(o)(t.center))
      return !0;
    var s = i.axis, l = o.center[s.crossAxisLine], c = t[s.crossAxisStart], u = t[s.crossAxisEnd], d = Lr(o[s.crossAxisStart], o[s.crossAxisEnd]), p = d(c), h = d(u);
    return !p && !h ? !0 : p ? c < l : u > l;
  });
  return a.length ? a.length === 1 ? a[0].descriptor.id : AN({
    pageBorderBox: t,
    draggable: r,
    candidates: a
  }) : null;
}
var Km = function(t, r) {
  return Gr(j1(t, r));
}, MN = function(e, t) {
  var r = e.frame;
  return r ? Km(t, r.scroll.diff.value) : t;
};
function Xm(e) {
  var t = e.displaced, r = e.id;
  return !!(t.visible[r] || t.invisible[r]);
}
function TN(e) {
  var t = e.draggable, r = e.closest, n = e.inHomeList;
  return r ? n && r.descriptor.index > t.descriptor.index ? r.descriptor.index - 1 : r.descriptor.index : null;
}
var $N = function(e) {
  var t = e.pageBorderBoxWithDroppableScroll, r = e.draggable, n = e.destination, a = e.insideDestination, i = e.last, o = e.viewport, s = e.afterCritical, l = n.axis, c = _1(n.axis, r.displaceBy), u = c.value, d = t[l.start], p = t[l.end], h = yu(r, a), m = ha(h, function(g) {
    var b = g.descriptor.id, C = g.page.borderBox.center[l.line], w = oa(b, s), x = Xm({
      displaced: i,
      id: b
    });
    return w ? x ? p <= C : d < C - u : x ? p <= C + u : d < C;
  }), v = TN({
    draggable: r,
    closest: m,
    inHomeList: So(r, n)
  });
  return Zl({
    draggable: r,
    insideDestination: a,
    destination: n,
    viewport: o,
    last: i,
    displacedBy: c,
    index: v
  });
}, NN = 4, IN = function(e) {
  var t = e.draggable, r = e.pageBorderBoxWithDroppableScroll, n = e.previousImpact, a = e.destination, i = e.insideDestination, o = e.afterCritical;
  if (!a.isCombineEnabled)
    return null;
  var s = a.axis, l = _1(a.axis, t.displaceBy), c = l.value, u = r[s.start], d = r[s.end], p = yu(t, i), h = ha(p, function(v) {
    var g = v.descriptor.id, b = v.page.borderBox, C = b[s.size], w = C / NN, x = oa(g, o), y = Xm({
      displaced: n.displaced,
      id: g
    });
    return x ? y ? d > b[s.start] + w && d < b[s.end] - w : u > b[s.start] - c + w && u < b[s.end] - c - w : y ? d > b[s.start] + c + w && d < b[s.end] + c - w : u > b[s.start] + w && u < b[s.end] - w;
  });
  if (!h)
    return null;
  var m = {
    displacedBy: l,
    displaced: n.displaced,
    at: {
      type: "COMBINE",
      combine: {
        draggableId: h.descriptor.id,
        droppableId: a.descriptor.id
      }
    }
  };
  return m;
}, Qm = function(e) {
  var t = e.pageOffset, r = e.draggable, n = e.draggables, a = e.droppables, i = e.previousImpact, o = e.viewport, s = e.afterCritical, l = Km(r.page.borderBox, t), c = DN({
    pageBorderBox: l,
    draggable: r,
    droppables: a
  });
  if (!c)
    return Y$;
  var u = a[c], d = ni(u.descriptor.id, n), p = MN(u, l);
  return IN({
    pageBorderBoxWithDroppableScroll: p,
    draggable: r,
    previousImpact: i,
    destination: u,
    insideDestination: d,
    afterCritical: s
  }) || $N({
    pageBorderBoxWithDroppableScroll: p,
    draggable: r,
    destination: u,
    insideDestination: d,
    last: i.displaced,
    viewport: o,
    afterCritical: s
  });
}, $d = function(e, t) {
  var r;
  return Ce({}, e, (r = {}, r[t.descriptor.id] = t, r));
}, LN = function(t) {
  var r = t.previousImpact, n = t.impact, a = t.droppables, i = wr(r), o = wr(n);
  if (!i || i === o)
    return a;
  var s = a[i];
  if (!s.subject.withPlaceholder)
    return a;
  var l = ON(s);
  return $d(a, l);
}, kN = function(e) {
  var t = e.draggable, r = e.draggables, n = e.droppables, a = e.previousImpact, i = e.impact, o = LN({
    previousImpact: a,
    impact: i,
    droppables: n
  }), s = wr(i);
  if (!s)
    return o;
  var l = n[s];
  if (So(t, l) || l.subject.withPlaceholder)
    return o;
  var c = Gm(l, t, r);
  return $d(o, c);
}, gs = function(e) {
  var t = e.state, r = e.clientSelection, n = e.dimensions, a = e.viewport, i = e.impact, o = e.scrollJumpRequest, s = a || t.viewport, l = n || t.dimensions, c = r || t.current.client.selection, u = xr(c, t.initial.client.selection), d = {
    offset: u,
    selection: c,
    borderBoxCenter: Yt(t.initial.client.borderBoxCenter, u)
  }, p = {
    selection: Yt(d.selection, s.scroll.current),
    borderBoxCenter: Yt(d.borderBoxCenter, s.scroll.current),
    offset: Yt(d.offset, s.scroll.diff.value)
  }, h = {
    client: d,
    page: p
  };
  if (t.phase === "COLLECTING")
    return Ce({
      phase: "COLLECTING"
    }, t, {
      dimensions: l,
      viewport: s,
      current: h
    });
  var m = l.draggables[t.critical.draggable.id], v = i || Qm({
    pageOffset: p.offset,
    draggable: m,
    draggables: l.draggables,
    droppables: l.droppables,
    previousImpact: t.impact,
    viewport: s,
    afterCritical: t.afterCritical
  }), g = kN({
    draggable: m,
    impact: v,
    previousImpact: t.impact,
    draggables: l.draggables,
    droppables: l.droppables
  }), b = Ce({}, t, {
    current: h,
    dimensions: {
      draggables: l.draggables,
      droppables: g
    },
    impact: v,
    viewport: s,
    scrollJumpRequest: o || null,
    forceShouldAnimate: o ? !1 : null
  });
  return b;
};
function RN(e, t) {
  return e.map(function(r) {
    return t[r];
  });
}
var Jm = function(e) {
  var t = e.impact, r = e.viewport, n = e.draggables, a = e.destination, i = e.forceShouldAnimate, o = t.displaced, s = RN(o.all, n), l = Rs({
    afterDragging: s,
    destination: a,
    displacedBy: t.displacedBy,
    viewport: r.frame,
    forceShouldAnimate: i,
    last: o
  });
  return Ce({}, t, {
    displaced: l
  });
}, eg = function(e) {
  var t = e.impact, r = e.draggable, n = e.droppable, a = e.draggables, i = e.viewport, o = e.afterCritical, s = bu({
    impact: t,
    draggable: r,
    draggables: a,
    droppable: n,
    afterCritical: o
  });
  return Td({
    pageBorderBoxCenter: s,
    draggable: r,
    viewport: i
  });
}, tg = function(e) {
  var t = e.state, r = e.dimensions, n = e.viewport;
  t.movementMode !== "SNAP" && (process.env.NODE_ENV, Y(!1));
  var a = t.impact, i = n || t.viewport, o = r || t.dimensions, s = o.draggables, l = o.droppables, c = s[t.critical.draggable.id], u = wr(a);
  u || (process.env.NODE_ENV !== "production" ? Y(!1, "Must be over a destination in SNAP movement mode") : Y(!1));
  var d = l[u], p = Jm({
    impact: a,
    viewport: i,
    destination: d,
    draggables: s
  }), h = eg({
    impact: p,
    draggable: c,
    droppable: d,
    draggables: s,
    viewport: i,
    afterCritical: t.afterCritical
  });
  return gs({
    impact: p,
    clientSelection: h,
    state: t,
    dimensions: o,
    viewport: i
  });
}, BN = function(e) {
  return {
    index: e.index,
    droppableId: e.droppableId
  };
}, rg = function(e) {
  var t = e.draggable, r = e.home, n = e.draggables, a = e.viewport, i = _1(r.axis, t.displaceBy), o = ni(r.descriptor.id, n), s = o.indexOf(t);
  s === -1 && (process.env.NODE_ENV !== "production" ? Y(!1, "Expected draggable to be inside home list") : Y(!1));
  var l = o.slice(s + 1), c = l.reduce(function(h, m) {
    return h[m.descriptor.id] = !0, h;
  }, {}), u = {
    inVirtualList: r.descriptor.mode === "virtual",
    displacedBy: i,
    effected: c
  }, d = Rs({
    afterDragging: l,
    destination: r,
    displacedBy: i,
    last: null,
    viewport: a.frame,
    forceShouldAnimate: !1
  }), p = {
    displaced: d,
    displacedBy: i,
    at: {
      type: "REORDER",
      destination: BN(t.descriptor)
    }
  };
  return {
    impact: p,
    afterCritical: u
  };
}, VN = function(e, t) {
  return {
    draggables: e.draggables,
    droppables: $d(e.droppables, t)
  };
}, A1 = function(t) {
  process.env.NODE_ENV;
}, D1 = function(t) {
  process.env.NODE_ENV;
}, HN = function(e) {
  var t = e.draggable, r = e.offset, n = e.initialWindowScroll, a = Fl(t.client, r), i = Wl(a, n), o = Ce({}, t, {
    placeholder: Ce({}, t.placeholder, {
      client: a
    }),
    client: a,
    page: i
  });
  return o;
}, FN = function(e) {
  var t = e.frame;
  return t || (process.env.NODE_ENV !== "production" ? Y(!1, "Expected Droppable to have a frame") : Y(!1)), t;
}, WN = function(e) {
  var t = e.additions, r = e.updatedDroppables, n = e.viewport, a = n.scroll.diff.value;
  return t.map(function(i) {
    var o = i.descriptor.droppableId, s = r[o], l = FN(s), c = l.scroll.diff.value, u = Yt(a, c), d = HN({
      draggable: i,
      offset: u,
      initialWindowScroll: n.scroll.initial
    });
    return d;
  });
}, zN = function(e) {
  var t = e.state, r = e.published;
  A1();
  var n = r.modified.map(function(w) {
    var x = t.dimensions.droppables[w.droppableId], y = Ed(x, w.scroll);
    return y;
  }), a = Ce({}, t.dimensions.droppables, {}, Rm(n)), i = Bm(WN({
    additions: r.additions,
    updatedDroppables: a,
    viewport: t.viewport
  })), o = Ce({}, t.dimensions.draggables, {}, i);
  r.removals.forEach(function(w) {
    delete o[w];
  });
  var s = {
    droppables: a,
    draggables: o
  }, l = wr(t.impact), c = l ? s.droppables[l] : null, u = s.draggables[t.critical.draggable.id], d = s.droppables[t.critical.droppable.id], p = rg({
    draggable: u,
    home: d,
    draggables: o,
    viewport: t.viewport
  }), h = p.impact, m = p.afterCritical, v = c && c.isCombineEnabled ? t.impact : h, g = Qm({
    pageOffset: t.current.page.offset,
    draggable: s.draggables[t.critical.draggable.id],
    draggables: s.draggables,
    droppables: s.droppables,
    previousImpact: v,
    viewport: t.viewport,
    afterCritical: m
  });
  D1();
  var b = Ce({
    phase: "DRAGGING"
  }, t, {
    phase: "DRAGGING",
    impact: g,
    onLiftImpact: h,
    dimensions: s,
    afterCritical: m,
    forceShouldAnimate: !1
  });
  if (t.phase === "COLLECTING")
    return b;
  var C = Ce({
    phase: "DROP_PENDING"
  }, b, {
    phase: "DROP_PENDING",
    reason: t.reason,
    isWaiting: !1
  });
  return C;
}, n0 = function(t) {
  return t.movementMode === "SNAP";
}, I2 = function(t, r, n) {
  var a = VN(t.dimensions, r);
  return !n0(t) || n ? gs({
    state: t,
    dimensions: a
  }) : tg({
    state: t,
    dimensions: a
  });
};
function L2(e) {
  return e.isDragging && e.movementMode === "SNAP" ? Ce({
    phase: "DRAGGING"
  }, e, {
    scrollJumpRequest: null
  }) : e;
}
var tp = {
  phase: "IDLE",
  completed: null,
  shouldFlush: !1
}, UN = function(e, t) {
  if (e === void 0 && (e = tp), t.type === "FLUSH")
    return Ce({}, tp, {
      shouldFlush: !0
    });
  if (t.type === "INITIAL_PUBLISH") {
    e.phase !== "IDLE" && (process.env.NODE_ENV !== "production" ? Y(!1, "INITIAL_PUBLISH must come after a IDLE phase") : Y(!1));
    var r = t.payload, n = r.critical, a = r.clientSelection, i = r.viewport, o = r.dimensions, s = r.movementMode, l = o.draggables[n.draggable.id], c = o.droppables[n.droppable.id], u = {
      selection: a,
      borderBoxCenter: l.client.borderBox.center,
      offset: Zt
    }, d = {
      client: u,
      page: {
        selection: Yt(u.selection, i.scroll.initial),
        borderBoxCenter: Yt(u.selection, i.scroll.initial),
        offset: Yt(u.selection, i.scroll.diff.value)
      }
    }, p = mu(o.droppables).every(function(V) {
      return !V.isFixedOnPage;
    }), h = rg({
      draggable: l,
      home: c,
      draggables: o.draggables,
      viewport: i
    }), m = h.impact, v = h.afterCritical, g = {
      phase: "DRAGGING",
      isDragging: !0,
      critical: n,
      movementMode: s,
      dimensions: o,
      initial: d,
      current: d,
      isWindowScrollAllowed: p,
      impact: m,
      afterCritical: v,
      onLiftImpact: m,
      viewport: i,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return g;
  }
  if (t.type === "COLLECTION_STARTING") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? Y(!1, "Collection cannot start from phase " + e.phase) : Y(!1));
    var b = Ce({
      phase: "COLLECTING"
    }, e, {
      phase: "COLLECTING"
    });
    return b;
  }
  if (t.type === "PUBLISH_WHILE_DRAGGING")
    return e.phase === "COLLECTING" || e.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? Y(!1, "Unexpected " + t.type + " received in phase " + e.phase) : Y(!1)), zN({
      state: e,
      published: t.payload
    });
  if (t.type === "MOVE") {
    if (e.phase === "DROP_PENDING")
      return e;
    Ta(e) || (process.env.NODE_ENV !== "production" ? Y(!1, t.type + " not permitted in phase " + e.phase) : Y(!1));
    var C = t.payload.client;
    return ta(C, e.current.client.selection) ? e : gs({
      state: e,
      clientSelection: C,
      impact: n0(e) ? e.impact : null
    });
  }
  if (t.type === "UPDATE_DROPPABLE_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "COLLECTING")
      return L2(e);
    Ta(e) || (process.env.NODE_ENV !== "production" ? Y(!1, t.type + " not permitted in phase " + e.phase) : Y(!1));
    var w = t.payload, x = w.id, y = w.newScroll, O = e.dimensions.droppables[x];
    if (!O)
      return e;
    var P = Ed(O, y);
    return I2(e, P, !1);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    Ta(e) || (process.env.NODE_ENV !== "production" ? Y(!1, "Attempting to move in an unsupported phase " + e.phase) : Y(!1));
    var j = t.payload, T = j.id, I = j.isEnabled, R = e.dimensions.droppables[T];
    R || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot find Droppable[id: " + T + "] to toggle its enabled state") : Y(!1)), R.isEnabled === I && (process.env.NODE_ENV !== "production" ? Y(!1, "Trying to set droppable isEnabled to " + String(I) + `
      but it is already ` + String(R.isEnabled)) : Y(!1));
    var F = Ce({}, R, {
      isEnabled: I
    });
    return I2(e, F, !0);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    Ta(e) || (process.env.NODE_ENV !== "production" ? Y(!1, "Attempting to move in an unsupported phase " + e.phase) : Y(!1));
    var $ = t.payload, Z = $.id, X = $.isCombineEnabled, K = e.dimensions.droppables[Z];
    K || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot find Droppable[id: " + Z + "] to toggle its isCombineEnabled state") : Y(!1)), K.isCombineEnabled === X && (process.env.NODE_ENV !== "production" ? Y(!1, "Trying to set droppable isCombineEnabled to " + String(X) + `
      but it is already ` + String(K.isCombineEnabled)) : Y(!1));
    var J = Ce({}, K, {
      isCombineEnabled: X
    });
    return I2(e, J, !0);
  }
  if (t.type === "MOVE_BY_WINDOW_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "DROP_ANIMATING")
      return e;
    Ta(e) || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot move by window in phase " + e.phase) : Y(!1)), e.isWindowScrollAllowed || (process.env.NODE_ENV !== "production" ? Y(!1, "Window scrolling is currently not supported for fixed lists") : Y(!1));
    var ee = t.payload.newScroll;
    if (ta(e.viewport.scroll.current, ee))
      return L2(e);
    var A = Um(e.viewport, ee);
    return n0(e) ? tg({
      state: e,
      viewport: A
    }) : gs({
      state: e,
      viewport: A
    });
  }
  if (t.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
    if (!Ta(e))
      return e;
    var _ = t.payload.maxScroll;
    if (ta(_, e.viewport.scroll.max))
      return e;
    var N = Ce({}, e.viewport, {
      scroll: Ce({}, e.viewport.scroll, {
        max: _
      })
    });
    return Ce({
      phase: "DRAGGING"
    }, e, {
      viewport: N
    });
  }
  if (t.type === "MOVE_UP" || t.type === "MOVE_DOWN" || t.type === "MOVE_LEFT" || t.type === "MOVE_RIGHT") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? Y(!1, t.type + " received while not in DRAGGING phase") : Y(!1));
    var M = jN({
      state: e,
      type: t.type
    });
    return M ? gs({
      state: e,
      impact: M.impact,
      clientSelection: M.clientSelection,
      scrollJumpRequest: M.scrollJumpRequest
    }) : e;
  }
  if (t.type === "DROP_PENDING") {
    var S = t.payload.reason;
    e.phase !== "COLLECTING" && (process.env.NODE_ENV !== "production" ? Y(!1, "Can only move into the DROP_PENDING phase from the COLLECTING phase") : Y(!1));
    var B = Ce({
      phase: "DROP_PENDING"
    }, e, {
      phase: "DROP_PENDING",
      isWaiting: !0,
      reason: S
    });
    return B;
  }
  if (t.type === "DROP_ANIMATE") {
    var G = t.payload, U = G.completed, H = G.dropDuration, k = G.newHomeClientOffset;
    e.phase === "DRAGGING" || e.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot animate drop from phase " + e.phase) : Y(!1));
    var L = {
      phase: "DROP_ANIMATING",
      completed: U,
      dropDuration: H,
      newHomeClientOffset: k,
      dimensions: e.dimensions
    };
    return L;
  }
  if (t.type === "DROP_COMPLETE") {
    var W = t.payload.completed;
    return {
      phase: "IDLE",
      completed: W,
      shouldFlush: !1
    };
  }
  return e;
}, ZN = function(t) {
  return {
    type: "BEFORE_INITIAL_CAPTURE",
    payload: t
  };
}, qN = function(t) {
  return {
    type: "LIFT",
    payload: t
  };
}, GN = function(t) {
  return {
    type: "INITIAL_PUBLISH",
    payload: t
  };
}, YN = function(t) {
  return {
    type: "PUBLISH_WHILE_DRAGGING",
    payload: t
  };
}, KN = function() {
  return {
    type: "COLLECTION_STARTING",
    payload: null
  };
}, XN = function(t) {
  return {
    type: "UPDATE_DROPPABLE_SCROLL",
    payload: t
  };
}, QN = function(t) {
  return {
    type: "UPDATE_DROPPABLE_IS_ENABLED",
    payload: t
  };
}, JN = function(t) {
  return {
    type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
    payload: t
  };
}, ng = function(t) {
  return {
    type: "MOVE",
    payload: t
  };
}, eI = function(t) {
  return {
    type: "MOVE_BY_WINDOW_SCROLL",
    payload: t
  };
}, tI = function(t) {
  return {
    type: "UPDATE_VIEWPORT_MAX_SCROLL",
    payload: t
  };
}, rI = function() {
  return {
    type: "MOVE_UP",
    payload: null
  };
}, nI = function() {
  return {
    type: "MOVE_DOWN",
    payload: null
  };
}, aI = function() {
  return {
    type: "MOVE_RIGHT",
    payload: null
  };
}, iI = function() {
  return {
    type: "MOVE_LEFT",
    payload: null
  };
}, Nd = function() {
  return {
    type: "FLUSH",
    payload: null
  };
}, oI = function(t) {
  return {
    type: "DROP_ANIMATE",
    payload: t
  };
}, Id = function(t) {
  return {
    type: "DROP_COMPLETE",
    payload: t
  };
}, ag = function(t) {
  return {
    type: "DROP",
    payload: t
  };
}, sI = function(t) {
  return {
    type: "DROP_PENDING",
    payload: t
  };
}, ig = function() {
  return {
    type: "DROP_ANIMATION_FINISHED",
    payload: null
  };
};
function lI(e) {
  if (!(e.length <= 1)) {
    for (var t = e.map(function(s) {
      return s.descriptor.index;
    }), r = {}, n = 1; n < t.length; n++) {
      var a = t[n], i = t[n - 1];
      a !== i + 1 && (r[a] = !0);
    }
    if (Object.keys(r).length) {
      var o = t.map(function(s) {
        var l = !!r[s];
        return l ? "[🔥" + s + "]" : "" + s;
      }).join(", ");
      process.env.NODE_ENV !== "production" && pt(`
    Detected non-consecutive <Draggable /> indexes.

    (This can cause unexpected bugs)

    ` + o + `
  `);
    }
  }
}
function cI(e, t) {
  if (process.env.NODE_ENV !== "production") {
    var r = ni(e.droppable.id, t.draggables);
    lI(r);
  }
}
var uI = function(e) {
  return function(t) {
    var r = t.getState, n = t.dispatch;
    return function(a) {
      return function(i) {
        if (i.type !== "LIFT") {
          a(i);
          return;
        }
        var o = i.payload, s = o.id, l = o.clientSelection, c = o.movementMode, u = r();
        u.phase === "DROP_ANIMATING" && n(Id({
          completed: u.completed
        })), r().phase !== "IDLE" && (process.env.NODE_ENV !== "production" ? Y(!1, "Unexpected phase to start a drag") : Y(!1)), n(Nd()), n(ZN({
          draggableId: s,
          movementMode: c
        }));
        var d = {
          shouldPublishImmediately: c === "SNAP"
        }, p = {
          draggableId: s,
          scrollOptions: d
        }, h = e.startPublishing(p), m = h.critical, v = h.dimensions, g = h.viewport;
        cI(m, v), n(GN({
          critical: m,
          dimensions: v,
          clientSelection: l,
          movementMode: c,
          viewport: g
        }));
      };
    };
  };
}, fI = function(e) {
  return function() {
    return function(t) {
      return function(r) {
        r.type === "INITIAL_PUBLISH" && e.dragging(), r.type === "DROP_ANIMATE" && e.dropping(r.payload.completed.result.reason), (r.type === "FLUSH" || r.type === "DROP_COMPLETE") && e.resting(), t(r);
      };
    };
  };
}, Ld = {
  outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
  drop: "cubic-bezier(.2,1,.1,1)"
}, Bs = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
}, kd = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
}, Pa = kd.outOfTheWay + "s " + Ld.outOfTheWay, ys = {
  fluid: "opacity " + Pa,
  snap: "transform " + Pa + ", opacity " + Pa,
  drop: function(t) {
    var r = t + "s " + Ld.drop;
    return "transform " + r + ", opacity " + r;
  },
  outOfTheWay: "transform " + Pa,
  placeholder: "height " + Pa + ", width " + Pa + ", margin " + Pa
}, rp = function(t) {
  return ta(t, Zt) ? null : "translate(" + t.x + "px, " + t.y + "px)";
}, a0 = {
  moveTo: rp,
  drop: function(t, r) {
    var n = rp(t);
    return n ? r ? n + " scale(" + Bs.scale.drop + ")" : n : null;
  }
}, i0 = kd.minDropTime, og = kd.maxDropTime, dI = og - i0, np = 1500, pI = 0.6, hI = function(e) {
  var t = e.current, r = e.destination, n = e.reason, a = Ls(t, r);
  if (a <= 0)
    return i0;
  if (a >= np)
    return og;
  var i = a / np, o = i0 + dI * i, s = n === "CANCEL" ? o * pI : o;
  return Number(s.toFixed(2));
}, vI = function(e) {
  var t = e.impact, r = e.draggable, n = e.dimensions, a = e.viewport, i = e.afterCritical, o = n.draggables, s = n.droppables, l = wr(t), c = l ? s[l] : null, u = s[r.descriptor.droppableId], d = eg({
    impact: t,
    draggable: r,
    draggables: o,
    afterCritical: i,
    droppable: c || u,
    viewport: a
  }), p = xr(d, r.client.borderBox.center);
  return p;
}, mI = function(e) {
  var t = e.draggables, r = e.reason, n = e.lastImpact, a = e.home, i = e.viewport, o = e.onLiftImpact;
  if (!n.at || r !== "DROP") {
    var s = Jm({
      draggables: t,
      impact: o,
      destination: a,
      viewport: i,
      forceShouldAnimate: !0
    });
    return {
      impact: s,
      didDropInsideDroppable: !1
    };
  }
  if (n.at.type === "REORDER")
    return {
      impact: n,
      didDropInsideDroppable: !0
    };
  var l = Ce({}, n, {
    displaced: ks
  });
  return {
    impact: l,
    didDropInsideDroppable: !0
  };
}, gI = function(e) {
  var t = e.getState, r = e.dispatch;
  return function(n) {
    return function(a) {
      if (a.type !== "DROP") {
        n(a);
        return;
      }
      var i = t(), o = a.payload.reason;
      if (i.phase === "COLLECTING") {
        r(sI({
          reason: o
        }));
        return;
      }
      if (i.phase !== "IDLE") {
        var s = i.phase === "DROP_PENDING" && i.isWaiting;
        s && (process.env.NODE_ENV !== "production" ? Y(!1, "A DROP action occurred while DROP_PENDING and still waiting") : Y(!1)), i.phase === "DRAGGING" || i.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot drop in phase: " + i.phase) : Y(!1));
        var l = i.critical, c = i.dimensions, u = c.draggables[i.critical.draggable.id], d = mI({
          reason: o,
          lastImpact: i.impact,
          afterCritical: i.afterCritical,
          onLiftImpact: i.onLiftImpact,
          home: i.dimensions.droppables[i.critical.droppable.id],
          viewport: i.viewport,
          draggables: i.dimensions.draggables
        }), p = d.impact, h = d.didDropInsideDroppable, m = h ? _d(p) : null, v = h ? gu(p) : null, g = {
          index: l.draggable.index,
          droppableId: l.droppable.id
        }, b = {
          draggableId: u.descriptor.id,
          type: u.descriptor.type,
          source: g,
          reason: o,
          mode: i.movementMode,
          destination: m,
          combine: v
        }, C = vI({
          impact: p,
          draggable: u,
          dimensions: c,
          viewport: i.viewport,
          afterCritical: i.afterCritical
        }), w = {
          critical: i.critical,
          afterCritical: i.afterCritical,
          result: b,
          impact: p
        }, x = !ta(i.current.client.offset, C) || !!b.combine;
        if (!x) {
          r(Id({
            completed: w
          }));
          return;
        }
        var y = hI({
          current: i.current.client.offset,
          destination: C,
          reason: o
        }), O = {
          newHomeClientOffset: C,
          dropDuration: y,
          completed: w
        };
        r(oI(O));
      }
    };
  };
}, sg = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};
function yI(e) {
  return {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: function(r) {
      r.target !== window && r.target !== window.document || e();
    }
  };
}
function bI(e) {
  var t = e.onWindowScroll;
  function r() {
    t(sg());
  }
  var n = Ns(r), a = yI(n), i = ea;
  function o() {
    return i !== ea;
  }
  function s() {
    o() && (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot start scroll listener when already active") : Y(!1)), i = Nr(window, [a]);
  }
  function l() {
    o() || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot stop scroll listener when not active") : Y(!1)), n.cancel(), i(), i = ea;
  }
  return {
    start: s,
    stop: l,
    isActive: o
  };
}
var CI = function(t) {
  return t.type === "DROP_COMPLETE" || t.type === "DROP_ANIMATE" || t.type === "FLUSH";
}, xI = function(e) {
  var t = bI({
    onWindowScroll: function(n) {
      e.dispatch(eI({
        newScroll: n
      }));
    }
  });
  return function(r) {
    return function(n) {
      !t.isActive() && n.type === "INITIAL_PUBLISH" && t.start(), t.isActive() && CI(n) && t.stop(), r(n);
    };
  };
}, wI = function(e) {
  var t = !1, r = !1, n = setTimeout(function() {
    r = !0;
  }), a = function(o) {
    if (t) {
      process.env.NODE_ENV !== "production" && pt("Announcement already made. Not making a second announcement");
      return;
    }
    if (r) {
      process.env.NODE_ENV !== "production" && pt(`
        Announcements cannot be made asynchronously.
        Default message has already been announced.
      `);
      return;
    }
    t = !0, e(o), clearTimeout(n);
  };
  return a.wasCalled = function() {
    return t;
  }, a;
}, OI = function() {
  var e = [], t = function(i) {
    var o = jd(e, function(c) {
      return c.timerId === i;
    });
    o === -1 && (process.env.NODE_ENV !== "production" ? Y(!1, "Could not find timer") : Y(!1));
    var s = e.splice(o, 1), l = s[0];
    l.callback();
  }, r = function(i) {
    var o = setTimeout(function() {
      return t(o);
    }), s = {
      timerId: o,
      callback: i
    };
    e.push(s);
  }, n = function() {
    if (e.length) {
      var i = [].concat(e);
      e.length = 0, i.forEach(function(o) {
        clearTimeout(o.timerId), o.callback();
      });
    }
  };
  return {
    add: r,
    flush: n
  };
}, SI = function(t, r) {
  return t == null && r == null ? !0 : t == null || r == null ? !1 : t.droppableId === r.droppableId && t.index === r.index;
}, PI = function(t, r) {
  return t == null && r == null ? !0 : t == null || r == null ? !1 : t.draggableId === r.draggableId && t.droppableId === r.droppableId;
}, EI = function(t, r) {
  if (t === r)
    return !0;
  var n = t.draggable.id === r.draggable.id && t.draggable.droppableId === r.draggable.droppableId && t.draggable.type === r.draggable.type && t.draggable.index === r.draggable.index, a = t.droppable.id === r.droppable.id && t.droppable.type === r.droppable.type;
  return n && a;
}, Zo = function(t, r) {
  A1(), r(), D1();
}, X1 = function(t, r) {
  return {
    draggableId: t.draggable.id,
    type: t.droppable.type,
    source: {
      droppableId: t.droppable.id,
      index: t.draggable.index
    },
    mode: r
  };
}, k2 = function(t, r, n, a) {
  if (!t) {
    n(a(r));
    return;
  }
  var i = wI(n), o = {
    announce: i
  };
  t(r, o), i.wasCalled() || n(a(r));
}, jI = function(e, t) {
  var r = OI(), n = null, a = function(p, h) {
    n && (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot fire onBeforeCapture as a drag start has already been published") : Y(!1)), Zo("onBeforeCapture", function() {
      var m = e().onBeforeCapture;
      if (m) {
        var v = {
          draggableId: p,
          mode: h
        };
        m(v);
      }
    });
  }, i = function(p, h) {
    n && (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot fire onBeforeDragStart as a drag start has already been published") : Y(!1)), Zo("onBeforeDragStart", function() {
      var m = e().onBeforeDragStart;
      m && m(X1(p, h));
    });
  }, o = function(p, h) {
    n && (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot fire onBeforeDragStart as a drag start has already been published") : Y(!1));
    var m = X1(p, h);
    n = {
      mode: h,
      lastCritical: p,
      lastLocation: m.source,
      lastCombine: null
    }, r.add(function() {
      Zo("onDragStart", function() {
        return k2(e().onDragStart, m, t, Cl.onDragStart);
      });
    });
  }, s = function(p, h) {
    var m = _d(h), v = gu(h);
    n || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot fire onDragMove when onDragStart has not been called") : Y(!1));
    var g = !EI(p, n.lastCritical);
    g && (n.lastCritical = p);
    var b = !SI(n.lastLocation, m);
    b && (n.lastLocation = m);
    var C = !PI(n.lastCombine, v);
    if (C && (n.lastCombine = v), !(!g && !b && !C)) {
      var w = Ce({}, X1(p, n.mode), {
        combine: v,
        destination: m
      });
      r.add(function() {
        Zo("onDragUpdate", function() {
          return k2(e().onDragUpdate, w, t, Cl.onDragUpdate);
        });
      });
    }
  }, l = function() {
    n || (process.env.NODE_ENV !== "production" ? Y(!1, "Can only flush responders while dragging") : Y(!1)), r.flush();
  }, c = function(p) {
    n || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot fire onDragEnd when there is no matching onDragStart") : Y(!1)), n = null, Zo("onDragEnd", function() {
      return k2(e().onDragEnd, p, t, Cl.onDragEnd);
    });
  }, u = function() {
    if (n) {
      var p = Ce({}, X1(n.lastCritical, n.mode), {
        combine: null,
        destination: null,
        reason: "CANCEL"
      });
      c(p);
    }
  };
  return {
    beforeCapture: a,
    beforeStart: i,
    start: o,
    update: s,
    flush: l,
    drop: c,
    abort: u
  };
}, _I = function(e, t) {
  var r = jI(e, t);
  return function(n) {
    return function(a) {
      return function(i) {
        if (i.type === "BEFORE_INITIAL_CAPTURE") {
          r.beforeCapture(i.payload.draggableId, i.payload.movementMode);
          return;
        }
        if (i.type === "INITIAL_PUBLISH") {
          var o = i.payload.critical;
          r.beforeStart(o, i.payload.movementMode), a(i), r.start(o, i.payload.movementMode);
          return;
        }
        if (i.type === "DROP_COMPLETE") {
          var s = i.payload.completed.result;
          r.flush(), a(i), r.drop(s);
          return;
        }
        if (a(i), i.type === "FLUSH") {
          r.abort();
          return;
        }
        var l = n.getState();
        l.phase === "DRAGGING" && r.update(l.critical, l.impact);
      };
    };
  };
}, AI = function(e) {
  return function(t) {
    return function(r) {
      if (r.type !== "DROP_ANIMATION_FINISHED") {
        t(r);
        return;
      }
      var n = e.getState();
      n.phase !== "DROP_ANIMATING" && (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot finish a drop animating when no drop is occurring") : Y(!1)), e.dispatch(Id({
        completed: n.completed
      }));
    };
  };
}, DI = function(e) {
  var t = null, r = null;
  function n() {
    r && (cancelAnimationFrame(r), r = null), t && (t(), t = null);
  }
  return function(a) {
    return function(i) {
      if ((i.type === "FLUSH" || i.type === "DROP_COMPLETE" || i.type === "DROP_ANIMATION_FINISHED") && n(), a(i), i.type === "DROP_ANIMATE") {
        var o = {
          eventName: "scroll",
          options: {
            capture: !0,
            passive: !1,
            once: !0
          },
          fn: function() {
            var l = e.getState();
            l.phase === "DROP_ANIMATING" && e.dispatch(ig());
          }
        };
        r = requestAnimationFrame(function() {
          r = null, t = Nr(window, [o]);
        });
      }
    };
  };
}, MI = function(e) {
  return function() {
    return function(t) {
      return function(r) {
        (r.type === "DROP_COMPLETE" || r.type === "FLUSH" || r.type === "DROP_ANIMATE") && e.stopPublishing(), t(r);
      };
    };
  };
}, TI = function(e) {
  var t = !1;
  return function() {
    return function(r) {
      return function(n) {
        if (n.type === "INITIAL_PUBLISH") {
          t = !0, e.tryRecordFocus(n.payload.critical.draggable.id), r(n), e.tryRestoreFocusRecorded();
          return;
        }
        if (r(n), !!t) {
          if (n.type === "FLUSH") {
            t = !1, e.tryRestoreFocusRecorded();
            return;
          }
          if (n.type === "DROP_COMPLETE") {
            t = !1;
            var a = n.payload.completed.result;
            a.combine && e.tryShiftRecord(a.draggableId, a.combine.draggableId), e.tryRestoreFocusRecorded();
          }
        }
      };
    };
  };
}, $I = function(t) {
  return t.type === "DROP_COMPLETE" || t.type === "DROP_ANIMATE" || t.type === "FLUSH";
}, NI = function(e) {
  return function(t) {
    return function(r) {
      return function(n) {
        if ($I(n)) {
          e.stop(), r(n);
          return;
        }
        if (n.type === "INITIAL_PUBLISH") {
          r(n);
          var a = t.getState();
          a.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? Y(!1, "Expected phase to be DRAGGING after INITIAL_PUBLISH") : Y(!1)), e.start(a);
          return;
        }
        r(n), e.scroll(t.getState());
      };
    };
  };
}, II = function(e) {
  return function(t) {
    return function(r) {
      if (t(r), r.type === "PUBLISH_WHILE_DRAGGING") {
        var n = e.getState();
        n.phase === "DROP_PENDING" && (n.isWaiting || e.dispatch(ag({
          reason: n.reason
        })));
      }
    };
  };
}, LI = process.env.NODE_ENV !== "production" && typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  name: "react-beautiful-dnd"
}) : bm, kI = function(e) {
  var t = e.dimensionMarshal, r = e.focusMarshal, n = e.styleMarshal, a = e.getResponders, i = e.announce, o = e.autoScroller;
  return ym(UN, LI(ST(fI(n), MI(t), uI(t), gI, AI, DI, II, NI(o), xI, TI(r), _I(a, i))));
}, R2 = function() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};
function RI(e) {
  var t = e.registry, r = e.callbacks, n = R2(), a = null, i = function() {
    a || (r.collectionStarting(), a = requestAnimationFrame(function() {
      a = null, A1();
      var u = n, d = u.additions, p = u.removals, h = u.modified, m = Object.keys(d).map(function(b) {
        return t.draggable.getById(b).getDimension(Zt);
      }).sort(function(b, C) {
        return b.descriptor.index - C.descriptor.index;
      }), v = Object.keys(h).map(function(b) {
        var C = t.droppable.getById(b), w = C.callbacks.getScrollWhileDragging();
        return {
          droppableId: b,
          scroll: w
        };
      }), g = {
        additions: m,
        removals: Object.keys(p),
        modified: v
      };
      n = R2(), D1(), r.publish(g);
    }));
  }, o = function(u) {
    var d = u.descriptor.id;
    n.additions[d] = u, n.modified[u.descriptor.droppableId] = !0, n.removals[d] && delete n.removals[d], i();
  }, s = function(u) {
    var d = u.descriptor;
    n.removals[d.id] = !0, n.modified[d.droppableId] = !0, n.additions[d.id] && delete n.additions[d.id], i();
  }, l = function() {
    a && (cancelAnimationFrame(a), a = null, n = R2());
  };
  return {
    add: o,
    remove: s,
    stop: l
  };
}
var lg = function(e) {
  var t = e.scrollHeight, r = e.scrollWidth, n = e.height, a = e.width, i = xr({
    x: r,
    y: t
  }, {
    x: a,
    y: n
  }), o = {
    x: Math.max(0, i.x),
    y: Math.max(0, i.y)
  };
  return o;
}, cg = function() {
  var e = document.documentElement;
  return e || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot find document.documentElement") : Y(!1)), e;
}, ug = function() {
  var e = cg(), t = lg({
    scrollHeight: e.scrollHeight,
    scrollWidth: e.scrollWidth,
    width: e.clientWidth,
    height: e.clientHeight
  });
  return t;
}, BI = function() {
  var e = sg(), t = ug(), r = e.y, n = e.x, a = cg(), i = a.clientWidth, o = a.clientHeight, s = n + i, l = r + o, c = Gr({
    top: r,
    left: n,
    right: s,
    bottom: l
  }), u = {
    frame: c,
    scroll: {
      initial: e,
      current: e,
      max: t,
      diff: {
        value: Zt,
        displacement: Zt
      }
    }
  };
  return u;
}, VI = function(e) {
  var t = e.critical, r = e.scrollOptions, n = e.registry;
  A1();
  var a = BI(), i = a.scroll.current, o = t.droppable, s = n.droppable.getAllByType(o.type).map(function(d) {
    return d.callbacks.getDimensionAndWatchScroll(i, r);
  }), l = n.draggable.getAllByType(t.draggable.type).map(function(d) {
    return d.getDimension(i);
  }), c = {
    draggables: Bm(l),
    droppables: Rm(s)
  };
  D1();
  var u = {
    dimensions: c,
    critical: t,
    viewport: a
  };
  return u;
};
function ap(e, t, r) {
  if (r.descriptor.id === t.id || r.descriptor.type !== t.type)
    return !1;
  var n = e.droppable.getById(r.descriptor.droppableId);
  return n.descriptor.mode !== "virtual" ? (process.env.NODE_ENV !== "production" && pt(`
      You are attempting to add or remove a Draggable [id: ` + r.descriptor.id + `]
      while a drag is occurring. This is only supported for virtual lists.

      See https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/patterns/virtual-lists.md
    `), !1) : !0;
}
var HI = function(e, t) {
  var r = null, n = RI({
    callbacks: {
      publish: t.publishWhileDragging,
      collectionStarting: t.collectionStarting
    },
    registry: e
  }), a = function(h, m) {
    e.droppable.exists(h) || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot update is enabled flag of Droppable " + h + " as it is not registered") : Y(!1)), r && t.updateDroppableIsEnabled({
      id: h,
      isEnabled: m
    });
  }, i = function(h, m) {
    r && (e.droppable.exists(h) || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot update isCombineEnabled flag of Droppable " + h + " as it is not registered") : Y(!1)), t.updateDroppableIsCombineEnabled({
      id: h,
      isCombineEnabled: m
    }));
  }, o = function(h, m) {
    r && (e.droppable.exists(h) || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot update the scroll on Droppable " + h + " as it is not registered") : Y(!1)), t.updateDroppableScroll({
      id: h,
      newScroll: m
    }));
  }, s = function(h, m) {
    r && e.droppable.getById(h).callbacks.scroll(m);
  }, l = function() {
    if (r) {
      n.stop();
      var h = r.critical.droppable;
      e.droppable.getAllByType(h.type).forEach(function(m) {
        return m.callbacks.dragStopped();
      }), r.unsubscribe(), r = null;
    }
  }, c = function(h) {
    r || (process.env.NODE_ENV !== "production" ? Y(!1, "Should only be subscribed when a collection is occurring") : Y(!1));
    var m = r.critical.draggable;
    h.type === "ADDITION" && ap(e, m, h.value) && n.add(h.value), h.type === "REMOVAL" && ap(e, m, h.value) && n.remove(h.value);
  }, u = function(h) {
    r && (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot start capturing critical dimensions as there is already a collection") : Y(!1));
    var m = e.draggable.getById(h.draggableId), v = e.droppable.getById(m.descriptor.droppableId), g = {
      draggable: m.descriptor,
      droppable: v.descriptor
    }, b = e.subscribe(c);
    return r = {
      critical: g,
      unsubscribe: b
    }, VI({
      critical: g,
      registry: e,
      scrollOptions: h.scrollOptions
    });
  }, d = {
    updateDroppableIsEnabled: a,
    updateDroppableIsCombineEnabled: i,
    scrollDroppable: s,
    updateDroppableScroll: o,
    startPublishing: u,
    stopPublishing: l
  };
  return d;
}, fg = function(e, t) {
  return e.phase === "IDLE" ? !0 : e.phase !== "DROP_ANIMATING" || e.completed.result.draggableId === t ? !1 : e.completed.result.reason === "DROP";
}, FI = function(e) {
  window.scrollBy(e.x, e.y);
}, WI = Ut(function(e) {
  return mu(e).filter(function(t) {
    return !(!t.isEnabled || !t.frame);
  });
}), zI = function(t, r) {
  var n = ha(WI(r), function(a) {
    return a.frame || (process.env.NODE_ENV !== "production" ? Y(!1, "Invalid result") : Y(!1)), Ym(a.frame.pageMarginBox)(t);
  });
  return n;
}, UI = function(e) {
  var t = e.center, r = e.destination, n = e.droppables;
  if (r) {
    var a = n[r];
    return a.frame ? a : null;
  }
  var i = zI(t, n);
  return i;
}, ra = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function(t) {
    return Math.pow(t, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
}, ZI = function(e, t) {
  var r = e[t.size] * ra.startFromPercentage, n = e[t.size] * ra.maxScrollAtPercentage, a = {
    startScrollingFrom: r,
    maxScrollValueAt: n
  };
  return a;
}, dg = function(e) {
  var t = e.startOfRange, r = e.endOfRange, n = e.current, a = r - t;
  if (a === 0)
    return process.env.NODE_ENV !== "production" && pt(`
      Detected distance range of 0 in the fluid auto scroller
      This is unexpected and would cause a divide by 0 issue.
      Not allowing an auto scroll
    `), 0;
  var i = n - t, o = i / a;
  return o;
}, Rd = 1, qI = function(e, t) {
  if (e > t.startScrollingFrom)
    return 0;
  if (e <= t.maxScrollValueAt)
    return ra.maxPixelScroll;
  if (e === t.startScrollingFrom)
    return Rd;
  var r = dg({
    startOfRange: t.maxScrollValueAt,
    endOfRange: t.startScrollingFrom,
    current: e
  }), n = 1 - r, a = ra.maxPixelScroll * ra.ease(n);
  return Math.ceil(a);
}, ip = ra.durationDampening.accelerateAt, op = ra.durationDampening.stopDampeningAt, GI = function(e, t) {
  var r = t, n = op, a = Date.now(), i = a - r;
  if (i >= op)
    return e;
  if (i < ip)
    return Rd;
  var o = dg({
    startOfRange: ip,
    endOfRange: n,
    current: i
  }), s = e * ra.ease(o);
  return Math.ceil(s);
}, sp = function(e) {
  var t = e.distanceToEdge, r = e.thresholds, n = e.dragStartTime, a = e.shouldUseTimeDampening, i = qI(t, r);
  return i === 0 ? 0 : a ? Math.max(GI(i, n), Rd) : i;
}, lp = function(e) {
  var t = e.container, r = e.distanceToEdges, n = e.dragStartTime, a = e.axis, i = e.shouldUseTimeDampening, o = ZI(t, a), s = r[a.end] < r[a.start];
  return s ? sp({
    distanceToEdge: r[a.end],
    thresholds: o,
    dragStartTime: n,
    shouldUseTimeDampening: i
  }) : -1 * sp({
    distanceToEdge: r[a.start],
    thresholds: o,
    dragStartTime: n,
    shouldUseTimeDampening: i
  });
}, YI = function(e) {
  var t = e.container, r = e.subject, n = e.proposedScroll, a = r.height > t.height, i = r.width > t.width;
  return !i && !a ? n : i && a ? null : {
    x: i ? 0 : n.x,
    y: a ? 0 : n.y
  };
}, KI = Lm(function(e) {
  return e === 0 ? 0 : e;
}), pg = function(e) {
  var t = e.dragStartTime, r = e.container, n = e.subject, a = e.center, i = e.shouldUseTimeDampening, o = {
    top: a.y - r.top,
    right: r.right - a.x,
    bottom: r.bottom - a.y,
    left: a.x - r.left
  }, s = lp({
    container: r,
    distanceToEdges: o,
    dragStartTime: t,
    axis: Ad,
    shouldUseTimeDampening: i
  }), l = lp({
    container: r,
    distanceToEdges: o,
    dragStartTime: t,
    axis: Fm,
    shouldUseTimeDampening: i
  }), c = KI({
    x: l,
    y: s
  });
  if (ta(c, Zt))
    return null;
  var u = YI({
    container: r,
    subject: n,
    proposedScroll: c
  });
  return u ? ta(u, Zt) ? null : u : null;
}, XI = Lm(function(e) {
  return e === 0 ? 0 : e > 0 ? 1 : -1;
}), Bd = function() {
  var e = function(r, n) {
    return r < 0 ? r : r > n ? r - n : 0;
  };
  return function(t) {
    var r = t.current, n = t.max, a = t.change, i = Yt(r, a), o = {
      x: e(i.x, n.x),
      y: e(i.y, n.y)
    };
    return ta(o, Zt) ? null : o;
  };
}(), hg = function(t) {
  var r = t.max, n = t.current, a = t.change, i = {
    x: Math.max(n.x, r.x),
    y: Math.max(n.y, r.y)
  }, o = XI(a), s = Bd({
    max: i,
    current: n,
    change: o
  });
  return !s || o.x !== 0 && s.x === 0 || o.y !== 0 && s.y === 0;
}, Vd = function(t, r) {
  return hg({
    current: t.scroll.current,
    max: t.scroll.max,
    change: r
  });
}, QI = function(t, r) {
  if (!Vd(t, r))
    return null;
  var n = t.scroll.max, a = t.scroll.current;
  return Bd({
    current: a,
    max: n,
    change: r
  });
}, Hd = function(t, r) {
  var n = t.frame;
  return n ? hg({
    current: n.scroll.current,
    max: n.scroll.max,
    change: r
  }) : !1;
}, JI = function(t, r) {
  var n = t.frame;
  return !n || !Hd(t, r) ? null : Bd({
    current: n.scroll.current,
    max: n.scroll.max,
    change: r
  });
}, eL = function(e) {
  var t = e.viewport, r = e.subject, n = e.center, a = e.dragStartTime, i = e.shouldUseTimeDampening, o = pg({
    dragStartTime: a,
    container: t.frame,
    subject: r,
    center: n,
    shouldUseTimeDampening: i
  });
  return o && Vd(t, o) ? o : null;
}, tL = function(e) {
  var t = e.droppable, r = e.subject, n = e.center, a = e.dragStartTime, i = e.shouldUseTimeDampening, o = t.frame;
  if (!o)
    return null;
  var s = pg({
    dragStartTime: a,
    container: o.pageMarginBox,
    subject: r,
    center: n,
    shouldUseTimeDampening: i
  });
  return s && Hd(t, s) ? s : null;
}, cp = function(e) {
  var t = e.state, r = e.dragStartTime, n = e.shouldUseTimeDampening, a = e.scrollWindow, i = e.scrollDroppable, o = t.current.page.borderBoxCenter, s = t.dimensions.draggables[t.critical.draggable.id], l = s.page.marginBox;
  if (t.isWindowScrollAllowed) {
    var c = t.viewport, u = eL({
      dragStartTime: r,
      viewport: c,
      subject: l,
      center: o,
      shouldUseTimeDampening: n
    });
    if (u) {
      a(u);
      return;
    }
  }
  var d = UI({
    center: o,
    destination: wr(t.impact),
    droppables: t.dimensions.droppables
  });
  if (d) {
    var p = tL({
      dragStartTime: r,
      droppable: d,
      subject: l,
      center: o,
      shouldUseTimeDampening: n
    });
    p && i(d.descriptor.id, p);
  }
}, rL = function(e) {
  var t = e.scrollWindow, r = e.scrollDroppable, n = Ns(t), a = Ns(r), i = null, o = function(u) {
    i || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot fluid scroll if not dragging") : Y(!1));
    var d = i, p = d.shouldUseTimeDampening, h = d.dragStartTime;
    cp({
      state: u,
      scrollWindow: n,
      scrollDroppable: a,
      dragStartTime: h,
      shouldUseTimeDampening: p
    });
  }, s = function(u) {
    A1(), i && (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot start auto scrolling when already started") : Y(!1));
    var d = Date.now(), p = !1, h = function() {
      p = !0;
    };
    cp({
      state: u,
      dragStartTime: 0,
      shouldUseTimeDampening: !1,
      scrollWindow: h,
      scrollDroppable: h
    }), i = {
      dragStartTime: d,
      shouldUseTimeDampening: p
    }, D1(), p && o(u);
  }, l = function() {
    i && (n.cancel(), a.cancel(), i = null);
  };
  return {
    start: s,
    stop: l,
    scroll: o
  };
}, nL = function(e) {
  var t = e.move, r = e.scrollDroppable, n = e.scrollWindow, a = function(c, u) {
    var d = Yt(c.current.client.selection, u);
    t({
      client: d
    });
  }, i = function(c, u) {
    if (!Hd(c, u))
      return u;
    var d = JI(c, u);
    if (!d)
      return r(c.descriptor.id, u), null;
    var p = xr(u, d);
    r(c.descriptor.id, p);
    var h = xr(u, p);
    return h;
  }, o = function(c, u, d) {
    if (!c || !Vd(u, d))
      return d;
    var p = QI(u, d);
    if (!p)
      return n(d), null;
    var h = xr(d, p);
    n(h);
    var m = xr(d, h);
    return m;
  }, s = function(c) {
    var u = c.scrollJumpRequest;
    if (u) {
      var d = wr(c.impact);
      d || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot perform a jump scroll when there is no destination") : Y(!1));
      var p = i(c.dimensions.droppables[d], u);
      if (p) {
        var h = c.viewport, m = o(c.isWindowScrollAllowed, h, p);
        m && a(c, m);
      }
    }
  };
  return s;
}, aL = function(e) {
  var t = e.scrollDroppable, r = e.scrollWindow, n = e.move, a = rL({
    scrollWindow: r,
    scrollDroppable: t
  }), i = nL({
    move: n,
    scrollWindow: r,
    scrollDroppable: t
  }), o = function(c) {
    if (c.phase === "DRAGGING") {
      if (c.movementMode === "FLUID") {
        a.scroll(c);
        return;
      }
      c.scrollJumpRequest && i(c);
    }
  }, s = {
    scroll: o,
    start: a.start,
    stop: a.stop
  };
  return s;
}, Bi = "data-rbd", Vi = function() {
  var e = Bi + "-drag-handle";
  return {
    base: e,
    draggableId: e + "-draggable-id",
    contextId: e + "-context-id"
  };
}(), o0 = function() {
  var e = Bi + "-draggable";
  return {
    base: e,
    contextId: e + "-context-id",
    id: e + "-id"
  };
}(), iL = function() {
  var e = Bi + "-droppable";
  return {
    base: e,
    contextId: e + "-context-id",
    id: e + "-id"
  };
}(), up = {
  contextId: Bi + "-scroll-container-context-id"
}, oL = function(t) {
  return function(r) {
    return "[" + r + '="' + t + '"]';
  };
}, qo = function(t, r) {
  return t.map(function(n) {
    var a = n.styles[r];
    return a ? n.selector + " { " + a + " }" : "";
  }).join(" ");
}, sL = "pointer-events: none;", lL = function(e) {
  var t = oL(e), r = function() {
    var s = `
      cursor: -webkit-grab;
      cursor: grab;
    `;
    return {
      selector: t(Vi.contextId),
      styles: {
        always: `
          -webkit-touch-callout: none;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
          touch-action: manipulation;
        `,
        resting: s,
        dragging: sL,
        dropAnimating: s
      }
    };
  }(), n = function() {
    var s = `
      transition: ` + ys.outOfTheWay + `;
    `;
    return {
      selector: t(o0.contextId),
      styles: {
        dragging: s,
        dropAnimating: s,
        userCancel: s
      }
    };
  }(), a = {
    selector: t(iL.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  }, i = {
    selector: "body",
    styles: {
      dragging: `
        cursor: grabbing;
        cursor: -webkit-grabbing;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        overflow-anchor: none;
      `
    }
  }, o = [n, r, a, i];
  return {
    always: qo(o, "always"),
    resting: qo(o, "resting"),
    dragging: qo(o, "dragging"),
    dropAnimating: qo(o, "dropAnimating"),
    userCancel: qo(o, "userCancel")
  };
}, Or = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? uv : _e, B2 = function() {
  var t = document.querySelector("head");
  return t || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot find the head to append a style to") : Y(!1)), t;
}, fp = function(t) {
  var r = document.createElement("style");
  return t && r.setAttribute("nonce", t), r.type = "text/css", r;
};
function cL(e, t) {
  var r = He(function() {
    return lL(e);
  }, [e]), n = ve(null), a = ve(null), i = ge(Ut(function(d) {
    var p = a.current;
    p || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot set dynamic style element if it is not set") : Y(!1)), p.textContent = d;
  }), []), o = ge(function(d) {
    var p = n.current;
    p || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot set dynamic style element if it is not set") : Y(!1)), p.textContent = d;
  }, []);
  Or(function() {
    !n.current && !a.current || (process.env.NODE_ENV !== "production" ? Y(!1, "style elements already mounted") : Y(!1));
    var d = fp(t), p = fp(t);
    return n.current = d, a.current = p, d.setAttribute(Bi + "-always", e), p.setAttribute(Bi + "-dynamic", e), B2().appendChild(d), B2().appendChild(p), o(r.always), i(r.resting), function() {
      var h = function(v) {
        var g = v.current;
        g || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot unmount ref as it is not set") : Y(!1)), B2().removeChild(g), v.current = null;
      };
      h(n), h(a);
    };
  }, [t, o, i, r.always, r.resting, e]);
  var s = ge(function() {
    return i(r.dragging);
  }, [i, r.dragging]), l = ge(function(d) {
    if (d === "DROP") {
      i(r.dropAnimating);
      return;
    }
    i(r.userCancel);
  }, [i, r.dropAnimating, r.userCancel]), c = ge(function() {
    a.current && i(r.resting);
  }, [i, r.resting]), u = He(function() {
    return {
      dragging: s,
      dropping: l,
      resting: c
    };
  }, [s, l, c]);
  return u;
}
var vg = function(e) {
  return e && e.ownerDocument ? e.ownerDocument.defaultView : window;
};
function M1(e) {
  return e instanceof vg(e).HTMLElement;
}
function mg(e, t) {
  var r = "[" + Vi.contextId + '="' + e + '"]', n = km(document.querySelectorAll(r));
  if (!n.length)
    return process.env.NODE_ENV !== "production" && pt('Unable to find any drag handles in the context "' + e + '"'), null;
  var a = ha(n, function(i) {
    return i.getAttribute(Vi.draggableId) === t;
  });
  return a ? M1(a) ? a : (process.env.NODE_ENV !== "production" && pt("drag handle needs to be a HTMLElement"), null) : (process.env.NODE_ENV !== "production" && pt('Unable to find drag handle with id "' + t + '" as no handle with a matching id was found'), null);
}
function uL(e) {
  var t = ve({}), r = ve(null), n = ve(null), a = ve(!1), i = ge(function(p, h) {
    var m = {
      id: p,
      focus: h
    };
    return t.current[p] = m, function() {
      var g = t.current, b = g[p];
      b !== m && delete g[p];
    };
  }, []), o = ge(function(p) {
    var h = mg(e, p);
    h && h !== document.activeElement && h.focus();
  }, [e]), s = ge(function(p, h) {
    r.current === p && (r.current = h);
  }, []), l = ge(function() {
    n.current || a.current && (n.current = requestAnimationFrame(function() {
      n.current = null;
      var p = r.current;
      p && o(p);
    }));
  }, [o]), c = ge(function(p) {
    r.current = null;
    var h = document.activeElement;
    h && h.getAttribute(Vi.draggableId) === p && (r.current = p);
  }, []);
  Or(function() {
    return a.current = !0, function() {
      a.current = !1;
      var p = n.current;
      p && cancelAnimationFrame(p);
    };
  }, []);
  var u = He(function() {
    return {
      register: i,
      tryRecordFocus: c,
      tryRestoreFocusRecorded: l,
      tryShiftRecord: s
    };
  }, [i, c, l, s]);
  return u;
}
function fL() {
  var e = {
    draggables: {},
    droppables: {}
  }, t = [];
  function r(d) {
    return t.push(d), function() {
      var h = t.indexOf(d);
      h !== -1 && t.splice(h, 1);
    };
  }
  function n(d) {
    t.length && t.forEach(function(p) {
      return p(d);
    });
  }
  function a(d) {
    return e.draggables[d] || null;
  }
  function i(d) {
    var p = a(d);
    return p || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot find draggable entry with id [" + d + "]") : Y(!1)), p;
  }
  var o = {
    register: function(p) {
      e.draggables[p.descriptor.id] = p, n({
        type: "ADDITION",
        value: p
      });
    },
    update: function(p, h) {
      var m = e.draggables[h.descriptor.id];
      m && m.uniqueId === p.uniqueId && (delete e.draggables[h.descriptor.id], e.draggables[p.descriptor.id] = p);
    },
    unregister: function(p) {
      var h = p.descriptor.id, m = a(h);
      m && p.uniqueId === m.uniqueId && (delete e.draggables[h], n({
        type: "REMOVAL",
        value: p
      }));
    },
    getById: i,
    findById: a,
    exists: function(p) {
      return !!a(p);
    },
    getAllByType: function(p) {
      return Ul(e.draggables).filter(function(h) {
        return h.descriptor.type === p;
      });
    }
  };
  function s(d) {
    return e.droppables[d] || null;
  }
  function l(d) {
    var p = s(d);
    return p || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot find droppable entry with id [" + d + "]") : Y(!1)), p;
  }
  var c = {
    register: function(p) {
      e.droppables[p.descriptor.id] = p;
    },
    unregister: function(p) {
      var h = s(p.descriptor.id);
      h && p.uniqueId === h.uniqueId && delete e.droppables[p.descriptor.id];
    },
    getById: l,
    findById: s,
    exists: function(p) {
      return !!s(p);
    },
    getAllByType: function(p) {
      return Ul(e.droppables).filter(function(h) {
        return h.descriptor.type === p;
      });
    }
  };
  function u() {
    e.draggables = {}, e.droppables = {}, t.length = 0;
  }
  return {
    draggable: o,
    droppable: c,
    subscribe: r,
    clean: u
  };
}
function dL() {
  var e = He(fL, []);
  return _e(function() {
    return function() {
      requestAnimationFrame(e.clean);
    };
  }, [e]), e;
}
var Fd = E.createContext(null), Vs = function() {
  var e = document.body;
  return e || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot find document.body") : Y(!1)), e;
}, pL = {
  position: "absolute",
  width: "1px",
  height: "1px",
  margin: "-1px",
  border: "0",
  padding: "0",
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  "clip-path": "inset(100%)"
}, hL = function(t) {
  return "rbd-announcement-" + t;
};
function vL(e) {
  var t = He(function() {
    return hL(e);
  }, [e]), r = ve(null);
  _e(function() {
    var i = document.createElement("div");
    return r.current = i, i.id = t, i.setAttribute("aria-live", "assertive"), i.setAttribute("aria-atomic", "true"), Ce(i.style, pL), Vs().appendChild(i), function() {
      setTimeout(function() {
        var l = Vs();
        l.contains(i) && l.removeChild(i), i === r.current && (r.current = null);
      });
    };
  }, [t]);
  var n = ge(function(a) {
    var i = r.current;
    if (i) {
      i.textContent = a;
      return;
    }
    process.env.NODE_ENV !== "production" && pt(`
      A screen reader message was trying to be announced but it was unable to do so.
      This can occur if you unmount your <DragDropContext /> in your onDragEnd.
      Consider calling provided.announce() before the unmount so that the instruction will
      not be lost for users relying on a screen reader.

      Message not passed to screen reader:

      "` + a + `"
    `);
  }, []);
  return n;
}
var mL = 0, gL = {
  separator: "::"
};
function Wd(e, t) {
  return t === void 0 && (t = gL), He(function() {
    return "" + e + t.separator + mL++;
  }, [t.separator, e]);
}
function yL(e) {
  var t = e.contextId, r = e.uniqueId;
  return "rbd-hidden-text-" + t + "-" + r;
}
function bL(e) {
  var t = e.contextId, r = e.text, n = Wd("hidden-text", {
    separator: "-"
  }), a = He(function() {
    return yL({
      contextId: t,
      uniqueId: n
    });
  }, [n, t]);
  return _e(function() {
    var o = document.createElement("div");
    return o.id = a, o.textContent = r, o.style.display = "none", Vs().appendChild(o), function() {
      var l = Vs();
      l.contains(o) && l.removeChild(o);
    };
  }, [a, r]), a;
}
var Cu = E.createContext(null), CL = {
  react: "^16.8.5 || ^17.0.0 || ^18.0.0",
  "react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
}, xL = /(\d+)\.(\d+)\.(\d+)/, dp = function(t) {
  var r = xL.exec(t);
  r == null && (process.env.NODE_ENV !== "production" ? Y(!1, "Unable to parse React version " + t) : Y(!1));
  var n = Number(r[1]), a = Number(r[2]), i = Number(r[3]);
  return {
    major: n,
    minor: a,
    patch: i,
    raw: t
  };
}, wL = function(t, r) {
  return r.major > t.major ? !0 : r.major < t.major ? !1 : r.minor > t.minor ? !0 : r.minor < t.minor ? !1 : r.patch >= t.patch;
}, OL = function(e, t) {
  var r = dp(e), n = dp(t);
  wL(r, n) || process.env.NODE_ENV !== "production" && pt(`
    React version: [` + n.raw + `]
    does not satisfy expected peer dependency version: [` + r.raw + `]

    This can result in run time bugs, and even fatal crashes
  `);
}, V2 = `
  We expect a html5 doctype: <!doctype html>
  This is to ensure consistent browser layout and measurement

  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md
`, SL = function(e) {
  var t = e.doctype;
  if (!t) {
    process.env.NODE_ENV !== "production" && pt(`
      No <!doctype html> found.

      ` + V2 + `
    `);
    return;
  }
  t.name.toLowerCase() !== "html" && process.env.NODE_ENV !== "production" && pt(`
      Unexpected <!doctype> found: (` + t.name + `)

      ` + V2 + `
    `), t.publicId !== "" && process.env.NODE_ENV !== "production" && pt(`
      Unexpected <!doctype> publicId found: (` + t.publicId + `)
      A html5 doctype does not have a publicId

      ` + V2 + `
    `);
};
function zd(e) {
  process.env.NODE_ENV !== "production" && e();
}
function T1(e, t) {
  zd(function() {
    _e(function() {
      try {
        e();
      } catch (r) {
        t0(`
          A setup problem was encountered.

          > ` + r.message + `
        `);
      }
    }, t);
  });
}
function PL() {
  T1(function() {
    OL(CL.react, E.version), SL(document);
  }, []);
}
function Ud(e) {
  var t = ve(e);
  return _e(function() {
    t.current = e;
  }), t;
}
function EL() {
  var e = null;
  function t() {
    return !!e;
  }
  function r(o) {
    return o === e;
  }
  function n(o) {
    e && (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot claim lock as it is already claimed") : Y(!1));
    var s = {
      abandon: o
    };
    return e = s, s;
  }
  function a() {
    e || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot release lock when there is no lock") : Y(!1)), e = null;
  }
  function i() {
    e && (e.abandon(), a());
  }
  return {
    isClaimed: t,
    isActive: r,
    claim: n,
    release: a,
    tryAbandon: i
  };
}
var jL = 9, _L = 13, Zd = 27, gg = 32, AL = 33, DL = 34, ML = 35, TL = 36, $L = 37, NL = 38, IL = 39, LL = 40, Q1, kL = (Q1 = {}, Q1[_L] = !0, Q1[jL] = !0, Q1), yg = function(e) {
  kL[e.keyCode] && e.preventDefault();
}, xu = function() {
  var e = "visibilitychange";
  if (typeof document > "u")
    return e;
  var t = [e, "ms" + e, "webkit" + e, "moz" + e, "o" + e], r = ha(t, function(n) {
    return "on" + n in document;
  });
  return r || e;
}(), bg = 0, pp = 5;
function RL(e, t) {
  return Math.abs(t.x - e.x) >= pp || Math.abs(t.y - e.y) >= pp;
}
var hp = {
  type: "IDLE"
};
function BL(e) {
  var t = e.cancel, r = e.completed, n = e.getPhase, a = e.setPhase;
  return [{
    eventName: "mousemove",
    fn: function(o) {
      var s = o.button, l = o.clientX, c = o.clientY;
      if (s === bg) {
        var u = {
          x: l,
          y: c
        }, d = n();
        if (d.type === "DRAGGING") {
          o.preventDefault(), d.actions.move(u);
          return;
        }
        d.type !== "PENDING" && (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot be IDLE") : Y(!1));
        var p = d.point;
        if (RL(p, u)) {
          o.preventDefault();
          var h = d.actions.fluidLift(u);
          a({
            type: "DRAGGING",
            actions: h
          });
        }
      }
    }
  }, {
    eventName: "mouseup",
    fn: function(o) {
      var s = n();
      if (s.type !== "DRAGGING") {
        t();
        return;
      }
      o.preventDefault(), s.actions.drop({
        shouldBlockNextClick: !0
      }), r();
    }
  }, {
    eventName: "mousedown",
    fn: function(o) {
      n().type === "DRAGGING" && o.preventDefault(), t();
    }
  }, {
    eventName: "keydown",
    fn: function(o) {
      var s = n();
      if (s.type === "PENDING") {
        t();
        return;
      }
      if (o.keyCode === Zd) {
        o.preventDefault(), t();
        return;
      }
      yg(o);
    }
  }, {
    eventName: "resize",
    fn: t
  }, {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: function() {
      n().type === "PENDING" && t();
    }
  }, {
    eventName: "webkitmouseforcedown",
    fn: function(o) {
      var s = n();
      if (s.type === "IDLE" && (process.env.NODE_ENV !== "production" ? Y(!1, "Unexpected phase") : Y(!1)), s.actions.shouldRespectForcePress()) {
        t();
        return;
      }
      o.preventDefault();
    }
  }, {
    eventName: xu,
    fn: t
  }];
}
function VL(e) {
  var t = ve(hp), r = ve(ea), n = He(function() {
    return {
      eventName: "mousedown",
      fn: function(d) {
        if (!d.defaultPrevented && d.button === bg && !(d.ctrlKey || d.metaKey || d.shiftKey || d.altKey)) {
          var p = e.findClosestDraggableId(d);
          if (p) {
            var h = e.tryGetLock(p, o, {
              sourceEvent: d
            });
            if (h) {
              d.preventDefault();
              var m = {
                x: d.clientX,
                y: d.clientY
              };
              r.current(), c(h, m);
            }
          }
        }
      }
    };
  }, [e]), a = He(function() {
    return {
      eventName: "webkitmouseforcewillbegin",
      fn: function(d) {
        if (!d.defaultPrevented) {
          var p = e.findClosestDraggableId(d);
          if (p) {
            var h = e.findOptionsForDraggable(p);
            h && (h.shouldRespectForcePress || e.canGetLock(p) && d.preventDefault());
          }
        }
      }
    };
  }, [e]), i = ge(function() {
    var d = {
      passive: !1,
      capture: !0
    };
    r.current = Nr(window, [a, n], d);
  }, [a, n]), o = ge(function() {
    var u = t.current;
    u.type !== "IDLE" && (t.current = hp, r.current(), i());
  }, [i]), s = ge(function() {
    var u = t.current;
    o(), u.type === "DRAGGING" && u.actions.cancel({
      shouldBlockNextClick: !0
    }), u.type === "PENDING" && u.actions.abort();
  }, [o]), l = ge(function() {
    var d = {
      capture: !0,
      passive: !1
    }, p = BL({
      cancel: s,
      completed: o,
      getPhase: function() {
        return t.current;
      },
      setPhase: function(m) {
        t.current = m;
      }
    });
    r.current = Nr(window, p, d);
  }, [s, o]), c = ge(function(d, p) {
    t.current.type !== "IDLE" && (process.env.NODE_ENV !== "production" ? Y(!1, "Expected to move from IDLE to PENDING drag") : Y(!1)), t.current = {
      type: "PENDING",
      point: p,
      actions: d
    }, l();
  }, [l]);
  Or(function() {
    return i(), function() {
      r.current();
    };
  }, [i]);
}
var hi;
function HL() {
}
var FL = (hi = {}, hi[DL] = !0, hi[AL] = !0, hi[TL] = !0, hi[ML] = !0, hi);
function WL(e, t) {
  function r() {
    t(), e.cancel();
  }
  function n() {
    t(), e.drop();
  }
  return [{
    eventName: "keydown",
    fn: function(i) {
      if (i.keyCode === Zd) {
        i.preventDefault(), r();
        return;
      }
      if (i.keyCode === gg) {
        i.preventDefault(), n();
        return;
      }
      if (i.keyCode === LL) {
        i.preventDefault(), e.moveDown();
        return;
      }
      if (i.keyCode === NL) {
        i.preventDefault(), e.moveUp();
        return;
      }
      if (i.keyCode === IL) {
        i.preventDefault(), e.moveRight();
        return;
      }
      if (i.keyCode === $L) {
        i.preventDefault(), e.moveLeft();
        return;
      }
      if (FL[i.keyCode]) {
        i.preventDefault();
        return;
      }
      yg(i);
    }
  }, {
    eventName: "mousedown",
    fn: r
  }, {
    eventName: "mouseup",
    fn: r
  }, {
    eventName: "click",
    fn: r
  }, {
    eventName: "touchstart",
    fn: r
  }, {
    eventName: "resize",
    fn: r
  }, {
    eventName: "wheel",
    fn: r,
    options: {
      passive: !0
    }
  }, {
    eventName: xu,
    fn: r
  }];
}
function zL(e) {
  var t = ve(HL), r = He(function() {
    return {
      eventName: "keydown",
      fn: function(i) {
        if (i.defaultPrevented || i.keyCode !== gg)
          return;
        var o = e.findClosestDraggableId(i);
        if (!o)
          return;
        var s = e.tryGetLock(o, u, {
          sourceEvent: i
        });
        if (!s)
          return;
        i.preventDefault();
        var l = !0, c = s.snapLift();
        t.current();
        function u() {
          l || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot stop capturing a keyboard drag when not capturing") : Y(!1)), l = !1, t.current(), n();
        }
        t.current = Nr(window, WL(c, u), {
          capture: !0,
          passive: !1
        });
      }
    };
  }, [e]), n = ge(function() {
    var i = {
      passive: !1,
      capture: !0
    };
    t.current = Nr(window, [r], i);
  }, [r]);
  Or(function() {
    return n(), function() {
      t.current();
    };
  }, [n]);
}
var H2 = {
  type: "IDLE"
}, UL = 120, ZL = 0.15;
function qL(e) {
  var t = e.cancel, r = e.getPhase;
  return [{
    eventName: "orientationchange",
    fn: t
  }, {
    eventName: "resize",
    fn: t
  }, {
    eventName: "contextmenu",
    fn: function(a) {
      a.preventDefault();
    }
  }, {
    eventName: "keydown",
    fn: function(a) {
      if (r().type !== "DRAGGING") {
        t();
        return;
      }
      a.keyCode === Zd && a.preventDefault(), t();
    }
  }, {
    eventName: xu,
    fn: t
  }];
}
function GL(e) {
  var t = e.cancel, r = e.completed, n = e.getPhase;
  return [{
    eventName: "touchmove",
    options: {
      capture: !1
    },
    fn: function(i) {
      var o = n();
      if (o.type !== "DRAGGING") {
        t();
        return;
      }
      o.hasMoved = !0;
      var s = i.touches[0], l = s.clientX, c = s.clientY, u = {
        x: l,
        y: c
      };
      i.preventDefault(), o.actions.move(u);
    }
  }, {
    eventName: "touchend",
    fn: function(i) {
      var o = n();
      if (o.type !== "DRAGGING") {
        t();
        return;
      }
      i.preventDefault(), o.actions.drop({
        shouldBlockNextClick: !0
      }), r();
    }
  }, {
    eventName: "touchcancel",
    fn: function(i) {
      if (n().type !== "DRAGGING") {
        t();
        return;
      }
      i.preventDefault(), t();
    }
  }, {
    eventName: "touchforcechange",
    fn: function(i) {
      var o = n();
      o.type === "IDLE" && (process.env.NODE_ENV, Y(!1));
      var s = i.touches[0];
      if (s) {
        var l = s.force >= ZL;
        if (l) {
          var c = o.actions.shouldRespectForcePress();
          if (o.type === "PENDING") {
            c && t();
            return;
          }
          if (c) {
            if (o.hasMoved) {
              i.preventDefault();
              return;
            }
            t();
            return;
          }
          i.preventDefault();
        }
      }
    }
  }, {
    eventName: xu,
    fn: t
  }];
}
function YL(e) {
  var t = ve(H2), r = ve(ea), n = ge(function() {
    return t.current;
  }, []), a = ge(function(h) {
    t.current = h;
  }, []), i = He(function() {
    return {
      eventName: "touchstart",
      fn: function(h) {
        if (!h.defaultPrevented) {
          var m = e.findClosestDraggableId(h);
          if (m) {
            var v = e.tryGetLock(m, s, {
              sourceEvent: h
            });
            if (v) {
              var g = h.touches[0], b = g.clientX, C = g.clientY, w = {
                x: b,
                y: C
              };
              r.current(), d(v, w);
            }
          }
        }
      }
    };
  }, [e]), o = ge(function() {
    var h = {
      capture: !0,
      passive: !1
    };
    r.current = Nr(window, [i], h);
  }, [i]), s = ge(function() {
    var p = t.current;
    p.type !== "IDLE" && (p.type === "PENDING" && clearTimeout(p.longPressTimerId), a(H2), r.current(), o());
  }, [o, a]), l = ge(function() {
    var p = t.current;
    s(), p.type === "DRAGGING" && p.actions.cancel({
      shouldBlockNextClick: !0
    }), p.type === "PENDING" && p.actions.abort();
  }, [s]), c = ge(function() {
    var h = {
      capture: !0,
      passive: !1
    }, m = {
      cancel: l,
      completed: s,
      getPhase: n
    }, v = Nr(window, GL(m), h), g = Nr(window, qL(m), h);
    r.current = function() {
      v(), g();
    };
  }, [l, n, s]), u = ge(function() {
    var h = n();
    h.type !== "PENDING" && (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot start dragging from phase " + h.type) : Y(!1));
    var m = h.actions.fluidLift(h.point);
    a({
      type: "DRAGGING",
      actions: m,
      hasMoved: !1
    });
  }, [n, a]), d = ge(function(h, m) {
    n().type !== "IDLE" && (process.env.NODE_ENV !== "production" ? Y(!1, "Expected to move from IDLE to PENDING drag") : Y(!1));
    var v = setTimeout(u, UL);
    a({
      type: "PENDING",
      point: m,
      actions: h,
      longPressTimerId: v
    }), c();
  }, [c, n, a, u]);
  Or(function() {
    return o(), function() {
      r.current();
      var m = n();
      m.type === "PENDING" && (clearTimeout(m.longPressTimerId), a(H2));
    };
  }, [n, o, a]), Or(function() {
    var h = Nr(window, [{
      eventName: "touchmove",
      fn: function() {
      },
      options: {
        capture: !1,
        passive: !1
      }
    }]);
    return h;
  }, []);
}
function KL(e) {
  zd(function() {
    var t = Ud(e);
    T1(function() {
      t.current.length !== e.length && (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot change the amount of sensor hooks after mounting") : Y(!1));
    });
  });
}
var XL = {
  input: !0,
  button: !0,
  textarea: !0,
  select: !0,
  option: !0,
  optgroup: !0,
  video: !0,
  audio: !0
};
function Cg(e, t) {
  if (t == null)
    return !1;
  var r = !!XL[t.tagName.toLowerCase()];
  if (r)
    return !0;
  var n = t.getAttribute("contenteditable");
  return n === "true" || n === "" ? !0 : t === e ? !1 : Cg(e, t.parentElement);
}
function QL(e, t) {
  var r = t.target;
  return M1(r) ? Cg(e, r) : !1;
}
var JL = function(e) {
  return Gr(e.getBoundingClientRect()).center;
};
function ek(e) {
  return e instanceof vg(e).Element;
}
var tk = function() {
  var e = "matches";
  if (typeof document > "u")
    return e;
  var t = [e, "msMatchesSelector", "webkitMatchesSelector"], r = ha(t, function(n) {
    return n in Element.prototype;
  });
  return r || e;
}();
function xg(e, t) {
  return e == null ? null : e[tk](t) ? e : xg(e.parentElement, t);
}
function rk(e, t) {
  return e.closest ? e.closest(t) : xg(e, t);
}
function nk(e) {
  return "[" + Vi.contextId + '="' + e + '"]';
}
function ak(e, t) {
  var r = t.target;
  if (!ek(r))
    return process.env.NODE_ENV !== "production" && pt("event.target must be a Element"), null;
  var n = nk(e), a = rk(r, n);
  return a ? M1(a) ? a : (process.env.NODE_ENV !== "production" && pt("drag handle must be a HTMLElement"), null) : null;
}
function ik(e, t) {
  var r = ak(e, t);
  return r ? r.getAttribute(Vi.draggableId) : null;
}
function ok(e, t) {
  var r = "[" + o0.contextId + '="' + e + '"]', n = km(document.querySelectorAll(r)), a = ha(n, function(i) {
    return i.getAttribute(o0.id) === t;
  });
  return a ? M1(a) ? a : (process.env.NODE_ENV !== "production" && pt("Draggable element is not a HTMLElement"), null) : null;
}
function sk(e) {
  e.preventDefault();
}
function J1(e) {
  var t = e.expected, r = e.phase, n = e.isLockActive, a = e.shouldWarn;
  return n() ? t !== r ? (a && process.env.NODE_ENV !== "production" && pt(`
        Cannot perform action.
        The actions you used belong to an outdated phase

        Current phase: ` + t + `
        You called an action from outdated phase: ` + r + `

        Tips:

        - Do not use preDragActions actions after calling preDragActions.lift()
      `), !1) : !0 : (a && process.env.NODE_ENV !== "production" && pt(`
        Cannot perform action.
        The sensor no longer has an action lock.

        Tips:

        - Throw away your action handlers when forceStop() is called
        - Check actions.isActive() if you really need to
      `), !1);
}
function wg(e) {
  var t = e.lockAPI, r = e.store, n = e.registry, a = e.draggableId;
  if (t.isClaimed())
    return !1;
  var i = n.draggable.findById(a);
  return i ? !(!i.options.isEnabled || !fg(r.getState(), a)) : (process.env.NODE_ENV !== "production" && pt("Unable to find draggable with id: " + a), !1);
}
function lk(e) {
  var t = e.lockAPI, r = e.contextId, n = e.store, a = e.registry, i = e.draggableId, o = e.forceSensorStop, s = e.sourceEvent, l = wg({
    lockAPI: t,
    store: n,
    registry: a,
    draggableId: i
  });
  if (!l)
    return null;
  var c = a.draggable.getById(i), u = ok(r, c.descriptor.id);
  if (!u)
    return process.env.NODE_ENV !== "production" && pt("Unable to find draggable element with id: " + i), null;
  if (s && !c.options.canDragInteractiveElements && QL(u, s))
    return null;
  var d = t.claim(o || ea), p = "PRE_DRAG";
  function h() {
    return c.options.shouldRespectForcePress;
  }
  function m() {
    return t.isActive(d);
  }
  function v(O, P) {
    J1({
      expected: O,
      phase: p,
      isLockActive: m,
      shouldWarn: !0
    }) && n.dispatch(P());
  }
  var g = v.bind(null, "DRAGGING");
  function b(O) {
    function P() {
      t.release(), p = "COMPLETED";
    }
    p !== "PRE_DRAG" && (P(), p !== "PRE_DRAG" && (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot lift in phase " + p) : Y(!1))), n.dispatch(qN(O.liftActionArgs)), p = "DRAGGING";
    function j(T, I) {
      if (I === void 0 && (I = {
        shouldBlockNextClick: !1
      }), O.cleanup(), I.shouldBlockNextClick) {
        var R = Nr(window, [{
          eventName: "click",
          fn: sk,
          options: {
            once: !0,
            passive: !1,
            capture: !0
          }
        }]);
        setTimeout(R);
      }
      P(), n.dispatch(ag({
        reason: T
      }));
    }
    return Ce({
      isActive: function() {
        return J1({
          expected: "DRAGGING",
          phase: p,
          isLockActive: m,
          shouldWarn: !1
        });
      },
      shouldRespectForcePress: h,
      drop: function(I) {
        return j("DROP", I);
      },
      cancel: function(I) {
        return j("CANCEL", I);
      }
    }, O.actions);
  }
  function C(O) {
    var P = Ns(function(T) {
      g(function() {
        return ng({
          client: T
        });
      });
    }), j = b({
      liftActionArgs: {
        id: i,
        clientSelection: O,
        movementMode: "FLUID"
      },
      cleanup: function() {
        return P.cancel();
      },
      actions: {
        move: P
      }
    });
    return Ce({}, j, {
      move: P
    });
  }
  function w() {
    var O = {
      moveUp: function() {
        return g(rI);
      },
      moveRight: function() {
        return g(aI);
      },
      moveDown: function() {
        return g(nI);
      },
      moveLeft: function() {
        return g(iI);
      }
    };
    return b({
      liftActionArgs: {
        id: i,
        clientSelection: JL(u),
        movementMode: "SNAP"
      },
      cleanup: ea,
      actions: O
    });
  }
  function x() {
    var O = J1({
      expected: "PRE_DRAG",
      phase: p,
      isLockActive: m,
      shouldWarn: !0
    });
    O && t.release();
  }
  var y = {
    isActive: function() {
      return J1({
        expected: "PRE_DRAG",
        phase: p,
        isLockActive: m,
        shouldWarn: !1
      });
    },
    shouldRespectForcePress: h,
    fluidLift: C,
    snapLift: w,
    abort: x
  };
  return y;
}
var ck = [VL, zL, YL];
function uk(e) {
  var t = e.contextId, r = e.store, n = e.registry, a = e.customSensors, i = e.enableDefaultSensors, o = [].concat(i ? ck : [], a || []), s = ye(function() {
    return EL();
  })[0], l = ge(function(C, w) {
    C.isDragging && !w.isDragging && s.tryAbandon();
  }, [s]);
  Or(function() {
    var C = r.getState(), w = r.subscribe(function() {
      var x = r.getState();
      l(C, x), C = x;
    });
    return w;
  }, [s, r, l]), Or(function() {
    return s.tryAbandon;
  }, [s.tryAbandon]);
  var c = ge(function(b) {
    return wg({
      lockAPI: s,
      registry: n,
      store: r,
      draggableId: b
    });
  }, [s, n, r]), u = ge(function(b, C, w) {
    return lk({
      lockAPI: s,
      registry: n,
      contextId: t,
      store: r,
      draggableId: b,
      forceSensorStop: C,
      sourceEvent: w && w.sourceEvent ? w.sourceEvent : null
    });
  }, [t, s, n, r]), d = ge(function(b) {
    return ik(t, b);
  }, [t]), p = ge(function(b) {
    var C = n.draggable.findById(b);
    return C ? C.options : null;
  }, [n.draggable]), h = ge(function() {
    s.isClaimed() && (s.tryAbandon(), r.getState().phase !== "IDLE" && r.dispatch(Nd()));
  }, [s, r]), m = ge(s.isClaimed, [s]), v = He(function() {
    return {
      canGetLock: c,
      tryGetLock: u,
      findClosestDraggableId: d,
      findOptionsForDraggable: p,
      tryReleaseLock: h,
      isLockClaimed: m
    };
  }, [c, u, d, p, h, m]);
  KL(o);
  for (var g = 0; g < o.length; g++)
    o[g](v);
}
var fk = function(t) {
  return {
    onBeforeCapture: t.onBeforeCapture,
    onBeforeDragStart: t.onBeforeDragStart,
    onDragStart: t.onDragStart,
    onDragEnd: t.onDragEnd,
    onDragUpdate: t.onDragUpdate
  };
};
function Go(e) {
  return e.current || (process.env.NODE_ENV !== "production" ? Y(!1, "Could not find store from lazy ref") : Y(!1)), e.current;
}
function dk(e) {
  var t = e.contextId, r = e.setCallbacks, n = e.sensors, a = e.nonce, i = e.dragHandleUsageInstructions, o = ve(null);
  PL();
  var s = Ud(e), l = ge(function() {
    return fk(s.current);
  }, [s]), c = vL(t), u = bL({
    contextId: t,
    text: i
  }), d = cL(t, a), p = ge(function(T) {
    Go(o).dispatch(T);
  }, []), h = He(function() {
    return A7({
      publishWhileDragging: YN,
      updateDroppableScroll: XN,
      updateDroppableIsEnabled: QN,
      updateDroppableIsCombineEnabled: JN,
      collectionStarting: KN
    }, p);
  }, [p]), m = dL(), v = He(function() {
    return HI(m, h);
  }, [m, h]), g = He(function() {
    return aL(Ce({
      scrollWindow: FI,
      scrollDroppable: v.scrollDroppable
    }, A7({
      move: ng
    }, p)));
  }, [v.scrollDroppable, p]), b = uL(t), C = He(function() {
    return kI({
      announce: c,
      autoScroller: g,
      dimensionMarshal: v,
      focusMarshal: b,
      getResponders: l,
      styleMarshal: d
    });
  }, [c, g, v, b, l, d]);
  process.env.NODE_ENV !== "production" && o.current && o.current !== C && process.env.NODE_ENV !== "production" && pt("unexpected store change"), o.current = C;
  var w = ge(function() {
    var T = Go(o), I = T.getState();
    I.phase !== "IDLE" && T.dispatch(Nd());
  }, []), x = ge(function() {
    var T = Go(o).getState();
    return T.isDragging || T.phase === "DROP_ANIMATING";
  }, []), y = He(function() {
    return {
      isDragging: x,
      tryAbort: w
    };
  }, [x, w]);
  r(y);
  var O = ge(function(T) {
    return fg(Go(o).getState(), T);
  }, []), P = ge(function() {
    return Ta(Go(o).getState());
  }, []), j = He(function() {
    return {
      marshal: v,
      focus: b,
      contextId: t,
      canLift: O,
      isMovementAllowed: P,
      dragHandleUsageInstructionsId: u,
      registry: m
    };
  }, [t, v, u, b, O, P, m]);
  return uk({
    contextId: t,
    store: C,
    registry: m,
    customSensors: n,
    enableDefaultSensors: e.enableDefaultSensors !== !1
  }), _e(function() {
    return w;
  }, [w]), E.createElement(Cu.Provider, {
    value: j
  }, E.createElement(Om, {
    context: Fd,
    store: C
  }, e.children));
}
var pk = 0;
function hk() {
  return He(function() {
    return "" + pk++;
  }, []);
}
function vk(e) {
  var t = hk(), r = e.dragHandleUsageInstructions || Cl.dragHandleUsageInstructions;
  return E.createElement(L$, null, function(n) {
    return E.createElement(dk, {
      nonce: e.nonce,
      contextId: t,
      setCallbacks: n,
      dragHandleUsageInstructions: r,
      enableDefaultSensors: e.enableDefaultSensors,
      sensors: e.sensors,
      onBeforeCapture: e.onBeforeCapture,
      onBeforeDragStart: e.onBeforeDragStart,
      onDragStart: e.onDragStart,
      onDragUpdate: e.onDragUpdate,
      onDragEnd: e.onDragEnd
    }, e.children);
  });
}
var qd = function(t) {
  return function(r) {
    return t === r;
  };
}, mk = qd("scroll"), gk = qd("auto"), yk = qd("visible"), vp = function(t, r) {
  return r(t.overflowX) || r(t.overflowY);
}, bk = function(t, r) {
  return r(t.overflowX) && r(t.overflowY);
}, Og = function(t) {
  var r = window.getComputedStyle(t), n = {
    overflowX: r.overflowX,
    overflowY: r.overflowY
  };
  return vp(n, mk) || vp(n, gk);
}, Ck = function() {
  if (process.env.NODE_ENV === "production")
    return !1;
  var t = Vs(), r = document.documentElement;
  if (r || (process.env.NODE_ENV, Y(!1)), !Og(t))
    return !1;
  var n = window.getComputedStyle(r), a = {
    overflowX: n.overflowX,
    overflowY: n.overflowY
  };
  return bk(a, yk) || process.env.NODE_ENV !== "production" && pt(`
    We have detected that your <body> element might be a scroll container.
    We have found no reliable way of detecting whether the <body> element is a scroll container.
    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)

    Because we cannot determine if the <body> is a scroll container, and generally it is not one,
    we will be treating the <body> as *not* a scroll container

    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-detect-scroll-containers.md
  `), !1;
}, Sg = function e(t) {
  return t == null ? null : t === document.body ? Ck() ? t : null : t === document.documentElement ? null : Og(t) ? t : e(t.parentElement);
}, xk = function(e) {
  if (e) {
    var t = Sg(e.parentElement);
    t && process.env.NODE_ENV !== "production" && pt(`
    Droppable: unsupported nested scroll container detected.
    A Droppable can only have one scroll parent (which can be itself)
    Nested scroll containers are currently not supported.

    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131
  `);
  }
}, s0 = function(e) {
  return {
    x: e.scrollLeft,
    y: e.scrollTop
  };
}, wk = function e(t) {
  if (!t)
    return !1;
  var r = window.getComputedStyle(t);
  return r.position === "fixed" ? !0 : e(t.parentElement);
}, Ok = function(e) {
  var t = Sg(e), r = wk(e);
  return {
    closestScrollable: t,
    isFixedOnPage: r
  };
}, Sk = function(e) {
  var t = e.descriptor, r = e.isEnabled, n = e.isCombineEnabled, a = e.isFixedOnPage, i = e.direction, o = e.client, s = e.page, l = e.closest, c = function() {
    if (!l)
      return null;
    var h = l.scrollSize, m = l.client, v = lg({
      scrollHeight: h.scrollHeight,
      scrollWidth: h.scrollWidth,
      height: m.paddingBox.height,
      width: m.paddingBox.width
    });
    return {
      pageMarginBox: l.page.marginBox,
      frameClient: m,
      scrollSize: h,
      shouldClipSubject: l.shouldClipSubject,
      scroll: {
        initial: l.scroll,
        current: l.scroll,
        max: v,
        diff: {
          value: Zt,
          displacement: Zt
        }
      }
    };
  }(), u = i === "vertical" ? Ad : Fm, d = Ri({
    page: s,
    withPlaceholder: null,
    axis: u,
    frame: c
  }), p = {
    descriptor: t,
    isCombineEnabled: n,
    isFixedOnPage: a,
    axis: u,
    isEnabled: r,
    client: o,
    page: s,
    frame: c,
    subject: d
  };
  return p;
}, Pk = function(t, r) {
  var n = Tm(t);
  if (!r || t !== r)
    return n;
  var a = n.paddingBox.top - r.scrollTop, i = n.paddingBox.left - r.scrollLeft, o = a + r.scrollHeight, s = i + r.scrollWidth, l = {
    top: a,
    right: s,
    bottom: o,
    left: i
  }, c = Sd(l, n.border), u = Pd({
    borderBox: c,
    margin: n.margin,
    border: n.border,
    padding: n.padding
  });
  return u;
}, Ek = function(e) {
  var t = e.ref, r = e.descriptor, n = e.env, a = e.windowScroll, i = e.direction, o = e.isDropDisabled, s = e.isCombineEnabled, l = e.shouldClipSubject, c = n.closestScrollable, u = Pk(t, c), d = Wl(u, a), p = function() {
    if (!c)
      return null;
    var m = Tm(c), v = {
      scrollHeight: c.scrollHeight,
      scrollWidth: c.scrollWidth
    };
    return {
      client: m,
      page: Wl(m, a),
      scroll: s0(c),
      scrollSize: v,
      shouldClipSubject: l
    };
  }(), h = Sk({
    descriptor: r,
    isEnabled: !o,
    isCombineEnabled: s,
    isFixedOnPage: n.isFixedOnPage,
    direction: i,
    client: u,
    page: d,
    closest: p
  });
  return h;
}, jk = {
  passive: !1
}, _k = {
  passive: !0
}, mp = function(e) {
  return e.shouldPublishImmediately ? jk : _k;
};
function ql(e) {
  var t = Mt(e);
  return t || (process.env.NODE_ENV !== "production" ? Y(!1, "Could not find required context") : Y(!1)), t;
}
var el = function(t) {
  return t && t.env.closestScrollable || null;
};
function Ak(e) {
  var t = ve(null), r = ql(Cu), n = Wd("droppable"), a = r.registry, i = r.marshal, o = Ud(e), s = He(function() {
    return {
      id: e.droppableId,
      type: e.type,
      mode: e.mode
    };
  }, [e.droppableId, e.mode, e.type]), l = ve(s), c = He(function() {
    return Ut(function(x, y) {
      t.current || (process.env.NODE_ENV !== "production" ? Y(!1, "Can only update scroll when dragging") : Y(!1));
      var O = {
        x,
        y
      };
      i.updateDroppableScroll(s.id, O);
    });
  }, [s.id, i]), u = ge(function() {
    var x = t.current;
    return !x || !x.env.closestScrollable ? Zt : s0(x.env.closestScrollable);
  }, []), d = ge(function() {
    var x = u();
    c(x.x, x.y);
  }, [u, c]), p = He(function() {
    return Ns(d);
  }, [d]), h = ge(function() {
    var x = t.current, y = el(x);
    x && y || (process.env.NODE_ENV !== "production" ? Y(!1, "Could not find scroll options while scrolling") : Y(!1));
    var O = x.scrollOptions;
    if (O.shouldPublishImmediately) {
      d();
      return;
    }
    p();
  }, [p, d]), m = ge(function(x, y) {
    t.current && (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot collect a droppable while a drag is occurring") : Y(!1));
    var O = o.current, P = O.getDroppableRef();
    P || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot collect without a droppable ref") : Y(!1));
    var j = Ok(P), T = {
      ref: P,
      descriptor: s,
      env: j,
      scrollOptions: y
    };
    t.current = T;
    var I = Ek({
      ref: P,
      descriptor: s,
      env: j,
      windowScroll: x,
      direction: O.direction,
      isDropDisabled: O.isDropDisabled,
      isCombineEnabled: O.isCombineEnabled,
      shouldClipSubject: !O.ignoreContainerClipping
    }), R = j.closestScrollable;
    return R && (R.setAttribute(up.contextId, r.contextId), R.addEventListener("scroll", h, mp(T.scrollOptions)), process.env.NODE_ENV !== "production" && xk(R)), I;
  }, [r.contextId, s, h, o]), v = ge(function() {
    var x = t.current, y = el(x);
    return x && y || (process.env.NODE_ENV !== "production" ? Y(!1, "Can only recollect Droppable client for Droppables that have a scroll container") : Y(!1)), s0(y);
  }, []), g = ge(function() {
    var x = t.current;
    x || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot stop drag when no active drag") : Y(!1));
    var y = el(x);
    t.current = null, y && (p.cancel(), y.removeAttribute(up.contextId), y.removeEventListener("scroll", h, mp(x.scrollOptions)));
  }, [h, p]), b = ge(function(x) {
    var y = t.current;
    y || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot scroll when there is no drag") : Y(!1));
    var O = el(y);
    O || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot scroll a droppable with no closest scrollable") : Y(!1)), O.scrollTop += x.y, O.scrollLeft += x.x;
  }, []), C = He(function() {
    return {
      getDimensionAndWatchScroll: m,
      getScrollWhileDragging: v,
      dragStopped: g,
      scroll: b
    };
  }, [g, m, v, b]), w = He(function() {
    return {
      uniqueId: n,
      descriptor: s,
      callbacks: C
    };
  }, [C, s, n]);
  Or(function() {
    return l.current = w.descriptor, a.droppable.register(w), function() {
      t.current && (process.env.NODE_ENV !== "production" && pt("Unsupported: changing the droppableId or type of a Droppable during a drag"), g()), a.droppable.unregister(w);
    };
  }, [C, s, g, w, i, a.droppable]), Or(function() {
    t.current && i.updateDroppableIsEnabled(l.current.id, !e.isDropDisabled);
  }, [e.isDropDisabled, i]), Or(function() {
    t.current && i.updateDroppableIsCombineEnabled(l.current.id, e.isCombineEnabled);
  }, [e.isCombineEnabled, i]);
}
function F2() {
}
var gp = {
  width: 0,
  height: 0,
  margin: F$
}, Dk = function(t) {
  var r = t.isAnimatingOpenOnMount, n = t.placeholder, a = t.animate;
  return r || a === "close" ? gp : {
    height: n.client.borderBox.height,
    width: n.client.borderBox.width,
    margin: n.client.margin
  };
}, Mk = function(t) {
  var r = t.isAnimatingOpenOnMount, n = t.placeholder, a = t.animate, i = Dk({
    isAnimatingOpenOnMount: r,
    placeholder: n,
    animate: a
  });
  return {
    display: n.display,
    boxSizing: "border-box",
    width: i.width,
    height: i.height,
    marginTop: i.margin.top,
    marginRight: i.margin.right,
    marginBottom: i.margin.bottom,
    marginLeft: i.margin.left,
    flexShrink: "0",
    flexGrow: "0",
    pointerEvents: "none",
    transition: a !== "none" ? ys.placeholder : null
  };
};
function Tk(e) {
  var t = ve(null), r = ge(function() {
    t.current && (clearTimeout(t.current), t.current = null);
  }, []), n = e.animate, a = e.onTransitionEnd, i = e.onClose, o = e.contextId, s = ye(e.animate === "open"), l = s[0], c = s[1];
  _e(function() {
    return l ? n !== "open" ? (r(), c(!1), F2) : t.current ? F2 : (t.current = setTimeout(function() {
      t.current = null, c(!1);
    }), r) : F2;
  }, [n, l, r]);
  var u = ge(function(p) {
    p.propertyName === "height" && (a(), n === "close" && i());
  }, [n, i, a]), d = Mk({
    isAnimatingOpenOnMount: l,
    animate: e.animate,
    placeholder: e.placeholder
  });
  return E.createElement(e.placeholder.tagName, {
    style: d,
    "data-rbd-placeholder-context-id": o,
    onTransitionEnd: u,
    ref: e.innerRef
  });
}
var $k = E.memo(Tk), Gd = E.createContext(null);
function Pg(e) {
  e && M1(e) || (process.env.NODE_ENV !== "production" ? Y(!1, `
    provided.innerRef has not been provided with a HTMLElement.

    You can find a guide on using the innerRef callback functions at:
    https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md
  `) : Y(!1));
}
function W2(e) {
  return typeof e == "boolean";
}
function z2(e, t) {
  t.forEach(function(r) {
    return r(e);
  });
}
var Nk = [function(t) {
  var r = t.props;
  r.droppableId || (process.env.NODE_ENV !== "production" ? Y(!1, "A Droppable requires a droppableId prop") : Y(!1)), typeof r.droppableId != "string" && (process.env.NODE_ENV !== "production" ? Y(!1, "A Droppable requires a [string] droppableId. Provided: [" + typeof r.droppableId + "]") : Y(!1));
}, function(t) {
  var r = t.props;
  W2(r.isDropDisabled) || (process.env.NODE_ENV !== "production" ? Y(!1, "isDropDisabled must be a boolean") : Y(!1)), W2(r.isCombineEnabled) || (process.env.NODE_ENV !== "production" ? Y(!1, "isCombineEnabled must be a boolean") : Y(!1)), W2(r.ignoreContainerClipping) || (process.env.NODE_ENV !== "production" ? Y(!1, "ignoreContainerClipping must be a boolean") : Y(!1));
}, function(t) {
  var r = t.getDroppableRef;
  Pg(r());
}], Ik = [function(t) {
  var r = t.props, n = t.getPlaceholderRef;
  if (r.placeholder) {
    var a = n();
    a || process.env.NODE_ENV !== "production" && pt(`
      Droppable setup issue [droppableId: "` + r.droppableId + `"]:
      DroppableProvided > placeholder could not be found.

      Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.
      More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/droppable.md
    `);
  }
}], Lk = [function(t) {
  var r = t.props;
  r.renderClone || (process.env.NODE_ENV !== "production" ? Y(!1, "Must provide a clone render function (renderClone) for virtual lists") : Y(!1));
}, function(t) {
  var r = t.getPlaceholderRef;
  r() && (process.env.NODE_ENV !== "production" ? Y(!1, "Expected virtual list to not have a placeholder") : Y(!1));
}];
function kk(e) {
  T1(function() {
    z2(e, Nk), e.props.mode === "standard" && z2(e, Ik), e.props.mode === "virtual" && z2(e, Lk);
  });
}
var Rk = function(e) {
  gm(t, e);
  function t() {
    for (var n, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(i)) || this, n.state = {
      isVisible: !!n.props.on,
      data: n.props.on,
      animate: n.props.shouldAnimate && n.props.on ? "open" : "none"
    }, n.onClose = function() {
      n.state.animate === "close" && n.setState({
        isVisible: !1
      });
    }, n;
  }
  t.getDerivedStateFromProps = function(a, i) {
    return a.shouldAnimate ? a.on ? {
      isVisible: !0,
      data: a.on,
      animate: "open"
    } : i.isVisible ? {
      isVisible: !0,
      data: i.data,
      animate: "close"
    } : {
      isVisible: !1,
      animate: "close",
      data: null
    } : {
      isVisible: !!a.on,
      data: a.on,
      animate: "none"
    };
  };
  var r = t.prototype;
  return r.render = function() {
    if (!this.state.isVisible)
      return null;
    var a = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(a);
  }, t;
}(E.PureComponent), yp = {
  dragging: 5e3,
  dropAnimating: 4500
}, Bk = function(t, r) {
  return r ? ys.drop(r.duration) : t ? ys.snap : ys.fluid;
}, Vk = function(t, r) {
  return t ? r ? Bs.opacity.drop : Bs.opacity.combining : null;
}, Hk = function(t) {
  return t.forceShouldAnimate != null ? t.forceShouldAnimate : t.mode === "SNAP";
};
function Fk(e) {
  var t = e.dimension, r = t.client, n = e.offset, a = e.combineWith, i = e.dropping, o = !!a, s = Hk(e), l = !!i, c = l ? a0.drop(n, o) : a0.moveTo(n), u = {
    position: "fixed",
    top: r.marginBox.top,
    left: r.marginBox.left,
    boxSizing: "border-box",
    width: r.borderBox.width,
    height: r.borderBox.height,
    transition: Bk(s, i),
    transform: c,
    opacity: Vk(o, l),
    zIndex: l ? yp.dropAnimating : yp.dragging,
    pointerEvents: "none"
  };
  return u;
}
function Wk(e) {
  return {
    transform: a0.moveTo(e.offset),
    transition: e.shouldAnimateDisplacement ? null : "none"
  };
}
function zk(e) {
  return e.type === "DRAGGING" ? Fk(e) : Wk(e);
}
function Uk(e, t, r) {
  r === void 0 && (r = Zt);
  var n = window.getComputedStyle(t), a = t.getBoundingClientRect(), i = Mm(a, n), o = Wl(i, r), s = {
    client: i,
    tagName: t.tagName.toLowerCase(),
    display: n.display
  }, l = {
    x: i.marginBox.width,
    y: i.marginBox.height
  }, c = {
    descriptor: e,
    placeholder: s,
    displaceBy: l,
    client: i,
    page: o
  };
  return c;
}
function Zk(e) {
  var t = Wd("draggable"), r = e.descriptor, n = e.registry, a = e.getDraggableRef, i = e.canDragInteractiveElements, o = e.shouldRespectForcePress, s = e.isEnabled, l = He(function() {
    return {
      canDragInteractiveElements: i,
      shouldRespectForcePress: o,
      isEnabled: s
    };
  }, [i, s, o]), c = ge(function(h) {
    var m = a();
    return m || (process.env.NODE_ENV !== "production" ? Y(!1, "Cannot get dimension when no ref is set") : Y(!1)), Uk(r, m, h);
  }, [r, a]), u = He(function() {
    return {
      uniqueId: t,
      descriptor: r,
      options: l,
      getDimension: c
    };
  }, [r, c, l, t]), d = ve(u), p = ve(!0);
  Or(function() {
    return n.draggable.register(d.current), function() {
      return n.draggable.unregister(d.current);
    };
  }, [n.draggable]), Or(function() {
    if (p.current) {
      p.current = !1;
      return;
    }
    var h = d.current;
    d.current = u, n.draggable.update(u, h);
  }, [u, n.draggable]);
}
function qk(e, t, r) {
  T1(function() {
    function n(i) {
      return "Draggable[id: " + i + "]: ";
    }
    var a = e.draggableId;
    a || (process.env.NODE_ENV !== "production" ? Y(!1, "Draggable requires a draggableId") : Y(!1)), typeof a != "string" && (process.env.NODE_ENV !== "production" ? Y(!1, `Draggable requires a [string] draggableId.
      Provided: [type: ` + typeof a + "] (value: " + a + ")") : Y(!1)), Z$(e.index) || (process.env.NODE_ENV !== "production" ? Y(!1, n(a) + " requires an integer index prop") : Y(!1)), e.mapped.type !== "DRAGGING" && (Pg(r()), e.isEnabled && (mg(t, a) || (process.env.NODE_ENV !== "production" ? Y(!1, n(a) + " Unable to find drag handle") : Y(!1))));
  });
}
function Gk(e) {
  zd(function() {
    var t = ve(e);
    T1(function() {
      e !== t.current && (process.env.NODE_ENV !== "production" ? Y(!1, "Draggable isClone prop value changed during component life") : Y(!1));
    }, [e]);
  });
}
function Yk(e) {
  e.preventDefault();
}
function Kk(e) {
  var t = ve(null), r = ge(function(T) {
    t.current = T;
  }, []), n = ge(function() {
    return t.current;
  }, []), a = ql(Cu), i = a.contextId, o = a.dragHandleUsageInstructionsId, s = a.registry, l = ql(Gd), c = l.type, u = l.droppableId, d = He(function() {
    return {
      id: e.draggableId,
      index: e.index,
      type: c,
      droppableId: u
    };
  }, [e.draggableId, e.index, c, u]), p = e.children, h = e.draggableId, m = e.isEnabled, v = e.shouldRespectForcePress, g = e.canDragInteractiveElements, b = e.isClone, C = e.mapped, w = e.dropAnimationFinished;
  if (qk(e, i, n), Gk(b), !b) {
    var x = He(function() {
      return {
        descriptor: d,
        registry: s,
        getDraggableRef: n,
        canDragInteractiveElements: g,
        shouldRespectForcePress: v,
        isEnabled: m
      };
    }, [d, s, n, g, v, m]);
    Zk(x);
  }
  var y = He(function() {
    return m ? {
      tabIndex: 0,
      role: "button",
      "aria-describedby": o,
      "data-rbd-drag-handle-draggable-id": h,
      "data-rbd-drag-handle-context-id": i,
      draggable: !1,
      onDragStart: Yk
    } : null;
  }, [i, o, h, m]), O = ge(function(T) {
    C.type === "DRAGGING" && C.dropping && T.propertyName === "transform" && w();
  }, [w, C]), P = He(function() {
    var T = zk(C), I = C.type === "DRAGGING" && C.dropping ? O : null, R = {
      innerRef: r,
      draggableProps: {
        "data-rbd-draggable-context-id": i,
        "data-rbd-draggable-id": h,
        style: T,
        onTransitionEnd: I
      },
      dragHandleProps: y
    };
    return R;
  }, [i, y, h, C, O, r]), j = He(function() {
    return {
      draggableId: d.id,
      type: d.type,
      source: {
        index: d.index,
        droppableId: d.droppableId
      }
    };
  }, [d.droppableId, d.id, d.index, d.type]);
  return p(P, C.snapshot, j);
}
var Eg = function(e, t) {
  return e === t;
}, jg = function(e) {
  var t = e.combine, r = e.destination;
  return r ? r.droppableId : t ? t.droppableId : null;
}, Xk = function(t) {
  return t.combine ? t.combine.draggableId : null;
}, Qk = function(t) {
  return t.at && t.at.type === "COMBINE" ? t.at.combine.draggableId : null;
};
function Jk() {
  var e = Ut(function(a, i) {
    return {
      x: a,
      y: i
    };
  }), t = Ut(function(a, i, o, s, l) {
    return {
      isDragging: !0,
      isClone: i,
      isDropAnimating: !!l,
      dropAnimation: l,
      mode: a,
      draggingOver: o,
      combineWith: s,
      combineTargetFor: null
    };
  }), r = Ut(function(a, i, o, s, l, c, u) {
    return {
      mapped: {
        type: "DRAGGING",
        dropping: null,
        draggingOver: l,
        combineWith: c,
        mode: i,
        offset: a,
        dimension: o,
        forceShouldAnimate: u,
        snapshot: t(i, s, l, c, null)
      }
    };
  }), n = function(i, o) {
    if (i.isDragging) {
      if (i.critical.draggable.id !== o.draggableId)
        return null;
      var s = i.current.client.offset, l = i.dimensions.draggables[o.draggableId], c = wr(i.impact), u = Qk(i.impact), d = i.forceShouldAnimate;
      return r(e(s.x, s.y), i.movementMode, l, o.isClone, c, u, d);
    }
    if (i.phase === "DROP_ANIMATING") {
      var p = i.completed;
      if (p.result.draggableId !== o.draggableId)
        return null;
      var h = o.isClone, m = i.dimensions.draggables[o.draggableId], v = p.result, g = v.mode, b = jg(v), C = Xk(v), w = i.dropDuration, x = {
        duration: w,
        curve: Ld.drop,
        moveTo: i.newHomeClientOffset,
        opacity: C ? Bs.opacity.drop : null,
        scale: C ? Bs.scale.drop : null
      };
      return {
        mapped: {
          type: "DRAGGING",
          offset: i.newHomeClientOffset,
          dimension: m,
          dropping: x,
          draggingOver: b,
          combineWith: C,
          mode: g,
          forceShouldAnimate: null,
          snapshot: t(g, h, b, C, x)
        }
      };
    }
    return null;
  };
  return n;
}
function _g(e) {
  return {
    isDragging: !1,
    isDropAnimating: !1,
    isClone: !1,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: e,
    combineWith: null
  };
}
var eR = {
  mapped: {
    type: "SECONDARY",
    offset: Zt,
    combineTargetFor: null,
    shouldAnimateDisplacement: !0,
    snapshot: _g(null)
  }
};
function tR() {
  var e = Ut(function(o, s) {
    return {
      x: o,
      y: s
    };
  }), t = Ut(_g), r = Ut(function(o, s, l) {
    return s === void 0 && (s = null), {
      mapped: {
        type: "SECONDARY",
        offset: o,
        combineTargetFor: s,
        shouldAnimateDisplacement: l,
        snapshot: t(s)
      }
    };
  }), n = function(s) {
    return s ? r(Zt, s, !0) : null;
  }, a = function(s, l, c, u) {
    var d = c.displaced.visible[s], p = !!(u.inVirtualList && u.effected[s]), h = gu(c), m = h && h.draggableId === s ? l : null;
    if (!d) {
      if (!p)
        return n(m);
      if (c.displaced.invisible[s])
        return null;
      var v = Oo(u.displacedBy.point), g = e(v.x, v.y);
      return r(g, m, !0);
    }
    if (p)
      return n(m);
    var b = c.displacedBy.point, C = e(b.x, b.y);
    return r(C, m, d.shouldAnimate);
  }, i = function(s, l) {
    if (s.isDragging)
      return s.critical.draggable.id === l.draggableId ? null : a(l.draggableId, s.critical.draggable.id, s.impact, s.afterCritical);
    if (s.phase === "DROP_ANIMATING") {
      var c = s.completed;
      return c.result.draggableId === l.draggableId ? null : a(l.draggableId, c.result.draggableId, c.impact, c.afterCritical);
    }
    return null;
  };
  return i;
}
var rR = function() {
  var t = Jk(), r = tR(), n = function(i, o) {
    return t(i, o) || r(i, o) || eR;
  };
  return n;
}, nR = {
  dropAnimationFinished: ig
}, aR = Am(rR, nR, null, {
  context: Fd,
  pure: !0,
  areStatePropsEqual: Eg
})(Kk);
function Ag(e) {
  var t = ql(Gd), r = t.isUsingCloneFor;
  return r === e.draggableId && !e.isClone ? null : E.createElement(aR, e);
}
function iR(e) {
  var t = typeof e.isDragDisabled == "boolean" ? !e.isDragDisabled : !0, r = !!e.disableInteractiveElementBlocking, n = !!e.shouldRespectForcePress;
  return E.createElement(Ag, Ce({}, e, {
    isClone: !1,
    isEnabled: t,
    canDragInteractiveElements: r,
    shouldRespectForcePress: n
  }));
}
function oR(e) {
  var t = Mt(Cu);
  t || (process.env.NODE_ENV !== "production" ? Y(!1, "Could not find app context") : Y(!1));
  var r = t.contextId, n = t.isMovementAllowed, a = ve(null), i = ve(null), o = e.children, s = e.droppableId, l = e.type, c = e.mode, u = e.direction, d = e.ignoreContainerClipping, p = e.isDropDisabled, h = e.isCombineEnabled, m = e.snapshot, v = e.useClone, g = e.updateViewportMaxScroll, b = e.getContainerForClone, C = ge(function() {
    return a.current;
  }, []), w = ge(function(F) {
    a.current = F;
  }, []), x = ge(function() {
    return i.current;
  }, []), y = ge(function(F) {
    i.current = F;
  }, []);
  kk({
    props: e,
    getDroppableRef: C,
    getPlaceholderRef: x
  });
  var O = ge(function() {
    n() && g({
      maxScroll: ug()
    });
  }, [n, g]);
  Ak({
    droppableId: s,
    type: l,
    mode: c,
    direction: u,
    isDropDisabled: p,
    isCombineEnabled: h,
    ignoreContainerClipping: d,
    getDroppableRef: C
  });
  var P = E.createElement(Rk, {
    on: e.placeholder,
    shouldAnimate: e.shouldAnimatePlaceholder
  }, function(F) {
    var $ = F.onClose, Z = F.data, X = F.animate;
    return E.createElement($k, {
      placeholder: Z,
      onClose: $,
      innerRef: y,
      animate: X,
      contextId: r,
      onTransitionEnd: O
    });
  }), j = He(function() {
    return {
      innerRef: w,
      placeholder: P,
      droppableProps: {
        "data-rbd-droppable-id": s,
        "data-rbd-droppable-context-id": r
      }
    };
  }, [r, s, P, w]), T = v ? v.dragging.draggableId : null, I = He(function() {
    return {
      droppableId: s,
      type: l,
      isUsingCloneFor: T
    };
  }, [s, T, l]);
  function R() {
    if (!v)
      return null;
    var F = v.dragging, $ = v.render, Z = E.createElement(Ag, {
      draggableId: F.draggableId,
      index: F.source.index,
      isClone: !0,
      isEnabled: !0,
      shouldRespectForcePress: !1,
      canDragInteractiveElements: !0
    }, function(X, K) {
      return $(X, K, F);
    });
    return Xf.createPortal(Z, b());
  }
  return E.createElement(Gd.Provider, {
    value: I
  }, o(j, m), R());
}
var U2 = function(t, r) {
  return t === r.droppable.type;
}, bp = function(t, r) {
  return r.draggables[t.draggable.id];
}, sR = function() {
  var t = {
    placeholder: null,
    shouldAnimatePlaceholder: !0,
    snapshot: {
      isDraggingOver: !1,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: !1
    },
    useClone: null
  }, r = Ce({}, t, {
    shouldAnimatePlaceholder: !1
  }), n = Ut(function(o) {
    return {
      draggableId: o.id,
      type: o.type,
      source: {
        index: o.index,
        droppableId: o.droppableId
      }
    };
  }), a = Ut(function(o, s, l, c, u, d) {
    var p = u.descriptor.id, h = u.descriptor.droppableId === o;
    if (h) {
      var m = d ? {
        render: d,
        dragging: n(u.descriptor)
      } : null, v = {
        isDraggingOver: l,
        draggingOverWith: l ? p : null,
        draggingFromThisWith: p,
        isUsingPlaceholder: !0
      };
      return {
        placeholder: u.placeholder,
        shouldAnimatePlaceholder: !1,
        snapshot: v,
        useClone: m
      };
    }
    if (!s)
      return r;
    if (!c)
      return t;
    var g = {
      isDraggingOver: l,
      draggingOverWith: p,
      draggingFromThisWith: null,
      isUsingPlaceholder: !0
    };
    return {
      placeholder: u.placeholder,
      shouldAnimatePlaceholder: !0,
      snapshot: g,
      useClone: null
    };
  }), i = function(s, l) {
    var c = l.droppableId, u = l.type, d = !l.isDropDisabled, p = l.renderClone;
    if (s.isDragging) {
      var h = s.critical;
      if (!U2(u, h))
        return r;
      var m = bp(h, s.dimensions), v = wr(s.impact) === c;
      return a(c, d, v, v, m, p);
    }
    if (s.phase === "DROP_ANIMATING") {
      var g = s.completed;
      if (!U2(u, g.critical))
        return r;
      var b = bp(g.critical, s.dimensions);
      return a(c, d, jg(g.result) === c, wr(g.impact) === c, b, p);
    }
    if (s.phase === "IDLE" && s.completed && !s.shouldFlush) {
      var C = s.completed;
      if (!U2(u, C.critical))
        return r;
      var w = wr(C.impact) === c, x = !!(C.impact.at && C.impact.at.type === "COMBINE"), y = C.critical.droppable.id === c;
      return w ? x ? t : r : y ? t : r;
    }
    return r;
  };
  return i;
}, lR = {
  updateViewportMaxScroll: tI
};
function cR() {
  return document.body || (process.env.NODE_ENV !== "production" ? Y(!1, "document.body is not ready") : Y(!1)), document.body;
}
var uR = {
  mode: "standard",
  type: "DEFAULT",
  direction: "vertical",
  isDropDisabled: !1,
  isCombineEnabled: !1,
  ignoreContainerClipping: !1,
  renderClone: null,
  getContainerForClone: cR
}, Dg = Am(sR, lR, null, {
  context: Fd,
  pure: !0,
  areStatePropsEqual: Eg
})(oR);
Dg.defaultProps = uR;
const Mg = E.forwardRef((e, t) => {
  const {
    item: r,
    currentItem: n,
    resetCurrentItem: a
  } = e, i = Mt(yn), o = (i == null ? void 0 : i.isCollapsedMenu) ?? !1, s = (r == null ? void 0 : r.items) ?? [];
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: n !== null && n.id === r.id && s.length > 0 && /* @__PURE__ */ f.jsx("div", { ref: t, className: `fixed left-0 z-[30] w-full m:max-w-[288px] bg-secondary-200 top-0 bottom-[4.5rem] 2s:bottom-0 2s:top-[4.5rem] l:top-[5rem] ${o ? "m:left-[288px] l:left-[130px]" : "m:left-[288px]"}`, children: /* @__PURE__ */ f.jsxs("div", { className: "flex h-full flex-col", children: [
    /* @__PURE__ */ f.jsxs("div", { className: "flex items-center gap-4 justify-between p-4 border-b border-secondary-300 m:px-8", children: [
      /* @__PURE__ */ f.jsx("div", { className: "w-10 min-w-[40px] h-10 m:hidden", children: /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          onClick: a,
          className: "bg-secondary-300 hover:bg-secondary-400 w-full h-full flex items-center justify-center rounded-md text-secondary-600",
          children: /* @__PURE__ */ f.jsx(me, { variant: "back-arrow", width: 18 })
        }
      ) }),
      /* @__PURE__ */ f.jsx("div", { className: "flex-grow font-bold text-neutral-600 leading-[120%]", children: n.description }),
      /* @__PURE__ */ f.jsx("div", { className: "w-10 min-w-[40px] h-10 m:hidden", children: /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          onClick: i == null ? void 0 : i.closeMenu,
          className: "bg-secondary-300 hover:bg-secondary-400 w-full h-full flex items-center justify-center rounded-md text-secondary-600",
          children: /* @__PURE__ */ f.jsx(me, { variant: "close", width: 14 })
        }
      ) })
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: "flex-grow overflow-hidden px-4", children: /* @__PURE__ */ f.jsx("div", { className: "h-full max-h-[calc(100%-32px)] w-full max-w-[568px] my-4 mx-auto overflow-y-auto menu-subitems-scrollbar", children: /* @__PURE__ */ f.jsx("ul", { children: s.map((l) => /* @__PURE__ */ f.jsx(
      "li",
      {
        className: "px-4 py-2 font-bold text-secondary-600 cursor-pointer rounded-md hover:bg-secondary-300",
        onClick: () => {
          l.onClick !== void 0 && (l == null || l.onClick()), i == null || i.closeMenu(), a();
        },
        children: l.description
      },
      l.id
    )) }) }) })
  ] }) }) });
});
Mg.displayName = "MenuSubitems";
const Tg = (e) => {
  const {
    idx: t,
    item: r,
    currentItem: n,
    changeCurrentItem: a,
    resetCurrentItem: i
  } = e, {
    id: o,
    icon: s,
    items: l,
    isActive: c,
    description: u,
    onClick: d = () => {
    }
  } = r, p = l !== void 0, h = l ?? [], m = n !== null && n.id === r.id, v = Mt(yn), g = (v == null ? void 0 : v.isCollapsedMenu) ?? !1, [b, C] = ye(!1), w = () => {
    window.innerWidth >= 1024 && !b && a(r);
  }, x = () => {
    window.innerWidth >= 1024 && !b && i();
  }, y = () => {
    p ? C((O) => (O ? i() : a(r), !O)) : (d(), v == null || v.closeMenu());
  };
  return /* @__PURE__ */ f.jsx(iR, { draggableId: `${o}`, index: t, children: (O, P) => /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: O.innerRef,
      ...O.draggableProps,
      ...O.dragHandleProps,
      style: {
        cursor: "default",
        ...O.draggableProps.style
      },
      className: "select-none px-4",
      onMouseEnter: w,
      onMouseLeave: x,
      children: [
        /* @__PURE__ */ f.jsxs(
          "div",
          {
            title: u,
            className: $e([
              "min-h-[40px] py-2 flex items-center justify-between font-bold gap-2 cursor-pointer rounded-md px-2",
              m ? "bg-primary-500" : c ? P.isDragging ? "bg-primary-500" : "bg-primary-600" : P.isDragging ? "bg-secondary-800" : "bg-secondary-900"
            ]),
            onClick: y,
            children: [
              /* @__PURE__ */ f.jsxs("div", { className: "flex gap-2 items-center", children: [
                /* @__PURE__ */ f.jsx("span", { className: "opacity-[0.15] cursor-grab", children: /* @__PURE__ */ f.jsx(me, { variant: "drag" }) }),
                /* @__PURE__ */ f.jsxs("div", { className: "flex gap-2 items-center leading-none capitalize", children: [
                  /* @__PURE__ */ f.jsx("span", { className: "w-[20px] min-w-[20px]", children: /* @__PURE__ */ f.jsx(me, { variant: s, width: 20 }) }),
                  /* @__PURE__ */ f.jsx("span", { className: `${g ? "block l:hidden" : "block"}`, children: u })
                ] })
              ] }),
              p && h.length > 0 && /* @__PURE__ */ f.jsx("span", { className: `-rotate-90 ${b ? "rotate-0" : ""}`, children: /* @__PURE__ */ f.jsx(me, { variant: "arrow-down", width: 14 }) })
            ]
          }
        ),
        m && /* @__PURE__ */ f.jsx(
          Mg,
          {
            item: r,
            currentItem: n,
            resetCurrentItem: i
          }
        )
      ]
    }
  ) }, o);
};
Tg.displayName = "MenuItem";
const fR = ({ children: e, ...t }) => {
  const [r, n] = ye(!1);
  return _e(() => {
    const a = requestAnimationFrame(() => n(!0));
    return () => {
      cancelAnimationFrame(a), n(!1);
    };
  }, []), r ? /* @__PURE__ */ f.jsx(Dg, { ...t, children: e }) : null;
}, dR = (e, t, r) => {
  const n = Array.from(e), [a] = n.splice(t, 1);
  return n.splice(r, 0, a), n;
}, pR = E.forwardRef((e, t) => {
  const {
    className: r,
    items: n,
    activeHome: a,
    labelHome: i = "Inicio",
    onClickHome: o = () => {
    },
    onMenuDragged: s = () => {
    },
    ...l
  } = e, [c, u] = ye(n), [d, p] = ye(null), h = Mt(yn), m = (h == null ? void 0 : h.isOpenMenu) ?? !1, v = (h == null ? void 0 : h.isCollapsedMenu) ?? !1, g = (w) => {
    p(w);
  }, b = () => {
    p(null);
  }, C = ({ source: w, destination: x }) => {
    if (x == null)
      return;
    const y = dR(
      c,
      w.index,
      x.index
    );
    s({
      _newItems: y,
      item: {
        payload: y[x.index],
        indexes: {
          previous: w.index,
          new: x.index
        }
      }
    }), u(y);
  };
  return _e(() => {
    m || p(null);
  }, [m]), _e(() => {
    u(n);
  }, [n]), /* @__PURE__ */ f.jsxs(
    "ul",
    {
      ref: t,
      className: $e(["flex flex-col text-white select-none", r]),
      ...l,
      children: [
        /* @__PURE__ */ f.jsx("li", { className: "h-10 px-4", children: /* @__PURE__ */ f.jsx(
          "div",
          {
            className: `h-full flex gap-2 items-center justify-between font-bold cursor-pointer rounded-md pl-2 l:pl-[36px] pr-2 ${a === !0 ? "bg-primary-600 hover:bg-primary-500" : "hover:bg-secondary-800"}`,
            title: i,
            onClick: () => {
              o(), h == null || h.closeMenu();
            },
            children: /* @__PURE__ */ f.jsxs("div", { className: "flex gap-2 items-center", children: [
              /* @__PURE__ */ f.jsx(me, { variant: "home", width: 20 }),
              /* @__PURE__ */ f.jsx("span", { className: `${v ? "block l:hidden" : "block"}`, children: i })
            ] })
          }
        ) }),
        /* @__PURE__ */ f.jsx(vk, { onDragEnd: C, children: /* @__PURE__ */ f.jsx(fR, { droppableId: "droppable", children: (w) => /* @__PURE__ */ f.jsxs(
          "div",
          {
            ...w.droppableProps,
            ref: w.innerRef,
            children: [
              c.map((x, y) => /* @__PURE__ */ f.jsx(
                Tg,
                {
                  idx: y,
                  item: x,
                  currentItem: d,
                  changeCurrentItem: g,
                  resetCurrentItem: b
                },
                x.id
              )),
              w.placeholder
            ]
          }
        ) }) })
      ]
    }
  );
});
pR.displayName = "MenuItems";
const hR = E.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e, a = Mt(yn), i = (a == null ? void 0 : a.isOpenMenu) ?? !1, o = (a == null ? void 0 : a.isCollapsedMenu) ?? !1;
  return /* @__PURE__ */ f.jsx("aside", { ref: t, ...n, className: `fixed z-[1000] w-full bg-secondary-900 top-0 bottom-[4.5rem] 2s:bottom-0 2s:top-[4.5rem] l:top-[5rem] ${i ? "left-0" : "-left-[100vw] m:-left-[288px] l:left-0"} ${o ? "m:max-w-[288px] l:max-w-[130px]" : "m:max-w-[288px]"}`, children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col h-full w-full", children: [
    /* @__PURE__ */ f.jsxs("div", { className: "flex l:hidden items-center justify-between px-4 h-[72px] text-white border-b border-secondary-850", children: [
      /* @__PURE__ */ f.jsx($n, { variant: "heading-6", children: "Menú" }),
      /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          onClick: a == null ? void 0 : a.closeMenu,
          className: "w-10 aspect-square bg-secondary-850 hover:bg-secondary-600 rounded-md flex justify-center items-center",
          children: /* @__PURE__ */ f.jsx(me, { variant: "close", width: 14 })
        }
      )
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: "hidden l:flex items-center justify-end px-4 h-[56px] text-white border-b border-secondary-850", children: /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        onClick: a == null ? void 0 : a.toggleCollapsedMenu,
        className: "w-10 aspect-square bg-secondary-850 hover:bg-secondary-600 rounded-md flex justify-center items-center",
        children: /* @__PURE__ */ f.jsx("span", { className: `${o ? "-rotate-180" : ""}`, children: /* @__PURE__ */ f.jsx(me, { variant: "collect-menu", width: 20 }) })
      }
    ) }),
    /* @__PURE__ */ f.jsx("div", { className: "flex-grow max-h-[calc(100%-72px-56px-32px)] l:max-h-[calc(100%-56px-56px-32px)] w-full max-w-[600px] my-4 mx-auto", children: /* @__PURE__ */ f.jsx("div", { className: "h-full overflow-y-auto menu-wrapper-scrollbar", children: /* @__PURE__ */ f.jsx("div", { className: "flex flex-col gap-4", children: r }) }) }),
    /* @__PURE__ */ f.jsx("div", { className: "flex items-center justify-center px-4 h-[56px] text-white border-t border-secondary-850", children: /* @__PURE__ */ f.jsxs(
      "svg",
      {
        className: "w-[64px]",
        viewBox: "0 0 60 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M29.3638 0.179688L0 16.6058L17.2099 33.8205L29.3638 0.179688Z",
              fill: "#E15B3E"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M27.6655 29.1228C26.6398 29.1228 25.8027 28.9486 25.1641 28.5954L25.6721 27.3084C26.3204 27.5358 26.9784 27.6471 27.6461 27.6471C28.517 27.6471 28.9525 27.4052 28.9525 26.9214C28.9525 26.7375 28.8654 26.573 28.6912 26.4278C28.517 26.2779 28.2993 26.1569 28.038 26.065C27.7768 25.9682 27.4913 25.8521 27.1816 25.7069C26.872 25.5618 26.5865 25.4118 26.3253 25.2473C26.064 25.0876 25.8463 24.8554 25.6721 24.5506C25.4979 24.2506 25.406 23.9022 25.406 23.5055C25.406 22.8378 25.6721 22.3298 26.1995 21.9766C26.7268 21.6234 27.3558 21.4492 28.0864 21.4492C28.4541 21.4492 28.7928 21.4782 29.1025 21.5315C29.4169 21.5895 29.6492 21.6428 29.7992 21.7008C29.9492 21.7589 30.1572 21.8411 30.4185 21.9524L29.9008 23.1959C29.1895 22.9926 28.6041 22.891 28.1396 22.891C27.4865 22.891 27.1575 23.0894 27.1575 23.491C27.1575 23.6458 27.2494 23.791 27.4284 23.9216C27.6074 24.0571 27.83 24.1732 28.0961 24.2748C28.3622 24.3764 28.6525 24.5022 28.9621 24.6522C29.2718 24.8022 29.5621 24.9667 29.8282 25.1409C30.0943 25.315 30.3169 25.5521 30.4959 25.8473C30.6749 26.1424 30.7668 26.4762 30.7668 26.8488C30.7668 27.2407 30.6797 27.589 30.5056 27.889C30.3314 28.189 30.0943 28.4261 29.7943 28.6003C29.4944 28.7744 29.1654 28.9051 28.8073 28.9922C28.4493 29.0744 28.0671 29.118 27.6703 29.118L27.6655 29.1228Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ f.jsx("path", { d: "M32.5186 29.0056V21.5449H34.3136V29.0056H32.5186Z", fill: "white" }),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M35.7744 29.0056L38.6435 21.5449H40.9563L43.4673 29.0056H41.6094L40.903 26.8235H38.3823L37.5694 29.0056H35.7744ZM38.8564 25.522H40.4821L39.7322 22.6529L38.8564 25.522Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M48.3829 29.1121C47.0233 29.1121 45.9976 28.7879 45.296 28.1396C44.5945 27.4913 44.2461 26.5526 44.2461 25.3237C44.2461 22.7352 45.6105 21.4434 48.3393 21.4434C49.2199 21.4434 49.994 21.5933 50.6617 21.8982L50.1876 23.1948C49.7956 23.0884 49.486 23.0207 49.2683 22.9819C49.0505 22.9481 48.7457 22.9239 48.3587 22.919C47.6619 22.9045 47.1055 23.0932 46.6943 23.49C46.2782 23.8819 46.0701 24.4625 46.0701 25.2221C46.0701 25.9817 46.2927 26.5817 46.7475 26.9929C47.1975 27.409 47.8071 27.6171 48.5716 27.6171C49.1812 27.6171 49.7618 27.5445 50.3037 27.4042L50.6859 28.7541C50.0376 28.9911 49.2731 29.1121 48.3877 29.1121H48.3829Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M55.9162 29.1323C54.6292 29.1323 53.6567 28.7936 52.9987 28.1162C52.3407 27.4389 52.0117 26.4857 52.0117 25.2616C52.0117 24.0375 52.3794 23.1473 53.1149 22.4603C53.8503 21.7732 54.8518 21.4297 56.1146 21.4297C57.3774 21.4297 58.3886 21.778 59.0321 22.4748C59.6756 23.1715 59.9998 24.1053 59.9998 25.281C59.9998 26.4567 59.6466 27.4244 58.945 28.1066C58.2435 28.7888 57.2323 29.1323 55.9162 29.1323ZM55.9501 27.7195C56.7291 27.7195 57.2952 27.5018 57.6484 27.0615C58.0016 26.6212 58.1757 26.0261 58.1757 25.2713C58.1757 24.5165 57.9967 23.9456 57.6435 23.5053C57.2903 23.065 56.7484 22.8473 56.0227 22.8473C55.2969 22.8473 54.7163 23.065 54.3631 23.5005C54.0099 23.9359 53.8309 24.5214 53.8309 25.252C53.8309 25.9825 54.0051 26.5777 54.3535 27.0373C54.7018 27.4969 55.234 27.7243 55.9501 27.7243V27.7195Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M14.8873 26.7615L13.7067 25.3874C13.5277 25.4019 13.339 25.4019 13.1455 25.4019H12.3762V29.0065H9.85059V18.5605H13.9148C16.2662 18.5605 17.9451 19.6395 17.9451 21.9716C17.9451 23.1376 17.3838 24.1585 16.2614 24.7923L17.3258 25.9438C17.9016 26.5631 18.5499 26.9792 19.6869 27.2744L19.1256 29.1952C17.0887 29.0936 15.9807 28.0291 14.8873 26.7567",
              fill: "white"
            }
          )
        ]
      }
    ) })
  ] }) });
});
hR.displayName = "MenuWrapper";
const vR = E.forwardRef((e, t) => {
  const {
    size: r = "xl",
    isTop: n = !1,
    isOpen: a,
    children: i
  } = e, o = {
    sm: "px-4 max-w-[calc(474px+32px)]",
    xl: "px-0 2s:px-4 w-full 2s:max-w-[calc(944px+32px)]"
  };
  return _e(() => {
    if (!n)
      return a ? document.body.classList.add("overflow-y-hidden-modal") : document.body.classList.remove("overflow-y-hidden-modal"), () => {
        document.body.classList.remove("overflow-y-hidden-modal");
      };
  }, [a]), /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: `
        fixed overflow-x-hidden overflow-y-auto modal-scrollbar
        ${n ? "z-[10]" : "z-[1700]"}
        ${r === "xl" ? "bg-white 2s:bg-[rgba(3,56,108,0.6)] left-0 top-0 bottom-[4.5rem] 2s:bottom-0" : "bg-[rgba(3,56,108,0.6)] inset-0"}
        ${a ? "visible w-full" : "invisible w-0 h-0"}
      `,
      children: /* @__PURE__ */ f.jsx("div", { className: `flex ${r === "xl" ? "items-start 2s:items-center" : "items-center"} ${r === "xl" ? "my-0 2s:my-[28px]" : "my-[28px]"} mx-auto ${r === "xl" ? "min-h-full 2s:min-h-[calc(100%-56px)]" : "min-h-[calc(100%-56px)]"} w-full relative ${o[r]}`, children: /* @__PURE__ */ f.jsx("div", { className: `bg-white rounded-lg relative w-full ${a ? "scale-[1] transition-all" : "scale-[0.9]"}`, children: i }) })
    }
  );
});
vR.displayName = "Modal";
const mR = E.forwardRef((e, t) => {
  const {
    size: r = "sm",
    children: n
  } = e, a = {
    sm: "p-4 s:p-8",
    xl: "p-4 2s:p-12"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: a[r],
      children: n
    }
  );
});
mR.displayName = "ModalBody";
const gR = E.forwardRef((e, t) => {
  const {
    isOpen: r,
    children: n
  } = e;
  return _e(() => (r ? document.body.classList.add("overflow-y-hidden-modal") : document.body.classList.remove("overflow-y-hidden-modal"), () => {
    document.body.classList.remove("overflow-y-hidden-modal");
  }), [r]), /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: `
        fixed z-[900] l:z-[1500] left-0 top-0 bottom-[4.5rem] 2s:bottom-0 2s:top-[4.5rem] l:top-[5rem] overflow-x-hidden overflow-y-auto modal-focus-scrollbar bg-white
        ${r ? "visible w-full" : "invisible w-0 h-0"}
      `,
      children: /* @__PURE__ */ f.jsx("div", { className: "flex mx-autom mb-[80px] min-h-[calc(100%-80px)] w-full relative", children: /* @__PURE__ */ f.jsx("div", { className: `relative w-full ${r ? "scale-[1] transition-all" : "scale-[0.9]"}`, children: n }) })
    }
  );
});
gR.displayName = "ModalFocus";
const yR = E.forwardRef((e, t) => {
  const {
    size: r = "xl",
    children: n
  } = e, a = {
    xl: "p-4 2s:p-8"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: `${a[r]} border-b border-neutral-200`,
      children: n
    }
  );
});
yR.displayName = "ModalHeader";
const bR = E.forwardRef((e, t) => {
  const {
    size: r = "xl",
    children: n
  } = e, a = {
    xl: "p-4 2s:px-8 2s:pt-8 2s:pb-16"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: `${a[r]} border-t border-neutral-200`,
      children: n
    }
  );
});
bR.displayName = "ModalFooter";
const CR = E.forwardRef((e, t) => {
  const {
    children: r
  } = e;
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: "w-full max-w-[1300px] mx-auto", children: r });
});
CR.displayName = "ModalFocusContainer";
const xR = E.forwardRef((e, t) => {
  const {
    variant: r,
    children: n,
    srcBgImage: a,
    className: i,
    ...o
  } = e, s = {
    login: "bg-h-full bg-image relative",
    "password-recovery": "relative bg-h-full bg-image m:py-20",
    "change-password": "relative bg-h-full bg-image m:py-20"
  }, l = {
    login: "m:flex m:justify-center m:items-center m:min-h-[100vh] m:w-[45rem] m:pl-[3.2rem]",
    "password-recovery": "m-auto m:max-w-[51rem]",
    "change-password": "m-auto m:max-w-[51rem]"
  }, c = {
    login: "m:grid m:grid-cols-2",
    "password-recovery": "bg-white m:px-8 pt-8 m:pb-16 m:rounded-lg",
    "change-password": "bg-white pt-8 m:pb-16 m:rounded-lg"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: $e([s[r], i]),
      style: { backgroundImage: `url(${a})` },
      ...o,
      children: /* @__PURE__ */ f.jsx("div", { className: l[r], children: /* @__PURE__ */ f.jsxs("div", { className: c[r], children: [
        n,
        /* @__PURE__ */ f.jsx("footer", { ref: t, className: "bg-white border border-t m:absolute m:border-0 m:top-0 m:right-0 m:rounded-bl-lg", ...o, children: /* @__PURE__ */ f.jsx("div", { className: "brand p-4 flex justify-center", children: /* @__PURE__ */ f.jsx(yT, {}) }) })
      ] }) })
    }
  );
});
xR.displayName = "Spreen";
const wR = E.forwardRef((e, t) => {
  const {
    variant: r,
    children: n,
    className: a,
    isSuccessPasswordRecovery: i = !1,
    ...o
  } = e, s = {
    login: "my-[2rem] px-[1rem] m:px-[2rem] grid gap-[2rem]",
    "password-recovery": `grid gap-8 px-4 mb-4 m:mb-0 m:px-0 ${i ? "m:grid-cols-1 m-auto m:max-w-[17rem] py-8" : "m:grid-cols-2"}`,
    "change-password": `grid gap-8 px-4 mb-4 m:mb-0 ${i ? "m:grid-cols-1 m-auto m:max-w-[17rem] py-8 m:px-0" : "m:grid-cols-2 m:px-8"}`
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: $e([s[r], a]),
      ...o,
      children: n
    }
  );
});
wR.displayName = "SpreenBody";
const OR = E.forwardRef((e, t) => {
  const {
    children: r,
    className: n,
    ...a
  } = e;
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: $e(["border-t py-[4rem] text-center", n]),
      ...a,
      children: r
    }
  );
});
OR.displayName = "SpreenFooter";
const SR = E.forwardRef((e, t) => {
  const {
    children: r,
    className: n,
    ...a
  } = e;
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: t,
      className: $e(["bg-white m:rounded-l-lg", n]),
      ...a,
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "border-b py-8 flex justify-center", id: "LOGO", children: /* @__PURE__ */ f.jsx(mm, {}) }),
        r
      ]
    }
  );
});
SR.displayName = "SpreenLeft";
const PR = E.forwardRef((e, t) => {
  const {
    children: r,
    className: n,
    ...a
  } = e;
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: $e(["bg-secondary-800 text-white py-[2rem] px-[1rem] m:px-[2rem] m:rounded-r-lg", n]),
      ...a,
      children: r
    }
  );
});
PR.displayName = "SpreenRight";
const ER = E.forwardRef((e, t) => {
  const {
    variant: r,
    children: n,
    className: a,
    ...i
  } = e, o = {
    "password-recovery": "flex items-center justify-between border-b border-100 px-5 pb-8 mb-8 m:px-0",
    "change-password": "flex items-center justify-between border-b border-100 px-5 pb-8 mb-8 m:px-8"
  };
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: t,
      className: $e([o[r], a]),
      ...i,
      children: [
        n,
        /* @__PURE__ */ f.jsx("div", { className: "flex justify-center", children: /* @__PURE__ */ f.jsx(mm, { width: 120 }) })
      ]
    }
  );
});
ER.displayName = "SpreenHeader";
const $g = E.forwardRef((e, t) => {
  const {
    gap: r,
    gapY: n,
    gapX: a,
    bg: i,
    rounded: o,
    columns: s,
    columnsVariant: l,
    spacing: c,
    alignItems: u,
    justifyItems: d,
    responsiveColumns: p,
    children: h,
    className: m,
    ...v
  } = e, g = {
    gridTemplateColumns: l === void 0 && s !== void 0 ? `repeat(${s}, 1fr)` : void 0,
    backgroundColor: i !== void 0 ? je[i] : void 0,
    borderRadius: o !== void 0 ? au[o] : void 0,
    padding: c !== void 0 ? `${c / 4}rem` : void 0,
    justifyItems: d,
    alignItems: u
  };
  r !== void 0 ? g.gap = r !== void 0 ? `${r / 4}rem` : void 0 : (g.columnGap = a !== void 0 ? `${a / 4}rem` : void 0, g.rowGap = n !== void 0 ? `${n / 4}rem` : void 0);
  const b = {
    "form-1": "grid-cols-1 gap-x-4 gap-y-8 label-form-1",
    "form-2": "grid-cols-1 2s:grid-cols-2 gap-x-4 gap-y-8 label-form-2",
    "form-3": "grid-cols-1 2s:grid-cols-2 m:grid-cols-3 gap-x-4 gap-y-8 label-form-3",
    "form-4": "grid-cols-1 2s:grid-cols-2 l:grid-cols-4 gap-x-4 gap-y-8 label-form-4"
  };
  p !== void 0 && Object.entries(p).forEach(([w, x]) => {
    const y = `--ck-cols-${w}`;
    typeof x == "number" && (g[y] = `repeat(${x},1fr)`), typeof x == "string" && (g[y] = x);
  });
  const C = {
    initial: "grid-cols-[var(--ck-cols-initial)]",
    small: "s:grid-cols-[var(--ck-cols-small)]",
    extraSmall: "2s:grid-cols-[var(--ck-cols-extraSmall)]",
    medium: "m:grid-cols-[var(--ck-cols-medium)]",
    large: "l:grid-cols-[var(--ck-cols-large)]",
    extraLarge: "xl:grid-cols-[var(--ck-cols-extraLarge)]"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: $e([
        "grid",
        l !== void 0 ? b[l] : void 0,
        p !== void 0 ? `${Object.keys(p).map((w) => C[w]).join(" ")}` : void 0
      ]),
      style: g,
      ...v,
      children: h
    }
  );
});
$g.displayName = "Stack";
const Hi = $g, Ng = E.forwardRef((e, t) => {
  const {
    responsiveColSpan: r,
    showDesktopOnly: n,
    forceWidth: a = !1,
    children: i,
    ...o
  } = e, s = {};
  r !== void 0 && Object.entries(r).forEach(([c, u]) => {
    if (typeof u == "number") {
      const d = `--ck-col-span-${c}`;
      s[d] = `span ${u} / span ${u}`;
    }
  });
  const l = {
    initial: "col-[var(--ck-col-span-initial)]",
    small: "s:col-[var(--ck-col-span-small)]",
    extraSmall: "2s:col-[var(--ck-col-span-extraSmall)]",
    medium: "m:col-[var(--ck-col-span-medium)]",
    large: "l:col-[var(--ck-col-span-large)]",
    extraLarge: "xl:col-[var(--ck-col-span-extraLarge)]"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      style: s,
      className: $e([
        `${n === !0 ? "hidden m:block" : "block"} ${a ? "max-w-full overflow-x-hidden" : ""}`,
        r !== void 0 ? `${Object.keys(r).map((c) => l[c]).join(" ")}` : void 0
      ]),
      ...o,
      children: i
    }
  );
});
Ng.displayName = "StackRow";
const Ei = Ng, jR = E.forwardRef((e, t) => {
  const {
    steps: r,
    value: n,
    onClickStepper: a
  } = e, i = Array.from({ length: r }, (o, s) => s + 1);
  return /* @__PURE__ */ f.jsx("ul", { ref: t, className: "flex items-center justify-between w-full m-auto m:max-w-[15rem]", children: i.map((o) => /* @__PURE__ */ f.jsxs(gn, { children: [
    /* @__PURE__ */ f.jsx(
      "li",
      {
        className: `text-neutral-100 px-3 py-1 rounded-full ${n >= o ? "bg-accent-500" : "bg-neutral-300"}`,
        style: { cursor: n >= o ? "pointer" : "" },
        onClick: n >= o && a !== void 0 ? () => a(o) : () => !0,
        children: o
      }
    ),
    o !== i.length && /* @__PURE__ */ f.jsx("hr", { className: `w-full h-[2px] border-0 ${n > o ? "bg-accent-500" : "bg-neutral-300"}` })
  ] }, o)) });
});
jR.displayName = "StepperSimple";
const _R = E.forwardRef((e) => {
  const { steps: t, tooltipDirection: r = "bottom" } = e, n = {
    top: "after:left-1/2 after:-translate-x-1/2 after:bottom-[calc(100%+15px)] before:left-1/2 before:-translate-x-1/2 before:bottom-[calc(100%+6px)] before:border-t-info-500 before:border-t-[9px] before:border-x-transparent before:border-x-[6px]",
    bottom: "after:left-1/2 after:-translate-x-1/2 after:top-[calc(100%+15px)] before:left-1/2 before:-translate-x-1/2 before:top-[calc(100%+6px)] before:border-b-info-500 before:border-b-[9px] before:border-x-transparent before:border-x-[6px]",
    left: "after:left-0 after:-translate-x-[calc(100%+15px)] after:top-1/2 after:-translate-y-1/2 before:left-0 before:-translate-x-[calc(100%+6px)] before:top-1/2 before:-translate-y-1/2 before:border-l-info-500 before:border-l-[9px] before:border-y-transparent before:border-y-[6px]",
    right: "after:right-0 after:translate-x-[calc(100%+15px)] after:top-1/2 after:-translate-y-1/2 before:right-0 before:translate-x-[calc(100%+6px)] before:top-1/2 before:-translate-y-1/2 before:border-r-info-500 before:border-r-[9px] before:border-y-transparent before:border-y-[6px]"
  };
  return /* @__PURE__ */ f.jsx("ol", { className: "flex items-center justify-between w-full", children: t.map((a, i) => /* @__PURE__ */ f.jsxs(gn, { children: [
    /* @__PURE__ */ f.jsx("li", { className: "text-neutral-100 py-1 rounded-full", children: /* @__PURE__ */ f.jsx(
      "div",
      {
        className: `flex items-center justify-center w-10 h-10 rounded-full lg:h-15 lg:w-15 bg-${je[a.color]} shrink-0`,
        style: { backgroundColor: je[a.color] },
        children: /* @__PURE__ */ f.jsx(
          "span",
          {
            "data-title": a.label,
            className: `${n[r]} relative after:content-[attr(data-title)] after:w-[180px] after:absolute after:z-[10] after:bg-info-500 after:h-[max-content] after:p-2 after:rounded-md after:text-s after:leading-[120%] after:text-white after:justify-center after:items-center after:hidden hover:after:flex before:absolute before:z-[10] before:hidden hover:before:block whitespace-pre-line`,
            children: /* @__PURE__ */ f.jsx(me, { variant: a.variant, width: 25, color: "white" })
          }
        )
      }
    ) }),
    i <= t.length - 2 && /* @__PURE__ */ f.jsx("hr", { className: "w-full h-[2px] border-0", style: { backgroundColor: je[a.color] } })
  ] }, `stepicon-${i}`)) });
});
_R.displayName = "StepperIcon";
const AR = E.forwardRef((e, t) => {
  const {
    children: r,
    className: n
  } = e;
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: $e(["bg-secondary-100 flex items-center justify-center p-5 rounded-md min-h-[70vh]", n]), children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col items-center justify-center w-full max-w-[300px] gap-4 text-center", children: [
    /* @__PURE__ */ f.jsx("div", { className: "flex justify-center select-none", children: /* @__PURE__ */ f.jsx(
      "svg",
      {
        width: 90,
        height: 101,
        viewBox: "0 0 90 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2127_49432)", children: [
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M89.9844 52.4766C89.8853 51.6849 89.314 51.0339 88.5418 50.8307L80.2566 48.6484L86.6766 41.5833C87.0783 41.1406 87.2531 40.5417 87.1566 39.9531C87.0601 39.3646 86.7001 38.8542 86.1783 38.5625L62.2618 25.276C61.3644 23.6068 60.2166 22.0573 58.834 20.6823C55.1401 16.9922 50.2253 14.9609 45.0001 14.9609C39.7748 14.9609 34.8601 16.9922 31.1661 20.6823C29.7731 22.0729 28.6357 23.6224 27.7514 25.2708L3.82441 38.5651C3.30267 38.8542 2.94267 39.3672 2.84614 39.9557C2.74962 40.5443 2.92701 41.1432 3.32875 41.5859L9.74615 48.651L1.45832 50.8333C0.686145 51.0365 0.11484 51.6875 0.0157101 52.4792C-0.0834204 53.2708 0.307884 54.0417 1.00701 54.4297L11.4027 60.2057V80.974C11.4027 81.6823 11.7888 82.3359 12.407 82.6797L44.0505 100.258C44.3479 100.422 44.674 100.505 45.0027 100.505C45.3314 100.505 45.6601 100.424 45.9548 100.258L77.5983 82.6797C78.2192 82.3359 78.6027 81.6823 78.6027 80.974V60.2057L88.9983 54.4297C89.6948 54.0417 90.0888 53.2708 89.987 52.4792L89.9844 52.4766ZM82.1192 40.7839L76.2366 47.2578L63.694 40.2917C64.2679 38.4401 64.5653 36.4896 64.5653 34.4974C64.5653 33.2578 64.4505 32.0365 64.2261 30.8438L82.1218 40.7839H82.1192ZM33.9314 23.4479C36.887 20.4974 40.8183 18.8724 45.0001 18.8724C49.1818 18.8724 53.1105 20.4974 56.0688 23.4479C59.027 26.3984 60.6522 30.3229 60.6522 34.4974C60.6522 38.6719 59.0244 42.5938 56.0688 45.5469C54.0235 47.5885 51.4644 49.0208 48.6653 49.6901C48.1435 49.8151 47.6948 50.1484 47.4261 50.612L45.0001 54.8099C44.1914 53.4089 43.3827 52.0104 42.574 50.612C42.3053 50.1484 41.8566 49.8151 41.3348 49.6875C38.5383 49.0182 35.9792 47.5859 33.934 45.5443C27.8322 39.4531 27.8322 29.5391 33.934 23.4479H33.9314ZM7.88093 40.7839L25.7896 30.8359C25.1948 33.9714 25.3696 37.2214 26.3192 40.2865L13.7661 47.2604L7.88354 40.7865L7.88093 40.7839ZM13.0957 51.8073L20.5331 55.9401C20.8357 56.1068 21.1618 56.1875 21.4827 56.1875C22.1714 56.1875 22.8366 55.8255 23.194 55.1823C23.7209 54.2396 23.3792 53.0495 22.4348 52.526L17.3818 49.7188L27.8531 43.9036C28.7218 45.4844 29.8279 46.9688 31.1661 48.3073C33.5192 50.6563 36.4148 52.3594 39.5922 53.2682C40.4348 54.7266 41.2774 56.1849 42.1227 57.6458C42.7253 58.6823 43.7975 59.2995 44.9975 59.2995H45.0235C46.2131 59.2917 47.3114 58.6484 47.8957 57.6172L50.4105 53.2682C53.5853 52.3568 56.4835 50.6536 58.8366 48.3073C60.1618 46.9818 61.2757 45.5026 62.1575 43.9063L72.6209 49.7188L45.0027 65.0599L37.8261 61.0729C36.8818 60.5495 35.6896 60.888 35.1653 61.8307C34.6383 62.7734 34.9801 63.9635 35.9244 64.487L39.8061 66.6432L33.8661 68.2057L7.15571 53.3672L13.0957 51.8047V51.8073ZM15.3157 62.375L32.6505 72.0052C33.0914 72.25 33.6105 72.3151 34.1009 72.1875L43.0461 69.8333V95.2266L15.3157 79.8229V62.3776V62.375ZM74.687 79.8203L46.9566 95.224V69.8307L55.9018 72.1849C56.0661 72.2266 56.2331 72.25 56.4001 72.25C56.7314 72.25 57.0574 72.1667 57.3496 72.0026L74.6844 62.3724V79.8177L74.687 79.8203ZM56.1392 68.2083L50.1992 66.6432L76.907 51.8073L82.847 53.3698L56.1392 68.2083Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M35.2173 36.7422C36.2973 36.7422 37.1738 35.8672 37.1738 34.7891C37.1738 33.7109 36.2973 32.8359 35.2173 32.8359C34.1373 32.8359 33.2607 33.7109 33.2607 34.7891C33.2607 35.8672 34.1373 36.7422 35.2173 36.7422Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M45 36.7422C46.08 36.7422 46.9565 35.8672 46.9565 34.7891C46.9565 33.7109 46.08 32.8359 45 32.8359C43.92 32.8359 43.0435 33.7109 43.0435 34.7891C43.0435 35.8672 43.92 36.7422 45 36.7422Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M54.7827 36.7422C55.8627 36.7422 56.7392 35.8672 56.7392 34.7891C56.7392 33.7109 55.8627 32.8359 54.7827 32.8359C53.7027 32.8359 52.8262 33.7109 52.8262 34.7891C52.8262 35.8672 53.7027 36.7422 54.7827 36.7422Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M45 8.89844C46.08 8.89844 46.9565 8.02344 46.9565 6.94531V2.45312C46.9565 1.375 46.08 0.5 45 0.5C43.92 0.5 43.0435 1.375 43.0435 2.45312V6.94531C43.0435 8.02344 43.92 8.89844 45 8.89844Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M33.0573 10.6639C33.4199 11.2915 34.0773 11.6405 34.7529 11.6405C35.0842 11.6405 35.4207 11.5571 35.7286 11.38C36.6651 10.841 36.9859 9.64566 36.4459 8.71077L34.1973 4.82014C33.6573 3.88525 32.4599 3.56494 31.5259 4.104C30.5894 4.64306 30.2686 5.83837 30.8086 6.77327L33.0573 10.6639Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M54.2685 11.3776C54.5764 11.5547 54.9129 11.638 55.2468 11.638C55.9225 11.638 56.5799 11.2891 56.9425 10.6615L59.1912 6.77083C59.7312 5.83593 59.4103 4.64062 58.4738 4.10156C57.5372 3.56249 56.3425 3.88281 55.8025 4.8177L53.5538 8.70833C53.0138 9.64322 53.3346 10.8359 54.2685 11.3776Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M29.1782 56.5547C28.0982 56.5547 27.2217 57.4297 27.2217 58.5078C27.2217 59.5859 28.0982 60.4609 29.1782 60.4609C30.2582 60.4609 31.1347 59.5885 31.1347 58.5078C31.1347 57.4271 30.2582 56.5547 29.1782 56.5547Z",
              fill: "#2875B4"
            }
          )
        ] })
      }
    ) }),
    r
  ] }) });
});
AR.displayName = "TableEmpty";
const DR = E.forwardRef((e, t) => {
  const {
    children: r,
    className: n
  } = e;
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: $e(["pt-4 px-4 border-t border-neutral-300 m:border-none", n]), children: /* @__PURE__ */ f.jsx("div", { className: "flex flex-col-reverse m:flex-row m:justify-between flex-wrap gap-4", children: r }) });
});
DR.displayName = "TableFooter";
const Ig = (e) => {
  const {
    idSearch: t,
    placeholder: r,
    minLengthToSearch: n = 5,
    onSearch: a,
    onClickRefresh: i
  } = e, [o, s] = ye(""), l = ve(!0), c = mv(o), u = (h) => {
    const m = h.target.value;
    m.startsWith(" ") || s(m);
  }, d = () => {
    s(""), a !== void 0 && a({
      value: "",
      canSearch: !1
    });
  };
  _e(() => {
    if (l.current) {
      l.current = !1;
      return;
    }
    a !== void 0 && (c.trim().length >= n ? a({
      value: c.trim(),
      canSearch: !0
    }) : a({
      value: c.trim(),
      canSearch: !1
    }));
  }, [c]);
  const p = () => {
    i !== void 0 && (d(), i());
  };
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx("div", { className: "flex-grow", children: /* @__PURE__ */ f.jsx(
      "input",
      {
        type: "text",
        id: t,
        placeholder: r,
        value: o,
        onChange: u,
        className: "w-full h-full px-3 bg-transparent text-neutral-600 placeholder:text-neutral-400 outline-none shadow-transparent",
        style: { textTransform: "none" }
      }
    ) }),
    o.trim().length >= n ? /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        onClick: d,
        className: "w-[48px] min-w-[48px] flex items-center justify-center border-l border-neutral-300 cursor-pointer",
        children: /* @__PURE__ */ f.jsx(me, { variant: "close", width: 14 })
      }
    ) : /* @__PURE__ */ f.jsx("label", { htmlFor: t, className: "w-[48px] min-w-[48px] flex items-center justify-center border-l border-neutral-300 cursor-pointer", children: /* @__PURE__ */ f.jsx(me, { variant: "search", width: 20 }) }),
    /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        onClick: p,
        className: "w-[48px] min-w-[48px] flex items-center justify-center border-l border-neutral-300 cursor-pointer",
        children: /* @__PURE__ */ f.jsx(me, { variant: "refresh-circle", width: 18 })
      }
    )
  ] });
}, MR = E.forwardRef((e, t) => {
  const {
    search: r,
    consult: n,
    selectFilter: a,
    permissions: i,
    onClickExport: o,
    onClickReports: s,
    onClickRefresh: l
  } = e, {
    placeholder: c = "Search...",
    minLengthToSearch: u = 5,
    onSearch: d
  } = r, p = Yf(), h = (n == null ? void 0 : n.filled) ?? 0, m = () => {
    (n == null ? void 0 : n.onClick) !== void 0 && n.onClick();
  }, v = () => {
    (n == null ? void 0 : n.onReset) !== void 0 && n.onReset();
  }, g = () => {
    s !== void 0 && s();
  }, b = () => {
    o !== void 0 && o();
  }, C = Object.values(i).reduce((w, x) => x ? w + 1 : w, 0);
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: "border-b border-neutral-300 m:border-none px-4 pt-4", children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col m:flex-row m:justify-between gap-4", children: [
    /* @__PURE__ */ f.jsx("div", { className: "flex flex-grow gap-2", children: /* @__PURE__ */ f.jsxs("div", { className: "flex m:flex-grow m:max-w-[800px] justify-between h-[40px] border border-neutral-300 rounded-md bg-neutral-200 w-[100%]", children: [
      /* @__PURE__ */ f.jsx("div", { className: "w-[110px] min-w-[110px] s:w-[140px] s:min-w-[140px] 2s:min-w-[30%] relative h-full border-r border-neutral-300", children: a }),
      /* @__PURE__ */ f.jsx(
        Ig,
        {
          idSearch: p,
          placeholder: c,
          minLengthToSearch: u,
          onSearch: d,
          onClickRefresh: l
        }
      )
    ] }) }),
    C > 0 && /* @__PURE__ */ f.jsx("div", { className: "flex flex-col m:flex-row gap-4", children: /* @__PURE__ */ f.jsxs("div", { className: `grid ${C < 2 ? "grid-cols-1" : "grid-table-main-header"} m:flex gap-4`, children: [
      i.consult && /* @__PURE__ */ f.jsxs("div", { className: "relative", children: [
        /* @__PURE__ */ f.jsx(
          "button",
          {
            type: "button",
            onClick: m,
            className: `h-10 w-full bg-secondary-100 text-secondary-600 hover:bg-secondary-200 font-bold flex gap-4 items-center rounded-md border ${h > 0 ? "justify-center s:justify-between pl-4 pr-4 s:pr-[4.5rem] border-secondary-600" : "justify-center px-4 border-transparent"}`,
            children: /* @__PURE__ */ f.jsxs("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ f.jsx("span", { className: "w-[20px] min-w-[20px]", children: /* @__PURE__ */ f.jsx(me, { variant: "filter" }) }),
              /* @__PURE__ */ f.jsx("span", { children: "Consulta" })
            ] })
          }
        ),
        h > 0 && /* @__PURE__ */ f.jsxs("div", { className: "absolute top-1/2 -translate-y-1/2 right-4 hidden s:flex items-center gap-2 z-[1] pointer-events-none font-bold", children: [
          /* @__PURE__ */ f.jsx("span", { className: "flex w-5 h-5 rounded-full bg-secondary-600 text-white text-xs items-center justify-center", children: h }),
          /* @__PURE__ */ f.jsx(
            "span",
            {
              onClick: v,
              className: "w-[14px] min-w-[14px] hover:scale-110 active:scale-95 pointer-events-auto cursor-pointer text-secondary-600",
              children: /* @__PURE__ */ f.jsx(me, { variant: "close", width: 14 })
            }
          )
        ] })
      ] }),
      i.reports && /* @__PURE__ */ f.jsx("div", { className: "m:w-[215px]", children: /* @__PURE__ */ f.jsx(gt, { variant: "secondary", size: "m", isFull: !0, onClick: g, children: /* @__PURE__ */ f.jsx("span", { className: `block ${C > 1 ? "w-[35vw] m:w-auto text-ellipsis overflow-hidden whitespace-nowrap h-[30px] leading-[30px]" : "whitespace-nowrap"}`, children: "Reportes programados" }) }) }),
      i.export && /* @__PURE__ */ f.jsx("div", { className: "m:min-w-[140px]", children: /* @__PURE__ */ f.jsx(gt, { variant: "secondary-bold", size: "m", isFull: !0, onClick: b, children: "Exportar" }) })
    ] }) })
  ] }) });
});
MR.displayName = "TableHeaderDeclarant";
const TR = E.forwardRef((e, t) => {
  const {
    text: r = "Cargando...",
    className: n
  } = e;
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: $e(["bg-secondary-100 flex items-center justify-center p-5 rounded-md min-h-[70vh] select-none", n]), children: /* @__PURE__ */ f.jsxs("div", { className: "text-center animate-pulse", children: [
    /* @__PURE__ */ f.jsx("div", { className: "bg-white flex justify-center items-center w-[64px] h-[64px] rounded-md mb-4", children: /* @__PURE__ */ f.jsxs(
      "svg",
      {
        width: 36,
        height: 40,
        viewBox: "0 0 36 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M1.65723 39.2676H28.9346C34.1715 39.2676 37.5922 33.638 35.247 28.8537L31.8969 22.001C24.2797 31.012 13.6826 37.3071 1.65723 39.2676Z",
              fill: "#165892"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M23.2922 4.46453L22.1638 2.16232C21.2292 0.255791 18.5667 0.255791 17.6322 2.16232L3.87891 30.2386C12.8715 24.1413 19.7834 15.0943 23.2922 4.46453Z",
              fill: "#F15C41"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M31.28 20.7422L24.1036 6.10156C20.1363 17.181 12.5367 26.4798 2.78593 32.5051L0 38.2067C12.5014 36.57 23.5569 30.131 31.2976 20.7602L31.28 20.7422Z",
              fill: "#2875B4"
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ f.jsx(hr, { variant: "description-3", children: r })
  ] }) });
});
TR.displayName = "TableLoader";
const Lg = (e) => {
  const {
    actions: t = [],
    row: r,
    canEdit: n,
    onEditClick: a,
    onActionClick: i,
    onRowClick: o,
    handleDisplayDetail: s,
    handleClickDetail: l,
    showDetail: c
  } = e, [u, d] = ye(!1), p = ve(null), h = ve(null), m = () => {
    d(!1), a !== void 0 && a({ row: r });
  }, v = (x) => () => {
    i !== void 0 && i({ row: r, action: x }), d(!1);
  }, g = () => {
    o !== void 0 && o({ row: r });
  }, b = (x) => {
    if (p.current !== null && !p.current.contains(x.target)) {
      if (h.current !== null) {
        if (h.current.contains(x.target))
          return;
        d(!1);
        return;
      }
      d(!1);
    }
  };
  _e(() => (document.addEventListener("click", b, !0), () => {
    document.removeEventListener("click", b, !0);
  }), []);
  const [C, w] = ye(!0);
  return /* @__PURE__ */ f.jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ f.jsx(
      gt,
      {
        type: "button",
        variant: "secondary-light-bold",
        icon: "menu-context",
        tooltip: "Acciones",
        tooltipDirection: "left",
        disabled: t.length === 0,
        ref: p,
        size: "s",
        onlyIcon: !0,
        onClick: () => {
          d((x) => !x);
        }
      }
    ),
    u && /* @__PURE__ */ f.jsx("div", { ref: h, className: "absolute top-[calc(100%+8px)] right-0 z-[20] cursor-default pb-[20px] pointer-events-none", children: /* @__PURE__ */ f.jsx("div", { className: "bg-white min-w-[165px] max-w-[250px] p-4 rounded-md shadow-l pointer-events-auto", children: /* @__PURE__ */ f.jsxs("ul", { children: [
      n && /* @__PURE__ */ f.jsxs(
        "li",
        {
          onClick: m,
          className: "p-2 rounded-md font-bold text-secondary-600 cursor-pointer min-h-[40px] flex items-center gap-2 hover:bg-secondary-200 2s:hidden",
          children: [
            /* @__PURE__ */ f.jsx("span", { className: "w-5 h-5 object-contain min-w-[20px]", children: /* @__PURE__ */ f.jsx(me, { variant: "edit", isContain: !0 }) }),
            /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] grow w-full text-ellipsis overflow-hidden whitespace-nowrap", children: "Editar" })
          ]
        }
      ),
      t.map((x) => /* @__PURE__ */ f.jsxs(
        "li",
        {
          onClick: v(x),
          className: "p-2 rounded-md font-bold text-secondary-600 cursor-pointer min-h-[40px] flex items-center gap-2 hover:bg-secondary-200",
          children: [
            /* @__PURE__ */ f.jsx("span", { className: "w-5 h-5 object-contain min-w-[20px]", children: /* @__PURE__ */ f.jsx(me, { variant: x.icon, isContain: !0 }) }),
            /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] grow w-full text-ellipsis overflow-hidden whitespace-nowrap", children: x.title })
          ]
        },
        x.id
      )),
      c && /* @__PURE__ */ f.jsxs(
        "li",
        {
          onClick: () => {
            s !== void 0 && (s({ row: r, isShowDetail: C }), l !== void 0 && l({ row: r }), w((x) => !x));
          },
          className: "p-2 rounded-md font-bold text-secondary-600 cursor-pointer min-h-[40px] flex items-center gap-2 hover:bg-secondary-200 2s:hidden",
          children: [
            /* @__PURE__ */ f.jsx("span", { className: "w-5 h-5 object-contain min-w-[20px]", children: /* @__PURE__ */ f.jsx(me, { variant: "arrow-down", isContain: !0 }) }),
            /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] grow w-full text-ellipsis overflow-hidden whitespace-nowrap", children: "Ver detalle" })
          ]
        }
      ),
      t.length === 0 && /* @__PURE__ */ f.jsxs(
        "li",
        {
          onClick: g,
          className: "p-2 rounded-md font-bold text-secondary-600 cursor-pointer min-h-[40px] flex items-center gap-2 hover:bg-secondary-200",
          children: [
            /* @__PURE__ */ f.jsx("span", { className: "w-5 h-5 object-contain min-w-[20px]", children: /* @__PURE__ */ f.jsx(me, { variant: "eye", isContain: !0 }) }),
            /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] grow w-full text-ellipsis overflow-hidden whitespace-nowrap", children: "Ver" })
          ]
        }
      )
    ] }) }) })
  ] });
}, $R = (e) => {
  const {
    actions: t,
    row: r,
    index: n,
    detailData: a = [],
    detailColumns: i = [],
    handleDeleteDetatail: o,
    rowDetail: s,
    NOMCOLXX: l,
    onRowDetailClick: c
  } = e, u = t.filter((d) => d.id === 104);
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: a.map((d, p) => s !== r[l] ? null : /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: "relative p-4 rounded-md bg-secondary-400 hover:bg-secondary-300 hover:text-secondary-600 w-full cursor-pointer",
      onClick: () => {
        c !== void 0 && c({ row: d });
      },
      children: [
        Object.entries(d).map(([h, m]) => i.find((g) => g.id === h) === void 0 ? null : /* @__PURE__ */ f.jsx("p", { className: "w-full text-ellipsis overflow-hidden whitespace-nowrap", children: m })),
        /* @__PURE__ */ f.jsx("div", { className: "absolute top-4 right-4", children: /* @__PURE__ */ f.jsx("div", { className: "bg-secondary-400", children: u && /* @__PURE__ */ f.jsx(
          gt,
          {
            type: "button",
            variant: "secondary-light-bold",
            icon: "trash",
            tooltip: "Eliminar",
            tooltipDirection: "left",
            size: "s",
            onlyIcon: !0,
            onClick: () => {
              o !== void 0 && o({ item: d, row: r });
            }
          }
        ) }) })
      ]
    },
    `detail-${n}-${p}`
  )) });
}, NR = (e) => {
  const {
    actions: t = [],
    columns: r = [],
    data: n = [],
    canEdit: a,
    onEditClick: i,
    onActionClick: o,
    onRowClick: s,
    handleDisplayDetail: l,
    detailData: c,
    detailColumns: u = [],
    showDetail: d,
    handleDeleteDetatail: p
  } = e, h = u.length > 0 ? u[0].id : "", [m, v] = ye(null), g = (b) => {
    const { row: C } = b;
    v(C[h]);
  };
  return /* @__PURE__ */ f.jsx("div", { className: "grid gap-2 2s:hidden", children: n.map((b, C) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs(
      "div",
      {
        className: "relative p-4 rounded-md bg-secondary-100 hover:bg-secondary-200 hover:text-secondary-600 w-full cursor-pointer",
        children: [
          /* @__PURE__ */ f.jsx(
            "div",
            {
              className: "flex flex-wrap gap-y-1.5 gap-x-6",
              onClick: () => {
                s !== void 0 && s({ row: b });
              },
              children: Object.entries(b).filter(([w]) => r.some((x) => x.id === w && x.isMobileShow)).map(([w, x]) => {
                const y = r.find((j) => j.id === w);
                if (y === void 0)
                  return null;
                const {
                  isMobileShow: O = !1,
                  isTextBold: P = !1
                } = y;
                return O ? /* @__PURE__ */ f.jsx(
                  "p",
                  {
                    className: `leading-[120%] ${P ? "font-bold" : ""} w-full pr-12`,
                    children: x
                  },
                  w
                ) : null;
              })
            }
          ),
          /* @__PURE__ */ f.jsx("div", { className: "absolute top-4 right-4", children: /* @__PURE__ */ f.jsx(
            Lg,
            {
              actions: t,
              row: b,
              canEdit: a,
              onEditClick: i,
              onActionClick: o,
              onRowClick: s,
              handleDisplayDetail: l,
              detailColumns: u,
              showDetail: d,
              handleClickDetail: g
            }
          ) })
        ]
      },
      b.id
    ),
    c.length > 0 && /* @__PURE__ */ f.jsx(
      $R,
      {
        actions: t,
        row: b,
        index: C,
        detailData: c,
        detailColumns: u,
        handleDeleteDetatail: p,
        rowDetail: m,
        NOMCOLXX: h,
        onRowDetailClick: s
      }
    )
  ] })) });
}, IR = (e) => {
  const {
    columns: t = [],
    onChangeShowColumn: r
  } = e, [n, a] = ye(!1), [i, o] = ye(!1), s = ve(null), l = ve(null), c = (u) => {
    if (s.current !== null && !s.current.contains(u.target)) {
      if (l.current !== null) {
        if (l.current.contains(u.target))
          return;
        a(!1);
        return;
      }
      a(!1);
    }
  };
  return _e(() => (document.addEventListener("click", c, !0), () => {
    document.removeEventListener("click", c, !0);
  }), []), _e(() => {
    t.filter((d) => d.canToggleShow).length > 0 ? o(!0) : o(!1);
  }, [t]), i ? /* @__PURE__ */ f.jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ f.jsx(
      gt,
      {
        type: "button",
        ref: s,
        variant: "secondary",
        icon: "column-actions",
        active: n,
        size: "s",
        onlyIcon: !0,
        tooltip: "Visualizar columnas",
        tooltipDirection: "left",
        onClick: () => {
          a((u) => !u);
        }
      }
    ),
    n && /* @__PURE__ */ f.jsx("div", { ref: l, className: "absolute top-[calc(100%+4px)] right-0 z-[30]", children: /* @__PURE__ */ f.jsxs("div", { className: "bg-white rounded-md shadow-xl w-[330px]", children: [
      /* @__PURE__ */ f.jsx("div", { className: "px-4 py-3.5 border-b border-b-neutral-300", children: /* @__PURE__ */ f.jsx(sr, { variant: "title-3", children: "Ver / esconder columnas" }) }),
      /* @__PURE__ */ f.jsx("div", { className: "p-4", children: /* @__PURE__ */ f.jsx(Hi, { gap: 2, children: t.map((u) => u.canToggleShow ? /* @__PURE__ */ f.jsx(
        gv,
        {
          type: "switch",
          variantSize: "xs",
          isBold: !0,
          checked: u.isShow,
          onChange: () => {
            r !== void 0 && r({ column: u });
          },
          children: /* @__PURE__ */ f.jsx("p", { children: u.title })
        },
        u.id
      ) : null) }) })
    ] }) })
  ] }) : /* @__PURE__ */ f.jsx(f.Fragment, {});
}, LR = (e) => {
  const {
    columns: t = [],
    onColumnClick: r,
    onChangeShowColumn: n,
    isCheckedRow: a,
    handleCheckedAllRows: i,
    data: o,
    ischeckedAll: s,
    handleOrderChange: l,
    isOrderColumns: c
  } = e;
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    a && /* @__PURE__ */ f.jsx(
      "div",
      {
        style: { gridArea: "col-reserved-check" },
        className: "min-w-[50px] flex gap-2 justify-between items-center px-4",
        children: /* @__PURE__ */ f.jsx(
          "input",
          {
            type: "checkbox",
            id: "checkAll",
            title: "Seleccionar todos",
            className: "w-full overflow-hidden whitespace-nowrap",
            onChange: (u) => {
              i !== void 0 && i(o, u.target.checked);
            },
            checked: s
          }
        )
      }
    ),
    t.filter((u) => u.isShow).map((u) => /* @__PURE__ */ f.jsxs(
      "div",
      {
        style: { gridArea: `col-${u.id}` },
        title: u.title,
        className: `min-w-[205px] flex gap-2 justify-between items-center px-4 font-bold leading-[120%] select-none ${u.sorted && u.orderBy !== null ? "text-secondary-600" : "hover:text-secondary-500"}`,
        children: [
          /* @__PURE__ */ f.jsx("p", { className: "w-full text-ellipsis overflow-hidden whitespace-nowrap", children: u.title }),
          u.sortable && /* @__PURE__ */ f.jsx(
            "button",
            {
              type: "button",
              className: "w-6 h-6 flex items-center justify-center",
              onClick: () => {
                r !== void 0 && r({ column: u });
              },
              children: /* @__PURE__ */ f.jsxs(
                "svg",
                {
                  className: "w-5",
                  viewBox: "0 0 25 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: [
                    /* @__PURE__ */ f.jsx(
                      "path",
                      {
                        d: "M16.743 10L8.25505 10C8.1049 9.9994 7.95831 9.95665 7.83381 9.87715C7.70931 9.79765 7.6125 9.68497 7.55561 9.55336C7.49873 9.42176 7.48433 9.27713 7.51423 9.13777C7.54413 8.99841 7.61699 8.87057 7.7236 8.77043L11.96 4.75815C12.0306 4.69075 12.1145 4.63726 12.207 4.60075C12.2996 4.56425 12.3988 4.54545 12.499 4.54545C12.5992 4.54545 12.6985 4.56425 12.791 4.60075C12.8835 4.63726 12.9675 4.69075 13.0381 4.75815L17.2744 8.77043C17.3811 8.87057 17.4539 8.99841 17.4838 9.13777C17.5137 9.27713 17.4993 9.42176 17.4424 9.55337C17.3855 9.68497 17.2887 9.79765 17.1642 9.87715C17.0397 9.95665 16.8931 9.9994 16.743 10Z",
                        fill: u.sorted && u.orderBy === "asc" ? "#2875B4" : "#E6E6E6"
                      }
                    ),
                    /* @__PURE__ */ f.jsx(
                      "path",
                      {
                        d: "M8.25505 14H16.743C16.8931 14.0006 17.0397 14.0433 17.1642 14.1228C17.2887 14.2023 17.3855 14.315 17.4424 14.4466C17.4993 14.5782 17.5137 14.7229 17.4838 14.8622C17.4539 15.0016 17.3811 15.1294 17.2744 15.2296L13.0381 19.2419C12.9675 19.3092 12.8835 19.3627 12.791 19.3992C12.6985 19.4358 12.5992 19.4545 12.499 19.4545C12.3988 19.4545 12.2996 19.4358 12.207 19.3992C12.1145 19.3627 12.0306 19.3092 11.96 19.2419L7.7236 15.2296C7.61699 15.1294 7.54413 15.0016 7.51423 14.8622C7.48433 14.7229 7.49873 14.5782 7.55561 14.4466C7.6125 14.315 7.70931 14.2023 7.83381 14.1228C7.95831 14.0433 8.1049 14.0006 8.25505 14Z",
                        fill: u.sorted && u.orderBy === "desc" ? "#2875B4" : "#E6E6E6"
                      }
                    )
                  ]
                }
              )
            }
          )
        ]
      },
      u.id
    )),
    /* @__PURE__ */ f.jsx("div", { className: "sticky right-0 bg-white z-[99999]", style: { gridArea: "col-reserved-actions" }, children: /* @__PURE__ */ f.jsxs("div", { className: "flex items-center justify-between pl-4 pr-2 h-10 select-none", children: [
      /* @__PURE__ */ f.jsx("p", { className: "font-bold", children: "Acciones" }),
      c && /* @__PURE__ */ f.jsx(
        gt,
        {
          type: "button",
          variant: "secondary",
          icon: "column-order",
          size: "s",
          onlyIcon: !0,
          onClick: () => {
            l !== void 0 && l(!0);
          },
          tooltip: "Reordenar Columnas",
          tooltipDirection: "left"
        }
      ),
      /* @__PURE__ */ f.jsx(
        IR,
        {
          columns: t,
          onChangeShowColumn: n
        }
      )
    ] }) })
  ] });
}, kR = (e) => {
  const {
    actions: t,
    row: r,
    index: n,
    canEdit: a,
    onEditClick: i,
    detailData: o = [],
    detailColumns: s = [],
    handleDeleteDetatail: l,
    rowDetail: c,
    NOMCOLXX: u,
    onRowDetailClick: d,
    colorColumn: p
  } = e, h = s.map((C) => `col-${C.id}`).concat("col-reserved-actions").join(" ").toString();
  let m = 0;
  const v = Array.from({ length: s.length }, () => {
    let C = "1fr";
    return m === 0 && (C = "0.2fr"), m++, C;
  }).join(" ").toString(), g = { gridTemplateAreas: `'${h}'`, gridTemplateColumns: v + " 150px" }, b = t.filter((C) => C.id === "toggle");
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: o.map((C, w) => c !== r[u] ? null : /* @__PURE__ */ f.jsxs(
    "div",
    {
      style: g,
      className: "bg-secondary-400 hover:bg-secondary-300 hover:text-secondary-600 cursor-pointer border-b border-white last:border-none h-[48px] grid w-full",
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "bg-white", children: /* @__PURE__ */ f.jsx("div", { className: "flex items-center gap-2 h-[48px]", children: /* @__PURE__ */ f.jsx(me, { variant: "arrow-turn-down-right" }) }) }),
        Object.entries(C).map(([x, y]) => {
          const O = s.find((I) => I.id === x);
          if (O === void 0)
            return null;
          let P = p ? p.filter((I) => I.title === x) : [], j = !1, T = "";
          if (P.length > 0) {
            j = !0;
            const I = P[0].params.filter((F) => F.value === y), R = I.length > 0 ? I[0].color : "transparent";
            T = je[R];
          }
          return /* @__PURE__ */ f.jsx(
            "div",
            {
              style: { gridArea: `col-${O.id}` },
              title: y,
              className: "min-w-[205px] flex items-center px-4 border-l border-white first:border-none leading-[120%]",
              onClick: () => {
                if (d !== void 0) {
                  const I = { ...C };
                  Object.keys(I).forEach((R) => {
                    R.startsWith("TARIDCHX") && (I.TARIDXXX = I[R], delete I[R]);
                  }), d({ row: I });
                }
              },
              children: j ? /* @__PURE__ */ f.jsx("div", { className: "w-full h-8 px-4 justify-center items-center gap-2 flex", style: { borderRadius: "8px", backgroundColor: T }, children: /* @__PURE__ */ f.jsx("div", { className: "grow text-center text-white text-xs font-bold leading-[14.40px]", children: y }) }) : /* @__PURE__ */ f.jsx("p", { className: "w-full text-ellipsis overflow-hidden whitespace-nowrap", children: y })
            },
            x
          );
        }),
        /* @__PURE__ */ f.jsx("div", { className: "bg-white sticky block right-0 border-l border-white cursor-default pr-1", children: /* @__PURE__ */ f.jsx("div", { className: "bg-secondary-400", children: /* @__PURE__ */ f.jsxs("div", { className: "flex items-center gap-2 h-[48px] px-4", children: [
          a && /* @__PURE__ */ f.jsx(
            gt,
            {
              type: "button",
              variant: "secondary-light-bold",
              icon: "edit",
              tooltip: "Editar",
              tooltipDirection: "left",
              size: "s",
              onlyIcon: !0,
              onClick: () => {
                if (i !== void 0) {
                  const x = { ...C };
                  Object.keys(x).forEach((y) => {
                    y.startsWith("TARIDCHX") && (x.TARIDXXX = x[y], delete x[y]);
                  }), i({ row: x });
                }
              }
            }
          ),
          b.length > 0 && /* @__PURE__ */ f.jsx(
            gt,
            {
              type: "button",
              variant: "secondary-light-bold",
              icon: "trash",
              tooltip: "Eliminar",
              tooltipDirection: "left",
              size: "s",
              onlyIcon: !0,
              onClick: () => {
                l !== void 0 && l({ item: C, row: r });
              }
            }
          )
        ] }) }) })
      ]
    },
    `detail-${n}-${w}`
  )) });
}, RR = (e) => {
  const {
    actions: t = [],
    columns: r = [],
    data: n = [],
    canEdit: a,
    activeRowValidation: i,
    onEditClick: o,
    onActionClick: s,
    onRowClick: l,
    onColumnClick: c,
    onChangeShowColumn: u,
    handleDisplayDetail: d,
    detailData: p = [],
    detailColumns: h = [],
    showDetail: m,
    handleDeleteDetatail: v,
    isCheckedRow: g,
    handleCheckedRow: b,
    handleCheckedAllRows: C,
    selectedRows: w,
    colorColumn: x,
    intermediateContent: y,
    ischeckedAll: O,
    handleOrderChange: P,
    isOrderColumns: j
  } = e, T = (g ? "col-reserved-check " : "") + r.filter((ee) => ee.isShow).map((ee) => `col-${ee.id}`).concat("col-reserved-actions").join(" ").toString(), I = (g ? "50px " : "") + Array.from({ length: r.filter((ee) => ee.isShow).length }, () => "1fr").concat(a ? "150px" : "").join(" ").toString(), R = { gridTemplateAreas: `'${T}'`, gridTemplateColumns: I }, [F, $] = ye(null), Z = h.length > 0 ? h[0].id : "", [X, K] = ye(!0), J = (ee) => {
    const { row: A } = ee;
    $(A[Z]);
  };
  return /* @__PURE__ */ f.jsx("div", { className: "grid gap-2 hidden 2s:block", children: /* @__PURE__ */ f.jsx("div", { className: `${y ? "" : "max-h-[calc(100vh-461px)] min-h-[calc(100vh-461px)]"}
                        ${y ? "" : "m:max-h-[calc(100vh-305px)] m:min-h-[calc(100vh-305px)]"}
                        ${y ? "" : "l:max-h-[calc(100vh-312px)] l:min-h-[calc(100vh-312px)]"}
                        ${y ? "table-max-height" : ""}
                        w-full overflow-x-auto overflow-y-auto table-main-scrollbar pb-1`, children: /* @__PURE__ */ f.jsxs("div", { className: "min-w-[min-content]", children: [
    /* @__PURE__ */ f.jsx("div", { className: "bg-white grid w-full h-10 sticky top-0", style: { ...R, zIndex: n.length + 10 }, children: /* @__PURE__ */ f.jsx(
      LR,
      {
        columns: r,
        onColumnClick: c,
        onChangeShowColumn: u,
        isCheckedRow: g,
        handleCheckedAllRows: C,
        data: n,
        ischeckedAll: O,
        handleOrderChange: P,
        isOrderColumns: j
      }
    ) }),
    /* @__PURE__ */ f.jsx("div", { className: "bg-secondary-100 w-full", children: /* @__PURE__ */ f.jsx("div", { children: n.map((ee, A) => {
      const _ = A % 2 === 0, N = ee != null && ee.error ? "error" : "secondary", M = i === void 0 || ee[i.field] === void 0 ? !0 : ee[i.field] === i.value, S = M ? _ ? `bg-${N}-200` : `bg-${N}-100` : "bg-neutral-200 text-neutral-400", B = w && w.some((G) => JSON.stringify(G) === JSON.stringify(ee));
      return /* @__PURE__ */ f.jsxs(gn, { children: [
        /* @__PURE__ */ f.jsxs(
          "div",
          {
            style: R,
            className: `${S} hover:bg-${N}-300 hover:text-${N}-600 cursor-pointer border-b border-white last:border-none h-[40px] grid w-full`,
            children: [
              g && /* @__PURE__ */ f.jsx("div", { className: "min-w-[50px] flex justify-between items-center pr-1", children: /* @__PURE__ */ f.jsx(
                "input",
                {
                  type: "checkbox",
                  title: "Seleccionar",
                  checked: B || O,
                  className: "checkbox w-full overflow-hidden whitespace-nowrap",
                  onChange: (G) => {
                    b !== void 0 && b(ee, G.target.checked);
                  }
                }
              ) }),
              Object.entries(ee).map(([G, U]) => {
                const H = r.find((D) => D.id === G);
                if (H === void 0 || !H.isShow)
                  return null;
                const {
                  isTextBold: k = !1
                } = H;
                let L = !1, W = "", V = x ? x.filter((D) => D.title === G) : [];
                if (V.length > 0) {
                  L = !0;
                  const D = V[0].params.filter((z) => z.value === U), Q = D.length > 0 ? D[0].color : "transparent";
                  W = je[Q];
                }
                return /* @__PURE__ */ f.jsx(
                  "div",
                  {
                    style: { gridArea: `col-${H.id}` },
                    title: U,
                    className: `min-w-[205px] h-10 flex items-center px-4 border-l border-white first:border-none leading-[120%] ${k ? "font-bold" : ""}`,
                    onClick: () => {
                      l !== void 0 && !H.onClickCell && l({ row: ee });
                    },
                    children: L ? /* @__PURE__ */ f.jsx("div", { className: "w-full h-8 px-4 justify-center items-center gap-2 flex", style: { borderRadius: "8px", backgroundColor: W }, children: /* @__PURE__ */ f.jsx("div", { className: "grow text-center text-white text-xs font-bold leading-[14.40px]", children: U }) }) : /* @__PURE__ */ f.jsx(
                      "p",
                      {
                        className: `w-full text-ellipsis overflow-hidden whitespace-nowrap ${H.isHyperlink ? "underline text-secondary-600" : ""}`,
                        onClick: () => H.onClickCell && H.onClickCell(ee, H),
                        children: U
                      }
                    )
                  },
                  G
                );
              }),
              /* @__PURE__ */ f.jsx("div", { className: "bg-white sticky block right-0 border-l border-white cursor-default pr-1", style: { zIndex: n.length - A + 1 }, children: /* @__PURE__ */ f.jsx("div", { className: S, children: /* @__PURE__ */ f.jsxs("div", { className: `flex items-center gap-2 h-[40px] ${a ? "px-4" : "pl-6 pr-4"} ${A + 1 === n.length ? "" : "border-b border-white"}`, children: [
                a && M ? /* @__PURE__ */ f.jsx(
                  gt,
                  {
                    type: "button",
                    variant: "secondary-light-bold",
                    icon: "edit",
                    tooltip: "Editar",
                    tooltipDirection: "left",
                    disabled: !M,
                    size: "s",
                    onlyIcon: !0,
                    onClick: () => {
                      o !== void 0 && o({ row: ee });
                    }
                  }
                ) : "        ",
                /* @__PURE__ */ f.jsx(
                  Lg,
                  {
                    actions: t,
                    row: ee,
                    canEdit: a,
                    onEditClick: o,
                    onActionClick: s,
                    onRowClick: l,
                    handleDisplayDetail: d,
                    detailColumns: h,
                    showDetail: m,
                    handleClickDetail: J
                  }
                ),
                m && /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx(
                  gt,
                  {
                    type: "button",
                    variant: "secondary-light-bold",
                    icon: "arrow-down",
                    tooltip: "Ver Detalle",
                    tooltipDirection: "left",
                    size: "s",
                    onlyIcon: !0,
                    onClick: () => {
                      d !== void 0 && (d({ row: ee, isShowDetail: X }), J({ row: ee }), K((G) => !G));
                    }
                  }
                ) })
              ] }) }) })
            ]
          },
          ee.id
        ),
        p.length > 0 && /* @__PURE__ */ f.jsx(
          kR,
          {
            actions: t,
            row: ee,
            index: A,
            canEdit: a,
            onEditClick: o,
            detailData: p,
            detailColumns: h,
            handleDeleteDetatail: v,
            rowDetail: F,
            NOMCOLXX: Z,
            onRowDetailClick: l,
            colorColumn: x
          }
        )
      ] }, `fragment-${A}`);
    }) }) })
  ] }) }) });
}, BR = E.forwardRef((e, t) => {
  const {
    actions: r = [],
    columns: n = [],
    data: a = [],
    canEdit: i = !1,
    activeRowValidation: o,
    className: s,
    onEditClick: l,
    onActionClick: c,
    onRowClick: u,
    onColumnClick: d,
    onChangeShowColumn: p,
    handleDisplayDetail: h,
    detailData: m = [],
    detailColumns: v = [],
    showDetail: g = !1,
    handleDeleteDetatail: b,
    isCheckedRow: C = !1,
    handleCheckedRow: w,
    handleCheckedAllRows: x,
    selectedRows: y,
    colorColumn: O,
    intermediateContent: P,
    ischeckedAll: j = !1,
    handleOrderChange: T,
    isOrderColumns: I = !0
  } = e;
  return n.length < 1 ? null : /* @__PURE__ */ f.jsxs("div", { ref: t, className: $e(["block", s]), children: [
    /* @__PURE__ */ f.jsx(
      NR,
      {
        actions: r,
        columns: n,
        data: a,
        canEdit: i,
        onEditClick: l,
        onActionClick: c,
        onRowClick: u,
        handleDisplayDetail: h,
        detailData: m,
        detailColumns: v,
        showDetail: g,
        handleDeleteDetatail: b
      }
    ),
    /* @__PURE__ */ f.jsx(
      RR,
      {
        actions: r,
        columns: n,
        data: a,
        activeRowValidation: o,
        canEdit: i,
        onEditClick: l,
        onActionClick: c,
        onRowClick: u,
        onColumnClick: d,
        onChangeShowColumn: p,
        handleDisplayDetail: h,
        detailData: m,
        detailColumns: v,
        showDetail: g,
        handleDeleteDetatail: b,
        isCheckedRow: C,
        handleCheckedRow: w,
        handleCheckedAllRows: x,
        selectedRows: y,
        colorColumn: O,
        intermediateContent: P,
        ischeckedAll: j,
        handleOrderChange: T,
        isOrderColumns: I
      }
    )
  ] });
});
BR.displayName = "TableMain";
function xl() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}
const VR = E.forwardRef((e, t) => {
  const {
    items: r = [],
    prevActive: n = !1,
    nextActive: a = !1,
    className: i,
    onItemClick: o,
    onPrevClick: s = () => {
    },
    onNextClick: l = () => {
    },
    trackingMeta: c
  } = e;
  return /* @__PURE__ */ f.jsxs("div", { ref: t, className: $e(["flex flex-wrap justify-center gap-4", i]), children: [
    /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        className: "bg-secondary-600 rounded-md w-8 h-8 flex items-center justify-center text-white disabled:bg-neutral-300 disabled:pointer-events-none",
        disabled: !n,
        onClick: () => {
          n && (s(), xl());
        },
        children: /* @__PURE__ */ f.jsx("span", { className: "w-[20px] min-w-[20px]", children: /* @__PURE__ */ f.jsx(me, { variant: "back-arrow", width: 18 }) })
      }
    ),
    r.map((u) => {
      const d = (u == null ? void 0 : u.isActive) ?? !0, p = (u == null ? void 0 : u.isDisabled) ?? !1;
      return /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          className: `w-8 h-8 flex justify-center items-center rounded-md font-bold ${d ? "bg-secondary-600 text-white pointer-events-none" : "bg-secondary-100 text-secondary-600 hover:bg-secondary-600 hover:text-white"} disabled:pointer-events-none`,
          disabled: p,
          onClick: () => {
            p || d || o !== void 0 && (o({ item: u }), xl());
          },
          children: u.label
        },
        u.label
      );
    }),
    /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        className: "bg-secondary-600 rounded-md w-8 h-8 flex items-center justify-center text-white disabled:bg-neutral-300 disabled:pointer-events-none",
        disabled: !a,
        onClick: () => {
          a && (l(), xl());
        },
        children: /* @__PURE__ */ f.jsx("span", { className: "w-[20px] min-w-[20px] -rotate-180", children: /* @__PURE__ */ f.jsx(me, { variant: "back-arrow", width: 18 }) })
      }
    ),
    /* @__PURE__ */ f.jsxs("p", { className: "text-ellipsis text-secondary-600 font-bold", children: [
      "Mostrando ",
      c.from,
      " al ",
      c.to,
      " de un total de ",
      c.total
    ] })
  ] });
});
VR.displayName = "TablePagination";
const HR = E.forwardRef((e, t) => {
  const {
    pages: r = [],
    onChangePage: n,
    className: a,
    trackingMeta: i
  } = e, [o, s] = ye(!1), l = r;
  return /* @__PURE__ */ f.jsxs("div", { ref: t, className: $e(["flex items-center justify-center gap-4", a]), children: [
    /* @__PURE__ */ f.jsx(sr, { variant: "title-2", children: "Items por página" }),
    /* @__PURE__ */ f.jsxs("div", { className: "flex-grow max-w-[100px] m:min-w-[100px] relative", children: [
      /* @__PURE__ */ f.jsxs(
        "button",
        {
          type: "button",
          className: `h-8 bg-neutral-200 border ${o ? "border-secondary-600" : "border-neutral-300 hover:border-secondary-400"} rounded-md w-full flex items-center justify-between gap-2 px-4`,
          onClick: () => {
            s((c) => !c);
          },
          children: [
            /* @__PURE__ */ f.jsx("span", { className: "block flex-grow text-left", children: i.per_page }),
            l.length > 0 && /* @__PURE__ */ f.jsx("span", { className: `w-[15px] min-w-[15px] ${o ? "-rotate-180" : ""}`, children: /* @__PURE__ */ f.jsx(me, { variant: "arrow-down", width: 15 }) })
          ]
        }
      ),
      l.length > 0 && o && /* @__PURE__ */ f.jsx("ul", { className: "absolute left-0 w-full bg-neutral-200 border border-neutral-300 rounded-md bottom-[calc(100%+8px)] shadow-m z-[1000] p-2 overflow-hidden", children: l.map((c) => /* @__PURE__ */ f.jsx(
        "li",
        {
          className: `px-4 py-3 rounded-md cursor-pointer leading-[120%] ${c === i.per_page ? "text-white bg-secondary-600" : "hover:bg-secondary-200"}`,
          onClick: () => {
            s(!1), c !== i.per_page && (n !== void 0 && n(c), xl());
          },
          children: c
        },
        c
      )) })
    ] })
  ] });
});
HR.displayName = "TableShowPages";
const FR = "animation-toast-in flex items-center justify-between gap-3 text-white font-bold py-4 px-5 rounded-[16px]", WR = {
  error: "bg-error-600",
  success: "bg-success-600",
  info: "bg-secondary-600",
  warning: "bg-warning-500"
}, zR = {
  error: `
    <svg width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke-width="1.8" stroke="white">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
    </svg>
  `,
  success: `
    <svg width="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.0674 20.3836L23.3861 14.2929C23.9154 13.7822 23.9314 12.9369 23.4194 12.4076C22.9087 11.8782 22.0647 11.8622 21.5341 12.3729L15.1981 18.4809C14.6767 19.0022 13.8354 19.0022 13.2781 18.4476L10.2407 15.6249C9.70473 15.1249 8.8594 15.1542 8.35673 15.6942C7.8554 16.2329 7.88607 17.0769 8.42607 17.5782L11.4287 20.3676C12.2101 21.1489 13.2381 21.5396 14.2634 21.5396C15.2834 21.5396 16.2981 21.1542 17.0687 20.3849L17.0674 20.3836Z" fill="white"/>
      <path d="M32 16C32 24.8227 24.8227 32 16 32C7.17733 32 0 24.8227 0 16C0 7.17733 7.17733 0 16 0C24.8227 0 32 7.17733 32 16ZM29.3333 16C29.3333 8.648 23.352 2.66667 16 2.66667C8.648 2.66667 2.66667 8.648 2.66667 16C2.66667 23.352 8.648 29.3333 16 29.3333C23.352 29.3333 29.3333 23.352 29.3333 16Z" fill="white"/>
    </svg>
  `,
  info: `
    <svg width="32" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 0.727295C12.8355 0.727295 9.74207 1.66568 7.11088 3.42378C4.4797 5.18188 2.42894 7.68074 1.21793 10.6044C0.00693257 13.528 -0.309921 16.745 0.307443 19.8487C0.924806 22.9524 2.44866 25.8034 4.6863 28.041C6.92394 30.2786 9.77486 31.8025 12.8786 32.4199C15.9823 33.0372 19.1993 32.7204 22.1229 31.5094C25.0466 30.2984 27.5454 28.2476 29.3035 25.6164C31.0616 22.9852 32 19.8918 32 16.7273C31.9954 12.4852 30.3082 8.41824 27.3086 5.41865C24.3091 2.41907 20.2421 0.731883 16 0.727295ZM16 30.0606C13.3629 30.0606 10.7851 29.2786 8.5924 27.8135C6.39975 26.3485 4.69078 24.2661 3.68161 21.8297C2.67244 19.3934 2.4084 16.7125 2.92287 14.1261C3.43734 11.5397 4.70722 9.1639 6.57192 7.2992C8.43661 5.4345 10.8124 4.16463 13.3988 3.65016C15.9852 3.13569 18.6661 3.39973 21.1024 4.4089C23.5388 5.41807 25.6212 7.12704 27.0863 9.31969C28.5513 11.5123 29.3333 14.0902 29.3333 16.7273C29.3295 20.2623 27.9234 23.6514 25.4238 26.1511C22.9242 28.6507 19.535 30.0567 16 30.0606Z" fill="white"/>
      <path d="M16.9563 7.47798C16.1874 7.33789 15.3971 7.3685 14.6414 7.56764C13.8856 7.76678 13.1829 8.12959 12.5829 8.63039C11.9828 9.13119 11.5002 9.75774 11.1691 10.4657C10.8381 11.1737 10.6666 11.9458 10.667 12.7273C10.667 13.0809 10.8075 13.4201 11.0575 13.6701C11.3076 13.9202 11.6467 14.0606 12.0003 14.0606C12.3539 14.0606 12.6931 13.9202 12.9431 13.6701C13.1932 13.4201 13.3337 13.0809 13.3337 12.7273C13.3333 12.335 13.4195 11.9475 13.5862 11.5923C13.7528 11.2372 13.9958 10.9232 14.2977 10.6727C14.5996 10.4222 14.9531 10.2414 15.3329 10.1432C15.7127 10.0451 16.1095 10.0319 16.495 10.1046C17.0217 10.2069 17.506 10.4638 17.886 10.8426C18.266 11.2214 18.5244 11.7049 18.6283 12.2313C18.7333 12.7839 18.6608 13.3554 18.4213 13.8643C18.1819 14.3732 17.7876 14.7933 17.295 15.0646C16.4792 15.5373 15.8051 16.22 15.3429 17.0417C14.8807 17.8634 14.6473 18.7941 14.667 19.7366V20.7273C14.667 21.0809 14.8075 21.4201 15.0575 21.6701C15.3076 21.9202 15.6467 22.0606 16.0003 22.0606C16.3539 22.0606 16.6931 21.9202 16.9431 21.6701C17.1932 21.4201 17.3337 21.0809 17.3337 20.7273V19.7366C17.3169 19.2727 17.4227 18.8125 17.6404 18.4024C17.8581 17.9923 18.18 17.6468 18.5737 17.4006C19.5397 16.8701 20.3176 16.0533 20.8004 15.0625C21.2833 14.0718 21.4473 12.9558 21.27 11.868C21.0927 10.7802 20.5828 9.7741 19.8103 8.98798C19.0379 8.20185 18.0408 7.67433 16.9563 7.47798Z" fill="white"/>
      <path d="M17.3337 24.7279C17.3337 23.9915 16.7367 23.3945 16.0003 23.3945C15.2639 23.3945 14.667 23.9915 14.667 24.7279C14.667 25.4642 15.2639 26.0612 16.0003 26.0612C16.7367 26.0612 17.3337 25.4642 17.3337 24.7279Z" fill="white"/>
    </svg>
  `,
  warning: `
    <svg width="32" viewBox="0 0 32 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.6636 16.7283V8.72391C14.6636 7.99017 15.2639 7.38984 15.9977 7.38984C16.7314 7.38984 17.3317 7.99017 17.3317 8.72391V16.7283C17.3317 17.4621 16.7314 18.0624 15.9977 18.0624C15.2639 18.0624 14.6636 17.4621 14.6636 16.7283ZM15.9977 19.3965C14.8904 19.3965 13.9965 20.2903 13.9965 21.3976C13.9965 22.5049 14.8904 23.3987 15.9977 23.3987C17.1049 23.3987 17.9988 22.5049 17.9988 21.3976C17.9988 20.2903 17.1049 19.3965 15.9977 19.3965ZM31.4462 25.9067C30.5123 27.7077 28.5513 28.735 26.0966 28.735H5.91207C3.44404 28.735 1.4963 27.7077 0.562449 25.9067C-0.384741 24.0924 -0.117927 21.7711 1.22948 19.8234L11.9554 2.854C12.9026 1.49324 14.3968 0.719482 15.9977 0.719482C17.5985 0.719482 19.0927 1.49324 19.9999 2.81397L30.7792 19.8501C32.1266 21.7978 32.38 24.1057 31.4328 25.9067H31.4462ZM28.5779 21.3442C28.5779 21.3442 28.5513 21.3175 28.5513 21.2909L17.7853 4.28145C17.3984 3.73448 16.7314 3.38762 15.9977 3.38762C15.2639 3.38762 14.5969 3.73448 14.1833 4.33482L3.44404 21.2909C2.61692 22.4648 2.43015 23.7456 2.91041 24.6661C3.37734 25.5732 4.44459 26.0668 5.89873 26.0668H26.0699C27.524 26.0668 28.5913 25.5732 29.0582 24.6661C29.5385 23.7456 29.3517 22.4648 28.5646 21.3442H28.5779Z" fill="white"/>
    </svg>
  `
}, UR = `
  <svg width="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.9998 0.999818C12.8123 0.812347 12.558 0.707031 12.2928 0.707031C12.0277 0.707031 11.7733 0.812347 11.5858 0.999818L6.99982 5.58582L2.41382 0.999818C2.22629 0.812347 1.97198 0.707031 1.70682 0.707031C1.44165 0.707031 1.18735 0.812347 0.999818 0.999818C0.812347 1.18735 0.707031 1.44165 0.707031 1.70682C0.707031 1.97198 0.812347 2.22629 0.999818 2.41382L5.58582 6.99982L0.999818 11.5858C0.812347 11.7733 0.707031 12.0277 0.707031 12.2928C0.707031 12.558 0.812347 12.8123 0.999818 12.9998C1.18735 13.1873 1.44165 13.2926 1.70682 13.2926C1.97198 13.2926 2.22629 13.1873 2.41382 12.9998L6.99982 8.41382L11.5858 12.9998C11.7733 13.1873 12.0277 13.2926 12.2928 13.2926C12.558 13.2926 12.8123 13.1873 12.9998 12.9998C13.1873 12.8123 13.2926 12.558 13.2926 12.2928C13.2926 12.0277 13.1873 11.7733 12.9998 11.5858L8.41382 6.99982L12.9998 2.41382C13.1873 2.22629 13.2926 1.97198 13.2926 1.70682C13.2926 1.44165 13.1873 1.18735 12.9998 0.999818Z" fill="white"/>
  </svg>
`, ZR = E.forwardRef((e, t) => {
  const {
    className: r
  } = e, n = ve(null);
  return _e(() => {
    const a = (i) => {
      var g;
      let o;
      const l = i.detail, c = l.duration ?? 6e3, u = (l == null ? void 0 : l.autoHide) ?? !0, d = document.createElement("div"), p = `${FR} ${WR[l.variant]}`.trim();
      d.setAttribute("class", p), u && (o = setTimeout(() => {
        d.classList.add("animation-toast-out"), l.onClose !== void 0 && l.onClose(), setTimeout(() => {
          d.style.display = "none";
        }, 250);
      }, c));
      const h = document.createElement("div");
      h.setAttribute("class", "w-8 min-w-[32px]"), h.innerHTML = `${zR[l.variant]}`;
      const m = document.createElement("p");
      m.setAttribute("class", "cursor-default flex-grow leading-[120%]"), m.innerText = l.text;
      const v = document.createElement("button");
      v.setAttribute("class", "w-10 min-w-[40px] h-10 rounded-md flex items-center justify-center bg-[rgba(255,255,255,0.18)]"), v.innerHTML = UR, v.onclick = () => {
        d.classList.add("animation-toast-out"), l.onClose !== void 0 && l.onClose(), clearTimeout(o), setTimeout(() => {
          d.style.display = "none";
        }, 250);
      }, d.append(h), d.append(m), d.append(v), (g = n.current) == null || g.append(d);
    };
    return document.addEventListener("codekit:shootToast", a, !0), () => {
      document.removeEventListener("codekit:shootToast", a, !0);
    };
  }, []), /* @__PURE__ */ f.jsx("div", { ref: t, className: $e(["fixed bottom-6 left-0 w-full pointer-events-none z-[2000] px-4", r]), children: /* @__PURE__ */ f.jsx("div", { ref: n, className: "grid gap-2 w-full max-w-[610px] mx-auto" }) });
});
ZR.displayName = "Toast";
const Fde = (e) => {
  const t = new CustomEvent("codekit:shootToast", {
    detail: e
  });
  document.dispatchEvent(t);
}, qR = E.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, c = `${{
    "body-1": "text-[20px]",
    "body-2": "text-[16px]",
    "body-3": "text-[14px]",
    "body-4": "text-[12px]"
  }[n]} not-italic font-normal leading-[160%]`, u = {
    textAlign: i,
    color: a !== void 0 ? je[a] : void 0
  };
  return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: c, style: u, ...s, children: r }) : /* @__PURE__ */ f.jsx("p", { ref: t, className: c, style: u, ...s, children: r });
});
qR.displayName = "Body";
const kg = E.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, c = `${{
    "description-1": "text-[20px]",
    "description-2": "text-[16px]",
    "description-3": "text-[14px]",
    "description-4": "text-[12px]"
  }[n]} not-italic font-normal leading-[120%]`, u = {
    textAlign: i,
    color: a !== void 0 ? je[a] : void 0
  };
  return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: c, style: u, ...s, children: r }) : /* @__PURE__ */ f.jsx("p", { ref: t, className: c, style: u, ...s, children: r });
});
kg.displayName = "Description";
const hr = kg, Rg = E.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, l = "not-italic font-bold leading-[120%]", c = {
    textAlign: i,
    color: a !== void 0 ? je[a] : void 0
  };
  if (n === "heading-1") {
    const u = `${l} text-[43px]`;
    return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: u, style: c, ...s, children: r }) : /* @__PURE__ */ f.jsx("h1", { ref: t, className: u, style: c, ...s, children: r });
  }
  if (n === "heading-2") {
    const u = `${l} text-[35px]`;
    return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: u, style: c, ...s, children: r }) : /* @__PURE__ */ f.jsx("h2", { ref: t, className: u, style: c, ...s, children: r });
  }
  if (n === "heading-3") {
    const u = `${l} text-[29px]`;
    return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: u, style: c, ...s, children: r }) : /* @__PURE__ */ f.jsx("h3", { ref: t, className: u, style: c, ...s, children: r });
  }
  if (n === "heading-4") {
    const u = `${l} text-[23px]`;
    return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: u, style: c, ...s, children: r }) : /* @__PURE__ */ f.jsx("h4", { ref: t, className: u, style: c, ...s, children: r });
  }
  if (n === "heading-5") {
    const u = `${l} text-[19px]`;
    return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: u, style: c, ...s, children: r }) : /* @__PURE__ */ f.jsx("h5", { ref: t, className: u, style: c, ...s, children: r });
  }
  if (n === "heading-6") {
    const u = `${l} text-[15px]`;
    return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: u, style: c, ...s, children: r }) : /* @__PURE__ */ f.jsx("h6", { ref: t, className: u, style: c, ...s, children: r });
  }
  return null;
});
Rg.displayName = "Heading";
const $n = Rg, GR = E.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, c = `${{
    "overheading-1": "font-normal text-[14px] tracking-[0.44em]",
    "hyperlink-1": "font-bold text-[14px] underline"
  }[n]} not-italic leading-[100%]`, u = {
    textAlign: i,
    color: a !== void 0 ? je[a] : void 0
  };
  return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: c, style: u, ...s, children: r }) : /* @__PURE__ */ f.jsx("p", { ref: t, className: c, style: u, ...s, children: r });
});
GR.displayName = "TextOther";
const Bg = E.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, c = `${{
    "title-1": "text-[20px]",
    "title-2": "text-[16px]",
    "title-3": "text-[14px]",
    "title-4": "text-[12px]"
  }[n]} not-italic font-bold leading-[120%]`, u = {
    textAlign: i,
    color: a !== void 0 ? je[a] : void 0
  };
  return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: c, style: u, ...s, children: r }) : /* @__PURE__ */ f.jsx("p", { ref: t, className: c, style: u, ...s, children: r });
});
Bg.displayName = "Title";
const sr = Bg, YR = E.forwardRef((e, t) => {
  const {
    alignment: r,
    children: n,
    weight: a = "bold",
    color: i,
    ...o
  } = e, s = {
    textAlign: r,
    fontWeight: a !== void 0 ? w1[a] : void 0,
    color: i !== void 0 ? je[i] : void 0
  };
  return /* @__PURE__ */ f.jsx("div", { ...o, ref: t, children: /* @__PURE__ */ f.jsx("div", { className: "p-2", style: s, children: /* @__PURE__ */ f.jsx(Tn, { spacingX: 5, children: /* @__PURE__ */ f.jsx(hr, { variant: "description-2", children: n }) }) }) });
});
YR.displayName = "TarjetBody";
const KR = E.forwardRef((e, t) => {
  const {
    alignment: r,
    children: n,
    weight: a = "bold",
    color: i,
    colorbox: o,
    icon: s,
    iconBooton: l,
    textLb: c,
    onClickAction: u,
    row: d,
    textToltip: p,
    directionToltip: h,
    ...m
  } = e, v = {
    textAlign: r,
    fontWeight: a !== void 0 ? w1[a] : void 0,
    color: i !== void 0 ? je[i] : void 0
  }, g = () => {
    u !== void 0 && u({ row: d });
  };
  return /* @__PURE__ */ f.jsx("div", { ...m, ref: t, children: /* @__PURE__ */ f.jsxs("div", { children: [
    /* @__PURE__ */ f.jsxs("div", { className: "float-right col-span-2 flex justify-end ", children: [
      /* @__PURE__ */ f.jsx(
        gt,
        {
          icon: l,
          variant: "secondary",
          size: "s",
          onlyIcon: !0,
          tooltip: p,
          tooltipDirection: h,
          onClick: g
        }
      ),
      /* @__PURE__ */ f.jsx(Tn, { bg: o, color: "white", rounded: "xl", spacingX: 6, spacingY: 1, children: /* @__PURE__ */ f.jsx(Qr, { alignItems: "center", children: /* @__PURE__ */ f.jsx("strong", { children: c.label }) }) })
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: "p-2", style: v, children: /* @__PURE__ */ f.jsxs(Tn, { spacingX: 5, children: [
      s !== void 0 && /* @__PURE__ */ f.jsx("span", { className: "inline-block w-7", children: /* @__PURE__ */ f.jsx(me, { variant: s }) }),
      /* @__PURE__ */ f.jsxs($n, { variant: "heading-6", children: [
        /* @__PURE__ */ f.jsx("div", { className: "hidden m:flex ", children: /* @__PURE__ */ f.jsx("p", { className: "line-clamp-1 hover:line-clamp-2", children: n }) }),
        /* @__PURE__ */ f.jsx("div", { className: "m:hidden", children: n })
      ] })
    ] }) })
  ] }) });
});
KR.displayName = "TarjetTitle";
const XR = E.forwardRef((e, t) => {
  const {
    alignment: r,
    children: n,
    weight: a = "bold",
    color: i,
    targetoo: o,
    icon2: s,
    urlphoto1: l,
    variant: c,
    ...u
  } = e, d = {
    textAlign: r,
    fontWeight: a !== void 0 ? w1[a] : void 0,
    color: i !== void 0 ? je[i] : void 0
  }, p = {
    primary: "bg-primary-700 ",
    secondary: "bg-secondary-600 ",
    accent: "bg-accent-700 ",
    info: "bg-info-700 ",
    warning: "bg-warning-600 ",
    success: "bg-success-600 ",
    error: "bg-error-600 "
  }, h = "bg-neutral-600";
  return /* @__PURE__ */ f.jsx("div", { ...u, ref: t, children: /* @__PURE__ */ f.jsx(Tn, { spacingX: 2, children: /* @__PURE__ */ f.jsxs(Hi, { columnsVariant: "form-2", spacing: 3, children: [
    /* @__PURE__ */ f.jsx(Ei, { children: /* @__PURE__ */ f.jsx("div", { className: "p-2 flex items-center space-2", children: /* @__PURE__ */ f.jsxs(Ei, { children: [
      /* @__PURE__ */ f.jsx(Tn, { mb: 2, children: /* @__PURE__ */ f.jsx($n, { variant: "heading-6", children: o.title1 }) }),
      /* @__PURE__ */ f.jsxs(Qr, { alignItems: "start", justifyContent: "between", gap: 3, children: [
        /* @__PURE__ */ f.jsx(os, { minWidth: 28, children: /* @__PURE__ */ f.jsx(x1, { size: "md", image: l, grayscale: !0 }) }),
        /* @__PURE__ */ f.jsx(os, { grow: !0, children: /* @__PURE__ */ f.jsxs(Hi, { children: [
          /* @__PURE__ */ f.jsx(sr, { variant: "title-2", children: o.respons1 }),
          /* @__PURE__ */ f.jsx("p", { className: "truncate text-[14px] not-italic font-normal leading-[120%]", children: o.descrip1 })
        ] }) })
      ] })
    ] }) }) }),
    /* @__PURE__ */ f.jsx(Ei, { children: /* @__PURE__ */ f.jsx("div", { className: "p-2 flex items-center space-2", style: d, children: /* @__PURE__ */ f.jsxs(Ei, { children: [
      /* @__PURE__ */ f.jsx(Tn, { mb: 2, children: /* @__PURE__ */ f.jsx($n, { variant: "heading-6", children: o.title2 }) }),
      /* @__PURE__ */ f.jsxs(Qr, { alignItems: "start", justifyContent: "between", gap: 2, children: [
        /* @__PURE__ */ f.jsx(os, { minWidth: 32, children: /* @__PURE__ */ f.jsx("span", { className: `h-[32px] w-[32px] min-w-[32px] flex items-center justify-center aspect-square rounded-full ${c !== void 0 ? p[c] : h} border border-white`, children: /* @__PURE__ */ f.jsx(me, { variant: s, width: 20, color: i ? "neutral-100" : "neutral-600" }) }) }),
        /* @__PURE__ */ f.jsxs(os, { grow: !0, children: [
          /* @__PURE__ */ f.jsx(hr, { variant: "description-2", children: o.respons2 }),
          /* @__PURE__ */ f.jsx("p", { className: "truncate text-[14px] not-italic font-normal leading-[120%]", children: o.descrip2 })
        ] })
      ] })
    ] }) }) })
  ] }) }) });
});
XR.displayName = "TarjetFooter";
const QR = E.forwardRef((e, t) => {
  const {
    alignment: r,
    weight: n = "bold",
    color: a,
    children: i,
    parametrs: o,
    colorTitle: s,
    colorBody: l,
    icon: c,
    maxHeigth: u,
    isOpen: d,
    colorLabel: p,
    borderColor: h,
    badge: m,
    shadow: v,
    alignTitle: g,
    isSpan: b,
    textSpan: C,
    variantSpan: w,
    handleClick: x,
    ...y
  } = e, O = {
    textAlign: r,
    fontWeight: n !== void 0 ? w1[n] : void 0,
    color: a !== void 0 ? je[a] : void 0,
    borderColor: h !== void 0 ? je[h] : je["neutral-300"]
  }, P = {
    backgroundColor: s !== void 0 ? je[s] : void 0
  }, j = {
    primary: "bg-primary-100 text-primary-600 hover:bg-primary-300",
    "primary-bold": "bg-primary-500 text-white ",
    secondary: "bg-secondary-600 text-white",
    "secondary-light": "bg-secondary-600 text-white",
    "secondary-light-bold": "bg-secondary-300 text-secondary-600 hover:bg-secondary-400",
    "secondary-bold": "bg-secondary-600 text-white hover:bg-secondary-500",
    terciary: "bg-secondary-800 text-white hover:bg-secondary-700",
    accent: "bg-accent-600 text-white hover:bg-accent-500",
    info: "bg-info-500 text-white hover:bg-info-400",
    warning: "bg-warning-500 text-white hover:bg-warning-400",
    success: "bg-success-500 text-white hover:bg-success-400",
    error: "bg-error-500 text-white hover:bg-error-400",
    "error-light": "bg-error-100 text-error-500",
    "error-light-bold": "bg-error-200 text-error-500 hover:bg-error-300",
    "white-secondary": "bg-white text-secondary-600 hover:bg-secondary-100"
  }, [T, I] = ye(d);
  return /* @__PURE__ */ f.jsx("div", { ...y, ref: t, className: "w-full mx-auto ", children: /* @__PURE__ */ f.jsxs("div", { className: "border rounded-lg mb-2", style: O, children: [
    /* @__PURE__ */ f.jsx("div", { className: `${T ? " rounded-t-lg " : " rounded-lg "} `, style: P, children: /* @__PURE__ */ f.jsxs(
      "div",
      {
        onClick: () => {
          I((R) => !R), x !== void 0 && x(T);
        },
        className: `w-full p-4 flex ${g === "right" ? "justify-end" : "justify-between"} items-center focus:outline-none`,
        children: [
          /* @__PURE__ */ f.jsx("span", { className: `${g === "center" ? "mx-auto" : ""}`, children: /* @__PURE__ */ f.jsxs(Jf, { icon: c, color: p, children: [
            o.title,
            " ",
            m ? ` / ${m}` : ""
          ] }) }),
          /* @__PURE__ */ f.jsxs("div", { className: "flex justify-between items-center", children: [
            b && w !== void 0 && /* @__PURE__ */ f.jsx("span", { className: `${j[w]} text-xs font-medium me-2 px-2.5 py-0.5 rounded`, children: C }),
            /* @__PURE__ */ f.jsx(
              "svg",
              {
                xmlns: "http://www.w3.org/2000/svg",
                className: `h-6 w-6 transition-transform transform ${T ? "rotate-180" : "rotate-0"}`,
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                style: { color: p ? je[p] : je.DEFAULT },
                children: /* @__PURE__ */ f.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M19 9l-7 7-7-7" })
              }
            )
          ] })
        ]
      }
    ) }),
    T && /* @__PURE__ */ f.jsx(Tn, { spacing: 5, bg: l, borderTop: 1, borderColor: h, children: /* @__PURE__ */ f.jsx(
      "div",
      {
        className: `overflow-y-auto ${T ? `${u !== void 0 ? `max-h-${u}` : ""}` : "max-h-0"}`,
        children: i
      }
    ) })
  ] }) });
});
QR.displayName = "Acordeon";
var JR = Error, eB = EvalError, tB = RangeError, rB = ReferenceError, Vg = SyntaxError, $1 = TypeError, nB = URIError, aB = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var t = {}, r = Symbol("test"), n = Object(r);
  if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
    return !1;
  var a = 42;
  t[r] = a;
  for (r in t)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
    return !1;
  var i = Object.getOwnPropertySymbols(t);
  if (i.length !== 1 || i[0] !== r || !Object.prototype.propertyIsEnumerable.call(t, r))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var o = Object.getOwnPropertyDescriptor(t, r);
    if (o.value !== a || o.enumerable !== !0)
      return !1;
  }
  return !0;
}, Cp = typeof Symbol < "u" && Symbol, iB = aB, oB = function() {
  return typeof Cp != "function" || typeof Symbol != "function" || typeof Cp("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : iB();
}, Z2 = {
  __proto__: null,
  foo: {}
}, sB = Object, lB = function() {
  return { __proto__: Z2 }.foo === Z2.foo && !(Z2 instanceof sB);
}, cB = "Function.prototype.bind called on incompatible ", uB = Object.prototype.toString, fB = Math.max, dB = "[object Function]", xp = function(t, r) {
  for (var n = [], a = 0; a < t.length; a += 1)
    n[a] = t[a];
  for (var i = 0; i < r.length; i += 1)
    n[i + t.length] = r[i];
  return n;
}, pB = function(t, r) {
  for (var n = [], a = r || 0, i = 0; a < t.length; a += 1, i += 1)
    n[i] = t[a];
  return n;
}, hB = function(e, t) {
  for (var r = "", n = 0; n < e.length; n += 1)
    r += e[n], n + 1 < e.length && (r += t);
  return r;
}, vB = function(t) {
  var r = this;
  if (typeof r != "function" || uB.apply(r) !== dB)
    throw new TypeError(cB + r);
  for (var n = pB(arguments, 1), a, i = function() {
    if (this instanceof a) {
      var u = r.apply(
        this,
        xp(n, arguments)
      );
      return Object(u) === u ? u : this;
    }
    return r.apply(
      t,
      xp(n, arguments)
    );
  }, o = fB(0, r.length - n.length), s = [], l = 0; l < o; l++)
    s[l] = "$" + l;
  if (a = Function("binder", "return function (" + hB(s, ",") + "){ return binder.apply(this,arguments); }")(i), r.prototype) {
    var c = function() {
    };
    c.prototype = r.prototype, a.prototype = new c(), c.prototype = null;
  }
  return a;
}, mB = vB, Yd = Function.prototype.bind || mB, gB = Function.prototype.call, yB = Object.prototype.hasOwnProperty, bB = Yd, CB = bB.call(gB, yB), Ie, xB = JR, wB = eB, OB = tB, SB = rB, Fi = Vg, Ti = $1, PB = nB, Hg = Function, q2 = function(e) {
  try {
    return Hg('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, Za = Object.getOwnPropertyDescriptor;
if (Za)
  try {
    Za({}, "");
  } catch {
    Za = null;
  }
var G2 = function() {
  throw new Ti();
}, EB = Za ? function() {
  try {
    return arguments.callee, G2;
  } catch {
    try {
      return Za(arguments, "callee").get;
    } catch {
      return G2;
    }
  }
}() : G2, vi = oB(), jB = lB(), Wt = Object.getPrototypeOf || (jB ? function(e) {
  return e.__proto__;
} : null), Oi = {}, _B = typeof Uint8Array > "u" || !Wt ? Ie : Wt(Uint8Array), qa = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? Ie : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? Ie : ArrayBuffer,
  "%ArrayIteratorPrototype%": vi && Wt ? Wt([][Symbol.iterator]()) : Ie,
  "%AsyncFromSyncIteratorPrototype%": Ie,
  "%AsyncFunction%": Oi,
  "%AsyncGenerator%": Oi,
  "%AsyncGeneratorFunction%": Oi,
  "%AsyncIteratorPrototype%": Oi,
  "%Atomics%": typeof Atomics > "u" ? Ie : Atomics,
  "%BigInt%": typeof BigInt > "u" ? Ie : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? Ie : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? Ie : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? Ie : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": xB,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": wB,
  "%Float32Array%": typeof Float32Array > "u" ? Ie : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? Ie : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? Ie : FinalizationRegistry,
  "%Function%": Hg,
  "%GeneratorFunction%": Oi,
  "%Int8Array%": typeof Int8Array > "u" ? Ie : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? Ie : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? Ie : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": vi && Wt ? Wt(Wt([][Symbol.iterator]())) : Ie,
  "%JSON%": typeof JSON == "object" ? JSON : Ie,
  "%Map%": typeof Map > "u" ? Ie : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !vi || !Wt ? Ie : Wt((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? Ie : Promise,
  "%Proxy%": typeof Proxy > "u" ? Ie : Proxy,
  "%RangeError%": OB,
  "%ReferenceError%": SB,
  "%Reflect%": typeof Reflect > "u" ? Ie : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? Ie : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !vi || !Wt ? Ie : Wt((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? Ie : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": vi && Wt ? Wt(""[Symbol.iterator]()) : Ie,
  "%Symbol%": vi ? Symbol : Ie,
  "%SyntaxError%": Fi,
  "%ThrowTypeError%": EB,
  "%TypedArray%": _B,
  "%TypeError%": Ti,
  "%Uint8Array%": typeof Uint8Array > "u" ? Ie : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? Ie : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? Ie : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? Ie : Uint32Array,
  "%URIError%": PB,
  "%WeakMap%": typeof WeakMap > "u" ? Ie : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? Ie : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? Ie : WeakSet
};
if (Wt)
  try {
    null.error;
  } catch (e) {
    var AB = Wt(Wt(e));
    qa["%Error.prototype%"] = AB;
  }
var DB = function e(t) {
  var r;
  if (t === "%AsyncFunction%")
    r = q2("async function () {}");
  else if (t === "%GeneratorFunction%")
    r = q2("function* () {}");
  else if (t === "%AsyncGeneratorFunction%")
    r = q2("async function* () {}");
  else if (t === "%AsyncGenerator%") {
    var n = e("%AsyncGeneratorFunction%");
    n && (r = n.prototype);
  } else if (t === "%AsyncIteratorPrototype%") {
    var a = e("%AsyncGenerator%");
    a && Wt && (r = Wt(a.prototype));
  }
  return qa[t] = r, r;
}, wp = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, N1 = Yd, Gl = CB, MB = N1.call(Function.call, Array.prototype.concat), TB = N1.call(Function.apply, Array.prototype.splice), Op = N1.call(Function.call, String.prototype.replace), Yl = N1.call(Function.call, String.prototype.slice), $B = N1.call(Function.call, RegExp.prototype.exec), NB = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, IB = /\\(\\)?/g, LB = function(t) {
  var r = Yl(t, 0, 1), n = Yl(t, -1);
  if (r === "%" && n !== "%")
    throw new Fi("invalid intrinsic syntax, expected closing `%`");
  if (n === "%" && r !== "%")
    throw new Fi("invalid intrinsic syntax, expected opening `%`");
  var a = [];
  return Op(t, NB, function(i, o, s, l) {
    a[a.length] = s ? Op(l, IB, "$1") : o || i;
  }), a;
}, kB = function(t, r) {
  var n = t, a;
  if (Gl(wp, n) && (a = wp[n], n = "%" + a[0] + "%"), Gl(qa, n)) {
    var i = qa[n];
    if (i === Oi && (i = DB(n)), typeof i > "u" && !r)
      throw new Ti("intrinsic " + t + " exists, but is not available. Please file an issue!");
    return {
      alias: a,
      name: n,
      value: i
    };
  }
  throw new Fi("intrinsic " + t + " does not exist!");
}, Po = function(t, r) {
  if (typeof t != "string" || t.length === 0)
    throw new Ti("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof r != "boolean")
    throw new Ti('"allowMissing" argument must be a boolean');
  if ($B(/^%?[^%]*%?$/, t) === null)
    throw new Fi("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var n = LB(t), a = n.length > 0 ? n[0] : "", i = kB("%" + a + "%", r), o = i.name, s = i.value, l = !1, c = i.alias;
  c && (a = c[0], TB(n, MB([0, 1], c)));
  for (var u = 1, d = !0; u < n.length; u += 1) {
    var p = n[u], h = Yl(p, 0, 1), m = Yl(p, -1);
    if ((h === '"' || h === "'" || h === "`" || m === '"' || m === "'" || m === "`") && h !== m)
      throw new Fi("property names with quotes must have matching quotes");
    if ((p === "constructor" || !d) && (l = !0), a += "." + p, o = "%" + a + "%", Gl(qa, o))
      s = qa[o];
    else if (s != null) {
      if (!(p in s)) {
        if (!r)
          throw new Ti("base intrinsic for " + t + " exists, but the property is not available.");
        return;
      }
      if (Za && u + 1 >= n.length) {
        var v = Za(s, p);
        d = !!v, d && "get" in v && !("originalValue" in v.get) ? s = v.get : s = s[p];
      } else
        d = Gl(s, p), s = s[p];
      d && !l && (qa[o] = s);
    }
  }
  return s;
}, Fg = { exports: {} }, Y2, Sp;
function Kd() {
  if (Sp)
    return Y2;
  Sp = 1;
  var e = Po, t = e("%Object.defineProperty%", !0) || !1;
  if (t)
    try {
      t({}, "a", { value: 1 });
    } catch {
      t = !1;
    }
  return Y2 = t, Y2;
}
var RB = Po, wl = RB("%Object.getOwnPropertyDescriptor%", !0);
if (wl)
  try {
    wl([], "length");
  } catch {
    wl = null;
  }
var Wg = wl, Pp = Kd(), BB = Vg, mi = $1, Ep = Wg, VB = function(t, r, n) {
  if (!t || typeof t != "object" && typeof t != "function")
    throw new mi("`obj` must be an object or a function`");
  if (typeof r != "string" && typeof r != "symbol")
    throw new mi("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new mi("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new mi("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new mi("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new mi("`loose`, if provided, must be a boolean");
  var a = arguments.length > 3 ? arguments[3] : null, i = arguments.length > 4 ? arguments[4] : null, o = arguments.length > 5 ? arguments[5] : null, s = arguments.length > 6 ? arguments[6] : !1, l = !!Ep && Ep(t, r);
  if (Pp)
    Pp(t, r, {
      configurable: o === null && l ? l.configurable : !o,
      enumerable: a === null && l ? l.enumerable : !a,
      value: n,
      writable: i === null && l ? l.writable : !i
    });
  else if (s || !a && !i && !o)
    t[r] = n;
  else
    throw new BB("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, l0 = Kd(), zg = function() {
  return !!l0;
};
zg.hasArrayLengthDefineBug = function() {
  if (!l0)
    return null;
  try {
    return l0([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var HB = zg, FB = Po, jp = VB, WB = HB(), _p = Wg, Ap = $1, zB = FB("%Math.floor%"), UB = function(t, r) {
  if (typeof t != "function")
    throw new Ap("`fn` is not a function");
  if (typeof r != "number" || r < 0 || r > 4294967295 || zB(r) !== r)
    throw new Ap("`length` must be a positive 32-bit integer");
  var n = arguments.length > 2 && !!arguments[2], a = !0, i = !0;
  if ("length" in t && _p) {
    var o = _p(t, "length");
    o && !o.configurable && (a = !1), o && !o.writable && (i = !1);
  }
  return (a || i || !n) && (WB ? jp(
    /** @type {Parameters<define>[0]} */
    t,
    "length",
    r,
    !0,
    !0
  ) : jp(
    /** @type {Parameters<define>[0]} */
    t,
    "length",
    r
  )), t;
};
(function(e) {
  var t = Yd, r = Po, n = UB, a = $1, i = r("%Function.prototype.apply%"), o = r("%Function.prototype.call%"), s = r("%Reflect.apply%", !0) || t.call(o, i), l = Kd(), c = r("%Math.max%");
  e.exports = function(p) {
    if (typeof p != "function")
      throw new a("a function is required");
    var h = s(t, o, arguments);
    return n(
      h,
      1 + c(0, p.length - (arguments.length - 1)),
      !0
    );
  };
  var u = function() {
    return s(t, i, arguments);
  };
  l ? l(e.exports, "apply", { value: u }) : e.exports.apply = u;
})(Fg);
var ZB = Fg.exports, Ug = Po, Zg = ZB, qB = Zg(Ug("String.prototype.indexOf")), GB = function(t, r) {
  var n = Ug(t, !!r);
  return typeof n == "function" && qB(t, ".prototype.") > -1 ? Zg(n) : n;
};
const YB = {}, KB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: YB
}, Symbol.toStringTag, { value: "Module" })), XB = /* @__PURE__ */ qe(KB);
var Xd = typeof Map == "function" && Map.prototype, K2 = Object.getOwnPropertyDescriptor && Xd ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, Kl = Xd && K2 && typeof K2.get == "function" ? K2.get : null, Dp = Xd && Map.prototype.forEach, Qd = typeof Set == "function" && Set.prototype, X2 = Object.getOwnPropertyDescriptor && Qd ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, Xl = Qd && X2 && typeof X2.get == "function" ? X2.get : null, Mp = Qd && Set.prototype.forEach, QB = typeof WeakMap == "function" && WeakMap.prototype, bs = QB ? WeakMap.prototype.has : null, JB = typeof WeakSet == "function" && WeakSet.prototype, Cs = JB ? WeakSet.prototype.has : null, eV = typeof WeakRef == "function" && WeakRef.prototype, Tp = eV ? WeakRef.prototype.deref : null, tV = Boolean.prototype.valueOf, rV = Object.prototype.toString, nV = Function.prototype.toString, aV = String.prototype.match, Jd = String.prototype.slice, Kn = String.prototype.replace, iV = String.prototype.toUpperCase, $p = String.prototype.toLowerCase, qg = RegExp.prototype.test, Np = Array.prototype.concat, sn = Array.prototype.join, oV = Array.prototype.slice, Ip = Math.floor, c0 = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, Q2 = Object.getOwnPropertySymbols, u0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, Wi = typeof Symbol == "function" && typeof Symbol.iterator == "object", Jt = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === Wi || "symbol") ? Symbol.toStringTag : null, Gg = Object.prototype.propertyIsEnumerable, Lp = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(e) {
  return e.__proto__;
} : null);
function kp(e, t) {
  if (e === 1 / 0 || e === -1 / 0 || e !== e || e && e > -1e3 && e < 1e3 || qg.call(/e/, t))
    return t;
  var r = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof e == "number") {
    var n = e < 0 ? -Ip(-e) : Ip(e);
    if (n !== e) {
      var a = String(n), i = Jd.call(t, a.length + 1);
      return Kn.call(a, r, "$&_") + "." + Kn.call(Kn.call(i, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return Kn.call(t, r, "$&_");
}
var f0 = XB, Rp = f0.custom, Bp = Kg(Rp) ? Rp : null, sV = function e(t, r, n, a) {
  var i = r || {};
  if (qn(i, "quoteStyle") && i.quoteStyle !== "single" && i.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (qn(i, "maxStringLength") && (typeof i.maxStringLength == "number" ? i.maxStringLength < 0 && i.maxStringLength !== 1 / 0 : i.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var o = qn(i, "customInspect") ? i.customInspect : !0;
  if (typeof o != "boolean" && o !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (qn(i, "indent") && i.indent !== null && i.indent !== "	" && !(parseInt(i.indent, 10) === i.indent && i.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (qn(i, "numericSeparator") && typeof i.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var s = i.numericSeparator;
  if (typeof t > "u")
    return "undefined";
  if (t === null)
    return "null";
  if (typeof t == "boolean")
    return t ? "true" : "false";
  if (typeof t == "string")
    return Qg(t, i);
  if (typeof t == "number") {
    if (t === 0)
      return 1 / 0 / t > 0 ? "0" : "-0";
    var l = String(t);
    return s ? kp(t, l) : l;
  }
  if (typeof t == "bigint") {
    var c = String(t) + "n";
    return s ? kp(t, c) : c;
  }
  var u = typeof i.depth > "u" ? 5 : i.depth;
  if (typeof n > "u" && (n = 0), n >= u && u > 0 && typeof t == "object")
    return d0(t) ? "[Array]" : "[Object]";
  var d = PV(i, n);
  if (typeof a > "u")
    a = [];
  else if (Xg(a, t) >= 0)
    return "[Circular]";
  function p($, Z, X) {
    if (Z && (a = oV.call(a), a.push(Z)), X) {
      var K = {
        depth: i.depth
      };
      return qn(i, "quoteStyle") && (K.quoteStyle = i.quoteStyle), e($, K, n + 1, a);
    }
    return e($, i, n + 1, a);
  }
  if (typeof t == "function" && !Vp(t)) {
    var h = mV(t), m = tl(t, p);
    return "[Function" + (h ? ": " + h : " (anonymous)") + "]" + (m.length > 0 ? " { " + sn.call(m, ", ") + " }" : "");
  }
  if (Kg(t)) {
    var v = Wi ? Kn.call(String(t), /^(Symbol\(.*\))_[^)]*$/, "$1") : u0.call(t);
    return typeof t == "object" && !Wi ? Yo(v) : v;
  }
  if (wV(t)) {
    for (var g = "<" + $p.call(String(t.nodeName)), b = t.attributes || [], C = 0; C < b.length; C++)
      g += " " + b[C].name + "=" + Yg(lV(b[C].value), "double", i);
    return g += ">", t.childNodes && t.childNodes.length && (g += "..."), g += "</" + $p.call(String(t.nodeName)) + ">", g;
  }
  if (d0(t)) {
    if (t.length === 0)
      return "[]";
    var w = tl(t, p);
    return d && !SV(w) ? "[" + p0(w, d) + "]" : "[ " + sn.call(w, ", ") + " ]";
  }
  if (uV(t)) {
    var x = tl(t, p);
    return !("cause" in Error.prototype) && "cause" in t && !Gg.call(t, "cause") ? "{ [" + String(t) + "] " + sn.call(Np.call("[cause]: " + p(t.cause), x), ", ") + " }" : x.length === 0 ? "[" + String(t) + "]" : "{ [" + String(t) + "] " + sn.call(x, ", ") + " }";
  }
  if (typeof t == "object" && o) {
    if (Bp && typeof t[Bp] == "function" && f0)
      return f0(t, { depth: u - n });
    if (o !== "symbol" && typeof t.inspect == "function")
      return t.inspect();
  }
  if (gV(t)) {
    var y = [];
    return Dp && Dp.call(t, function($, Z) {
      y.push(p(Z, t, !0) + " => " + p($, t));
    }), Hp("Map", Kl.call(t), y, d);
  }
  if (CV(t)) {
    var O = [];
    return Mp && Mp.call(t, function($) {
      O.push(p($, t));
    }), Hp("Set", Xl.call(t), O, d);
  }
  if (yV(t))
    return J2("WeakMap");
  if (xV(t))
    return J2("WeakSet");
  if (bV(t))
    return J2("WeakRef");
  if (dV(t))
    return Yo(p(Number(t)));
  if (hV(t))
    return Yo(p(c0.call(t)));
  if (pV(t))
    return Yo(tV.call(t));
  if (fV(t))
    return Yo(p(String(t)));
  if (typeof window < "u" && t === window)
    return "{ [object Window] }";
  if (typeof globalThis < "u" && t === globalThis || typeof Ba < "u" && t === Ba)
    return "{ [object globalThis] }";
  if (!cV(t) && !Vp(t)) {
    var P = tl(t, p), j = Lp ? Lp(t) === Object.prototype : t instanceof Object || t.constructor === Object, T = t instanceof Object ? "" : "null prototype", I = !j && Jt && Object(t) === t && Jt in t ? Jd.call(va(t), 8, -1) : T ? "Object" : "", R = j || typeof t.constructor != "function" ? "" : t.constructor.name ? t.constructor.name + " " : "", F = R + (I || T ? "[" + sn.call(Np.call([], I || [], T || []), ": ") + "] " : "");
    return P.length === 0 ? F + "{}" : d ? F + "{" + p0(P, d) + "}" : F + "{ " + sn.call(P, ", ") + " }";
  }
  return String(t);
};
function Yg(e, t, r) {
  var n = (r.quoteStyle || t) === "double" ? '"' : "'";
  return n + e + n;
}
function lV(e) {
  return Kn.call(String(e), /"/g, "&quot;");
}
function d0(e) {
  return va(e) === "[object Array]" && (!Jt || !(typeof e == "object" && Jt in e));
}
function cV(e) {
  return va(e) === "[object Date]" && (!Jt || !(typeof e == "object" && Jt in e));
}
function Vp(e) {
  return va(e) === "[object RegExp]" && (!Jt || !(typeof e == "object" && Jt in e));
}
function uV(e) {
  return va(e) === "[object Error]" && (!Jt || !(typeof e == "object" && Jt in e));
}
function fV(e) {
  return va(e) === "[object String]" && (!Jt || !(typeof e == "object" && Jt in e));
}
function dV(e) {
  return va(e) === "[object Number]" && (!Jt || !(typeof e == "object" && Jt in e));
}
function pV(e) {
  return va(e) === "[object Boolean]" && (!Jt || !(typeof e == "object" && Jt in e));
}
function Kg(e) {
  if (Wi)
    return e && typeof e == "object" && e instanceof Symbol;
  if (typeof e == "symbol")
    return !0;
  if (!e || typeof e != "object" || !u0)
    return !1;
  try {
    return u0.call(e), !0;
  } catch {
  }
  return !1;
}
function hV(e) {
  if (!e || typeof e != "object" || !c0)
    return !1;
  try {
    return c0.call(e), !0;
  } catch {
  }
  return !1;
}
var vV = Object.prototype.hasOwnProperty || function(e) {
  return e in this;
};
function qn(e, t) {
  return vV.call(e, t);
}
function va(e) {
  return rV.call(e);
}
function mV(e) {
  if (e.name)
    return e.name;
  var t = aV.call(nV.call(e), /^function\s*([\w$]+)/);
  return t ? t[1] : null;
}
function Xg(e, t) {
  if (e.indexOf)
    return e.indexOf(t);
  for (var r = 0, n = e.length; r < n; r++)
    if (e[r] === t)
      return r;
  return -1;
}
function gV(e) {
  if (!Kl || !e || typeof e != "object")
    return !1;
  try {
    Kl.call(e);
    try {
      Xl.call(e);
    } catch {
      return !0;
    }
    return e instanceof Map;
  } catch {
  }
  return !1;
}
function yV(e) {
  if (!bs || !e || typeof e != "object")
    return !1;
  try {
    bs.call(e, bs);
    try {
      Cs.call(e, Cs);
    } catch {
      return !0;
    }
    return e instanceof WeakMap;
  } catch {
  }
  return !1;
}
function bV(e) {
  if (!Tp || !e || typeof e != "object")
    return !1;
  try {
    return Tp.call(e), !0;
  } catch {
  }
  return !1;
}
function CV(e) {
  if (!Xl || !e || typeof e != "object")
    return !1;
  try {
    Xl.call(e);
    try {
      Kl.call(e);
    } catch {
      return !0;
    }
    return e instanceof Set;
  } catch {
  }
  return !1;
}
function xV(e) {
  if (!Cs || !e || typeof e != "object")
    return !1;
  try {
    Cs.call(e, Cs);
    try {
      bs.call(e, bs);
    } catch {
      return !0;
    }
    return e instanceof WeakSet;
  } catch {
  }
  return !1;
}
function wV(e) {
  return !e || typeof e != "object" ? !1 : typeof HTMLElement < "u" && e instanceof HTMLElement ? !0 : typeof e.nodeName == "string" && typeof e.getAttribute == "function";
}
function Qg(e, t) {
  if (e.length > t.maxStringLength) {
    var r = e.length - t.maxStringLength, n = "... " + r + " more character" + (r > 1 ? "s" : "");
    return Qg(Jd.call(e, 0, t.maxStringLength), t) + n;
  }
  var a = Kn.call(Kn.call(e, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, OV);
  return Yg(a, "single", t);
}
function OV(e) {
  var t = e.charCodeAt(0), r = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[t];
  return r ? "\\" + r : "\\x" + (t < 16 ? "0" : "") + iV.call(t.toString(16));
}
function Yo(e) {
  return "Object(" + e + ")";
}
function J2(e) {
  return e + " { ? }";
}
function Hp(e, t, r, n) {
  var a = n ? p0(r, n) : sn.call(r, ", ");
  return e + " (" + t + ") {" + a + "}";
}
function SV(e) {
  for (var t = 0; t < e.length; t++)
    if (Xg(e[t], `
`) >= 0)
      return !1;
  return !0;
}
function PV(e, t) {
  var r;
  if (e.indent === "	")
    r = "	";
  else if (typeof e.indent == "number" && e.indent > 0)
    r = sn.call(Array(e.indent + 1), " ");
  else
    return null;
  return {
    base: r,
    prev: sn.call(Array(t + 1), r)
  };
}
function p0(e, t) {
  if (e.length === 0)
    return "";
  var r = `
` + t.prev + t.base;
  return r + sn.call(e, "," + r) + `
` + t.prev;
}
function tl(e, t) {
  var r = d0(e), n = [];
  if (r) {
    n.length = e.length;
    for (var a = 0; a < e.length; a++)
      n[a] = qn(e, a) ? t(e[a], e) : "";
  }
  var i = typeof Q2 == "function" ? Q2(e) : [], o;
  if (Wi) {
    o = {};
    for (var s = 0; s < i.length; s++)
      o["$" + i[s]] = i[s];
  }
  for (var l in e)
    qn(e, l) && (r && String(Number(l)) === l && l < e.length || Wi && o["$" + l] instanceof Symbol || (qg.call(/[^\w$]/, l) ? n.push(t(l, e) + ": " + t(e[l], e)) : n.push(l + ": " + t(e[l], e))));
  if (typeof Q2 == "function")
    for (var c = 0; c < i.length; c++)
      Gg.call(e, i[c]) && n.push("[" + t(i[c]) + "]: " + t(e[i[c]], e));
  return n;
}
var Jg = Po, Eo = GB, EV = sV, jV = $1, rl = Jg("%WeakMap%", !0), nl = Jg("%Map%", !0), _V = Eo("WeakMap.prototype.get", !0), AV = Eo("WeakMap.prototype.set", !0), DV = Eo("WeakMap.prototype.has", !0), MV = Eo("Map.prototype.get", !0), TV = Eo("Map.prototype.set", !0), $V = Eo("Map.prototype.has", !0), e6 = function(e, t) {
  for (var r = e, n; (n = r.next) !== null; r = n)
    if (n.key === t)
      return r.next = n.next, n.next = /** @type {NonNullable<typeof list.next>} */
      e.next, e.next = n, n;
}, NV = function(e, t) {
  var r = e6(e, t);
  return r && r.value;
}, IV = function(e, t, r) {
  var n = e6(e, t);
  n ? n.value = r : e.next = /** @type {import('.').ListNode<typeof value>} */
  {
    // eslint-disable-line no-param-reassign, no-extra-parens
    key: t,
    next: e.next,
    value: r
  };
}, LV = function(e, t) {
  return !!e6(e, t);
}, kV = function() {
  var t, r, n, a = {
    assert: function(i) {
      if (!a.has(i))
        throw new jV("Side channel does not contain " + EV(i));
    },
    get: function(i) {
      if (rl && i && (typeof i == "object" || typeof i == "function")) {
        if (t)
          return _V(t, i);
      } else if (nl) {
        if (r)
          return MV(r, i);
      } else if (n)
        return NV(n, i);
    },
    has: function(i) {
      if (rl && i && (typeof i == "object" || typeof i == "function")) {
        if (t)
          return DV(t, i);
      } else if (nl) {
        if (r)
          return $V(r, i);
      } else if (n)
        return LV(n, i);
      return !1;
    },
    set: function(i, o) {
      rl && i && (typeof i == "object" || typeof i == "function") ? (t || (t = new rl()), AV(t, i, o)) : nl ? (r || (r = new nl()), TV(r, i, o)) : (n || (n = { key: {}, next: null }), IV(n, i, o));
    }
  };
  return a;
}, RV = String.prototype.replace, BV = /%20/g, e3 = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, t6 = {
  default: e3.RFC3986,
  formatters: {
    RFC1738: function(e) {
      return RV.call(e, BV, "+");
    },
    RFC3986: function(e) {
      return String(e);
    }
  },
  RFC1738: e3.RFC1738,
  RFC3986: e3.RFC3986
}, VV = t6, t3 = Object.prototype.hasOwnProperty, ka = Array.isArray, an = function() {
  for (var e = [], t = 0; t < 256; ++t)
    e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
  return e;
}(), HV = function(t) {
  for (; t.length > 1; ) {
    var r = t.pop(), n = r.obj[r.prop];
    if (ka(n)) {
      for (var a = [], i = 0; i < n.length; ++i)
        typeof n[i] < "u" && a.push(n[i]);
      r.obj[r.prop] = a;
    }
  }
}, ey = function(t, r) {
  for (var n = r && r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, a = 0; a < t.length; ++a)
    typeof t[a] < "u" && (n[a] = t[a]);
  return n;
}, FV = function e(t, r, n) {
  if (!r)
    return t;
  if (typeof r != "object") {
    if (ka(t))
      t.push(r);
    else if (t && typeof t == "object")
      (n && (n.plainObjects || n.allowPrototypes) || !t3.call(Object.prototype, r)) && (t[r] = !0);
    else
      return [t, r];
    return t;
  }
  if (!t || typeof t != "object")
    return [t].concat(r);
  var a = t;
  return ka(t) && !ka(r) && (a = ey(t, n)), ka(t) && ka(r) ? (r.forEach(function(i, o) {
    if (t3.call(t, o)) {
      var s = t[o];
      s && typeof s == "object" && i && typeof i == "object" ? t[o] = e(s, i, n) : t.push(i);
    } else
      t[o] = i;
  }), t) : Object.keys(r).reduce(function(i, o) {
    var s = r[o];
    return t3.call(i, o) ? i[o] = e(i[o], s, n) : i[o] = s, i;
  }, a);
}, WV = function(t, r) {
  return Object.keys(r).reduce(function(n, a) {
    return n[a] = r[a], n;
  }, t);
}, zV = function(e, t, r) {
  var n = e.replace(/\+/g, " ");
  if (r === "iso-8859-1")
    return n.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(n);
  } catch {
    return n;
  }
}, r3 = 1024, UV = function(t, r, n, a, i) {
  if (t.length === 0)
    return t;
  var o = t;
  if (typeof t == "symbol" ? o = Symbol.prototype.toString.call(t) : typeof t != "string" && (o = String(t)), n === "iso-8859-1")
    return escape(o).replace(/%u[0-9a-f]{4}/gi, function(h) {
      return "%26%23" + parseInt(h.slice(2), 16) + "%3B";
    });
  for (var s = "", l = 0; l < o.length; l += r3) {
    for (var c = o.length >= r3 ? o.slice(l, l + r3) : o, u = [], d = 0; d < c.length; ++d) {
      var p = c.charCodeAt(d);
      if (p === 45 || p === 46 || p === 95 || p === 126 || p >= 48 && p <= 57 || p >= 65 && p <= 90 || p >= 97 && p <= 122 || i === VV.RFC1738 && (p === 40 || p === 41)) {
        u[u.length] = c.charAt(d);
        continue;
      }
      if (p < 128) {
        u[u.length] = an[p];
        continue;
      }
      if (p < 2048) {
        u[u.length] = an[192 | p >> 6] + an[128 | p & 63];
        continue;
      }
      if (p < 55296 || p >= 57344) {
        u[u.length] = an[224 | p >> 12] + an[128 | p >> 6 & 63] + an[128 | p & 63];
        continue;
      }
      d += 1, p = 65536 + ((p & 1023) << 10 | c.charCodeAt(d) & 1023), u[u.length] = an[240 | p >> 18] + an[128 | p >> 12 & 63] + an[128 | p >> 6 & 63] + an[128 | p & 63];
    }
    s += u.join("");
  }
  return s;
}, ZV = function(t) {
  for (var r = [{ obj: { o: t }, prop: "o" }], n = [], a = 0; a < r.length; ++a)
    for (var i = r[a], o = i.obj[i.prop], s = Object.keys(o), l = 0; l < s.length; ++l) {
      var c = s[l], u = o[c];
      typeof u == "object" && u !== null && n.indexOf(u) === -1 && (r.push({ obj: o, prop: c }), n.push(u));
    }
  return HV(r), t;
}, qV = function(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}, GV = function(t) {
  return !t || typeof t != "object" ? !1 : !!(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t));
}, YV = function(t, r) {
  return [].concat(t, r);
}, KV = function(t, r) {
  if (ka(t)) {
    for (var n = [], a = 0; a < t.length; a += 1)
      n.push(r(t[a]));
    return n;
  }
  return r(t);
}, ty = {
  arrayToObject: ey,
  assign: WV,
  combine: YV,
  compact: ZV,
  decode: zV,
  encode: UV,
  isBuffer: GV,
  isRegExp: qV,
  maybeMap: KV,
  merge: FV
}, ry = kV, Ol = ty, xs = t6, XV = Object.prototype.hasOwnProperty, ny = {
  brackets: function(t) {
    return t + "[]";
  },
  comma: "comma",
  indices: function(t, r) {
    return t + "[" + r + "]";
  },
  repeat: function(t) {
    return t;
  }
}, on = Array.isArray, QV = Array.prototype.push, ay = function(e, t) {
  QV.apply(e, on(t) ? t : [t]);
}, JV = Date.prototype.toISOString, Fp = xs.default, kt = {
  addQueryPrefix: !1,
  allowDots: !1,
  allowEmptyArrays: !1,
  arrayFormat: "indices",
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encodeDotInKeys: !1,
  encoder: Ol.encode,
  encodeValuesOnly: !1,
  format: Fp,
  formatter: xs.formatters[Fp],
  // deprecated
  indices: !1,
  serializeDate: function(t) {
    return JV.call(t);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, eH = function(t) {
  return typeof t == "string" || typeof t == "number" || typeof t == "boolean" || typeof t == "symbol" || typeof t == "bigint";
}, n3 = {}, tH = function e(t, r, n, a, i, o, s, l, c, u, d, p, h, m, v, g, b, C) {
  for (var w = t, x = C, y = 0, O = !1; (x = x.get(n3)) !== void 0 && !O; ) {
    var P = x.get(t);
    if (y += 1, typeof P < "u") {
      if (P === y)
        throw new RangeError("Cyclic object value");
      O = !0;
    }
    typeof x.get(n3) > "u" && (y = 0);
  }
  if (typeof u == "function" ? w = u(r, w) : w instanceof Date ? w = h(w) : n === "comma" && on(w) && (w = Ol.maybeMap(w, function(_) {
    return _ instanceof Date ? h(_) : _;
  })), w === null) {
    if (o)
      return c && !g ? c(r, kt.encoder, b, "key", m) : r;
    w = "";
  }
  if (eH(w) || Ol.isBuffer(w)) {
    if (c) {
      var j = g ? r : c(r, kt.encoder, b, "key", m);
      return [v(j) + "=" + v(c(w, kt.encoder, b, "value", m))];
    }
    return [v(r) + "=" + v(String(w))];
  }
  var T = [];
  if (typeof w > "u")
    return T;
  var I;
  if (n === "comma" && on(w))
    g && c && (w = Ol.maybeMap(w, c)), I = [{ value: w.length > 0 ? w.join(",") || null : void 0 }];
  else if (on(u))
    I = u;
  else {
    var R = Object.keys(w);
    I = d ? R.sort(d) : R;
  }
  var F = l ? r.replace(/\./g, "%2E") : r, $ = a && on(w) && w.length === 1 ? F + "[]" : F;
  if (i && on(w) && w.length === 0)
    return $ + "[]";
  for (var Z = 0; Z < I.length; ++Z) {
    var X = I[Z], K = typeof X == "object" && typeof X.value < "u" ? X.value : w[X];
    if (!(s && K === null)) {
      var J = p && l ? X.replace(/\./g, "%2E") : X, ee = on(w) ? typeof n == "function" ? n($, J) : $ : $ + (p ? "." + J : "[" + J + "]");
      C.set(t, y);
      var A = ry();
      A.set(n3, C), ay(T, e(
        K,
        ee,
        n,
        a,
        i,
        o,
        s,
        l,
        n === "comma" && g && on(w) ? null : c,
        u,
        d,
        p,
        h,
        m,
        v,
        g,
        b,
        A
      ));
    }
  }
  return T;
}, rH = function(t) {
  if (!t)
    return kt;
  if (typeof t.allowEmptyArrays < "u" && typeof t.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof t.encodeDotInKeys < "u" && typeof t.encodeDotInKeys != "boolean")
    throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
  if (t.encoder !== null && typeof t.encoder < "u" && typeof t.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var r = t.charset || kt.charset;
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var n = xs.default;
  if (typeof t.format < "u") {
    if (!XV.call(xs.formatters, t.format))
      throw new TypeError("Unknown format option provided.");
    n = t.format;
  }
  var a = xs.formatters[n], i = kt.filter;
  (typeof t.filter == "function" || on(t.filter)) && (i = t.filter);
  var o;
  if (t.arrayFormat in ny ? o = t.arrayFormat : "indices" in t ? o = t.indices ? "indices" : "repeat" : o = kt.arrayFormat, "commaRoundTrip" in t && typeof t.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var s = typeof t.allowDots > "u" ? t.encodeDotInKeys === !0 ? !0 : kt.allowDots : !!t.allowDots;
  return {
    addQueryPrefix: typeof t.addQueryPrefix == "boolean" ? t.addQueryPrefix : kt.addQueryPrefix,
    allowDots: s,
    allowEmptyArrays: typeof t.allowEmptyArrays == "boolean" ? !!t.allowEmptyArrays : kt.allowEmptyArrays,
    arrayFormat: o,
    charset: r,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : kt.charsetSentinel,
    commaRoundTrip: t.commaRoundTrip,
    delimiter: typeof t.delimiter > "u" ? kt.delimiter : t.delimiter,
    encode: typeof t.encode == "boolean" ? t.encode : kt.encode,
    encodeDotInKeys: typeof t.encodeDotInKeys == "boolean" ? t.encodeDotInKeys : kt.encodeDotInKeys,
    encoder: typeof t.encoder == "function" ? t.encoder : kt.encoder,
    encodeValuesOnly: typeof t.encodeValuesOnly == "boolean" ? t.encodeValuesOnly : kt.encodeValuesOnly,
    filter: i,
    format: n,
    formatter: a,
    serializeDate: typeof t.serializeDate == "function" ? t.serializeDate : kt.serializeDate,
    skipNulls: typeof t.skipNulls == "boolean" ? t.skipNulls : kt.skipNulls,
    sort: typeof t.sort == "function" ? t.sort : null,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : kt.strictNullHandling
  };
}, nH = function(e, t) {
  var r = e, n = rH(t), a, i;
  typeof n.filter == "function" ? (i = n.filter, r = i("", r)) : on(n.filter) && (i = n.filter, a = i);
  var o = [];
  if (typeof r != "object" || r === null)
    return "";
  var s = ny[n.arrayFormat], l = s === "comma" && n.commaRoundTrip;
  a || (a = Object.keys(r)), n.sort && a.sort(n.sort);
  for (var c = ry(), u = 0; u < a.length; ++u) {
    var d = a[u];
    n.skipNulls && r[d] === null || ay(o, tH(
      r[d],
      d,
      s,
      l,
      n.allowEmptyArrays,
      n.strictNullHandling,
      n.skipNulls,
      n.encodeDotInKeys,
      n.encode ? n.encoder : null,
      n.filter,
      n.sort,
      n.allowDots,
      n.serializeDate,
      n.format,
      n.formatter,
      n.encodeValuesOnly,
      n.charset,
      c
    ));
  }
  var p = o.join(n.delimiter), h = n.addQueryPrefix === !0 ? "?" : "";
  return n.charsetSentinel && (n.charset === "iso-8859-1" ? h += "utf8=%26%2310003%3B&" : h += "utf8=%E2%9C%93&"), p.length > 0 ? h + p : "";
}, zi = ty, h0 = Object.prototype.hasOwnProperty, aH = Array.isArray, St = {
  allowDots: !1,
  allowEmptyArrays: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decodeDotInKeys: !1,
  decoder: zi.decode,
  delimiter: "&",
  depth: 5,
  duplicates: "combine",
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictDepth: !1,
  strictNullHandling: !1
}, iH = function(e) {
  return e.replace(/&#(\d+);/g, function(t, r) {
    return String.fromCharCode(parseInt(r, 10));
  });
}, iy = function(e, t) {
  return e && typeof e == "string" && t.comma && e.indexOf(",") > -1 ? e.split(",") : e;
}, oH = "utf8=%26%2310003%3B", sH = "utf8=%E2%9C%93", lH = function(t, r) {
  var n = { __proto__: null }, a = r.ignoreQueryPrefix ? t.replace(/^\?/, "") : t;
  a = a.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  var i = r.parameterLimit === 1 / 0 ? void 0 : r.parameterLimit, o = a.split(r.delimiter, i), s = -1, l, c = r.charset;
  if (r.charsetSentinel)
    for (l = 0; l < o.length; ++l)
      o[l].indexOf("utf8=") === 0 && (o[l] === sH ? c = "utf-8" : o[l] === oH && (c = "iso-8859-1"), s = l, l = o.length);
  for (l = 0; l < o.length; ++l)
    if (l !== s) {
      var u = o[l], d = u.indexOf("]="), p = d === -1 ? u.indexOf("=") : d + 1, h, m;
      p === -1 ? (h = r.decoder(u, St.decoder, c, "key"), m = r.strictNullHandling ? null : "") : (h = r.decoder(u.slice(0, p), St.decoder, c, "key"), m = zi.maybeMap(
        iy(u.slice(p + 1), r),
        function(g) {
          return r.decoder(g, St.decoder, c, "value");
        }
      )), m && r.interpretNumericEntities && c === "iso-8859-1" && (m = iH(m)), u.indexOf("[]=") > -1 && (m = aH(m) ? [m] : m);
      var v = h0.call(n, h);
      v && r.duplicates === "combine" ? n[h] = zi.combine(n[h], m) : (!v || r.duplicates === "last") && (n[h] = m);
    }
  return n;
}, cH = function(e, t, r, n) {
  for (var a = n ? t : iy(t, r), i = e.length - 1; i >= 0; --i) {
    var o, s = e[i];
    if (s === "[]" && r.parseArrays)
      o = r.allowEmptyArrays && (a === "" || r.strictNullHandling && a === null) ? [] : [].concat(a);
    else {
      o = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var l = s.charAt(0) === "[" && s.charAt(s.length - 1) === "]" ? s.slice(1, -1) : s, c = r.decodeDotInKeys ? l.replace(/%2E/g, ".") : l, u = parseInt(c, 10);
      !r.parseArrays && c === "" ? o = { 0: a } : !isNaN(u) && s !== c && String(u) === c && u >= 0 && r.parseArrays && u <= r.arrayLimit ? (o = [], o[u] = a) : c !== "__proto__" && (o[c] = a);
    }
    a = o;
  }
  return a;
}, uH = function(t, r, n, a) {
  if (t) {
    var i = n.allowDots ? t.replace(/\.([^.[]+)/g, "[$1]") : t, o = /(\[[^[\]]*])/, s = /(\[[^[\]]*])/g, l = n.depth > 0 && o.exec(i), c = l ? i.slice(0, l.index) : i, u = [];
    if (c) {
      if (!n.plainObjects && h0.call(Object.prototype, c) && !n.allowPrototypes)
        return;
      u.push(c);
    }
    for (var d = 0; n.depth > 0 && (l = s.exec(i)) !== null && d < n.depth; ) {
      if (d += 1, !n.plainObjects && h0.call(Object.prototype, l[1].slice(1, -1)) && !n.allowPrototypes)
        return;
      u.push(l[1]);
    }
    if (l) {
      if (n.strictDepth === !0)
        throw new RangeError("Input depth exceeded depth option of " + n.depth + " and strictDepth is true");
      u.push("[" + i.slice(l.index) + "]");
    }
    return cH(u, r, n, a);
  }
}, fH = function(t) {
  if (!t)
    return St;
  if (typeof t.allowEmptyArrays < "u" && typeof t.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof t.decodeDotInKeys < "u" && typeof t.decodeDotInKeys != "boolean")
    throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
  if (t.decoder !== null && typeof t.decoder < "u" && typeof t.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var r = typeof t.charset > "u" ? St.charset : t.charset, n = typeof t.duplicates > "u" ? St.duplicates : t.duplicates;
  if (n !== "combine" && n !== "first" && n !== "last")
    throw new TypeError("The duplicates option must be either combine, first, or last");
  var a = typeof t.allowDots > "u" ? t.decodeDotInKeys === !0 ? !0 : St.allowDots : !!t.allowDots;
  return {
    allowDots: a,
    allowEmptyArrays: typeof t.allowEmptyArrays == "boolean" ? !!t.allowEmptyArrays : St.allowEmptyArrays,
    allowPrototypes: typeof t.allowPrototypes == "boolean" ? t.allowPrototypes : St.allowPrototypes,
    allowSparse: typeof t.allowSparse == "boolean" ? t.allowSparse : St.allowSparse,
    arrayLimit: typeof t.arrayLimit == "number" ? t.arrayLimit : St.arrayLimit,
    charset: r,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : St.charsetSentinel,
    comma: typeof t.comma == "boolean" ? t.comma : St.comma,
    decodeDotInKeys: typeof t.decodeDotInKeys == "boolean" ? t.decodeDotInKeys : St.decodeDotInKeys,
    decoder: typeof t.decoder == "function" ? t.decoder : St.decoder,
    delimiter: typeof t.delimiter == "string" || zi.isRegExp(t.delimiter) ? t.delimiter : St.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof t.depth == "number" || t.depth === !1 ? +t.depth : St.depth,
    duplicates: n,
    ignoreQueryPrefix: t.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof t.interpretNumericEntities == "boolean" ? t.interpretNumericEntities : St.interpretNumericEntities,
    parameterLimit: typeof t.parameterLimit == "number" ? t.parameterLimit : St.parameterLimit,
    parseArrays: t.parseArrays !== !1,
    plainObjects: typeof t.plainObjects == "boolean" ? t.plainObjects : St.plainObjects,
    strictDepth: typeof t.strictDepth == "boolean" ? !!t.strictDepth : St.strictDepth,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : St.strictNullHandling
  };
}, dH = function(e, t) {
  var r = fH(t);
  if (e === "" || e === null || typeof e > "u")
    return r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var n = typeof e == "string" ? lH(e, r) : e, a = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, i = Object.keys(n), o = 0; o < i.length; ++o) {
    var s = i[o], l = uH(s, n[s], r, typeof e == "string");
    a = zi.merge(a, l, r);
  }
  return r.allowSparse === !0 ? a : zi.compact(a);
}, pH = nH, hH = dH, vH = t6, mH = {
  formats: vH,
  parse: hH,
  stringify: pH
};
const gH = /* @__PURE__ */ Ze(mH), yH = E.forwardRef((e, t) => {
  const {
    EMPNITXX: r,
    AREAIDXX: n,
    SERIEIDX: a,
    TIPOIDXX: i,
    JSONMETX: o,
    children: s,
    ...l
  } = e, c = () => {
    let u = "EMPNITXX=" + r + "&AREAIDXX=" + n + "&SERIEIDX=" + a;
    if (u += i ? "&TIPOIDXX=" + i : "", o) {
      const d = encodeURIComponent(
        gH.stringify(o, {
          encode: !1,
          allowDots: !0,
          strictNullHandling: !0
        })
      );
      u += `&JSONMETX=${d}`;
    }
    window.open("https://genio.repremundo.com.co/#/home?" + u);
  };
  return /* @__PURE__ */ f.jsx("div", { ...l, ref: t, children: /* @__PURE__ */ f.jsx("div", { onClick: c, children: s }) });
});
yH.displayName = "Genlingx";
const bH = E.forwardRef((e, t) => {
  const {
    filters: r,
    ...n
  } = e, a = () => {
    window.open("https://geniovisor.repremundo.com.co/home/" + r);
  };
  return /* @__PURE__ */ f.jsx("div", { ...n, ref: t, children: /* @__PURE__ */ f.jsx("div", { className: "max-w-[50px] rounded-md hover:bg-neutral-200", onClick: a, children: /* @__PURE__ */ f.jsx(Tn, { spacing: 3, border: 1, borderColor: "neutral-300", rounded: "md", children: /* @__PURE__ */ f.jsx(me, { variant: "genio", color: "warning-1000", width: 25 }) }) }) });
});
bH.displayName = "Visrlink";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var v0 = function(e, t) {
  return v0 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var a in n)
      n.hasOwnProperty(a) && (r[a] = n[a]);
  }, v0(e, t);
};
function CH(e, t) {
  v0(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var ws = function() {
  return ws = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, ws.apply(this, arguments);
};
function xH(e, t, r, n) {
  var a, i = !1, o = 0;
  function s() {
    a && clearTimeout(a);
  }
  function l() {
    s(), i = !0;
  }
  typeof t != "boolean" && (n = r, r = t, t = void 0);
  function c() {
    var u = this, d = Date.now() - o, p = arguments;
    if (i)
      return;
    function h() {
      o = Date.now(), r.apply(u, p);
    }
    function m() {
      a = void 0;
    }
    n && !a && h(), s(), n === void 0 && d > e ? h() : t !== !0 && (a = setTimeout(n ? m : h, n === void 0 ? e - d : e));
  }
  return c.cancel = l, c;
}
var $i = {
  Pixel: "Pixel",
  Percent: "Percent"
}, Wp = {
  unit: $i.Percent,
  value: 0.8
};
function zp(e) {
  return typeof e == "number" ? {
    unit: $i.Percent,
    value: e * 100
  } : typeof e == "string" ? e.match(/^(\d*(\.\d+)?)px$/) ? {
    unit: $i.Pixel,
    value: parseFloat(e)
  } : e.match(/^(\d*(\.\d+)?)%$/) ? {
    unit: $i.Percent,
    value: parseFloat(e)
  } : (console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...'), Wp) : (console.warn("scrollThreshold should be string or number"), Wp);
}
var wu = (
  /** @class */
  function(e) {
    CH(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n.lastScrollTop = 0, n.actionTriggered = !1, n.startY = 0, n.currentY = 0, n.dragging = !1, n.maxPullDownDistance = 0, n.getScrollableTarget = function() {
        return n.props.scrollableTarget instanceof HTMLElement ? n.props.scrollableTarget : typeof n.props.scrollableTarget == "string" ? document.getElementById(n.props.scrollableTarget) : (n.props.scrollableTarget === null && console.warn(`You are trying to pass scrollableTarget but it is null. This might
        happen because the element may not have been added to DOM yet.
        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.
      `), null);
      }, n.onStart = function(a) {
        n.lastScrollTop || (n.dragging = !0, a instanceof MouseEvent ? n.startY = a.pageY : a instanceof TouchEvent && (n.startY = a.touches[0].pageY), n.currentY = n.startY, n._infScroll && (n._infScroll.style.willChange = "transform", n._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)"));
      }, n.onMove = function(a) {
        n.dragging && (a instanceof MouseEvent ? n.currentY = a.pageY : a instanceof TouchEvent && (n.currentY = a.touches[0].pageY), !(n.currentY < n.startY) && (n.currentY - n.startY >= Number(n.props.pullDownToRefreshThreshold) && n.setState({
          pullToRefreshThresholdBreached: !0
        }), !(n.currentY - n.startY > n.maxPullDownDistance * 1.5) && n._infScroll && (n._infScroll.style.overflow = "visible", n._infScroll.style.transform = "translate3d(0px, " + (n.currentY - n.startY) + "px, 0px)")));
      }, n.onEnd = function() {
        n.startY = 0, n.currentY = 0, n.dragging = !1, n.state.pullToRefreshThresholdBreached && (n.props.refreshFunction && n.props.refreshFunction(), n.setState({
          pullToRefreshThresholdBreached: !1
        })), requestAnimationFrame(function() {
          n._infScroll && (n._infScroll.style.overflow = "auto", n._infScroll.style.transform = "none", n._infScroll.style.willChange = "unset");
        });
      }, n.onScrollListener = function(a) {
        typeof n.props.onScroll == "function" && setTimeout(function() {
          return n.props.onScroll && n.props.onScroll(a);
        }, 0);
        var i = n.props.height || n._scrollableNode ? a.target : document.documentElement.scrollTop ? document.documentElement : document.body;
        if (!n.actionTriggered) {
          var o = n.props.inverse ? n.isElementAtTop(i, n.props.scrollThreshold) : n.isElementAtBottom(i, n.props.scrollThreshold);
          o && n.props.hasMore && (n.actionTriggered = !0, n.setState({ showLoader: !0 }), n.props.next && n.props.next()), n.lastScrollTop = i.scrollTop;
        }
      }, n.state = {
        showLoader: !1,
        pullToRefreshThresholdBreached: !1,
        prevDataLength: r.dataLength
      }, n.throttledOnScrollListener = xH(150, n.onScrollListener).bind(n), n.onStart = n.onStart.bind(n), n.onMove = n.onMove.bind(n), n.onEnd = n.onEnd.bind(n), n;
    }
    return t.prototype.componentDidMount = function() {
      if (typeof this.props.dataLength > "u")
        throw new Error('mandatory prop "dataLength" is missing. The prop is needed when loading more content. Check README.md for usage');
      if (this._scrollableNode = this.getScrollableTarget(), this.el = this.props.height ? this._infScroll : this._scrollableNode || window, this.el && this.el.addEventListener("scroll", this.throttledOnScrollListener), typeof this.props.initialScrollY == "number" && this.el && this.el instanceof HTMLElement && this.el.scrollHeight > this.props.initialScrollY && this.el.scrollTo(0, this.props.initialScrollY), this.props.pullDownToRefresh && this.el && (this.el.addEventListener("touchstart", this.onStart), this.el.addEventListener("touchmove", this.onMove), this.el.addEventListener("touchend", this.onEnd), this.el.addEventListener("mousedown", this.onStart), this.el.addEventListener("mousemove", this.onMove), this.el.addEventListener("mouseup", this.onEnd), this.maxPullDownDistance = this._pullDown && this._pullDown.firstChild && this._pullDown.firstChild.getBoundingClientRect().height || 0, this.forceUpdate(), typeof this.props.refreshFunction != "function"))
        throw new Error(`Mandatory prop "refreshFunction" missing.
          Pull Down To Refresh functionality will not work
          as expected. Check README.md for usage'`);
    }, t.prototype.componentWillUnmount = function() {
      this.el && (this.el.removeEventListener("scroll", this.throttledOnScrollListener), this.props.pullDownToRefresh && (this.el.removeEventListener("touchstart", this.onStart), this.el.removeEventListener("touchmove", this.onMove), this.el.removeEventListener("touchend", this.onEnd), this.el.removeEventListener("mousedown", this.onStart), this.el.removeEventListener("mousemove", this.onMove), this.el.removeEventListener("mouseup", this.onEnd)));
    }, t.prototype.componentDidUpdate = function(r) {
      this.props.dataLength !== r.dataLength && (this.actionTriggered = !1, this.setState({
        showLoader: !1
      }));
    }, t.getDerivedStateFromProps = function(r, n) {
      var a = r.dataLength !== n.prevDataLength;
      return a ? ws(ws({}, n), { prevDataLength: r.dataLength }) : null;
    }, t.prototype.isElementAtTop = function(r, n) {
      n === void 0 && (n = 0.8);
      var a = r === document.body || r === document.documentElement ? window.screen.availHeight : r.clientHeight, i = zp(n);
      return i.unit === $i.Pixel ? r.scrollTop <= i.value + a - r.scrollHeight + 1 : r.scrollTop <= i.value / 100 + a - r.scrollHeight + 1;
    }, t.prototype.isElementAtBottom = function(r, n) {
      n === void 0 && (n = 0.8);
      var a = r === document.body || r === document.documentElement ? window.screen.availHeight : r.clientHeight, i = zp(n);
      return i.unit === $i.Pixel ? r.scrollTop + a >= r.scrollHeight - i.value : r.scrollTop + a >= i.value / 100 * r.scrollHeight;
    }, t.prototype.render = function() {
      var r = this, n = ws({ height: this.props.height || "auto", overflow: "auto", WebkitOverflowScrolling: "touch" }, this.props.style), a = this.props.hasChildren || !!(this.props.children && this.props.children instanceof Array && this.props.children.length), i = this.props.pullDownToRefresh && this.props.height ? { overflow: "auto" } : {};
      return E.createElement(
        "div",
        { style: i, className: "infinite-scroll-component__outerdiv" },
        E.createElement(
          "div",
          { className: "infinite-scroll-component " + (this.props.className || ""), ref: function(o) {
            return r._infScroll = o;
          }, style: n },
          this.props.pullDownToRefresh && E.createElement(
            "div",
            { style: { position: "relative" }, ref: function(o) {
              return r._pullDown = o;
            } },
            E.createElement("div", { style: {
              position: "absolute",
              left: 0,
              right: 0,
              top: -1 * this.maxPullDownDistance
            } }, this.state.pullToRefreshThresholdBreached ? this.props.releaseToRefreshContent : this.props.pullDownToRefreshContent)
          ),
          this.props.children,
          !this.state.showLoader && !a && this.props.hasMore && this.props.loader,
          this.state.showLoader && this.props.hasMore && this.props.loader,
          !this.props.hasMore && this.props.endMessage
        )
      );
    }, t;
  }(Kf)
);
const wH = (e) => {
  const { columns: t = [], data: r = [], onColumnClick: n, dataLength: a = 0, fetchData: i, hasMore: o = !1, onRowClick: s } = e, l = t.map((p) => `col-${p.id}`).join(" ").toString(), c = Array.from({ length: t.length }, () => "1fr").join(" ").toString(), u = { gridTemplateAreas: `'${l}'`, gridTemplateColumns: c }, d = () => i !== void 0 ? i() : null;
  return /* @__PURE__ */ f.jsx("div", { className: "grid gap-2 hidden 2s:block", children: /* @__PURE__ */ f.jsx(
    "div",
    {
      className: "table-max-height w-full overflow-x-auto overflow-y-auto table-main-scrollbar pb-1",
      id: "scrollableTable",
      children: /* @__PURE__ */ f.jsx("div", { className: "min-w-[min-content]", children: /* @__PURE__ */ f.jsx(
        wu,
        {
          dataLength: a,
          hasMore: o,
          next: d,
          scrollableTarget: "scrollableTable",
          style: { overflow: "hidden" },
          loader: /* @__PURE__ */ f.jsx(sr, { variant: "title-2", children: "Cargando nueva información..." }),
          children: /* @__PURE__ */ f.jsxs("div", { className: "min-w-[min-content]", children: [
            /* @__PURE__ */ f.jsx(
              "div",
              {
                className: "bg-white grid w-full h-10 sticky top-0",
                style: { ...u, zIndex: r.length + 10 },
                children: t.map((p) => /* @__PURE__ */ f.jsxs(
                  "div",
                  {
                    style: { gridArea: `col-${p.id}` },
                    title: p.title,
                    className: "min-w-[205px] bg-neutral-200 flex gap-2 justify-between items-center px-4 font-bold leading-[120%] select-none",
                    children: [
                      /* @__PURE__ */ f.jsx("p", { className: "w-full text-ellipsis overflow-hidden whitespace-nowrap", children: p.title }),
                      /* @__PURE__ */ f.jsx(
                        "button",
                        {
                          type: "button",
                          className: "w-6 h-6 flex items-center justify-center",
                          onClick: () => {
                            n !== void 0 && n({ column: p });
                          },
                          children: /* @__PURE__ */ f.jsxs("svg", { className: "w-5", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
                            /* @__PURE__ */ f.jsx(
                              "path",
                              {
                                d: "M16.743 10L8.25505 10C8.1049 9.9994 7.95831 9.95665 7.83381 9.87715C7.70931 9.79765 7.6125 9.68497 7.55561 9.55336C7.49873 9.42176 7.48433 9.27713 7.51423 9.13777C7.54413 8.99841 7.61699 8.87057 7.7236 8.77043L11.96 4.75815C12.0306 4.69075 12.1145 4.63726 12.207 4.60075C12.2996 4.56425 12.3988 4.54545 12.499 4.54545C12.5992 4.54545 12.6985 4.56425 12.791 4.60075C12.8835 4.63726 12.9675 4.69075 13.0381 4.75815L17.2744 8.77043C17.3811 8.87057 17.4539 8.99841 17.4838 9.13777C17.5137 9.27713 17.4993 9.42176 17.4424 9.55337C17.3855 9.68497 17.2887 9.79765 17.1642 9.87715C17.0397 9.95665 16.8931 9.9994 16.743 10Z",
                                fill: p.sorted && p.orderBy === "asc" ? "#2875B4" : "#E6E6E6"
                              }
                            ),
                            /* @__PURE__ */ f.jsx(
                              "path",
                              {
                                d: "M8.25505 14H16.743C16.8931 14.0006 17.0397 14.0433 17.1642 14.1228C17.2887 14.2023 17.3855 14.315 17.4424 14.4466C17.4993 14.5782 17.5137 14.7229 17.4838 14.8622C17.4539 15.0016 17.3811 15.1294 17.2744 15.2296L13.0381 19.2419C12.9675 19.3092 12.8835 19.3627 12.791 19.3992C12.6985 19.4358 12.5992 19.4545 12.499 19.4545C12.3988 19.4545 12.2996 19.4358 12.207 19.3992C12.1145 19.3627 12.0306 19.3092 11.96 19.2419L7.7236 15.2296C7.61699 15.1294 7.54413 15.0016 7.51423 14.8622C7.48433 14.7229 7.49873 14.5782 7.55561 14.4466C7.6125 14.315 7.70931 14.2023 7.83381 14.1228C7.95831 14.0433 8.1049 14.0006 8.25505 14Z",
                                fill: p.sorted && p.orderBy === "desc" ? "#2875B4" : "#E6E6E6"
                              }
                            )
                          ] })
                        }
                      )
                    ]
                  },
                  p.id
                ))
              }
            ),
            /* @__PURE__ */ f.jsx("div", { className: "bg-secondary-100 w-full", children: /* @__PURE__ */ f.jsx("div", { children: r.map((p, h) => {
              const m = h % 2 === 0, v = p != null && p.error ? "error" : "secondary", g = m ? `bg-${v}-200` : `bg-${v}-100`;
              return /* @__PURE__ */ f.jsx(gn, { children: /* @__PURE__ */ f.jsx(
                "div",
                {
                  style: u,
                  className: `${g} hover:bg-${v}-300 hover:text-${v}-600 border-b border-white last:border-none h-[48px] grid w-full`,
                  onClick: () => {
                    s && s({ row: p });
                  },
                  children: Object.entries(p).map(([b, C]) => {
                    const w = t.find((j) => j.id === b);
                    let x = !1, y = !1, O = !1, P = !1;
                    if (w)
                      x = w == null ? void 0 : w.center, y = (p == null ? void 0 : p.isHyperlink) ?? !1, O = (w == null ? void 0 : w.isHyperlink) ?? !1, P = (p == null ? void 0 : p.isBold) ?? !1;
                    else
                      return null;
                    return /* @__PURE__ */ f.jsx(
                      "div",
                      {
                        style: { gridArea: `col-${w.id}` },
                        title: C,
                        className: `min-w-[205px] flex items-center ${x ? "text-center" : "text-left"} px-4 border-l border-white first:border-none leading-[120%]`,
                        children: /* @__PURE__ */ f.jsx(
                          "p",
                          {
                            className: `w-full text-ellipsis overflow-hidden whitespace-nowrap ${P ? "font-bold" : ""} ${y && O ? "underline text-secondary-600" : ""}`,
                            onClick: () => y && O && w.onClickCell && w.onClickCell(p),
                            children: C
                          }
                        )
                      },
                      b
                    );
                  })
                },
                p.id
              ) }, `fragment-${h}`);
            }) }) })
          ] })
        }
      ) })
    }
  ) });
}, OH = (e) => {
  const { columns: t = [], data: r = [], dataLength: n = 0, fetchData: a, hasMore: i = !1 } = e, o = () => a !== void 0 ? a() : null;
  return /* @__PURE__ */ f.jsx("div", { className: "grid gap-2 2s:hidden", children: /* @__PURE__ */ f.jsx(
    "div",
    {
      className: `max-h-[calc(100vh-461px)] min-h-[calc(100vh-461px)] m:max-h-[calc(100vh-305px)] m:min-h-[calc(100vh-305px)]
        l:max-h-[calc(100vh-312px)] l:min-h-[calc(100vh-312px)] table-max-height w-full overflow-auto table-main-scrollbar pb-1`,
      id: "scrollableTableMobile",
      children: /* @__PURE__ */ f.jsx(
        wu,
        {
          dataLength: n,
          hasMore: i,
          next: o,
          scrollableTarget: "scrollableTableMobile",
          style: { overflow: "hidden" },
          loader: /* @__PURE__ */ f.jsx(sr, { variant: "title-2", children: "Cargando nueva información..." }),
          className: "grid gap-2",
          scrollThreshold: "300px",
          children: r.map((s, l) => /* @__PURE__ */ f.jsx(gn, { children: /* @__PURE__ */ f.jsx(
            "div",
            {
              className: "relative p-4 rounded-md bg-neutral-200 hover:bg-secondary-200 hover:text-secondary-600 w-full cursor-pointer",
              children: /* @__PURE__ */ f.jsx("div", { className: "flex flex-wrap gap-y-1.5 gap-x-6", children: Object.entries(s).filter(([c]) => t.some((u) => u.id === c)).map(([c, u]) => t.find((p) => p.id === c) === void 0 ? null : /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] w-full pr-12", children: u }, c)) })
            },
            s.id
          ) }, `fragment-${l}`))
        }
      )
    }
  ) });
}, SH = E.forwardRef((e, t) => {
  const { columns: r = [], data: n = [], className: a, onColumnClick: i, dataLength: o = 0, hasMore: s = !1, fetchData: l, onRowClick: c } = e;
  return r.length < 1 ? null : /* @__PURE__ */ f.jsxs("div", { ref: t, className: $e(["block", a]), children: [
    /* @__PURE__ */ f.jsx(
      wH,
      {
        columns: r,
        data: n,
        onColumnClick: i,
        dataLength: o,
        hasMore: s,
        fetchData: l,
        onRowClick: c
      }
    ),
    /* @__PURE__ */ f.jsx(
      OH,
      {
        columns: r,
        data: n,
        dataLength: o,
        hasMore: s,
        fetchData: l,
        onRowClick: c
      }
    )
  ] });
});
SH.displayName = "TableBasic";
function oy(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var a = e.length;
      for (t = 0; t < a; t++)
        e[t] && (r = oy(e[t])) && (n && (n += " "), n += r);
    } else
      for (r in e)
        e[r] && (n && (n += " "), n += r);
  return n;
}
function De() {
  for (var e, t, r = 0, n = "", a = arguments.length; r < a; r++)
    (e = arguments[r]) && (t = oy(e)) && (n && (n += " "), n += t);
  return n;
}
var PH = Array.isArray, vr = PH, EH = typeof Ba == "object" && Ba && Ba.Object === Object && Ba, sy = EH, jH = sy, _H = typeof self == "object" && self && self.Object === Object && self, AH = jH || _H || Function("return this")(), xn = AH, DH = xn, MH = DH.Symbol, I1 = MH, Up = I1, ly = Object.prototype, TH = ly.hasOwnProperty, $H = ly.toString, Ko = Up ? Up.toStringTag : void 0;
function NH(e) {
  var t = TH.call(e, Ko), r = e[Ko];
  try {
    e[Ko] = void 0;
    var n = !0;
  } catch {
  }
  var a = $H.call(e);
  return n && (t ? e[Ko] = r : delete e[Ko]), a;
}
var IH = NH, LH = Object.prototype, kH = LH.toString;
function RH(e) {
  return kH.call(e);
}
var BH = RH, Zp = I1, VH = IH, HH = BH, FH = "[object Null]", WH = "[object Undefined]", qp = Zp ? Zp.toStringTag : void 0;
function zH(e) {
  return e == null ? e === void 0 ? WH : FH : qp && qp in Object(e) ? VH(e) : HH(e);
}
var Fn = zH;
function UH(e) {
  return e != null && typeof e == "object";
}
var Wn = UH, ZH = Fn, qH = Wn, GH = "[object Symbol]";
function YH(e) {
  return typeof e == "symbol" || qH(e) && ZH(e) == GH;
}
var jo = YH, KH = vr, XH = jo, QH = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, JH = /^\w*$/;
function eF(e, t) {
  if (KH(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || XH(e) ? !0 : JH.test(e) || !QH.test(e) || t != null && e in Object(t);
}
var r6 = eF;
function tF(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var ma = tF;
const _o = /* @__PURE__ */ Ze(ma);
var rF = Fn, nF = ma, aF = "[object AsyncFunction]", iF = "[object Function]", oF = "[object GeneratorFunction]", sF = "[object Proxy]";
function lF(e) {
  if (!nF(e))
    return !1;
  var t = rF(e);
  return t == iF || t == oF || t == aF || t == sF;
}
var n6 = lF;
const we = /* @__PURE__ */ Ze(n6);
var cF = xn, uF = cF["__core-js_shared__"], fF = uF, a3 = fF, Gp = function() {
  var e = /[^.]+$/.exec(a3 && a3.keys && a3.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function dF(e) {
  return !!Gp && Gp in e;
}
var pF = dF, hF = Function.prototype, vF = hF.toString;
function mF(e) {
  if (e != null) {
    try {
      return vF.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var cy = mF, gF = n6, yF = pF, bF = ma, CF = cy, xF = /[\\^$.*+?()[\]{}|]/g, wF = /^\[object .+?Constructor\]$/, OF = Function.prototype, SF = Object.prototype, PF = OF.toString, EF = SF.hasOwnProperty, jF = RegExp(
  "^" + PF.call(EF).replace(xF, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function _F(e) {
  if (!bF(e) || yF(e))
    return !1;
  var t = gF(e) ? jF : wF;
  return t.test(CF(e));
}
var AF = _F;
function DF(e, t) {
  return e == null ? void 0 : e[t];
}
var MF = DF, TF = AF, $F = MF;
function NF(e, t) {
  var r = $F(e, t);
  return TF(r) ? r : void 0;
}
var ai = NF, IF = ai, LF = IF(Object, "create"), Ou = LF, Yp = Ou;
function kF() {
  this.__data__ = Yp ? Yp(null) : {}, this.size = 0;
}
var RF = kF;
function BF(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var VF = BF, HF = Ou, FF = "__lodash_hash_undefined__", WF = Object.prototype, zF = WF.hasOwnProperty;
function UF(e) {
  var t = this.__data__;
  if (HF) {
    var r = t[e];
    return r === FF ? void 0 : r;
  }
  return zF.call(t, e) ? t[e] : void 0;
}
var ZF = UF, qF = Ou, GF = Object.prototype, YF = GF.hasOwnProperty;
function KF(e) {
  var t = this.__data__;
  return qF ? t[e] !== void 0 : YF.call(t, e);
}
var XF = KF, QF = Ou, JF = "__lodash_hash_undefined__";
function eW(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = QF && t === void 0 ? JF : t, this;
}
var tW = eW, rW = RF, nW = VF, aW = ZF, iW = XF, oW = tW;
function Ao(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Ao.prototype.clear = rW;
Ao.prototype.delete = nW;
Ao.prototype.get = aW;
Ao.prototype.has = iW;
Ao.prototype.set = oW;
var sW = Ao;
function lW() {
  this.__data__ = [], this.size = 0;
}
var cW = lW;
function uW(e, t) {
  return e === t || e !== e && t !== t;
}
var a6 = uW, fW = a6;
function dW(e, t) {
  for (var r = e.length; r--; )
    if (fW(e[r][0], t))
      return r;
  return -1;
}
var Su = dW, pW = Su, hW = Array.prototype, vW = hW.splice;
function mW(e) {
  var t = this.__data__, r = pW(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : vW.call(t, r, 1), --this.size, !0;
}
var gW = mW, yW = Su;
function bW(e) {
  var t = this.__data__, r = yW(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var CW = bW, xW = Su;
function wW(e) {
  return xW(this.__data__, e) > -1;
}
var OW = wW, SW = Su;
function PW(e, t) {
  var r = this.__data__, n = SW(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var EW = PW, jW = cW, _W = gW, AW = CW, DW = OW, MW = EW;
function Do(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Do.prototype.clear = jW;
Do.prototype.delete = _W;
Do.prototype.get = AW;
Do.prototype.has = DW;
Do.prototype.set = MW;
var Pu = Do, TW = ai, $W = xn, NW = TW($W, "Map"), i6 = NW, Kp = sW, IW = Pu, LW = i6;
function kW() {
  this.size = 0, this.__data__ = {
    hash: new Kp(),
    map: new (LW || IW)(),
    string: new Kp()
  };
}
var RW = kW;
function BW(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var VW = BW, HW = VW;
function FW(e, t) {
  var r = e.__data__;
  return HW(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var Eu = FW, WW = Eu;
function zW(e) {
  var t = WW(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var UW = zW, ZW = Eu;
function qW(e) {
  return ZW(this, e).get(e);
}
var GW = qW, YW = Eu;
function KW(e) {
  return YW(this, e).has(e);
}
var XW = KW, QW = Eu;
function JW(e, t) {
  var r = QW(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var ez = JW, tz = RW, rz = UW, nz = GW, az = XW, iz = ez;
function Mo(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Mo.prototype.clear = tz;
Mo.prototype.delete = rz;
Mo.prototype.get = nz;
Mo.prototype.has = az;
Mo.prototype.set = iz;
var o6 = Mo, uy = o6, oz = "Expected a function";
function s6(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(oz);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, n);
    return r.cache = i.set(a, o) || i, o;
  };
  return r.cache = new (s6.Cache || uy)(), r;
}
s6.Cache = uy;
var fy = s6;
const sz = /* @__PURE__ */ Ze(fy);
var lz = fy, cz = 500;
function uz(e) {
  var t = lz(e, function(n) {
    return r.size === cz && r.clear(), n;
  }), r = t.cache;
  return t;
}
var fz = uz, dz = fz, pz = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, hz = /\\(\\)?/g, vz = dz(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(pz, function(r, n, a, i) {
    t.push(a ? i.replace(hz, "$1") : n || r);
  }), t;
}), mz = vz;
function gz(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var l6 = gz, Xp = I1, yz = l6, bz = vr, Cz = jo, xz = 1 / 0, Qp = Xp ? Xp.prototype : void 0, Jp = Qp ? Qp.toString : void 0;
function dy(e) {
  if (typeof e == "string")
    return e;
  if (bz(e))
    return yz(e, dy) + "";
  if (Cz(e))
    return Jp ? Jp.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -xz ? "-0" : t;
}
var wz = dy, Oz = wz;
function Sz(e) {
  return e == null ? "" : Oz(e);
}
var py = Sz, Pz = vr, Ez = r6, jz = mz, _z = py;
function Az(e, t) {
  return Pz(e) ? e : Ez(e, t) ? [e] : jz(_z(e));
}
var hy = Az, Dz = jo, Mz = 1 / 0;
function Tz(e) {
  if (typeof e == "string" || Dz(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -Mz ? "-0" : t;
}
var ju = Tz, $z = hy, Nz = ju;
function Iz(e, t) {
  t = $z(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[Nz(t[r++])];
  return r && r == n ? e : void 0;
}
var c6 = Iz, Lz = c6;
function kz(e, t, r) {
  var n = e == null ? void 0 : Lz(e, t);
  return n === void 0 ? r : n;
}
var vy = kz;
const Sr = /* @__PURE__ */ Ze(vy);
function Rz(e) {
  return e == null;
}
var Bz = Rz;
const xe = /* @__PURE__ */ Ze(Bz);
var Vz = Fn, Hz = vr, Fz = Wn, Wz = "[object String]";
function zz(e) {
  return typeof e == "string" || !Hz(e) && Fz(e) && Vz(e) == Wz;
}
var Uz = zz;
const L1 = /* @__PURE__ */ Ze(Uz);
var m0 = { exports: {} }, et = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e4;
function Zz() {
  if (e4)
    return et;
  e4 = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m;
  m = Symbol.for("react.module.reference");
  function v(g) {
    if (typeof g == "object" && g !== null) {
      var b = g.$$typeof;
      switch (b) {
        case e:
          switch (g = g.type, g) {
            case r:
            case a:
            case n:
            case c:
            case u:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case s:
                case o:
                case l:
                case p:
                case d:
                case i:
                  return g;
                default:
                  return b;
              }
          }
        case t:
          return b;
      }
    }
  }
  return et.ContextConsumer = o, et.ContextProvider = i, et.Element = e, et.ForwardRef = l, et.Fragment = r, et.Lazy = p, et.Memo = d, et.Portal = t, et.Profiler = a, et.StrictMode = n, et.Suspense = c, et.SuspenseList = u, et.isAsyncMode = function() {
    return !1;
  }, et.isConcurrentMode = function() {
    return !1;
  }, et.isContextConsumer = function(g) {
    return v(g) === o;
  }, et.isContextProvider = function(g) {
    return v(g) === i;
  }, et.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === e;
  }, et.isForwardRef = function(g) {
    return v(g) === l;
  }, et.isFragment = function(g) {
    return v(g) === r;
  }, et.isLazy = function(g) {
    return v(g) === p;
  }, et.isMemo = function(g) {
    return v(g) === d;
  }, et.isPortal = function(g) {
    return v(g) === t;
  }, et.isProfiler = function(g) {
    return v(g) === a;
  }, et.isStrictMode = function(g) {
    return v(g) === n;
  }, et.isSuspense = function(g) {
    return v(g) === c;
  }, et.isSuspenseList = function(g) {
    return v(g) === u;
  }, et.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === r || g === a || g === n || g === c || g === u || g === h || typeof g == "object" && g !== null && (g.$$typeof === p || g.$$typeof === d || g.$$typeof === i || g.$$typeof === o || g.$$typeof === l || g.$$typeof === m || g.getModuleId !== void 0);
  }, et.typeOf = v, et;
}
var tt = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var t4;
function qz() {
  return t4 || (t4 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = !1, v = !1, g = !1, b = !1, C = !1, w;
    w = Symbol.for("react.module.reference");
    function x(z) {
      return !!(typeof z == "string" || typeof z == "function" || z === r || z === a || C || z === n || z === c || z === u || b || z === h || m || v || g || typeof z == "object" && z !== null && (z.$$typeof === p || z.$$typeof === d || z.$$typeof === i || z.$$typeof === o || z.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      z.$$typeof === w || z.getModuleId !== void 0));
    }
    function y(z) {
      if (typeof z == "object" && z !== null) {
        var te = z.$$typeof;
        switch (te) {
          case e:
            var ne = z.type;
            switch (ne) {
              case r:
              case a:
              case n:
              case c:
              case u:
                return ne;
              default:
                var ae = ne && ne.$$typeof;
                switch (ae) {
                  case s:
                  case o:
                  case l:
                  case p:
                  case d:
                  case i:
                    return ae;
                  default:
                    return te;
                }
            }
          case t:
            return te;
        }
      }
    }
    var O = o, P = i, j = e, T = l, I = r, R = p, F = d, $ = t, Z = a, X = n, K = c, J = u, ee = !1, A = !1;
    function _(z) {
      return ee || (ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function N(z) {
      return A || (A = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function M(z) {
      return y(z) === o;
    }
    function S(z) {
      return y(z) === i;
    }
    function B(z) {
      return typeof z == "object" && z !== null && z.$$typeof === e;
    }
    function G(z) {
      return y(z) === l;
    }
    function U(z) {
      return y(z) === r;
    }
    function H(z) {
      return y(z) === p;
    }
    function k(z) {
      return y(z) === d;
    }
    function L(z) {
      return y(z) === t;
    }
    function W(z) {
      return y(z) === a;
    }
    function V(z) {
      return y(z) === n;
    }
    function D(z) {
      return y(z) === c;
    }
    function Q(z) {
      return y(z) === u;
    }
    tt.ContextConsumer = O, tt.ContextProvider = P, tt.Element = j, tt.ForwardRef = T, tt.Fragment = I, tt.Lazy = R, tt.Memo = F, tt.Portal = $, tt.Profiler = Z, tt.StrictMode = X, tt.Suspense = K, tt.SuspenseList = J, tt.isAsyncMode = _, tt.isConcurrentMode = N, tt.isContextConsumer = M, tt.isContextProvider = S, tt.isElement = B, tt.isForwardRef = G, tt.isFragment = U, tt.isLazy = H, tt.isMemo = k, tt.isPortal = L, tt.isProfiler = W, tt.isStrictMode = V, tt.isSuspense = D, tt.isSuspenseList = Q, tt.isValidElementType = x, tt.typeOf = y;
  }()), tt;
}
process.env.NODE_ENV === "production" ? m0.exports = Zz() : m0.exports = qz();
var my = m0.exports, Gz = Fn, Yz = Wn, Kz = "[object Number]";
function Xz(e) {
  return typeof e == "number" || Yz(e) && Gz(e) == Kz;
}
var gy = Xz;
const Qz = /* @__PURE__ */ Ze(gy);
var Jz = gy;
function eU(e) {
  return Jz(e) && e != +e;
}
var tU = eU;
const To = /* @__PURE__ */ Ze(tU);
var ar = function(t) {
  return t === 0 ? 0 : t > 0 ? 1 : -1;
}, Va = function(t) {
  return L1(t) && t.indexOf("%") === t.length - 1;
}, oe = function(t) {
  return Qz(t) && !To(t);
}, Vt = function(t) {
  return oe(t) || L1(t);
}, rU = 0, ga = function(t) {
  var r = ++rU;
  return "".concat(t || "").concat(r);
}, ir = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!oe(t) && !L1(t))
    return n;
  var i;
  if (Va(t)) {
    var o = t.indexOf("%");
    i = r * parseFloat(t.slice(0, o)) / 100;
  } else
    i = +t;
  return To(i) && (i = n), a && i > r && (i = r), i;
}, Yn = function(t) {
  if (!t)
    return null;
  var r = Object.keys(t);
  return r && r.length ? t[r[0]] : null;
}, nU = function(t) {
  if (!Array.isArray(t))
    return !1;
  for (var r = t.length, n = {}, a = 0; a < r; a++)
    if (!n[t[a]])
      n[t[a]] = !0;
    else
      return !0;
  return !1;
}, xt = function(t, r) {
  return oe(t) && oe(r) ? function(n) {
    return t + n * (r - t);
  } : function() {
    return r;
  };
};
function Ql(e, t, r) {
  return !e || !e.length ? null : e.find(function(n) {
    return n && (typeof t == "function" ? t(n) : Sr(n, t)) === r;
  });
}
var aU = function(t) {
  if (!t || !t.length)
    return null;
  for (var r = t.length, n = 0, a = 0, i = 0, o = 0, s = 1 / 0, l = -1 / 0, c = 0, u = 0, d = 0; d < r; d++)
    c = t[d].cx || 0, u = t[d].cy || 0, n += c, a += u, i += c * u, o += c * c, s = Math.min(s, c), l = Math.max(l, c);
  var p = r * o !== n * n ? (r * i - n * a) / (r * o - n * n) : 0;
  return {
    xmin: s,
    xmax: l,
    a: p,
    b: (a - p * n) / r
  };
};
function Ni(e, t) {
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r) && (!{}.hasOwnProperty.call(t, r) || e[r] !== t[r]))
      return !1;
  for (var n in t)
    if ({}.hasOwnProperty.call(t, n) && !{}.hasOwnProperty.call(e, n))
      return !1;
  return !0;
}
function g0(e) {
  "@babel/helpers - typeof";
  return g0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, g0(e);
}
var iU = ["viewBox", "children"], oU = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], r4 = ["points", "pathLength"], i3 = {
  svg: iU,
  polygon: r4,
  polyline: r4
}, u6 = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], Jl = function(t, r) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var n = t;
  if (/* @__PURE__ */ Yr(t) && (n = t.props), !_o(n))
    return null;
  var a = {};
  return Object.keys(n).forEach(function(i) {
    u6.includes(i) && (a[i] = r || function(o) {
      return n[i](n, o);
    });
  }), a;
}, sU = function(t, r, n) {
  return function(a) {
    return t(r, n, a), null;
  };
}, sa = function(t, r, n) {
  if (!_o(t) || g0(t) !== "object")
    return null;
  var a = null;
  return Object.keys(t).forEach(function(i) {
    var o = t[i];
    u6.includes(i) && typeof o == "function" && (a || (a = {}), a[i] = sU(o, r, n));
  }), a;
}, lU = ["children"], cU = ["children"];
function n4(e, t) {
  if (e == null)
    return {};
  var r = uU(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function uU(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function y0(e) {
  "@babel/helpers - typeof";
  return y0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, y0(e);
}
var a4 = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart"
}, Nn = function(t) {
  return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
}, i4 = null, o3 = null, f6 = function e(t) {
  if (t === i4 && Array.isArray(o3))
    return o3;
  var r = [];
  return Ua.forEach(t, function(n) {
    xe(n) || (my.isFragment(n) ? r = r.concat(e(n.props.children)) : r.push(n));
  }), o3 = r, i4 = t, r;
};
function lr(e, t) {
  var r = [], n = [];
  return Array.isArray(t) ? n = t.map(function(a) {
    return Nn(a);
  }) : n = [Nn(t)], f6(e).forEach(function(a) {
    var i = Sr(a, "type.displayName") || Sr(a, "type.name");
    n.indexOf(i) !== -1 && r.push(a);
  }), r;
}
function br(e, t) {
  var r = lr(e, t);
  return r && r[0];
}
var o4 = function(t) {
  if (!t || !t.props)
    return !1;
  var r = t.props, n = r.width, a = r.height;
  return !(!oe(n) || n <= 0 || !oe(a) || a <= 0);
}, fU = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], dU = function(t) {
  return t && t.type && L1(t.type) && fU.indexOf(t.type) >= 0;
}, yy = function(t) {
  return t && y0(t) === "object" && "clipDot" in t;
}, pU = function(t, r, n, a) {
  var i, o = (i = i3 == null ? void 0 : i3[a]) !== null && i !== void 0 ? i : [];
  return !we(t) && (a && o.includes(r) || oU.includes(r)) || n && u6.includes(r);
}, he = function(t, r, n) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var a = t;
  if (/* @__PURE__ */ Yr(t) && (a = t.props), !_o(a))
    return null;
  var i = {};
  return Object.keys(a).forEach(function(o) {
    var s;
    pU((s = a) === null || s === void 0 ? void 0 : s[o], o, r, n) && (i[o] = a[o]);
  }), i;
}, b0 = function e(t, r) {
  if (t === r)
    return !0;
  var n = Ua.count(t);
  if (n !== Ua.count(r))
    return !1;
  if (n === 0)
    return !0;
  if (n === 1)
    return s4(Array.isArray(t) ? t[0] : t, Array.isArray(r) ? r[0] : r);
  for (var a = 0; a < n; a++) {
    var i = t[a], o = r[a];
    if (Array.isArray(i) || Array.isArray(o)) {
      if (!e(i, o))
        return !1;
    } else if (!s4(i, o))
      return !1;
  }
  return !0;
}, s4 = function(t, r) {
  if (xe(t) && xe(r))
    return !0;
  if (!xe(t) && !xe(r)) {
    var n = t.props || {}, a = n.children, i = n4(n, lU), o = r.props || {}, s = o.children, l = n4(o, cU);
    return a && s ? Ni(i, l) && b0(a, s) : !a && !s ? Ni(i, l) : !1;
  }
  return !1;
}, l4 = function(t, r) {
  var n = [], a = {};
  return f6(t).forEach(function(i, o) {
    if (dU(i))
      n.push(i);
    else if (i) {
      var s = Nn(i.type), l = r[s] || {}, c = l.handler, u = l.once;
      if (c && (!u || !a[s])) {
        var d = c(i, s, o);
        n.push(d), a[s] = !0;
      }
    }
  }), n;
}, hU = function(t) {
  var r = t && t.type;
  return r && a4[r] ? a4[r] : null;
}, vU = function(t, r) {
  return f6(r).indexOf(t);
}, mU = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function C0() {
  return C0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, C0.apply(this, arguments);
}
function gU(e, t) {
  if (e == null)
    return {};
  var r = yU(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function yU(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function x0(e) {
  var t = e.children, r = e.width, n = e.height, a = e.viewBox, i = e.className, o = e.style, s = e.title, l = e.desc, c = gU(e, mU), u = a || {
    width: r,
    height: n,
    x: 0,
    y: 0
  }, d = De("recharts-surface", i);
  return /* @__PURE__ */ E.createElement("svg", C0({}, he(c, !0, "svg"), {
    className: d,
    width: r,
    height: n,
    style: o,
    viewBox: "".concat(u.x, " ").concat(u.y, " ").concat(u.width, " ").concat(u.height)
  }), /* @__PURE__ */ E.createElement("title", null, s), /* @__PURE__ */ E.createElement("desc", null, l), t);
}
var bU = ["children", "className"];
function w0() {
  return w0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, w0.apply(this, arguments);
}
function CU(e, t) {
  if (e == null)
    return {};
  var r = xU(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function xU(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
var Me = /* @__PURE__ */ E.forwardRef(function(e, t) {
  var r = e.children, n = e.className, a = CU(e, bU), i = De("recharts-layer", n);
  return /* @__PURE__ */ E.createElement("g", w0({
    className: i
  }, he(a, !0), {
    ref: t
  }), r);
}), wU = process.env.NODE_ENV !== "production", Kr = function(t, r) {
  for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    a[i - 2] = arguments[i];
  if (wU && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var o = 0;
      console.warn(r.replace(/%s/g, function() {
        return a[o++];
      }));
    }
};
function OU(e, t, r) {
  var n = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), r = r > a ? a : r, r < 0 && (r += a), a = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var i = Array(a); ++n < a; )
    i[n] = e[n + t];
  return i;
}
var SU = OU, PU = SU;
function EU(e, t, r) {
  var n = e.length;
  return r = r === void 0 ? n : r, !t && r >= n ? e : PU(e, t, r);
}
var jU = EU, _U = "\\ud800-\\udfff", AU = "\\u0300-\\u036f", DU = "\\ufe20-\\ufe2f", MU = "\\u20d0-\\u20ff", TU = AU + DU + MU, $U = "\\ufe0e\\ufe0f", NU = "\\u200d", IU = RegExp("[" + NU + _U + TU + $U + "]");
function LU(e) {
  return IU.test(e);
}
var by = LU;
function kU(e) {
  return e.split("");
}
var RU = kU, Cy = "\\ud800-\\udfff", BU = "\\u0300-\\u036f", VU = "\\ufe20-\\ufe2f", HU = "\\u20d0-\\u20ff", FU = BU + VU + HU, WU = "\\ufe0e\\ufe0f", zU = "[" + Cy + "]", O0 = "[" + FU + "]", S0 = "\\ud83c[\\udffb-\\udfff]", UU = "(?:" + O0 + "|" + S0 + ")", xy = "[^" + Cy + "]", wy = "(?:\\ud83c[\\udde6-\\uddff]){2}", Oy = "[\\ud800-\\udbff][\\udc00-\\udfff]", ZU = "\\u200d", Sy = UU + "?", Py = "[" + WU + "]?", qU = "(?:" + ZU + "(?:" + [xy, wy, Oy].join("|") + ")" + Py + Sy + ")*", GU = Py + Sy + qU, YU = "(?:" + [xy + O0 + "?", O0, wy, Oy, zU].join("|") + ")", KU = RegExp(S0 + "(?=" + S0 + ")|" + YU + GU, "g");
function XU(e) {
  return e.match(KU) || [];
}
var QU = XU, JU = RU, eZ = by, tZ = QU;
function rZ(e) {
  return eZ(e) ? tZ(e) : JU(e);
}
var nZ = rZ, aZ = jU, iZ = by, oZ = nZ, sZ = py;
function lZ(e) {
  return function(t) {
    t = sZ(t);
    var r = iZ(t) ? oZ(t) : void 0, n = r ? r[0] : t.charAt(0), a = r ? aZ(r, 1).join("") : t.slice(1);
    return n[e]() + a;
  };
}
var cZ = lZ, uZ = cZ, fZ = uZ("toUpperCase"), dZ = fZ;
const _u = /* @__PURE__ */ Ze(dZ);
function ft(e) {
  return function() {
    return e;
  };
}
const Ey = Math.cos, ec = Math.sin, rn = Math.sqrt, tc = Math.PI, Au = 2 * tc, P0 = Math.PI, E0 = 2 * P0, $a = 1e-6, pZ = E0 - $a;
function jy(e) {
  this._ += e[0];
  for (let t = 1, r = e.length; t < r; ++t)
    this._ += arguments[t] + e[t];
}
function hZ(e) {
  let t = Math.floor(e);
  if (!(t >= 0))
    throw new Error(`invalid digits: ${e}`);
  if (t > 15)
    return jy;
  const r = 10 ** t;
  return function(n) {
    this._ += n[0];
    for (let a = 1, i = n.length; a < i; ++a)
      this._ += Math.round(arguments[a] * r) / r + n[a];
  };
}
class vZ {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? jy : hZ(t);
  }
  moveTo(t, r) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, r) {
    this._append`L${this._x1 = +t},${this._y1 = +r}`;
  }
  quadraticCurveTo(t, r, n, a) {
    this._append`Q${+t},${+r},${this._x1 = +n},${this._y1 = +a}`;
  }
  bezierCurveTo(t, r, n, a, i, o) {
    this._append`C${+t},${+r},${+n},${+a},${this._x1 = +i},${this._y1 = +o}`;
  }
  arcTo(t, r, n, a, i) {
    if (t = +t, r = +r, n = +n, a = +a, i = +i, i < 0)
      throw new Error(`negative radius: ${i}`);
    let o = this._x1, s = this._y1, l = n - t, c = a - r, u = o - t, d = s - r, p = u * u + d * d;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = r}`;
    else if (p > $a)
      if (!(Math.abs(d * l - c * u) > $a) || !i)
        this._append`L${this._x1 = t},${this._y1 = r}`;
      else {
        let h = n - o, m = a - s, v = l * l + c * c, g = h * h + m * m, b = Math.sqrt(v), C = Math.sqrt(p), w = i * Math.tan((P0 - Math.acos((v + p - g) / (2 * b * C))) / 2), x = w / C, y = w / b;
        Math.abs(x - 1) > $a && this._append`L${t + x * u},${r + x * d}`, this._append`A${i},${i},0,0,${+(d * h > u * m)},${this._x1 = t + y * l},${this._y1 = r + y * c}`;
      }
  }
  arc(t, r, n, a, i, o) {
    if (t = +t, r = +r, n = +n, o = !!o, n < 0)
      throw new Error(`negative radius: ${n}`);
    let s = n * Math.cos(a), l = n * Math.sin(a), c = t + s, u = r + l, d = 1 ^ o, p = o ? a - i : i - a;
    this._x1 === null ? this._append`M${c},${u}` : (Math.abs(this._x1 - c) > $a || Math.abs(this._y1 - u) > $a) && this._append`L${c},${u}`, n && (p < 0 && (p = p % E0 + E0), p > pZ ? this._append`A${n},${n},0,1,${d},${t - s},${r - l}A${n},${n},0,1,${d},${this._x1 = c},${this._y1 = u}` : p > $a && this._append`A${n},${n},0,${+(p >= P0)},${d},${this._x1 = t + n * Math.cos(i)},${this._y1 = r + n * Math.sin(i)}`);
  }
  rect(t, r, n, a) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}h${n = +n}v${+a}h${-n}Z`;
  }
  toString() {
    return this._;
  }
}
function d6(e) {
  let t = 3;
  return e.digits = function(r) {
    if (!arguments.length)
      return t;
    if (r == null)
      t = null;
    else {
      const n = Math.floor(r);
      if (!(n >= 0))
        throw new RangeError(`invalid digits: ${r}`);
      t = n;
    }
    return e;
  }, () => new vZ(t);
}
function p6(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function _y(e) {
  this._context = e;
}
_y.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function Du(e) {
  return new _y(e);
}
function Ay(e) {
  return e[0];
}
function Dy(e) {
  return e[1];
}
function My(e, t) {
  var r = ft(!0), n = null, a = Du, i = null, o = d6(s);
  e = typeof e == "function" ? e : e === void 0 ? Ay : ft(e), t = typeof t == "function" ? t : t === void 0 ? Dy : ft(t);
  function s(l) {
    var c, u = (l = p6(l)).length, d, p = !1, h;
    for (n == null && (i = a(h = o())), c = 0; c <= u; ++c)
      !(c < u && r(d = l[c], c, l)) === p && ((p = !p) ? i.lineStart() : i.lineEnd()), p && i.point(+e(d, c, l), +t(d, c, l));
    if (h)
      return i = null, h + "" || null;
  }
  return s.x = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : ft(+l), s) : e;
  }, s.y = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : ft(+l), s) : t;
  }, s.defined = function(l) {
    return arguments.length ? (r = typeof l == "function" ? l : ft(!!l), s) : r;
  }, s.curve = function(l) {
    return arguments.length ? (a = l, n != null && (i = a(n)), s) : a;
  }, s.context = function(l) {
    return arguments.length ? (l == null ? n = i = null : i = a(n = l), s) : n;
  }, s;
}
function al(e, t, r) {
  var n = null, a = ft(!0), i = null, o = Du, s = null, l = d6(c);
  e = typeof e == "function" ? e : e === void 0 ? Ay : ft(+e), t = typeof t == "function" ? t : ft(t === void 0 ? 0 : +t), r = typeof r == "function" ? r : r === void 0 ? Dy : ft(+r);
  function c(d) {
    var p, h, m, v = (d = p6(d)).length, g, b = !1, C, w = new Array(v), x = new Array(v);
    for (i == null && (s = o(C = l())), p = 0; p <= v; ++p) {
      if (!(p < v && a(g = d[p], p, d)) === b)
        if (b = !b)
          h = p, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), m = p - 1; m >= h; --m)
            s.point(w[m], x[m]);
          s.lineEnd(), s.areaEnd();
        }
      b && (w[p] = +e(g, p, d), x[p] = +t(g, p, d), s.point(n ? +n(g, p, d) : w[p], r ? +r(g, p, d) : x[p]));
    }
    if (C)
      return s = null, C + "" || null;
  }
  function u() {
    return My().defined(a).curve(o).context(i);
  }
  return c.x = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : ft(+d), n = null, c) : e;
  }, c.x0 = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : ft(+d), c) : e;
  }, c.x1 = function(d) {
    return arguments.length ? (n = d == null ? null : typeof d == "function" ? d : ft(+d), c) : n;
  }, c.y = function(d) {
    return arguments.length ? (t = typeof d == "function" ? d : ft(+d), r = null, c) : t;
  }, c.y0 = function(d) {
    return arguments.length ? (t = typeof d == "function" ? d : ft(+d), c) : t;
  }, c.y1 = function(d) {
    return arguments.length ? (r = d == null ? null : typeof d == "function" ? d : ft(+d), c) : r;
  }, c.lineX0 = c.lineY0 = function() {
    return u().x(e).y(t);
  }, c.lineY1 = function() {
    return u().x(e).y(r);
  }, c.lineX1 = function() {
    return u().x(n).y(t);
  }, c.defined = function(d) {
    return arguments.length ? (a = typeof d == "function" ? d : ft(!!d), c) : a;
  }, c.curve = function(d) {
    return arguments.length ? (o = d, i != null && (s = o(i)), c) : o;
  }, c.context = function(d) {
    return arguments.length ? (d == null ? i = s = null : s = o(i = d), c) : i;
  }, c;
}
class Ty {
  constructor(t, r) {
    this._context = t, this._x = r;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, r) {
    switch (t = +t, r = +r, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, r) : this._context.moveTo(t, r);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, r, t, r) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + r) / 2, t, this._y0, t, r);
        break;
      }
    }
    this._x0 = t, this._y0 = r;
  }
}
function mZ(e) {
  return new Ty(e, !0);
}
function gZ(e) {
  return new Ty(e, !1);
}
const h6 = {
  draw(e, t) {
    const r = rn(t / tc);
    e.moveTo(r, 0), e.arc(0, 0, r, 0, Au);
  }
}, yZ = {
  draw(e, t) {
    const r = rn(t / 5) / 2;
    e.moveTo(-3 * r, -r), e.lineTo(-r, -r), e.lineTo(-r, -3 * r), e.lineTo(r, -3 * r), e.lineTo(r, -r), e.lineTo(3 * r, -r), e.lineTo(3 * r, r), e.lineTo(r, r), e.lineTo(r, 3 * r), e.lineTo(-r, 3 * r), e.lineTo(-r, r), e.lineTo(-3 * r, r), e.closePath();
  }
}, $y = rn(1 / 3), bZ = $y * 2, CZ = {
  draw(e, t) {
    const r = rn(t / bZ), n = r * $y;
    e.moveTo(0, -r), e.lineTo(n, 0), e.lineTo(0, r), e.lineTo(-n, 0), e.closePath();
  }
}, xZ = {
  draw(e, t) {
    const r = rn(t), n = -r / 2;
    e.rect(n, n, r, r);
  }
}, wZ = 0.8908130915292852, Ny = ec(tc / 10) / ec(7 * tc / 10), OZ = ec(Au / 10) * Ny, SZ = -Ey(Au / 10) * Ny, PZ = {
  draw(e, t) {
    const r = rn(t * wZ), n = OZ * r, a = SZ * r;
    e.moveTo(0, -r), e.lineTo(n, a);
    for (let i = 1; i < 5; ++i) {
      const o = Au * i / 5, s = Ey(o), l = ec(o);
      e.lineTo(l * r, -s * r), e.lineTo(s * n - l * a, l * n + s * a);
    }
    e.closePath();
  }
}, s3 = rn(3), EZ = {
  draw(e, t) {
    const r = -rn(t / (s3 * 3));
    e.moveTo(0, r * 2), e.lineTo(-s3 * r, -r), e.lineTo(s3 * r, -r), e.closePath();
  }
}, _r = -0.5, Ar = rn(3) / 2, j0 = 1 / rn(12), jZ = (j0 / 2 + 1) * 3, _Z = {
  draw(e, t) {
    const r = rn(t / jZ), n = r / 2, a = r * j0, i = n, o = r * j0 + r, s = -i, l = o;
    e.moveTo(n, a), e.lineTo(i, o), e.lineTo(s, l), e.lineTo(_r * n - Ar * a, Ar * n + _r * a), e.lineTo(_r * i - Ar * o, Ar * i + _r * o), e.lineTo(_r * s - Ar * l, Ar * s + _r * l), e.lineTo(_r * n + Ar * a, _r * a - Ar * n), e.lineTo(_r * i + Ar * o, _r * o - Ar * i), e.lineTo(_r * s + Ar * l, _r * l - Ar * s), e.closePath();
  }
};
function AZ(e, t) {
  let r = null, n = d6(a);
  e = typeof e == "function" ? e : ft(e || h6), t = typeof t == "function" ? t : ft(t === void 0 ? 64 : +t);
  function a() {
    let i;
    if (r || (r = i = n()), e.apply(this, arguments).draw(r, +t.apply(this, arguments)), i)
      return r = null, i + "" || null;
  }
  return a.type = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : ft(i), a) : e;
  }, a.size = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : ft(+i), a) : t;
  }, a.context = function(i) {
    return arguments.length ? (r = i ?? null, a) : r;
  }, a;
}
function rc() {
}
function nc(e, t, r) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + r) / 6
  );
}
function Iy(e) {
  this._context = e;
}
Iy.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        nc(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        nc(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function DZ(e) {
  return new Iy(e);
}
function Ly(e) {
  this._context = e;
}
Ly.prototype = {
  areaStart: rc,
  areaEnd: rc,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        nc(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function MZ(e) {
  return new Ly(e);
}
function ky(e) {
  this._context = e;
}
ky.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var r = (this._x0 + 4 * this._x1 + e) / 6, n = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
        break;
      case 3:
        this._point = 4;
      default:
        nc(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function TZ(e) {
  return new ky(e);
}
function Ry(e) {
  this._context = e;
}
Ry.prototype = {
  areaStart: rc,
  areaEnd: rc,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function $Z(e) {
  return new Ry(e);
}
function c4(e) {
  return e < 0 ? -1 : 1;
}
function u4(e, t, r) {
  var n = e._x1 - e._x0, a = t - e._x1, i = (e._y1 - e._y0) / (n || a < 0 && -0), o = (r - e._y1) / (a || n < 0 && -0), s = (i * a + o * n) / (n + a);
  return (c4(i) + c4(o)) * Math.min(Math.abs(i), Math.abs(o), 0.5 * Math.abs(s)) || 0;
}
function f4(e, t) {
  var r = e._x1 - e._x0;
  return r ? (3 * (e._y1 - e._y0) / r - t) / 2 : t;
}
function l3(e, t, r) {
  var n = e._x0, a = e._y0, i = e._x1, o = e._y1, s = (i - n) / 3;
  e._context.bezierCurveTo(n + s, a + s * t, i - s, o - s * r, i, o);
}
function ac(e) {
  this._context = e;
}
ac.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        l3(this, this._t0, f4(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var r = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, l3(this, f4(this, r = u4(this, e, t)), r);
          break;
        default:
          l3(this, this._t0, r = u4(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = r;
    }
  }
};
function By(e) {
  this._context = new Vy(e);
}
(By.prototype = Object.create(ac.prototype)).point = function(e, t) {
  ac.prototype.point.call(this, t, e);
};
function Vy(e) {
  this._context = e;
}
Vy.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, r, n, a, i) {
    this._context.bezierCurveTo(t, e, n, r, i, a);
  }
};
function NZ(e) {
  return new ac(e);
}
function IZ(e) {
  return new By(e);
}
function Hy(e) {
  this._context = e;
}
Hy.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, r = e.length;
    if (r)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), r === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var n = d4(e), a = d4(t), i = 0, o = 1; o < r; ++i, ++o)
          this._context.bezierCurveTo(n[0][i], a[0][i], n[1][i], a[1][i], e[o], t[o]);
    (this._line || this._line !== 0 && r === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function d4(e) {
  var t, r = e.length - 1, n, a = new Array(r), i = new Array(r), o = new Array(r);
  for (a[0] = 0, i[0] = 2, o[0] = e[0] + 2 * e[1], t = 1; t < r - 1; ++t)
    a[t] = 1, i[t] = 4, o[t] = 4 * e[t] + 2 * e[t + 1];
  for (a[r - 1] = 2, i[r - 1] = 7, o[r - 1] = 8 * e[r - 1] + e[r], t = 1; t < r; ++t)
    n = a[t] / i[t - 1], i[t] -= n, o[t] -= n * o[t - 1];
  for (a[r - 1] = o[r - 1] / i[r - 1], t = r - 2; t >= 0; --t)
    a[t] = (o[t] - a[t + 1]) / i[t];
  for (i[r - 1] = (e[r] + a[r - 1]) / 2, t = 0; t < r - 1; ++t)
    i[t] = 2 * e[t + 1] - a[t + 1];
  return [a, i];
}
function LZ(e) {
  return new Hy(e);
}
function Mu(e, t) {
  this._context = e, this._t = t;
}
Mu.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var r = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(r, this._y), this._context.lineTo(r, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function kZ(e) {
  return new Mu(e, 0.5);
}
function RZ(e) {
  return new Mu(e, 0);
}
function BZ(e) {
  return new Mu(e, 1);
}
function Ui(e, t) {
  if ((o = e.length) > 1)
    for (var r = 1, n, a, i = e[t[0]], o, s = i.length; r < o; ++r)
      for (a = i, i = e[t[r]], n = 0; n < s; ++n)
        i[n][1] += i[n][0] = isNaN(a[n][1]) ? a[n][0] : a[n][1];
}
function _0(e) {
  for (var t = e.length, r = new Array(t); --t >= 0; )
    r[t] = t;
  return r;
}
function VZ(e, t) {
  return e[t];
}
function HZ(e) {
  const t = [];
  return t.key = e, t;
}
function FZ() {
  var e = ft([]), t = _0, r = Ui, n = VZ;
  function a(i) {
    var o = Array.from(e.apply(this, arguments), HZ), s, l = o.length, c = -1, u;
    for (const d of i)
      for (s = 0, ++c; s < l; ++s)
        (o[s][c] = [0, +n(d, o[s].key, c, i)]).data = d;
    for (s = 0, u = p6(t(o)); s < l; ++s)
      o[u[s]].index = s;
    return r(o, u), o;
  }
  return a.keys = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : ft(Array.from(i)), a) : e;
  }, a.value = function(i) {
    return arguments.length ? (n = typeof i == "function" ? i : ft(+i), a) : n;
  }, a.order = function(i) {
    return arguments.length ? (t = i == null ? _0 : typeof i == "function" ? i : ft(Array.from(i)), a) : t;
  }, a.offset = function(i) {
    return arguments.length ? (r = i ?? Ui, a) : r;
  }, a;
}
function WZ(e, t) {
  if ((n = e.length) > 0) {
    for (var r, n, a = 0, i = e[0].length, o; a < i; ++a) {
      for (o = r = 0; r < n; ++r)
        o += e[r][a][1] || 0;
      if (o)
        for (r = 0; r < n; ++r)
          e[r][a][1] /= o;
    }
    Ui(e, t);
  }
}
function zZ(e, t) {
  if ((a = e.length) > 0) {
    for (var r = 0, n = e[t[0]], a, i = n.length; r < i; ++r) {
      for (var o = 0, s = 0; o < a; ++o)
        s += e[o][r][1] || 0;
      n[r][1] += n[r][0] = -s / 2;
    }
    Ui(e, t);
  }
}
function UZ(e, t) {
  if (!(!((o = e.length) > 0) || !((i = (a = e[t[0]]).length) > 0))) {
    for (var r = 0, n = 1, a, i, o; n < i; ++n) {
      for (var s = 0, l = 0, c = 0; s < o; ++s) {
        for (var u = e[t[s]], d = u[n][1] || 0, p = u[n - 1][1] || 0, h = (d - p) / 2, m = 0; m < s; ++m) {
          var v = e[t[m]], g = v[n][1] || 0, b = v[n - 1][1] || 0;
          h += g - b;
        }
        l += d, c += h * d;
      }
      a[n - 1][1] += a[n - 1][0] = r, l && (r -= c / l);
    }
    a[n - 1][1] += a[n - 1][0] = r, Ui(e, t);
  }
}
function Hs(e) {
  "@babel/helpers - typeof";
  return Hs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Hs(e);
}
var ZZ = ["type", "size", "sizeType"];
function A0() {
  return A0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, A0.apply(this, arguments);
}
function p4(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function h4(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? p4(Object(r), !0).forEach(function(n) {
      qZ(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : p4(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function qZ(e, t, r) {
  return t = GZ(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function GZ(e) {
  var t = YZ(e, "string");
  return Hs(t) == "symbol" ? t : t + "";
}
function YZ(e, t) {
  if (Hs(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Hs(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function KZ(e, t) {
  if (e == null)
    return {};
  var r = XZ(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function XZ(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
var Fy = {
  symbolCircle: h6,
  symbolCross: yZ,
  symbolDiamond: CZ,
  symbolSquare: xZ,
  symbolStar: PZ,
  symbolTriangle: EZ,
  symbolWye: _Z
}, QZ = Math.PI / 180, JZ = function(t) {
  var r = "symbol".concat(_u(t));
  return Fy[r] || h6;
}, eq = function(t, r, n) {
  if (r === "area")
    return t;
  switch (n) {
    case "cross":
      return 5 * t * t / 9;
    case "diamond":
      return 0.5 * t * t / Math.sqrt(3);
    case "square":
      return t * t;
    case "star": {
      var a = 18 * QZ;
      return 1.25 * t * t * (Math.tan(a) - Math.tan(a * 2) * Math.pow(Math.tan(a), 2));
    }
    case "triangle":
      return Math.sqrt(3) * t * t / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * t * t / 8;
    default:
      return Math.PI * t * t / 4;
  }
}, tq = function(t, r) {
  Fy["symbol".concat(_u(t))] = r;
}, Tu = function(t) {
  var r = t.type, n = r === void 0 ? "circle" : r, a = t.size, i = a === void 0 ? 64 : a, o = t.sizeType, s = o === void 0 ? "area" : o, l = KZ(t, ZZ), c = h4(h4({}, l), {}, {
    type: n,
    size: i,
    sizeType: s
  }), u = function() {
    var g = JZ(n), b = AZ().type(g).size(eq(i, s, n));
    return b();
  }, d = c.className, p = c.cx, h = c.cy, m = he(c, !0);
  return p === +p && h === +h && i === +i ? /* @__PURE__ */ E.createElement("path", A0({}, m, {
    className: De("recharts-symbols", d),
    transform: "translate(".concat(p, ", ").concat(h, ")"),
    d: u()
  })) : null;
};
Tu.registerSymbol = tq;
function Zi(e) {
  "@babel/helpers - typeof";
  return Zi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zi(e);
}
function D0() {
  return D0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, D0.apply(this, arguments);
}
function v4(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function rq(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? v4(Object(r), !0).forEach(function(n) {
      Fs(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : v4(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function nq(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function m4(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, zy(n.key), n);
  }
}
function aq(e, t, r) {
  return t && m4(e.prototype, t), r && m4(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function iq(e, t, r) {
  return t = ic(t), oq(e, Wy() ? Reflect.construct(t, r || [], ic(e).constructor) : t.apply(e, r));
}
function oq(e, t) {
  if (t && (Zi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return sq(e);
}
function sq(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Wy() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Wy = function() {
    return !!e;
  })();
}
function ic(e) {
  return ic = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ic(e);
}
function lq(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && M0(e, t);
}
function M0(e, t) {
  return M0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, M0(e, t);
}
function Fs(e, t, r) {
  return t = zy(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function zy(e) {
  var t = cq(e, "string");
  return Zi(t) == "symbol" ? t : t + "";
}
function cq(e, t) {
  if (Zi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Zi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Dr = 32, v6 = /* @__PURE__ */ function(e) {
  function t() {
    return nq(this, t), iq(this, t, arguments);
  }
  return lq(t, e), aq(t, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(n) {
        var a = this.props.inactiveColor, i = Dr / 2, o = Dr / 6, s = Dr / 3, l = n.inactive ? a : n.color;
        if (n.type === "plainline")
          return /* @__PURE__ */ E.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: l,
            strokeDasharray: n.payload.strokeDasharray,
            x1: 0,
            y1: i,
            x2: Dr,
            y2: i,
            className: "recharts-legend-icon"
          });
        if (n.type === "line")
          return /* @__PURE__ */ E.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: l,
            d: "M0,".concat(i, "h").concat(s, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(2 * s, ",").concat(i, `
            H`).concat(Dr, "M").concat(2 * s, ",").concat(i, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(s, ",").concat(i),
            className: "recharts-legend-icon"
          });
        if (n.type === "rect")
          return /* @__PURE__ */ E.createElement("path", {
            stroke: "none",
            fill: l,
            d: "M0,".concat(Dr / 8, "h").concat(Dr, "v").concat(Dr * 3 / 4, "h").concat(-Dr, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ E.isValidElement(n.legendIcon)) {
          var c = rq({}, n);
          return delete c.legendIcon, /* @__PURE__ */ E.cloneElement(n.legendIcon, c);
        }
        return /* @__PURE__ */ E.createElement(Tu, {
          fill: l,
          cx: i,
          cy: i,
          size: Dr,
          sizeType: "diameter",
          type: n.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var n = this, a = this.props, i = a.payload, o = a.iconSize, s = a.layout, l = a.formatter, c = a.inactiveColor, u = {
        x: 0,
        y: 0,
        width: Dr,
        height: Dr
      }, d = {
        display: s === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, p = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return i.map(function(h, m) {
        var v = h.formatter || l, g = De(Fs(Fs({
          "recharts-legend-item": !0
        }, "legend-item-".concat(m), !0), "inactive", h.inactive));
        if (h.type === "none")
          return null;
        var b = we(h.value) ? null : h.value;
        Kr(
          !we(h.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var C = h.inactive ? c : h.color;
        return /* @__PURE__ */ E.createElement("li", D0({
          className: g,
          style: d,
          key: "legend-item-".concat(m)
        }, sa(n.props, h, m)), /* @__PURE__ */ E.createElement(x0, {
          width: o,
          height: o,
          viewBox: u,
          style: p
        }, n.renderIcon(h)), /* @__PURE__ */ E.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: C
          }
        }, v ? v(b, h, m) : b));
      });
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.payload, i = n.layout, o = n.align;
      if (!a || !a.length)
        return null;
      var s = {
        padding: 0,
        margin: 0,
        textAlign: i === "horizontal" ? o : "left"
      };
      return /* @__PURE__ */ E.createElement("ul", {
        className: "recharts-default-legend",
        style: s
      }, this.renderItems());
    }
  }]);
}(Pr);
Fs(v6, "displayName", "Legend");
Fs(v6, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var uq = Pu;
function fq() {
  this.__data__ = new uq(), this.size = 0;
}
var dq = fq;
function pq(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var hq = pq;
function vq(e) {
  return this.__data__.get(e);
}
var mq = vq;
function gq(e) {
  return this.__data__.has(e);
}
var yq = gq, bq = Pu, Cq = i6, xq = o6, wq = 200;
function Oq(e, t) {
  var r = this.__data__;
  if (r instanceof bq) {
    var n = r.__data__;
    if (!Cq || n.length < wq - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new xq(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var Sq = Oq, Pq = Pu, Eq = dq, jq = hq, _q = mq, Aq = yq, Dq = Sq;
function $o(e) {
  var t = this.__data__ = new Pq(e);
  this.size = t.size;
}
$o.prototype.clear = Eq;
$o.prototype.delete = jq;
$o.prototype.get = _q;
$o.prototype.has = Aq;
$o.prototype.set = Dq;
var Uy = $o, Mq = "__lodash_hash_undefined__";
function Tq(e) {
  return this.__data__.set(e, Mq), this;
}
var $q = Tq;
function Nq(e) {
  return this.__data__.has(e);
}
var Iq = Nq, Lq = o6, kq = $q, Rq = Iq;
function oc(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Lq(); ++t < r; )
    this.add(e[t]);
}
oc.prototype.add = oc.prototype.push = kq;
oc.prototype.has = Rq;
var Zy = oc;
function Bq(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var qy = Bq;
function Vq(e, t) {
  return e.has(t);
}
var Gy = Vq, Hq = Zy, Fq = qy, Wq = Gy, zq = 1, Uq = 2;
function Zq(e, t, r, n, a, i) {
  var o = r & zq, s = e.length, l = t.length;
  if (s != l && !(o && l > s))
    return !1;
  var c = i.get(e), u = i.get(t);
  if (c && u)
    return c == t && u == e;
  var d = -1, p = !0, h = r & Uq ? new Hq() : void 0;
  for (i.set(e, t), i.set(t, e); ++d < s; ) {
    var m = e[d], v = t[d];
    if (n)
      var g = o ? n(v, m, d, t, e, i) : n(m, v, d, e, t, i);
    if (g !== void 0) {
      if (g)
        continue;
      p = !1;
      break;
    }
    if (h) {
      if (!Fq(t, function(b, C) {
        if (!Wq(h, C) && (m === b || a(m, b, r, n, i)))
          return h.push(C);
      })) {
        p = !1;
        break;
      }
    } else if (!(m === v || a(m, v, r, n, i))) {
      p = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), p;
}
var Yy = Zq, qq = xn, Gq = qq.Uint8Array, Yq = Gq;
function Kq(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
var Xq = Kq;
function Qq(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var m6 = Qq, g4 = I1, y4 = Yq, Jq = a6, eG = Yy, tG = Xq, rG = m6, nG = 1, aG = 2, iG = "[object Boolean]", oG = "[object Date]", sG = "[object Error]", lG = "[object Map]", cG = "[object Number]", uG = "[object RegExp]", fG = "[object Set]", dG = "[object String]", pG = "[object Symbol]", hG = "[object ArrayBuffer]", vG = "[object DataView]", b4 = g4 ? g4.prototype : void 0, c3 = b4 ? b4.valueOf : void 0;
function mG(e, t, r, n, a, i, o) {
  switch (r) {
    case vG:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case hG:
      return !(e.byteLength != t.byteLength || !i(new y4(e), new y4(t)));
    case iG:
    case oG:
    case cG:
      return Jq(+e, +t);
    case sG:
      return e.name == t.name && e.message == t.message;
    case uG:
    case dG:
      return e == t + "";
    case lG:
      var s = tG;
    case fG:
      var l = n & nG;
      if (s || (s = rG), e.size != t.size && !l)
        return !1;
      var c = o.get(e);
      if (c)
        return c == t;
      n |= aG, o.set(e, t);
      var u = eG(s(e), s(t), n, a, i, o);
      return o.delete(e), u;
    case pG:
      if (c3)
        return c3.call(e) == c3.call(t);
  }
  return !1;
}
var gG = mG;
function yG(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var Ky = yG, bG = Ky, CG = vr;
function xG(e, t, r) {
  var n = t(e);
  return CG(e) ? n : bG(n, r(e));
}
var wG = xG;
function OG(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (i[a++] = o);
  }
  return i;
}
var SG = OG;
function PG() {
  return [];
}
var EG = PG, jG = SG, _G = EG, AG = Object.prototype, DG = AG.propertyIsEnumerable, C4 = Object.getOwnPropertySymbols, MG = C4 ? function(e) {
  return e == null ? [] : (e = Object(e), jG(C4(e), function(t) {
    return DG.call(e, t);
  }));
} : _G, TG = MG;
function $G(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var NG = $G, IG = Fn, LG = Wn, kG = "[object Arguments]";
function RG(e) {
  return LG(e) && IG(e) == kG;
}
var BG = RG, x4 = BG, VG = Wn, Xy = Object.prototype, HG = Xy.hasOwnProperty, FG = Xy.propertyIsEnumerable, WG = x4(function() {
  return arguments;
}()) ? x4 : function(e) {
  return VG(e) && HG.call(e, "callee") && !FG.call(e, "callee");
}, g6 = WG, sc = { exports: {} };
function zG() {
  return !1;
}
var UG = zG;
sc.exports;
(function(e, t) {
  var r = xn, n = UG, a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, s = o ? r.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || n;
  e.exports = c;
})(sc, sc.exports);
var Qy = sc.exports, ZG = 9007199254740991, qG = /^(?:0|[1-9]\d*)$/;
function GG(e, t) {
  var r = typeof e;
  return t = t ?? ZG, !!t && (r == "number" || r != "symbol" && qG.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var y6 = GG, YG = 9007199254740991;
function KG(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= YG;
}
var b6 = KG, XG = Fn, QG = b6, JG = Wn, eY = "[object Arguments]", tY = "[object Array]", rY = "[object Boolean]", nY = "[object Date]", aY = "[object Error]", iY = "[object Function]", oY = "[object Map]", sY = "[object Number]", lY = "[object Object]", cY = "[object RegExp]", uY = "[object Set]", fY = "[object String]", dY = "[object WeakMap]", pY = "[object ArrayBuffer]", hY = "[object DataView]", vY = "[object Float32Array]", mY = "[object Float64Array]", gY = "[object Int8Array]", yY = "[object Int16Array]", bY = "[object Int32Array]", CY = "[object Uint8Array]", xY = "[object Uint8ClampedArray]", wY = "[object Uint16Array]", OY = "[object Uint32Array]", ht = {};
ht[vY] = ht[mY] = ht[gY] = ht[yY] = ht[bY] = ht[CY] = ht[xY] = ht[wY] = ht[OY] = !0;
ht[eY] = ht[tY] = ht[pY] = ht[rY] = ht[hY] = ht[nY] = ht[aY] = ht[iY] = ht[oY] = ht[sY] = ht[lY] = ht[cY] = ht[uY] = ht[fY] = ht[dY] = !1;
function SY(e) {
  return JG(e) && QG(e.length) && !!ht[XG(e)];
}
var PY = SY;
function EY(e) {
  return function(t) {
    return e(t);
  };
}
var Jy = EY, lc = { exports: {} };
lc.exports;
(function(e, t) {
  var r = sy, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, o = i && r.process, s = function() {
    try {
      var l = a && a.require && a.require("util").types;
      return l || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(lc, lc.exports);
var jY = lc.exports, _Y = PY, AY = Jy, w4 = jY, O4 = w4 && w4.isTypedArray, DY = O4 ? AY(O4) : _Y, eb = DY, MY = NG, TY = g6, $Y = vr, NY = Qy, IY = y6, LY = eb, kY = Object.prototype, RY = kY.hasOwnProperty;
function BY(e, t) {
  var r = $Y(e), n = !r && TY(e), a = !r && !n && NY(e), i = !r && !n && !a && LY(e), o = r || n || a || i, s = o ? MY(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || RY.call(e, c)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    IY(c, l))) && s.push(c);
  return s;
}
var VY = BY, HY = Object.prototype;
function FY(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || HY;
  return e === r;
}
var WY = FY;
function zY(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var tb = zY, UY = tb, ZY = UY(Object.keys, Object), qY = ZY, GY = WY, YY = qY, KY = Object.prototype, XY = KY.hasOwnProperty;
function QY(e) {
  if (!GY(e))
    return YY(e);
  var t = [];
  for (var r in Object(e))
    XY.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var JY = QY, eK = n6, tK = b6;
function rK(e) {
  return e != null && tK(e.length) && !eK(e);
}
var k1 = rK, nK = VY, aK = JY, iK = k1;
function oK(e) {
  return iK(e) ? nK(e) : aK(e);
}
var $u = oK, sK = wG, lK = TG, cK = $u;
function uK(e) {
  return sK(e, cK, lK);
}
var fK = uK, S4 = fK, dK = 1, pK = Object.prototype, hK = pK.hasOwnProperty;
function vK(e, t, r, n, a, i) {
  var o = r & dK, s = S4(e), l = s.length, c = S4(t), u = c.length;
  if (l != u && !o)
    return !1;
  for (var d = l; d--; ) {
    var p = s[d];
    if (!(o ? p in t : hK.call(t, p)))
      return !1;
  }
  var h = i.get(e), m = i.get(t);
  if (h && m)
    return h == t && m == e;
  var v = !0;
  i.set(e, t), i.set(t, e);
  for (var g = o; ++d < l; ) {
    p = s[d];
    var b = e[p], C = t[p];
    if (n)
      var w = o ? n(C, b, p, t, e, i) : n(b, C, p, e, t, i);
    if (!(w === void 0 ? b === C || a(b, C, r, n, i) : w)) {
      v = !1;
      break;
    }
    g || (g = p == "constructor");
  }
  if (v && !g) {
    var x = e.constructor, y = t.constructor;
    x != y && "constructor" in e && "constructor" in t && !(typeof x == "function" && x instanceof x && typeof y == "function" && y instanceof y) && (v = !1);
  }
  return i.delete(e), i.delete(t), v;
}
var mK = vK, gK = ai, yK = xn, bK = gK(yK, "DataView"), CK = bK, xK = ai, wK = xn, OK = xK(wK, "Promise"), SK = OK, PK = ai, EK = xn, jK = PK(EK, "Set"), rb = jK, _K = ai, AK = xn, DK = _K(AK, "WeakMap"), MK = DK, T0 = CK, $0 = i6, N0 = SK, I0 = rb, L0 = MK, nb = Fn, No = cy, P4 = "[object Map]", TK = "[object Object]", E4 = "[object Promise]", j4 = "[object Set]", _4 = "[object WeakMap]", A4 = "[object DataView]", $K = No(T0), NK = No($0), IK = No(N0), LK = No(I0), kK = No(L0), Na = nb;
(T0 && Na(new T0(new ArrayBuffer(1))) != A4 || $0 && Na(new $0()) != P4 || N0 && Na(N0.resolve()) != E4 || I0 && Na(new I0()) != j4 || L0 && Na(new L0()) != _4) && (Na = function(e) {
  var t = nb(e), r = t == TK ? e.constructor : void 0, n = r ? No(r) : "";
  if (n)
    switch (n) {
      case $K:
        return A4;
      case NK:
        return P4;
      case IK:
        return E4;
      case LK:
        return j4;
      case kK:
        return _4;
    }
  return t;
});
var RK = Na, u3 = Uy, BK = Yy, VK = gG, HK = mK, D4 = RK, M4 = vr, T4 = Qy, FK = eb, WK = 1, $4 = "[object Arguments]", N4 = "[object Array]", il = "[object Object]", zK = Object.prototype, I4 = zK.hasOwnProperty;
function UK(e, t, r, n, a, i) {
  var o = M4(e), s = M4(t), l = o ? N4 : D4(e), c = s ? N4 : D4(t);
  l = l == $4 ? il : l, c = c == $4 ? il : c;
  var u = l == il, d = c == il, p = l == c;
  if (p && T4(e)) {
    if (!T4(t))
      return !1;
    o = !0, u = !1;
  }
  if (p && !u)
    return i || (i = new u3()), o || FK(e) ? BK(e, t, r, n, a, i) : VK(e, t, l, r, n, a, i);
  if (!(r & WK)) {
    var h = u && I4.call(e, "__wrapped__"), m = d && I4.call(t, "__wrapped__");
    if (h || m) {
      var v = h ? e.value() : e, g = m ? t.value() : t;
      return i || (i = new u3()), a(v, g, r, n, i);
    }
  }
  return p ? (i || (i = new u3()), HK(e, t, r, n, a, i)) : !1;
}
var ZK = UK, qK = ZK, L4 = Wn;
function ab(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !L4(e) && !L4(t) ? e !== e && t !== t : qK(e, t, r, n, ab, a);
}
var C6 = ab, GK = Uy, YK = C6, KK = 1, XK = 2;
function QK(e, t, r, n) {
  var a = r.length, i = a, o = !n;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var s = r[a];
    if (o && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    s = r[a];
    var l = s[0], c = e[l], u = s[1];
    if (o && s[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var d = new GK();
      if (n)
        var p = n(c, u, l, e, t, d);
      if (!(p === void 0 ? YK(u, c, KK | XK, n, d) : p))
        return !1;
    }
  }
  return !0;
}
var JK = QK, eX = ma;
function tX(e) {
  return e === e && !eX(e);
}
var ib = tX, rX = ib, nX = $u;
function aX(e) {
  for (var t = nX(e), r = t.length; r--; ) {
    var n = t[r], a = e[n];
    t[r] = [n, a, rX(a)];
  }
  return t;
}
var iX = aX;
function oX(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var ob = oX, sX = JK, lX = iX, cX = ob;
function uX(e) {
  var t = lX(e);
  return t.length == 1 && t[0][2] ? cX(t[0][0], t[0][1]) : function(r) {
    return r === e || sX(r, e, t);
  };
}
var fX = uX;
function dX(e, t) {
  return e != null && t in Object(e);
}
var pX = dX, hX = hy, vX = g6, mX = vr, gX = y6, yX = b6, bX = ju;
function CX(e, t, r) {
  t = hX(t, e);
  for (var n = -1, a = t.length, i = !1; ++n < a; ) {
    var o = bX(t[n]);
    if (!(i = e != null && r(e, o)))
      break;
    e = e[o];
  }
  return i || ++n != a ? i : (a = e == null ? 0 : e.length, !!a && yX(a) && gX(o, a) && (mX(e) || vX(e)));
}
var xX = CX, wX = pX, OX = xX;
function SX(e, t) {
  return e != null && OX(e, t, wX);
}
var PX = SX, EX = C6, jX = vy, _X = PX, AX = r6, DX = ib, MX = ob, TX = ju, $X = 1, NX = 2;
function IX(e, t) {
  return AX(e) && DX(t) ? MX(TX(e), t) : function(r) {
    var n = jX(r, e);
    return n === void 0 && n === t ? _X(r, e) : EX(t, n, $X | NX);
  };
}
var LX = IX;
function kX(e) {
  return e;
}
var Io = kX;
function RX(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var BX = RX, VX = c6;
function HX(e) {
  return function(t) {
    return VX(t, e);
  };
}
var FX = HX, WX = BX, zX = FX, UX = r6, ZX = ju;
function qX(e) {
  return UX(e) ? WX(ZX(e)) : zX(e);
}
var GX = qX, YX = fX, KX = LX, XX = Io, QX = vr, JX = GX;
function eQ(e) {
  return typeof e == "function" ? e : e == null ? XX : typeof e == "object" ? QX(e) ? KX(e[0], e[1]) : YX(e) : JX(e);
}
var wn = eQ;
function tQ(e, t, r, n) {
  for (var a = e.length, i = r + (n ? 1 : -1); n ? i-- : ++i < a; )
    if (t(e[i], i, e))
      return i;
  return -1;
}
var sb = tQ;
function rQ(e) {
  return e !== e;
}
var nQ = rQ;
function aQ(e, t, r) {
  for (var n = r - 1, a = e.length; ++n < a; )
    if (e[n] === t)
      return n;
  return -1;
}
var iQ = aQ, oQ = sb, sQ = nQ, lQ = iQ;
function cQ(e, t, r) {
  return t === t ? lQ(e, t, r) : oQ(e, sQ, r);
}
var uQ = cQ, fQ = uQ;
function dQ(e, t) {
  var r = e == null ? 0 : e.length;
  return !!r && fQ(e, t, 0) > -1;
}
var pQ = dQ;
function hQ(e, t, r) {
  for (var n = -1, a = e == null ? 0 : e.length; ++n < a; )
    if (r(t, e[n]))
      return !0;
  return !1;
}
var vQ = hQ;
function mQ() {
}
var gQ = mQ, f3 = rb, yQ = gQ, bQ = m6, CQ = 1 / 0, xQ = f3 && 1 / bQ(new f3([, -0]))[1] == CQ ? function(e) {
  return new f3(e);
} : yQ, wQ = xQ, OQ = Zy, SQ = pQ, PQ = vQ, EQ = Gy, jQ = wQ, _Q = m6, AQ = 200;
function DQ(e, t, r) {
  var n = -1, a = SQ, i = e.length, o = !0, s = [], l = s;
  if (r)
    o = !1, a = PQ;
  else if (i >= AQ) {
    var c = t ? null : jQ(e);
    if (c)
      return _Q(c);
    o = !1, a = EQ, l = new OQ();
  } else
    l = t ? [] : s;
  e:
    for (; ++n < i; ) {
      var u = e[n], d = t ? t(u) : u;
      if (u = r || u !== 0 ? u : 0, o && d === d) {
        for (var p = l.length; p--; )
          if (l[p] === d)
            continue e;
        t && l.push(d), s.push(u);
      } else
        a(l, d, r) || (l !== s && l.push(d), s.push(u));
    }
  return s;
}
var MQ = DQ, TQ = wn, $Q = MQ;
function NQ(e, t) {
  return e && e.length ? $Q(e, TQ(t)) : [];
}
var IQ = NQ;
const k4 = /* @__PURE__ */ Ze(IQ);
function lb(e, t, r) {
  return t === !0 ? k4(e, r) : we(t) ? k4(e, t) : e;
}
function qi(e) {
  "@babel/helpers - typeof";
  return qi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qi(e);
}
var LQ = ["ref"];
function R4(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function jn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? R4(Object(r), !0).forEach(function(n) {
      Nu(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : R4(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function kQ(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function B4(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ub(n.key), n);
  }
}
function RQ(e, t, r) {
  return t && B4(e.prototype, t), r && B4(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function BQ(e, t, r) {
  return t = cc(t), VQ(e, cb() ? Reflect.construct(t, r || [], cc(e).constructor) : t.apply(e, r));
}
function VQ(e, t) {
  if (t && (qi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return HQ(e);
}
function HQ(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function cb() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (cb = function() {
    return !!e;
  })();
}
function cc(e) {
  return cc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, cc(e);
}
function FQ(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && k0(e, t);
}
function k0(e, t) {
  return k0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, k0(e, t);
}
function Nu(e, t, r) {
  return t = ub(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ub(e) {
  var t = WQ(e, "string");
  return qi(t) == "symbol" ? t : t + "";
}
function WQ(e, t) {
  if (qi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (qi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function zQ(e, t) {
  if (e == null)
    return {};
  var r = UQ(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function UQ(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function ZQ(e) {
  return e.value;
}
function qQ(e, t) {
  if (/* @__PURE__ */ E.isValidElement(e))
    return /* @__PURE__ */ E.cloneElement(e, t);
  if (typeof e == "function")
    return /* @__PURE__ */ E.createElement(e, t);
  t.ref;
  var r = zQ(t, LQ);
  return /* @__PURE__ */ E.createElement(v6, r);
}
var V4 = 1, In = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    kQ(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = BQ(this, t, [].concat(a)), Nu(r, "lastBoundingBox", {
      width: -1,
      height: -1
    }), r;
  }
  return FQ(t, e), RQ(t, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        return n.height = this.wrapperNode.offsetHeight, n.width = this.wrapperNode.offsetWidth, n;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var n = this.props.onBBoxUpdate, a = this.getBBox();
      a ? (Math.abs(a.width - this.lastBoundingBox.width) > V4 || Math.abs(a.height - this.lastBoundingBox.height) > V4) && (this.lastBoundingBox.width = a.width, this.lastBoundingBox.height = a.height, n && n(a)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, n && n(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? jn({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(n) {
      var a = this.props, i = a.layout, o = a.align, s = a.verticalAlign, l = a.margin, c = a.chartWidth, u = a.chartHeight, d, p;
      if (!n || (n.left === void 0 || n.left === null) && (n.right === void 0 || n.right === null))
        if (o === "center" && i === "vertical") {
          var h = this.getBBoxSnapshot();
          d = {
            left: ((c || 0) - h.width) / 2
          };
        } else
          d = o === "right" ? {
            right: l && l.right || 0
          } : {
            left: l && l.left || 0
          };
      if (!n || (n.top === void 0 || n.top === null) && (n.bottom === void 0 || n.bottom === null))
        if (s === "middle") {
          var m = this.getBBoxSnapshot();
          p = {
            top: ((u || 0) - m.height) / 2
          };
        } else
          p = s === "bottom" ? {
            bottom: l && l.bottom || 0
          } : {
            top: l && l.top || 0
          };
      return jn(jn({}, d), p);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.content, o = a.width, s = a.height, l = a.wrapperStyle, c = a.payloadUniqBy, u = a.payload, d = jn(jn({
        position: "absolute",
        width: o || "auto",
        height: s || "auto"
      }, this.getDefaultPosition(l)), l);
      return /* @__PURE__ */ E.createElement("div", {
        className: "recharts-legend-wrapper",
        style: d,
        ref: function(h) {
          n.wrapperNode = h;
        }
      }, qQ(i, jn(jn({}, this.props), {}, {
        payload: lb(u, c, ZQ)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(n, a) {
      var i = jn(jn({}, this.defaultProps), n.props), o = i.layout;
      return o === "vertical" && oe(n.props.height) ? {
        height: n.props.height
      } : o === "horizontal" ? {
        width: n.props.width || a
      } : null;
    }
  }]);
}(Pr);
Nu(In, "displayName", "Legend");
Nu(In, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var H4 = I1, GQ = g6, YQ = vr, F4 = H4 ? H4.isConcatSpreadable : void 0;
function KQ(e) {
  return YQ(e) || GQ(e) || !!(F4 && e && e[F4]);
}
var XQ = KQ, QQ = Ky, JQ = XQ;
function fb(e, t, r, n, a) {
  var i = -1, o = e.length;
  for (r || (r = JQ), a || (a = []); ++i < o; ) {
    var s = e[i];
    t > 0 && r(s) ? t > 1 ? fb(s, t - 1, r, n, a) : QQ(a, s) : n || (a[a.length] = s);
  }
  return a;
}
var db = fb;
function eJ(e) {
  return function(t, r, n) {
    for (var a = -1, i = Object(t), o = n(t), s = o.length; s--; ) {
      var l = o[e ? s : ++a];
      if (r(i[l], l, i) === !1)
        break;
    }
    return t;
  };
}
var tJ = eJ, rJ = tJ, nJ = rJ(), aJ = nJ, iJ = aJ, oJ = $u;
function sJ(e, t) {
  return e && iJ(e, t, oJ);
}
var pb = sJ, lJ = k1;
function cJ(e, t) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!lJ(r))
      return e(r, n);
    for (var a = r.length, i = t ? a : -1, o = Object(r); (t ? i-- : ++i < a) && n(o[i], i, o) !== !1; )
      ;
    return r;
  };
}
var uJ = cJ, fJ = pb, dJ = uJ, pJ = dJ(fJ), x6 = pJ, hJ = x6, vJ = k1;
function mJ(e, t) {
  var r = -1, n = vJ(e) ? Array(e.length) : [];
  return hJ(e, function(a, i, o) {
    n[++r] = t(a, i, o);
  }), n;
}
var hb = mJ;
function gJ(e, t) {
  var r = e.length;
  for (e.sort(t); r--; )
    e[r] = e[r].value;
  return e;
}
var yJ = gJ, W4 = jo;
function bJ(e, t) {
  if (e !== t) {
    var r = e !== void 0, n = e === null, a = e === e, i = W4(e), o = t !== void 0, s = t === null, l = t === t, c = W4(t);
    if (!s && !c && !i && e > t || i && o && l && !s && !c || n && o && l || !r && l || !a)
      return 1;
    if (!n && !i && !c && e < t || c && r && a && !n && !i || s && r && a || !o && a || !l)
      return -1;
  }
  return 0;
}
var CJ = bJ, xJ = CJ;
function wJ(e, t, r) {
  for (var n = -1, a = e.criteria, i = t.criteria, o = a.length, s = r.length; ++n < o; ) {
    var l = xJ(a[n], i[n]);
    if (l) {
      if (n >= s)
        return l;
      var c = r[n];
      return l * (c == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
var OJ = wJ, d3 = l6, SJ = c6, PJ = wn, EJ = hb, jJ = yJ, _J = Jy, AJ = OJ, DJ = Io, MJ = vr;
function TJ(e, t, r) {
  t.length ? t = d3(t, function(i) {
    return MJ(i) ? function(o) {
      return SJ(o, i.length === 1 ? i[0] : i);
    } : i;
  }) : t = [DJ];
  var n = -1;
  t = d3(t, _J(PJ));
  var a = EJ(e, function(i, o, s) {
    var l = d3(t, function(c) {
      return c(i);
    });
    return { criteria: l, index: ++n, value: i };
  });
  return jJ(a, function(i, o) {
    return AJ(i, o, r);
  });
}
var $J = TJ;
function NJ(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
var IJ = NJ, LJ = IJ, z4 = Math.max;
function kJ(e, t, r) {
  return t = z4(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, a = -1, i = z4(n.length - t, 0), o = Array(i); ++a < i; )
      o[a] = n[t + a];
    a = -1;
    for (var s = Array(t + 1); ++a < t; )
      s[a] = n[a];
    return s[t] = r(o), LJ(e, this, s);
  };
}
var RJ = kJ;
function BJ(e) {
  return function() {
    return e;
  };
}
var VJ = BJ, HJ = ai, FJ = function() {
  try {
    var e = HJ(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), vb = FJ, WJ = VJ, U4 = vb, zJ = Io, UJ = U4 ? function(e, t) {
  return U4(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: WJ(t),
    writable: !0
  });
} : zJ, ZJ = UJ, qJ = 800, GJ = 16, YJ = Date.now;
function KJ(e) {
  var t = 0, r = 0;
  return function() {
    var n = YJ(), a = GJ - (n - r);
    if (r = n, a > 0) {
      if (++t >= qJ)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var XJ = KJ, QJ = ZJ, JJ = XJ, eee = JJ(QJ), tee = eee, ree = Io, nee = RJ, aee = tee;
function iee(e, t) {
  return aee(nee(e, t, ree), e + "");
}
var oee = iee, see = a6, lee = k1, cee = y6, uee = ma;
function fee(e, t, r) {
  if (!uee(r))
    return !1;
  var n = typeof t;
  return (n == "number" ? lee(r) && cee(t, r.length) : n == "string" && t in r) ? see(r[t], e) : !1;
}
var Iu = fee, dee = db, pee = $J, hee = oee, Z4 = Iu, vee = hee(function(e, t) {
  if (e == null)
    return [];
  var r = t.length;
  return r > 1 && Z4(e, t[0], t[1]) ? t = [] : r > 2 && Z4(t[0], t[1], t[2]) && (t = [t[0]]), pee(e, dee(t, 1), []);
}), mee = vee;
const w6 = /* @__PURE__ */ Ze(mee);
function Ws(e) {
  "@babel/helpers - typeof";
  return Ws = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ws(e);
}
function R0() {
  return R0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, R0.apply(this, arguments);
}
function gee(e, t) {
  return xee(e) || Cee(e, t) || bee(e, t) || yee();
}
function yee() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bee(e, t) {
  if (e) {
    if (typeof e == "string")
      return q4(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return q4(e, t);
  }
}
function q4(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Cee(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function xee(e) {
  if (Array.isArray(e))
    return e;
}
function G4(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function p3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? G4(Object(r), !0).forEach(function(n) {
      wee(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : G4(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function wee(e, t, r) {
  return t = Oee(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Oee(e) {
  var t = See(e, "string");
  return Ws(t) == "symbol" ? t : t + "";
}
function See(e, t) {
  if (Ws(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ws(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Pee(e) {
  return Array.isArray(e) && Vt(e[0]) && Vt(e[1]) ? e.join(" ~ ") : e;
}
var Eee = function(t) {
  var r = t.separator, n = r === void 0 ? " : " : r, a = t.contentStyle, i = a === void 0 ? {} : a, o = t.itemStyle, s = o === void 0 ? {} : o, l = t.labelStyle, c = l === void 0 ? {} : l, u = t.payload, d = t.formatter, p = t.itemSorter, h = t.wrapperClassName, m = t.labelClassName, v = t.label, g = t.labelFormatter, b = t.accessibilityLayer, C = b === void 0 ? !1 : b, w = function() {
    if (u && u.length) {
      var F = {
        padding: 0,
        margin: 0
      }, $ = (p ? w6(u, p) : u).map(function(Z, X) {
        if (Z.type === "none")
          return null;
        var K = p3({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: Z.color || "#000"
        }, s), J = Z.formatter || d || Pee, ee = Z.value, A = Z.name, _ = ee, N = A;
        if (J && _ != null && N != null) {
          var M = J(ee, A, Z, X, u);
          if (Array.isArray(M)) {
            var S = gee(M, 2);
            _ = S[0], N = S[1];
          } else
            _ = M;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ E.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(X),
            style: K
          }, Vt(N) ? /* @__PURE__ */ E.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, N) : null, Vt(N) ? /* @__PURE__ */ E.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, n) : null, /* @__PURE__ */ E.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, _), /* @__PURE__ */ E.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, Z.unit || ""))
        );
      });
      return /* @__PURE__ */ E.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: F
      }, $);
    }
    return null;
  }, x = p3({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, i), y = p3({
    margin: 0
  }, c), O = !xe(v), P = O ? v : "", j = De("recharts-default-tooltip", h), T = De("recharts-tooltip-label", m);
  O && g && u !== void 0 && u !== null && (P = g(v, u));
  var I = C ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ E.createElement("div", R0({
    className: j,
    style: x
  }, I), /* @__PURE__ */ E.createElement("p", {
    className: T,
    style: y
  }, /* @__PURE__ */ E.isValidElement(P) ? P : "".concat(P)), w());
};
function zs(e) {
  "@babel/helpers - typeof";
  return zs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zs(e);
}
function ol(e, t, r) {
  return t = jee(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function jee(e) {
  var t = _ee(e, "string");
  return zs(t) == "symbol" ? t : t + "";
}
function _ee(e, t) {
  if (zs(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (zs(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Xo = "recharts-tooltip-wrapper", Aee = {
  visibility: "hidden"
};
function Dee(e) {
  var t = e.coordinate, r = e.translateX, n = e.translateY;
  return De(Xo, ol(ol(ol(ol({}, "".concat(Xo, "-right"), oe(r) && t && oe(t.x) && r >= t.x), "".concat(Xo, "-left"), oe(r) && t && oe(t.x) && r < t.x), "".concat(Xo, "-bottom"), oe(n) && t && oe(t.y) && n >= t.y), "".concat(Xo, "-top"), oe(n) && t && oe(t.y) && n < t.y));
}
function Y4(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.key, a = e.offsetTopLeft, i = e.position, o = e.reverseDirection, s = e.tooltipDimension, l = e.viewBox, c = e.viewBoxDimension;
  if (i && oe(i[n]))
    return i[n];
  var u = r[n] - s - a, d = r[n] + a;
  if (t[n])
    return o[n] ? u : d;
  if (o[n]) {
    var p = u, h = l[n];
    return p < h ? Math.max(d, l[n]) : Math.max(u, l[n]);
  }
  var m = d + s, v = l[n] + c;
  return m > v ? Math.max(u, l[n]) : Math.max(d, l[n]);
}
function Mee(e) {
  var t = e.translateX, r = e.translateY, n = e.useTranslate3d;
  return {
    transform: n ? "translate3d(".concat(t, "px, ").concat(r, "px, 0)") : "translate(".concat(t, "px, ").concat(r, "px)")
  };
}
function Tee(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.offsetTopLeft, a = e.position, i = e.reverseDirection, o = e.tooltipBox, s = e.useTranslate3d, l = e.viewBox, c, u, d;
  return o.height > 0 && o.width > 0 && r ? (u = Y4({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "x",
    offsetTopLeft: n,
    position: a,
    reverseDirection: i,
    tooltipDimension: o.width,
    viewBox: l,
    viewBoxDimension: l.width
  }), d = Y4({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "y",
    offsetTopLeft: n,
    position: a,
    reverseDirection: i,
    tooltipDimension: o.height,
    viewBox: l,
    viewBoxDimension: l.height
  }), c = Mee({
    translateX: u,
    translateY: d,
    useTranslate3d: s
  })) : c = Aee, {
    cssProperties: c,
    cssClasses: Dee({
      translateX: u,
      translateY: d,
      coordinate: r
    })
  };
}
function Gi(e) {
  "@babel/helpers - typeof";
  return Gi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gi(e);
}
function K4(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function X4(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? K4(Object(r), !0).forEach(function(n) {
      V0(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : K4(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function $ee(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Q4(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, gb(n.key), n);
  }
}
function Nee(e, t, r) {
  return t && Q4(e.prototype, t), r && Q4(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Iee(e, t, r) {
  return t = uc(t), Lee(e, mb() ? Reflect.construct(t, r || [], uc(e).constructor) : t.apply(e, r));
}
function Lee(e, t) {
  if (t && (Gi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return kee(e);
}
function kee(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function mb() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (mb = function() {
    return !!e;
  })();
}
function uc(e) {
  return uc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, uc(e);
}
function Ree(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && B0(e, t);
}
function B0(e, t) {
  return B0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, B0(e, t);
}
function V0(e, t, r) {
  return t = gb(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function gb(e) {
  var t = Bee(e, "string");
  return Gi(t) == "symbol" ? t : t + "";
}
function Bee(e, t) {
  if (Gi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Gi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var J4 = 1, Vee = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    $ee(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = Iee(this, t, [].concat(a)), V0(r, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), V0(r, "handleKeyDown", function(o) {
      if (o.key === "Escape") {
        var s, l, c, u;
        r.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (s = (l = r.props.coordinate) === null || l === void 0 ? void 0 : l.x) !== null && s !== void 0 ? s : 0,
            y: (c = (u = r.props.coordinate) === null || u === void 0 ? void 0 : u.y) !== null && c !== void 0 ? c : 0
          }
        });
      }
    }), r;
  }
  return Ree(t, e), Nee(t, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        (Math.abs(n.width - this.state.lastBoundingBox.width) > J4 || Math.abs(n.height - this.state.lastBoundingBox.height) > J4) && this.setState({
          lastBoundingBox: {
            width: n.width,
            height: n.height
          }
        });
      } else
        (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
          lastBoundingBox: {
            width: -1,
            height: -1
          }
        });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var n, a;
      this.props.active && this.updateBBox(), this.state.dismissed && (((n = this.props.coordinate) === null || n === void 0 ? void 0 : n.x) !== this.state.dismissedAtCoordinate.x || ((a = this.props.coordinate) === null || a === void 0 ? void 0 : a.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.active, o = a.allowEscapeViewBox, s = a.animationDuration, l = a.animationEasing, c = a.children, u = a.coordinate, d = a.hasPayload, p = a.isAnimationActive, h = a.offset, m = a.position, v = a.reverseDirection, g = a.useTranslate3d, b = a.viewBox, C = a.wrapperStyle, w = Tee({
        allowEscapeViewBox: o,
        coordinate: u,
        offsetTopLeft: h,
        position: m,
        reverseDirection: v,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: g,
        viewBox: b
      }), x = w.cssClasses, y = w.cssProperties, O = X4(X4({
        transition: p && i ? "transform ".concat(s, "ms ").concat(l) : void 0
      }, y), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && i && d ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, C);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ E.createElement("div", {
          tabIndex: -1,
          className: x,
          style: O,
          ref: function(j) {
            n.wrapperNode = j;
          }
        }, c)
      );
    }
  }]);
}(Pr), Hee = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, kr = {
  isSsr: Hee(),
  get: function(t) {
    return kr[t];
  },
  set: function(t, r) {
    if (typeof t == "string")
      kr[t] = r;
    else {
      var n = Object.keys(t);
      n && n.length && n.forEach(function(a) {
        kr[a] = t[a];
      });
    }
  }
};
function Yi(e) {
  "@babel/helpers - typeof";
  return Yi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yi(e);
}
function e8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function t8(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? e8(Object(r), !0).forEach(function(n) {
      O6(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : e8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Fee(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function r8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bb(n.key), n);
  }
}
function Wee(e, t, r) {
  return t && r8(e.prototype, t), r && r8(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function zee(e, t, r) {
  return t = fc(t), Uee(e, yb() ? Reflect.construct(t, r || [], fc(e).constructor) : t.apply(e, r));
}
function Uee(e, t) {
  if (t && (Yi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Zee(e);
}
function Zee(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function yb() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (yb = function() {
    return !!e;
  })();
}
function fc(e) {
  return fc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, fc(e);
}
function qee(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && H0(e, t);
}
function H0(e, t) {
  return H0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, H0(e, t);
}
function O6(e, t, r) {
  return t = bb(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function bb(e) {
  var t = Gee(e, "string");
  return Yi(t) == "symbol" ? t : t + "";
}
function Gee(e, t) {
  if (Yi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Yi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Yee(e) {
  return e.dataKey;
}
function Kee(e, t) {
  return /* @__PURE__ */ E.isValidElement(e) ? /* @__PURE__ */ E.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ E.createElement(e, t) : /* @__PURE__ */ E.createElement(Eee, t);
}
var dr = /* @__PURE__ */ function(e) {
  function t() {
    return Fee(this, t), zee(this, t, arguments);
  }
  return qee(t, e), Wee(t, [{
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.active, o = a.allowEscapeViewBox, s = a.animationDuration, l = a.animationEasing, c = a.content, u = a.coordinate, d = a.filterNull, p = a.isAnimationActive, h = a.offset, m = a.payload, v = a.payloadUniqBy, g = a.position, b = a.reverseDirection, C = a.useTranslate3d, w = a.viewBox, x = a.wrapperStyle, y = m ?? [];
      d && y.length && (y = lb(m.filter(function(P) {
        return P.value != null && (P.hide !== !0 || n.props.includeHidden);
      }), v, Yee));
      var O = y.length > 0;
      return /* @__PURE__ */ E.createElement(Vee, {
        allowEscapeViewBox: o,
        animationDuration: s,
        animationEasing: l,
        isAnimationActive: p,
        active: i,
        coordinate: u,
        hasPayload: O,
        offset: h,
        position: g,
        reverseDirection: b,
        useTranslate3d: C,
        viewBox: w,
        wrapperStyle: x
      }, Kee(c, t8(t8({}, this.props), {}, {
        payload: y
      })));
    }
  }]);
}(Pr);
O6(dr, "displayName", "Tooltip");
O6(dr, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !kr.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var Xee = xn, Qee = function() {
  return Xee.Date.now();
}, Jee = Qee, ete = /\s/;
function tte(e) {
  for (var t = e.length; t-- && ete.test(e.charAt(t)); )
    ;
  return t;
}
var rte = tte, nte = rte, ate = /^\s+/;
function ite(e) {
  return e && e.slice(0, nte(e) + 1).replace(ate, "");
}
var ote = ite, ste = ote, n8 = ma, lte = jo, a8 = 0 / 0, cte = /^[-+]0x[0-9a-f]+$/i, ute = /^0b[01]+$/i, fte = /^0o[0-7]+$/i, dte = parseInt;
function pte(e) {
  if (typeof e == "number")
    return e;
  if (lte(e))
    return a8;
  if (n8(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = n8(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = ste(e);
  var r = ute.test(e);
  return r || fte.test(e) ? dte(e.slice(2), r ? 2 : 8) : cte.test(e) ? a8 : +e;
}
var Cb = pte, hte = ma, h3 = Jee, i8 = Cb, vte = "Expected a function", mte = Math.max, gte = Math.min;
function yte(e, t, r) {
  var n, a, i, o, s, l, c = 0, u = !1, d = !1, p = !0;
  if (typeof e != "function")
    throw new TypeError(vte);
  t = i8(t) || 0, hte(r) && (u = !!r.leading, d = "maxWait" in r, i = d ? mte(i8(r.maxWait) || 0, t) : i, p = "trailing" in r ? !!r.trailing : p);
  function h(O) {
    var P = n, j = a;
    return n = a = void 0, c = O, o = e.apply(j, P), o;
  }
  function m(O) {
    return c = O, s = setTimeout(b, t), u ? h(O) : o;
  }
  function v(O) {
    var P = O - l, j = O - c, T = t - P;
    return d ? gte(T, i - j) : T;
  }
  function g(O) {
    var P = O - l, j = O - c;
    return l === void 0 || P >= t || P < 0 || d && j >= i;
  }
  function b() {
    var O = h3();
    if (g(O))
      return C(O);
    s = setTimeout(b, v(O));
  }
  function C(O) {
    return s = void 0, p && n ? h(O) : (n = a = void 0, o);
  }
  function w() {
    s !== void 0 && clearTimeout(s), c = 0, n = l = a = s = void 0;
  }
  function x() {
    return s === void 0 ? o : C(h3());
  }
  function y() {
    var O = h3(), P = g(O);
    if (n = arguments, a = this, l = O, P) {
      if (s === void 0)
        return m(l);
      if (d)
        return clearTimeout(s), s = setTimeout(b, t), h(l);
    }
    return s === void 0 && (s = setTimeout(b, t)), o;
  }
  return y.cancel = w, y.flush = x, y;
}
var bte = yte, Cte = bte, xte = ma, wte = "Expected a function";
function Ote(e, t, r) {
  var n = !0, a = !0;
  if (typeof e != "function")
    throw new TypeError(wte);
  return xte(r) && (n = "leading" in r ? !!r.leading : n, a = "trailing" in r ? !!r.trailing : a), Cte(e, t, {
    leading: n,
    maxWait: t,
    trailing: a
  });
}
var Ste = Ote;
const xb = /* @__PURE__ */ Ze(Ste);
function Us(e) {
  "@babel/helpers - typeof";
  return Us = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Us(e);
}
function o8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function sl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? o8(Object(r), !0).forEach(function(n) {
      Pte(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : o8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Pte(e, t, r) {
  return t = Ete(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Ete(e) {
  var t = jte(e, "string");
  return Us(t) == "symbol" ? t : t + "";
}
function jte(e, t) {
  if (Us(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Us(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function _te(e, t) {
  return Tte(e) || Mte(e, t) || Dte(e, t) || Ate();
}
function Ate() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Dte(e, t) {
  if (e) {
    if (typeof e == "string")
      return s8(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return s8(e, t);
  }
}
function s8(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Mte(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function Tte(e) {
  if (Array.isArray(e))
    return e;
}
var R1 = /* @__PURE__ */ yw(function(e, t) {
  var r = e.aspect, n = e.initialDimension, a = n === void 0 ? {
    width: -1,
    height: -1
  } : n, i = e.width, o = i === void 0 ? "100%" : i, s = e.height, l = s === void 0 ? "100%" : s, c = e.minWidth, u = c === void 0 ? 0 : c, d = e.minHeight, p = e.maxHeight, h = e.children, m = e.debounce, v = m === void 0 ? 0 : m, g = e.id, b = e.className, C = e.onResize, w = e.style, x = w === void 0 ? {} : w, y = ve(null), O = ve();
  O.current = C, bw(t, function() {
    return Object.defineProperty(y.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), y.current;
      },
      configurable: !0
    });
  });
  var P = ye({
    containerWidth: a.width,
    containerHeight: a.height
  }), j = _te(P, 2), T = j[0], I = j[1], R = Cw(function($, Z) {
    I(function(X) {
      var K = Math.round($), J = Math.round(Z);
      return X.containerWidth === K && X.containerHeight === J ? X : {
        containerWidth: K,
        containerHeight: J
      };
    });
  }, []);
  _e(function() {
    var $ = function(A) {
      var _, N = A[0].contentRect, M = N.width, S = N.height;
      R(M, S), (_ = O.current) === null || _ === void 0 || _.call(O, M, S);
    };
    v > 0 && ($ = xb($, v, {
      trailing: !0,
      leading: !1
    }));
    var Z = new ResizeObserver($), X = y.current.getBoundingClientRect(), K = X.width, J = X.height;
    return R(K, J), Z.observe(y.current), function() {
      Z.disconnect();
    };
  }, [R, v]);
  var F = Tr(function() {
    var $ = T.containerWidth, Z = T.containerHeight;
    if ($ < 0 || Z < 0)
      return null;
    Kr(Va(o) || Va(l), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, o, l), Kr(!r || r > 0, "The aspect(%s) must be greater than zero.", r);
    var X = Va(o) ? $ : o, K = Va(l) ? Z : l;
    r && r > 0 && (X ? K = X / r : K && (X = K * r), p && K > p && (K = p)), Kr(X > 0 || K > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, X, K, o, l, u, d, r);
    var J = !Array.isArray(h) && Nn(h.type).endsWith("Chart");
    return E.Children.map(h, function(ee) {
      return my.isElement(ee) ? /* @__PURE__ */ Rt(ee, sl({
        width: X,
        height: K
      }, J ? {
        style: sl({
          height: "100%",
          width: "100%",
          maxHeight: K,
          maxWidth: X
        }, ee.props.style)
      } : {})) : ee;
    });
  }, [r, h, l, p, d, u, T, o]);
  return /* @__PURE__ */ E.createElement("div", {
    id: g ? "".concat(g) : void 0,
    className: De("recharts-responsive-container", b),
    style: sl(sl({}, x), {}, {
      width: o,
      height: l,
      minWidth: u,
      minHeight: d,
      maxHeight: p
    }),
    ref: y
  }, F);
}), en = function(t) {
  return null;
};
en.displayName = "Cell";
function Zs(e) {
  "@babel/helpers - typeof";
  return Zs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zs(e);
}
function l8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function F0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? l8(Object(r), !0).forEach(function(n) {
      $te(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : l8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function $te(e, t, r) {
  return t = Nte(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Nte(e) {
  var t = Ite(e, "string");
  return Zs(t) == "symbol" ? t : t + "";
}
function Ite(e, t) {
  if (Zs(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Zs(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var gi = {
  widthCache: {},
  cacheCount: 0
}, Lte = 2e3, kte = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, c8 = "recharts_measurement_span";
function Rte(e) {
  var t = F0({}, e);
  return Object.keys(t).forEach(function(r) {
    t[r] || delete t[r];
  }), t;
}
var Os = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || kr.isSsr)
    return {
      width: 0,
      height: 0
    };
  var n = Rte(r), a = JSON.stringify({
    text: t,
    copyStyle: n
  });
  if (gi.widthCache[a])
    return gi.widthCache[a];
  try {
    var i = document.getElementById(c8);
    i || (i = document.createElement("span"), i.setAttribute("id", c8), i.setAttribute("aria-hidden", "true"), document.body.appendChild(i));
    var o = F0(F0({}, kte), n);
    Object.assign(i.style, o), i.textContent = "".concat(t);
    var s = i.getBoundingClientRect(), l = {
      width: s.width,
      height: s.height
    };
    return gi.widthCache[a] = l, ++gi.cacheCount > Lte && (gi.cacheCount = 0, gi.widthCache = {}), l;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, Bte = function(t) {
  return {
    top: t.top + window.scrollY - document.documentElement.clientTop,
    left: t.left + window.scrollX - document.documentElement.clientLeft
  };
};
function qs(e) {
  "@babel/helpers - typeof";
  return qs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qs(e);
}
function dc(e, t) {
  return Wte(e) || Fte(e, t) || Hte(e, t) || Vte();
}
function Vte() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Hte(e, t) {
  if (e) {
    if (typeof e == "string")
      return u8(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return u8(e, t);
  }
}
function u8(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Fte(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function Wte(e) {
  if (Array.isArray(e))
    return e;
}
function zte(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function f8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Zte(n.key), n);
  }
}
function Ute(e, t, r) {
  return t && f8(e.prototype, t), r && f8(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Zte(e) {
  var t = qte(e, "string");
  return qs(t) == "symbol" ? t : t + "";
}
function qte(e, t) {
  if (qs(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (qs(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var d8 = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, p8 = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, Gte = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, Yte = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, wb = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, Kte = Object.keys(wb), ji = "NaN";
function Xte(e, t) {
  return e * wb[t];
}
var ll = /* @__PURE__ */ function() {
  function e(t, r) {
    zte(this, e), this.num = t, this.unit = r, this.num = t, this.unit = r, Number.isNaN(t) && (this.unit = ""), r !== "" && !Gte.test(r) && (this.num = NaN, this.unit = ""), Kte.includes(r) && (this.num = Xte(t, r), this.unit = "px");
  }
  return Ute(e, [{
    key: "add",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num + r.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num - r.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num * r.num, this.unit || r.unit);
    }
  }, {
    key: "divide",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num / r.num, this.unit || r.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(r) {
      var n, a = (n = Yte.exec(r)) !== null && n !== void 0 ? n : [], i = dc(a, 3), o = i[1], s = i[2];
      return new e(parseFloat(o), s ?? "");
    }
  }]);
}();
function Ob(e) {
  if (e.includes(ji))
    return ji;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var r, n = (r = d8.exec(t)) !== null && r !== void 0 ? r : [], a = dc(n, 4), i = a[1], o = a[2], s = a[3], l = ll.parse(i ?? ""), c = ll.parse(s ?? ""), u = o === "*" ? l.multiply(c) : l.divide(c);
    if (u.isNaN())
      return ji;
    t = t.replace(d8, u.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var d, p = (d = p8.exec(t)) !== null && d !== void 0 ? d : [], h = dc(p, 4), m = h[1], v = h[2], g = h[3], b = ll.parse(m ?? ""), C = ll.parse(g ?? ""), w = v === "+" ? b.add(C) : b.subtract(C);
    if (w.isNaN())
      return ji;
    t = t.replace(p8, w.toString());
  }
  return t;
}
var h8 = /\(([^()]*)\)/;
function Qte(e) {
  for (var t = e; t.includes("("); ) {
    var r = h8.exec(t), n = dc(r, 2), a = n[1];
    t = t.replace(h8, Ob(a));
  }
  return t;
}
function Jte(e) {
  var t = e.replace(/\s+/g, "");
  return t = Qte(t), t = Ob(t), t;
}
function ere(e) {
  try {
    return Jte(e);
  } catch {
    return ji;
  }
}
function v3(e) {
  var t = ere(e.slice(5, -1));
  return t === ji ? "" : t;
}
var tre = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], rre = ["dx", "dy", "angle", "className", "breakAll"];
function W0() {
  return W0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, W0.apply(this, arguments);
}
function v8(e, t) {
  if (e == null)
    return {};
  var r = nre(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function nre(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function m8(e, t) {
  return sre(e) || ore(e, t) || ire(e, t) || are();
}
function are() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ire(e, t) {
  if (e) {
    if (typeof e == "string")
      return g8(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return g8(e, t);
  }
}
function g8(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function ore(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function sre(e) {
  if (Array.isArray(e))
    return e;
}
var Sb = /[ \f\n\r\t\v\u2028\u2029]+/, Pb = function(t) {
  var r = t.children, n = t.breakAll, a = t.style;
  try {
    var i = [];
    xe(r) || (n ? i = r.toString().split("") : i = r.toString().split(Sb));
    var o = i.map(function(l) {
      return {
        word: l,
        width: Os(l, a).width
      };
    }), s = n ? 0 : Os(" ", a).width;
    return {
      wordsWithComputedWidth: o,
      spaceWidth: s
    };
  } catch {
    return null;
  }
}, lre = function(t, r, n, a, i) {
  var o = t.maxLines, s = t.children, l = t.style, c = t.breakAll, u = oe(o), d = s, p = function() {
    var X = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return X.reduce(function(K, J) {
      var ee = J.word, A = J.width, _ = K[K.length - 1];
      if (_ && (a == null || i || _.width + A + n < Number(a)))
        _.words.push(ee), _.width += A + n;
      else {
        var N = {
          words: [ee],
          width: A
        };
        K.push(N);
      }
      return K;
    }, []);
  }, h = p(r), m = function(X) {
    return X.reduce(function(K, J) {
      return K.width > J.width ? K : J;
    });
  };
  if (!u)
    return h;
  for (var v = "…", g = function(X) {
    var K = d.slice(0, X), J = Pb({
      breakAll: c,
      style: l,
      children: K + v
    }).wordsWithComputedWidth, ee = p(J), A = ee.length > o || m(ee).width > Number(a);
    return [A, ee];
  }, b = 0, C = d.length - 1, w = 0, x; b <= C && w <= d.length - 1; ) {
    var y = Math.floor((b + C) / 2), O = y - 1, P = g(O), j = m8(P, 2), T = j[0], I = j[1], R = g(y), F = m8(R, 1), $ = F[0];
    if (!T && !$ && (b = y + 1), T && $ && (C = y - 1), !T && $) {
      x = I;
      break;
    }
    w++;
  }
  return x || h;
}, y8 = function(t) {
  var r = xe(t) ? [] : t.toString().split(Sb);
  return [{
    words: r
  }];
}, cre = function(t) {
  var r = t.width, n = t.scaleToFit, a = t.children, i = t.style, o = t.breakAll, s = t.maxLines;
  if ((r || n) && !kr.isSsr) {
    var l, c, u = Pb({
      breakAll: o,
      children: a,
      style: i
    });
    if (u) {
      var d = u.wordsWithComputedWidth, p = u.spaceWidth;
      l = d, c = p;
    } else
      return y8(a);
    return lre({
      breakAll: o,
      children: a,
      maxLines: s,
      style: i
    }, l, c, r, n);
  }
  return y8(a);
}, b8 = "#808080", Qa = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, a = t.y, i = a === void 0 ? 0 : a, o = t.lineHeight, s = o === void 0 ? "1em" : o, l = t.capHeight, c = l === void 0 ? "0.71em" : l, u = t.scaleToFit, d = u === void 0 ? !1 : u, p = t.textAnchor, h = p === void 0 ? "start" : p, m = t.verticalAnchor, v = m === void 0 ? "end" : m, g = t.fill, b = g === void 0 ? b8 : g, C = v8(t, tre), w = Tr(function() {
    return cre({
      breakAll: C.breakAll,
      children: C.children,
      maxLines: C.maxLines,
      scaleToFit: d,
      style: C.style,
      width: C.width
    });
  }, [C.breakAll, C.children, C.maxLines, d, C.style, C.width]), x = C.dx, y = C.dy, O = C.angle, P = C.className, j = C.breakAll, T = v8(C, rre);
  if (!Vt(n) || !Vt(i))
    return null;
  var I = n + (oe(x) ? x : 0), R = i + (oe(y) ? y : 0), F;
  switch (v) {
    case "start":
      F = v3("calc(".concat(c, ")"));
      break;
    case "middle":
      F = v3("calc(".concat((w.length - 1) / 2, " * -").concat(s, " + (").concat(c, " / 2))"));
      break;
    default:
      F = v3("calc(".concat(w.length - 1, " * -").concat(s, ")"));
      break;
  }
  var $ = [];
  if (d) {
    var Z = w[0].width, X = C.width;
    $.push("scale(".concat((oe(X) ? X / Z : 1) / Z, ")"));
  }
  return O && $.push("rotate(".concat(O, ", ").concat(I, ", ").concat(R, ")")), $.length && (T.transform = $.join(" ")), /* @__PURE__ */ E.createElement("text", W0({}, he(T, !0), {
    x: I,
    y: R,
    className: De("recharts-text", P),
    textAnchor: h,
    fill: b.includes("url") ? b8 : b
  }), w.map(function(K, J) {
    var ee = K.words.join(j ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ E.createElement("tspan", {
        x: I,
        dy: J === 0 ? F : s,
        key: "".concat(ee, "-").concat(J)
      }, ee)
    );
  }));
};
function na(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function ure(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function S6(e) {
  let t, r, n;
  e.length !== 2 ? (t = na, r = (s, l) => na(e(s), l), n = (s, l) => e(s) - l) : (t = e === na || e === ure ? e : fre, r = e, n = e);
  function a(s, l, c = 0, u = s.length) {
    if (c < u) {
      if (t(l, l) !== 0)
        return u;
      do {
        const d = c + u >>> 1;
        r(s[d], l) < 0 ? c = d + 1 : u = d;
      } while (c < u);
    }
    return c;
  }
  function i(s, l, c = 0, u = s.length) {
    if (c < u) {
      if (t(l, l) !== 0)
        return u;
      do {
        const d = c + u >>> 1;
        r(s[d], l) <= 0 ? c = d + 1 : u = d;
      } while (c < u);
    }
    return c;
  }
  function o(s, l, c = 0, u = s.length) {
    const d = a(s, l, c, u - 1);
    return d > c && n(s[d - 1], l) > -n(s[d], l) ? d - 1 : d;
  }
  return { left: a, center: o, right: i };
}
function fre() {
  return 0;
}
function Eb(e) {
  return e === null ? NaN : +e;
}
function* dre(e, t) {
  if (t === void 0)
    for (let r of e)
      r != null && (r = +r) >= r && (yield r);
  else {
    let r = -1;
    for (let n of e)
      (n = t(n, ++r, e)) != null && (n = +n) >= n && (yield n);
  }
}
const pre = S6(na), hre = pre.right;
S6(Eb).center;
const B1 = hre;
class C8 extends Map {
  constructor(t, r = gre) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: r } }), t != null)
      for (const [n, a] of t)
        this.set(n, a);
  }
  get(t) {
    return super.get(x8(this, t));
  }
  has(t) {
    return super.has(x8(this, t));
  }
  set(t, r) {
    return super.set(vre(this, t), r);
  }
  delete(t) {
    return super.delete(mre(this, t));
  }
}
function x8({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : r;
}
function vre({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : (e.set(n, r), r);
}
function mre({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) && (r = e.get(n), e.delete(n)), r;
}
function gre(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function yre(e = na) {
  if (e === na)
    return jb;
  if (typeof e != "function")
    throw new TypeError("compare is not a function");
  return (t, r) => {
    const n = e(t, r);
    return n || n === 0 ? n : (e(r, r) === 0) - (e(t, t) === 0);
  };
}
function jb(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const bre = Math.sqrt(50), Cre = Math.sqrt(10), xre = Math.sqrt(2);
function pc(e, t, r) {
  const n = (t - e) / Math.max(0, r), a = Math.floor(Math.log10(n)), i = n / Math.pow(10, a), o = i >= bre ? 10 : i >= Cre ? 5 : i >= xre ? 2 : 1;
  let s, l, c;
  return a < 0 ? (c = Math.pow(10, -a) / o, s = Math.round(e * c), l = Math.round(t * c), s / c < e && ++s, l / c > t && --l, c = -c) : (c = Math.pow(10, a) * o, s = Math.round(e / c), l = Math.round(t / c), s * c < e && ++s, l * c > t && --l), l < s && 0.5 <= r && r < 2 ? pc(e, t, r * 2) : [s, l, c];
}
function z0(e, t, r) {
  if (t = +t, e = +e, r = +r, !(r > 0))
    return [];
  if (e === t)
    return [e];
  const n = t < e, [a, i, o] = n ? pc(t, e, r) : pc(e, t, r);
  if (!(i >= a))
    return [];
  const s = i - a + 1, l = new Array(s);
  if (n)
    if (o < 0)
      for (let c = 0; c < s; ++c)
        l[c] = (i - c) / -o;
    else
      for (let c = 0; c < s; ++c)
        l[c] = (i - c) * o;
  else if (o < 0)
    for (let c = 0; c < s; ++c)
      l[c] = (a + c) / -o;
  else
    for (let c = 0; c < s; ++c)
      l[c] = (a + c) * o;
  return l;
}
function U0(e, t, r) {
  return t = +t, e = +e, r = +r, pc(e, t, r)[2];
}
function Z0(e, t, r) {
  t = +t, e = +e, r = +r;
  const n = t < e, a = n ? U0(t, e, r) : U0(e, t, r);
  return (n ? -1 : 1) * (a < 0 ? 1 / -a : a);
}
function w8(e, t) {
  let r;
  if (t === void 0)
    for (const n of e)
      n != null && (r < n || r === void 0 && n >= n) && (r = n);
  else {
    let n = -1;
    for (let a of e)
      (a = t(a, ++n, e)) != null && (r < a || r === void 0 && a >= a) && (r = a);
  }
  return r;
}
function O8(e, t) {
  let r;
  if (t === void 0)
    for (const n of e)
      n != null && (r > n || r === void 0 && n >= n) && (r = n);
  else {
    let n = -1;
    for (let a of e)
      (a = t(a, ++n, e)) != null && (r > a || r === void 0 && a >= a) && (r = a);
  }
  return r;
}
function _b(e, t, r = 0, n = 1 / 0, a) {
  if (t = Math.floor(t), r = Math.floor(Math.max(0, r)), n = Math.floor(Math.min(e.length - 1, n)), !(r <= t && t <= n))
    return e;
  for (a = a === void 0 ? jb : yre(a); n > r; ) {
    if (n - r > 600) {
      const l = n - r + 1, c = t - r + 1, u = Math.log(l), d = 0.5 * Math.exp(2 * u / 3), p = 0.5 * Math.sqrt(u * d * (l - d) / l) * (c - l / 2 < 0 ? -1 : 1), h = Math.max(r, Math.floor(t - c * d / l + p)), m = Math.min(n, Math.floor(t + (l - c) * d / l + p));
      _b(e, t, h, m, a);
    }
    const i = e[t];
    let o = r, s = n;
    for (Qo(e, r, t), a(e[n], i) > 0 && Qo(e, r, n); o < s; ) {
      for (Qo(e, o, s), ++o, --s; a(e[o], i) < 0; )
        ++o;
      for (; a(e[s], i) > 0; )
        --s;
    }
    a(e[r], i) === 0 ? Qo(e, r, s) : (++s, Qo(e, s, n)), s <= t && (r = s + 1), t <= s && (n = s - 1);
  }
  return e;
}
function Qo(e, t, r) {
  const n = e[t];
  e[t] = e[r], e[r] = n;
}
function wre(e, t, r) {
  if (e = Float64Array.from(dre(e, r)), !(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2)
      return O8(e);
    if (t >= 1)
      return w8(e);
    var n, a = (n - 1) * t, i = Math.floor(a), o = w8(_b(e, i).subarray(0, i + 1)), s = O8(e.subarray(i + 1));
    return o + (s - o) * (a - i);
  }
}
function Ore(e, t, r = Eb) {
  if (!(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2)
      return +r(e[0], 0, e);
    if (t >= 1)
      return +r(e[n - 1], n - 1, e);
    var n, a = (n - 1) * t, i = Math.floor(a), o = +r(e[i], i, e), s = +r(e[i + 1], i + 1, e);
    return o + (s - o) * (a - i);
  }
}
function Sre(e, t, r) {
  e = +e, t = +t, r = (a = arguments.length) < 2 ? (t = e, e = 0, 1) : a < 3 ? 1 : +r;
  for (var n = -1, a = Math.max(0, Math.ceil((t - e) / r)) | 0, i = new Array(a); ++n < a; )
    i[n] = e + n * r;
  return i;
}
function Fr(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function zn(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const q0 = Symbol("implicit");
function P6() {
  var e = new C8(), t = [], r = [], n = q0;
  function a(i) {
    let o = e.get(i);
    if (o === void 0) {
      if (n !== q0)
        return n;
      e.set(i, o = t.push(i) - 1);
    }
    return r[o % r.length];
  }
  return a.domain = function(i) {
    if (!arguments.length)
      return t.slice();
    t = [], e = new C8();
    for (const o of i)
      e.has(o) || e.set(o, t.push(o) - 1);
    return a;
  }, a.range = function(i) {
    return arguments.length ? (r = Array.from(i), a) : r.slice();
  }, a.unknown = function(i) {
    return arguments.length ? (n = i, a) : n;
  }, a.copy = function() {
    return P6(t, r).unknown(n);
  }, Fr.apply(a, arguments), a;
}
function Gs() {
  var e = P6().unknown(void 0), t = e.domain, r = e.range, n = 0, a = 1, i, o, s = !1, l = 0, c = 0, u = 0.5;
  delete e.unknown;
  function d() {
    var p = t().length, h = a < n, m = h ? a : n, v = h ? n : a;
    i = (v - m) / Math.max(1, p - l + c * 2), s && (i = Math.floor(i)), m += (v - m - i * (p - l)) * u, o = i * (1 - l), s && (m = Math.round(m), o = Math.round(o));
    var g = Sre(p).map(function(b) {
      return m + i * b;
    });
    return r(h ? g.reverse() : g);
  }
  return e.domain = function(p) {
    return arguments.length ? (t(p), d()) : t();
  }, e.range = function(p) {
    return arguments.length ? ([n, a] = p, n = +n, a = +a, d()) : [n, a];
  }, e.rangeRound = function(p) {
    return [n, a] = p, n = +n, a = +a, s = !0, d();
  }, e.bandwidth = function() {
    return o;
  }, e.step = function() {
    return i;
  }, e.round = function(p) {
    return arguments.length ? (s = !!p, d()) : s;
  }, e.padding = function(p) {
    return arguments.length ? (l = Math.min(1, c = +p), d()) : l;
  }, e.paddingInner = function(p) {
    return arguments.length ? (l = Math.min(1, p), d()) : l;
  }, e.paddingOuter = function(p) {
    return arguments.length ? (c = +p, d()) : c;
  }, e.align = function(p) {
    return arguments.length ? (u = Math.max(0, Math.min(1, p)), d()) : u;
  }, e.copy = function() {
    return Gs(t(), [n, a]).round(s).paddingInner(l).paddingOuter(c).align(u);
  }, Fr.apply(d(), arguments);
}
function Ab(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return Ab(t());
  }, e;
}
function Ss() {
  return Ab(Gs.apply(null, arguments).paddingInner(1));
}
function E6(e, t, r) {
  e.prototype = t.prototype = r, r.constructor = e;
}
function Db(e, t) {
  var r = Object.create(e.prototype);
  for (var n in t)
    r[n] = t[n];
  return r;
}
function V1() {
}
var Ys = 0.7, hc = 1 / Ys, Ii = "\\s*([+-]?\\d+)\\s*", Ks = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", hn = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Pre = /^#([0-9a-f]{3,8})$/, Ere = new RegExp(`^rgb\\(${Ii},${Ii},${Ii}\\)$`), jre = new RegExp(`^rgb\\(${hn},${hn},${hn}\\)$`), _re = new RegExp(`^rgba\\(${Ii},${Ii},${Ii},${Ks}\\)$`), Are = new RegExp(`^rgba\\(${hn},${hn},${hn},${Ks}\\)$`), Dre = new RegExp(`^hsl\\(${Ks},${hn},${hn}\\)$`), Mre = new RegExp(`^hsla\\(${Ks},${hn},${hn},${Ks}\\)$`), S8 = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
E6(V1, Xs, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: P8,
  // Deprecated! Use color.formatHex.
  formatHex: P8,
  formatHex8: Tre,
  formatHsl: $re,
  formatRgb: E8,
  toString: E8
});
function P8() {
  return this.rgb().formatHex();
}
function Tre() {
  return this.rgb().formatHex8();
}
function $re() {
  return Mb(this).formatHsl();
}
function E8() {
  return this.rgb().formatRgb();
}
function Xs(e) {
  var t, r;
  return e = (e + "").trim().toLowerCase(), (t = Pre.exec(e)) ? (r = t[1].length, t = parseInt(t[1], 16), r === 6 ? j8(t) : r === 3 ? new pr(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : r === 8 ? cl(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : r === 4 ? cl(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = Ere.exec(e)) ? new pr(t[1], t[2], t[3], 1) : (t = jre.exec(e)) ? new pr(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = _re.exec(e)) ? cl(t[1], t[2], t[3], t[4]) : (t = Are.exec(e)) ? cl(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = Dre.exec(e)) ? D8(t[1], t[2] / 100, t[3] / 100, 1) : (t = Mre.exec(e)) ? D8(t[1], t[2] / 100, t[3] / 100, t[4]) : S8.hasOwnProperty(e) ? j8(S8[e]) : e === "transparent" ? new pr(NaN, NaN, NaN, 0) : null;
}
function j8(e) {
  return new pr(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function cl(e, t, r, n) {
  return n <= 0 && (e = t = r = NaN), new pr(e, t, r, n);
}
function Nre(e) {
  return e instanceof V1 || (e = Xs(e)), e ? (e = e.rgb(), new pr(e.r, e.g, e.b, e.opacity)) : new pr();
}
function G0(e, t, r, n) {
  return arguments.length === 1 ? Nre(e) : new pr(e, t, r, n ?? 1);
}
function pr(e, t, r, n) {
  this.r = +e, this.g = +t, this.b = +r, this.opacity = +n;
}
E6(pr, G0, Db(V1, {
  brighter(e) {
    return e = e == null ? hc : Math.pow(hc, e), new pr(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Ys : Math.pow(Ys, e), new pr(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new pr(Ga(this.r), Ga(this.g), Ga(this.b), vc(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: _8,
  // Deprecated! Use color.formatHex.
  formatHex: _8,
  formatHex8: Ire,
  formatRgb: A8,
  toString: A8
}));
function _8() {
  return `#${Ha(this.r)}${Ha(this.g)}${Ha(this.b)}`;
}
function Ire() {
  return `#${Ha(this.r)}${Ha(this.g)}${Ha(this.b)}${Ha((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function A8() {
  const e = vc(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${Ga(this.r)}, ${Ga(this.g)}, ${Ga(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function vc(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function Ga(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Ha(e) {
  return e = Ga(e), (e < 16 ? "0" : "") + e.toString(16);
}
function D8(e, t, r, n) {
  return n <= 0 ? e = t = r = NaN : r <= 0 || r >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new qr(e, t, r, n);
}
function Mb(e) {
  if (e instanceof qr)
    return new qr(e.h, e.s, e.l, e.opacity);
  if (e instanceof V1 || (e = Xs(e)), !e)
    return new qr();
  if (e instanceof qr)
    return e;
  e = e.rgb();
  var t = e.r / 255, r = e.g / 255, n = e.b / 255, a = Math.min(t, r, n), i = Math.max(t, r, n), o = NaN, s = i - a, l = (i + a) / 2;
  return s ? (t === i ? o = (r - n) / s + (r < n) * 6 : r === i ? o = (n - t) / s + 2 : o = (t - r) / s + 4, s /= l < 0.5 ? i + a : 2 - i - a, o *= 60) : s = l > 0 && l < 1 ? 0 : o, new qr(o, s, l, e.opacity);
}
function Lre(e, t, r, n) {
  return arguments.length === 1 ? Mb(e) : new qr(e, t, r, n ?? 1);
}
function qr(e, t, r, n) {
  this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
}
E6(qr, Lre, Db(V1, {
  brighter(e) {
    return e = e == null ? hc : Math.pow(hc, e), new qr(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Ys : Math.pow(Ys, e), new qr(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < 0.5 ? r : 1 - r) * t, a = 2 * r - n;
    return new pr(
      m3(e >= 240 ? e - 240 : e + 120, a, n),
      m3(e, a, n),
      m3(e < 120 ? e + 240 : e - 120, a, n),
      this.opacity
    );
  },
  clamp() {
    return new qr(M8(this.h), ul(this.s), ul(this.l), vc(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = vc(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${M8(this.h)}, ${ul(this.s) * 100}%, ${ul(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function M8(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function ul(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function m3(e, t, r) {
  return (e < 60 ? t + (r - t) * e / 60 : e < 180 ? r : e < 240 ? t + (r - t) * (240 - e) / 60 : t) * 255;
}
const j6 = (e) => () => e;
function kre(e, t) {
  return function(r) {
    return e + r * t;
  };
}
function Rre(e, t, r) {
  return e = Math.pow(e, r), t = Math.pow(t, r) - e, r = 1 / r, function(n) {
    return Math.pow(e + n * t, r);
  };
}
function Bre(e) {
  return (e = +e) == 1 ? Tb : function(t, r) {
    return r - t ? Rre(t, r, e) : j6(isNaN(t) ? r : t);
  };
}
function Tb(e, t) {
  var r = t - e;
  return r ? kre(e, r) : j6(isNaN(e) ? t : e);
}
const T8 = function e(t) {
  var r = Bre(t);
  function n(a, i) {
    var o = r((a = G0(a)).r, (i = G0(i)).r), s = r(a.g, i.g), l = r(a.b, i.b), c = Tb(a.opacity, i.opacity);
    return function(u) {
      return a.r = o(u), a.g = s(u), a.b = l(u), a.opacity = c(u), a + "";
    };
  }
  return n.gamma = e, n;
}(1);
function Vre(e, t) {
  t || (t = []);
  var r = e ? Math.min(t.length, e.length) : 0, n = t.slice(), a;
  return function(i) {
    for (a = 0; a < r; ++a)
      n[a] = e[a] * (1 - i) + t[a] * i;
    return n;
  };
}
function Hre(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function Fre(e, t) {
  var r = t ? t.length : 0, n = e ? Math.min(r, e.length) : 0, a = new Array(n), i = new Array(r), o;
  for (o = 0; o < n; ++o)
    a[o] = Lo(e[o], t[o]);
  for (; o < r; ++o)
    i[o] = t[o];
  return function(s) {
    for (o = 0; o < n; ++o)
      i[o] = a[o](s);
    return i;
  };
}
function Wre(e, t) {
  var r = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(n) {
    return r.setTime(e * (1 - n) + t * n), r;
  };
}
function mc(e, t) {
  return e = +e, t = +t, function(r) {
    return e * (1 - r) + t * r;
  };
}
function zre(e, t) {
  var r = {}, n = {}, a;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (a in t)
    a in e ? r[a] = Lo(e[a], t[a]) : n[a] = t[a];
  return function(i) {
    for (a in r)
      n[a] = r[a](i);
    return n;
  };
}
var Y0 = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, g3 = new RegExp(Y0.source, "g");
function Ure(e) {
  return function() {
    return e;
  };
}
function Zre(e) {
  return function(t) {
    return e(t) + "";
  };
}
function qre(e, t) {
  var r = Y0.lastIndex = g3.lastIndex = 0, n, a, i, o = -1, s = [], l = [];
  for (e = e + "", t = t + ""; (n = Y0.exec(e)) && (a = g3.exec(t)); )
    (i = a.index) > r && (i = t.slice(r, i), s[o] ? s[o] += i : s[++o] = i), (n = n[0]) === (a = a[0]) ? s[o] ? s[o] += a : s[++o] = a : (s[++o] = null, l.push({ i: o, x: mc(n, a) })), r = g3.lastIndex;
  return r < t.length && (i = t.slice(r), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? l[0] ? Zre(l[0].x) : Ure(t) : (t = l.length, function(c) {
    for (var u = 0, d; u < t; ++u)
      s[(d = l[u]).i] = d.x(c);
    return s.join("");
  });
}
function Lo(e, t) {
  var r = typeof t, n;
  return t == null || r === "boolean" ? j6(t) : (r === "number" ? mc : r === "string" ? (n = Xs(t)) ? (t = n, T8) : qre : t instanceof Xs ? T8 : t instanceof Date ? Wre : Hre(t) ? Vre : Array.isArray(t) ? Fre : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? zre : mc)(e, t);
}
function _6(e, t) {
  return e = +e, t = +t, function(r) {
    return Math.round(e * (1 - r) + t * r);
  };
}
function Gre(e, t) {
  t === void 0 && (t = e, e = Lo);
  for (var r = 0, n = t.length - 1, a = t[0], i = new Array(n < 0 ? 0 : n); r < n; )
    i[r] = e(a, a = t[++r]);
  return function(o) {
    var s = Math.max(0, Math.min(n - 1, Math.floor(o *= n)));
    return i[s](o - s);
  };
}
function Yre(e) {
  return function() {
    return e;
  };
}
function gc(e) {
  return +e;
}
var $8 = [0, 1];
function or(e) {
  return e;
}
function K0(e, t) {
  return (t -= e = +e) ? function(r) {
    return (r - e) / t;
  } : Yre(isNaN(t) ? NaN : 0.5);
}
function Kre(e, t) {
  var r;
  return e > t && (r = e, e = t, t = r), function(n) {
    return Math.max(e, Math.min(t, n));
  };
}
function Xre(e, t, r) {
  var n = e[0], a = e[1], i = t[0], o = t[1];
  return a < n ? (n = K0(a, n), i = r(o, i)) : (n = K0(n, a), i = r(i, o)), function(s) {
    return i(n(s));
  };
}
function Qre(e, t, r) {
  var n = Math.min(e.length, t.length) - 1, a = new Array(n), i = new Array(n), o = -1;
  for (e[n] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++o < n; )
    a[o] = K0(e[o], e[o + 1]), i[o] = r(t[o], t[o + 1]);
  return function(s) {
    var l = B1(e, s, 1, n) - 1;
    return i[l](a[l](s));
  };
}
function H1(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function Lu() {
  var e = $8, t = $8, r = Lo, n, a, i, o = or, s, l, c;
  function u() {
    var p = Math.min(e.length, t.length);
    return o !== or && (o = Kre(e[0], e[p - 1])), s = p > 2 ? Qre : Xre, l = c = null, d;
  }
  function d(p) {
    return p == null || isNaN(p = +p) ? i : (l || (l = s(e.map(n), t, r)))(n(o(p)));
  }
  return d.invert = function(p) {
    return o(a((c || (c = s(t, e.map(n), mc)))(p)));
  }, d.domain = function(p) {
    return arguments.length ? (e = Array.from(p, gc), u()) : e.slice();
  }, d.range = function(p) {
    return arguments.length ? (t = Array.from(p), u()) : t.slice();
  }, d.rangeRound = function(p) {
    return t = Array.from(p), r = _6, u();
  }, d.clamp = function(p) {
    return arguments.length ? (o = p ? !0 : or, u()) : o !== or;
  }, d.interpolate = function(p) {
    return arguments.length ? (r = p, u()) : r;
  }, d.unknown = function(p) {
    return arguments.length ? (i = p, d) : i;
  }, function(p, h) {
    return n = p, a = h, u();
  };
}
function A6() {
  return Lu()(or, or);
}
function Jre(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function yc(e, t) {
  if ((r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0)
    return null;
  var r, n = e.slice(0, r);
  return [
    n.length > 1 ? n[0] + n.slice(2) : n,
    +e.slice(r + 1)
  ];
}
function Ki(e) {
  return e = yc(Math.abs(e)), e ? e[1] : NaN;
}
function ene(e, t) {
  return function(r, n) {
    for (var a = r.length, i = [], o = 0, s = e[0], l = 0; a > 0 && s > 0 && (l + s + 1 > n && (s = Math.max(1, n - l)), i.push(r.substring(a -= s, a + s)), !((l += s + 1) > n)); )
      s = e[o = (o + 1) % e.length];
    return i.reverse().join(t);
  };
}
function tne(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(r) {
      return e[+r];
    });
  };
}
var rne = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Qs(e) {
  if (!(t = rne.exec(e)))
    throw new Error("invalid format: " + e);
  var t;
  return new D6({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
Qs.prototype = D6.prototype;
function D6(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
D6.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function nne(e) {
  e:
    for (var t = e.length, r = 1, n = -1, a; r < t; ++r)
      switch (e[r]) {
        case ".":
          n = a = r;
          break;
        case "0":
          n === 0 && (n = r), a = r;
          break;
        default:
          if (!+e[r])
            break e;
          n > 0 && (n = 0);
          break;
      }
  return n > 0 ? e.slice(0, n) + e.slice(a + 1) : e;
}
var $b;
function ane(e, t) {
  var r = yc(e, t);
  if (!r)
    return e + "";
  var n = r[0], a = r[1], i = a - ($b = Math.max(-8, Math.min(8, Math.floor(a / 3))) * 3) + 1, o = n.length;
  return i === o ? n : i > o ? n + new Array(i - o + 1).join("0") : i > 0 ? n.slice(0, i) + "." + n.slice(i) : "0." + new Array(1 - i).join("0") + yc(e, Math.max(0, t + i - 1))[0];
}
function N8(e, t) {
  var r = yc(e, t);
  if (!r)
    return e + "";
  var n = r[0], a = r[1];
  return a < 0 ? "0." + new Array(-a).join("0") + n : n.length > a + 1 ? n.slice(0, a + 1) + "." + n.slice(a + 1) : n + new Array(a - n.length + 2).join("0");
}
const I8 = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: Jre,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => N8(e * 100, t),
  r: N8,
  s: ane,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function L8(e) {
  return e;
}
var k8 = Array.prototype.map, R8 = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function ine(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? L8 : ene(k8.call(e.grouping, Number), e.thousands + ""), r = e.currency === void 0 ? "" : e.currency[0] + "", n = e.currency === void 0 ? "" : e.currency[1] + "", a = e.decimal === void 0 ? "." : e.decimal + "", i = e.numerals === void 0 ? L8 : tne(k8.call(e.numerals, String)), o = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", l = e.nan === void 0 ? "NaN" : e.nan + "";
  function c(d) {
    d = Qs(d);
    var p = d.fill, h = d.align, m = d.sign, v = d.symbol, g = d.zero, b = d.width, C = d.comma, w = d.precision, x = d.trim, y = d.type;
    y === "n" ? (C = !0, y = "g") : I8[y] || (w === void 0 && (w = 12), x = !0, y = "g"), (g || p === "0" && h === "=") && (g = !0, p = "0", h = "=");
    var O = v === "$" ? r : v === "#" && /[boxX]/.test(y) ? "0" + y.toLowerCase() : "", P = v === "$" ? n : /[%p]/.test(y) ? o : "", j = I8[y], T = /[defgprs%]/.test(y);
    w = w === void 0 ? 6 : /[gprs]/.test(y) ? Math.max(1, Math.min(21, w)) : Math.max(0, Math.min(20, w));
    function I(R) {
      var F = O, $ = P, Z, X, K;
      if (y === "c")
        $ = j(R) + $, R = "";
      else {
        R = +R;
        var J = R < 0 || 1 / R < 0;
        if (R = isNaN(R) ? l : j(Math.abs(R), w), x && (R = nne(R)), J && +R == 0 && m !== "+" && (J = !1), F = (J ? m === "(" ? m : s : m === "-" || m === "(" ? "" : m) + F, $ = (y === "s" ? R8[8 + $b / 3] : "") + $ + (J && m === "(" ? ")" : ""), T) {
          for (Z = -1, X = R.length; ++Z < X; )
            if (K = R.charCodeAt(Z), 48 > K || K > 57) {
              $ = (K === 46 ? a + R.slice(Z + 1) : R.slice(Z)) + $, R = R.slice(0, Z);
              break;
            }
        }
      }
      C && !g && (R = t(R, 1 / 0));
      var ee = F.length + R.length + $.length, A = ee < b ? new Array(b - ee + 1).join(p) : "";
      switch (C && g && (R = t(A + R, A.length ? b - $.length : 1 / 0), A = ""), h) {
        case "<":
          R = F + R + $ + A;
          break;
        case "=":
          R = F + A + R + $;
          break;
        case "^":
          R = A.slice(0, ee = A.length >> 1) + F + R + $ + A.slice(ee);
          break;
        default:
          R = A + F + R + $;
          break;
      }
      return i(R);
    }
    return I.toString = function() {
      return d + "";
    }, I;
  }
  function u(d, p) {
    var h = c((d = Qs(d), d.type = "f", d)), m = Math.max(-8, Math.min(8, Math.floor(Ki(p) / 3))) * 3, v = Math.pow(10, -m), g = R8[8 + m / 3];
    return function(b) {
      return h(v * b) + g;
    };
  }
  return {
    format: c,
    formatPrefix: u
  };
}
var fl, M6, Nb;
one({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function one(e) {
  return fl = ine(e), M6 = fl.format, Nb = fl.formatPrefix, fl;
}
function sne(e) {
  return Math.max(0, -Ki(Math.abs(e)));
}
function lne(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Ki(t) / 3))) * 3 - Ki(Math.abs(e)));
}
function cne(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, Ki(t) - Ki(e)) + 1;
}
function Ib(e, t, r, n) {
  var a = Z0(e, t, r), i;
  switch (n = Qs(n ?? ",f"), n.type) {
    case "s": {
      var o = Math.max(Math.abs(e), Math.abs(t));
      return n.precision == null && !isNaN(i = lne(a, o)) && (n.precision = i), Nb(n, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(i = cne(a, Math.max(Math.abs(e), Math.abs(t)))) && (n.precision = i - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(i = sne(a)) && (n.precision = i - (n.type === "%") * 2);
      break;
    }
  }
  return M6(n);
}
function ya(e) {
  var t = e.domain;
  return e.ticks = function(r) {
    var n = t();
    return z0(n[0], n[n.length - 1], r ?? 10);
  }, e.tickFormat = function(r, n) {
    var a = t();
    return Ib(a[0], a[a.length - 1], r ?? 10, n);
  }, e.nice = function(r) {
    r == null && (r = 10);
    var n = t(), a = 0, i = n.length - 1, o = n[a], s = n[i], l, c, u = 10;
    for (s < o && (c = o, o = s, s = c, c = a, a = i, i = c); u-- > 0; ) {
      if (c = U0(o, s, r), c === l)
        return n[a] = o, n[i] = s, t(n);
      if (c > 0)
        o = Math.floor(o / c) * c, s = Math.ceil(s / c) * c;
      else if (c < 0)
        o = Math.ceil(o * c) / c, s = Math.floor(s * c) / c;
      else
        break;
      l = c;
    }
    return e;
  }, e;
}
function bc() {
  var e = A6();
  return e.copy = function() {
    return H1(e, bc());
  }, Fr.apply(e, arguments), ya(e);
}
function Lb(e) {
  var t;
  function r(n) {
    return n == null || isNaN(n = +n) ? t : n;
  }
  return r.invert = r, r.domain = r.range = function(n) {
    return arguments.length ? (e = Array.from(n, gc), r) : e.slice();
  }, r.unknown = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.copy = function() {
    return Lb(e).unknown(t);
  }, e = arguments.length ? Array.from(e, gc) : [0, 1], ya(r);
}
function kb(e, t) {
  e = e.slice();
  var r = 0, n = e.length - 1, a = e[r], i = e[n], o;
  return i < a && (o = r, r = n, n = o, o = a, a = i, i = o), e[r] = t.floor(a), e[n] = t.ceil(i), e;
}
function B8(e) {
  return Math.log(e);
}
function V8(e) {
  return Math.exp(e);
}
function une(e) {
  return -Math.log(-e);
}
function fne(e) {
  return -Math.exp(-e);
}
function dne(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function pne(e) {
  return e === 10 ? dne : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function hne(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function H8(e) {
  return (t, r) => -e(-t, r);
}
function T6(e) {
  const t = e(B8, V8), r = t.domain;
  let n = 10, a, i;
  function o() {
    return a = hne(n), i = pne(n), r()[0] < 0 ? (a = H8(a), i = H8(i), e(une, fne)) : e(B8, V8), t;
  }
  return t.base = function(s) {
    return arguments.length ? (n = +s, o()) : n;
  }, t.domain = function(s) {
    return arguments.length ? (r(s), o()) : r();
  }, t.ticks = (s) => {
    const l = r();
    let c = l[0], u = l[l.length - 1];
    const d = u < c;
    d && ([c, u] = [u, c]);
    let p = a(c), h = a(u), m, v;
    const g = s == null ? 10 : +s;
    let b = [];
    if (!(n % 1) && h - p < g) {
      if (p = Math.floor(p), h = Math.ceil(h), c > 0) {
        for (; p <= h; ++p)
          for (m = 1; m < n; ++m)
            if (v = p < 0 ? m / i(-p) : m * i(p), !(v < c)) {
              if (v > u)
                break;
              b.push(v);
            }
      } else
        for (; p <= h; ++p)
          for (m = n - 1; m >= 1; --m)
            if (v = p > 0 ? m / i(-p) : m * i(p), !(v < c)) {
              if (v > u)
                break;
              b.push(v);
            }
      b.length * 2 < g && (b = z0(c, u, g));
    } else
      b = z0(p, h, Math.min(h - p, g)).map(i);
    return d ? b.reverse() : b;
  }, t.tickFormat = (s, l) => {
    if (s == null && (s = 10), l == null && (l = n === 10 ? "s" : ","), typeof l != "function" && (!(n % 1) && (l = Qs(l)).precision == null && (l.trim = !0), l = M6(l)), s === 1 / 0)
      return l;
    const c = Math.max(1, n * s / t.ticks().length);
    return (u) => {
      let d = u / i(Math.round(a(u)));
      return d * n < n - 0.5 && (d *= n), d <= c ? l(u) : "";
    };
  }, t.nice = () => r(kb(r(), {
    floor: (s) => i(Math.floor(a(s))),
    ceil: (s) => i(Math.ceil(a(s)))
  })), t;
}
function Rb() {
  const e = T6(Lu()).domain([1, 10]);
  return e.copy = () => H1(e, Rb()).base(e.base()), Fr.apply(e, arguments), e;
}
function F8(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function W8(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function $6(e) {
  var t = 1, r = e(F8(t), W8(t));
  return r.constant = function(n) {
    return arguments.length ? e(F8(t = +n), W8(t)) : t;
  }, ya(r);
}
function Bb() {
  var e = $6(Lu());
  return e.copy = function() {
    return H1(e, Bb()).constant(e.constant());
  }, Fr.apply(e, arguments);
}
function z8(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function vne(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function mne(e) {
  return e < 0 ? -e * e : e * e;
}
function N6(e) {
  var t = e(or, or), r = 1;
  function n() {
    return r === 1 ? e(or, or) : r === 0.5 ? e(vne, mne) : e(z8(r), z8(1 / r));
  }
  return t.exponent = function(a) {
    return arguments.length ? (r = +a, n()) : r;
  }, ya(t);
}
function I6() {
  var e = N6(Lu());
  return e.copy = function() {
    return H1(e, I6()).exponent(e.exponent());
  }, Fr.apply(e, arguments), e;
}
function gne() {
  return I6.apply(null, arguments).exponent(0.5);
}
function U8(e) {
  return Math.sign(e) * e * e;
}
function yne(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function Vb() {
  var e = A6(), t = [0, 1], r = !1, n;
  function a(i) {
    var o = yne(e(i));
    return isNaN(o) ? n : r ? Math.round(o) : o;
  }
  return a.invert = function(i) {
    return e.invert(U8(i));
  }, a.domain = function(i) {
    return arguments.length ? (e.domain(i), a) : e.domain();
  }, a.range = function(i) {
    return arguments.length ? (e.range((t = Array.from(i, gc)).map(U8)), a) : t.slice();
  }, a.rangeRound = function(i) {
    return a.range(i).round(!0);
  }, a.round = function(i) {
    return arguments.length ? (r = !!i, a) : r;
  }, a.clamp = function(i) {
    return arguments.length ? (e.clamp(i), a) : e.clamp();
  }, a.unknown = function(i) {
    return arguments.length ? (n = i, a) : n;
  }, a.copy = function() {
    return Vb(e.domain(), t).round(r).clamp(e.clamp()).unknown(n);
  }, Fr.apply(a, arguments), ya(a);
}
function Hb() {
  var e = [], t = [], r = [], n;
  function a() {
    var o = 0, s = Math.max(1, t.length);
    for (r = new Array(s - 1); ++o < s; )
      r[o - 1] = Ore(e, o / s);
    return i;
  }
  function i(o) {
    return o == null || isNaN(o = +o) ? n : t[B1(r, o)];
  }
  return i.invertExtent = function(o) {
    var s = t.indexOf(o);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? r[s - 1] : e[0],
      s < r.length ? r[s] : e[e.length - 1]
    ];
  }, i.domain = function(o) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (let s of o)
      s != null && !isNaN(s = +s) && e.push(s);
    return e.sort(na), a();
  }, i.range = function(o) {
    return arguments.length ? (t = Array.from(o), a()) : t.slice();
  }, i.unknown = function(o) {
    return arguments.length ? (n = o, i) : n;
  }, i.quantiles = function() {
    return r.slice();
  }, i.copy = function() {
    return Hb().domain(e).range(t).unknown(n);
  }, Fr.apply(i, arguments);
}
function Fb() {
  var e = 0, t = 1, r = 1, n = [0.5], a = [0, 1], i;
  function o(l) {
    return l != null && l <= l ? a[B1(n, l, 0, r)] : i;
  }
  function s() {
    var l = -1;
    for (n = new Array(r); ++l < r; )
      n[l] = ((l + 1) * t - (l - r) * e) / (r + 1);
    return o;
  }
  return o.domain = function(l) {
    return arguments.length ? ([e, t] = l, e = +e, t = +t, s()) : [e, t];
  }, o.range = function(l) {
    return arguments.length ? (r = (a = Array.from(l)).length - 1, s()) : a.slice();
  }, o.invertExtent = function(l) {
    var c = a.indexOf(l);
    return c < 0 ? [NaN, NaN] : c < 1 ? [e, n[0]] : c >= r ? [n[r - 1], t] : [n[c - 1], n[c]];
  }, o.unknown = function(l) {
    return arguments.length && (i = l), o;
  }, o.thresholds = function() {
    return n.slice();
  }, o.copy = function() {
    return Fb().domain([e, t]).range(a).unknown(i);
  }, Fr.apply(ya(o), arguments);
}
function Wb() {
  var e = [0.5], t = [0, 1], r, n = 1;
  function a(i) {
    return i != null && i <= i ? t[B1(e, i, 0, n)] : r;
  }
  return a.domain = function(i) {
    return arguments.length ? (e = Array.from(i), n = Math.min(e.length, t.length - 1), a) : e.slice();
  }, a.range = function(i) {
    return arguments.length ? (t = Array.from(i), n = Math.min(e.length, t.length - 1), a) : t.slice();
  }, a.invertExtent = function(i) {
    var o = t.indexOf(i);
    return [e[o - 1], e[o]];
  }, a.unknown = function(i) {
    return arguments.length ? (r = i, a) : r;
  }, a.copy = function() {
    return Wb().domain(e).range(t).unknown(r);
  }, Fr.apply(a, arguments);
}
const y3 = /* @__PURE__ */ new Date(), b3 = /* @__PURE__ */ new Date();
function Ht(e, t, r, n) {
  function a(i) {
    return e(i = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+i)), i;
  }
  return a.floor = (i) => (e(i = /* @__PURE__ */ new Date(+i)), i), a.ceil = (i) => (e(i = new Date(i - 1)), t(i, 1), e(i), i), a.round = (i) => {
    const o = a(i), s = a.ceil(i);
    return i - o < s - i ? o : s;
  }, a.offset = (i, o) => (t(i = /* @__PURE__ */ new Date(+i), o == null ? 1 : Math.floor(o)), i), a.range = (i, o, s) => {
    const l = [];
    if (i = a.ceil(i), s = s == null ? 1 : Math.floor(s), !(i < o) || !(s > 0))
      return l;
    let c;
    do
      l.push(c = /* @__PURE__ */ new Date(+i)), t(i, s), e(i);
    while (c < i && i < o);
    return l;
  }, a.filter = (i) => Ht((o) => {
    if (o >= o)
      for (; e(o), !i(o); )
        o.setTime(o - 1);
  }, (o, s) => {
    if (o >= o)
      if (s < 0)
        for (; ++s <= 0; )
          for (; t(o, -1), !i(o); )
            ;
      else
        for (; --s >= 0; )
          for (; t(o, 1), !i(o); )
            ;
  }), r && (a.count = (i, o) => (y3.setTime(+i), b3.setTime(+o), e(y3), e(b3), Math.floor(r(y3, b3))), a.every = (i) => (i = Math.floor(i), !isFinite(i) || !(i > 0) ? null : i > 1 ? a.filter(n ? (o) => n(o) % i === 0 : (o) => a.count(0, o) % i === 0) : a)), a;
}
const Cc = Ht(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
Cc.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Ht((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, r) => {
  t.setTime(+t + r * e);
}, (t, r) => (r - t) / e) : Cc);
Cc.range;
const An = 1e3, Ir = An * 60, Dn = Ir * 60, Rn = Dn * 24, L6 = Rn * 7, Z8 = Rn * 30, C3 = Rn * 365, Fa = Ht((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * An);
}, (e, t) => (t - e) / An, (e) => e.getUTCSeconds());
Fa.range;
const k6 = Ht((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * An);
}, (e, t) => {
  e.setTime(+e + t * Ir);
}, (e, t) => (t - e) / Ir, (e) => e.getMinutes());
k6.range;
const R6 = Ht((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * Ir);
}, (e, t) => (t - e) / Ir, (e) => e.getUTCMinutes());
R6.range;
const B6 = Ht((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * An - e.getMinutes() * Ir);
}, (e, t) => {
  e.setTime(+e + t * Dn);
}, (e, t) => (t - e) / Dn, (e) => e.getHours());
B6.range;
const V6 = Ht((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * Dn);
}, (e, t) => (t - e) / Dn, (e) => e.getUTCHours());
V6.range;
const F1 = Ht(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * Ir) / Rn,
  (e) => e.getDate() - 1
);
F1.range;
const ku = Ht((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Rn, (e) => e.getUTCDate() - 1);
ku.range;
const zb = Ht((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Rn, (e) => Math.floor(e / Rn));
zb.range;
function ii(e) {
  return Ht((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setDate(t.getDate() + r * 7);
  }, (t, r) => (r - t - (r.getTimezoneOffset() - t.getTimezoneOffset()) * Ir) / L6);
}
const Ru = ii(0), xc = ii(1), bne = ii(2), Cne = ii(3), Xi = ii(4), xne = ii(5), wne = ii(6);
Ru.range;
xc.range;
bne.range;
Cne.range;
Xi.range;
xne.range;
wne.range;
function oi(e) {
  return Ht((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setUTCDate(t.getUTCDate() + r * 7);
  }, (t, r) => (r - t) / L6);
}
const Bu = oi(0), wc = oi(1), One = oi(2), Sne = oi(3), Qi = oi(4), Pne = oi(5), Ene = oi(6);
Bu.range;
wc.range;
One.range;
Sne.range;
Qi.range;
Pne.range;
Ene.range;
const H6 = Ht((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
H6.range;
const F6 = Ht((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
F6.range;
const Bn = Ht((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Bn.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Ht((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, r) => {
  t.setFullYear(t.getFullYear() + r * e);
});
Bn.range;
const Vn = Ht((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
Vn.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Ht((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, r) => {
  t.setUTCFullYear(t.getUTCFullYear() + r * e);
});
Vn.range;
function Ub(e, t, r, n, a, i) {
  const o = [
    [Fa, 1, An],
    [Fa, 5, 5 * An],
    [Fa, 15, 15 * An],
    [Fa, 30, 30 * An],
    [i, 1, Ir],
    [i, 5, 5 * Ir],
    [i, 15, 15 * Ir],
    [i, 30, 30 * Ir],
    [a, 1, Dn],
    [a, 3, 3 * Dn],
    [a, 6, 6 * Dn],
    [a, 12, 12 * Dn],
    [n, 1, Rn],
    [n, 2, 2 * Rn],
    [r, 1, L6],
    [t, 1, Z8],
    [t, 3, 3 * Z8],
    [e, 1, C3]
  ];
  function s(c, u, d) {
    const p = u < c;
    p && ([c, u] = [u, c]);
    const h = d && typeof d.range == "function" ? d : l(c, u, d), m = h ? h.range(c, +u + 1) : [];
    return p ? m.reverse() : m;
  }
  function l(c, u, d) {
    const p = Math.abs(u - c) / d, h = S6(([, , g]) => g).right(o, p);
    if (h === o.length)
      return e.every(Z0(c / C3, u / C3, d));
    if (h === 0)
      return Cc.every(Math.max(Z0(c, u, d), 1));
    const [m, v] = o[p / o[h - 1][2] < o[h][2] / p ? h - 1 : h];
    return m.every(v);
  }
  return [s, l];
}
const [jne, _ne] = Ub(Vn, F6, Bu, zb, V6, R6), [Ane, Dne] = Ub(Bn, H6, Ru, F1, B6, k6);
function x3(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function w3(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Jo(e, t, r) {
  return { y: e, m: t, d: r, H: 0, M: 0, S: 0, L: 0 };
}
function Mne(e) {
  var t = e.dateTime, r = e.date, n = e.time, a = e.periods, i = e.days, o = e.shortDays, s = e.months, l = e.shortMonths, c = es(a), u = ts(a), d = es(i), p = ts(i), h = es(o), m = ts(o), v = es(s), g = ts(s), b = es(l), C = ts(l), w = {
    a: J,
    A: ee,
    b: A,
    B: _,
    c: null,
    d: Q8,
    e: Q8,
    f: eae,
    g: uae,
    G: dae,
    H: Xne,
    I: Qne,
    j: Jne,
    L: Zb,
    m: tae,
    M: rae,
    p: N,
    q: M,
    Q: t9,
    s: r9,
    S: nae,
    u: aae,
    U: iae,
    V: oae,
    w: sae,
    W: lae,
    x: null,
    X: null,
    y: cae,
    Y: fae,
    Z: pae,
    "%": e9
  }, x = {
    a: S,
    A: B,
    b: G,
    B: U,
    c: null,
    d: J8,
    e: J8,
    f: gae,
    g: jae,
    G: Aae,
    H: hae,
    I: vae,
    j: mae,
    L: Gb,
    m: yae,
    M: bae,
    p: H,
    q: k,
    Q: t9,
    s: r9,
    S: Cae,
    u: xae,
    U: wae,
    V: Oae,
    w: Sae,
    W: Pae,
    x: null,
    X: null,
    y: Eae,
    Y: _ae,
    Z: Dae,
    "%": e9
  }, y = {
    a: I,
    A: R,
    b: F,
    B: $,
    c: Z,
    d: K8,
    e: K8,
    f: qne,
    g: Y8,
    G: G8,
    H: X8,
    I: X8,
    j: Wne,
    L: Zne,
    m: Fne,
    M: zne,
    p: T,
    q: Hne,
    Q: Yne,
    s: Kne,
    S: Une,
    u: Lne,
    U: kne,
    V: Rne,
    w: Ine,
    W: Bne,
    x: X,
    X: K,
    y: Y8,
    Y: G8,
    Z: Vne,
    "%": Gne
  };
  w.x = O(r, w), w.X = O(n, w), w.c = O(t, w), x.x = O(r, x), x.X = O(n, x), x.c = O(t, x);
  function O(L, W) {
    return function(V) {
      var D = [], Q = -1, z = 0, te = L.length, ne, ae, se;
      for (V instanceof Date || (V = /* @__PURE__ */ new Date(+V)); ++Q < te; )
        L.charCodeAt(Q) === 37 && (D.push(L.slice(z, Q)), (ae = q8[ne = L.charAt(++Q)]) != null ? ne = L.charAt(++Q) : ae = ne === "e" ? " " : "0", (se = W[ne]) && (ne = se(V, ae)), D.push(ne), z = Q + 1);
      return D.push(L.slice(z, Q)), D.join("");
    };
  }
  function P(L, W) {
    return function(V) {
      var D = Jo(1900, void 0, 1), Q = j(D, L, V += "", 0), z, te;
      if (Q != V.length)
        return null;
      if ("Q" in D)
        return new Date(D.Q);
      if ("s" in D)
        return new Date(D.s * 1e3 + ("L" in D ? D.L : 0));
      if (W && !("Z" in D) && (D.Z = 0), "p" in D && (D.H = D.H % 12 + D.p * 12), D.m === void 0 && (D.m = "q" in D ? D.q : 0), "V" in D) {
        if (D.V < 1 || D.V > 53)
          return null;
        "w" in D || (D.w = 1), "Z" in D ? (z = w3(Jo(D.y, 0, 1)), te = z.getUTCDay(), z = te > 4 || te === 0 ? wc.ceil(z) : wc(z), z = ku.offset(z, (D.V - 1) * 7), D.y = z.getUTCFullYear(), D.m = z.getUTCMonth(), D.d = z.getUTCDate() + (D.w + 6) % 7) : (z = x3(Jo(D.y, 0, 1)), te = z.getDay(), z = te > 4 || te === 0 ? xc.ceil(z) : xc(z), z = F1.offset(z, (D.V - 1) * 7), D.y = z.getFullYear(), D.m = z.getMonth(), D.d = z.getDate() + (D.w + 6) % 7);
      } else
        ("W" in D || "U" in D) && ("w" in D || (D.w = "u" in D ? D.u % 7 : "W" in D ? 1 : 0), te = "Z" in D ? w3(Jo(D.y, 0, 1)).getUTCDay() : x3(Jo(D.y, 0, 1)).getDay(), D.m = 0, D.d = "W" in D ? (D.w + 6) % 7 + D.W * 7 - (te + 5) % 7 : D.w + D.U * 7 - (te + 6) % 7);
      return "Z" in D ? (D.H += D.Z / 100 | 0, D.M += D.Z % 100, w3(D)) : x3(D);
    };
  }
  function j(L, W, V, D) {
    for (var Q = 0, z = W.length, te = V.length, ne, ae; Q < z; ) {
      if (D >= te)
        return -1;
      if (ne = W.charCodeAt(Q++), ne === 37) {
        if (ne = W.charAt(Q++), ae = y[ne in q8 ? W.charAt(Q++) : ne], !ae || (D = ae(L, V, D)) < 0)
          return -1;
      } else if (ne != V.charCodeAt(D++))
        return -1;
    }
    return D;
  }
  function T(L, W, V) {
    var D = c.exec(W.slice(V));
    return D ? (L.p = u.get(D[0].toLowerCase()), V + D[0].length) : -1;
  }
  function I(L, W, V) {
    var D = h.exec(W.slice(V));
    return D ? (L.w = m.get(D[0].toLowerCase()), V + D[0].length) : -1;
  }
  function R(L, W, V) {
    var D = d.exec(W.slice(V));
    return D ? (L.w = p.get(D[0].toLowerCase()), V + D[0].length) : -1;
  }
  function F(L, W, V) {
    var D = b.exec(W.slice(V));
    return D ? (L.m = C.get(D[0].toLowerCase()), V + D[0].length) : -1;
  }
  function $(L, W, V) {
    var D = v.exec(W.slice(V));
    return D ? (L.m = g.get(D[0].toLowerCase()), V + D[0].length) : -1;
  }
  function Z(L, W, V) {
    return j(L, t, W, V);
  }
  function X(L, W, V) {
    return j(L, r, W, V);
  }
  function K(L, W, V) {
    return j(L, n, W, V);
  }
  function J(L) {
    return o[L.getDay()];
  }
  function ee(L) {
    return i[L.getDay()];
  }
  function A(L) {
    return l[L.getMonth()];
  }
  function _(L) {
    return s[L.getMonth()];
  }
  function N(L) {
    return a[+(L.getHours() >= 12)];
  }
  function M(L) {
    return 1 + ~~(L.getMonth() / 3);
  }
  function S(L) {
    return o[L.getUTCDay()];
  }
  function B(L) {
    return i[L.getUTCDay()];
  }
  function G(L) {
    return l[L.getUTCMonth()];
  }
  function U(L) {
    return s[L.getUTCMonth()];
  }
  function H(L) {
    return a[+(L.getUTCHours() >= 12)];
  }
  function k(L) {
    return 1 + ~~(L.getUTCMonth() / 3);
  }
  return {
    format: function(L) {
      var W = O(L += "", w);
      return W.toString = function() {
        return L;
      }, W;
    },
    parse: function(L) {
      var W = P(L += "", !1);
      return W.toString = function() {
        return L;
      }, W;
    },
    utcFormat: function(L) {
      var W = O(L += "", x);
      return W.toString = function() {
        return L;
      }, W;
    },
    utcParse: function(L) {
      var W = P(L += "", !0);
      return W.toString = function() {
        return L;
      }, W;
    }
  };
}
var q8 = { "-": "", _: " ", 0: "0" }, qt = /^\s*\d+/, Tne = /^%/, $ne = /[\\^$*+?|[\]().{}]/g;
function ze(e, t, r) {
  var n = e < 0 ? "-" : "", a = (n ? -e : e) + "", i = a.length;
  return n + (i < r ? new Array(r - i + 1).join(t) + a : a);
}
function Nne(e) {
  return e.replace($ne, "\\$&");
}
function es(e) {
  return new RegExp("^(?:" + e.map(Nne).join("|") + ")", "i");
}
function ts(e) {
  return new Map(e.map((t, r) => [t.toLowerCase(), r]));
}
function Ine(e, t, r) {
  var n = qt.exec(t.slice(r, r + 1));
  return n ? (e.w = +n[0], r + n[0].length) : -1;
}
function Lne(e, t, r) {
  var n = qt.exec(t.slice(r, r + 1));
  return n ? (e.u = +n[0], r + n[0].length) : -1;
}
function kne(e, t, r) {
  var n = qt.exec(t.slice(r, r + 2));
  return n ? (e.U = +n[0], r + n[0].length) : -1;
}
function Rne(e, t, r) {
  var n = qt.exec(t.slice(r, r + 2));
  return n ? (e.V = +n[0], r + n[0].length) : -1;
}
function Bne(e, t, r) {
  var n = qt.exec(t.slice(r, r + 2));
  return n ? (e.W = +n[0], r + n[0].length) : -1;
}
function G8(e, t, r) {
  var n = qt.exec(t.slice(r, r + 4));
  return n ? (e.y = +n[0], r + n[0].length) : -1;
}
function Y8(e, t, r) {
  var n = qt.exec(t.slice(r, r + 2));
  return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
}
function Vne(e, t, r) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
  return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
}
function Hne(e, t, r) {
  var n = qt.exec(t.slice(r, r + 1));
  return n ? (e.q = n[0] * 3 - 3, r + n[0].length) : -1;
}
function Fne(e, t, r) {
  var n = qt.exec(t.slice(r, r + 2));
  return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
}
function K8(e, t, r) {
  var n = qt.exec(t.slice(r, r + 2));
  return n ? (e.d = +n[0], r + n[0].length) : -1;
}
function Wne(e, t, r) {
  var n = qt.exec(t.slice(r, r + 3));
  return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
}
function X8(e, t, r) {
  var n = qt.exec(t.slice(r, r + 2));
  return n ? (e.H = +n[0], r + n[0].length) : -1;
}
function zne(e, t, r) {
  var n = qt.exec(t.slice(r, r + 2));
  return n ? (e.M = +n[0], r + n[0].length) : -1;
}
function Une(e, t, r) {
  var n = qt.exec(t.slice(r, r + 2));
  return n ? (e.S = +n[0], r + n[0].length) : -1;
}
function Zne(e, t, r) {
  var n = qt.exec(t.slice(r, r + 3));
  return n ? (e.L = +n[0], r + n[0].length) : -1;
}
function qne(e, t, r) {
  var n = qt.exec(t.slice(r, r + 6));
  return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
}
function Gne(e, t, r) {
  var n = Tne.exec(t.slice(r, r + 1));
  return n ? r + n[0].length : -1;
}
function Yne(e, t, r) {
  var n = qt.exec(t.slice(r));
  return n ? (e.Q = +n[0], r + n[0].length) : -1;
}
function Kne(e, t, r) {
  var n = qt.exec(t.slice(r));
  return n ? (e.s = +n[0], r + n[0].length) : -1;
}
function Q8(e, t) {
  return ze(e.getDate(), t, 2);
}
function Xne(e, t) {
  return ze(e.getHours(), t, 2);
}
function Qne(e, t) {
  return ze(e.getHours() % 12 || 12, t, 2);
}
function Jne(e, t) {
  return ze(1 + F1.count(Bn(e), e), t, 3);
}
function Zb(e, t) {
  return ze(e.getMilliseconds(), t, 3);
}
function eae(e, t) {
  return Zb(e, t) + "000";
}
function tae(e, t) {
  return ze(e.getMonth() + 1, t, 2);
}
function rae(e, t) {
  return ze(e.getMinutes(), t, 2);
}
function nae(e, t) {
  return ze(e.getSeconds(), t, 2);
}
function aae(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function iae(e, t) {
  return ze(Ru.count(Bn(e) - 1, e), t, 2);
}
function qb(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? Xi(e) : Xi.ceil(e);
}
function oae(e, t) {
  return e = qb(e), ze(Xi.count(Bn(e), e) + (Bn(e).getDay() === 4), t, 2);
}
function sae(e) {
  return e.getDay();
}
function lae(e, t) {
  return ze(xc.count(Bn(e) - 1, e), t, 2);
}
function cae(e, t) {
  return ze(e.getFullYear() % 100, t, 2);
}
function uae(e, t) {
  return e = qb(e), ze(e.getFullYear() % 100, t, 2);
}
function fae(e, t) {
  return ze(e.getFullYear() % 1e4, t, 4);
}
function dae(e, t) {
  var r = e.getDay();
  return e = r >= 4 || r === 0 ? Xi(e) : Xi.ceil(e), ze(e.getFullYear() % 1e4, t, 4);
}
function pae(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + ze(t / 60 | 0, "0", 2) + ze(t % 60, "0", 2);
}
function J8(e, t) {
  return ze(e.getUTCDate(), t, 2);
}
function hae(e, t) {
  return ze(e.getUTCHours(), t, 2);
}
function vae(e, t) {
  return ze(e.getUTCHours() % 12 || 12, t, 2);
}
function mae(e, t) {
  return ze(1 + ku.count(Vn(e), e), t, 3);
}
function Gb(e, t) {
  return ze(e.getUTCMilliseconds(), t, 3);
}
function gae(e, t) {
  return Gb(e, t) + "000";
}
function yae(e, t) {
  return ze(e.getUTCMonth() + 1, t, 2);
}
function bae(e, t) {
  return ze(e.getUTCMinutes(), t, 2);
}
function Cae(e, t) {
  return ze(e.getUTCSeconds(), t, 2);
}
function xae(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function wae(e, t) {
  return ze(Bu.count(Vn(e) - 1, e), t, 2);
}
function Yb(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? Qi(e) : Qi.ceil(e);
}
function Oae(e, t) {
  return e = Yb(e), ze(Qi.count(Vn(e), e) + (Vn(e).getUTCDay() === 4), t, 2);
}
function Sae(e) {
  return e.getUTCDay();
}
function Pae(e, t) {
  return ze(wc.count(Vn(e) - 1, e), t, 2);
}
function Eae(e, t) {
  return ze(e.getUTCFullYear() % 100, t, 2);
}
function jae(e, t) {
  return e = Yb(e), ze(e.getUTCFullYear() % 100, t, 2);
}
function _ae(e, t) {
  return ze(e.getUTCFullYear() % 1e4, t, 4);
}
function Aae(e, t) {
  var r = e.getUTCDay();
  return e = r >= 4 || r === 0 ? Qi(e) : Qi.ceil(e), ze(e.getUTCFullYear() % 1e4, t, 4);
}
function Dae() {
  return "+0000";
}
function e9() {
  return "%";
}
function t9(e) {
  return +e;
}
function r9(e) {
  return Math.floor(+e / 1e3);
}
var yi, Kb, Xb;
Mae({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function Mae(e) {
  return yi = Mne(e), Kb = yi.format, yi.parse, Xb = yi.utcFormat, yi.utcParse, yi;
}
function Tae(e) {
  return new Date(e);
}
function $ae(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function W6(e, t, r, n, a, i, o, s, l, c) {
  var u = A6(), d = u.invert, p = u.domain, h = c(".%L"), m = c(":%S"), v = c("%I:%M"), g = c("%I %p"), b = c("%a %d"), C = c("%b %d"), w = c("%B"), x = c("%Y");
  function y(O) {
    return (l(O) < O ? h : s(O) < O ? m : o(O) < O ? v : i(O) < O ? g : n(O) < O ? a(O) < O ? b : C : r(O) < O ? w : x)(O);
  }
  return u.invert = function(O) {
    return new Date(d(O));
  }, u.domain = function(O) {
    return arguments.length ? p(Array.from(O, $ae)) : p().map(Tae);
  }, u.ticks = function(O) {
    var P = p();
    return e(P[0], P[P.length - 1], O ?? 10);
  }, u.tickFormat = function(O, P) {
    return P == null ? y : c(P);
  }, u.nice = function(O) {
    var P = p();
    return (!O || typeof O.range != "function") && (O = t(P[0], P[P.length - 1], O ?? 10)), O ? p(kb(P, O)) : u;
  }, u.copy = function() {
    return H1(u, W6(e, t, r, n, a, i, o, s, l, c));
  }, u;
}
function Nae() {
  return Fr.apply(W6(Ane, Dne, Bn, H6, Ru, F1, B6, k6, Fa, Kb).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function Iae() {
  return Fr.apply(W6(jne, _ne, Vn, F6, Bu, ku, V6, R6, Fa, Xb).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function Vu() {
  var e = 0, t = 1, r, n, a, i, o = or, s = !1, l;
  function c(d) {
    return d == null || isNaN(d = +d) ? l : o(a === 0 ? 0.5 : (d = (i(d) - r) * a, s ? Math.max(0, Math.min(1, d)) : d));
  }
  c.domain = function(d) {
    return arguments.length ? ([e, t] = d, r = i(e = +e), n = i(t = +t), a = r === n ? 0 : 1 / (n - r), c) : [e, t];
  }, c.clamp = function(d) {
    return arguments.length ? (s = !!d, c) : s;
  }, c.interpolator = function(d) {
    return arguments.length ? (o = d, c) : o;
  };
  function u(d) {
    return function(p) {
      var h, m;
      return arguments.length ? ([h, m] = p, o = d(h, m), c) : [o(0), o(1)];
    };
  }
  return c.range = u(Lo), c.rangeRound = u(_6), c.unknown = function(d) {
    return arguments.length ? (l = d, c) : l;
  }, function(d) {
    return i = d, r = d(e), n = d(t), a = r === n ? 0 : 1 / (n - r), c;
  };
}
function ba(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function Qb() {
  var e = ya(Vu()(or));
  return e.copy = function() {
    return ba(e, Qb());
  }, zn.apply(e, arguments);
}
function Jb() {
  var e = T6(Vu()).domain([1, 10]);
  return e.copy = function() {
    return ba(e, Jb()).base(e.base());
  }, zn.apply(e, arguments);
}
function eC() {
  var e = $6(Vu());
  return e.copy = function() {
    return ba(e, eC()).constant(e.constant());
  }, zn.apply(e, arguments);
}
function z6() {
  var e = N6(Vu());
  return e.copy = function() {
    return ba(e, z6()).exponent(e.exponent());
  }, zn.apply(e, arguments);
}
function Lae() {
  return z6.apply(null, arguments).exponent(0.5);
}
function tC() {
  var e = [], t = or;
  function r(n) {
    if (n != null && !isNaN(n = +n))
      return t((B1(e, n, 1) - 1) / (e.length - 1));
  }
  return r.domain = function(n) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (let a of n)
      a != null && !isNaN(a = +a) && e.push(a);
    return e.sort(na), r;
  }, r.interpolator = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.range = function() {
    return e.map((n, a) => t(a / (e.length - 1)));
  }, r.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (a, i) => wre(e, i / n));
  }, r.copy = function() {
    return tC(t).domain(e);
  }, zn.apply(r, arguments);
}
function Hu() {
  var e = 0, t = 0.5, r = 1, n = 1, a, i, o, s, l, c = or, u, d = !1, p;
  function h(v) {
    return isNaN(v = +v) ? p : (v = 0.5 + ((v = +u(v)) - i) * (n * v < n * i ? s : l), c(d ? Math.max(0, Math.min(1, v)) : v));
  }
  h.domain = function(v) {
    return arguments.length ? ([e, t, r] = v, a = u(e = +e), i = u(t = +t), o = u(r = +r), s = a === i ? 0 : 0.5 / (i - a), l = i === o ? 0 : 0.5 / (o - i), n = i < a ? -1 : 1, h) : [e, t, r];
  }, h.clamp = function(v) {
    return arguments.length ? (d = !!v, h) : d;
  }, h.interpolator = function(v) {
    return arguments.length ? (c = v, h) : c;
  };
  function m(v) {
    return function(g) {
      var b, C, w;
      return arguments.length ? ([b, C, w] = g, c = Gre(v, [b, C, w]), h) : [c(0), c(0.5), c(1)];
    };
  }
  return h.range = m(Lo), h.rangeRound = m(_6), h.unknown = function(v) {
    return arguments.length ? (p = v, h) : p;
  }, function(v) {
    return u = v, a = v(e), i = v(t), o = v(r), s = a === i ? 0 : 0.5 / (i - a), l = i === o ? 0 : 0.5 / (o - i), n = i < a ? -1 : 1, h;
  };
}
function rC() {
  var e = ya(Hu()(or));
  return e.copy = function() {
    return ba(e, rC());
  }, zn.apply(e, arguments);
}
function nC() {
  var e = T6(Hu()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return ba(e, nC()).base(e.base());
  }, zn.apply(e, arguments);
}
function aC() {
  var e = $6(Hu());
  return e.copy = function() {
    return ba(e, aC()).constant(e.constant());
  }, zn.apply(e, arguments);
}
function U6() {
  var e = N6(Hu());
  return e.copy = function() {
    return ba(e, U6()).exponent(e.exponent());
  }, zn.apply(e, arguments);
}
function kae() {
  return U6.apply(null, arguments).exponent(0.5);
}
const n9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: Gs,
  scaleDiverging: rC,
  scaleDivergingLog: nC,
  scaleDivergingPow: U6,
  scaleDivergingSqrt: kae,
  scaleDivergingSymlog: aC,
  scaleIdentity: Lb,
  scaleImplicit: q0,
  scaleLinear: bc,
  scaleLog: Rb,
  scaleOrdinal: P6,
  scalePoint: Ss,
  scalePow: I6,
  scaleQuantile: Hb,
  scaleQuantize: Fb,
  scaleRadial: Vb,
  scaleSequential: Qb,
  scaleSequentialLog: Jb,
  scaleSequentialPow: z6,
  scaleSequentialQuantile: tC,
  scaleSequentialSqrt: Lae,
  scaleSequentialSymlog: eC,
  scaleSqrt: gne,
  scaleSymlog: Bb,
  scaleThreshold: Wb,
  scaleTime: Nae,
  scaleUtc: Iae,
  tickFormat: Ib
}, Symbol.toStringTag, { value: "Module" }));
var Rae = jo;
function Bae(e, t, r) {
  for (var n = -1, a = e.length; ++n < a; ) {
    var i = e[n], o = t(i);
    if (o != null && (s === void 0 ? o === o && !Rae(o) : r(o, s)))
      var s = o, l = i;
  }
  return l;
}
var Fu = Bae;
function Vae(e, t) {
  return e > t;
}
var iC = Vae, Hae = Fu, Fae = iC, Wae = Io;
function zae(e) {
  return e && e.length ? Hae(e, Wae, Fae) : void 0;
}
var Uae = zae;
const Xn = /* @__PURE__ */ Ze(Uae);
function Zae(e, t) {
  return e < t;
}
var oC = Zae, qae = Fu, Gae = oC, Yae = Io;
function Kae(e) {
  return e && e.length ? qae(e, Yae, Gae) : void 0;
}
var Xae = Kae;
const Wu = /* @__PURE__ */ Ze(Xae);
var Qae = l6, Jae = wn, eie = hb, tie = vr;
function rie(e, t) {
  var r = tie(e) ? Qae : eie;
  return r(e, Jae(t));
}
var nie = rie, aie = db, iie = nie;
function oie(e, t) {
  return aie(iie(e, t), 1);
}
var sie = oie;
const lie = /* @__PURE__ */ Ze(sie);
var cie = C6;
function uie(e, t) {
  return cie(e, t);
}
var fie = uie;
const la = /* @__PURE__ */ Ze(fie);
var ko = 1e9, die = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, q6, bt = !0, Rr = "[DecimalError] ", Ya = Rr + "Invalid argument: ", Z6 = Rr + "Exponent out of range: ", Ro = Math.floor, Ia = Math.pow, pie = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, Cr, zt = 1e7, vt = 7, sC = 9007199254740991, Oc = Ro(sC / vt), de = {};
de.absoluteValue = de.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
de.comparedTo = de.cmp = function(e) {
  var t, r, n, a, i = this;
  if (e = new i.constructor(e), i.s !== e.s)
    return i.s || -e.s;
  if (i.e !== e.e)
    return i.e > e.e ^ i.s < 0 ? 1 : -1;
  for (n = i.d.length, a = e.d.length, t = 0, r = n < a ? n : a; t < r; ++t)
    if (i.d[t] !== e.d[t])
      return i.d[t] > e.d[t] ^ i.s < 0 ? 1 : -1;
  return n === a ? 0 : n > a ^ i.s < 0 ? 1 : -1;
};
de.decimalPlaces = de.dp = function() {
  var e = this, t = e.d.length - 1, r = (t - e.e) * vt;
  if (t = e.d[t], t)
    for (; t % 10 == 0; t /= 10)
      r--;
  return r < 0 ? 0 : r;
};
de.dividedBy = de.div = function(e) {
  return Ln(this, new this.constructor(e));
};
de.dividedToIntegerBy = de.idiv = function(e) {
  var t = this, r = t.constructor;
  return ct(Ln(t, new r(e), 0, 1), r.precision);
};
de.equals = de.eq = function(e) {
  return !this.cmp(e);
};
de.exponent = function() {
  return Nt(this);
};
de.greaterThan = de.gt = function(e) {
  return this.cmp(e) > 0;
};
de.greaterThanOrEqualTo = de.gte = function(e) {
  return this.cmp(e) >= 0;
};
de.isInteger = de.isint = function() {
  return this.e > this.d.length - 2;
};
de.isNegative = de.isneg = function() {
  return this.s < 0;
};
de.isPositive = de.ispos = function() {
  return this.s > 0;
};
de.isZero = function() {
  return this.s === 0;
};
de.lessThan = de.lt = function(e) {
  return this.cmp(e) < 0;
};
de.lessThanOrEqualTo = de.lte = function(e) {
  return this.cmp(e) < 1;
};
de.logarithm = de.log = function(e) {
  var t, r = this, n = r.constructor, a = n.precision, i = a + 5;
  if (e === void 0)
    e = new n(10);
  else if (e = new n(e), e.s < 1 || e.eq(Cr))
    throw Error(Rr + "NaN");
  if (r.s < 1)
    throw Error(Rr + (r.s ? "NaN" : "-Infinity"));
  return r.eq(Cr) ? new n(0) : (bt = !1, t = Ln(Js(r, i), Js(e, i), i), bt = !0, ct(t, a));
};
de.minus = de.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? uC(t, e) : lC(t, (e.s = -e.s, e));
};
de.modulo = de.mod = function(e) {
  var t, r = this, n = r.constructor, a = n.precision;
  if (e = new n(e), !e.s)
    throw Error(Rr + "NaN");
  return r.s ? (bt = !1, t = Ln(r, e, 0, 1).times(e), bt = !0, r.minus(t)) : ct(new n(r), a);
};
de.naturalExponential = de.exp = function() {
  return cC(this);
};
de.naturalLogarithm = de.ln = function() {
  return Js(this);
};
de.negated = de.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
de.plus = de.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? lC(t, e) : uC(t, (e.s = -e.s, e));
};
de.precision = de.sd = function(e) {
  var t, r, n, a = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0)
    throw Error(Ya + e);
  if (t = Nt(a) + 1, n = a.d.length - 1, r = n * vt + 1, n = a.d[n], n) {
    for (; n % 10 == 0; n /= 10)
      r--;
    for (n = a.d[0]; n >= 10; n /= 10)
      r++;
  }
  return e && t > r ? t : r;
};
de.squareRoot = de.sqrt = function() {
  var e, t, r, n, a, i, o, s = this, l = s.constructor;
  if (s.s < 1) {
    if (!s.s)
      return new l(0);
    throw Error(Rr + "NaN");
  }
  for (e = Nt(s), bt = !1, a = Math.sqrt(+s), a == 0 || a == 1 / 0 ? (t = dn(s.d), (t.length + e) % 2 == 0 && (t += "0"), a = Math.sqrt(t), e = Ro((e + 1) / 2) - (e < 0 || e % 2), a == 1 / 0 ? t = "5e" + e : (t = a.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), n = new l(t)) : n = new l(a.toString()), r = l.precision, a = o = r + 3; ; )
    if (i = n, n = i.plus(Ln(s, i, o + 2)).times(0.5), dn(i.d).slice(0, o) === (t = dn(n.d)).slice(0, o)) {
      if (t = t.slice(o - 3, o + 1), a == o && t == "4999") {
        if (ct(i, r + 1, 0), i.times(i).eq(s)) {
          n = i;
          break;
        }
      } else if (t != "9999")
        break;
      o += 4;
    }
  return bt = !0, ct(n, r);
};
de.times = de.mul = function(e) {
  var t, r, n, a, i, o, s, l, c, u = this, d = u.constructor, p = u.d, h = (e = new d(e)).d;
  if (!u.s || !e.s)
    return new d(0);
  for (e.s *= u.s, r = u.e + e.e, l = p.length, c = h.length, l < c && (i = p, p = h, h = i, o = l, l = c, c = o), i = [], o = l + c, n = o; n--; )
    i.push(0);
  for (n = c; --n >= 0; ) {
    for (t = 0, a = l + n; a > n; )
      s = i[a] + h[n] * p[a - n - 1] + t, i[a--] = s % zt | 0, t = s / zt | 0;
    i[a] = (i[a] + t) % zt | 0;
  }
  for (; !i[--o]; )
    i.pop();
  return t ? ++r : i.shift(), e.d = i, e.e = r, bt ? ct(e, d.precision) : e;
};
de.toDecimalPlaces = de.todp = function(e, t) {
  var r = this, n = r.constructor;
  return r = new n(r), e === void 0 ? r : (mn(e, 0, ko), t === void 0 ? t = n.rounding : mn(t, 0, 8), ct(r, e + Nt(r) + 1, t));
};
de.toExponential = function(e, t) {
  var r, n = this, a = n.constructor;
  return e === void 0 ? r = Ja(n, !0) : (mn(e, 0, ko), t === void 0 ? t = a.rounding : mn(t, 0, 8), n = ct(new a(n), e + 1, t), r = Ja(n, !0, e + 1)), r;
};
de.toFixed = function(e, t) {
  var r, n, a = this, i = a.constructor;
  return e === void 0 ? Ja(a) : (mn(e, 0, ko), t === void 0 ? t = i.rounding : mn(t, 0, 8), n = ct(new i(a), e + Nt(a) + 1, t), r = Ja(n.abs(), !1, e + Nt(n) + 1), a.isneg() && !a.isZero() ? "-" + r : r);
};
de.toInteger = de.toint = function() {
  var e = this, t = e.constructor;
  return ct(new t(e), Nt(e) + 1, t.rounding);
};
de.toNumber = function() {
  return +this;
};
de.toPower = de.pow = function(e) {
  var t, r, n, a, i, o, s = this, l = s.constructor, c = 12, u = +(e = new l(e));
  if (!e.s)
    return new l(Cr);
  if (s = new l(s), !s.s) {
    if (e.s < 1)
      throw Error(Rr + "Infinity");
    return s;
  }
  if (s.eq(Cr))
    return s;
  if (n = l.precision, e.eq(Cr))
    return ct(s, n);
  if (t = e.e, r = e.d.length - 1, o = t >= r, i = s.s, o) {
    if ((r = u < 0 ? -u : u) <= sC) {
      for (a = new l(Cr), t = Math.ceil(n / vt + 4), bt = !1; r % 2 && (a = a.times(s), i9(a.d, t)), r = Ro(r / 2), r !== 0; )
        s = s.times(s), i9(s.d, t);
      return bt = !0, e.s < 0 ? new l(Cr).div(a) : ct(a, n);
    }
  } else if (i < 0)
    throw Error(Rr + "NaN");
  return i = i < 0 && e.d[Math.max(t, r)] & 1 ? -1 : 1, s.s = 1, bt = !1, a = e.times(Js(s, n + c)), bt = !0, a = cC(a), a.s = i, a;
};
de.toPrecision = function(e, t) {
  var r, n, a = this, i = a.constructor;
  return e === void 0 ? (r = Nt(a), n = Ja(a, r <= i.toExpNeg || r >= i.toExpPos)) : (mn(e, 1, ko), t === void 0 ? t = i.rounding : mn(t, 0, 8), a = ct(new i(a), e, t), r = Nt(a), n = Ja(a, e <= r || r <= i.toExpNeg, e)), n;
};
de.toSignificantDigits = de.tosd = function(e, t) {
  var r = this, n = r.constructor;
  return e === void 0 ? (e = n.precision, t = n.rounding) : (mn(e, 1, ko), t === void 0 ? t = n.rounding : mn(t, 0, 8)), ct(new n(r), e, t);
};
de.toString = de.valueOf = de.val = de.toJSON = de[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = Nt(e), r = e.constructor;
  return Ja(e, t <= r.toExpNeg || t >= r.toExpPos);
};
function lC(e, t) {
  var r, n, a, i, o, s, l, c, u = e.constructor, d = u.precision;
  if (!e.s || !t.s)
    return t.s || (t = new u(e)), bt ? ct(t, d) : t;
  if (l = e.d, c = t.d, o = e.e, a = t.e, l = l.slice(), i = o - a, i) {
    for (i < 0 ? (n = l, i = -i, s = c.length) : (n = c, a = o, s = l.length), o = Math.ceil(d / vt), s = o > s ? o + 1 : s + 1, i > s && (i = s, n.length = 1), n.reverse(); i--; )
      n.push(0);
    n.reverse();
  }
  for (s = l.length, i = c.length, s - i < 0 && (i = s, n = c, c = l, l = n), r = 0; i; )
    r = (l[--i] = l[i] + c[i] + r) / zt | 0, l[i] %= zt;
  for (r && (l.unshift(r), ++a), s = l.length; l[--s] == 0; )
    l.pop();
  return t.d = l, t.e = a, bt ? ct(t, d) : t;
}
function mn(e, t, r) {
  if (e !== ~~e || e < t || e > r)
    throw Error(Ya + e);
}
function dn(e) {
  var t, r, n, a = e.length - 1, i = "", o = e[0];
  if (a > 0) {
    for (i += o, t = 1; t < a; t++)
      n = e[t] + "", r = vt - n.length, r && (i += Gn(r)), i += n;
    o = e[t], n = o + "", r = vt - n.length, r && (i += Gn(r));
  } else if (o === 0)
    return "0";
  for (; o % 10 === 0; )
    o /= 10;
  return i + o;
}
var Ln = function() {
  function e(n, a) {
    var i, o = 0, s = n.length;
    for (n = n.slice(); s--; )
      i = n[s] * a + o, n[s] = i % zt | 0, o = i / zt | 0;
    return o && n.unshift(o), n;
  }
  function t(n, a, i, o) {
    var s, l;
    if (i != o)
      l = i > o ? 1 : -1;
    else
      for (s = l = 0; s < i; s++)
        if (n[s] != a[s]) {
          l = n[s] > a[s] ? 1 : -1;
          break;
        }
    return l;
  }
  function r(n, a, i) {
    for (var o = 0; i--; )
      n[i] -= o, o = n[i] < a[i] ? 1 : 0, n[i] = o * zt + n[i] - a[i];
    for (; !n[0] && n.length > 1; )
      n.shift();
  }
  return function(n, a, i, o) {
    var s, l, c, u, d, p, h, m, v, g, b, C, w, x, y, O, P, j, T = n.constructor, I = n.s == a.s ? 1 : -1, R = n.d, F = a.d;
    if (!n.s)
      return new T(n);
    if (!a.s)
      throw Error(Rr + "Division by zero");
    for (l = n.e - a.e, P = F.length, y = R.length, h = new T(I), m = h.d = [], c = 0; F[c] == (R[c] || 0); )
      ++c;
    if (F[c] > (R[c] || 0) && --l, i == null ? C = i = T.precision : o ? C = i + (Nt(n) - Nt(a)) + 1 : C = i, C < 0)
      return new T(0);
    if (C = C / vt + 2 | 0, c = 0, P == 1)
      for (u = 0, F = F[0], C++; (c < y || u) && C--; c++)
        w = u * zt + (R[c] || 0), m[c] = w / F | 0, u = w % F | 0;
    else {
      for (u = zt / (F[0] + 1) | 0, u > 1 && (F = e(F, u), R = e(R, u), P = F.length, y = R.length), x = P, v = R.slice(0, P), g = v.length; g < P; )
        v[g++] = 0;
      j = F.slice(), j.unshift(0), O = F[0], F[1] >= zt / 2 && ++O;
      do
        u = 0, s = t(F, v, P, g), s < 0 ? (b = v[0], P != g && (b = b * zt + (v[1] || 0)), u = b / O | 0, u > 1 ? (u >= zt && (u = zt - 1), d = e(F, u), p = d.length, g = v.length, s = t(d, v, p, g), s == 1 && (u--, r(d, P < p ? j : F, p))) : (u == 0 && (s = u = 1), d = F.slice()), p = d.length, p < g && d.unshift(0), r(v, d, g), s == -1 && (g = v.length, s = t(F, v, P, g), s < 1 && (u++, r(v, P < g ? j : F, g))), g = v.length) : s === 0 && (u++, v = [0]), m[c++] = u, s && v[0] ? v[g++] = R[x] || 0 : (v = [R[x]], g = 1);
      while ((x++ < y || v[0] !== void 0) && C--);
    }
    return m[0] || m.shift(), h.e = l, ct(h, o ? i + Nt(h) + 1 : i);
  };
}();
function cC(e, t) {
  var r, n, a, i, o, s, l = 0, c = 0, u = e.constructor, d = u.precision;
  if (Nt(e) > 16)
    throw Error(Z6 + Nt(e));
  if (!e.s)
    return new u(Cr);
  for (t == null ? (bt = !1, s = d) : s = t, o = new u(0.03125); e.abs().gte(0.1); )
    e = e.times(o), c += 5;
  for (n = Math.log(Ia(2, c)) / Math.LN10 * 2 + 5 | 0, s += n, r = a = i = new u(Cr), u.precision = s; ; ) {
    if (a = ct(a.times(e), s), r = r.times(++l), o = i.plus(Ln(a, r, s)), dn(o.d).slice(0, s) === dn(i.d).slice(0, s)) {
      for (; c--; )
        i = ct(i.times(i), s);
      return u.precision = d, t == null ? (bt = !0, ct(i, d)) : i;
    }
    i = o;
  }
}
function Nt(e) {
  for (var t = e.e * vt, r = e.d[0]; r >= 10; r /= 10)
    t++;
  return t;
}
function O3(e, t, r) {
  if (t > e.LN10.sd())
    throw bt = !0, r && (e.precision = r), Error(Rr + "LN10 precision limit exceeded");
  return ct(new e(e.LN10), t);
}
function Gn(e) {
  for (var t = ""; e--; )
    t += "0";
  return t;
}
function Js(e, t) {
  var r, n, a, i, o, s, l, c, u, d = 1, p = 10, h = e, m = h.d, v = h.constructor, g = v.precision;
  if (h.s < 1)
    throw Error(Rr + (h.s ? "NaN" : "-Infinity"));
  if (h.eq(Cr))
    return new v(0);
  if (t == null ? (bt = !1, c = g) : c = t, h.eq(10))
    return t == null && (bt = !0), O3(v, c);
  if (c += p, v.precision = c, r = dn(m), n = r.charAt(0), i = Nt(h), Math.abs(i) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      h = h.times(e), r = dn(h.d), n = r.charAt(0), d++;
    i = Nt(h), n > 1 ? (h = new v("0." + r), i++) : h = new v(n + "." + r.slice(1));
  } else
    return l = O3(v, c + 2, g).times(i + ""), h = Js(new v(n + "." + r.slice(1)), c - p).plus(l), v.precision = g, t == null ? (bt = !0, ct(h, g)) : h;
  for (s = o = h = Ln(h.minus(Cr), h.plus(Cr), c), u = ct(h.times(h), c), a = 3; ; ) {
    if (o = ct(o.times(u), c), l = s.plus(Ln(o, new v(a), c)), dn(l.d).slice(0, c) === dn(s.d).slice(0, c))
      return s = s.times(2), i !== 0 && (s = s.plus(O3(v, c + 2, g).times(i + ""))), s = Ln(s, new v(d), c), v.precision = g, t == null ? (bt = !0, ct(s, g)) : s;
    s = l, a += 2;
  }
}
function a9(e, t) {
  var r, n, a;
  for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; )
    ++n;
  for (a = t.length; t.charCodeAt(a - 1) === 48; )
    --a;
  if (t = t.slice(n, a), t) {
    if (a -= n, r = r - n - 1, e.e = Ro(r / vt), e.d = [], n = (r + 1) % vt, r < 0 && (n += vt), n < a) {
      for (n && e.d.push(+t.slice(0, n)), a -= vt; n < a; )
        e.d.push(+t.slice(n, n += vt));
      t = t.slice(n), n = vt - t.length;
    } else
      n -= a;
    for (; n--; )
      t += "0";
    if (e.d.push(+t), bt && (e.e > Oc || e.e < -Oc))
      throw Error(Z6 + r);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function ct(e, t, r) {
  var n, a, i, o, s, l, c, u, d = e.d;
  for (o = 1, i = d[0]; i >= 10; i /= 10)
    o++;
  if (n = t - o, n < 0)
    n += vt, a = t, c = d[u = 0];
  else {
    if (u = Math.ceil((n + 1) / vt), i = d.length, u >= i)
      return e;
    for (c = i = d[u], o = 1; i >= 10; i /= 10)
      o++;
    n %= vt, a = n - vt + o;
  }
  if (r !== void 0 && (i = Ia(10, o - a - 1), s = c / i % 10 | 0, l = t < 0 || d[u + 1] !== void 0 || c % i, l = r < 4 ? (s || l) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (r == 4 || l || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (n > 0 ? a > 0 ? c / Ia(10, o - a) : 0 : d[u - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7))), t < 1 || !d[0])
    return l ? (i = Nt(e), d.length = 1, t = t - i - 1, d[0] = Ia(10, (vt - t % vt) % vt), e.e = Ro(-t / vt) || 0) : (d.length = 1, d[0] = e.e = e.s = 0), e;
  if (n == 0 ? (d.length = u, i = 1, u--) : (d.length = u + 1, i = Ia(10, vt - n), d[u] = a > 0 ? (c / Ia(10, o - a) % Ia(10, a) | 0) * i : 0), l)
    for (; ; )
      if (u == 0) {
        (d[0] += i) == zt && (d[0] = 1, ++e.e);
        break;
      } else {
        if (d[u] += i, d[u] != zt)
          break;
        d[u--] = 0, i = 1;
      }
  for (n = d.length; d[--n] === 0; )
    d.pop();
  if (bt && (e.e > Oc || e.e < -Oc))
    throw Error(Z6 + Nt(e));
  return e;
}
function uC(e, t) {
  var r, n, a, i, o, s, l, c, u, d, p = e.constructor, h = p.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new p(e), bt ? ct(t, h) : t;
  if (l = e.d, d = t.d, n = t.e, c = e.e, l = l.slice(), o = c - n, o) {
    for (u = o < 0, u ? (r = l, o = -o, s = d.length) : (r = d, n = c, s = l.length), a = Math.max(Math.ceil(h / vt), s) + 2, o > a && (o = a, r.length = 1), r.reverse(), a = o; a--; )
      r.push(0);
    r.reverse();
  } else {
    for (a = l.length, s = d.length, u = a < s, u && (s = a), a = 0; a < s; a++)
      if (l[a] != d[a]) {
        u = l[a] < d[a];
        break;
      }
    o = 0;
  }
  for (u && (r = l, l = d, d = r, t.s = -t.s), s = l.length, a = d.length - s; a > 0; --a)
    l[s++] = 0;
  for (a = d.length; a > o; ) {
    if (l[--a] < d[a]) {
      for (i = a; i && l[--i] === 0; )
        l[i] = zt - 1;
      --l[i], l[a] += zt;
    }
    l[a] -= d[a];
  }
  for (; l[--s] === 0; )
    l.pop();
  for (; l[0] === 0; l.shift())
    --n;
  return l[0] ? (t.d = l, t.e = n, bt ? ct(t, h) : t) : new p(0);
}
function Ja(e, t, r) {
  var n, a = Nt(e), i = dn(e.d), o = i.length;
  return t ? (r && (n = r - o) > 0 ? i = i.charAt(0) + "." + i.slice(1) + Gn(n) : o > 1 && (i = i.charAt(0) + "." + i.slice(1)), i = i + (a < 0 ? "e" : "e+") + a) : a < 0 ? (i = "0." + Gn(-a - 1) + i, r && (n = r - o) > 0 && (i += Gn(n))) : a >= o ? (i += Gn(a + 1 - o), r && (n = r - a - 1) > 0 && (i = i + "." + Gn(n))) : ((n = a + 1) < o && (i = i.slice(0, n) + "." + i.slice(n)), r && (n = r - o) > 0 && (a + 1 === o && (i += "."), i += Gn(n))), e.s < 0 ? "-" + i : i;
}
function i9(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function fC(e) {
  var t, r, n;
  function a(i) {
    var o = this;
    if (!(o instanceof a))
      return new a(i);
    if (o.constructor = a, i instanceof a) {
      o.s = i.s, o.e = i.e, o.d = (i = i.d) ? i.slice() : i;
      return;
    }
    if (typeof i == "number") {
      if (i * 0 !== 0)
        throw Error(Ya + i);
      if (i > 0)
        o.s = 1;
      else if (i < 0)
        i = -i, o.s = -1;
      else {
        o.s = 0, o.e = 0, o.d = [0];
        return;
      }
      if (i === ~~i && i < 1e7) {
        o.e = 0, o.d = [i];
        return;
      }
      return a9(o, i.toString());
    } else if (typeof i != "string")
      throw Error(Ya + i);
    if (i.charCodeAt(0) === 45 ? (i = i.slice(1), o.s = -1) : o.s = 1, pie.test(i))
      a9(o, i);
    else
      throw Error(Ya + i);
  }
  if (a.prototype = de, a.ROUND_UP = 0, a.ROUND_DOWN = 1, a.ROUND_CEIL = 2, a.ROUND_FLOOR = 3, a.ROUND_HALF_UP = 4, a.ROUND_HALF_DOWN = 5, a.ROUND_HALF_EVEN = 6, a.ROUND_HALF_CEIL = 7, a.ROUND_HALF_FLOOR = 8, a.clone = fC, a.config = a.set = hie, e === void 0 && (e = {}), e)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < n.length; )
      e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
  return a.config(e), a;
}
function hie(e) {
  if (!e || typeof e != "object")
    throw Error(Rr + "Object expected");
  var t, r, n, a = [
    "precision",
    1,
    ko,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < a.length; t += 3)
    if ((n = e[r = a[t]]) !== void 0)
      if (Ro(n) === n && n >= a[t + 1] && n <= a[t + 2])
        this[r] = n;
      else
        throw Error(Ya + r + ": " + n);
  if ((n = e[r = "LN10"]) !== void 0)
    if (n == Math.LN10)
      this[r] = new this(n);
    else
      throw Error(Ya + r + ": " + n);
  return this;
}
var q6 = fC(die);
Cr = new q6(1);
const ot = q6;
function vie(e) {
  return bie(e) || yie(e) || gie(e) || mie();
}
function mie() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gie(e, t) {
  if (e) {
    if (typeof e == "string")
      return X0(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return X0(e, t);
  }
}
function yie(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function bie(e) {
  if (Array.isArray(e))
    return X0(e);
}
function X0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var Cie = function(t) {
  return t;
}, dC = {
  "@@functional/placeholder": !0
}, pC = function(t) {
  return t === dC;
}, o9 = function(t) {
  return function r() {
    return arguments.length === 0 || arguments.length === 1 && pC(arguments.length <= 0 ? void 0 : arguments[0]) ? r : t.apply(void 0, arguments);
  };
}, xie = function e(t, r) {
  return t === 1 ? r : o9(function() {
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    var o = a.filter(function(s) {
      return s !== dC;
    }).length;
    return o >= t ? r.apply(void 0, a) : e(t - o, o9(function() {
      for (var s = arguments.length, l = new Array(s), c = 0; c < s; c++)
        l[c] = arguments[c];
      var u = a.map(function(d) {
        return pC(d) ? l.shift() : d;
      });
      return r.apply(void 0, vie(u).concat(l));
    }));
  });
}, zu = function(t) {
  return xie(t.length, t);
}, Q0 = function(t, r) {
  for (var n = [], a = t; a < r; ++a)
    n[a - t] = a;
  return n;
}, wie = zu(function(e, t) {
  return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(r) {
    return t[r];
  }).map(e);
}), Oie = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  if (!r.length)
    return Cie;
  var a = r.reverse(), i = a[0], o = a.slice(1);
  return function() {
    return o.reduce(function(s, l) {
      return l(s);
    }, i.apply(void 0, arguments));
  };
}, J0 = function(t) {
  return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
}, hC = function(t) {
  var r = null, n = null;
  return function() {
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r && i.every(function(s, l) {
      return s === r[l];
    }) || (r = i, n = t.apply(void 0, i)), n;
  };
};
function Sie(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new ot(e).abs().log(10).toNumber()) + 1, t;
}
function Pie(e, t, r) {
  for (var n = new ot(e), a = 0, i = []; n.lt(t) && a < 1e5; )
    i.push(n.toNumber()), n = n.add(r), a++;
  return i;
}
var Eie = zu(function(e, t, r) {
  var n = +e, a = +t;
  return n + r * (a - n);
}), jie = zu(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, (r - e) / n;
}), _ie = zu(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, Math.max(0, Math.min(1, (r - e) / n));
});
const Uu = {
  rangeStep: Pie,
  getDigitCount: Sie,
  interpolateNumber: Eie,
  uninterpolateNumber: jie,
  uninterpolateTruncation: _ie
};
function ef(e) {
  return Mie(e) || Die(e) || vC(e) || Aie();
}
function Aie() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Die(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function Mie(e) {
  if (Array.isArray(e))
    return tf(e);
}
function e1(e, t) {
  return Nie(e) || $ie(e, t) || vC(e, t) || Tie();
}
function Tie() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vC(e, t) {
  if (e) {
    if (typeof e == "string")
      return tf(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return tf(e, t);
  }
}
function tf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function $ie(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], n = !0, a = !1, i = void 0;
    try {
      for (var o = e[Symbol.iterator](), s; !(n = (s = o.next()).done) && (r.push(s.value), !(t && r.length === t)); n = !0)
        ;
    } catch (l) {
      a = !0, i = l;
    } finally {
      try {
        !n && o.return != null && o.return();
      } finally {
        if (a)
          throw i;
      }
    }
    return r;
  }
}
function Nie(e) {
  if (Array.isArray(e))
    return e;
}
function mC(e) {
  var t = e1(e, 2), r = t[0], n = t[1], a = r, i = n;
  return r > n && (a = n, i = r), [a, i];
}
function gC(e, t, r) {
  if (e.lte(0))
    return new ot(0);
  var n = Uu.getDigitCount(e.toNumber()), a = new ot(10).pow(n), i = e.div(a), o = n !== 1 ? 0.05 : 0.1, s = new ot(Math.ceil(i.div(o).toNumber())).add(r).mul(o), l = s.mul(a);
  return t ? l : new ot(Math.ceil(l));
}
function Iie(e, t, r) {
  var n = 1, a = new ot(e);
  if (!a.isint() && r) {
    var i = Math.abs(e);
    i < 1 ? (n = new ot(10).pow(Uu.getDigitCount(e) - 1), a = new ot(Math.floor(a.div(n).toNumber())).mul(n)) : i > 1 && (a = new ot(Math.floor(e)));
  } else
    e === 0 ? a = new ot(Math.floor((t - 1) / 2)) : r || (a = new ot(Math.floor(e)));
  var o = Math.floor((t - 1) / 2), s = Oie(wie(function(l) {
    return a.add(new ot(l - o).mul(n)).toNumber();
  }), Q0);
  return s(0, t);
}
function yC(e, t, r, n) {
  var a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((t - e) / (r - 1)))
    return {
      step: new ot(0),
      tickMin: new ot(0),
      tickMax: new ot(0)
    };
  var i = gC(new ot(t).sub(e).div(r - 1), n, a), o;
  e <= 0 && t >= 0 ? o = new ot(0) : (o = new ot(e).add(t).div(2), o = o.sub(new ot(o).mod(i)));
  var s = Math.ceil(o.sub(e).div(i).toNumber()), l = Math.ceil(new ot(t).sub(o).div(i).toNumber()), c = s + l + 1;
  return c > r ? yC(e, t, r, n, a + 1) : (c < r && (l = t > 0 ? l + (r - c) : l, s = t > 0 ? s : s + (r - c)), {
    step: i,
    tickMin: o.sub(new ot(s).mul(i)),
    tickMax: o.add(new ot(l).mul(i))
  });
}
function Lie(e) {
  var t = e1(e, 2), r = t[0], n = t[1], a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = Math.max(a, 2), s = mC([r, n]), l = e1(s, 2), c = l[0], u = l[1];
  if (c === -1 / 0 || u === 1 / 0) {
    var d = u === 1 / 0 ? [c].concat(ef(Q0(0, a - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(ef(Q0(0, a - 1).map(function() {
      return -1 / 0;
    })), [u]);
    return r > n ? J0(d) : d;
  }
  if (c === u)
    return Iie(c, a, i);
  var p = yC(c, u, o, i), h = p.step, m = p.tickMin, v = p.tickMax, g = Uu.rangeStep(m, v.add(new ot(0.1).mul(h)), h);
  return r > n ? J0(g) : g;
}
function kie(e, t) {
  var r = e1(e, 2), n = r[0], a = r[1], i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = mC([n, a]), s = e1(o, 2), l = s[0], c = s[1];
  if (l === -1 / 0 || c === 1 / 0)
    return [n, a];
  if (l === c)
    return [l];
  var u = Math.max(t, 2), d = gC(new ot(c).sub(l).div(u - 1), i, 0), p = [].concat(ef(Uu.rangeStep(new ot(l), new ot(c).sub(new ot(0.99).mul(d)), d)), [c]);
  return n > a ? J0(p) : p;
}
var Rie = hC(Lie), Bie = hC(kie), Vie = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function Ji(e) {
  "@babel/helpers - typeof";
  return Ji = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ji(e);
}
function Sc() {
  return Sc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Sc.apply(this, arguments);
}
function Hie(e, t) {
  return Uie(e) || zie(e, t) || Wie(e, t) || Fie();
}
function Fie() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Wie(e, t) {
  if (e) {
    if (typeof e == "string")
      return s9(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return s9(e, t);
  }
}
function s9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function zie(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function Uie(e) {
  if (Array.isArray(e))
    return e;
}
function Zie(e, t) {
  if (e == null)
    return {};
  var r = qie(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function qie(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function Gie(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function l9(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, xC(n.key), n);
  }
}
function Yie(e, t, r) {
  return t && l9(e.prototype, t), r && l9(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Kie(e, t, r) {
  return t = Pc(t), Xie(e, bC() ? Reflect.construct(t, r || [], Pc(e).constructor) : t.apply(e, r));
}
function Xie(e, t) {
  if (t && (Ji(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Qie(e);
}
function Qie(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function bC() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (bC = function() {
    return !!e;
  })();
}
function Pc(e) {
  return Pc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Pc(e);
}
function Jie(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && rf(e, t);
}
function rf(e, t) {
  return rf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, rf(e, t);
}
function CC(e, t, r) {
  return t = xC(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function xC(e) {
  var t = eoe(e, "string");
  return Ji(t) == "symbol" ? t : t + "";
}
function eoe(e, t) {
  if (Ji(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ji(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Bo = /* @__PURE__ */ function(e) {
  function t() {
    return Gie(this, t), Kie(this, t, arguments);
  }
  return Jie(t, e), Yie(t, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.offset, i = n.layout, o = n.width, s = n.dataKey, l = n.data, c = n.dataPointFormatter, u = n.xAxis, d = n.yAxis, p = Zie(n, Vie), h = he(p, !1);
      this.props.direction === "x" && u.type !== "number" && (process.env.NODE_ENV !== "production" ? Qt(!1, 'ErrorBar requires Axis type property to be "number".') : Qt(!1));
      var m = l.map(function(v) {
        var g = c(v, s), b = g.x, C = g.y, w = g.value, x = g.errorVal;
        if (!x)
          return null;
        var y = [], O, P;
        if (Array.isArray(x)) {
          var j = Hie(x, 2);
          O = j[0], P = j[1];
        } else
          O = P = x;
        if (i === "vertical") {
          var T = u.scale, I = C + a, R = I + o, F = I - o, $ = T(w - O), Z = T(w + P);
          y.push({
            x1: Z,
            y1: R,
            x2: Z,
            y2: F
          }), y.push({
            x1: $,
            y1: I,
            x2: Z,
            y2: I
          }), y.push({
            x1: $,
            y1: R,
            x2: $,
            y2: F
          });
        } else if (i === "horizontal") {
          var X = d.scale, K = b + a, J = K - o, ee = K + o, A = X(w - O), _ = X(w + P);
          y.push({
            x1: J,
            y1: _,
            x2: ee,
            y2: _
          }), y.push({
            x1: K,
            y1: A,
            x2: K,
            y2: _
          }), y.push({
            x1: J,
            y1: A,
            x2: ee,
            y2: A
          });
        }
        return /* @__PURE__ */ E.createElement(Me, Sc({
          className: "recharts-errorBar",
          key: "bar-".concat(y.map(function(N) {
            return "".concat(N.x1, "-").concat(N.x2, "-").concat(N.y1, "-").concat(N.y2);
          }))
        }, h), y.map(function(N) {
          return /* @__PURE__ */ E.createElement("line", Sc({}, N, {
            key: "line-".concat(N.x1, "-").concat(N.x2, "-").concat(N.y1, "-").concat(N.y2)
          }));
        }));
      });
      return /* @__PURE__ */ E.createElement(Me, {
        className: "recharts-errorBars"
      }, m);
    }
  }]);
}(E.Component);
CC(Bo, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
CC(Bo, "displayName", "ErrorBar");
function t1(e) {
  "@babel/helpers - typeof";
  return t1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, t1(e);
}
function c9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ea(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? c9(Object(r), !0).forEach(function(n) {
      toe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : c9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function toe(e, t, r) {
  return t = roe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function roe(e) {
  var t = noe(e, "string");
  return t1(t) == "symbol" ? t : t + "";
}
function noe(e, t) {
  if (t1(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (t1(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var wC = function(t) {
  var r = t.children, n = t.formattedGraphicalItems, a = t.legendWidth, i = t.legendContent, o = br(r, In);
  if (!o)
    return null;
  var s = In.defaultProps, l = s !== void 0 ? Ea(Ea({}, s), o.props) : {}, c;
  return o.props && o.props.payload ? c = o.props && o.props.payload : i === "children" ? c = (n || []).reduce(function(u, d) {
    var p = d.item, h = d.props, m = h.sectors || h.data || [];
    return u.concat(m.map(function(v) {
      return {
        type: o.props.iconType || p.props.legendType,
        value: v.name,
        color: v.fill,
        payload: v
      };
    }));
  }, []) : c = (n || []).map(function(u) {
    var d = u.item, p = d.type.defaultProps, h = p !== void 0 ? Ea(Ea({}, p), d.props) : {}, m = h.dataKey, v = h.name, g = h.legendType, b = h.hide;
    return {
      inactive: b,
      dataKey: m,
      type: l.iconType || g || "square",
      color: G6(d),
      value: v || m,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: h
    };
  }), Ea(Ea(Ea({}, l), In.getWithHeight(o, a)), {}, {
    payload: c,
    item: o
  });
};
function r1(e) {
  "@babel/helpers - typeof";
  return r1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, r1(e);
}
function u9(e) {
  return soe(e) || ooe(e) || ioe(e) || aoe();
}
function aoe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ioe(e, t) {
  if (e) {
    if (typeof e == "string")
      return nf(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return nf(e, t);
  }
}
function ooe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function soe(e) {
  if (Array.isArray(e))
    return nf(e);
}
function nf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function f9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Pt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? f9(Object(r), !0).forEach(function(n) {
      Li(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : f9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Li(e, t, r) {
  return t = loe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function loe(e) {
  var t = coe(e, "string");
  return r1(t) == "symbol" ? t : t + "";
}
function coe(e, t) {
  if (r1(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (r1(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function mt(e, t, r) {
  return xe(e) || xe(t) ? r : Vt(t) ? Sr(e, t, r) : we(t) ? t(e) : r;
}
function Ps(e, t, r, n) {
  var a = lie(e, function(s) {
    return mt(s, t);
  });
  if (r === "number") {
    var i = a.filter(function(s) {
      return oe(s) || parseFloat(s);
    });
    return i.length ? [Wu(i), Xn(i)] : [1 / 0, -1 / 0];
  }
  var o = n ? a.filter(function(s) {
    return !xe(s);
  }) : a;
  return o.map(function(s) {
    return Vt(s) || s instanceof Date ? s : "";
  });
}
var uoe = function(t) {
  var r, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], a = arguments.length > 2 ? arguments[2] : void 0, i = arguments.length > 3 ? arguments[3] : void 0, o = -1, s = (r = n == null ? void 0 : n.length) !== null && r !== void 0 ? r : 0;
  if (s <= 1)
    return 0;
  if (i && i.axisType === "angleAxis" && Math.abs(Math.abs(i.range[1] - i.range[0]) - 360) <= 1e-6)
    for (var l = i.range, c = 0; c < s; c++) {
      var u = c > 0 ? a[c - 1].coordinate : a[s - 1].coordinate, d = a[c].coordinate, p = c >= s - 1 ? a[0].coordinate : a[c + 1].coordinate, h = void 0;
      if (ar(d - u) !== ar(p - d)) {
        var m = [];
        if (ar(p - d) === ar(l[1] - l[0])) {
          h = p;
          var v = d + l[1] - l[0];
          m[0] = Math.min(v, (v + u) / 2), m[1] = Math.max(v, (v + u) / 2);
        } else {
          h = u;
          var g = p + l[1] - l[0];
          m[0] = Math.min(d, (g + d) / 2), m[1] = Math.max(d, (g + d) / 2);
        }
        var b = [Math.min(d, (h + d) / 2), Math.max(d, (h + d) / 2)];
        if (t > b[0] && t <= b[1] || t >= m[0] && t <= m[1]) {
          o = a[c].index;
          break;
        }
      } else {
        var C = Math.min(u, p), w = Math.max(u, p);
        if (t > (C + d) / 2 && t <= (w + d) / 2) {
          o = a[c].index;
          break;
        }
      }
    }
  else
    for (var x = 0; x < s; x++)
      if (x === 0 && t <= (n[x].coordinate + n[x + 1].coordinate) / 2 || x > 0 && x < s - 1 && t > (n[x].coordinate + n[x - 1].coordinate) / 2 && t <= (n[x].coordinate + n[x + 1].coordinate) / 2 || x === s - 1 && t > (n[x].coordinate + n[x - 1].coordinate) / 2) {
        o = n[x].index;
        break;
      }
  return o;
}, G6 = function(t) {
  var r, n = t, a = n.type.displayName, i = (r = t.type) !== null && r !== void 0 && r.defaultProps ? Pt(Pt({}, t.type.defaultProps), t.props) : t.props, o = i.stroke, s = i.fill, l;
  switch (a) {
    case "Line":
      l = o;
      break;
    case "Area":
    case "Radar":
      l = o && o !== "none" ? o : s;
      break;
    default:
      l = s;
      break;
  }
  return l;
}, foe = function(t) {
  var r = t.barSize, n = t.totalSize, a = t.stackGroups, i = a === void 0 ? {} : a;
  if (!i)
    return {};
  for (var o = {}, s = Object.keys(i), l = 0, c = s.length; l < c; l++)
    for (var u = i[s[l]].stackGroups, d = Object.keys(u), p = 0, h = d.length; p < h; p++) {
      var m = u[d[p]], v = m.items, g = m.cateAxisId, b = v.filter(function(P) {
        return Nn(P.type).indexOf("Bar") >= 0;
      });
      if (b && b.length) {
        var C = b[0].type.defaultProps, w = C !== void 0 ? Pt(Pt({}, C), b[0].props) : b[0].props, x = w.barSize, y = w[g];
        o[y] || (o[y] = []);
        var O = xe(x) ? r : x;
        o[y].push({
          item: b[0],
          stackList: b.slice(1),
          barSize: xe(O) ? void 0 : ir(O, n, 0)
        });
      }
    }
  return o;
}, doe = function(t) {
  var r = t.barGap, n = t.barCategoryGap, a = t.bandSize, i = t.sizeList, o = i === void 0 ? [] : i, s = t.maxBarSize, l = o.length;
  if (l < 1)
    return null;
  var c = ir(r, a, 0, !0), u, d = [];
  if (o[0].barSize === +o[0].barSize) {
    var p = !1, h = a / l, m = o.reduce(function(x, y) {
      return x + y.barSize || 0;
    }, 0);
    m += (l - 1) * c, m >= a && (m -= (l - 1) * c, c = 0), m >= a && h > 0 && (p = !0, h *= 0.9, m = l * h);
    var v = (a - m) / 2 >> 0, g = {
      offset: v - c,
      size: 0
    };
    u = o.reduce(function(x, y) {
      var O = {
        item: y.item,
        position: {
          offset: g.offset + g.size + c,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: p ? h : y.barSize
        }
      }, P = [].concat(u9(x), [O]);
      return g = P[P.length - 1].position, y.stackList && y.stackList.length && y.stackList.forEach(function(j) {
        P.push({
          item: j,
          position: g
        });
      }), P;
    }, d);
  } else {
    var b = ir(n, a, 0, !0);
    a - 2 * b - (l - 1) * c <= 0 && (c = 0);
    var C = (a - 2 * b - (l - 1) * c) / l;
    C > 1 && (C >>= 0);
    var w = s === +s ? Math.min(C, s) : C;
    u = o.reduce(function(x, y, O) {
      var P = [].concat(u9(x), [{
        item: y.item,
        position: {
          offset: b + (C + c) * O + (C - w) / 2,
          size: w
        }
      }]);
      return y.stackList && y.stackList.length && y.stackList.forEach(function(j) {
        P.push({
          item: j,
          position: P[P.length - 1].position
        });
      }), P;
    }, d);
  }
  return u;
}, poe = function(t, r, n, a) {
  var i = n.children, o = n.width, s = n.margin, l = o - (s.left || 0) - (s.right || 0), c = wC({
    children: i,
    legendWidth: l
  });
  if (c) {
    var u = a || {}, d = u.width, p = u.height, h = c.align, m = c.verticalAlign, v = c.layout;
    if ((v === "vertical" || v === "horizontal" && m === "middle") && h !== "center" && oe(t[h]))
      return Pt(Pt({}, t), {}, Li({}, h, t[h] + (d || 0)));
    if ((v === "horizontal" || v === "vertical" && h === "center") && m !== "middle" && oe(t[m]))
      return Pt(Pt({}, t), {}, Li({}, m, t[m] + (p || 0)));
  }
  return t;
}, hoe = function(t, r, n) {
  return xe(r) ? !0 : t === "horizontal" ? r === "yAxis" : t === "vertical" || n === "x" ? r === "xAxis" : n === "y" ? r === "yAxis" : !0;
}, OC = function(t, r, n, a, i) {
  var o = r.props.children, s = lr(o, Bo).filter(function(c) {
    return hoe(a, i, c.props.direction);
  });
  if (s && s.length) {
    var l = s.map(function(c) {
      return c.props.dataKey;
    });
    return t.reduce(function(c, u) {
      var d = mt(u, n);
      if (xe(d))
        return c;
      var p = Array.isArray(d) ? [Wu(d), Xn(d)] : [d, d], h = l.reduce(function(m, v) {
        var g = mt(u, v, 0), b = p[0] - Math.abs(Array.isArray(g) ? g[0] : g), C = p[1] + Math.abs(Array.isArray(g) ? g[1] : g);
        return [Math.min(b, m[0]), Math.max(C, m[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(h[0], c[0]), Math.max(h[1], c[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, voe = function(t, r, n, a, i) {
  var o = r.map(function(s) {
    return OC(t, s, n, i, a);
  }).filter(function(s) {
    return !xe(s);
  });
  return o && o.length ? o.reduce(function(s, l) {
    return [Math.min(s[0], l[0]), Math.max(s[1], l[1])];
  }, [1 / 0, -1 / 0]) : null;
}, SC = function(t, r, n, a, i) {
  var o = r.map(function(l) {
    var c = l.props.dataKey;
    return n === "number" && c && OC(t, l, c, a) || Ps(t, c, n, i);
  });
  if (n === "number")
    return o.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(l, c) {
        return [Math.min(l[0], c[0]), Math.max(l[1], c[1])];
      },
      [1 / 0, -1 / 0]
    );
  var s = {};
  return o.reduce(function(l, c) {
    for (var u = 0, d = c.length; u < d; u++)
      s[c[u]] || (s[c[u]] = !0, l.push(c[u]));
    return l;
  }, []);
}, PC = function(t, r) {
  return t === "horizontal" && r === "xAxis" || t === "vertical" && r === "yAxis" || t === "centric" && r === "angleAxis" || t === "radial" && r === "radiusAxis";
}, EC = function(t, r, n, a) {
  if (a)
    return t.map(function(l) {
      return l.coordinate;
    });
  var i, o, s = t.map(function(l) {
    return l.coordinate === r && (i = !0), l.coordinate === n && (o = !0), l.coordinate;
  });
  return i || s.push(r), o || s.push(n), s;
}, Mn = function(t, r, n) {
  if (!t)
    return null;
  var a = t.scale, i = t.duplicateDomain, o = t.type, s = t.range, l = t.realScaleType === "scaleBand" ? a.bandwidth() / 2 : 2, c = (r || n) && o === "category" && a.bandwidth ? a.bandwidth() / l : 0;
  if (c = t.axisType === "angleAxis" && (s == null ? void 0 : s.length) >= 2 ? ar(s[0] - s[1]) * 2 * c : c, r && (t.ticks || t.niceTicks)) {
    var u = (t.ticks || t.niceTicks).map(function(d) {
      var p = i ? i.indexOf(d) : d;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: a(p) + c,
        value: d,
        offset: c
      };
    });
    return u.filter(function(d) {
      return !To(d.coordinate);
    });
  }
  return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(d, p) {
    return {
      coordinate: a(d) + c,
      value: d,
      index: p,
      offset: c
    };
  }) : a.ticks && !n ? a.ticks(t.tickCount).map(function(d) {
    return {
      coordinate: a(d) + c,
      value: d,
      offset: c
    };
  }) : a.domain().map(function(d, p) {
    return {
      coordinate: a(d) + c,
      value: i ? i[d] : d,
      index: p,
      offset: c
    };
  });
}, S3 = /* @__PURE__ */ new WeakMap(), dl = function(t, r) {
  if (typeof r != "function")
    return t;
  S3.has(t) || S3.set(t, /* @__PURE__ */ new WeakMap());
  var n = S3.get(t);
  if (n.has(r))
    return n.get(r);
  var a = function() {
    t.apply(void 0, arguments), r.apply(void 0, arguments);
  };
  return n.set(r, a), a;
}, jC = function(t, r, n) {
  var a = t.scale, i = t.type, o = t.layout, s = t.axisType;
  if (a === "auto")
    return o === "radial" && s === "radiusAxis" ? {
      scale: Gs(),
      realScaleType: "band"
    } : o === "radial" && s === "angleAxis" ? {
      scale: bc(),
      realScaleType: "linear"
    } : i === "category" && r && (r.indexOf("LineChart") >= 0 || r.indexOf("AreaChart") >= 0 || r.indexOf("ComposedChart") >= 0 && !n) ? {
      scale: Ss(),
      realScaleType: "point"
    } : i === "category" ? {
      scale: Gs(),
      realScaleType: "band"
    } : {
      scale: bc(),
      realScaleType: "linear"
    };
  if (L1(a)) {
    var l = "scale".concat(_u(a));
    return {
      scale: (n9[l] || Ss)(),
      realScaleType: n9[l] ? l : "point"
    };
  }
  return we(a) ? {
    scale: a
  } : {
    scale: Ss(),
    realScaleType: "point"
  };
}, d9 = 1e-4, _C = function(t) {
  var r = t.domain();
  if (!(!r || r.length <= 2)) {
    var n = r.length, a = t.range(), i = Math.min(a[0], a[1]) - d9, o = Math.max(a[0], a[1]) + d9, s = t(r[0]), l = t(r[n - 1]);
    (s < i || s > o || l < i || l > o) && t.domain([r[0], r[n - 1]]);
  }
}, moe = function(t, r) {
  if (!t)
    return null;
  for (var n = 0, a = t.length; n < a; n++)
    if (t[n].item === r)
      return t[n].position;
  return null;
}, goe = function(t, r) {
  if (!r || r.length !== 2 || !oe(r[0]) || !oe(r[1]))
    return t;
  var n = Math.min(r[0], r[1]), a = Math.max(r[0], r[1]), i = [t[0], t[1]];
  return (!oe(t[0]) || t[0] < n) && (i[0] = n), (!oe(t[1]) || t[1] > a) && (i[1] = a), i[0] > a && (i[0] = a), i[1] < n && (i[1] = n), i;
}, yoe = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, a = t[0].length; n < a; ++n)
      for (var i = 0, o = 0, s = 0; s < r; ++s) {
        var l = To(t[s][n][1]) ? t[s][n][0] : t[s][n][1];
        l >= 0 ? (t[s][n][0] = i, t[s][n][1] = i + l, i = t[s][n][1]) : (t[s][n][0] = o, t[s][n][1] = o + l, o = t[s][n][1]);
      }
}, boe = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, a = t[0].length; n < a; ++n)
      for (var i = 0, o = 0; o < r; ++o) {
        var s = To(t[o][n][1]) ? t[o][n][0] : t[o][n][1];
        s >= 0 ? (t[o][n][0] = i, t[o][n][1] = i + s, i = t[o][n][1]) : (t[o][n][0] = 0, t[o][n][1] = 0);
      }
}, Coe = {
  sign: yoe,
  // @ts-expect-error definitelytyped types are incorrect
  expand: WZ,
  // @ts-expect-error definitelytyped types are incorrect
  none: Ui,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: zZ,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: UZ,
  positive: boe
}, xoe = function(t, r, n) {
  var a = r.map(function(s) {
    return s.props.dataKey;
  }), i = Coe[n], o = FZ().keys(a).value(function(s, l) {
    return +mt(s, l, 0);
  }).order(_0).offset(i);
  return o(t);
}, woe = function(t, r, n, a, i, o) {
  if (!t)
    return null;
  var s = o ? r.reverse() : r, l = {}, c = s.reduce(function(d, p) {
    var h, m = (h = p.type) !== null && h !== void 0 && h.defaultProps ? Pt(Pt({}, p.type.defaultProps), p.props) : p.props, v = m.stackId, g = m.hide;
    if (g)
      return d;
    var b = m[n], C = d[b] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (Vt(v)) {
      var w = C.stackGroups[v] || {
        numericAxisId: n,
        cateAxisId: a,
        items: []
      };
      w.items.push(p), C.hasStack = !0, C.stackGroups[v] = w;
    } else
      C.stackGroups[ga("_stackId_")] = {
        numericAxisId: n,
        cateAxisId: a,
        items: [p]
      };
    return Pt(Pt({}, d), {}, Li({}, b, C));
  }, l), u = {};
  return Object.keys(c).reduce(function(d, p) {
    var h = c[p];
    if (h.hasStack) {
      var m = {};
      h.stackGroups = Object.keys(h.stackGroups).reduce(function(v, g) {
        var b = h.stackGroups[g];
        return Pt(Pt({}, v), {}, Li({}, g, {
          numericAxisId: n,
          cateAxisId: a,
          items: b.items,
          stackedData: xoe(t, b.items, i)
        }));
      }, m);
    }
    return Pt(Pt({}, d), {}, Li({}, p, h));
  }, u);
}, AC = function(t, r) {
  var n = r.realScaleType, a = r.type, i = r.tickCount, o = r.originalDomain, s = r.allowDecimals, l = n || r.scale;
  if (l !== "auto" && l !== "linear")
    return null;
  if (i && a === "number" && o && (o[0] === "auto" || o[1] === "auto")) {
    var c = t.domain();
    if (!c.length)
      return null;
    var u = Rie(c, i, s);
    return t.domain([Wu(u), Xn(u)]), {
      niceTicks: u
    };
  }
  if (i && a === "number") {
    var d = t.domain(), p = Bie(d, i, s);
    return {
      niceTicks: p
    };
  }
  return null;
};
function eo(e) {
  var t = e.axis, r = e.ticks, n = e.bandSize, a = e.entry, i = e.index, o = e.dataKey;
  if (t.type === "category") {
    if (!t.allowDuplicatedCategory && t.dataKey && !xe(a[t.dataKey])) {
      var s = Ql(r, "value", a[t.dataKey]);
      if (s)
        return s.coordinate + n / 2;
    }
    return r[i] ? r[i].coordinate + n / 2 : null;
  }
  var l = mt(a, xe(o) ? t.dataKey : o);
  return xe(l) ? null : t.scale(l);
}
var p9 = function(t) {
  var r = t.axis, n = t.ticks, a = t.offset, i = t.bandSize, o = t.entry, s = t.index;
  if (r.type === "category")
    return n[s] ? n[s].coordinate + a : null;
  var l = mt(o, r.dataKey, r.domain[s]);
  return xe(l) ? null : r.scale(l) - i / 2 + a;
}, Ooe = function(t) {
  var r = t.numericAxis, n = r.scale.domain();
  if (r.type === "number") {
    var a = Math.min(n[0], n[1]), i = Math.max(n[0], n[1]);
    return a <= 0 && i >= 0 ? 0 : i < 0 ? i : a;
  }
  return n[0];
}, Soe = function(t, r) {
  var n, a = (n = t.type) !== null && n !== void 0 && n.defaultProps ? Pt(Pt({}, t.type.defaultProps), t.props) : t.props, i = a.stackId;
  if (Vt(i)) {
    var o = r[i];
    if (o) {
      var s = o.items.indexOf(t);
      return s >= 0 ? o.stackedData[s] : null;
    }
  }
  return null;
}, Poe = function(t) {
  return t.reduce(function(r, n) {
    return [Wu(n.concat([r[0]]).filter(oe)), Xn(n.concat([r[1]]).filter(oe))];
  }, [1 / 0, -1 / 0]);
}, DC = function(t, r, n) {
  return Object.keys(t).reduce(function(a, i) {
    var o = t[i], s = o.stackedData, l = s.reduce(function(c, u) {
      var d = Poe(u.slice(r, n + 1));
      return [Math.min(c[0], d[0]), Math.max(c[1], d[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(l[0], a[0]), Math.max(l[1], a[1])];
  }, [1 / 0, -1 / 0]).map(function(a) {
    return a === 1 / 0 || a === -1 / 0 ? 0 : a;
  });
}, h9 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, v9 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, af = function(t, r, n) {
  if (we(t))
    return t(r, n);
  if (!Array.isArray(t))
    return r;
  var a = [];
  if (oe(t[0]))
    a[0] = n ? t[0] : Math.min(t[0], r[0]);
  else if (h9.test(t[0])) {
    var i = +h9.exec(t[0])[1];
    a[0] = r[0] - i;
  } else
    we(t[0]) ? a[0] = t[0](r[0]) : a[0] = r[0];
  if (oe(t[1]))
    a[1] = n ? t[1] : Math.max(t[1], r[1]);
  else if (v9.test(t[1])) {
    var o = +v9.exec(t[1])[1];
    a[1] = r[1] + o;
  } else
    we(t[1]) ? a[1] = t[1](r[1]) : a[1] = r[1];
  return a;
}, Ec = function(t, r, n) {
  if (t && t.scale && t.scale.bandwidth) {
    var a = t.scale.bandwidth();
    if (!n || a > 0)
      return a;
  }
  if (t && r && r.length >= 2) {
    for (var i = w6(r, function(d) {
      return d.coordinate;
    }), o = 1 / 0, s = 1, l = i.length; s < l; s++) {
      var c = i[s], u = i[s - 1];
      o = Math.min((c.coordinate || 0) - (u.coordinate || 0), o);
    }
    return o === 1 / 0 ? 0 : o;
  }
  return n ? void 0 : 0;
}, m9 = function(t, r, n) {
  return !t || !t.length || la(t, Sr(n, "type.defaultProps.domain")) ? r : t;
}, MC = function(t, r) {
  var n = t.type.defaultProps ? Pt(Pt({}, t.type.defaultProps), t.props) : t.props, a = n.dataKey, i = n.name, o = n.unit, s = n.formatter, l = n.tooltipType, c = n.chartType, u = n.hide;
  return Pt(Pt({}, he(t, !1)), {}, {
    dataKey: a,
    unit: o,
    formatter: s,
    name: i || a,
    color: G6(t),
    value: mt(r, a),
    type: l,
    payload: r,
    chartType: c,
    hide: u
  });
};
function n1(e) {
  "@babel/helpers - typeof";
  return n1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, n1(e);
}
function g9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _n(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? g9(Object(r), !0).forEach(function(n) {
      TC(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : g9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function TC(e, t, r) {
  return t = Eoe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Eoe(e) {
  var t = joe(e, "string");
  return n1(t) == "symbol" ? t : t + "";
}
function joe(e, t) {
  if (n1(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (n1(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function _oe(e, t) {
  return Toe(e) || Moe(e, t) || Doe(e, t) || Aoe();
}
function Aoe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Doe(e, t) {
  if (e) {
    if (typeof e == "string")
      return y9(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return y9(e, t);
  }
}
function y9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Moe(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function Toe(e) {
  if (Array.isArray(e))
    return e;
}
var jc = Math.PI / 180, $oe = function(t) {
  return t * 180 / Math.PI;
}, dt = function(t, r, n, a) {
  return {
    x: t + Math.cos(-jc * a) * n,
    y: r + Math.sin(-jc * a) * n
  };
}, $C = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(t - (n.left || 0) - (n.right || 0)), Math.abs(r - (n.top || 0) - (n.bottom || 0))) / 2;
}, Noe = function(t, r, n, a, i) {
  var o = t.width, s = t.height, l = t.startAngle, c = t.endAngle, u = ir(t.cx, o, o / 2), d = ir(t.cy, s, s / 2), p = $C(o, s, n), h = ir(t.innerRadius, p, 0), m = ir(t.outerRadius, p, p * 0.8), v = Object.keys(r);
  return v.reduce(function(g, b) {
    var C = r[b], w = C.domain, x = C.reversed, y;
    if (xe(C.range))
      a === "angleAxis" ? y = [l, c] : a === "radiusAxis" && (y = [h, m]), x && (y = [y[1], y[0]]);
    else {
      y = C.range;
      var O = y, P = _oe(O, 2);
      l = P[0], c = P[1];
    }
    var j = jC(C, i), T = j.realScaleType, I = j.scale;
    I.domain(w).range(y), _C(I);
    var R = AC(I, _n(_n({}, C), {}, {
      realScaleType: T
    })), F = _n(_n(_n({}, C), R), {}, {
      range: y,
      radius: m,
      realScaleType: T,
      scale: I,
      cx: u,
      cy: d,
      innerRadius: h,
      outerRadius: m,
      startAngle: l,
      endAngle: c
    });
    return _n(_n({}, g), {}, TC({}, b, F));
  }, {});
}, Ioe = function(t, r) {
  var n = t.x, a = t.y, i = r.x, o = r.y;
  return Math.sqrt(Math.pow(n - i, 2) + Math.pow(a - o, 2));
}, Loe = function(t, r) {
  var n = t.x, a = t.y, i = r.cx, o = r.cy, s = Ioe({
    x: n,
    y: a
  }, {
    x: i,
    y: o
  });
  if (s <= 0)
    return {
      radius: s
    };
  var l = (n - i) / s, c = Math.acos(l);
  return a > o && (c = 2 * Math.PI - c), {
    radius: s,
    angle: $oe(c),
    angleInRadian: c
  };
}, koe = function(t) {
  var r = t.startAngle, n = t.endAngle, a = Math.floor(r / 360), i = Math.floor(n / 360), o = Math.min(a, i);
  return {
    startAngle: r - o * 360,
    endAngle: n - o * 360
  };
}, Roe = function(t, r) {
  var n = r.startAngle, a = r.endAngle, i = Math.floor(n / 360), o = Math.floor(a / 360), s = Math.min(i, o);
  return t + s * 360;
}, b9 = function(t, r) {
  var n = t.x, a = t.y, i = Loe({
    x: n,
    y: a
  }, r), o = i.radius, s = i.angle, l = r.innerRadius, c = r.outerRadius;
  if (o < l || o > c)
    return !1;
  if (o === 0)
    return !0;
  var u = koe(r), d = u.startAngle, p = u.endAngle, h = s, m;
  if (d <= p) {
    for (; h > p; )
      h -= 360;
    for (; h < d; )
      h += 360;
    m = h >= d && h <= p;
  } else {
    for (; h > d; )
      h -= 360;
    for (; h < p; )
      h += 360;
    m = h >= p && h <= d;
  }
  return m ? _n(_n({}, r), {}, {
    radius: o,
    angle: Roe(h, r)
  }) : null;
}, NC = function(t) {
  return !/* @__PURE__ */ Yr(t) && !we(t) && typeof t != "boolean" ? t.className : "";
};
function a1(e) {
  "@babel/helpers - typeof";
  return a1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, a1(e);
}
var Boe = ["offset"];
function Voe(e) {
  return zoe(e) || Woe(e) || Foe(e) || Hoe();
}
function Hoe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Foe(e, t) {
  if (e) {
    if (typeof e == "string")
      return of(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return of(e, t);
  }
}
function Woe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function zoe(e) {
  if (Array.isArray(e))
    return of(e);
}
function of(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Uoe(e, t) {
  if (e == null)
    return {};
  var r = Zoe(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Zoe(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function C9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Lt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? C9(Object(r), !0).forEach(function(n) {
      qoe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : C9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function qoe(e, t, r) {
  return t = Goe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Goe(e) {
  var t = Yoe(e, "string");
  return a1(t) == "symbol" ? t : t + "";
}
function Yoe(e, t) {
  if (a1(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (a1(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function i1() {
  return i1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, i1.apply(this, arguments);
}
var Koe = function(t) {
  var r = t.value, n = t.formatter, a = xe(t.children) ? r : t.children;
  return we(n) ? n(a) : a;
}, Xoe = function(t, r) {
  var n = ar(r - t), a = Math.min(Math.abs(r - t), 360);
  return n * a;
}, Qoe = function(t, r, n) {
  var a = t.position, i = t.viewBox, o = t.offset, s = t.className, l = i, c = l.cx, u = l.cy, d = l.innerRadius, p = l.outerRadius, h = l.startAngle, m = l.endAngle, v = l.clockWise, g = (d + p) / 2, b = Xoe(h, m), C = b >= 0 ? 1 : -1, w, x;
  a === "insideStart" ? (w = h + C * o, x = v) : a === "insideEnd" ? (w = m - C * o, x = !v) : a === "end" && (w = m + C * o, x = v), x = b <= 0 ? x : !x;
  var y = dt(c, u, g, w), O = dt(c, u, g, w + (x ? 1 : -1) * 359), P = "M".concat(y.x, ",").concat(y.y, `
    A`).concat(g, ",").concat(g, ",0,1,").concat(x ? 0 : 1, `,
    `).concat(O.x, ",").concat(O.y), j = xe(t.id) ? ga("recharts-radial-line-") : t.id;
  return /* @__PURE__ */ E.createElement("text", i1({}, n, {
    dominantBaseline: "central",
    className: De("recharts-radial-bar-label", s)
  }), /* @__PURE__ */ E.createElement("defs", null, /* @__PURE__ */ E.createElement("path", {
    id: j,
    d: P
  })), /* @__PURE__ */ E.createElement("textPath", {
    xlinkHref: "#".concat(j)
  }, r));
}, Joe = function(t) {
  var r = t.viewBox, n = t.offset, a = t.position, i = r, o = i.cx, s = i.cy, l = i.innerRadius, c = i.outerRadius, u = i.startAngle, d = i.endAngle, p = (u + d) / 2;
  if (a === "outside") {
    var h = dt(o, s, c + n, p), m = h.x, v = h.y;
    return {
      x: m,
      y: v,
      textAnchor: m >= o ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (a === "center")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (a === "centerTop")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (a === "centerBottom")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var g = (l + c) / 2, b = dt(o, s, g, p), C = b.x, w = b.y;
  return {
    x: C,
    y: w,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, ese = function(t) {
  var r = t.viewBox, n = t.parentViewBox, a = t.offset, i = t.position, o = r, s = o.x, l = o.y, c = o.width, u = o.height, d = u >= 0 ? 1 : -1, p = d * a, h = d > 0 ? "end" : "start", m = d > 0 ? "start" : "end", v = c >= 0 ? 1 : -1, g = v * a, b = v > 0 ? "end" : "start", C = v > 0 ? "start" : "end";
  if (i === "top") {
    var w = {
      x: s + c / 2,
      y: l - d * a,
      textAnchor: "middle",
      verticalAnchor: h
    };
    return Lt(Lt({}, w), n ? {
      height: Math.max(l - n.y, 0),
      width: c
    } : {});
  }
  if (i === "bottom") {
    var x = {
      x: s + c / 2,
      y: l + u + p,
      textAnchor: "middle",
      verticalAnchor: m
    };
    return Lt(Lt({}, x), n ? {
      height: Math.max(n.y + n.height - (l + u), 0),
      width: c
    } : {});
  }
  if (i === "left") {
    var y = {
      x: s - g,
      y: l + u / 2,
      textAnchor: b,
      verticalAnchor: "middle"
    };
    return Lt(Lt({}, y), n ? {
      width: Math.max(y.x - n.x, 0),
      height: u
    } : {});
  }
  if (i === "right") {
    var O = {
      x: s + c + g,
      y: l + u / 2,
      textAnchor: C,
      verticalAnchor: "middle"
    };
    return Lt(Lt({}, O), n ? {
      width: Math.max(n.x + n.width - O.x, 0),
      height: u
    } : {});
  }
  var P = n ? {
    width: c,
    height: u
  } : {};
  return i === "insideLeft" ? Lt({
    x: s + g,
    y: l + u / 2,
    textAnchor: C,
    verticalAnchor: "middle"
  }, P) : i === "insideRight" ? Lt({
    x: s + c - g,
    y: l + u / 2,
    textAnchor: b,
    verticalAnchor: "middle"
  }, P) : i === "insideTop" ? Lt({
    x: s + c / 2,
    y: l + p,
    textAnchor: "middle",
    verticalAnchor: m
  }, P) : i === "insideBottom" ? Lt({
    x: s + c / 2,
    y: l + u - p,
    textAnchor: "middle",
    verticalAnchor: h
  }, P) : i === "insideTopLeft" ? Lt({
    x: s + g,
    y: l + p,
    textAnchor: C,
    verticalAnchor: m
  }, P) : i === "insideTopRight" ? Lt({
    x: s + c - g,
    y: l + p,
    textAnchor: b,
    verticalAnchor: m
  }, P) : i === "insideBottomLeft" ? Lt({
    x: s + g,
    y: l + u - p,
    textAnchor: C,
    verticalAnchor: h
  }, P) : i === "insideBottomRight" ? Lt({
    x: s + c - g,
    y: l + u - p,
    textAnchor: b,
    verticalAnchor: h
  }, P) : _o(i) && (oe(i.x) || Va(i.x)) && (oe(i.y) || Va(i.y)) ? Lt({
    x: s + ir(i.x, c),
    y: l + ir(i.y, u),
    textAnchor: "end",
    verticalAnchor: "end"
  }, P) : Lt({
    x: s + c / 2,
    y: l + u / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, P);
}, tse = function(t) {
  return "cx" in t && oe(t.cx);
};
function Bt(e) {
  var t = e.offset, r = t === void 0 ? 5 : t, n = Uoe(e, Boe), a = Lt({
    offset: r
  }, n), i = a.viewBox, o = a.position, s = a.value, l = a.children, c = a.content, u = a.className, d = u === void 0 ? "" : u, p = a.textBreakAll;
  if (!i || xe(s) && xe(l) && !/* @__PURE__ */ Yr(c) && !we(c))
    return null;
  if (/* @__PURE__ */ Yr(c))
    return /* @__PURE__ */ Rt(c, a);
  var h;
  if (we(c)) {
    if (h = /* @__PURE__ */ fv(c, a), /* @__PURE__ */ Yr(h))
      return h;
  } else
    h = Koe(a);
  var m = tse(i), v = he(a, !0);
  if (m && (o === "insideStart" || o === "insideEnd" || o === "end"))
    return Qoe(a, h, v);
  var g = m ? Joe(a) : ese(a);
  return /* @__PURE__ */ E.createElement(Qa, i1({
    className: De("recharts-label", d)
  }, v, g, {
    breakAll: p
  }), h);
}
Bt.displayName = "Label";
var IC = function(t) {
  var r = t.cx, n = t.cy, a = t.angle, i = t.startAngle, o = t.endAngle, s = t.r, l = t.radius, c = t.innerRadius, u = t.outerRadius, d = t.x, p = t.y, h = t.top, m = t.left, v = t.width, g = t.height, b = t.clockWise, C = t.labelViewBox;
  if (C)
    return C;
  if (oe(v) && oe(g)) {
    if (oe(d) && oe(p))
      return {
        x: d,
        y: p,
        width: v,
        height: g
      };
    if (oe(h) && oe(m))
      return {
        x: h,
        y: m,
        width: v,
        height: g
      };
  }
  return oe(d) && oe(p) ? {
    x: d,
    y: p,
    width: 0,
    height: 0
  } : oe(r) && oe(n) ? {
    cx: r,
    cy: n,
    startAngle: i || a || 0,
    endAngle: o || a || 0,
    innerRadius: c || 0,
    outerRadius: u || l || s || 0,
    clockWise: b
  } : t.viewBox ? t.viewBox : {};
}, rse = function(t, r) {
  return t ? t === !0 ? /* @__PURE__ */ E.createElement(Bt, {
    key: "label-implicit",
    viewBox: r
  }) : Vt(t) ? /* @__PURE__ */ E.createElement(Bt, {
    key: "label-implicit",
    viewBox: r,
    value: t
  }) : /* @__PURE__ */ Yr(t) ? t.type === Bt ? /* @__PURE__ */ Rt(t, {
    key: "label-implicit",
    viewBox: r
  }) : /* @__PURE__ */ E.createElement(Bt, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : we(t) ? /* @__PURE__ */ E.createElement(Bt, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : _o(t) ? /* @__PURE__ */ E.createElement(Bt, i1({
    viewBox: r
  }, t, {
    key: "label-implicit"
  })) : null : null;
}, nse = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && n && !t.label)
    return null;
  var a = t.children, i = IC(t), o = lr(a, Bt).map(function(l, c) {
    return /* @__PURE__ */ Rt(l, {
      viewBox: r || i,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(c)
    });
  });
  if (!n)
    return o;
  var s = rse(t.label, r || i);
  return [s].concat(Voe(o));
};
Bt.parseViewBox = IC;
Bt.renderCallByParent = nse;
function ase(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var ise = ase;
const ose = /* @__PURE__ */ Ze(ise);
function o1(e) {
  "@babel/helpers - typeof";
  return o1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, o1(e);
}
var sse = ["valueAccessor"], lse = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function cse(e) {
  return pse(e) || dse(e) || fse(e) || use();
}
function use() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fse(e, t) {
  if (e) {
    if (typeof e == "string")
      return sf(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return sf(e, t);
  }
}
function dse(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function pse(e) {
  if (Array.isArray(e))
    return sf(e);
}
function sf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function _c() {
  return _c = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _c.apply(this, arguments);
}
function x9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function w9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? x9(Object(r), !0).forEach(function(n) {
      hse(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : x9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function hse(e, t, r) {
  return t = vse(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function vse(e) {
  var t = mse(e, "string");
  return o1(t) == "symbol" ? t : t + "";
}
function mse(e, t) {
  if (o1(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (o1(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function O9(e, t) {
  if (e == null)
    return {};
  var r = gse(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function gse(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
var yse = function(t) {
  return Array.isArray(t.value) ? ose(t.value) : t.value;
};
function Xr(e) {
  var t = e.valueAccessor, r = t === void 0 ? yse : t, n = O9(e, sse), a = n.data, i = n.dataKey, o = n.clockWise, s = n.id, l = n.textBreakAll, c = O9(n, lse);
  return !a || !a.length ? null : /* @__PURE__ */ E.createElement(Me, {
    className: "recharts-label-list"
  }, a.map(function(u, d) {
    var p = xe(i) ? r(u, d) : mt(u && u.payload, i), h = xe(s) ? {} : {
      id: "".concat(s, "-").concat(d)
    };
    return /* @__PURE__ */ E.createElement(Bt, _c({}, he(u, !0), c, h, {
      parentViewBox: u.parentViewBox,
      value: p,
      textBreakAll: l,
      viewBox: Bt.parseViewBox(xe(o) ? u : w9(w9({}, u), {}, {
        clockWise: o
      })),
      key: "label-".concat(d),
      index: d
    }));
  }));
}
Xr.displayName = "LabelList";
function bse(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ E.createElement(Xr, {
    key: "labelList-implicit",
    data: t
  }) : /* @__PURE__ */ E.isValidElement(e) || we(e) ? /* @__PURE__ */ E.createElement(Xr, {
    key: "labelList-implicit",
    data: t,
    content: e
  }) : _o(e) ? /* @__PURE__ */ E.createElement(Xr, _c({
    data: t
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function Cse(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && r && !e.label)
    return null;
  var n = e.children, a = lr(n, Xr).map(function(o, s) {
    return /* @__PURE__ */ Rt(o, {
      data: t,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(s)
    });
  });
  if (!r)
    return a;
  var i = bse(e.label, t);
  return [i].concat(cse(a));
}
Xr.renderCallByParent = Cse;
function s1(e) {
  "@babel/helpers - typeof";
  return s1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, s1(e);
}
function lf() {
  return lf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lf.apply(this, arguments);
}
function S9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function P9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? S9(Object(r), !0).forEach(function(n) {
      xse(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : S9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function xse(e, t, r) {
  return t = wse(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function wse(e) {
  var t = Ose(e, "string");
  return s1(t) == "symbol" ? t : t + "";
}
function Ose(e, t) {
  if (s1(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (s1(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Sse = function(t, r) {
  var n = ar(r - t), a = Math.min(Math.abs(r - t), 359.999);
  return n * a;
}, pl = function(t) {
  var r = t.cx, n = t.cy, a = t.radius, i = t.angle, o = t.sign, s = t.isExternal, l = t.cornerRadius, c = t.cornerIsExternal, u = l * (s ? 1 : -1) + a, d = Math.asin(l / u) / jc, p = c ? i : i + o * d, h = dt(r, n, u, p), m = dt(r, n, a, p), v = c ? i - o * d : i, g = dt(r, n, u * Math.cos(d * jc), v);
  return {
    center: h,
    circleTangency: m,
    lineTangency: g,
    theta: d
  };
}, LC = function(t) {
  var r = t.cx, n = t.cy, a = t.innerRadius, i = t.outerRadius, o = t.startAngle, s = t.endAngle, l = Sse(o, s), c = o + l, u = dt(r, n, i, o), d = dt(r, n, i, c), p = "M ".concat(u.x, ",").concat(u.y, `
    A `).concat(i, ",").concat(i, `,0,
    `).concat(+(Math.abs(l) > 180), ",").concat(+(o > c), `,
    `).concat(d.x, ",").concat(d.y, `
  `);
  if (a > 0) {
    var h = dt(r, n, a, o), m = dt(r, n, a, c);
    p += "L ".concat(m.x, ",").concat(m.y, `
            A `).concat(a, ",").concat(a, `,0,
            `).concat(+(Math.abs(l) > 180), ",").concat(+(o <= c), `,
            `).concat(h.x, ",").concat(h.y, " Z");
  } else
    p += "L ".concat(r, ",").concat(n, " Z");
  return p;
}, Pse = function(t) {
  var r = t.cx, n = t.cy, a = t.innerRadius, i = t.outerRadius, o = t.cornerRadius, s = t.forceCornerRadius, l = t.cornerIsExternal, c = t.startAngle, u = t.endAngle, d = ar(u - c), p = pl({
    cx: r,
    cy: n,
    radius: i,
    angle: c,
    sign: d,
    cornerRadius: o,
    cornerIsExternal: l
  }), h = p.circleTangency, m = p.lineTangency, v = p.theta, g = pl({
    cx: r,
    cy: n,
    radius: i,
    angle: u,
    sign: -d,
    cornerRadius: o,
    cornerIsExternal: l
  }), b = g.circleTangency, C = g.lineTangency, w = g.theta, x = l ? Math.abs(c - u) : Math.abs(c - u) - v - w;
  if (x < 0)
    return s ? "M ".concat(m.x, ",").concat(m.y, `
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(o * 2, `,0
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(-o * 2, `,0
      `) : LC({
      cx: r,
      cy: n,
      innerRadius: a,
      outerRadius: i,
      startAngle: c,
      endAngle: u
    });
  var y = "M ".concat(m.x, ",").concat(m.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(d < 0), ",").concat(h.x, ",").concat(h.y, `
    A`).concat(i, ",").concat(i, ",0,").concat(+(x > 180), ",").concat(+(d < 0), ",").concat(b.x, ",").concat(b.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(d < 0), ",").concat(C.x, ",").concat(C.y, `
  `);
  if (a > 0) {
    var O = pl({
      cx: r,
      cy: n,
      radius: a,
      angle: c,
      sign: d,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: l
    }), P = O.circleTangency, j = O.lineTangency, T = O.theta, I = pl({
      cx: r,
      cy: n,
      radius: a,
      angle: u,
      sign: -d,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: l
    }), R = I.circleTangency, F = I.lineTangency, $ = I.theta, Z = l ? Math.abs(c - u) : Math.abs(c - u) - T - $;
    if (Z < 0 && o === 0)
      return "".concat(y, "L").concat(r, ",").concat(n, "Z");
    y += "L".concat(F.x, ",").concat(F.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(d < 0), ",").concat(R.x, ",").concat(R.y, `
      A`).concat(a, ",").concat(a, ",0,").concat(+(Z > 180), ",").concat(+(d > 0), ",").concat(P.x, ",").concat(P.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(d < 0), ",").concat(j.x, ",").concat(j.y, "Z");
  } else
    y += "L".concat(r, ",").concat(n, "Z");
  return y;
}, Ese = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, kC = function(t) {
  var r = P9(P9({}, Ese), t), n = r.cx, a = r.cy, i = r.innerRadius, o = r.outerRadius, s = r.cornerRadius, l = r.forceCornerRadius, c = r.cornerIsExternal, u = r.startAngle, d = r.endAngle, p = r.className;
  if (o < i || u === d)
    return null;
  var h = De("recharts-sector", p), m = o - i, v = ir(s, m, 0, !0), g;
  return v > 0 && Math.abs(u - d) < 360 ? g = Pse({
    cx: n,
    cy: a,
    innerRadius: i,
    outerRadius: o,
    cornerRadius: Math.min(v, m / 2),
    forceCornerRadius: l,
    cornerIsExternal: c,
    startAngle: u,
    endAngle: d
  }) : g = LC({
    cx: n,
    cy: a,
    innerRadius: i,
    outerRadius: o,
    startAngle: u,
    endAngle: d
  }), /* @__PURE__ */ E.createElement("path", lf({}, he(r, !0), {
    className: h,
    d: g,
    role: "img"
  }));
};
function l1(e) {
  "@babel/helpers - typeof";
  return l1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, l1(e);
}
function cf() {
  return cf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cf.apply(this, arguments);
}
function E9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function j9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? E9(Object(r), !0).forEach(function(n) {
      jse(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : E9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function jse(e, t, r) {
  return t = _se(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function _se(e) {
  var t = Ase(e, "string");
  return l1(t) == "symbol" ? t : t + "";
}
function Ase(e, t) {
  if (l1(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (l1(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var _9 = {
  curveBasisClosed: MZ,
  curveBasisOpen: TZ,
  curveBasis: DZ,
  curveBumpX: mZ,
  curveBumpY: gZ,
  curveLinearClosed: $Z,
  curveLinear: Du,
  curveMonotoneX: NZ,
  curveMonotoneY: IZ,
  curveNatural: LZ,
  curveStep: kZ,
  curveStepAfter: BZ,
  curveStepBefore: RZ
}, hl = function(t) {
  return t.x === +t.x && t.y === +t.y;
}, rs = function(t) {
  return t.x;
}, ns = function(t) {
  return t.y;
}, Dse = function(t, r) {
  if (we(t))
    return t;
  var n = "curve".concat(_u(t));
  return (n === "curveMonotone" || n === "curveBump") && r ? _9["".concat(n).concat(r === "vertical" ? "Y" : "X")] : _9[n] || Du;
}, Mse = function(t) {
  var r = t.type, n = r === void 0 ? "linear" : r, a = t.points, i = a === void 0 ? [] : a, o = t.baseLine, s = t.layout, l = t.connectNulls, c = l === void 0 ? !1 : l, u = Dse(n, s), d = c ? i.filter(function(v) {
    return hl(v);
  }) : i, p;
  if (Array.isArray(o)) {
    var h = c ? o.filter(function(v) {
      return hl(v);
    }) : o, m = d.map(function(v, g) {
      return j9(j9({}, v), {}, {
        base: h[g]
      });
    });
    return s === "vertical" ? p = al().y(ns).x1(rs).x0(function(v) {
      return v.base.x;
    }) : p = al().x(rs).y1(ns).y0(function(v) {
      return v.base.y;
    }), p.defined(hl).curve(u), p(m);
  }
  return s === "vertical" && oe(o) ? p = al().y(ns).x1(rs).x0(o) : oe(o) ? p = al().x(rs).y1(ns).y0(o) : p = My().x(rs).y(ns), p.defined(hl).curve(u), p(d);
}, aa = function(t) {
  var r = t.className, n = t.points, a = t.path, i = t.pathRef;
  if ((!n || !n.length) && !a)
    return null;
  var o = n && n.length ? Mse(t) : a;
  return /* @__PURE__ */ E.createElement("path", cf({}, he(t, !1), Jl(t), {
    className: De("recharts-curve", r),
    d: o,
    ref: i
  }));
}, Tse = Object.getOwnPropertyNames, $se = Object.getOwnPropertySymbols, Nse = Object.prototype.hasOwnProperty;
function A9(e, t) {
  return function(n, a, i) {
    return e(n, a, i) && t(n, a, i);
  };
}
function vl(e) {
  return function(r, n, a) {
    if (!r || !n || typeof r != "object" || typeof n != "object")
      return e(r, n, a);
    var i = a.cache, o = i.get(r), s = i.get(n);
    if (o && s)
      return o === n && s === r;
    i.set(r, n), i.set(n, r);
    var l = e(r, n, a);
    return i.delete(r), i.delete(n), l;
  };
}
function D9(e) {
  return Tse(e).concat($se(e));
}
var RC = Object.hasOwn || function(e, t) {
  return Nse.call(e, t);
};
function Vo(e, t) {
  return e || t ? e === t : e === t || e !== e && t !== t;
}
var BC = "_owner", M9 = Object.getOwnPropertyDescriptor, T9 = Object.keys;
function Ise(e, t, r) {
  var n = e.length;
  if (t.length !== n)
    return !1;
  for (; n-- > 0; )
    if (!r.equals(e[n], t[n], n, n, e, t, r))
      return !1;
  return !0;
}
function Lse(e, t) {
  return Vo(e.getTime(), t.getTime());
}
function $9(e, t, r) {
  if (e.size !== t.size)
    return !1;
  for (var n = {}, a = e.entries(), i = 0, o, s; (o = a.next()) && !o.done; ) {
    for (var l = t.entries(), c = !1, u = 0; (s = l.next()) && !s.done; ) {
      var d = o.value, p = d[0], h = d[1], m = s.value, v = m[0], g = m[1];
      !c && !n[u] && (c = r.equals(p, v, i, u, e, t, r) && r.equals(h, g, p, v, e, t, r)) && (n[u] = !0), u++;
    }
    if (!c)
      return !1;
    i++;
  }
  return !0;
}
function kse(e, t, r) {
  var n = T9(e), a = n.length;
  if (T9(t).length !== a)
    return !1;
  for (var i; a-- > 0; )
    if (i = n[a], i === BC && (e.$$typeof || t.$$typeof) && e.$$typeof !== t.$$typeof || !RC(t, i) || !r.equals(e[i], t[i], i, i, e, t, r))
      return !1;
  return !0;
}
function as(e, t, r) {
  var n = D9(e), a = n.length;
  if (D9(t).length !== a)
    return !1;
  for (var i, o, s; a-- > 0; )
    if (i = n[a], i === BC && (e.$$typeof || t.$$typeof) && e.$$typeof !== t.$$typeof || !RC(t, i) || !r.equals(e[i], t[i], i, i, e, t, r) || (o = M9(e, i), s = M9(t, i), (o || s) && (!o || !s || o.configurable !== s.configurable || o.enumerable !== s.enumerable || o.writable !== s.writable)))
      return !1;
  return !0;
}
function Rse(e, t) {
  return Vo(e.valueOf(), t.valueOf());
}
function Bse(e, t) {
  return e.source === t.source && e.flags === t.flags;
}
function N9(e, t, r) {
  if (e.size !== t.size)
    return !1;
  for (var n = {}, a = e.values(), i, o; (i = a.next()) && !i.done; ) {
    for (var s = t.values(), l = !1, c = 0; (o = s.next()) && !o.done; )
      !l && !n[c] && (l = r.equals(i.value, o.value, i.value, o.value, e, t, r)) && (n[c] = !0), c++;
    if (!l)
      return !1;
  }
  return !0;
}
function Vse(e, t) {
  var r = e.length;
  if (t.length !== r)
    return !1;
  for (; r-- > 0; )
    if (e[r] !== t[r])
      return !1;
  return !0;
}
var Hse = "[object Arguments]", Fse = "[object Boolean]", Wse = "[object Date]", zse = "[object Map]", Use = "[object Number]", Zse = "[object Object]", qse = "[object RegExp]", Gse = "[object Set]", Yse = "[object String]", Kse = Array.isArray, I9 = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, L9 = Object.assign, Xse = Object.prototype.toString.call.bind(Object.prototype.toString);
function Qse(e) {
  var t = e.areArraysEqual, r = e.areDatesEqual, n = e.areMapsEqual, a = e.areObjectsEqual, i = e.arePrimitiveWrappersEqual, o = e.areRegExpsEqual, s = e.areSetsEqual, l = e.areTypedArraysEqual;
  return function(u, d, p) {
    if (u === d)
      return !0;
    if (u == null || d == null || typeof u != "object" || typeof d != "object")
      return u !== u && d !== d;
    var h = u.constructor;
    if (h !== d.constructor)
      return !1;
    if (h === Object)
      return a(u, d, p);
    if (Kse(u))
      return t(u, d, p);
    if (I9 != null && I9(u))
      return l(u, d, p);
    if (h === Date)
      return r(u, d, p);
    if (h === RegExp)
      return o(u, d, p);
    if (h === Map)
      return n(u, d, p);
    if (h === Set)
      return s(u, d, p);
    var m = Xse(u);
    return m === Wse ? r(u, d, p) : m === qse ? o(u, d, p) : m === zse ? n(u, d, p) : m === Gse ? s(u, d, p) : m === Zse ? typeof u.then != "function" && typeof d.then != "function" && a(u, d, p) : m === Hse ? a(u, d, p) : m === Fse || m === Use || m === Yse ? i(u, d, p) : !1;
  };
}
function Jse(e) {
  var t = e.circular, r = e.createCustomConfig, n = e.strict, a = {
    areArraysEqual: n ? as : Ise,
    areDatesEqual: Lse,
    areMapsEqual: n ? A9($9, as) : $9,
    areObjectsEqual: n ? as : kse,
    arePrimitiveWrappersEqual: Rse,
    areRegExpsEqual: Bse,
    areSetsEqual: n ? A9(N9, as) : N9,
    areTypedArraysEqual: n ? as : Vse
  };
  if (r && (a = L9({}, a, r(a))), t) {
    var i = vl(a.areArraysEqual), o = vl(a.areMapsEqual), s = vl(a.areObjectsEqual), l = vl(a.areSetsEqual);
    a = L9({}, a, {
      areArraysEqual: i,
      areMapsEqual: o,
      areObjectsEqual: s,
      areSetsEqual: l
    });
  }
  return a;
}
function e1e(e) {
  return function(t, r, n, a, i, o, s) {
    return e(t, r, s);
  };
}
function t1e(e) {
  var t = e.circular, r = e.comparator, n = e.createState, a = e.equals, i = e.strict;
  if (n)
    return function(l, c) {
      var u = n(), d = u.cache, p = d === void 0 ? t ? /* @__PURE__ */ new WeakMap() : void 0 : d, h = u.meta;
      return r(l, c, {
        cache: p,
        equals: a,
        meta: h,
        strict: i
      });
    };
  if (t)
    return function(l, c) {
      return r(l, c, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: a,
        meta: void 0,
        strict: i
      });
    };
  var o = {
    cache: void 0,
    equals: a,
    meta: void 0,
    strict: i
  };
  return function(l, c) {
    return r(l, c, o);
  };
}
var r1e = Ca();
Ca({ strict: !0 });
Ca({ circular: !0 });
Ca({
  circular: !0,
  strict: !0
});
Ca({
  createInternalComparator: function() {
    return Vo;
  }
});
Ca({
  strict: !0,
  createInternalComparator: function() {
    return Vo;
  }
});
Ca({
  circular: !0,
  createInternalComparator: function() {
    return Vo;
  }
});
Ca({
  circular: !0,
  createInternalComparator: function() {
    return Vo;
  },
  strict: !0
});
function Ca(e) {
  e === void 0 && (e = {});
  var t = e.circular, r = t === void 0 ? !1 : t, n = e.createInternalComparator, a = e.createState, i = e.strict, o = i === void 0 ? !1 : i, s = Jse(e), l = Qse(s), c = n ? n(l) : e1e(l);
  return t1e({ circular: r, comparator: l, createState: a, equals: c, strict: o });
}
function n1e(e) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
}
function k9(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = -1, n = function a(i) {
    r < 0 && (r = i), i - r > t ? (e(i), r = -1) : n1e(a);
  };
  requestAnimationFrame(n);
}
function uf(e) {
  "@babel/helpers - typeof";
  return uf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, uf(e);
}
function a1e(e) {
  return l1e(e) || s1e(e) || o1e(e) || i1e();
}
function i1e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function o1e(e, t) {
  if (e) {
    if (typeof e == "string")
      return R9(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return R9(e, t);
  }
}
function R9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function s1e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function l1e(e) {
  if (Array.isArray(e))
    return e;
}
function c1e() {
  var e = {}, t = function() {
    return null;
  }, r = !1, n = function a(i) {
    if (!r) {
      if (Array.isArray(i)) {
        if (!i.length)
          return;
        var o = i, s = a1e(o), l = s[0], c = s.slice(1);
        if (typeof l == "number") {
          k9(a.bind(null, c), l);
          return;
        }
        a(l), k9(a.bind(null, c));
        return;
      }
      uf(i) === "object" && (e = i, t(e)), typeof i == "function" && i();
    }
  };
  return {
    stop: function() {
      r = !0;
    },
    start: function(i) {
      r = !1, n(i);
    },
    subscribe: function(i) {
      return t = i, function() {
        t = function() {
          return null;
        };
      };
    }
  };
}
function c1(e) {
  "@babel/helpers - typeof";
  return c1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, c1(e);
}
function B9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function V9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? B9(Object(r), !0).forEach(function(n) {
      VC(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : B9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function VC(e, t, r) {
  return t = u1e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function u1e(e) {
  var t = f1e(e, "string");
  return c1(t) === "symbol" ? t : String(t);
}
function f1e(e, t) {
  if (c1(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (c1(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var d1e = function(t, r) {
  return [Object.keys(t), Object.keys(r)].reduce(function(n, a) {
    return n.filter(function(i) {
      return a.includes(i);
    });
  });
}, p1e = function(t) {
  return t;
}, h1e = function(t) {
  return t.replace(/([A-Z])/g, function(r) {
    return "-".concat(r.toLowerCase());
  });
}, Es = function(t, r) {
  return Object.keys(r).reduce(function(n, a) {
    return V9(V9({}, n), {}, VC({}, a, t(a, r[a])));
  }, {});
}, H9 = function(t, r, n) {
  return t.map(function(a) {
    return "".concat(h1e(a), " ").concat(r, "ms ").concat(n);
  }).join(",");
}, v1e = process.env.NODE_ENV !== "production", Ac = function(t, r, n, a, i, o, s, l) {
  if (v1e && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var c = [n, a, i, o, s, l], u = 0;
      console.warn(r.replace(/%s/g, function() {
        return c[u++];
      }));
    }
};
function m1e(e, t) {
  return b1e(e) || y1e(e, t) || HC(e, t) || g1e();
}
function g1e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function y1e(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function b1e(e) {
  if (Array.isArray(e))
    return e;
}
function C1e(e) {
  return O1e(e) || w1e(e) || HC(e) || x1e();
}
function x1e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function HC(e, t) {
  if (e) {
    if (typeof e == "string")
      return ff(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return ff(e, t);
  }
}
function w1e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function O1e(e) {
  if (Array.isArray(e))
    return ff(e);
}
function ff(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var Dc = 1e-4, FC = function(t, r) {
  return [0, 3 * t, 3 * r - 6 * t, 3 * t - 3 * r + 1];
}, WC = function(t, r) {
  return t.map(function(n, a) {
    return n * Math.pow(r, a);
  }).reduce(function(n, a) {
    return n + a;
  });
}, F9 = function(t, r) {
  return function(n) {
    var a = FC(t, r);
    return WC(a, n);
  };
}, S1e = function(t, r) {
  return function(n) {
    var a = FC(t, r), i = [].concat(C1e(a.map(function(o, s) {
      return o * s;
    }).slice(1)), [0]);
    return WC(i, n);
  };
}, W9 = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var a = r[0], i = r[1], o = r[2], s = r[3];
  if (r.length === 1)
    switch (r[0]) {
      case "linear":
        a = 0, i = 0, o = 1, s = 1;
        break;
      case "ease":
        a = 0.25, i = 0.1, o = 0.25, s = 1;
        break;
      case "ease-in":
        a = 0.42, i = 0, o = 1, s = 1;
        break;
      case "ease-out":
        a = 0.42, i = 0, o = 0.58, s = 1;
        break;
      case "ease-in-out":
        a = 0, i = 0, o = 0.58, s = 1;
        break;
      default: {
        var l = r[0].split("(");
        if (l[0] === "cubic-bezier" && l[1].split(")")[0].split(",").length === 4) {
          var c = l[1].split(")")[0].split(",").map(function(g) {
            return parseFloat(g);
          }), u = m1e(c, 4);
          a = u[0], i = u[1], o = u[2], s = u[3];
        } else
          Ac(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", r);
      }
    }
  Ac([a, o, i, s].every(function(g) {
    return typeof g == "number" && g >= 0 && g <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", r);
  var d = F9(a, o), p = F9(i, s), h = S1e(a, o), m = function(b) {
    return b > 1 ? 1 : b < 0 ? 0 : b;
  }, v = function(b) {
    for (var C = b > 1 ? 1 : b, w = C, x = 0; x < 8; ++x) {
      var y = d(w) - C, O = h(w);
      if (Math.abs(y - C) < Dc || O < Dc)
        return p(w);
      w = m(w - y / O);
    }
    return p(w);
  };
  return v.isStepper = !1, v;
}, P1e = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.stiff, n = r === void 0 ? 100 : r, a = t.damping, i = a === void 0 ? 8 : a, o = t.dt, s = o === void 0 ? 17 : o, l = function(u, d, p) {
    var h = -(u - d) * n, m = p * i, v = p + (h - m) * s / 1e3, g = p * s / 1e3 + u;
    return Math.abs(g - d) < Dc && Math.abs(v) < Dc ? [d, 0] : [g, v];
  };
  return l.isStepper = !0, l.dt = s, l;
}, E1e = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var a = r[0];
  if (typeof a == "string")
    switch (a) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return W9(a);
      case "spring":
        return P1e();
      default:
        if (a.split("(")[0] === "cubic-bezier")
          return W9(a);
        Ac(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", r);
    }
  return typeof a == "function" ? a : (Ac(!1, "[configEasing]: first argument type should be function or string, instead received %s", r), null);
};
function u1(e) {
  "@babel/helpers - typeof";
  return u1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, u1(e);
}
function z9(e) {
  return A1e(e) || _1e(e) || zC(e) || j1e();
}
function j1e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _1e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function A1e(e) {
  if (Array.isArray(e))
    return pf(e);
}
function U9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Gt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? U9(Object(r), !0).forEach(function(n) {
      df(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : U9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function df(e, t, r) {
  return t = D1e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function D1e(e) {
  var t = M1e(e, "string");
  return u1(t) === "symbol" ? t : String(t);
}
function M1e(e, t) {
  if (u1(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (u1(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function T1e(e, t) {
  return I1e(e) || N1e(e, t) || zC(e, t) || $1e();
}
function $1e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zC(e, t) {
  if (e) {
    if (typeof e == "string")
      return pf(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return pf(e, t);
  }
}
function pf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function N1e(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function I1e(e) {
  if (Array.isArray(e))
    return e;
}
var Mc = function(t, r, n) {
  return t + (r - t) * n;
}, hf = function(t) {
  var r = t.from, n = t.to;
  return r !== n;
}, L1e = function e(t, r, n) {
  var a = Es(function(i, o) {
    if (hf(o)) {
      var s = t(o.from, o.to, o.velocity), l = T1e(s, 2), c = l[0], u = l[1];
      return Gt(Gt({}, o), {}, {
        from: c,
        velocity: u
      });
    }
    return o;
  }, r);
  return n < 1 ? Es(function(i, o) {
    return hf(o) ? Gt(Gt({}, o), {}, {
      velocity: Mc(o.velocity, a[i].velocity, n),
      from: Mc(o.from, a[i].from, n)
    }) : o;
  }, r) : e(t, a, n - 1);
};
const k1e = function(e, t, r, n, a) {
  var i = d1e(e, t), o = i.reduce(function(g, b) {
    return Gt(Gt({}, g), {}, df({}, b, [e[b], t[b]]));
  }, {}), s = i.reduce(function(g, b) {
    return Gt(Gt({}, g), {}, df({}, b, {
      from: e[b],
      velocity: 0,
      to: t[b]
    }));
  }, {}), l = -1, c, u, d = function() {
    return null;
  }, p = function() {
    return Es(function(b, C) {
      return C.from;
    }, s);
  }, h = function() {
    return !Object.values(s).filter(hf).length;
  }, m = function(b) {
    c || (c = b);
    var C = b - c, w = C / r.dt;
    s = L1e(r, s, w), a(Gt(Gt(Gt({}, e), t), p())), c = b, h() || (l = requestAnimationFrame(d));
  }, v = function(b) {
    u || (u = b);
    var C = (b - u) / n, w = Es(function(y, O) {
      return Mc.apply(void 0, z9(O).concat([r(C)]));
    }, o);
    if (a(Gt(Gt(Gt({}, e), t), w)), C < 1)
      l = requestAnimationFrame(d);
    else {
      var x = Es(function(y, O) {
        return Mc.apply(void 0, z9(O).concat([r(1)]));
      }, o);
      a(Gt(Gt(Gt({}, e), t), x));
    }
  };
  return d = r.isStepper ? m : v, function() {
    return requestAnimationFrame(d), function() {
      cancelAnimationFrame(l);
    };
  };
};
function to(e) {
  "@babel/helpers - typeof";
  return to = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, to(e);
}
var R1e = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function B1e(e, t) {
  if (e == null)
    return {};
  var r = V1e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function V1e(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function P3(e) {
  return z1e(e) || W1e(e) || F1e(e) || H1e();
}
function H1e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function F1e(e, t) {
  if (e) {
    if (typeof e == "string")
      return vf(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return vf(e, t);
  }
}
function W1e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function z1e(e) {
  if (Array.isArray(e))
    return vf(e);
}
function vf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Z9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function zr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Z9(Object(r), !0).forEach(function(n) {
      ls(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Z9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ls(e, t, r) {
  return t = UC(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function U1e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function q9(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, UC(n.key), n);
  }
}
function Z1e(e, t, r) {
  return t && q9(e.prototype, t), r && q9(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function UC(e) {
  var t = q1e(e, "string");
  return to(t) === "symbol" ? t : String(t);
}
function q1e(e, t) {
  if (to(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (to(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function G1e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && mf(e, t);
}
function mf(e, t) {
  return mf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, mf(e, t);
}
function Y1e(e) {
  var t = K1e();
  return function() {
    var n = Tc(e), a;
    if (t) {
      var i = Tc(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return gf(this, a);
  };
}
function gf(e, t) {
  if (t && (to(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return yf(e);
}
function yf(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function K1e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Tc(e) {
  return Tc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Tc(e);
}
var Br = /* @__PURE__ */ function(e) {
  G1e(r, e);
  var t = Y1e(r);
  function r(n, a) {
    var i;
    U1e(this, r), i = t.call(this, n, a);
    var o = i.props, s = o.isActive, l = o.attributeName, c = o.from, u = o.to, d = o.steps, p = o.children, h = o.duration;
    if (i.handleStyleChange = i.handleStyleChange.bind(yf(i)), i.changeStyle = i.changeStyle.bind(yf(i)), !s || h <= 0)
      return i.state = {
        style: {}
      }, typeof p == "function" && (i.state = {
        style: u
      }), gf(i);
    if (d && d.length)
      i.state = {
        style: d[0].style
      };
    else if (c) {
      if (typeof p == "function")
        return i.state = {
          style: c
        }, gf(i);
      i.state = {
        style: l ? ls({}, l, c) : c
      };
    } else
      i.state = {
        style: {}
      };
    return i;
  }
  return Z1e(r, [{
    key: "componentDidMount",
    value: function() {
      var a = this.props, i = a.isActive, o = a.canBegin;
      this.mounted = !0, !(!i || !o) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      var i = this.props, o = i.isActive, s = i.canBegin, l = i.attributeName, c = i.shouldReAnimate, u = i.to, d = i.from, p = this.state.style;
      if (s) {
        if (!o) {
          var h = {
            style: l ? ls({}, l, u) : u
          };
          this.state && p && (l && p[l] !== u || !l && p !== u) && this.setState(h);
          return;
        }
        if (!(r1e(a.to, u) && a.canBegin && a.isActive)) {
          var m = !a.canBegin || !a.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var v = m || c ? d : a.to;
          if (this.state && p) {
            var g = {
              style: l ? ls({}, l, v) : v
            };
            (l && p[l] !== v || !l && p !== v) && this.setState(g);
          }
          this.runAnimation(zr(zr({}, this.props), {}, {
            from: v,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var a = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), a && a();
    }
  }, {
    key: "handleStyleChange",
    value: function(a) {
      this.changeStyle(a);
    }
  }, {
    key: "changeStyle",
    value: function(a) {
      this.mounted && this.setState({
        style: a
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(a) {
      var i = this, o = a.from, s = a.to, l = a.duration, c = a.easing, u = a.begin, d = a.onAnimationEnd, p = a.onAnimationStart, h = k1e(o, s, E1e(c), l, this.changeStyle), m = function() {
        i.stopJSAnimation = h();
      };
      this.manager.start([p, u, m, l, d]);
    }
  }, {
    key: "runStepAnimation",
    value: function(a) {
      var i = this, o = a.steps, s = a.begin, l = a.onAnimationStart, c = o[0], u = c.style, d = c.duration, p = d === void 0 ? 0 : d, h = function(v, g, b) {
        if (b === 0)
          return v;
        var C = g.duration, w = g.easing, x = w === void 0 ? "ease" : w, y = g.style, O = g.properties, P = g.onAnimationEnd, j = b > 0 ? o[b - 1] : g, T = O || Object.keys(y);
        if (typeof x == "function" || x === "spring")
          return [].concat(P3(v), [i.runJSAnimation.bind(i, {
            from: j.style,
            to: y,
            duration: C,
            easing: x
          }), C]);
        var I = H9(T, C, x), R = zr(zr(zr({}, j.style), y), {}, {
          transition: I
        });
        return [].concat(P3(v), [R, C, P]).filter(p1e);
      };
      return this.manager.start([l].concat(P3(o.reduce(h, [u, Math.max(p, s)])), [a.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(a) {
      this.manager || (this.manager = c1e());
      var i = a.begin, o = a.duration, s = a.attributeName, l = a.to, c = a.easing, u = a.onAnimationStart, d = a.onAnimationEnd, p = a.steps, h = a.children, m = this.manager;
      if (this.unSubscribe = m.subscribe(this.handleStyleChange), typeof c == "function" || typeof h == "function" || c === "spring") {
        this.runJSAnimation(a);
        return;
      }
      if (p.length > 1) {
        this.runStepAnimation(a);
        return;
      }
      var v = s ? ls({}, s, l) : l, g = H9(Object.keys(v), o, c);
      m.start([u, i, zr(zr({}, v), {}, {
        transition: g
      }), o, d]);
    }
  }, {
    key: "render",
    value: function() {
      var a = this.props, i = a.children;
      a.begin;
      var o = a.duration;
      a.attributeName, a.easing;
      var s = a.isActive;
      a.steps, a.from, a.to, a.canBegin, a.onAnimationEnd, a.shouldReAnimate, a.onAnimationReStart;
      var l = B1e(a, R1e), c = Ua.count(i), u = this.state.style;
      if (typeof i == "function")
        return i(u);
      if (!s || c === 0 || o <= 0)
        return i;
      var d = function(h) {
        var m = h.props, v = m.style, g = v === void 0 ? {} : v, b = m.className, C = /* @__PURE__ */ Rt(h, zr(zr({}, l), {}, {
          style: zr(zr({}, g), u),
          className: b
        }));
        return C;
      };
      return c === 1 ? d(Ua.only(i)) : /* @__PURE__ */ E.createElement("div", null, Ua.map(i, function(p) {
        return d(p);
      }));
    }
  }]), r;
}(Pr);
Br.displayName = "Animate";
Br.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
Br.propTypes = {
  from: Pe.oneOfType([Pe.object, Pe.string]),
  to: Pe.oneOfType([Pe.object, Pe.string]),
  attributeName: Pe.string,
  // animation duration
  duration: Pe.number,
  begin: Pe.number,
  easing: Pe.oneOfType([Pe.string, Pe.func]),
  steps: Pe.arrayOf(Pe.shape({
    duration: Pe.number.isRequired,
    style: Pe.object.isRequired,
    easing: Pe.oneOfType([Pe.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), Pe.func]),
    // transition css properties(dash case), optional
    properties: Pe.arrayOf("string"),
    onAnimationEnd: Pe.func
  })),
  children: Pe.oneOfType([Pe.node, Pe.func]),
  isActive: Pe.bool,
  canBegin: Pe.bool,
  onAnimationEnd: Pe.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: Pe.bool,
  onAnimationStart: Pe.func,
  onAnimationReStart: Pe.func
};
Pe.object, Pe.object, Pe.object, Pe.element;
Pe.object, Pe.object, Pe.object, Pe.oneOfType([Pe.array, Pe.element]), Pe.any;
function f1(e) {
  "@babel/helpers - typeof";
  return f1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, f1(e);
}
function $c() {
  return $c = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $c.apply(this, arguments);
}
function X1e(e, t) {
  return tle(e) || ele(e, t) || J1e(e, t) || Q1e();
}
function Q1e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function J1e(e, t) {
  if (e) {
    if (typeof e == "string")
      return G9(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return G9(e, t);
  }
}
function G9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function ele(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function tle(e) {
  if (Array.isArray(e))
    return e;
}
function Y9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function K9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Y9(Object(r), !0).forEach(function(n) {
      rle(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Y9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function rle(e, t, r) {
  return t = nle(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function nle(e) {
  var t = ale(e, "string");
  return f1(t) == "symbol" ? t : t + "";
}
function ale(e, t) {
  if (f1(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (f1(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var X9 = function(t, r, n, a, i) {
  var o = Math.min(Math.abs(n) / 2, Math.abs(a) / 2), s = a >= 0 ? 1 : -1, l = n >= 0 ? 1 : -1, c = a >= 0 && n >= 0 || a < 0 && n < 0 ? 1 : 0, u;
  if (o > 0 && i instanceof Array) {
    for (var d = [0, 0, 0, 0], p = 0, h = 4; p < h; p++)
      d[p] = i[p] > o ? o : i[p];
    u = "M".concat(t, ",").concat(r + s * d[0]), d[0] > 0 && (u += "A ".concat(d[0], ",").concat(d[0], ",0,0,").concat(c, ",").concat(t + l * d[0], ",").concat(r)), u += "L ".concat(t + n - l * d[1], ",").concat(r), d[1] > 0 && (u += "A ".concat(d[1], ",").concat(d[1], ",0,0,").concat(c, `,
        `).concat(t + n, ",").concat(r + s * d[1])), u += "L ".concat(t + n, ",").concat(r + a - s * d[2]), d[2] > 0 && (u += "A ".concat(d[2], ",").concat(d[2], ",0,0,").concat(c, `,
        `).concat(t + n - l * d[2], ",").concat(r + a)), u += "L ".concat(t + l * d[3], ",").concat(r + a), d[3] > 0 && (u += "A ".concat(d[3], ",").concat(d[3], ",0,0,").concat(c, `,
        `).concat(t, ",").concat(r + a - s * d[3])), u += "Z";
  } else if (o > 0 && i === +i && i > 0) {
    var m = Math.min(o, i);
    u = "M ".concat(t, ",").concat(r + s * m, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(t + l * m, ",").concat(r, `
            L `).concat(t + n - l * m, ",").concat(r, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(t + n, ",").concat(r + s * m, `
            L `).concat(t + n, ",").concat(r + a - s * m, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(t + n - l * m, ",").concat(r + a, `
            L `).concat(t + l * m, ",").concat(r + a, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(t, ",").concat(r + a - s * m, " Z");
  } else
    u = "M ".concat(t, ",").concat(r, " h ").concat(n, " v ").concat(a, " h ").concat(-n, " Z");
  return u;
}, ile = function(t, r) {
  if (!t || !r)
    return !1;
  var n = t.x, a = t.y, i = r.x, o = r.y, s = r.width, l = r.height;
  if (Math.abs(s) > 0 && Math.abs(l) > 0) {
    var c = Math.min(i, i + s), u = Math.max(i, i + s), d = Math.min(o, o + l), p = Math.max(o, o + l);
    return n >= c && n <= u && a >= d && a <= p;
  }
  return !1;
}, ole = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Y6 = function(t) {
  var r = K9(K9({}, ole), t), n = ve(), a = ye(-1), i = X1e(a, 2), o = i[0], s = i[1];
  _e(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var x = n.current.getTotalLength();
        x && s(x);
      } catch {
      }
  }, []);
  var l = r.x, c = r.y, u = r.width, d = r.height, p = r.radius, h = r.className, m = r.animationEasing, v = r.animationDuration, g = r.animationBegin, b = r.isAnimationActive, C = r.isUpdateAnimationActive;
  if (l !== +l || c !== +c || u !== +u || d !== +d || u === 0 || d === 0)
    return null;
  var w = De("recharts-rectangle", h);
  return C ? /* @__PURE__ */ E.createElement(Br, {
    canBegin: o > 0,
    from: {
      width: u,
      height: d,
      x: l,
      y: c
    },
    to: {
      width: u,
      height: d,
      x: l,
      y: c
    },
    duration: v,
    animationEasing: m,
    isActive: C
  }, function(x) {
    var y = x.width, O = x.height, P = x.x, j = x.y;
    return /* @__PURE__ */ E.createElement(Br, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: g,
      duration: v,
      isActive: b,
      easing: m
    }, /* @__PURE__ */ E.createElement("path", $c({}, he(r, !0), {
      className: w,
      d: X9(P, j, y, O, p),
      ref: n
    })));
  }) : /* @__PURE__ */ E.createElement("path", $c({}, he(r, !0), {
    className: w,
    d: X9(l, c, u, d, p)
  }));
}, sle = ["points", "className", "baseLinePoints", "connectNulls"];
function _i() {
  return _i = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _i.apply(this, arguments);
}
function lle(e, t) {
  if (e == null)
    return {};
  var r = cle(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function cle(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function Q9(e) {
  return ple(e) || dle(e) || fle(e) || ule();
}
function ule() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fle(e, t) {
  if (e) {
    if (typeof e == "string")
      return bf(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return bf(e, t);
  }
}
function dle(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function ple(e) {
  if (Array.isArray(e))
    return bf(e);
}
function bf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var J9 = function(t) {
  return t && t.x === +t.x && t.y === +t.y;
}, hle = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = [[]];
  return t.forEach(function(n) {
    J9(n) ? r[r.length - 1].push(n) : r[r.length - 1].length > 0 && r.push([]);
  }), J9(t[0]) && r[r.length - 1].push(t[0]), r[r.length - 1].length <= 0 && (r = r.slice(0, -1)), r;
}, js = function(t, r) {
  var n = hle(t);
  r && (n = [n.reduce(function(i, o) {
    return [].concat(Q9(i), Q9(o));
  }, [])]);
  var a = n.map(function(i) {
    return i.reduce(function(o, s, l) {
      return "".concat(o).concat(l === 0 ? "M" : "L").concat(s.x, ",").concat(s.y);
    }, "");
  }).join("");
  return n.length === 1 ? "".concat(a, "Z") : a;
}, vle = function(t, r, n) {
  var a = js(t, n);
  return "".concat(a.slice(-1) === "Z" ? a.slice(0, -1) : a, "L").concat(js(r.reverse(), n).slice(1));
}, mle = function(t) {
  var r = t.points, n = t.className, a = t.baseLinePoints, i = t.connectNulls, o = lle(t, sle);
  if (!r || !r.length)
    return null;
  var s = De("recharts-polygon", n);
  if (a && a.length) {
    var l = o.stroke && o.stroke !== "none", c = vle(r, a, i);
    return /* @__PURE__ */ E.createElement("g", {
      className: s
    }, /* @__PURE__ */ E.createElement("path", _i({}, he(o, !0), {
      fill: c.slice(-1) === "Z" ? o.fill : "none",
      stroke: "none",
      d: c
    })), l ? /* @__PURE__ */ E.createElement("path", _i({}, he(o, !0), {
      fill: "none",
      d: js(r, i)
    })) : null, l ? /* @__PURE__ */ E.createElement("path", _i({}, he(o, !0), {
      fill: "none",
      d: js(a, i)
    })) : null);
  }
  var u = js(r, i);
  return /* @__PURE__ */ E.createElement("path", _i({}, he(o, !0), {
    fill: u.slice(-1) === "Z" ? o.fill : "none",
    className: s,
    d: u
  }));
};
function Cf() {
  return Cf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Cf.apply(this, arguments);
}
var W1 = function(t) {
  var r = t.cx, n = t.cy, a = t.r, i = t.className, o = De("recharts-dot", i);
  return r === +r && n === +n && a === +a ? /* @__PURE__ */ E.createElement("circle", Cf({}, he(t, !1), Jl(t), {
    className: o,
    cx: r,
    cy: n,
    r: a
  })) : null;
};
function d1(e) {
  "@babel/helpers - typeof";
  return d1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, d1(e);
}
var gle = ["x", "y", "top", "left", "width", "height", "className"];
function xf() {
  return xf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xf.apply(this, arguments);
}
function eh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function yle(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? eh(Object(r), !0).forEach(function(n) {
      ble(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : eh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ble(e, t, r) {
  return t = Cle(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Cle(e) {
  var t = xle(e, "string");
  return d1(t) == "symbol" ? t : t + "";
}
function xle(e, t) {
  if (d1(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (d1(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function wle(e, t) {
  if (e == null)
    return {};
  var r = Ole(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Ole(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
var Sle = function(t, r, n, a, i, o) {
  return "M".concat(t, ",").concat(i, "v").concat(a, "M").concat(o, ",").concat(r, "h").concat(n);
}, Ple = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, a = t.y, i = a === void 0 ? 0 : a, o = t.top, s = o === void 0 ? 0 : o, l = t.left, c = l === void 0 ? 0 : l, u = t.width, d = u === void 0 ? 0 : u, p = t.height, h = p === void 0 ? 0 : p, m = t.className, v = wle(t, gle), g = yle({
    x: n,
    y: i,
    top: s,
    left: c,
    width: d,
    height: h
  }, v);
  return !oe(n) || !oe(i) || !oe(d) || !oe(h) || !oe(s) || !oe(c) ? null : /* @__PURE__ */ E.createElement("path", xf({}, he(g, !0), {
    className: De("recharts-cross", m),
    d: Sle(n, i, d, h, s, c)
  }));
}, Ele = Fu, jle = iC, _le = wn;
function Ale(e, t) {
  return e && e.length ? Ele(e, _le(t), jle) : void 0;
}
var Dle = Ale;
const Mle = /* @__PURE__ */ Ze(Dle);
var Tle = Fu, $le = wn, Nle = oC;
function Ile(e, t) {
  return e && e.length ? Tle(e, $le(t), Nle) : void 0;
}
var Lle = Ile;
const kle = /* @__PURE__ */ Ze(Lle);
var Rle = ["cx", "cy", "angle", "ticks", "axisLine"], Ble = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function ro(e) {
  "@babel/helpers - typeof";
  return ro = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ro(e);
}
function _s() {
  return _s = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _s.apply(this, arguments);
}
function th(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ja(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? th(Object(r), !0).forEach(function(n) {
      Zu(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : th(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function rh(e, t) {
  if (e == null)
    return {};
  var r = Vle(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Vle(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function Hle(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function nh(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, qC(n.key), n);
  }
}
function Fle(e, t, r) {
  return t && nh(e.prototype, t), r && nh(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Wle(e, t, r) {
  return t = Nc(t), zle(e, ZC() ? Reflect.construct(t, r || [], Nc(e).constructor) : t.apply(e, r));
}
function zle(e, t) {
  if (t && (ro(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ule(e);
}
function Ule(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ZC() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ZC = function() {
    return !!e;
  })();
}
function Nc(e) {
  return Nc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Nc(e);
}
function Zle(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && wf(e, t);
}
function wf(e, t) {
  return wf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, wf(e, t);
}
function Zu(e, t, r) {
  return t = qC(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function qC(e) {
  var t = qle(e, "string");
  return ro(t) == "symbol" ? t : t + "";
}
function qle(e, t) {
  if (ro(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ro(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var qu = /* @__PURE__ */ function(e) {
  function t() {
    return Hle(this, t), Wle(this, t, arguments);
  }
  return Zle(t, e), Fle(t, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      function(n) {
        var a = n.coordinate, i = this.props, o = i.angle, s = i.cx, l = i.cy;
        return dt(s, l, a, o);
      }
    )
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props.orientation, a;
      switch (n) {
        case "left":
          a = "end";
          break;
        case "right":
          a = "start";
          break;
        default:
          a = "middle";
          break;
      }
      return a;
    }
  }, {
    key: "getViewBox",
    value: function() {
      var n = this.props, a = n.cx, i = n.cy, o = n.angle, s = n.ticks, l = Mle(s, function(u) {
        return u.coordinate || 0;
      }), c = kle(s, function(u) {
        return u.coordinate || 0;
      });
      return {
        cx: a,
        cy: i,
        startAngle: o,
        endAngle: o,
        innerRadius: c.coordinate || 0,
        outerRadius: l.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.cx, i = n.cy, o = n.angle, s = n.ticks, l = n.axisLine, c = rh(n, Rle), u = s.reduce(function(m, v) {
        return [Math.min(m[0], v.coordinate), Math.max(m[1], v.coordinate)];
      }, [1 / 0, -1 / 0]), d = dt(a, i, u[0], o), p = dt(a, i, u[1], o), h = ja(ja(ja({}, he(c, !1)), {}, {
        fill: "none"
      }, he(l, !1)), {}, {
        x1: d.x,
        y1: d.y,
        x2: p.x,
        y2: p.y
      });
      return /* @__PURE__ */ E.createElement("line", _s({
        className: "recharts-polar-radius-axis-line"
      }, h));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, a = this.props, i = a.ticks, o = a.tick, s = a.angle, l = a.tickFormatter, c = a.stroke, u = rh(a, Ble), d = this.getTickTextAnchor(), p = he(u, !1), h = he(o, !1), m = i.map(function(v, g) {
        var b = n.getTickValueCoord(v), C = ja(ja(ja(ja({
          textAnchor: d,
          transform: "rotate(".concat(90 - s, ", ").concat(b.x, ", ").concat(b.y, ")")
        }, p), {}, {
          stroke: "none",
          fill: c
        }, h), {}, {
          index: g
        }, b), {}, {
          payload: v
        });
        return /* @__PURE__ */ E.createElement(Me, _s({
          className: De("recharts-polar-radius-axis-tick", NC(o)),
          key: "tick-".concat(v.coordinate)
        }, sa(n.props, v, g)), t.renderTickItem(o, C, l ? l(v.value, g) : v.value));
      });
      return /* @__PURE__ */ E.createElement(Me, {
        className: "recharts-polar-radius-axis-ticks"
      }, m);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.ticks, i = n.axisLine, o = n.tick;
      return !a || !a.length ? null : /* @__PURE__ */ E.createElement(Me, {
        className: De("recharts-polar-radius-axis", this.props.className)
      }, i && this.renderAxisLine(), o && this.renderTicks(), Bt.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, i) {
      var o;
      return /* @__PURE__ */ E.isValidElement(n) ? o = /* @__PURE__ */ E.cloneElement(n, a) : we(n) ? o = n(a) : o = /* @__PURE__ */ E.createElement(Qa, _s({}, a, {
        className: "recharts-polar-radius-axis-tick-value"
      }), i), o;
    }
  }]);
}(Pr);
Zu(qu, "displayName", "PolarRadiusAxis");
Zu(qu, "axisType", "radiusAxis");
Zu(qu, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: !0,
  tick: !0,
  tickCount: 5,
  allowDataOverflow: !1,
  scale: "auto",
  allowDuplicatedCategory: !0
});
function no(e) {
  "@babel/helpers - typeof";
  return no = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, no(e);
}
function Ra() {
  return Ra = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ra.apply(this, arguments);
}
function ah(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _a(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ah(Object(r), !0).forEach(function(n) {
      Gu(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ah(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Gle(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ih(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, YC(n.key), n);
  }
}
function Yle(e, t, r) {
  return t && ih(e.prototype, t), r && ih(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Kle(e, t, r) {
  return t = Ic(t), Xle(e, GC() ? Reflect.construct(t, r || [], Ic(e).constructor) : t.apply(e, r));
}
function Xle(e, t) {
  if (t && (no(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Qle(e);
}
function Qle(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function GC() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (GC = function() {
    return !!e;
  })();
}
function Ic(e) {
  return Ic = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ic(e);
}
function Jle(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Of(e, t);
}
function Of(e, t) {
  return Of = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Of(e, t);
}
function Gu(e, t, r) {
  return t = YC(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function YC(e) {
  var t = ece(e, "string");
  return no(t) == "symbol" ? t : t + "";
}
function ece(e, t) {
  if (no(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (no(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var tce = Math.PI / 180, oh = 1e-5, Yu = /* @__PURE__ */ function(e) {
  function t() {
    return Gle(this, t), Kle(this, t, arguments);
  }
  return Jle(t, e), Yle(t, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function(n) {
        var a = this.props, i = a.cx, o = a.cy, s = a.radius, l = a.orientation, c = a.tickSize, u = c || 8, d = dt(i, o, s, n.coordinate), p = dt(i, o, s + (l === "inner" ? -1 : 1) * u, n.coordinate);
        return {
          x1: d.x,
          y1: d.y,
          x2: p.x,
          y2: p.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function(n) {
      var a = this.props.orientation, i = Math.cos(-n.coordinate * tce), o;
      return i > oh ? o = a === "outer" ? "start" : "end" : i < -oh ? o = a === "outer" ? "end" : "start" : o = "middle", o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.cx, i = n.cy, o = n.radius, s = n.axisLine, l = n.axisLineType, c = _a(_a({}, he(this.props, !1)), {}, {
        fill: "none"
      }, he(s, !1));
      if (l === "circle")
        return /* @__PURE__ */ E.createElement(W1, Ra({
          className: "recharts-polar-angle-axis-line"
        }, c, {
          cx: a,
          cy: i,
          r: o
        }));
      var u = this.props.ticks, d = u.map(function(p) {
        return dt(a, i, o, p.coordinate);
      });
      return /* @__PURE__ */ E.createElement(mle, Ra({
        className: "recharts-polar-angle-axis-line"
      }, c, {
        points: d
      }));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, a = this.props, i = a.ticks, o = a.tick, s = a.tickLine, l = a.tickFormatter, c = a.stroke, u = he(this.props, !1), d = he(o, !1), p = _a(_a({}, u), {}, {
        fill: "none"
      }, he(s, !1)), h = i.map(function(m, v) {
        var g = n.getTickLineCoord(m), b = n.getTickTextAnchor(m), C = _a(_a(_a({
          textAnchor: b
        }, u), {}, {
          stroke: "none",
          fill: c
        }, d), {}, {
          index: v,
          payload: m,
          x: g.x2,
          y: g.y2
        });
        return /* @__PURE__ */ E.createElement(Me, Ra({
          className: De("recharts-polar-angle-axis-tick", NC(o)),
          key: "tick-".concat(m.coordinate)
        }, sa(n.props, m, v)), s && /* @__PURE__ */ E.createElement("line", Ra({
          className: "recharts-polar-angle-axis-tick-line"
        }, p, g)), o && t.renderTickItem(o, C, l ? l(m.value, v) : m.value));
      });
      return /* @__PURE__ */ E.createElement(Me, {
        className: "recharts-polar-angle-axis-ticks"
      }, h);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.ticks, i = n.radius, o = n.axisLine;
      return i <= 0 || !a || !a.length ? null : /* @__PURE__ */ E.createElement(Me, {
        className: De("recharts-polar-angle-axis", this.props.className)
      }, o && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, i) {
      var o;
      return /* @__PURE__ */ E.isValidElement(n) ? o = /* @__PURE__ */ E.cloneElement(n, a) : we(n) ? o = n(a) : o = /* @__PURE__ */ E.createElement(Qa, Ra({}, a, {
        className: "recharts-polar-angle-axis-tick-value"
      }), i), o;
    }
  }]);
}(Pr);
Gu(Yu, "displayName", "PolarAngleAxis");
Gu(Yu, "axisType", "angleAxis");
Gu(Yu, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
});
var rce = tb, nce = rce(Object.getPrototypeOf, Object), ace = nce, ice = Fn, oce = ace, sce = Wn, lce = "[object Object]", cce = Function.prototype, uce = Object.prototype, KC = cce.toString, fce = uce.hasOwnProperty, dce = KC.call(Object);
function pce(e) {
  if (!sce(e) || ice(e) != lce)
    return !1;
  var t = oce(e);
  if (t === null)
    return !0;
  var r = fce.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && KC.call(r) == dce;
}
var hce = pce;
const vce = /* @__PURE__ */ Ze(hce);
var mce = Fn, gce = Wn, yce = "[object Boolean]";
function bce(e) {
  return e === !0 || e === !1 || gce(e) && mce(e) == yce;
}
var Cce = bce;
const xce = /* @__PURE__ */ Ze(Cce);
function p1(e) {
  "@babel/helpers - typeof";
  return p1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, p1(e);
}
function Lc() {
  return Lc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Lc.apply(this, arguments);
}
function wce(e, t) {
  return Ece(e) || Pce(e, t) || Sce(e, t) || Oce();
}
function Oce() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Sce(e, t) {
  if (e) {
    if (typeof e == "string")
      return sh(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return sh(e, t);
  }
}
function sh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Pce(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function Ece(e) {
  if (Array.isArray(e))
    return e;
}
function lh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ch(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? lh(Object(r), !0).forEach(function(n) {
      jce(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : lh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function jce(e, t, r) {
  return t = _ce(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function _ce(e) {
  var t = Ace(e, "string");
  return p1(t) == "symbol" ? t : t + "";
}
function Ace(e, t) {
  if (p1(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (p1(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var uh = function(t, r, n, a, i) {
  var o = n - a, s;
  return s = "M ".concat(t, ",").concat(r), s += "L ".concat(t + n, ",").concat(r), s += "L ".concat(t + n - o / 2, ",").concat(r + i), s += "L ".concat(t + n - o / 2 - a, ",").concat(r + i), s += "L ".concat(t, ",").concat(r, " Z"), s;
}, Dce = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Mce = function(t) {
  var r = ch(ch({}, Dce), t), n = ve(), a = ye(-1), i = wce(a, 2), o = i[0], s = i[1];
  _e(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var w = n.current.getTotalLength();
        w && s(w);
      } catch {
      }
  }, []);
  var l = r.x, c = r.y, u = r.upperWidth, d = r.lowerWidth, p = r.height, h = r.className, m = r.animationEasing, v = r.animationDuration, g = r.animationBegin, b = r.isUpdateAnimationActive;
  if (l !== +l || c !== +c || u !== +u || d !== +d || p !== +p || u === 0 && d === 0 || p === 0)
    return null;
  var C = De("recharts-trapezoid", h);
  return b ? /* @__PURE__ */ E.createElement(Br, {
    canBegin: o > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: p,
      x: l,
      y: c
    },
    to: {
      upperWidth: u,
      lowerWidth: d,
      height: p,
      x: l,
      y: c
    },
    duration: v,
    animationEasing: m,
    isActive: b
  }, function(w) {
    var x = w.upperWidth, y = w.lowerWidth, O = w.height, P = w.x, j = w.y;
    return /* @__PURE__ */ E.createElement(Br, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: g,
      duration: v,
      easing: m
    }, /* @__PURE__ */ E.createElement("path", Lc({}, he(r, !0), {
      className: C,
      d: uh(P, j, x, y, O),
      ref: n
    })));
  }) : /* @__PURE__ */ E.createElement("g", null, /* @__PURE__ */ E.createElement("path", Lc({}, he(r, !0), {
    className: C,
    d: uh(l, c, u, d, p)
  })));
}, Tce = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function h1(e) {
  "@babel/helpers - typeof";
  return h1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, h1(e);
}
function $ce(e, t) {
  if (e == null)
    return {};
  var r = Nce(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Nce(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function fh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function kc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fh(Object(r), !0).forEach(function(n) {
      Ice(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ice(e, t, r) {
  return t = Lce(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Lce(e) {
  var t = kce(e, "string");
  return h1(t) == "symbol" ? t : t + "";
}
function kce(e, t) {
  if (h1(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (h1(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Rce(e, t) {
  return kc(kc({}, t), e);
}
function Bce(e, t) {
  return e === "symbols";
}
function dh(e) {
  var t = e.shapeType, r = e.elementProps;
  switch (t) {
    case "rectangle":
      return /* @__PURE__ */ E.createElement(Y6, r);
    case "trapezoid":
      return /* @__PURE__ */ E.createElement(Mce, r);
    case "sector":
      return /* @__PURE__ */ E.createElement(kC, r);
    case "symbols":
      if (Bce(t))
        return /* @__PURE__ */ E.createElement(Tu, r);
      break;
    default:
      return null;
  }
}
function Vce(e) {
  return /* @__PURE__ */ Yr(e) ? e.props : e;
}
function Rc(e) {
  var t = e.option, r = e.shapeType, n = e.propTransformer, a = n === void 0 ? Rce : n, i = e.activeClassName, o = i === void 0 ? "recharts-active-shape" : i, s = e.isActive, l = $ce(e, Tce), c;
  if (/* @__PURE__ */ Yr(t))
    c = /* @__PURE__ */ Rt(t, kc(kc({}, l), Vce(t)));
  else if (we(t))
    c = t(l);
  else if (vce(t) && !xce(t)) {
    var u = a(t, l);
    c = /* @__PURE__ */ E.createElement(dh, {
      shapeType: r,
      elementProps: u
    });
  } else {
    var d = l;
    c = /* @__PURE__ */ E.createElement(dh, {
      shapeType: r,
      elementProps: d
    });
  }
  return s ? /* @__PURE__ */ E.createElement(Me, {
    className: o
  }, c) : c;
}
function Ku(e, t) {
  return t != null && "trapezoids" in e.props;
}
function Xu(e, t) {
  return t != null && "sectors" in e.props;
}
function v1(e, t) {
  return t != null && "points" in e.props;
}
function Hce(e, t) {
  var r, n, a = e.x === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.x) || e.x === t.x, i = e.y === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.y) || e.y === t.y;
  return a && i;
}
function Fce(e, t) {
  var r = e.endAngle === t.endAngle, n = e.startAngle === t.startAngle;
  return r && n;
}
function Wce(e, t) {
  var r = e.x === t.x, n = e.y === t.y, a = e.z === t.z;
  return r && n && a;
}
function zce(e, t) {
  var r;
  return Ku(e, t) ? r = Hce : Xu(e, t) ? r = Fce : v1(e, t) && (r = Wce), r;
}
function Uce(e, t) {
  var r;
  return Ku(e, t) ? r = "trapezoids" : Xu(e, t) ? r = "sectors" : v1(e, t) && (r = "points"), r;
}
function Zce(e, t) {
  if (Ku(e, t)) {
    var r;
    return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  if (Xu(e, t)) {
    var n;
    return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  return v1(e, t) ? t.payload : {};
}
function qce(e) {
  var t = e.activeTooltipItem, r = e.graphicalItem, n = e.itemData, a = Uce(r, t), i = Zce(r, t), o = n.filter(function(l, c) {
    var u = la(i, l), d = r.props[a].filter(function(m) {
      var v = zce(r, t);
      return v(m, t);
    }), p = r.props[a].indexOf(d[d.length - 1]), h = c === p;
    return u && h;
  }), s = n.indexOf(o[o.length - 1]);
  return s;
}
var Sl;
function ao(e) {
  "@babel/helpers - typeof";
  return ao = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ao(e);
}
function Ai() {
  return Ai = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ai.apply(this, arguments);
}
function ph(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ut(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ph(Object(r), !0).forEach(function(n) {
      $r(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ph(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Gce(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function hh(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, QC(n.key), n);
  }
}
function Yce(e, t, r) {
  return t && hh(e.prototype, t), r && hh(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Kce(e, t, r) {
  return t = Bc(t), Xce(e, XC() ? Reflect.construct(t, r || [], Bc(e).constructor) : t.apply(e, r));
}
function Xce(e, t) {
  if (t && (ao(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Qce(e);
}
function Qce(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function XC() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (XC = function() {
    return !!e;
  })();
}
function Bc(e) {
  return Bc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Bc(e);
}
function Jce(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Sf(e, t);
}
function Sf(e, t) {
  return Sf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Sf(e, t);
}
function $r(e, t, r) {
  return t = QC(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function QC(e) {
  var t = eue(e, "string");
  return ao(t) == "symbol" ? t : t + "";
}
function eue(e, t) {
  if (ao(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ao(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var On = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    return Gce(this, t), n = Kce(this, t, [r]), $r(n, "pieRef", null), $r(n, "sectorRefs", []), $r(n, "id", ga("recharts-pie-")), $r(n, "handleAnimationEnd", function() {
      var a = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), we(a) && a();
    }), $r(n, "handleAnimationStart", function() {
      var a = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), we(a) && a();
    }), n.state = {
      isAnimationFinished: !r.isAnimationActive,
      prevIsAnimationActive: r.isAnimationActive,
      prevAnimationId: r.animationId,
      sectorToFocus: 0
    }, n;
  }
  return Jce(t, e), Yce(t, [{
    key: "isActiveIndex",
    value: function(n) {
      var a = this.props.activeIndex;
      return Array.isArray(a) ? a.indexOf(n) !== -1 : n === a;
    }
  }, {
    key: "hasActiveIndex",
    value: function() {
      var n = this.props.activeIndex;
      return Array.isArray(n) ? n.length !== 0 : n || n === 0;
    }
  }, {
    key: "renderLabels",
    value: function(n) {
      var a = this.props.isAnimationActive;
      if (a && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.label, s = i.labelLine, l = i.dataKey, c = i.valueKey, u = he(this.props, !1), d = he(o, !1), p = he(s, !1), h = o && o.offsetRadius || 20, m = n.map(function(v, g) {
        var b = (v.startAngle + v.endAngle) / 2, C = dt(v.cx, v.cy, v.outerRadius + h, b), w = ut(ut(ut(ut({}, u), v), {}, {
          stroke: "none"
        }, d), {}, {
          index: g,
          textAnchor: t.getTextAnchor(C.x, v.cx)
        }, C), x = ut(ut(ut(ut({}, u), v), {}, {
          fill: "none",
          stroke: v.fill
        }, p), {}, {
          index: g,
          points: [dt(v.cx, v.cy, v.outerRadius, b), C]
        }), y = l;
        return xe(l) && xe(c) ? y = "value" : xe(l) && (y = c), // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ E.createElement(Me, {
          key: "label-".concat(v.startAngle, "-").concat(v.endAngle, "-").concat(v.midAngle, "-").concat(g)
        }, s && t.renderLabelLineItem(s, x, "line"), t.renderLabelItem(o, w, mt(v, y)));
      });
      return /* @__PURE__ */ E.createElement(Me, {
        className: "recharts-pie-labels"
      }, m);
    }
  }, {
    key: "renderSectorsStatically",
    value: function(n) {
      var a = this, i = this.props, o = i.activeShape, s = i.blendStroke, l = i.inactiveShape;
      return n.map(function(c, u) {
        if ((c == null ? void 0 : c.startAngle) === 0 && (c == null ? void 0 : c.endAngle) === 0 && n.length !== 1)
          return null;
        var d = a.isActiveIndex(u), p = l && a.hasActiveIndex() ? l : null, h = d ? o : p, m = ut(ut({}, c), {}, {
          stroke: s ? c.fill : c.stroke,
          tabIndex: -1
        });
        return /* @__PURE__ */ E.createElement(Me, Ai({
          ref: function(g) {
            g && !a.sectorRefs.includes(g) && a.sectorRefs.push(g);
          },
          tabIndex: -1,
          className: "recharts-pie-sector"
        }, sa(a.props, c, u), {
          // eslint-disable-next-line react/no-array-index-key
          key: "sector-".concat(c == null ? void 0 : c.startAngle, "-").concat(c == null ? void 0 : c.endAngle, "-").concat(c.midAngle, "-").concat(u)
        }), /* @__PURE__ */ E.createElement(Rc, Ai({
          option: h,
          isActive: d,
          shapeType: "sector"
        }, m)));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function() {
      var n = this, a = this.props, i = a.sectors, o = a.isAnimationActive, s = a.animationBegin, l = a.animationDuration, c = a.animationEasing, u = a.animationId, d = this.state, p = d.prevSectors, h = d.prevIsAnimationActive;
      return /* @__PURE__ */ E.createElement(Br, {
        begin: s,
        duration: l,
        isActive: o,
        easing: c,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(u, "-").concat(h),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function(m) {
        var v = m.t, g = [], b = i && i[0], C = b.startAngle;
        return i.forEach(function(w, x) {
          var y = p && p[x], O = x > 0 ? Sr(w, "paddingAngle", 0) : 0;
          if (y) {
            var P = xt(y.endAngle - y.startAngle, w.endAngle - w.startAngle), j = ut(ut({}, w), {}, {
              startAngle: C + O,
              endAngle: C + P(v) + O
            });
            g.push(j), C = j.endAngle;
          } else {
            var T = w.endAngle, I = w.startAngle, R = xt(0, T - I), F = R(v), $ = ut(ut({}, w), {}, {
              startAngle: C + O,
              endAngle: C + F + O
            });
            g.push($), C = $.endAngle;
          }
        }), /* @__PURE__ */ E.createElement(Me, null, n.renderSectorsStatically(g));
      });
    }
  }, {
    key: "attachKeyboardHandlers",
    value: function(n) {
      var a = this;
      n.onkeydown = function(i) {
        if (!i.altKey)
          switch (i.key) {
            case "ArrowLeft": {
              var o = ++a.state.sectorToFocus % a.sectorRefs.length;
              a.sectorRefs[o].focus(), a.setState({
                sectorToFocus: o
              });
              break;
            }
            case "ArrowRight": {
              var s = --a.state.sectorToFocus < 0 ? a.sectorRefs.length - 1 : a.state.sectorToFocus % a.sectorRefs.length;
              a.sectorRefs[s].focus(), a.setState({
                sectorToFocus: s
              });
              break;
            }
            case "Escape": {
              a.sectorRefs[a.state.sectorToFocus].blur(), a.setState({
                sectorToFocus: 0
              });
              break;
            }
          }
      };
    }
  }, {
    key: "renderSectors",
    value: function() {
      var n = this.props, a = n.sectors, i = n.isAnimationActive, o = this.state.prevSectors;
      return i && a && a.length && (!o || !la(o, a)) ? this.renderSectorsWithAnimation() : this.renderSectorsStatically(a);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.pieRef && this.attachKeyboardHandlers(this.pieRef);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.hide, o = a.sectors, s = a.className, l = a.label, c = a.cx, u = a.cy, d = a.innerRadius, p = a.outerRadius, h = a.isAnimationActive, m = this.state.isAnimationFinished;
      if (i || !o || !o.length || !oe(c) || !oe(u) || !oe(d) || !oe(p))
        return null;
      var v = De("recharts-pie", s);
      return /* @__PURE__ */ E.createElement(Me, {
        tabIndex: this.props.rootTabIndex,
        className: v,
        ref: function(b) {
          n.pieRef = b;
        }
      }, this.renderSectors(), l && this.renderLabels(o), Bt.renderCallByParent(this.props, null, !1), (!h || m) && Xr.renderCallByParent(this.props, o, !1));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return a.prevIsAnimationActive !== n.isAnimationActive ? {
        prevIsAnimationActive: n.isAnimationActive,
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: [],
        isAnimationFinished: !0
      } : n.isAnimationActive && n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: a.curSectors,
        isAnimationFinished: !0
      } : n.sectors !== a.curSectors ? {
        curSectors: n.sectors,
        isAnimationFinished: !0
      } : null;
    }
  }, {
    key: "getTextAnchor",
    value: function(n, a) {
      return n > a ? "start" : n < a ? "end" : "middle";
    }
  }, {
    key: "renderLabelLineItem",
    value: function(n, a, i) {
      if (/* @__PURE__ */ E.isValidElement(n))
        return /* @__PURE__ */ E.cloneElement(n, a);
      if (we(n))
        return n(a);
      var o = De("recharts-pie-label-line", typeof n != "boolean" ? n.className : "");
      return /* @__PURE__ */ E.createElement(aa, Ai({}, a, {
        key: i,
        type: "linear",
        className: o
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function(n, a, i) {
      if (/* @__PURE__ */ E.isValidElement(n))
        return /* @__PURE__ */ E.cloneElement(n, a);
      var o = i;
      if (we(n) && (o = n(a), /* @__PURE__ */ E.isValidElement(o)))
        return o;
      var s = De("recharts-pie-label-text", typeof n != "boolean" && !we(n) ? n.className : "");
      return /* @__PURE__ */ E.createElement(Qa, Ai({}, a, {
        alignmentBaseline: "middle",
        className: s
      }), o);
    }
  }]);
}(Pr);
Sl = On;
$r(On, "displayName", "Pie");
$r(On, "defaultProps", {
  stroke: "#fff",
  fill: "#808080",
  legendType: "rect",
  cx: "50%",
  cy: "50%",
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: "80%",
  paddingAngle: 0,
  labelLine: !0,
  hide: !1,
  minAngle: 0,
  isAnimationActive: !kr.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: "ease",
  nameKey: "name",
  blendStroke: !1,
  rootTabIndex: 0
});
$r(On, "parseDeltaAngle", function(e, t) {
  var r = ar(t - e), n = Math.min(Math.abs(t - e), 360);
  return r * n;
});
$r(On, "getRealPieData", function(e) {
  var t = e.data, r = e.children, n = he(e, !1), a = lr(r, en);
  return t && t.length ? t.map(function(i, o) {
    return ut(ut(ut({
      payload: i
    }, n), i), a && a[o] && a[o].props);
  }) : a && a.length ? a.map(function(i) {
    return ut(ut({}, n), i.props);
  }) : [];
});
$r(On, "parseCoordinateOfPie", function(e, t) {
  var r = t.top, n = t.left, a = t.width, i = t.height, o = $C(a, i), s = n + ir(e.cx, a, a / 2), l = r + ir(e.cy, i, i / 2), c = ir(e.innerRadius, o, 0), u = ir(e.outerRadius, o, o * 0.8), d = e.maxRadius || Math.sqrt(a * a + i * i) / 2;
  return {
    cx: s,
    cy: l,
    innerRadius: c,
    outerRadius: u,
    maxRadius: d
  };
});
$r(On, "getComposedData", function(e) {
  var t = e.item, r = e.offset, n = t.type.defaultProps !== void 0 ? ut(ut({}, t.type.defaultProps), t.props) : t.props, a = Sl.getRealPieData(n);
  if (!a || !a.length)
    return null;
  var i = n.cornerRadius, o = n.startAngle, s = n.endAngle, l = n.paddingAngle, c = n.dataKey, u = n.nameKey, d = n.valueKey, p = n.tooltipType, h = Math.abs(n.minAngle), m = Sl.parseCoordinateOfPie(n, r), v = Sl.parseDeltaAngle(o, s), g = Math.abs(v), b = c;
  xe(c) && xe(d) ? (Kr(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), b = "value") : xe(c) && (Kr(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), b = d);
  var C = a.filter(function(j) {
    return mt(j, b, 0) !== 0;
  }).length, w = (g >= 360 ? C : C - 1) * l, x = g - C * h - w, y = a.reduce(function(j, T) {
    var I = mt(T, b, 0);
    return j + (oe(I) ? I : 0);
  }, 0), O;
  if (y > 0) {
    var P;
    O = a.map(function(j, T) {
      var I = mt(j, b, 0), R = mt(j, u, T), F = (oe(I) ? I : 0) / y, $;
      T ? $ = P.endAngle + ar(v) * l * (I !== 0 ? 1 : 0) : $ = o;
      var Z = $ + ar(v) * ((I !== 0 ? h : 0) + F * x), X = ($ + Z) / 2, K = (m.innerRadius + m.outerRadius) / 2, J = [{
        name: R,
        value: I,
        payload: j,
        dataKey: b,
        type: p
      }], ee = dt(m.cx, m.cy, K, X);
      return P = ut(ut(ut({
        percent: F,
        cornerRadius: i,
        name: R,
        tooltipPayload: J,
        midAngle: X,
        middleRadius: K,
        tooltipPosition: ee
      }, j), m), {}, {
        value: mt(j, b),
        startAngle: $,
        endAngle: Z,
        payload: j,
        paddingAngle: ar(v) * l
      }), P;
    });
  }
  return ut(ut({}, m), {}, {
    sectors: O,
    data: a
  });
});
var tue = Math.ceil, rue = Math.max;
function nue(e, t, r, n) {
  for (var a = -1, i = rue(tue((t - e) / (r || 1)), 0), o = Array(i); i--; )
    o[n ? i : ++a] = e, e += r;
  return o;
}
var aue = nue, iue = Cb, vh = 1 / 0, oue = 17976931348623157e292;
function sue(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = iue(e), e === vh || e === -vh) {
    var t = e < 0 ? -1 : 1;
    return t * oue;
  }
  return e === e ? e : 0;
}
var JC = sue, lue = aue, cue = Iu, E3 = JC;
function uue(e) {
  return function(t, r, n) {
    return n && typeof n != "number" && cue(t, r, n) && (r = n = void 0), t = E3(t), r === void 0 ? (r = t, t = 0) : r = E3(r), n = n === void 0 ? t < r ? 1 : -1 : E3(n), lue(t, r, n, e);
  };
}
var fue = uue, due = fue, pue = due(), hue = pue;
const Vc = /* @__PURE__ */ Ze(hue);
function m1(e) {
  "@babel/helpers - typeof";
  return m1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, m1(e);
}
function mh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function gh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? mh(Object(r), !0).forEach(function(n) {
      ex(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : mh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ex(e, t, r) {
  return t = vue(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function vue(e) {
  var t = mue(e, "string");
  return m1(t) == "symbol" ? t : t + "";
}
function mue(e, t) {
  if (m1(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (m1(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var gue = ["Webkit", "Moz", "O", "ms"], yue = function(t, r) {
  if (!t)
    return null;
  var n = t.replace(/(\w)/, function(i) {
    return i.toUpperCase();
  }), a = gue.reduce(function(i, o) {
    return gh(gh({}, i), {}, ex({}, o + n, r));
  }, {});
  return a[t] = r, a;
};
function io(e) {
  "@babel/helpers - typeof";
  return io = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, io(e);
}
function Hc() {
  return Hc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Hc.apply(this, arguments);
}
function yh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function j3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yh(Object(r), !0).forEach(function(n) {
      yr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : yh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function bue(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function bh(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, rx(n.key), n);
  }
}
function Cue(e, t, r) {
  return t && bh(e.prototype, t), r && bh(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function xue(e, t, r) {
  return t = Fc(t), wue(e, tx() ? Reflect.construct(t, r || [], Fc(e).constructor) : t.apply(e, r));
}
function wue(e, t) {
  if (t && (io(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Oue(e);
}
function Oue(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function tx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (tx = function() {
    return !!e;
  })();
}
function Fc(e) {
  return Fc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Fc(e);
}
function Sue(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Pf(e, t);
}
function Pf(e, t) {
  return Pf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Pf(e, t);
}
function yr(e, t, r) {
  return t = rx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function rx(e) {
  var t = Pue(e, "string");
  return io(t) == "symbol" ? t : t + "";
}
function Pue(e, t) {
  if (io(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (io(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Eue = function(t) {
  var r = t.data, n = t.startIndex, a = t.endIndex, i = t.x, o = t.width, s = t.travellerWidth;
  if (!r || !r.length)
    return {};
  var l = r.length, c = Ss().domain(Vc(0, l)).range([i, i + o - s]), u = c.domain().map(function(d) {
    return c(d);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: c(n),
    endX: c(a),
    scale: c,
    scaleValues: u
  };
}, Ch = function(t) {
  return t.changedTouches && !!t.changedTouches.length;
}, oo = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    return bue(this, t), n = xue(this, t, [r]), yr(n, "handleDrag", function(a) {
      n.leaveTimer && (clearTimeout(n.leaveTimer), n.leaveTimer = null), n.state.isTravellerMoving ? n.handleTravellerMove(a) : n.state.isSlideMoving && n.handleSlideDrag(a);
    }), yr(n, "handleTouchMove", function(a) {
      a.changedTouches != null && a.changedTouches.length > 0 && n.handleDrag(a.changedTouches[0]);
    }), yr(n, "handleDragEnd", function() {
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var a = n.props, i = a.endIndex, o = a.onDragEnd, s = a.startIndex;
        o == null || o({
          endIndex: i,
          startIndex: s
        });
      }), n.detachDragEndListener();
    }), yr(n, "handleLeaveWrapper", function() {
      (n.state.isTravellerMoving || n.state.isSlideMoving) && (n.leaveTimer = window.setTimeout(n.handleDragEnd, n.props.leaveTimeOut));
    }), yr(n, "handleEnterSlideOrTraveller", function() {
      n.setState({
        isTextActive: !0
      });
    }), yr(n, "handleLeaveSlideOrTraveller", function() {
      n.setState({
        isTextActive: !1
      });
    }), yr(n, "handleSlideDragStart", function(a) {
      var i = Ch(a) ? a.changedTouches[0] : a;
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: i.pageX
      }), n.attachDragEndListener();
    }), n.travellerDragStartHandlers = {
      startX: n.handleTravellerDragStart.bind(n, "startX"),
      endX: n.handleTravellerDragStart.bind(n, "endX")
    }, n.state = {}, n;
  }
  return Sue(t, e), Cue(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(n) {
      var a = n.startX, i = n.endX, o = this.state.scaleValues, s = this.props, l = s.gap, c = s.data, u = c.length - 1, d = Math.min(a, i), p = Math.max(a, i), h = t.getIndexInRange(o, d), m = t.getIndexInRange(o, p);
      return {
        startIndex: h - h % l,
        endIndex: m === u ? u : m - m % l
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(n) {
      var a = this.props, i = a.data, o = a.tickFormatter, s = a.dataKey, l = mt(i[n], s, n);
      return we(o) ? o(l, n) : l;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(n) {
      var a = this.state, i = a.slideMoveStartX, o = a.startX, s = a.endX, l = this.props, c = l.x, u = l.width, d = l.travellerWidth, p = l.startIndex, h = l.endIndex, m = l.onChange, v = n.pageX - i;
      v > 0 ? v = Math.min(v, c + u - d - s, c + u - d - o) : v < 0 && (v = Math.max(v, c - o, c - s));
      var g = this.getIndex({
        startX: o + v,
        endX: s + v
      });
      (g.startIndex !== p || g.endIndex !== h) && m && m(g), this.setState({
        startX: o + v,
        endX: s + v,
        slideMoveStartX: n.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(n, a) {
      var i = Ch(a) ? a.changedTouches[0] : a;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: n,
        brushMoveStartX: i.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(n) {
      var a = this.state, i = a.brushMoveStartX, o = a.movingTravellerId, s = a.endX, l = a.startX, c = this.state[o], u = this.props, d = u.x, p = u.width, h = u.travellerWidth, m = u.onChange, v = u.gap, g = u.data, b = {
        startX: this.state.startX,
        endX: this.state.endX
      }, C = n.pageX - i;
      C > 0 ? C = Math.min(C, d + p - h - c) : C < 0 && (C = Math.max(C, d - c)), b[o] = c + C;
      var w = this.getIndex(b), x = w.startIndex, y = w.endIndex, O = function() {
        var j = g.length - 1;
        return o === "startX" && (s > l ? x % v === 0 : y % v === 0) || s < l && y === j || o === "endX" && (s > l ? y % v === 0 : x % v === 0) || s > l && y === j;
      };
      this.setState(yr(yr({}, o, c + C), "brushMoveStartX", n.pageX), function() {
        m && O() && m(w);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(n, a) {
      var i = this, o = this.state, s = o.scaleValues, l = o.startX, c = o.endX, u = this.state[a], d = s.indexOf(u);
      if (d !== -1) {
        var p = d + n;
        if (!(p === -1 || p >= s.length)) {
          var h = s[p];
          a === "startX" && h >= c || a === "endX" && h <= l || this.setState(yr({}, a, h), function() {
            i.props.onChange(i.getIndex({
              startX: i.state.startX,
              endX: i.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, s = n.height, l = n.fill, c = n.stroke;
      return /* @__PURE__ */ E.createElement("rect", {
        stroke: c,
        fill: l,
        x: a,
        y: i,
        width: o,
        height: s
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, s = n.height, l = n.data, c = n.children, u = n.padding, d = Ua.only(c);
      return d ? /* @__PURE__ */ E.cloneElement(d, {
        x: a,
        y: i,
        width: o,
        height: s,
        margin: u,
        compact: !0,
        data: l
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(n, a) {
      var i, o, s = this, l = this.props, c = l.y, u = l.travellerWidth, d = l.height, p = l.traveller, h = l.ariaLabel, m = l.data, v = l.startIndex, g = l.endIndex, b = Math.max(n, this.props.x), C = j3(j3({}, he(this.props, !1)), {}, {
        x: b,
        y: c,
        width: u,
        height: d
      }), w = h || "Min value: ".concat((i = m[v]) === null || i === void 0 ? void 0 : i.name, ", Max value: ").concat((o = m[g]) === null || o === void 0 ? void 0 : o.name);
      return /* @__PURE__ */ E.createElement(Me, {
        tabIndex: 0,
        role: "slider",
        "aria-label": w,
        "aria-valuenow": n,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[a],
        onTouchStart: this.travellerDragStartHandlers[a],
        onKeyDown: function(y) {
          ["ArrowLeft", "ArrowRight"].includes(y.key) && (y.preventDefault(), y.stopPropagation(), s.handleTravellerMoveKeyboard(y.key === "ArrowRight" ? 1 : -1, a));
        },
        onFocus: function() {
          s.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          s.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, t.renderTraveller(p, C));
    }
  }, {
    key: "renderSlide",
    value: function(n, a) {
      var i = this.props, o = i.y, s = i.height, l = i.stroke, c = i.travellerWidth, u = Math.min(n, a) + c, d = Math.max(Math.abs(a - n) - c, 0);
      return /* @__PURE__ */ E.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: l,
        fillOpacity: 0.2,
        x: u,
        y: o,
        width: d,
        height: s
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var n = this.props, a = n.startIndex, i = n.endIndex, o = n.y, s = n.height, l = n.travellerWidth, c = n.stroke, u = this.state, d = u.startX, p = u.endX, h = 5, m = {
        pointerEvents: "none",
        fill: c
      };
      return /* @__PURE__ */ E.createElement(Me, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ E.createElement(Qa, Hc({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(d, p) - h,
        y: o + s / 2
      }, m), this.getTextOfTick(a)), /* @__PURE__ */ E.createElement(Qa, Hc({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(d, p) + l + h,
        y: o + s / 2
      }, m), this.getTextOfTick(i)));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.data, i = n.className, o = n.children, s = n.x, l = n.y, c = n.width, u = n.height, d = n.alwaysShowText, p = this.state, h = p.startX, m = p.endX, v = p.isTextActive, g = p.isSlideMoving, b = p.isTravellerMoving, C = p.isTravellerFocused;
      if (!a || !a.length || !oe(s) || !oe(l) || !oe(c) || !oe(u) || c <= 0 || u <= 0)
        return null;
      var w = De("recharts-brush", i), x = E.Children.count(o) === 1, y = yue("userSelect", "none");
      return /* @__PURE__ */ E.createElement(Me, {
        className: w,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: y
      }, this.renderBackground(), x && this.renderPanorama(), this.renderSlide(h, m), this.renderTravellerLayer(h, "startX"), this.renderTravellerLayer(m, "endX"), (v || g || b || C || d) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(n) {
      var a = n.x, i = n.y, o = n.width, s = n.height, l = n.stroke, c = Math.floor(i + s / 2) - 1;
      return /* @__PURE__ */ E.createElement(E.Fragment, null, /* @__PURE__ */ E.createElement("rect", {
        x: a,
        y: i,
        width: o,
        height: s,
        fill: l,
        stroke: "none"
      }), /* @__PURE__ */ E.createElement("line", {
        x1: a + 1,
        y1: c,
        x2: a + o - 1,
        y2: c,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ E.createElement("line", {
        x1: a + 1,
        y1: c + 2,
        x2: a + o - 1,
        y2: c + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(n, a) {
      var i;
      return /* @__PURE__ */ E.isValidElement(n) ? i = /* @__PURE__ */ E.cloneElement(n, a) : we(n) ? i = n(a) : i = t.renderDefaultTraveller(a), i;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      var i = n.data, o = n.width, s = n.x, l = n.travellerWidth, c = n.updateId, u = n.startIndex, d = n.endIndex;
      if (i !== a.prevData || c !== a.prevUpdateId)
        return j3({
          prevData: i,
          prevTravellerWidth: l,
          prevUpdateId: c,
          prevX: s,
          prevWidth: o
        }, i && i.length ? Eue({
          data: i,
          width: o,
          x: s,
          travellerWidth: l,
          startIndex: u,
          endIndex: d
        }) : {
          scale: null,
          scaleValues: null
        });
      if (a.scale && (o !== a.prevWidth || s !== a.prevX || l !== a.prevTravellerWidth)) {
        a.scale.range([s, s + o - l]);
        var p = a.scale.domain().map(function(h) {
          return a.scale(h);
        });
        return {
          prevData: i,
          prevTravellerWidth: l,
          prevUpdateId: c,
          prevX: s,
          prevWidth: o,
          startX: a.scale(n.startIndex),
          endX: a.scale(n.endIndex),
          scaleValues: p
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(n, a) {
      for (var i = n.length, o = 0, s = i - 1; s - o > 1; ) {
        var l = Math.floor((o + s) / 2);
        n[l] > a ? s = l : o = l;
      }
      return a >= n[s] ? s : o;
    }
  }]);
}(Pr);
yr(oo, "displayName", "Brush");
yr(oo, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var jue = x6;
function _ue(e, t) {
  var r;
  return jue(e, function(n, a, i) {
    return r = t(n, a, i), !r;
  }), !!r;
}
var Aue = _ue, Due = qy, Mue = wn, Tue = Aue, $ue = vr, Nue = Iu;
function Iue(e, t, r) {
  var n = $ue(e) ? Due : Tue;
  return r && Nue(e, t, r) && (t = void 0), n(e, Mue(t));
}
var Lue = Iue;
const kue = /* @__PURE__ */ Ze(Lue);
var vn = function(t, r) {
  var n = t.alwaysShow, a = t.ifOverflow;
  return n && (a = "extendDomain"), a === r;
}, xh = vb;
function Rue(e, t, r) {
  t == "__proto__" && xh ? xh(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var Bue = Rue, Vue = Bue, Hue = pb, Fue = wn;
function Wue(e, t) {
  var r = {};
  return t = Fue(t), Hue(e, function(n, a, i) {
    Vue(r, a, t(n, a, i));
  }), r;
}
var zue = Wue;
const Uue = /* @__PURE__ */ Ze(zue);
function Zue(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (!t(e[r], r, e))
      return !1;
  return !0;
}
var que = Zue, Gue = x6;
function Yue(e, t) {
  var r = !0;
  return Gue(e, function(n, a, i) {
    return r = !!t(n, a, i), r;
  }), r;
}
var Kue = Yue, Xue = que, Que = Kue, Jue = wn, e2e = vr, t2e = Iu;
function r2e(e, t, r) {
  var n = e2e(e) ? Xue : Que;
  return r && t2e(e, t, r) && (t = void 0), n(e, Jue(t));
}
var n2e = r2e;
const nx = /* @__PURE__ */ Ze(n2e);
var a2e = ["x", "y"];
function so(e) {
  "@babel/helpers - typeof";
  return so = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, so(e);
}
function Ef() {
  return Ef = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ef.apply(this, arguments);
}
function wh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function is(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wh(Object(r), !0).forEach(function(n) {
      i2e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : wh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function i2e(e, t, r) {
  return t = o2e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function o2e(e) {
  var t = s2e(e, "string");
  return so(t) == "symbol" ? t : t + "";
}
function s2e(e, t) {
  if (so(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (so(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function l2e(e, t) {
  if (e == null)
    return {};
  var r = c2e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function c2e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function u2e(e, t) {
  var r = e.x, n = e.y, a = l2e(e, a2e), i = "".concat(r), o = parseInt(i, 10), s = "".concat(n), l = parseInt(s, 10), c = "".concat(t.height || a.height), u = parseInt(c, 10), d = "".concat(t.width || a.width), p = parseInt(d, 10);
  return is(is(is(is(is({}, t), a), o ? {
    x: o
  } : {}), l ? {
    y: l
  } : {}), {}, {
    height: u,
    width: p,
    name: t.name,
    radius: t.radius
  });
}
function Oh(e) {
  return /* @__PURE__ */ E.createElement(Rc, Ef({
    shapeType: "rectangle",
    propTransformer: u2e,
    activeClassName: "recharts-active-bar"
  }, e));
}
var f2e = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(n, a) {
    if (typeof t == "number")
      return t;
    var i = typeof n == "number";
    return i ? t(n, a) : (i || (process.env.NODE_ENV !== "production" ? Qt(!1, "minPointSize callback function received a value with type of ".concat(so(n), ". Currently only numbers are supported.")) : Qt(!1)), r);
  };
}, d2e = ["value", "background"], ax;
function lo(e) {
  "@babel/helpers - typeof";
  return lo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, lo(e);
}
function p2e(e, t) {
  if (e == null)
    return {};
  var r = h2e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function h2e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function Wc() {
  return Wc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wc.apply(this, arguments);
}
function Sh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $t(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Sh(Object(r), !0).forEach(function(n) {
      Qn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Sh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function v2e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ph(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ox(n.key), n);
  }
}
function m2e(e, t, r) {
  return t && Ph(e.prototype, t), r && Ph(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function g2e(e, t, r) {
  return t = zc(t), y2e(e, ix() ? Reflect.construct(t, r || [], zc(e).constructor) : t.apply(e, r));
}
function y2e(e, t) {
  if (t && (lo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return b2e(e);
}
function b2e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ix() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ix = function() {
    return !!e;
  })();
}
function zc(e) {
  return zc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, zc(e);
}
function C2e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && jf(e, t);
}
function jf(e, t) {
  return jf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, jf(e, t);
}
function Qn(e, t, r) {
  return t = ox(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ox(e) {
  var t = x2e(e, "string");
  return lo(t) == "symbol" ? t : t + "";
}
function x2e(e, t) {
  if (lo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (lo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Vr = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    v2e(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = g2e(this, t, [].concat(a)), Qn(r, "state", {
      isAnimationFinished: !1
    }), Qn(r, "id", ga("recharts-bar-")), Qn(r, "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), o && o();
    }), Qn(r, "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), o && o();
    }), r;
  }
  return C2e(t, e), m2e(t, [{
    key: "renderRectanglesStatically",
    value: function(n) {
      var a = this, i = this.props, o = i.shape, s = i.dataKey, l = i.activeIndex, c = i.activeBar, u = he(this.props, !1);
      return n && n.map(function(d, p) {
        var h = p === l, m = h ? c : o, v = $t($t($t({}, u), d), {}, {
          isActive: h,
          option: m,
          index: p,
          dataKey: s,
          onAnimationStart: a.handleAnimationStart,
          onAnimationEnd: a.handleAnimationEnd
        });
        return /* @__PURE__ */ E.createElement(Me, Wc({
          className: "recharts-bar-rectangle"
        }, sa(a.props, d, p), {
          key: "rectangle-".concat(d == null ? void 0 : d.x, "-").concat(d == null ? void 0 : d.y, "-").concat(d == null ? void 0 : d.value)
        }), /* @__PURE__ */ E.createElement(Oh, v));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var n = this, a = this.props, i = a.data, o = a.layout, s = a.isAnimationActive, l = a.animationBegin, c = a.animationDuration, u = a.animationEasing, d = a.animationId, p = this.state.prevData;
      return /* @__PURE__ */ E.createElement(Br, {
        begin: l,
        duration: c,
        isActive: s,
        easing: u,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(d),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(h) {
        var m = h.t, v = i.map(function(g, b) {
          var C = p && p[b];
          if (C) {
            var w = xt(C.x, g.x), x = xt(C.y, g.y), y = xt(C.width, g.width), O = xt(C.height, g.height);
            return $t($t({}, g), {}, {
              x: w(m),
              y: x(m),
              width: y(m),
              height: O(m)
            });
          }
          if (o === "horizontal") {
            var P = xt(0, g.height), j = P(m);
            return $t($t({}, g), {}, {
              y: g.y + g.height - j,
              height: j
            });
          }
          var T = xt(0, g.width), I = T(m);
          return $t($t({}, g), {}, {
            width: I
          });
        });
        return /* @__PURE__ */ E.createElement(Me, null, n.renderRectanglesStatically(v));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var n = this.props, a = n.data, i = n.isAnimationActive, o = this.state.prevData;
      return i && a && a.length && (!o || !la(o, a)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(a);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this, a = this.props, i = a.data, o = a.dataKey, s = a.activeIndex, l = he(this.props.background, !1);
      return i.map(function(c, u) {
        c.value;
        var d = c.background, p = p2e(c, d2e);
        if (!d)
          return null;
        var h = $t($t($t($t($t({}, p), {}, {
          fill: "#eee"
        }, d), l), sa(n.props, c, u)), {}, {
          onAnimationStart: n.handleAnimationStart,
          onAnimationEnd: n.handleAnimationEnd,
          dataKey: o,
          index: u,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ E.createElement(Oh, Wc({
          key: "background-bar-".concat(u),
          option: n.props.background,
          isActive: u === s
        }, h));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(n, a) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.data, s = i.xAxis, l = i.yAxis, c = i.layout, u = i.children, d = lr(u, Bo);
      if (!d)
        return null;
      var p = c === "vertical" ? o[0].height / 2 : o[0].width / 2, h = function(g, b) {
        var C = Array.isArray(g.value) ? g.value[1] : g.value;
        return {
          x: g.x,
          y: g.y,
          value: C,
          errorVal: mt(g, b)
        };
      }, m = {
        clipPath: n ? "url(#clipPath-".concat(a, ")") : null
      };
      return /* @__PURE__ */ E.createElement(Me, m, d.map(function(v) {
        return /* @__PURE__ */ E.cloneElement(v, {
          key: "error-bar-".concat(a, "-").concat(v.props.dataKey),
          data: o,
          xAxis: s,
          yAxis: l,
          layout: c,
          offset: p,
          dataPointFormatter: h
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.hide, i = n.data, o = n.className, s = n.xAxis, l = n.yAxis, c = n.left, u = n.top, d = n.width, p = n.height, h = n.isAnimationActive, m = n.background, v = n.id;
      if (a || !i || !i.length)
        return null;
      var g = this.state.isAnimationFinished, b = De("recharts-bar", o), C = s && s.allowDataOverflow, w = l && l.allowDataOverflow, x = C || w, y = xe(v) ? this.id : v;
      return /* @__PURE__ */ E.createElement(Me, {
        className: b
      }, C || w ? /* @__PURE__ */ E.createElement("defs", null, /* @__PURE__ */ E.createElement("clipPath", {
        id: "clipPath-".concat(y)
      }, /* @__PURE__ */ E.createElement("rect", {
        x: C ? c : c - d / 2,
        y: w ? u : u - p / 2,
        width: C ? d : d * 2,
        height: w ? p : p * 2
      }))) : null, /* @__PURE__ */ E.createElement(Me, {
        className: "recharts-bar-rectangles",
        clipPath: x ? "url(#clipPath-".concat(y, ")") : null
      }, m ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(x, y), (!h || g) && Xr.renderCallByParent(this.props, i));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curData: n.data,
        prevData: a.curData
      } : n.data !== a.curData ? {
        curData: n.data
      } : null;
    }
  }]);
}(Pr);
ax = Vr;
Qn(Vr, "displayName", "Bar");
Qn(Vr, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !kr.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
Qn(Vr, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.barPosition, a = e.bandSize, i = e.xAxis, o = e.yAxis, s = e.xAxisTicks, l = e.yAxisTicks, c = e.stackedData, u = e.dataStartIndex, d = e.displayedData, p = e.offset, h = moe(n, r);
  if (!h)
    return null;
  var m = t.layout, v = r.type.defaultProps, g = v !== void 0 ? $t($t({}, v), r.props) : r.props, b = g.dataKey, C = g.children, w = g.minPointSize, x = m === "horizontal" ? o : i, y = c ? x.scale.domain() : null, O = Ooe({
    numericAxis: x
  }), P = lr(C, en), j = d.map(function(T, I) {
    var R, F, $, Z, X, K;
    c ? R = goe(c[u + I], y) : (R = mt(T, b), Array.isArray(R) || (R = [O, R]));
    var J = f2e(w, ax.defaultProps.minPointSize)(R[1], I);
    if (m === "horizontal") {
      var ee, A = [o.scale(R[0]), o.scale(R[1])], _ = A[0], N = A[1];
      F = p9({
        axis: i,
        ticks: s,
        bandSize: a,
        offset: h.offset,
        entry: T,
        index: I
      }), $ = (ee = N ?? _) !== null && ee !== void 0 ? ee : void 0, Z = h.size;
      var M = _ - N;
      if (X = Number.isNaN(M) ? 0 : M, K = {
        x: F,
        y: o.y,
        width: Z,
        height: o.height
      }, Math.abs(J) > 0 && Math.abs(X) < Math.abs(J)) {
        var S = ar(X || J) * (Math.abs(J) - Math.abs(X));
        $ -= S, X += S;
      }
    } else {
      var B = [i.scale(R[0]), i.scale(R[1])], G = B[0], U = B[1];
      if (F = G, $ = p9({
        axis: o,
        ticks: l,
        bandSize: a,
        offset: h.offset,
        entry: T,
        index: I
      }), Z = U - G, X = h.size, K = {
        x: i.x,
        y: $,
        width: i.width,
        height: X
      }, Math.abs(J) > 0 && Math.abs(Z) < Math.abs(J)) {
        var H = ar(Z || J) * (Math.abs(J) - Math.abs(Z));
        Z += H;
      }
    }
    return $t($t($t({}, T), {}, {
      x: F,
      y: $,
      width: Z,
      height: X,
      value: c ? R : R[1],
      payload: T,
      background: K
    }, P && P[I] && P[I].props), {}, {
      tooltipPayload: [MC(r, T)],
      tooltipPosition: {
        x: F + Z / 2,
        y: $ + X / 2
      }
    });
  });
  return $t({
    data: j,
    layout: m
  }, p);
});
function g1(e) {
  "@babel/helpers - typeof";
  return g1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, g1(e);
}
function w2e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Eh(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, sx(n.key), n);
  }
}
function O2e(e, t, r) {
  return t && Eh(e.prototype, t), r && Eh(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function jh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ur(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jh(Object(r), !0).forEach(function(n) {
      Qu(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : jh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Qu(e, t, r) {
  return t = sx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function sx(e) {
  var t = S2e(e, "string");
  return g1(t) == "symbol" ? t : t + "";
}
function S2e(e, t) {
  if (g1(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (g1(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var lx = function(t, r, n, a, i) {
  var o = t.width, s = t.height, l = t.layout, c = t.children, u = Object.keys(r), d = {
    left: n.left,
    leftMirror: n.left,
    right: o - n.right,
    rightMirror: o - n.right,
    top: n.top,
    topMirror: n.top,
    bottom: s - n.bottom,
    bottomMirror: s - n.bottom
  }, p = !!br(c, Vr);
  return u.reduce(function(h, m) {
    var v = r[m], g = v.orientation, b = v.domain, C = v.padding, w = C === void 0 ? {} : C, x = v.mirror, y = v.reversed, O = "".concat(g).concat(x ? "Mirror" : ""), P, j, T, I, R;
    if (v.type === "number" && (v.padding === "gap" || v.padding === "no-gap")) {
      var F = b[1] - b[0], $ = 1 / 0, Z = v.categoricalDomain.sort();
      if (Z.forEach(function(B, G) {
        G > 0 && ($ = Math.min((B || 0) - (Z[G - 1] || 0), $));
      }), Number.isFinite($)) {
        var X = $ / F, K = v.layout === "vertical" ? n.height : n.width;
        if (v.padding === "gap" && (P = X * K / 2), v.padding === "no-gap") {
          var J = ir(t.barCategoryGap, X * K), ee = X * K / 2;
          P = ee - J - (ee - J) / K * J;
        }
      }
    }
    a === "xAxis" ? j = [n.left + (w.left || 0) + (P || 0), n.left + n.width - (w.right || 0) - (P || 0)] : a === "yAxis" ? j = l === "horizontal" ? [n.top + n.height - (w.bottom || 0), n.top + (w.top || 0)] : [n.top + (w.top || 0) + (P || 0), n.top + n.height - (w.bottom || 0) - (P || 0)] : j = v.range, y && (j = [j[1], j[0]]);
    var A = jC(v, i, p), _ = A.scale, N = A.realScaleType;
    _.domain(b).range(j), _C(_);
    var M = AC(_, Ur(Ur({}, v), {}, {
      realScaleType: N
    }));
    a === "xAxis" ? (R = g === "top" && !x || g === "bottom" && x, T = n.left, I = d[O] - R * v.height) : a === "yAxis" && (R = g === "left" && !x || g === "right" && x, T = d[O] - R * v.width, I = n.top);
    var S = Ur(Ur(Ur({}, v), M), {}, {
      realScaleType: N,
      x: T,
      y: I,
      scale: _,
      width: a === "xAxis" ? n.width : v.width,
      height: a === "yAxis" ? n.height : v.height
    });
    return S.bandSize = Ec(S, M), !v.hide && a === "xAxis" ? d[O] += (R ? -1 : 1) * S.height : v.hide || (d[O] += (R ? -1 : 1) * S.width), Ur(Ur({}, h), {}, Qu({}, m, S));
  }, {});
}, cx = function(t, r) {
  var n = t.x, a = t.y, i = r.x, o = r.y;
  return {
    x: Math.min(n, i),
    y: Math.min(a, o),
    width: Math.abs(i - n),
    height: Math.abs(o - a)
  };
}, P2e = function(t) {
  var r = t.x1, n = t.y1, a = t.x2, i = t.y2;
  return cx({
    x: r,
    y: n
  }, {
    x: a,
    y: i
  });
}, ux = /* @__PURE__ */ function() {
  function e(t) {
    w2e(this, e), this.scale = t;
  }
  return O2e(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.bandAware, i = n.position;
      if (r !== void 0) {
        if (i)
          switch (i) {
            case "start":
              return this.scale(r);
            case "middle": {
              var o = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(r) + o;
            }
            case "end": {
              var s = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(r) + s;
            }
            default:
              return this.scale(r);
          }
        if (a) {
          var l = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(r) + l;
        }
        return this.scale(r);
      }
    }
  }, {
    key: "isInRange",
    value: function(r) {
      var n = this.range(), a = n[0], i = n[n.length - 1];
      return a <= i ? r >= a && r <= i : r >= i && r <= a;
    }
  }], [{
    key: "create",
    value: function(r) {
      return new e(r);
    }
  }]);
}();
Qu(ux, "EPS", 1e-4);
var K6 = function(t) {
  var r = Object.keys(t).reduce(function(n, a) {
    return Ur(Ur({}, n), {}, Qu({}, a, ux.create(t[a])));
  }, {});
  return Ur(Ur({}, r), {}, {
    apply: function(a) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = i.bandAware, s = i.position;
      return Uue(a, function(l, c) {
        return r[c].apply(l, {
          bandAware: o,
          position: s
        });
      });
    },
    isInRange: function(a) {
      return nx(a, function(i, o) {
        return r[o].isInRange(i);
      });
    }
  });
};
function E2e(e) {
  return (e % 180 + 180) % 180;
}
var j2e = function(t) {
  var r = t.width, n = t.height, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = E2e(a), o = i * Math.PI / 180, s = Math.atan(n / r), l = o > s && o < Math.PI - s ? n / Math.sin(o) : r / Math.cos(o);
  return Math.abs(l);
}, _2e = wn, A2e = k1, D2e = $u;
function M2e(e) {
  return function(t, r, n) {
    var a = Object(t);
    if (!A2e(t)) {
      var i = _2e(r);
      t = D2e(t), r = function(s) {
        return i(a[s], s, a);
      };
    }
    var o = e(t, r, n);
    return o > -1 ? a[i ? t[o] : o] : void 0;
  };
}
var T2e = M2e, $2e = JC;
function N2e(e) {
  var t = $2e(e), r = t % 1;
  return t === t ? r ? t - r : t : 0;
}
var I2e = N2e, L2e = sb, k2e = wn, R2e = I2e, B2e = Math.max;
function V2e(e, t, r) {
  var n = e == null ? 0 : e.length;
  if (!n)
    return -1;
  var a = r == null ? 0 : R2e(r);
  return a < 0 && (a = B2e(n + a, 0)), L2e(e, k2e(t), a);
}
var H2e = V2e, F2e = T2e, W2e = H2e, z2e = F2e(W2e), U2e = z2e;
const Z2e = /* @__PURE__ */ Ze(U2e);
var q2e = sz(function(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width,
    height: e.height
  };
}, function(e) {
  return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
});
function Uc(e) {
  "@babel/helpers - typeof";
  return Uc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Uc(e);
}
var X6 = /* @__PURE__ */ ua(void 0), Q6 = /* @__PURE__ */ ua(void 0), fx = /* @__PURE__ */ ua(void 0), dx = /* @__PURE__ */ ua({}), px = /* @__PURE__ */ ua(void 0), hx = /* @__PURE__ */ ua(0), vx = /* @__PURE__ */ ua(0), _h = function(t) {
  var r = t.state, n = r.xAxisMap, a = r.yAxisMap, i = r.offset, o = t.clipPathId, s = t.children, l = t.width, c = t.height, u = q2e(i);
  return /* @__PURE__ */ E.createElement(X6.Provider, {
    value: n
  }, /* @__PURE__ */ E.createElement(Q6.Provider, {
    value: a
  }, /* @__PURE__ */ E.createElement(dx.Provider, {
    value: i
  }, /* @__PURE__ */ E.createElement(fx.Provider, {
    value: u
  }, /* @__PURE__ */ E.createElement(px.Provider, {
    value: o
  }, /* @__PURE__ */ E.createElement(hx.Provider, {
    value: c
  }, /* @__PURE__ */ E.createElement(vx.Provider, {
    value: l
  }, s)))))));
}, G2e = function() {
  return Mt(px);
};
function mx(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
}
var gx = function(t) {
  var r = Mt(X6);
  r == null && (process.env.NODE_ENV !== "production" ? Qt(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : Qt(!1));
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? Qt(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(Uc(t), "]. ").concat(mx(r))) : Qt(!1)), n;
}, Y2e = function() {
  var t = Mt(X6);
  return Yn(t);
}, K2e = function() {
  var t = Mt(Q6), r = Z2e(t, function(n) {
    return nx(n.domain, Number.isFinite);
  });
  return r || Yn(t);
}, yx = function(t) {
  var r = Mt(Q6);
  r == null && (process.env.NODE_ENV !== "production" ? Qt(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : Qt(!1));
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? Qt(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(Uc(t), "]. ").concat(mx(r))) : Qt(!1)), n;
}, X2e = function() {
  var t = Mt(fx);
  return t;
}, Q2e = function() {
  return Mt(dx);
}, J6 = function() {
  return Mt(vx);
}, e5 = function() {
  return Mt(hx);
};
function co(e) {
  "@babel/helpers - typeof";
  return co = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, co(e);
}
function J2e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ah(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Cx(n.key), n);
  }
}
function e3e(e, t, r) {
  return t && Ah(e.prototype, t), r && Ah(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function t3e(e, t, r) {
  return t = Zc(t), r3e(e, bx() ? Reflect.construct(t, r || [], Zc(e).constructor) : t.apply(e, r));
}
function r3e(e, t) {
  if (t && (co(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return n3e(e);
}
function n3e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function bx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (bx = function() {
    return !!e;
  })();
}
function Zc(e) {
  return Zc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Zc(e);
}
function a3e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && _f(e, t);
}
function _f(e, t) {
  return _f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, _f(e, t);
}
function Dh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Mh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Dh(Object(r), !0).forEach(function(n) {
      t5(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Dh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function t5(e, t, r) {
  return t = Cx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Cx(e) {
  var t = i3e(e, "string");
  return co(t) == "symbol" ? t : t + "";
}
function i3e(e, t) {
  if (co(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (co(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function o3e(e, t) {
  return u3e(e) || c3e(e, t) || l3e(e, t) || s3e();
}
function s3e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function l3e(e, t) {
  if (e) {
    if (typeof e == "string")
      return Th(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Th(e, t);
  }
}
function Th(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function c3e(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function u3e(e) {
  if (Array.isArray(e))
    return e;
}
function Af() {
  return Af = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Af.apply(this, arguments);
}
var f3e = function(t, r) {
  var n;
  return /* @__PURE__ */ E.isValidElement(t) ? n = /* @__PURE__ */ E.cloneElement(t, r) : we(t) ? n = t(r) : n = /* @__PURE__ */ E.createElement("line", Af({}, r, {
    className: "recharts-reference-line-line"
  })), n;
}, d3e = function(t, r, n, a, i, o, s, l, c) {
  var u = i.x, d = i.y, p = i.width, h = i.height;
  if (n) {
    var m = c.y, v = t.y.apply(m, {
      position: o
    });
    if (vn(c, "discard") && !t.y.isInRange(v))
      return null;
    var g = [{
      x: u + p,
      y: v
    }, {
      x: u,
      y: v
    }];
    return l === "left" ? g.reverse() : g;
  }
  if (r) {
    var b = c.x, C = t.x.apply(b, {
      position: o
    });
    if (vn(c, "discard") && !t.x.isInRange(C))
      return null;
    var w = [{
      x: C,
      y: d + h
    }, {
      x: C,
      y: d
    }];
    return s === "top" ? w.reverse() : w;
  }
  if (a) {
    var x = c.segment, y = x.map(function(O) {
      return t.apply(O, {
        position: o
      });
    });
    return vn(c, "discard") && kue(y, function(O) {
      return !t.isInRange(O);
    }) ? null : y;
  }
  return null;
};
function p3e(e) {
  var t = e.x, r = e.y, n = e.segment, a = e.xAxisId, i = e.yAxisId, o = e.shape, s = e.className, l = e.alwaysShow, c = G2e(), u = gx(a), d = yx(i), p = X2e();
  if (!c || !p)
    return null;
  Kr(l === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var h = K6({
    x: u.scale,
    y: d.scale
  }), m = Vt(t), v = Vt(r), g = n && n.length === 2, b = d3e(h, m, v, g, p, e.position, u.orientation, d.orientation, e);
  if (!b)
    return null;
  var C = o3e(b, 2), w = C[0], x = w.x, y = w.y, O = C[1], P = O.x, j = O.y, T = vn(e, "hidden") ? "url(#".concat(c, ")") : void 0, I = Mh(Mh({
    clipPath: T
  }, he(e, !0)), {}, {
    x1: x,
    y1: y,
    x2: P,
    y2: j
  });
  return /* @__PURE__ */ E.createElement(Me, {
    className: De("recharts-reference-line", s)
  }, f3e(o, I), Bt.renderCallByParent(e, P2e({
    x1: x,
    y1: y,
    x2: P,
    y2: j
  })));
}
var r5 = /* @__PURE__ */ function(e) {
  function t() {
    return J2e(this, t), t3e(this, t, arguments);
  }
  return a3e(t, e), e3e(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ E.createElement(p3e, this.props);
    }
  }]);
}(E.Component);
t5(r5, "displayName", "ReferenceLine");
t5(r5, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function Df() {
  return Df = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Df.apply(this, arguments);
}
function uo(e) {
  "@babel/helpers - typeof";
  return uo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, uo(e);
}
function $h(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Nh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $h(Object(r), !0).forEach(function(n) {
      Ju(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : $h(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function h3e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ih(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, wx(n.key), n);
  }
}
function v3e(e, t, r) {
  return t && Ih(e.prototype, t), r && Ih(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function m3e(e, t, r) {
  return t = qc(t), g3e(e, xx() ? Reflect.construct(t, r || [], qc(e).constructor) : t.apply(e, r));
}
function g3e(e, t) {
  if (t && (uo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return y3e(e);
}
function y3e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function xx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (xx = function() {
    return !!e;
  })();
}
function qc(e) {
  return qc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, qc(e);
}
function b3e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Mf(e, t);
}
function Mf(e, t) {
  return Mf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Mf(e, t);
}
function Ju(e, t, r) {
  return t = wx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function wx(e) {
  var t = C3e(e, "string");
  return uo(t) == "symbol" ? t : t + "";
}
function C3e(e, t) {
  if (uo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (uo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var x3e = function(t) {
  var r = t.x, n = t.y, a = t.xAxis, i = t.yAxis, o = K6({
    x: a.scale,
    y: i.scale
  }), s = o.apply({
    x: r,
    y: n
  }, {
    bandAware: !0
  });
  return vn(t, "discard") && !o.isInRange(s) ? null : s;
}, e2 = /* @__PURE__ */ function(e) {
  function t() {
    return h3e(this, t), m3e(this, t, arguments);
  }
  return b3e(t, e), v3e(t, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.r, s = n.alwaysShow, l = n.clipPathId, c = Vt(a), u = Vt(i);
      if (Kr(s === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !c || !u)
        return null;
      var d = x3e(this.props);
      if (!d)
        return null;
      var p = d.x, h = d.y, m = this.props, v = m.shape, g = m.className, b = vn(this.props, "hidden") ? "url(#".concat(l, ")") : void 0, C = Nh(Nh({
        clipPath: b
      }, he(this.props, !0)), {}, {
        cx: p,
        cy: h
      });
      return /* @__PURE__ */ E.createElement(Me, {
        className: De("recharts-reference-dot", g)
      }, t.renderDot(v, C), Bt.renderCallByParent(this.props, {
        x: p - o,
        y: h - o,
        width: 2 * o,
        height: 2 * o
      }));
    }
  }]);
}(E.Component);
Ju(e2, "displayName", "ReferenceDot");
Ju(e2, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
Ju(e2, "renderDot", function(e, t) {
  var r;
  return /* @__PURE__ */ E.isValidElement(e) ? r = /* @__PURE__ */ E.cloneElement(e, t) : we(e) ? r = e(t) : r = /* @__PURE__ */ E.createElement(W1, Df({}, t, {
    cx: t.cx,
    cy: t.cy,
    className: "recharts-reference-dot-dot"
  })), r;
});
function Tf() {
  return Tf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Tf.apply(this, arguments);
}
function fo(e) {
  "@babel/helpers - typeof";
  return fo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fo(e);
}
function Lh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function kh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Lh(Object(r), !0).forEach(function(n) {
      t2(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Lh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function w3e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Rh(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Sx(n.key), n);
  }
}
function O3e(e, t, r) {
  return t && Rh(e.prototype, t), r && Rh(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function S3e(e, t, r) {
  return t = Gc(t), P3e(e, Ox() ? Reflect.construct(t, r || [], Gc(e).constructor) : t.apply(e, r));
}
function P3e(e, t) {
  if (t && (fo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return E3e(e);
}
function E3e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ox() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ox = function() {
    return !!e;
  })();
}
function Gc(e) {
  return Gc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Gc(e);
}
function j3e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && $f(e, t);
}
function $f(e, t) {
  return $f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, $f(e, t);
}
function t2(e, t, r) {
  return t = Sx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Sx(e) {
  var t = _3e(e, "string");
  return fo(t) == "symbol" ? t : t + "";
}
function _3e(e, t) {
  if (fo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (fo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var A3e = function(t, r, n, a, i) {
  var o = i.x1, s = i.x2, l = i.y1, c = i.y2, u = i.xAxis, d = i.yAxis;
  if (!u || !d)
    return null;
  var p = K6({
    x: u.scale,
    y: d.scale
  }), h = {
    x: t ? p.x.apply(o, {
      position: "start"
    }) : p.x.rangeMin,
    y: n ? p.y.apply(l, {
      position: "start"
    }) : p.y.rangeMin
  }, m = {
    x: r ? p.x.apply(s, {
      position: "end"
    }) : p.x.rangeMax,
    y: a ? p.y.apply(c, {
      position: "end"
    }) : p.y.rangeMax
  };
  return vn(i, "discard") && (!p.isInRange(h) || !p.isInRange(m)) ? null : cx(h, m);
}, r2 = /* @__PURE__ */ function(e) {
  function t() {
    return w3e(this, t), S3e(this, t, arguments);
  }
  return j3e(t, e), O3e(t, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.x1, i = n.x2, o = n.y1, s = n.y2, l = n.className, c = n.alwaysShow, u = n.clipPathId;
      Kr(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var d = Vt(a), p = Vt(i), h = Vt(o), m = Vt(s), v = this.props.shape;
      if (!d && !p && !h && !m && !v)
        return null;
      var g = A3e(d, p, h, m, this.props);
      if (!g && !v)
        return null;
      var b = vn(this.props, "hidden") ? "url(#".concat(u, ")") : void 0;
      return /* @__PURE__ */ E.createElement(Me, {
        className: De("recharts-reference-area", l)
      }, t.renderRect(v, kh(kh({
        clipPath: b
      }, he(this.props, !0)), g)), Bt.renderCallByParent(this.props, g));
    }
  }]);
}(E.Component);
t2(r2, "displayName", "ReferenceArea");
t2(r2, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
t2(r2, "renderRect", function(e, t) {
  var r;
  return /* @__PURE__ */ E.isValidElement(e) ? r = /* @__PURE__ */ E.cloneElement(e, t) : we(e) ? r = e(t) : r = /* @__PURE__ */ E.createElement(Y6, Tf({}, t, {
    className: "recharts-reference-area-rect"
  })), r;
});
function Px(e, t, r) {
  if (t < 1)
    return [];
  if (t === 1 && r === void 0)
    return e;
  for (var n = [], a = 0; a < e.length; a += t)
    if (r === void 0 || r(e[a]) === !0)
      n.push(e[a]);
    else
      return;
  return n;
}
function D3e(e, t, r) {
  var n = {
    width: e.width + t.width,
    height: e.height + t.height
  };
  return j2e(n, r);
}
function M3e(e, t, r) {
  var n = r === "width", a = e.x, i = e.y, o = e.width, s = e.height;
  return t === 1 ? {
    start: n ? a : i,
    end: n ? a + o : i + s
  } : {
    start: n ? a + o : i + s,
    end: n ? a : i
  };
}
function Yc(e, t, r, n, a) {
  if (e * t < e * n || e * t > e * a)
    return !1;
  var i = r();
  return e * (t - e * i / 2 - n) >= 0 && e * (t + e * i / 2 - a) <= 0;
}
function T3e(e, t) {
  return Px(e, t + 1);
}
function $3e(e, t, r, n, a) {
  for (var i = (n || []).slice(), o = t.start, s = t.end, l = 0, c = 1, u = o, d = function() {
    var m = n == null ? void 0 : n[l];
    if (m === void 0)
      return {
        v: Px(n, c)
      };
    var v = l, g, b = function() {
      return g === void 0 && (g = r(m, v)), g;
    }, C = m.coordinate, w = l === 0 || Yc(e, C, b, u, s);
    w || (l = 0, u = o, c += 1), w && (u = C + e * (b() / 2 + a), l += c);
  }, p; c <= i.length; )
    if (p = d(), p)
      return p.v;
  return [];
}
function y1(e) {
  "@babel/helpers - typeof";
  return y1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, y1(e);
}
function Bh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Kt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Bh(Object(r), !0).forEach(function(n) {
      N3e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Bh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function N3e(e, t, r) {
  return t = I3e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function I3e(e) {
  var t = L3e(e, "string");
  return y1(t) == "symbol" ? t : t + "";
}
function L3e(e, t) {
  if (y1(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (y1(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function k3e(e, t, r, n, a) {
  for (var i = (n || []).slice(), o = i.length, s = t.start, l = t.end, c = function(p) {
    var h = i[p], m, v = function() {
      return m === void 0 && (m = r(h, p)), m;
    };
    if (p === o - 1) {
      var g = e * (h.coordinate + e * v() / 2 - l);
      i[p] = h = Kt(Kt({}, h), {}, {
        tickCoord: g > 0 ? h.coordinate - g * e : h.coordinate
      });
    } else
      i[p] = h = Kt(Kt({}, h), {}, {
        tickCoord: h.coordinate
      });
    var b = Yc(e, h.tickCoord, v, s, l);
    b && (l = h.tickCoord - e * (v() / 2 + a), i[p] = Kt(Kt({}, h), {}, {
      isShow: !0
    }));
  }, u = o - 1; u >= 0; u--)
    c(u);
  return i;
}
function R3e(e, t, r, n, a, i) {
  var o = (n || []).slice(), s = o.length, l = t.start, c = t.end;
  if (i) {
    var u = n[s - 1], d = r(u, s - 1), p = e * (u.coordinate + e * d / 2 - c);
    o[s - 1] = u = Kt(Kt({}, u), {}, {
      tickCoord: p > 0 ? u.coordinate - p * e : u.coordinate
    });
    var h = Yc(e, u.tickCoord, function() {
      return d;
    }, l, c);
    h && (c = u.tickCoord - e * (d / 2 + a), o[s - 1] = Kt(Kt({}, u), {}, {
      isShow: !0
    }));
  }
  for (var m = i ? s - 1 : s, v = function(C) {
    var w = o[C], x, y = function() {
      return x === void 0 && (x = r(w, C)), x;
    };
    if (C === 0) {
      var O = e * (w.coordinate - e * y() / 2 - l);
      o[C] = w = Kt(Kt({}, w), {}, {
        tickCoord: O < 0 ? w.coordinate - O * e : w.coordinate
      });
    } else
      o[C] = w = Kt(Kt({}, w), {}, {
        tickCoord: w.coordinate
      });
    var P = Yc(e, w.tickCoord, y, l, c);
    P && (l = w.tickCoord + e * (y() / 2 + a), o[C] = Kt(Kt({}, w), {}, {
      isShow: !0
    }));
  }, g = 0; g < m; g++)
    v(g);
  return o;
}
function n5(e, t, r) {
  var n = e.tick, a = e.ticks, i = e.viewBox, o = e.minTickGap, s = e.orientation, l = e.interval, c = e.tickFormatter, u = e.unit, d = e.angle;
  if (!a || !a.length || !n)
    return [];
  if (oe(l) || kr.isSsr)
    return T3e(a, typeof l == "number" && oe(l) ? l : 0);
  var p = [], h = s === "top" || s === "bottom" ? "width" : "height", m = u && h === "width" ? Os(u, {
    fontSize: t,
    letterSpacing: r
  }) : {
    width: 0,
    height: 0
  }, v = function(w, x) {
    var y = we(c) ? c(w.value, x) : w.value;
    return h === "width" ? D3e(Os(y, {
      fontSize: t,
      letterSpacing: r
    }), m, d) : Os(y, {
      fontSize: t,
      letterSpacing: r
    })[h];
  }, g = a.length >= 2 ? ar(a[1].coordinate - a[0].coordinate) : 1, b = M3e(i, g, h);
  return l === "equidistantPreserveStart" ? $3e(g, b, v, a, o) : (l === "preserveStart" || l === "preserveStartEnd" ? p = R3e(g, b, v, a, o, l === "preserveStartEnd") : p = k3e(g, b, v, a, o), p.filter(function(C) {
    return C.isShow;
  }));
}
var B3e = ["viewBox"], V3e = ["viewBox"], H3e = ["ticks"];
function po(e) {
  "@babel/helpers - typeof";
  return po = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, po(e);
}
function Di() {
  return Di = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Di.apply(this, arguments);
}
function Vh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function rr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Vh(Object(r), !0).forEach(function(n) {
      a5(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Vh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function _3(e, t) {
  if (e == null)
    return {};
  var r = F3e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function F3e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function W3e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Hh(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, jx(n.key), n);
  }
}
function z3e(e, t, r) {
  return t && Hh(e.prototype, t), r && Hh(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function U3e(e, t, r) {
  return t = Kc(t), Z3e(e, Ex() ? Reflect.construct(t, r || [], Kc(e).constructor) : t.apply(e, r));
}
function Z3e(e, t) {
  if (t && (po(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return q3e(e);
}
function q3e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ex() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ex = function() {
    return !!e;
  })();
}
function Kc(e) {
  return Kc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Kc(e);
}
function G3e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Nf(e, t);
}
function Nf(e, t) {
  return Nf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Nf(e, t);
}
function a5(e, t, r) {
  return t = jx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function jx(e) {
  var t = Y3e(e, "string");
  return po(t) == "symbol" ? t : t + "";
}
function Y3e(e, t) {
  if (po(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (po(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ho = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    return W3e(this, t), n = U3e(this, t, [r]), n.state = {
      fontSize: "",
      letterSpacing: ""
    }, n;
  }
  return G3e(t, e), z3e(t, [{
    key: "shouldComponentUpdate",
    value: function(n, a) {
      var i = n.viewBox, o = _3(n, B3e), s = this.props, l = s.viewBox, c = _3(s, V3e);
      return !Ni(i, l) || !Ni(o, c) || !Ni(a, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var n = this.layerReference;
      if (n) {
        var a = n.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        a && this.setState({
          fontSize: window.getComputedStyle(a).fontSize,
          letterSpacing: window.getComputedStyle(a).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(n) {
      var a = this.props, i = a.x, o = a.y, s = a.width, l = a.height, c = a.orientation, u = a.tickSize, d = a.mirror, p = a.tickMargin, h, m, v, g, b, C, w = d ? -1 : 1, x = n.tickSize || u, y = oe(n.tickCoord) ? n.tickCoord : n.coordinate;
      switch (c) {
        case "top":
          h = m = n.coordinate, g = o + +!d * l, v = g - w * x, C = v - w * p, b = y;
          break;
        case "left":
          v = g = n.coordinate, m = i + +!d * s, h = m - w * x, b = h - w * p, C = y;
          break;
        case "right":
          v = g = n.coordinate, m = i + +d * s, h = m + w * x, b = h + w * p, C = y;
          break;
        default:
          h = m = n.coordinate, g = o + +d * l, v = g + w * x, C = v + w * p, b = y;
          break;
      }
      return {
        line: {
          x1: h,
          y1: v,
          x2: m,
          y2: g
        },
        tick: {
          x: b,
          y: C
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props, a = n.orientation, i = n.mirror, o;
      switch (a) {
        case "left":
          o = i ? "start" : "end";
          break;
        case "right":
          o = i ? "end" : "start";
          break;
        default:
          o = "middle";
          break;
      }
      return o;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var n = this.props, a = n.orientation, i = n.mirror, o = "end";
      switch (a) {
        case "left":
        case "right":
          o = "middle";
          break;
        case "top":
          o = i ? "start" : "end";
          break;
        default:
          o = i ? "end" : "start";
          break;
      }
      return o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, s = n.height, l = n.orientation, c = n.mirror, u = n.axisLine, d = rr(rr(rr({}, he(this.props, !1)), he(u, !1)), {}, {
        fill: "none"
      });
      if (l === "top" || l === "bottom") {
        var p = +(l === "top" && !c || l === "bottom" && c);
        d = rr(rr({}, d), {}, {
          x1: a,
          y1: i + p * s,
          x2: a + o,
          y2: i + p * s
        });
      } else {
        var h = +(l === "left" && !c || l === "right" && c);
        d = rr(rr({}, d), {}, {
          x1: a + h * o,
          y1: i,
          x2: a + h * o,
          y2: i + s
        });
      }
      return /* @__PURE__ */ E.createElement("line", Di({}, d, {
        className: De("recharts-cartesian-axis-line", Sr(u, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(n, a, i) {
        var o = this, s = this.props, l = s.tickLine, c = s.stroke, u = s.tick, d = s.tickFormatter, p = s.unit, h = n5(rr(rr({}, this.props), {}, {
          ticks: n
        }), a, i), m = this.getTickTextAnchor(), v = this.getTickVerticalAnchor(), g = he(this.props, !1), b = he(u, !1), C = rr(rr({}, g), {}, {
          fill: "none"
        }, he(l, !1)), w = h.map(function(x, y) {
          var O = o.getTickLineCoord(x), P = O.line, j = O.tick, T = rr(rr(rr(rr({
            textAnchor: m,
            verticalAnchor: v
          }, g), {}, {
            stroke: "none",
            fill: c
          }, b), j), {}, {
            index: y,
            payload: x,
            visibleTicksCount: h.length,
            tickFormatter: d
          });
          return /* @__PURE__ */ E.createElement(Me, Di({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(x.value, "-").concat(x.coordinate, "-").concat(x.tickCoord)
          }, sa(o.props, x, y)), l && /* @__PURE__ */ E.createElement("line", Di({}, C, P, {
            className: De("recharts-cartesian-axis-tick-line", Sr(l, "className"))
          })), u && t.renderTickItem(u, T, "".concat(we(d) ? d(x.value, y) : x.value).concat(p || "")));
        });
        return /* @__PURE__ */ E.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, w);
      }
    )
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.axisLine, o = a.width, s = a.height, l = a.ticksGenerator, c = a.className, u = a.hide;
      if (u)
        return null;
      var d = this.props, p = d.ticks, h = _3(d, H3e), m = p;
      return we(l) && (m = p && p.length > 0 ? l(this.props) : l(h)), o <= 0 || s <= 0 || !m || !m.length ? null : /* @__PURE__ */ E.createElement(Me, {
        className: De("recharts-cartesian-axis", c),
        ref: function(g) {
          n.layerReference = g;
        }
      }, i && this.renderAxisLine(), this.renderTicks(m, this.state.fontSize, this.state.letterSpacing), Bt.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, i) {
      var o;
      return /* @__PURE__ */ E.isValidElement(n) ? o = /* @__PURE__ */ E.cloneElement(n, a) : we(n) ? o = n(a) : o = /* @__PURE__ */ E.createElement(Qa, Di({}, a, {
        className: "recharts-cartesian-axis-tick-value"
      }), i), o;
    }
  }]);
}(Kf);
a5(Ho, "displayName", "CartesianAxis");
a5(Ho, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var K3e = ["x1", "y1", "x2", "y2", "key"], X3e = ["offset"];
function ei(e) {
  "@babel/helpers - typeof";
  return ei = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ei(e);
}
function Fh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Xt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Fh(Object(r), !0).forEach(function(n) {
      Q3e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Fh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Q3e(e, t, r) {
  return t = J3e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function J3e(e) {
  var t = e0e(e, "string");
  return ei(t) == "symbol" ? t : t + "";
}
function e0e(e, t) {
  if (ei(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ei(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Wa() {
  return Wa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wa.apply(this, arguments);
}
function Wh(e, t) {
  if (e == null)
    return {};
  var r = t0e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function t0e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
var r0e = function(t) {
  var r = t.fill;
  if (!r || r === "none")
    return null;
  var n = t.fillOpacity, a = t.x, i = t.y, o = t.width, s = t.height, l = t.ry;
  return /* @__PURE__ */ E.createElement("rect", {
    x: a,
    y: i,
    ry: l,
    width: o,
    height: s,
    stroke: "none",
    fill: r,
    fillOpacity: n,
    className: "recharts-cartesian-grid-bg"
  });
};
function _x(e, t) {
  var r;
  if (/* @__PURE__ */ E.isValidElement(e))
    r = /* @__PURE__ */ E.cloneElement(e, t);
  else if (we(e))
    r = e(t);
  else {
    var n = t.x1, a = t.y1, i = t.x2, o = t.y2, s = t.key, l = Wh(t, K3e), c = he(l, !1);
    c.offset;
    var u = Wh(c, X3e);
    r = /* @__PURE__ */ E.createElement("line", Wa({}, u, {
      x1: n,
      y1: a,
      x2: i,
      y2: o,
      fill: "none",
      key: s
    }));
  }
  return r;
}
function n0e(e) {
  var t = e.x, r = e.width, n = e.horizontal, a = n === void 0 ? !0 : n, i = e.horizontalPoints;
  if (!a || !i || !i.length)
    return null;
  var o = i.map(function(s, l) {
    var c = Xt(Xt({}, e), {}, {
      x1: t,
      y1: s,
      x2: t + r,
      y2: s,
      key: "line-".concat(l),
      index: l
    });
    return _x(a, c);
  });
  return /* @__PURE__ */ E.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, o);
}
function a0e(e) {
  var t = e.y, r = e.height, n = e.vertical, a = n === void 0 ? !0 : n, i = e.verticalPoints;
  if (!a || !i || !i.length)
    return null;
  var o = i.map(function(s, l) {
    var c = Xt(Xt({}, e), {}, {
      x1: s,
      y1: t,
      x2: s,
      y2: t + r,
      key: "line-".concat(l),
      index: l
    });
    return _x(a, c);
  });
  return /* @__PURE__ */ E.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, o);
}
function i0e(e) {
  var t = e.horizontalFill, r = e.fillOpacity, n = e.x, a = e.y, i = e.width, o = e.height, s = e.horizontalPoints, l = e.horizontal, c = l === void 0 ? !0 : l;
  if (!c || !t || !t.length)
    return null;
  var u = s.map(function(p) {
    return Math.round(p + a - a);
  }).sort(function(p, h) {
    return p - h;
  });
  a !== u[0] && u.unshift(0);
  var d = u.map(function(p, h) {
    var m = !u[h + 1], v = m ? a + o - p : u[h + 1] - p;
    if (v <= 0)
      return null;
    var g = h % t.length;
    return /* @__PURE__ */ E.createElement("rect", {
      key: "react-".concat(h),
      y: p,
      x: n,
      height: v,
      width: i,
      stroke: "none",
      fill: t[g],
      fillOpacity: r,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ E.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, d);
}
function o0e(e) {
  var t = e.vertical, r = t === void 0 ? !0 : t, n = e.verticalFill, a = e.fillOpacity, i = e.x, o = e.y, s = e.width, l = e.height, c = e.verticalPoints;
  if (!r || !n || !n.length)
    return null;
  var u = c.map(function(p) {
    return Math.round(p + i - i);
  }).sort(function(p, h) {
    return p - h;
  });
  i !== u[0] && u.unshift(0);
  var d = u.map(function(p, h) {
    var m = !u[h + 1], v = m ? i + s - p : u[h + 1] - p;
    if (v <= 0)
      return null;
    var g = h % n.length;
    return /* @__PURE__ */ E.createElement("rect", {
      key: "react-".concat(h),
      x: p,
      y: o,
      width: v,
      height: l,
      stroke: "none",
      fill: n[g],
      fillOpacity: a,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ E.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, d);
}
var s0e = function(t, r) {
  var n = t.xAxis, a = t.width, i = t.height, o = t.offset;
  return EC(n5(Xt(Xt(Xt({}, Ho.defaultProps), n), {}, {
    ticks: Mn(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: a,
      height: i
    }
  })), o.left, o.left + o.width, r);
}, l0e = function(t, r) {
  var n = t.yAxis, a = t.width, i = t.height, o = t.offset;
  return EC(n5(Xt(Xt(Xt({}, Ho.defaultProps), n), {}, {
    ticks: Mn(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: a,
      height: i
    }
  })), o.top, o.top + o.height, r);
}, bi = {
  horizontal: !0,
  vertical: !0,
  // The ordinates of horizontal grid lines
  horizontalPoints: [],
  // The abscissas of vertical grid lines
  verticalPoints: [],
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function n2(e) {
  var t, r, n, a, i, o, s = J6(), l = e5(), c = Q2e(), u = Xt(Xt({}, e), {}, {
    stroke: (t = e.stroke) !== null && t !== void 0 ? t : bi.stroke,
    fill: (r = e.fill) !== null && r !== void 0 ? r : bi.fill,
    horizontal: (n = e.horizontal) !== null && n !== void 0 ? n : bi.horizontal,
    horizontalFill: (a = e.horizontalFill) !== null && a !== void 0 ? a : bi.horizontalFill,
    vertical: (i = e.vertical) !== null && i !== void 0 ? i : bi.vertical,
    verticalFill: (o = e.verticalFill) !== null && o !== void 0 ? o : bi.verticalFill,
    x: oe(e.x) ? e.x : c.left,
    y: oe(e.y) ? e.y : c.top,
    width: oe(e.width) ? e.width : c.width,
    height: oe(e.height) ? e.height : c.height
  }), d = u.x, p = u.y, h = u.width, m = u.height, v = u.syncWithTicks, g = u.horizontalValues, b = u.verticalValues, C = Y2e(), w = K2e();
  if (!oe(h) || h <= 0 || !oe(m) || m <= 0 || !oe(d) || d !== +d || !oe(p) || p !== +p)
    return null;
  var x = u.verticalCoordinatesGenerator || s0e, y = u.horizontalCoordinatesGenerator || l0e, O = u.horizontalPoints, P = u.verticalPoints;
  if ((!O || !O.length) && we(y)) {
    var j = g && g.length, T = y({
      yAxis: w ? Xt(Xt({}, w), {}, {
        ticks: j ? g : w.ticks
      }) : void 0,
      width: s,
      height: l,
      offset: c
    }, j ? !0 : v);
    Kr(Array.isArray(T), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(ei(T), "]")), Array.isArray(T) && (O = T);
  }
  if ((!P || !P.length) && we(x)) {
    var I = b && b.length, R = x({
      xAxis: C ? Xt(Xt({}, C), {}, {
        ticks: I ? b : C.ticks
      }) : void 0,
      width: s,
      height: l,
      offset: c
    }, I ? !0 : v);
    Kr(Array.isArray(R), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(ei(R), "]")), Array.isArray(R) && (P = R);
  }
  return /* @__PURE__ */ E.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ E.createElement(r0e, {
    fill: u.fill,
    fillOpacity: u.fillOpacity,
    x: u.x,
    y: u.y,
    width: u.width,
    height: u.height,
    ry: u.ry
  }), /* @__PURE__ */ E.createElement(n0e, Wa({}, u, {
    offset: c,
    horizontalPoints: O,
    xAxis: C,
    yAxis: w
  })), /* @__PURE__ */ E.createElement(a0e, Wa({}, u, {
    offset: c,
    verticalPoints: P,
    xAxis: C,
    yAxis: w
  })), /* @__PURE__ */ E.createElement(i0e, Wa({}, u, {
    horizontalPoints: O
  })), /* @__PURE__ */ E.createElement(o0e, Wa({}, u, {
    verticalPoints: P
  })));
}
n2.displayName = "CartesianGrid";
var c0e = ["type", "layout", "connectNulls", "ref"], u0e = ["key"];
function ho(e) {
  "@babel/helpers - typeof";
  return ho = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ho(e);
}
function zh(e, t) {
  if (e == null)
    return {};
  var r = f0e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function f0e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function As() {
  return As = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, As.apply(this, arguments);
}
function Uh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function gr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Uh(Object(r), !0).forEach(function(n) {
      Zr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Uh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ci(e) {
  return v0e(e) || h0e(e) || p0e(e) || d0e();
}
function d0e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function p0e(e, t) {
  if (e) {
    if (typeof e == "string")
      return If(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return If(e, t);
  }
}
function h0e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function v0e(e) {
  if (Array.isArray(e))
    return If(e);
}
function If(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function m0e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Zh(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Dx(n.key), n);
  }
}
function g0e(e, t, r) {
  return t && Zh(e.prototype, t), r && Zh(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function y0e(e, t, r) {
  return t = Xc(t), b0e(e, Ax() ? Reflect.construct(t, r || [], Xc(e).constructor) : t.apply(e, r));
}
function b0e(e, t) {
  if (t && (ho(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return C0e(e);
}
function C0e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ax() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ax = function() {
    return !!e;
  })();
}
function Xc(e) {
  return Xc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Xc(e);
}
function x0e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Lf(e, t);
}
function Lf(e, t) {
  return Lf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Lf(e, t);
}
function Zr(e, t, r) {
  return t = Dx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Dx(e) {
  var t = w0e(e, "string");
  return ho(t) == "symbol" ? t : t + "";
}
function w0e(e, t) {
  if (ho(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ho(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var z1 = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    m0e(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = y0e(this, t, [].concat(a)), Zr(r, "state", {
      isAnimationFinished: !0,
      totalLength: 0
    }), Zr(r, "generateSimpleStrokeDasharray", function(o, s) {
      return "".concat(s, "px ").concat(o - s, "px");
    }), Zr(r, "getStrokeDasharray", function(o, s, l) {
      var c = l.reduce(function(b, C) {
        return b + C;
      });
      if (!c)
        return r.generateSimpleStrokeDasharray(s, o);
      for (var u = Math.floor(o / c), d = o % c, p = s - o, h = [], m = 0, v = 0; m < l.length; v += l[m], ++m)
        if (v + l[m] > d) {
          h = [].concat(Ci(l.slice(0, m)), [d - v]);
          break;
        }
      var g = h.length % 2 === 0 ? [0, p] : [p];
      return [].concat(Ci(t.repeat(l, u)), Ci(h), g).map(function(b) {
        return "".concat(b, "px");
      }).join(", ");
    }), Zr(r, "id", ga("recharts-line-")), Zr(r, "pathRef", function(o) {
      r.mainCurve = o;
    }), Zr(r, "handleAnimationEnd", function() {
      r.setState({
        isAnimationFinished: !0
      }), r.props.onAnimationEnd && r.props.onAnimationEnd();
    }), Zr(r, "handleAnimationStart", function() {
      r.setState({
        isAnimationFinished: !1
      }), r.props.onAnimationStart && r.props.onAnimationStart();
    }), r;
  }
  return x0e(t, e), g0e(t, [{
    key: "componentDidMount",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        n !== this.state.totalLength && this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function() {
      var n = this.mainCurve;
      try {
        return n && n.getTotalLength && n.getTotalLength() || 0;
      } catch {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function(n, a) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.points, s = i.xAxis, l = i.yAxis, c = i.layout, u = i.children, d = lr(u, Bo);
      if (!d)
        return null;
      var p = function(v, g) {
        return {
          x: v.x,
          y: v.y,
          value: v.value,
          errorVal: mt(v.payload, g)
        };
      }, h = {
        clipPath: n ? "url(#clipPath-".concat(a, ")") : null
      };
      return /* @__PURE__ */ E.createElement(Me, h, d.map(function(m) {
        return /* @__PURE__ */ E.cloneElement(m, {
          key: "bar-".concat(m.props.dataKey),
          data: o,
          xAxis: s,
          yAxis: l,
          layout: c,
          dataPointFormatter: p
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function(n, a, i) {
      var o = this.props.isAnimationActive;
      if (o && !this.state.isAnimationFinished)
        return null;
      var s = this.props, l = s.dot, c = s.points, u = s.dataKey, d = he(this.props, !1), p = he(l, !0), h = c.map(function(v, g) {
        var b = gr(gr(gr({
          key: "dot-".concat(g),
          r: 3
        }, d), p), {}, {
          value: v.value,
          dataKey: u,
          cx: v.x,
          cy: v.y,
          index: g,
          payload: v.payload
        });
        return t.renderDotItem(l, b);
      }), m = {
        clipPath: n ? "url(#clipPath-".concat(a ? "" : "dots-").concat(i, ")") : null
      };
      return /* @__PURE__ */ E.createElement(Me, As({
        className: "recharts-line-dots",
        key: "dots"
      }, m), h);
    }
  }, {
    key: "renderCurveStatically",
    value: function(n, a, i, o) {
      var s = this.props, l = s.type, c = s.layout, u = s.connectNulls;
      s.ref;
      var d = zh(s, c0e), p = gr(gr(gr({}, he(d, !0)), {}, {
        fill: "none",
        className: "recharts-line-curve",
        clipPath: a ? "url(#clipPath-".concat(i, ")") : null,
        points: n
      }, o), {}, {
        type: l,
        layout: c,
        connectNulls: u
      });
      return /* @__PURE__ */ E.createElement(aa, As({}, p, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function(n, a) {
      var i = this, o = this.props, s = o.points, l = o.strokeDasharray, c = o.isAnimationActive, u = o.animationBegin, d = o.animationDuration, p = o.animationEasing, h = o.animationId, m = o.animateNewValues, v = o.width, g = o.height, b = this.state, C = b.prevPoints, w = b.totalLength;
      return /* @__PURE__ */ E.createElement(Br, {
        begin: u,
        duration: d,
        isActive: c,
        easing: p,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(h),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(x) {
        var y = x.t;
        if (C) {
          var O = C.length / s.length, P = s.map(function(F, $) {
            var Z = Math.floor($ * O);
            if (C[Z]) {
              var X = C[Z], K = xt(X.x, F.x), J = xt(X.y, F.y);
              return gr(gr({}, F), {}, {
                x: K(y),
                y: J(y)
              });
            }
            if (m) {
              var ee = xt(v * 2, F.x), A = xt(g / 2, F.y);
              return gr(gr({}, F), {}, {
                x: ee(y),
                y: A(y)
              });
            }
            return gr(gr({}, F), {}, {
              x: F.x,
              y: F.y
            });
          });
          return i.renderCurveStatically(P, n, a);
        }
        var j = xt(0, w), T = j(y), I;
        if (l) {
          var R = "".concat(l).split(/[,\s]+/gim).map(function(F) {
            return parseFloat(F);
          });
          I = i.getStrokeDasharray(T, w, R);
        } else
          I = i.generateSimpleStrokeDasharray(w, T);
        return i.renderCurveStatically(s, n, a, {
          strokeDasharray: I
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function(n, a) {
      var i = this.props, o = i.points, s = i.isAnimationActive, l = this.state, c = l.prevPoints, u = l.totalLength;
      return s && o && o.length && (!c && u > 0 || !la(c, o)) ? this.renderCurveWithAnimation(n, a) : this.renderCurveStatically(o, n, a);
    }
  }, {
    key: "render",
    value: function() {
      var n, a = this.props, i = a.hide, o = a.dot, s = a.points, l = a.className, c = a.xAxis, u = a.yAxis, d = a.top, p = a.left, h = a.width, m = a.height, v = a.isAnimationActive, g = a.id;
      if (i || !s || !s.length)
        return null;
      var b = this.state.isAnimationFinished, C = s.length === 1, w = De("recharts-line", l), x = c && c.allowDataOverflow, y = u && u.allowDataOverflow, O = x || y, P = xe(g) ? this.id : g, j = (n = he(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, T = j.r, I = T === void 0 ? 3 : T, R = j.strokeWidth, F = R === void 0 ? 2 : R, $ = yy(o) ? o : {}, Z = $.clipDot, X = Z === void 0 ? !0 : Z, K = I * 2 + F;
      return /* @__PURE__ */ E.createElement(Me, {
        className: w
      }, x || y ? /* @__PURE__ */ E.createElement("defs", null, /* @__PURE__ */ E.createElement("clipPath", {
        id: "clipPath-".concat(P)
      }, /* @__PURE__ */ E.createElement("rect", {
        x: x ? p : p - h / 2,
        y: y ? d : d - m / 2,
        width: x ? h : h * 2,
        height: y ? m : m * 2
      })), !X && /* @__PURE__ */ E.createElement("clipPath", {
        id: "clipPath-dots-".concat(P)
      }, /* @__PURE__ */ E.createElement("rect", {
        x: p - K / 2,
        y: d - K / 2,
        width: h + K,
        height: m + K
      }))) : null, !C && this.renderCurve(O, P), this.renderErrorBar(O, P), (C || o) && this.renderDots(O, X, P), (!v || b) && Xr.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        prevPoints: a.curPoints
      } : n.points !== a.curPoints ? {
        curPoints: n.points
      } : null;
    }
  }, {
    key: "repeat",
    value: function(n, a) {
      for (var i = n.length % 2 !== 0 ? [].concat(Ci(n), [0]) : n, o = [], s = 0; s < a; ++s)
        o = [].concat(Ci(o), Ci(i));
      return o;
    }
  }, {
    key: "renderDotItem",
    value: function(n, a) {
      var i;
      if (/* @__PURE__ */ E.isValidElement(n))
        i = /* @__PURE__ */ E.cloneElement(n, a);
      else if (we(n))
        i = n(a);
      else {
        var o = a.key, s = zh(a, u0e), l = De("recharts-line-dot", typeof n != "boolean" ? n.className : "");
        i = /* @__PURE__ */ E.createElement(W1, As({
          key: o
        }, s, {
          className: l
        }));
      }
      return i;
    }
  }]);
}(Pr);
Zr(z1, "displayName", "Line");
Zr(z1, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: !1,
  activeDot: !0,
  dot: !0,
  legendType: "line",
  stroke: "#3182bd",
  strokeWidth: 1,
  fill: "#fff",
  points: [],
  isAnimationActive: !kr.isSsr,
  animateNewValues: !0,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  hide: !1,
  label: !1
});
Zr(z1, "getComposedData", function(e) {
  var t = e.props, r = e.xAxis, n = e.yAxis, a = e.xAxisTicks, i = e.yAxisTicks, o = e.dataKey, s = e.bandSize, l = e.displayedData, c = e.offset, u = t.layout, d = l.map(function(p, h) {
    var m = mt(p, o);
    return u === "horizontal" ? {
      x: eo({
        axis: r,
        ticks: a,
        bandSize: s,
        entry: p,
        index: h
      }),
      y: xe(m) ? null : n.scale(m),
      value: m,
      payload: p
    } : {
      x: xe(m) ? null : r.scale(m),
      y: eo({
        axis: n,
        ticks: i,
        bandSize: s,
        entry: p,
        index: h
      }),
      value: m,
      payload: p
    };
  });
  return gr({
    points: d,
    layout: u
  }, c);
});
var O0e = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"], S0e = ["key"], Mx;
function vo(e) {
  "@babel/helpers - typeof";
  return vo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vo(e);
}
function Tx(e, t) {
  if (e == null)
    return {};
  var r = P0e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function P0e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function za() {
  return za = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, za.apply(this, arguments);
}
function qh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Zn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qh(Object(r), !0).forEach(function(n) {
      pn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : qh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function E0e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Gh(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Nx(n.key), n);
  }
}
function j0e(e, t, r) {
  return t && Gh(e.prototype, t), r && Gh(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function _0e(e, t, r) {
  return t = Qc(t), A0e(e, $x() ? Reflect.construct(t, r || [], Qc(e).constructor) : t.apply(e, r));
}
function A0e(e, t) {
  if (t && (vo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return D0e(e);
}
function D0e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function $x() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return ($x = function() {
    return !!e;
  })();
}
function Qc(e) {
  return Qc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Qc(e);
}
function M0e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && kf(e, t);
}
function kf(e, t) {
  return kf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, kf(e, t);
}
function pn(e, t, r) {
  return t = Nx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Nx(e) {
  var t = T0e(e, "string");
  return vo(t) == "symbol" ? t : t + "";
}
function T0e(e, t) {
  if (vo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (vo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var si = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    E0e(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = _0e(this, t, [].concat(a)), pn(r, "state", {
      isAnimationFinished: !0
    }), pn(r, "id", ga("recharts-area-")), pn(r, "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), we(o) && o();
    }), pn(r, "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), we(o) && o();
    }), r;
  }
  return M0e(t, e), j0e(t, [{
    key: "renderDots",
    value: function(n, a, i) {
      var o = this.props.isAnimationActive, s = this.state.isAnimationFinished;
      if (o && !s)
        return null;
      var l = this.props, c = l.dot, u = l.points, d = l.dataKey, p = he(this.props, !1), h = he(c, !0), m = u.map(function(g, b) {
        var C = Zn(Zn(Zn({
          key: "dot-".concat(b),
          r: 3
        }, p), h), {}, {
          index: b,
          cx: g.x,
          cy: g.y,
          dataKey: d,
          value: g.value,
          payload: g.payload,
          points: u
        });
        return t.renderDotItem(c, C);
      }), v = {
        clipPath: n ? "url(#clipPath-".concat(a ? "" : "dots-").concat(i, ")") : null
      };
      return /* @__PURE__ */ E.createElement(Me, za({
        className: "recharts-area-dots"
      }, v), m);
    }
  }, {
    key: "renderHorizontalRect",
    value: function(n) {
      var a = this.props, i = a.baseLine, o = a.points, s = a.strokeWidth, l = o[0].x, c = o[o.length - 1].x, u = n * Math.abs(l - c), d = Xn(o.map(function(p) {
        return p.y || 0;
      }));
      return oe(i) && typeof i == "number" ? d = Math.max(i, d) : i && Array.isArray(i) && i.length && (d = Math.max(Xn(i.map(function(p) {
        return p.y || 0;
      })), d)), oe(d) ? /* @__PURE__ */ E.createElement("rect", {
        x: l < c ? l : l - u,
        y: 0,
        width: u,
        height: Math.floor(d + (s ? parseInt("".concat(s), 10) : 1))
      }) : null;
    }
  }, {
    key: "renderVerticalRect",
    value: function(n) {
      var a = this.props, i = a.baseLine, o = a.points, s = a.strokeWidth, l = o[0].y, c = o[o.length - 1].y, u = n * Math.abs(l - c), d = Xn(o.map(function(p) {
        return p.x || 0;
      }));
      return oe(i) && typeof i == "number" ? d = Math.max(i, d) : i && Array.isArray(i) && i.length && (d = Math.max(Xn(i.map(function(p) {
        return p.x || 0;
      })), d)), oe(d) ? /* @__PURE__ */ E.createElement("rect", {
        x: 0,
        y: l < c ? l : l - u,
        width: d + (s ? parseInt("".concat(s), 10) : 1),
        height: Math.floor(u)
      }) : null;
    }
  }, {
    key: "renderClipRect",
    value: function(n) {
      var a = this.props.layout;
      return a === "vertical" ? this.renderVerticalRect(n) : this.renderHorizontalRect(n);
    }
  }, {
    key: "renderAreaStatically",
    value: function(n, a, i, o) {
      var s = this.props, l = s.layout, c = s.type, u = s.stroke, d = s.connectNulls, p = s.isRange;
      s.ref;
      var h = Tx(s, O0e);
      return /* @__PURE__ */ E.createElement(Me, {
        clipPath: i ? "url(#clipPath-".concat(o, ")") : null
      }, /* @__PURE__ */ E.createElement(aa, za({}, he(h, !0), {
        points: n,
        connectNulls: d,
        type: c,
        baseLine: a,
        layout: l,
        stroke: "none",
        className: "recharts-area-area"
      })), u !== "none" && /* @__PURE__ */ E.createElement(aa, za({}, he(this.props, !1), {
        className: "recharts-area-curve",
        layout: l,
        type: c,
        connectNulls: d,
        fill: "none",
        points: n
      })), u !== "none" && p && /* @__PURE__ */ E.createElement(aa, za({}, he(this.props, !1), {
        className: "recharts-area-curve",
        layout: l,
        type: c,
        connectNulls: d,
        fill: "none",
        points: a
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function(n, a) {
      var i = this, o = this.props, s = o.points, l = o.baseLine, c = o.isAnimationActive, u = o.animationBegin, d = o.animationDuration, p = o.animationEasing, h = o.animationId, m = this.state, v = m.prevPoints, g = m.prevBaseLine;
      return /* @__PURE__ */ E.createElement(Br, {
        begin: u,
        duration: d,
        isActive: c,
        easing: p,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(h),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(b) {
        var C = b.t;
        if (v) {
          var w = v.length / s.length, x = s.map(function(j, T) {
            var I = Math.floor(T * w);
            if (v[I]) {
              var R = v[I], F = xt(R.x, j.x), $ = xt(R.y, j.y);
              return Zn(Zn({}, j), {}, {
                x: F(C),
                y: $(C)
              });
            }
            return j;
          }), y;
          if (oe(l) && typeof l == "number") {
            var O = xt(g, l);
            y = O(C);
          } else if (xe(l) || To(l)) {
            var P = xt(g, 0);
            y = P(C);
          } else
            y = l.map(function(j, T) {
              var I = Math.floor(T * w);
              if (g[I]) {
                var R = g[I], F = xt(R.x, j.x), $ = xt(R.y, j.y);
                return Zn(Zn({}, j), {}, {
                  x: F(C),
                  y: $(C)
                });
              }
              return j;
            });
          return i.renderAreaStatically(x, y, n, a);
        }
        return /* @__PURE__ */ E.createElement(Me, null, /* @__PURE__ */ E.createElement("defs", null, /* @__PURE__ */ E.createElement("clipPath", {
          id: "animationClipPath-".concat(a)
        }, i.renderClipRect(C))), /* @__PURE__ */ E.createElement(Me, {
          clipPath: "url(#animationClipPath-".concat(a, ")")
        }, i.renderAreaStatically(s, l, n, a)));
      });
    }
  }, {
    key: "renderArea",
    value: function(n, a) {
      var i = this.props, o = i.points, s = i.baseLine, l = i.isAnimationActive, c = this.state, u = c.prevPoints, d = c.prevBaseLine, p = c.totalLength;
      return l && o && o.length && (!u && p > 0 || !la(u, o) || !la(d, s)) ? this.renderAreaWithAnimation(n, a) : this.renderAreaStatically(o, s, n, a);
    }
  }, {
    key: "render",
    value: function() {
      var n, a = this.props, i = a.hide, o = a.dot, s = a.points, l = a.className, c = a.top, u = a.left, d = a.xAxis, p = a.yAxis, h = a.width, m = a.height, v = a.isAnimationActive, g = a.id;
      if (i || !s || !s.length)
        return null;
      var b = this.state.isAnimationFinished, C = s.length === 1, w = De("recharts-area", l), x = d && d.allowDataOverflow, y = p && p.allowDataOverflow, O = x || y, P = xe(g) ? this.id : g, j = (n = he(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, T = j.r, I = T === void 0 ? 3 : T, R = j.strokeWidth, F = R === void 0 ? 2 : R, $ = yy(o) ? o : {}, Z = $.clipDot, X = Z === void 0 ? !0 : Z, K = I * 2 + F;
      return /* @__PURE__ */ E.createElement(Me, {
        className: w
      }, x || y ? /* @__PURE__ */ E.createElement("defs", null, /* @__PURE__ */ E.createElement("clipPath", {
        id: "clipPath-".concat(P)
      }, /* @__PURE__ */ E.createElement("rect", {
        x: x ? u : u - h / 2,
        y: y ? c : c - m / 2,
        width: x ? h : h * 2,
        height: y ? m : m * 2
      })), !X && /* @__PURE__ */ E.createElement("clipPath", {
        id: "clipPath-dots-".concat(P)
      }, /* @__PURE__ */ E.createElement("rect", {
        x: u - K / 2,
        y: c - K / 2,
        width: h + K,
        height: m + K
      }))) : null, C ? null : this.renderArea(O, P), (o || C) && this.renderDots(O, X, P), (!v || b) && Xr.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        curBaseLine: n.baseLine,
        prevPoints: a.curPoints,
        prevBaseLine: a.curBaseLine
      } : n.points !== a.curPoints || n.baseLine !== a.curBaseLine ? {
        curPoints: n.points,
        curBaseLine: n.baseLine
      } : null;
    }
  }]);
}(Pr);
Mx = si;
pn(si, "displayName", "Area");
pn(si, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: !1,
  // points of area
  points: [],
  dot: !1,
  activeDot: !0,
  hide: !1,
  isAnimationActive: !kr.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
pn(si, "getBaseValue", function(e, t, r, n) {
  var a = e.layout, i = e.baseValue, o = t.props.baseValue, s = o ?? i;
  if (oe(s) && typeof s == "number")
    return s;
  var l = a === "horizontal" ? n : r, c = l.scale.domain();
  if (l.type === "number") {
    var u = Math.max(c[0], c[1]), d = Math.min(c[0], c[1]);
    return s === "dataMin" ? d : s === "dataMax" || u < 0 ? u : Math.max(Math.min(c[0], c[1]), 0);
  }
  return s === "dataMin" ? c[0] : s === "dataMax" ? c[1] : c[0];
});
pn(si, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.xAxis, a = e.yAxis, i = e.xAxisTicks, o = e.yAxisTicks, s = e.bandSize, l = e.dataKey, c = e.stackedData, u = e.dataStartIndex, d = e.displayedData, p = e.offset, h = t.layout, m = c && c.length, v = Mx.getBaseValue(t, r, n, a), g = h === "horizontal", b = !1, C = d.map(function(x, y) {
    var O;
    m ? O = c[u + y] : (O = mt(x, l), Array.isArray(O) ? b = !0 : O = [v, O]);
    var P = O[1] == null || m && mt(x, l) == null;
    return g ? {
      x: eo({
        axis: n,
        ticks: i,
        bandSize: s,
        entry: x,
        index: y
      }),
      y: P ? null : a.scale(O[1]),
      value: O,
      payload: x
    } : {
      x: P ? null : n.scale(O[1]),
      y: eo({
        axis: a,
        ticks: o,
        bandSize: s,
        entry: x,
        index: y
      }),
      value: O,
      payload: x
    };
  }), w;
  return m || b ? w = C.map(function(x) {
    var y = Array.isArray(x.value) ? x.value[0] : null;
    return g ? {
      x: x.x,
      y: y != null && x.y != null ? a.scale(y) : null
    } : {
      x: y != null ? n.scale(y) : null,
      y: x.y
    };
  }) : w = g ? a.scale(v) : n.scale(v), Zn({
    points: C,
    baseLine: w,
    layout: h,
    isRange: b
  }, p);
});
pn(si, "renderDotItem", function(e, t) {
  var r;
  if (/* @__PURE__ */ E.isValidElement(e))
    r = /* @__PURE__ */ E.cloneElement(e, t);
  else if (we(e))
    r = e(t);
  else {
    var n = De("recharts-area-dot", typeof e != "boolean" ? e.className : ""), a = t.key, i = Tx(t, S0e);
    r = /* @__PURE__ */ E.createElement(W1, za({}, i, {
      key: a,
      className: n
    }));
  }
  return r;
});
function mo(e) {
  "@babel/helpers - typeof";
  return mo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, mo(e);
}
function $0e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Yh(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, kx(n.key), n);
  }
}
function N0e(e, t, r) {
  return t && Yh(e.prototype, t), r && Yh(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function I0e(e, t, r) {
  return t = Jc(t), L0e(e, Ix() ? Reflect.construct(t, r || [], Jc(e).constructor) : t.apply(e, r));
}
function L0e(e, t) {
  if (t && (mo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return k0e(e);
}
function k0e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ix() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ix = function() {
    return !!e;
  })();
}
function Jc(e) {
  return Jc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Jc(e);
}
function R0e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Rf(e, t);
}
function Rf(e, t) {
  return Rf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Rf(e, t);
}
function Lx(e, t, r) {
  return t = kx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function kx(e) {
  var t = B0e(e, "string");
  return mo(t) == "symbol" ? t : t + "";
}
function B0e(e, t) {
  if (mo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (mo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var a2 = /* @__PURE__ */ function(e) {
  function t() {
    return $0e(this, t), I0e(this, t, arguments);
  }
  return R0e(t, e), N0e(t, [{
    key: "render",
    value: function() {
      return null;
    }
  }]);
}(E.Component);
Lx(a2, "displayName", "ZAxis");
Lx(a2, "defaultProps", {
  zAxisId: 0,
  range: [64, 64],
  scale: "auto",
  type: "number"
});
var V0e = ["option", "isActive"];
function Ds() {
  return Ds = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ds.apply(this, arguments);
}
function H0e(e, t) {
  if (e == null)
    return {};
  var r = F0e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function F0e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function W0e(e) {
  var t = e.option, r = e.isActive, n = H0e(e, V0e);
  return typeof t == "string" ? /* @__PURE__ */ E.createElement(Rc, Ds({
    option: /* @__PURE__ */ E.createElement(Tu, Ds({
      type: t
    }, n)),
    isActive: r,
    shapeType: "symbols"
  }, n)) : /* @__PURE__ */ E.createElement(Rc, Ds({
    option: t,
    isActive: r,
    shapeType: "symbols"
  }, n));
}
function go(e) {
  "@babel/helpers - typeof";
  return go = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, go(e);
}
function Ms() {
  return Ms = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ms.apply(this, arguments);
}
function Kh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Mr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Kh(Object(r), !0).forEach(function(n) {
      Jn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Kh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function z0e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Xh(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Bx(n.key), n);
  }
}
function U0e(e, t, r) {
  return t && Xh(e.prototype, t), r && Xh(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Z0e(e, t, r) {
  return t = eu(t), q0e(e, Rx() ? Reflect.construct(t, r || [], eu(e).constructor) : t.apply(e, r));
}
function q0e(e, t) {
  if (t && (go(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return G0e(e);
}
function G0e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Rx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Rx = function() {
    return !!e;
  })();
}
function eu(e) {
  return eu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, eu(e);
}
function Y0e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Bf(e, t);
}
function Bf(e, t) {
  return Bf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Bf(e, t);
}
function Jn(e, t, r) {
  return t = Bx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Bx(e) {
  var t = K0e(e, "string");
  return go(t) == "symbol" ? t : t + "";
}
function K0e(e, t) {
  if (go(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (go(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var i2 = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    z0e(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = Z0e(this, t, [].concat(a)), Jn(r, "state", {
      isAnimationFinished: !1
    }), Jn(r, "handleAnimationEnd", function() {
      r.setState({
        isAnimationFinished: !0
      });
    }), Jn(r, "handleAnimationStart", function() {
      r.setState({
        isAnimationFinished: !1
      });
    }), Jn(r, "id", ga("recharts-scatter-")), r;
  }
  return Y0e(t, e), U0e(t, [{
    key: "renderSymbolsStatically",
    value: function(n) {
      var a = this, i = this.props, o = i.shape, s = i.activeShape, l = i.activeIndex, c = he(this.props, !1);
      return n.map(function(u, d) {
        var p = l === d, h = p ? s : o, m = Mr(Mr({}, c), u);
        return /* @__PURE__ */ E.createElement(Me, Ms({
          className: "recharts-scatter-symbol",
          key: "symbol-".concat(u == null ? void 0 : u.cx, "-").concat(u == null ? void 0 : u.cy, "-").concat(u == null ? void 0 : u.size, "-").concat(d)
        }, sa(a.props, u, d), {
          role: "img"
        }), /* @__PURE__ */ E.createElement(W0e, Ms({
          option: h,
          isActive: p,
          key: "symbol-".concat(d)
        }, m)));
      });
    }
  }, {
    key: "renderSymbolsWithAnimation",
    value: function() {
      var n = this, a = this.props, i = a.points, o = a.isAnimationActive, s = a.animationBegin, l = a.animationDuration, c = a.animationEasing, u = a.animationId, d = this.state.prevPoints;
      return /* @__PURE__ */ E.createElement(Br, {
        begin: s,
        duration: l,
        isActive: o,
        easing: c,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(u),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(p) {
        var h = p.t, m = i.map(function(v, g) {
          var b = d && d[g];
          if (b) {
            var C = xt(b.cx, v.cx), w = xt(b.cy, v.cy), x = xt(b.size, v.size);
            return Mr(Mr({}, v), {}, {
              cx: C(h),
              cy: w(h),
              size: x(h)
            });
          }
          var y = xt(0, v.size);
          return Mr(Mr({}, v), {}, {
            size: y(h)
          });
        });
        return /* @__PURE__ */ E.createElement(Me, null, n.renderSymbolsStatically(m));
      });
    }
  }, {
    key: "renderSymbols",
    value: function() {
      var n = this.props, a = n.points, i = n.isAnimationActive, o = this.state.prevPoints;
      return i && a && a.length && (!o || !la(o, a)) ? this.renderSymbolsWithAnimation() : this.renderSymbolsStatically(a);
    }
  }, {
    key: "renderErrorBar",
    value: function() {
      var n = this.props.isAnimationActive;
      if (n && !this.state.isAnimationFinished)
        return null;
      var a = this.props, i = a.points, o = a.xAxis, s = a.yAxis, l = a.children, c = lr(l, Bo);
      return c ? c.map(function(u, d) {
        var p = u.props, h = p.direction, m = p.dataKey;
        return /* @__PURE__ */ E.cloneElement(u, {
          key: "".concat(h, "-").concat(m, "-").concat(i[d]),
          data: i,
          xAxis: o,
          yAxis: s,
          layout: h === "x" ? "vertical" : "horizontal",
          dataPointFormatter: function(g, b) {
            return {
              x: g.cx,
              y: g.cy,
              value: h === "x" ? +g.node.x : +g.node.y,
              errorVal: mt(g, b)
            };
          }
        });
      }) : null;
    }
  }, {
    key: "renderLine",
    value: function() {
      var n = this.props, a = n.points, i = n.line, o = n.lineType, s = n.lineJointType, l = he(this.props, !1), c = he(i, !1), u, d;
      if (o === "joint")
        u = a.map(function(w) {
          return {
            x: w.cx,
            y: w.cy
          };
        });
      else if (o === "fitting") {
        var p = aU(a), h = p.xmin, m = p.xmax, v = p.a, g = p.b, b = function(x) {
          return v * x + g;
        };
        u = [{
          x: h,
          y: b(h)
        }, {
          x: m,
          y: b(m)
        }];
      }
      var C = Mr(Mr(Mr({}, l), {}, {
        fill: "none",
        stroke: l && l.fill
      }, c), {}, {
        points: u
      });
      return /* @__PURE__ */ E.isValidElement(i) ? d = /* @__PURE__ */ E.cloneElement(i, C) : we(i) ? d = i(C) : d = /* @__PURE__ */ E.createElement(aa, Ms({}, C, {
        type: s
      })), /* @__PURE__ */ E.createElement(Me, {
        className: "recharts-scatter-line",
        key: "recharts-scatter-line"
      }, d);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.hide, i = n.points, o = n.line, s = n.className, l = n.xAxis, c = n.yAxis, u = n.left, d = n.top, p = n.width, h = n.height, m = n.id, v = n.isAnimationActive;
      if (a || !i || !i.length)
        return null;
      var g = this.state.isAnimationFinished, b = De("recharts-scatter", s), C = l && l.allowDataOverflow, w = c && c.allowDataOverflow, x = C || w, y = xe(m) ? this.id : m;
      return /* @__PURE__ */ E.createElement(Me, {
        className: b,
        clipPath: x ? "url(#clipPath-".concat(y, ")") : null
      }, C || w ? /* @__PURE__ */ E.createElement("defs", null, /* @__PURE__ */ E.createElement("clipPath", {
        id: "clipPath-".concat(y)
      }, /* @__PURE__ */ E.createElement("rect", {
        x: C ? u : u - p / 2,
        y: w ? d : d - h / 2,
        width: C ? p : p * 2,
        height: w ? h : h * 2
      }))) : null, o && this.renderLine(), this.renderErrorBar(), /* @__PURE__ */ E.createElement(Me, {
        key: "recharts-scatter-symbols"
      }, this.renderSymbols()), (!v || g) && Xr.renderCallByParent(this.props, i));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        prevPoints: a.curPoints
      } : n.points !== a.curPoints ? {
        curPoints: n.points
      } : null;
    }
  }]);
}(Pr);
Jn(i2, "displayName", "Scatter");
Jn(i2, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  zAxisId: 0,
  legendType: "circle",
  lineType: "joint",
  lineJointType: "linear",
  data: [],
  shape: "circle",
  hide: !1,
  isAnimationActive: !kr.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "linear"
});
Jn(i2, "getComposedData", function(e) {
  var t = e.xAxis, r = e.yAxis, n = e.zAxis, a = e.item, i = e.displayedData, o = e.xAxisTicks, s = e.yAxisTicks, l = e.offset, c = a.props.tooltipType, u = lr(a.props.children, en), d = xe(t.dataKey) ? a.props.dataKey : t.dataKey, p = xe(r.dataKey) ? a.props.dataKey : r.dataKey, h = n && n.dataKey, m = n ? n.range : a2.defaultProps.range, v = m && m[0], g = t.scale.bandwidth ? t.scale.bandwidth() : 0, b = r.scale.bandwidth ? r.scale.bandwidth() : 0, C = i.map(function(w, x) {
    var y = mt(w, d), O = mt(w, p), P = !xe(h) && mt(w, h) || "-", j = [{
      name: xe(t.dataKey) ? a.props.name : t.name || t.dataKey,
      unit: t.unit || "",
      value: y,
      payload: w,
      dataKey: d,
      type: c
    }, {
      name: xe(r.dataKey) ? a.props.name : r.name || r.dataKey,
      unit: r.unit || "",
      value: O,
      payload: w,
      dataKey: p,
      type: c
    }];
    P !== "-" && j.push({
      name: n.name || n.dataKey,
      unit: n.unit || "",
      value: P,
      payload: w,
      dataKey: h,
      type: c
    });
    var T = eo({
      axis: t,
      ticks: o,
      bandSize: g,
      entry: w,
      index: x,
      dataKey: d
    }), I = eo({
      axis: r,
      ticks: s,
      bandSize: b,
      entry: w,
      index: x,
      dataKey: p
    }), R = P !== "-" ? n.scale(P) : v, F = Math.sqrt(Math.max(R, 0) / Math.PI);
    return Mr(Mr({}, w), {}, {
      cx: T,
      cy: I,
      x: T - F,
      y: I - F,
      xAxis: t,
      yAxis: r,
      zAxis: n,
      width: 2 * F,
      height: 2 * F,
      size: R,
      node: {
        x: y,
        y: O,
        z: P
      },
      tooltipPayload: j,
      tooltipPosition: {
        x: T,
        y: I
      },
      payload: w
    }, u && u[x] && u[x].props);
  });
  return Mr({
    points: C
  }, l);
});
function yo(e) {
  "@babel/helpers - typeof";
  return yo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, yo(e);
}
function X0e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Qh(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Fx(n.key), n);
  }
}
function Q0e(e, t, r) {
  return t && Qh(e.prototype, t), r && Qh(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function J0e(e, t, r) {
  return t = tu(t), efe(e, Vx() ? Reflect.construct(t, r || [], tu(e).constructor) : t.apply(e, r));
}
function efe(e, t) {
  if (t && (yo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return tfe(e);
}
function tfe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Vx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Vx = function() {
    return !!e;
  })();
}
function tu(e) {
  return tu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, tu(e);
}
function rfe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Vf(e, t);
}
function Vf(e, t) {
  return Vf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Vf(e, t);
}
function Hx(e, t, r) {
  return t = Fx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Fx(e) {
  var t = nfe(e, "string");
  return yo(t) == "symbol" ? t : t + "";
}
function nfe(e, t) {
  if (yo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (yo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Hf() {
  return Hf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Hf.apply(this, arguments);
}
function afe(e) {
  var t = e.xAxisId, r = J6(), n = e5(), a = gx(t);
  return a == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ E.createElement(Ho, Hf({}, a, {
      className: De("recharts-".concat(a.axisType, " ").concat(a.axisType), a.className),
      viewBox: {
        x: 0,
        y: 0,
        width: r,
        height: n
      },
      ticksGenerator: function(o) {
        return Mn(o, !0);
      }
    }))
  );
}
var ca = /* @__PURE__ */ function(e) {
  function t() {
    return X0e(this, t), J0e(this, t, arguments);
  }
  return rfe(t, e), Q0e(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ E.createElement(afe, this.props);
    }
  }]);
}(E.Component);
Hx(ca, "displayName", "XAxis");
Hx(ca, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function bo(e) {
  "@babel/helpers - typeof";
  return bo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, bo(e);
}
function ife(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Jh(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ux(n.key), n);
  }
}
function ofe(e, t, r) {
  return t && Jh(e.prototype, t), r && Jh(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function sfe(e, t, r) {
  return t = ru(t), lfe(e, Wx() ? Reflect.construct(t, r || [], ru(e).constructor) : t.apply(e, r));
}
function lfe(e, t) {
  if (t && (bo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return cfe(e);
}
function cfe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Wx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Wx = function() {
    return !!e;
  })();
}
function ru(e) {
  return ru = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ru(e);
}
function ufe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ff(e, t);
}
function Ff(e, t) {
  return Ff = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Ff(e, t);
}
function zx(e, t, r) {
  return t = Ux(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Ux(e) {
  var t = ffe(e, "string");
  return bo(t) == "symbol" ? t : t + "";
}
function ffe(e, t) {
  if (bo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (bo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Wf() {
  return Wf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wf.apply(this, arguments);
}
var dfe = function(t) {
  var r = t.yAxisId, n = J6(), a = e5(), i = yx(r);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ E.createElement(Ho, Wf({}, i, {
      className: De("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: a
      },
      ticksGenerator: function(s) {
        return Mn(s, !0);
      }
    }))
  );
}, li = /* @__PURE__ */ function(e) {
  function t() {
    return ife(this, t), sfe(this, t, arguments);
  }
  return ufe(t, e), ofe(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ E.createElement(dfe, this.props);
    }
  }]);
}(E.Component);
zx(li, "displayName", "YAxis");
zx(li, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function ev(e) {
  return mfe(e) || vfe(e) || hfe(e) || pfe();
}
function pfe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function hfe(e, t) {
  if (e) {
    if (typeof e == "string")
      return zf(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return zf(e, t);
  }
}
function vfe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function mfe(e) {
  if (Array.isArray(e))
    return zf(e);
}
function zf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var Uf = function(t, r, n, a, i) {
  var o = lr(t, r5), s = lr(t, e2), l = [].concat(ev(o), ev(s)), c = lr(t, r2), u = "".concat(a, "Id"), d = a[0], p = r;
  if (l.length && (p = l.reduce(function(v, g) {
    if (g.props[u] === n && vn(g.props, "extendDomain") && oe(g.props[d])) {
      var b = g.props[d];
      return [Math.min(v[0], b), Math.max(v[1], b)];
    }
    return v;
  }, p)), c.length) {
    var h = "".concat(d, "1"), m = "".concat(d, "2");
    p = c.reduce(function(v, g) {
      if (g.props[u] === n && vn(g.props, "extendDomain") && oe(g.props[h]) && oe(g.props[m])) {
        var b = g.props[h], C = g.props[m];
        return [Math.min(v[0], b, C), Math.max(v[1], b, C)];
      }
      return v;
    }, p);
  }
  return i && i.length && (p = i.reduce(function(v, g) {
    return oe(g) ? [Math.min(v[0], g), Math.max(v[1], g)] : v;
  }, p)), p;
}, Zx = { exports: {} };
(function(e) {
  var t = Object.prototype.hasOwnProperty, r = "~";
  function n() {
  }
  Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
  function a(l, c, u) {
    this.fn = l, this.context = c, this.once = u || !1;
  }
  function i(l, c, u, d, p) {
    if (typeof u != "function")
      throw new TypeError("The listener must be a function");
    var h = new a(u, d || l, p), m = r ? r + c : c;
    return l._events[m] ? l._events[m].fn ? l._events[m] = [l._events[m], h] : l._events[m].push(h) : (l._events[m] = h, l._eventsCount++), l;
  }
  function o(l, c) {
    --l._eventsCount === 0 ? l._events = new n() : delete l._events[c];
  }
  function s() {
    this._events = new n(), this._eventsCount = 0;
  }
  s.prototype.eventNames = function() {
    var c = [], u, d;
    if (this._eventsCount === 0)
      return c;
    for (d in u = this._events)
      t.call(u, d) && c.push(r ? d.slice(1) : d);
    return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(u)) : c;
  }, s.prototype.listeners = function(c) {
    var u = r ? r + c : c, d = this._events[u];
    if (!d)
      return [];
    if (d.fn)
      return [d.fn];
    for (var p = 0, h = d.length, m = new Array(h); p < h; p++)
      m[p] = d[p].fn;
    return m;
  }, s.prototype.listenerCount = function(c) {
    var u = r ? r + c : c, d = this._events[u];
    return d ? d.fn ? 1 : d.length : 0;
  }, s.prototype.emit = function(c, u, d, p, h, m) {
    var v = r ? r + c : c;
    if (!this._events[v])
      return !1;
    var g = this._events[v], b = arguments.length, C, w;
    if (g.fn) {
      switch (g.once && this.removeListener(c, g.fn, void 0, !0), b) {
        case 1:
          return g.fn.call(g.context), !0;
        case 2:
          return g.fn.call(g.context, u), !0;
        case 3:
          return g.fn.call(g.context, u, d), !0;
        case 4:
          return g.fn.call(g.context, u, d, p), !0;
        case 5:
          return g.fn.call(g.context, u, d, p, h), !0;
        case 6:
          return g.fn.call(g.context, u, d, p, h, m), !0;
      }
      for (w = 1, C = new Array(b - 1); w < b; w++)
        C[w - 1] = arguments[w];
      g.fn.apply(g.context, C);
    } else {
      var x = g.length, y;
      for (w = 0; w < x; w++)
        switch (g[w].once && this.removeListener(c, g[w].fn, void 0, !0), b) {
          case 1:
            g[w].fn.call(g[w].context);
            break;
          case 2:
            g[w].fn.call(g[w].context, u);
            break;
          case 3:
            g[w].fn.call(g[w].context, u, d);
            break;
          case 4:
            g[w].fn.call(g[w].context, u, d, p);
            break;
          default:
            if (!C)
              for (y = 1, C = new Array(b - 1); y < b; y++)
                C[y - 1] = arguments[y];
            g[w].fn.apply(g[w].context, C);
        }
    }
    return !0;
  }, s.prototype.on = function(c, u, d) {
    return i(this, c, u, d, !1);
  }, s.prototype.once = function(c, u, d) {
    return i(this, c, u, d, !0);
  }, s.prototype.removeListener = function(c, u, d, p) {
    var h = r ? r + c : c;
    if (!this._events[h])
      return this;
    if (!u)
      return o(this, h), this;
    var m = this._events[h];
    if (m.fn)
      m.fn === u && (!p || m.once) && (!d || m.context === d) && o(this, h);
    else {
      for (var v = 0, g = [], b = m.length; v < b; v++)
        (m[v].fn !== u || p && !m[v].once || d && m[v].context !== d) && g.push(m[v]);
      g.length ? this._events[h] = g.length === 1 ? g[0] : g : o(this, h);
    }
    return this;
  }, s.prototype.removeAllListeners = function(c) {
    var u;
    return c ? (u = r ? r + c : c, this._events[u] && o(this, u)) : (this._events = new n(), this._eventsCount = 0), this;
  }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = r, s.EventEmitter = s, e.exports = s;
})(Zx);
var gfe = Zx.exports;
const yfe = /* @__PURE__ */ Ze(gfe);
var A3 = new yfe(), D3 = "recharts.syncMouseEvents";
function b1(e) {
  "@babel/helpers - typeof";
  return b1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, b1(e);
}
function bfe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function tv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, qx(n.key), n);
  }
}
function Cfe(e, t, r) {
  return t && tv(e.prototype, t), r && tv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function M3(e, t, r) {
  return t = qx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function qx(e) {
  var t = xfe(e, "string");
  return b1(t) == "symbol" ? t : t + "";
}
function xfe(e, t) {
  if (b1(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (b1(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var wfe = /* @__PURE__ */ function() {
  function e() {
    bfe(this, e), M3(this, "activeIndex", 0), M3(this, "coordinateList", []), M3(this, "layout", "horizontal");
  }
  return Cfe(e, [{
    key: "setDetails",
    value: function(r) {
      var n, a = r.coordinateList, i = a === void 0 ? null : a, o = r.container, s = o === void 0 ? null : o, l = r.layout, c = l === void 0 ? null : l, u = r.offset, d = u === void 0 ? null : u, p = r.mouseHandlerCallback, h = p === void 0 ? null : p;
      this.coordinateList = (n = i ?? this.coordinateList) !== null && n !== void 0 ? n : [], this.container = s ?? this.container, this.layout = c ?? this.layout, this.offset = d ?? this.offset, this.mouseHandlerCallback = h ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(r) {
      if (this.coordinateList.length !== 0)
        switch (r.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(r) {
      this.activeIndex = r;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var r, n;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var a = this.container.getBoundingClientRect(), i = a.x, o = a.y, s = a.height, l = this.coordinateList[this.activeIndex].coordinate, c = ((r = window) === null || r === void 0 ? void 0 : r.scrollX) || 0, u = ((n = window) === null || n === void 0 ? void 0 : n.scrollY) || 0, d = i + l + c, p = o + this.offset.top + s / 2 + u;
        this.mouseHandlerCallback({
          pageX: d,
          pageY: p
        });
      }
    }
  }]);
}();
function Ofe(e, t, r) {
  if (r === "number" && t === !0 && Array.isArray(e)) {
    var n = e == null ? void 0 : e[0], a = e == null ? void 0 : e[1];
    if (n && a && oe(n) && oe(a))
      return !0;
  }
  return !1;
}
function Sfe(e, t, r, n) {
  var a = n / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - a : r.left + 0.5,
    y: e === "horizontal" ? r.top + 0.5 : t.y - a,
    width: e === "horizontal" ? n : r.width - 1,
    height: e === "horizontal" ? r.height - 1 : n
  };
}
function Gx(e) {
  var t = e.cx, r = e.cy, n = e.radius, a = e.startAngle, i = e.endAngle, o = dt(t, r, n, a), s = dt(t, r, n, i);
  return {
    points: [o, s],
    cx: t,
    cy: r,
    radius: n,
    startAngle: a,
    endAngle: i
  };
}
function Pfe(e, t, r) {
  var n, a, i, o;
  if (e === "horizontal")
    n = t.x, i = n, a = r.top, o = r.top + r.height;
  else if (e === "vertical")
    a = t.y, o = a, n = r.left, i = r.left + r.width;
  else if (t.cx != null && t.cy != null)
    if (e === "centric") {
      var s = t.cx, l = t.cy, c = t.innerRadius, u = t.outerRadius, d = t.angle, p = dt(s, l, c, d), h = dt(s, l, u, d);
      n = p.x, a = p.y, i = h.x, o = h.y;
    } else
      return Gx(t);
  return [{
    x: n,
    y: a
  }, {
    x: i,
    y: o
  }];
}
function C1(e) {
  "@babel/helpers - typeof";
  return C1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, C1(e);
}
function rv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ml(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? rv(Object(r), !0).forEach(function(n) {
      Efe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : rv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Efe(e, t, r) {
  return t = jfe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function jfe(e) {
  var t = _fe(e, "string");
  return C1(t) == "symbol" ? t : t + "";
}
function _fe(e, t) {
  if (C1(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (C1(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Afe(e) {
  var t, r, n = e.element, a = e.tooltipEventType, i = e.isActive, o = e.activeCoordinate, s = e.activePayload, l = e.offset, c = e.activeTooltipIndex, u = e.tooltipAxisBandSize, d = e.layout, p = e.chartName, h = (t = n.props.cursor) !== null && t !== void 0 ? t : (r = n.type.defaultProps) === null || r === void 0 ? void 0 : r.cursor;
  if (!n || !h || !i || !o || p !== "ScatterChart" && a !== "axis")
    return null;
  var m, v = aa;
  if (p === "ScatterChart")
    m = o, v = Ple;
  else if (p === "BarChart")
    m = Sfe(d, o, l, u), v = Y6;
  else if (d === "radial") {
    var g = Gx(o), b = g.cx, C = g.cy, w = g.radius, x = g.startAngle, y = g.endAngle;
    m = {
      cx: b,
      cy: C,
      startAngle: x,
      endAngle: y,
      innerRadius: w,
      outerRadius: w
    }, v = kC;
  } else
    m = {
      points: Pfe(d, o, l)
    }, v = aa;
  var O = ml(ml(ml(ml({
    stroke: "#ccc",
    pointerEvents: "none"
  }, l), m), he(h, !1)), {}, {
    payload: s,
    payloadIndex: c,
    className: De("recharts-tooltip-cursor", h.className)
  });
  return /* @__PURE__ */ Yr(h) ? /* @__PURE__ */ Rt(h, O) : /* @__PURE__ */ fv(v, O);
}
var Dfe = ["item"], Mfe = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function Co(e) {
  "@babel/helpers - typeof";
  return Co = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Co(e);
}
function Ts() {
  return Ts = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ts.apply(this, arguments);
}
function nv(e, t) {
  return Nfe(e) || $fe(e, t) || Kx(e, t) || Tfe();
}
function Tfe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $fe(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function Nfe(e) {
  if (Array.isArray(e))
    return e;
}
function av(e, t) {
  if (e == null)
    return {};
  var r = Ife(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Ife(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function Lfe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function iv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Xx(n.key), n);
  }
}
function kfe(e, t, r) {
  return t && iv(e.prototype, t), r && iv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Rfe(e, t, r) {
  return t = nu(t), Bfe(e, Yx() ? Reflect.construct(t, r || [], nu(e).constructor) : t.apply(e, r));
}
function Bfe(e, t) {
  if (t && (Co(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Vfe(e);
}
function Vfe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Yx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Yx = function() {
    return !!e;
  })();
}
function nu(e) {
  return nu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, nu(e);
}
function Hfe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Zf(e, t);
}
function Zf(e, t) {
  return Zf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Zf(e, t);
}
function xo(e) {
  return zfe(e) || Wfe(e) || Kx(e) || Ffe();
}
function Ffe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Kx(e, t) {
  if (e) {
    if (typeof e == "string")
      return qf(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return qf(e, t);
  }
}
function Wfe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function zfe(e) {
  if (Array.isArray(e))
    return qf(e);
}
function qf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function ov(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function re(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ov(Object(r), !0).forEach(function(n) {
      Oe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ov(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Oe(e, t, r) {
  return t = Xx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Xx(e) {
  var t = Ufe(e, "string");
  return Co(t) == "symbol" ? t : t + "";
}
function Ufe(e, t) {
  if (Co(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Co(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Zfe = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, qfe = {
  width: "100%",
  height: "100%"
}, Qx = {
  x: 0,
  y: 0
};
function gl(e) {
  return e;
}
var Gfe = function(t, r) {
  return r === "horizontal" ? t.x : r === "vertical" ? t.y : r === "centric" ? t.angle : t.radius;
}, Yfe = function(t, r, n, a) {
  var i = r.find(function(u) {
    return u && u.index === n;
  });
  if (i) {
    if (t === "horizontal")
      return {
        x: i.coordinate,
        y: a.y
      };
    if (t === "vertical")
      return {
        x: a.x,
        y: i.coordinate
      };
    if (t === "centric") {
      var o = i.coordinate, s = a.radius;
      return re(re(re({}, a), dt(a.cx, a.cy, s, o)), {}, {
        angle: o,
        radius: s
      });
    }
    var l = i.coordinate, c = a.angle;
    return re(re(re({}, a), dt(a.cx, a.cy, l, c)), {}, {
      angle: c,
      radius: l
    });
  }
  return Qx;
}, o2 = function(t, r) {
  var n = r.graphicalItems, a = r.dataStartIndex, i = r.dataEndIndex, o = (n ?? []).reduce(function(s, l) {
    var c = l.props.data;
    return c && c.length ? [].concat(xo(s), xo(c)) : s;
  }, []);
  return o.length > 0 ? o : t && t.length && oe(a) && oe(i) ? t.slice(a, i + 1) : [];
};
function Jx(e) {
  return e === "number" ? [0, "auto"] : void 0;
}
var Gf = function(t, r, n, a) {
  var i = t.graphicalItems, o = t.tooltipAxis, s = o2(r, t);
  return n < 0 || !i || !i.length || n >= s.length ? null : i.reduce(function(l, c) {
    var u, d = (u = c.props.data) !== null && u !== void 0 ? u : r;
    d && t.dataStartIndex + t.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    t.dataEndIndex - t.dataStartIndex >= n && (d = d.slice(t.dataStartIndex, t.dataEndIndex + 1));
    var p;
    if (o.dataKey && !o.allowDuplicatedCategory) {
      var h = d === void 0 ? s : d;
      p = Ql(h, o.dataKey, a);
    } else
      p = d && d[n] || s[n];
    return p ? [].concat(xo(l), [MC(c, p)]) : l;
  }, []);
}, sv = function(t, r, n, a) {
  var i = a || {
    x: t.chartX,
    y: t.chartY
  }, o = Gfe(i, n), s = t.orderedTooltipTicks, l = t.tooltipAxis, c = t.tooltipTicks, u = uoe(o, s, c, l);
  if (u >= 0 && c) {
    var d = c[u] && c[u].value, p = Gf(t, r, u, d), h = Yfe(n, s, u, i);
    return {
      activeTooltipIndex: u,
      activeLabel: d,
      activePayload: p,
      activeCoordinate: h
    };
  }
  return null;
}, Kfe = function(t, r) {
  var n = r.axes, a = r.graphicalItems, i = r.axisType, o = r.axisIdKey, s = r.stackGroups, l = r.dataStartIndex, c = r.dataEndIndex, u = t.layout, d = t.children, p = t.stackOffset, h = PC(u, i);
  return n.reduce(function(m, v) {
    var g, b = v.type.defaultProps !== void 0 ? re(re({}, v.type.defaultProps), v.props) : v.props, C = b.type, w = b.dataKey, x = b.allowDataOverflow, y = b.allowDuplicatedCategory, O = b.scale, P = b.ticks, j = b.includeHidden, T = b[o];
    if (m[T])
      return m;
    var I = o2(t.data, {
      graphicalItems: a.filter(function(M) {
        var S, B = o in M.props ? M.props[o] : (S = M.type.defaultProps) === null || S === void 0 ? void 0 : S[o];
        return B === T;
      }),
      dataStartIndex: l,
      dataEndIndex: c
    }), R = I.length, F, $, Z;
    Ofe(b.domain, x, C) && (F = af(b.domain, null, x), h && (C === "number" || O !== "auto") && (Z = Ps(I, w, "category")));
    var X = Jx(C);
    if (!F || F.length === 0) {
      var K, J = (K = b.domain) !== null && K !== void 0 ? K : X;
      if (w) {
        if (F = Ps(I, w, C), C === "category" && h) {
          var ee = nU(F);
          y && ee ? ($ = F, F = Vc(0, R)) : y || (F = m9(J, F, v).reduce(function(M, S) {
            return M.indexOf(S) >= 0 ? M : [].concat(xo(M), [S]);
          }, []));
        } else if (C === "category")
          y ? F = F.filter(function(M) {
            return M !== "" && !xe(M);
          }) : F = m9(J, F, v).reduce(function(M, S) {
            return M.indexOf(S) >= 0 || S === "" || xe(S) ? M : [].concat(xo(M), [S]);
          }, []);
        else if (C === "number") {
          var A = voe(I, a.filter(function(M) {
            var S, B, G = o in M.props ? M.props[o] : (S = M.type.defaultProps) === null || S === void 0 ? void 0 : S[o], U = "hide" in M.props ? M.props.hide : (B = M.type.defaultProps) === null || B === void 0 ? void 0 : B.hide;
            return G === T && (j || !U);
          }), w, i, u);
          A && (F = A);
        }
        h && (C === "number" || O !== "auto") && (Z = Ps(I, w, "category"));
      } else
        h ? F = Vc(0, R) : s && s[T] && s[T].hasStack && C === "number" ? F = p === "expand" ? [0, 1] : DC(s[T].stackGroups, l, c) : F = SC(I, a.filter(function(M) {
          var S = o in M.props ? M.props[o] : M.type.defaultProps[o], B = "hide" in M.props ? M.props.hide : M.type.defaultProps.hide;
          return S === T && (j || !B);
        }), C, u, !0);
      if (C === "number")
        F = Uf(d, F, T, i, P), J && (F = af(J, F, x));
      else if (C === "category" && J) {
        var _ = J, N = F.every(function(M) {
          return _.indexOf(M) >= 0;
        });
        N && (F = _);
      }
    }
    return re(re({}, m), {}, Oe({}, T, re(re({}, b), {}, {
      axisType: i,
      domain: F,
      categoricalDomain: Z,
      duplicateDomain: $,
      originalDomain: (g = b.domain) !== null && g !== void 0 ? g : X,
      isCategorical: h,
      layout: u
    })));
  }, {});
}, Xfe = function(t, r) {
  var n = r.graphicalItems, a = r.Axis, i = r.axisType, o = r.axisIdKey, s = r.stackGroups, l = r.dataStartIndex, c = r.dataEndIndex, u = t.layout, d = t.children, p = o2(t.data, {
    graphicalItems: n,
    dataStartIndex: l,
    dataEndIndex: c
  }), h = p.length, m = PC(u, i), v = -1;
  return n.reduce(function(g, b) {
    var C = b.type.defaultProps !== void 0 ? re(re({}, b.type.defaultProps), b.props) : b.props, w = C[o], x = Jx("number");
    if (!g[w]) {
      v++;
      var y;
      return m ? y = Vc(0, h) : s && s[w] && s[w].hasStack ? (y = DC(s[w].stackGroups, l, c), y = Uf(d, y, w, i)) : (y = af(x, SC(p, n.filter(function(O) {
        var P, j, T = o in O.props ? O.props[o] : (P = O.type.defaultProps) === null || P === void 0 ? void 0 : P[o], I = "hide" in O.props ? O.props.hide : (j = O.type.defaultProps) === null || j === void 0 ? void 0 : j.hide;
        return T === w && !I;
      }), "number", u), a.defaultProps.allowDataOverflow), y = Uf(d, y, w, i)), re(re({}, g), {}, Oe({}, w, re(re({
        axisType: i
      }, a.defaultProps), {}, {
        hide: !0,
        orientation: Sr(Zfe, "".concat(i, ".").concat(v % 2), null),
        domain: y,
        originalDomain: x,
        isCategorical: m,
        layout: u
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return g;
  }, {});
}, Qfe = function(t, r) {
  var n = r.axisType, a = n === void 0 ? "xAxis" : n, i = r.AxisComp, o = r.graphicalItems, s = r.stackGroups, l = r.dataStartIndex, c = r.dataEndIndex, u = t.children, d = "".concat(a, "Id"), p = lr(u, i), h = {};
  return p && p.length ? h = Kfe(t, {
    axes: p,
    graphicalItems: o,
    axisType: a,
    axisIdKey: d,
    stackGroups: s,
    dataStartIndex: l,
    dataEndIndex: c
  }) : o && o.length && (h = Xfe(t, {
    Axis: i,
    graphicalItems: o,
    axisType: a,
    axisIdKey: d,
    stackGroups: s,
    dataStartIndex: l,
    dataEndIndex: c
  })), h;
}, Jfe = function(t) {
  var r = Yn(t), n = Mn(r, !1, !0);
  return {
    tooltipTicks: n,
    orderedTooltipTicks: w6(n, function(a) {
      return a.coordinate;
    }),
    tooltipAxis: r,
    tooltipAxisBandSize: Ec(r, n)
  };
}, lv = function(t) {
  var r = t.children, n = t.defaultShowTooltip, a = br(r, oo), i = 0, o = 0;
  return t.data && t.data.length !== 0 && (o = t.data.length - 1), a && a.props && (a.props.startIndex >= 0 && (i = a.props.startIndex), a.props.endIndex >= 0 && (o = a.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: i,
    dataEndIndex: o,
    activeTooltipIndex: -1,
    isTooltipActive: !!n
  };
}, ede = function(t) {
  return !t || !t.length ? !1 : t.some(function(r) {
    var n = Nn(r && r.type);
    return n && n.indexOf("Bar") >= 0;
  });
}, cv = function(t) {
  return t === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : t === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : t === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, tde = function(t, r) {
  var n = t.props, a = t.graphicalItems, i = t.xAxisMap, o = i === void 0 ? {} : i, s = t.yAxisMap, l = s === void 0 ? {} : s, c = n.width, u = n.height, d = n.children, p = n.margin || {}, h = br(d, oo), m = br(d, In), v = Object.keys(l).reduce(function(y, O) {
    var P = l[O], j = P.orientation;
    return !P.mirror && !P.hide ? re(re({}, y), {}, Oe({}, j, y[j] + P.width)) : y;
  }, {
    left: p.left || 0,
    right: p.right || 0
  }), g = Object.keys(o).reduce(function(y, O) {
    var P = o[O], j = P.orientation;
    return !P.mirror && !P.hide ? re(re({}, y), {}, Oe({}, j, Sr(y, "".concat(j)) + P.height)) : y;
  }, {
    top: p.top || 0,
    bottom: p.bottom || 0
  }), b = re(re({}, g), v), C = b.bottom;
  h && (b.bottom += h.props.height || oo.defaultProps.height), m && r && (b = poe(b, a, n, r));
  var w = c - b.left - b.right, x = u - b.top - b.bottom;
  return re(re({
    brushBottom: C
  }, b), {}, {
    // never return negative values for height and width
    width: Math.max(w, 0),
    height: Math.max(x, 0)
  });
}, rde = function(t, r) {
  if (r === "xAxis")
    return t[r].width;
  if (r === "yAxis")
    return t[r].height;
}, i5 = function(t) {
  var r = t.chartName, n = t.GraphicalChild, a = t.defaultTooltipEventType, i = a === void 0 ? "axis" : a, o = t.validateTooltipEventTypes, s = o === void 0 ? ["axis"] : o, l = t.axisComponents, c = t.legendContent, u = t.formatAxisMap, d = t.defaultProps, p = function(g, b) {
    var C = b.graphicalItems, w = b.stackGroups, x = b.offset, y = b.updateId, O = b.dataStartIndex, P = b.dataEndIndex, j = g.barSize, T = g.layout, I = g.barGap, R = g.barCategoryGap, F = g.maxBarSize, $ = cv(T), Z = $.numericAxisName, X = $.cateAxisName, K = ede(C), J = [];
    return C.forEach(function(ee, A) {
      var _ = o2(g.data, {
        graphicalItems: [ee],
        dataStartIndex: O,
        dataEndIndex: P
      }), N = ee.type.defaultProps !== void 0 ? re(re({}, ee.type.defaultProps), ee.props) : ee.props, M = N.dataKey, S = N.maxBarSize, B = N["".concat(Z, "Id")], G = N["".concat(X, "Id")], U = {}, H = l.reduce(function(ue, Te) {
        var Be, Ye, Ct = b["".concat(Te.axisType, "Map")], It = N["".concat(Te.axisType, "Id")];
        Ct && Ct[It] || Te.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? Qt(!1, "Specifying a(n) ".concat(Te.axisType, "Id requires a corresponding ").concat(
          Te.axisType,
          "Id on the targeted graphical component "
        ).concat((Be = ee == null || (Ye = ee.type) === null || Ye === void 0 ? void 0 : Ye.displayName) !== null && Be !== void 0 ? Be : "")) : Qt(!1));
        var Wr = Ct[It];
        return re(re({}, ue), {}, Oe(Oe({}, Te.axisType, Wr), "".concat(Te.axisType, "Ticks"), Mn(Wr)));
      }, U), k = H[X], L = H["".concat(X, "Ticks")], W = w && w[B] && w[B].hasStack && Soe(ee, w[B].stackGroups), V = Nn(ee.type).indexOf("Bar") >= 0, D = Ec(k, L), Q = [], z = K && foe({
        barSize: j,
        stackGroups: w,
        totalSize: rde(H, X)
      });
      if (V) {
        var te, ne, ae = xe(S) ? F : S, se = (te = (ne = Ec(k, L, !0)) !== null && ne !== void 0 ? ne : ae) !== null && te !== void 0 ? te : 0;
        Q = doe({
          barGap: I,
          barCategoryGap: R,
          bandSize: se !== D ? se : D,
          sizeList: z[G],
          maxBarSize: ae
        }), se !== D && (Q = Q.map(function(ue) {
          return re(re({}, ue), {}, {
            position: re(re({}, ue.position), {}, {
              offset: ue.position.offset - se / 2
            })
          });
        }));
      }
      var pe = ee && ee.type && ee.type.getComposedData;
      pe && J.push({
        props: re(re({}, pe(re(re({}, H), {}, {
          displayedData: _,
          props: g,
          dataKey: M,
          item: ee,
          bandSize: D,
          barPosition: Q,
          offset: x,
          stackedData: W,
          layout: T,
          dataStartIndex: O,
          dataEndIndex: P
        }))), {}, Oe(Oe(Oe({
          key: ee.key || "item-".concat(A)
        }, Z, H[Z]), X, H[X]), "animationId", y)),
        childIndex: vU(ee, g.children),
        item: ee
      });
    }), J;
  }, h = function(g, b) {
    var C = g.props, w = g.dataStartIndex, x = g.dataEndIndex, y = g.updateId;
    if (!o4({
      props: C
    }))
      return null;
    var O = C.children, P = C.layout, j = C.stackOffset, T = C.data, I = C.reverseStackOrder, R = cv(P), F = R.numericAxisName, $ = R.cateAxisName, Z = lr(O, n), X = woe(T, Z, "".concat(F, "Id"), "".concat($, "Id"), j, I), K = l.reduce(function(N, M) {
      var S = "".concat(M.axisType, "Map");
      return re(re({}, N), {}, Oe({}, S, Qfe(C, re(re({}, M), {}, {
        graphicalItems: Z,
        stackGroups: M.axisType === F && X,
        dataStartIndex: w,
        dataEndIndex: x
      }))));
    }, {}), J = tde(re(re({}, K), {}, {
      props: C,
      graphicalItems: Z
    }), b == null ? void 0 : b.legendBBox);
    Object.keys(K).forEach(function(N) {
      K[N] = u(C, K[N], J, N.replace("Map", ""), r);
    });
    var ee = K["".concat($, "Map")], A = Jfe(ee), _ = p(C, re(re({}, K), {}, {
      dataStartIndex: w,
      dataEndIndex: x,
      updateId: y,
      graphicalItems: Z,
      stackGroups: X,
      offset: J
    }));
    return re(re({
      formattedGraphicalItems: _,
      graphicalItems: Z,
      offset: J,
      stackGroups: X
    }, A), K);
  }, m = /* @__PURE__ */ function(v) {
    function g(b) {
      var C, w, x;
      return Lfe(this, g), x = Rfe(this, g, [b]), Oe(x, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), Oe(x, "accessibilityManager", new wfe()), Oe(x, "handleLegendBBoxUpdate", function(y) {
        if (y) {
          var O = x.state, P = O.dataStartIndex, j = O.dataEndIndex, T = O.updateId;
          x.setState(re({
            legendBBox: y
          }, h({
            props: x.props,
            dataStartIndex: P,
            dataEndIndex: j,
            updateId: T
          }, re(re({}, x.state), {}, {
            legendBBox: y
          }))));
        }
      }), Oe(x, "handleReceiveSyncEvent", function(y, O, P) {
        if (x.props.syncId === y) {
          if (P === x.eventEmitterSymbol && typeof x.props.syncMethod != "function")
            return;
          x.applySyncEvent(O);
        }
      }), Oe(x, "handleBrushChange", function(y) {
        var O = y.startIndex, P = y.endIndex;
        if (O !== x.state.dataStartIndex || P !== x.state.dataEndIndex) {
          var j = x.state.updateId;
          x.setState(function() {
            return re({
              dataStartIndex: O,
              dataEndIndex: P
            }, h({
              props: x.props,
              dataStartIndex: O,
              dataEndIndex: P,
              updateId: j
            }, x.state));
          }), x.triggerSyncEvent({
            dataStartIndex: O,
            dataEndIndex: P
          });
        }
      }), Oe(x, "handleMouseEnter", function(y) {
        var O = x.getMouseInfo(y);
        if (O) {
          var P = re(re({}, O), {}, {
            isTooltipActive: !0
          });
          x.setState(P), x.triggerSyncEvent(P);
          var j = x.props.onMouseEnter;
          we(j) && j(P, y);
        }
      }), Oe(x, "triggeredAfterMouseMove", function(y) {
        var O = x.getMouseInfo(y), P = O ? re(re({}, O), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        x.setState(P), x.triggerSyncEvent(P);
        var j = x.props.onMouseMove;
        we(j) && j(P, y);
      }), Oe(x, "handleItemMouseEnter", function(y) {
        x.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: y,
            activePayload: y.tooltipPayload,
            activeCoordinate: y.tooltipPosition || {
              x: y.cx,
              y: y.cy
            }
          };
        });
      }), Oe(x, "handleItemMouseLeave", function() {
        x.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), Oe(x, "handleMouseMove", function(y) {
        y.persist(), x.throttleTriggeredAfterMouseMove(y);
      }), Oe(x, "handleMouseLeave", function(y) {
        x.throttleTriggeredAfterMouseMove.cancel();
        var O = {
          isTooltipActive: !1
        };
        x.setState(O), x.triggerSyncEvent(O);
        var P = x.props.onMouseLeave;
        we(P) && P(O, y);
      }), Oe(x, "handleOuterEvent", function(y) {
        var O = hU(y), P = Sr(x.props, "".concat(O));
        if (O && we(P)) {
          var j, T;
          /.*touch.*/i.test(O) ? T = x.getMouseInfo(y.changedTouches[0]) : T = x.getMouseInfo(y), P((j = T) !== null && j !== void 0 ? j : {}, y);
        }
      }), Oe(x, "handleClick", function(y) {
        var O = x.getMouseInfo(y);
        if (O) {
          var P = re(re({}, O), {}, {
            isTooltipActive: !0
          });
          x.setState(P), x.triggerSyncEvent(P);
          var j = x.props.onClick;
          we(j) && j(P, y);
        }
      }), Oe(x, "handleMouseDown", function(y) {
        var O = x.props.onMouseDown;
        if (we(O)) {
          var P = x.getMouseInfo(y);
          O(P, y);
        }
      }), Oe(x, "handleMouseUp", function(y) {
        var O = x.props.onMouseUp;
        if (we(O)) {
          var P = x.getMouseInfo(y);
          O(P, y);
        }
      }), Oe(x, "handleTouchMove", function(y) {
        y.changedTouches != null && y.changedTouches.length > 0 && x.throttleTriggeredAfterMouseMove(y.changedTouches[0]);
      }), Oe(x, "handleTouchStart", function(y) {
        y.changedTouches != null && y.changedTouches.length > 0 && x.handleMouseDown(y.changedTouches[0]);
      }), Oe(x, "handleTouchEnd", function(y) {
        y.changedTouches != null && y.changedTouches.length > 0 && x.handleMouseUp(y.changedTouches[0]);
      }), Oe(x, "triggerSyncEvent", function(y) {
        x.props.syncId !== void 0 && A3.emit(D3, x.props.syncId, y, x.eventEmitterSymbol);
      }), Oe(x, "applySyncEvent", function(y) {
        var O = x.props, P = O.layout, j = O.syncMethod, T = x.state.updateId, I = y.dataStartIndex, R = y.dataEndIndex;
        if (y.dataStartIndex !== void 0 || y.dataEndIndex !== void 0)
          x.setState(re({
            dataStartIndex: I,
            dataEndIndex: R
          }, h({
            props: x.props,
            dataStartIndex: I,
            dataEndIndex: R,
            updateId: T
          }, x.state)));
        else if (y.activeTooltipIndex !== void 0) {
          var F = y.chartX, $ = y.chartY, Z = y.activeTooltipIndex, X = x.state, K = X.offset, J = X.tooltipTicks;
          if (!K)
            return;
          if (typeof j == "function")
            Z = j(J, y);
          else if (j === "value") {
            Z = -1;
            for (var ee = 0; ee < J.length; ee++)
              if (J[ee].value === y.activeLabel) {
                Z = ee;
                break;
              }
          }
          var A = re(re({}, K), {}, {
            x: K.left,
            y: K.top
          }), _ = Math.min(F, A.x + A.width), N = Math.min($, A.y + A.height), M = J[Z] && J[Z].value, S = Gf(x.state, x.props.data, Z), B = J[Z] ? {
            x: P === "horizontal" ? J[Z].coordinate : _,
            y: P === "horizontal" ? N : J[Z].coordinate
          } : Qx;
          x.setState(re(re({}, y), {}, {
            activeLabel: M,
            activeCoordinate: B,
            activePayload: S,
            activeTooltipIndex: Z
          }));
        } else
          x.setState(y);
      }), Oe(x, "renderCursor", function(y) {
        var O, P = x.state, j = P.isTooltipActive, T = P.activeCoordinate, I = P.activePayload, R = P.offset, F = P.activeTooltipIndex, $ = P.tooltipAxisBandSize, Z = x.getTooltipEventType(), X = (O = y.props.active) !== null && O !== void 0 ? O : j, K = x.props.layout, J = y.key || "_recharts-cursor";
        return /* @__PURE__ */ E.createElement(Afe, {
          key: J,
          activeCoordinate: T,
          activePayload: I,
          activeTooltipIndex: F,
          chartName: r,
          element: y,
          isActive: X,
          layout: K,
          offset: R,
          tooltipAxisBandSize: $,
          tooltipEventType: Z
        });
      }), Oe(x, "renderPolarAxis", function(y, O, P) {
        var j = Sr(y, "type.axisType"), T = Sr(x.state, "".concat(j, "Map")), I = y.type.defaultProps, R = I !== void 0 ? re(re({}, I), y.props) : y.props, F = T && T[R["".concat(j, "Id")]];
        return /* @__PURE__ */ Rt(y, re(re({}, F), {}, {
          className: De(j, F.className),
          key: y.key || "".concat(O, "-").concat(P),
          ticks: Mn(F, !0)
        }));
      }), Oe(x, "renderPolarGrid", function(y) {
        var O = y.props, P = O.radialLines, j = O.polarAngles, T = O.polarRadius, I = x.state, R = I.radiusAxisMap, F = I.angleAxisMap, $ = Yn(R), Z = Yn(F), X = Z.cx, K = Z.cy, J = Z.innerRadius, ee = Z.outerRadius;
        return /* @__PURE__ */ Rt(y, {
          polarAngles: Array.isArray(j) ? j : Mn(Z, !0).map(function(A) {
            return A.coordinate;
          }),
          polarRadius: Array.isArray(T) ? T : Mn($, !0).map(function(A) {
            return A.coordinate;
          }),
          cx: X,
          cy: K,
          innerRadius: J,
          outerRadius: ee,
          key: y.key || "polar-grid",
          radialLines: P
        });
      }), Oe(x, "renderLegend", function() {
        var y = x.state.formattedGraphicalItems, O = x.props, P = O.children, j = O.width, T = O.height, I = x.props.margin || {}, R = j - (I.left || 0) - (I.right || 0), F = wC({
          children: P,
          formattedGraphicalItems: y,
          legendWidth: R,
          legendContent: c
        });
        if (!F)
          return null;
        var $ = F.item, Z = av(F, Dfe);
        return /* @__PURE__ */ Rt($, re(re({}, Z), {}, {
          chartWidth: j,
          chartHeight: T,
          margin: I,
          onBBoxUpdate: x.handleLegendBBoxUpdate
        }));
      }), Oe(x, "renderTooltip", function() {
        var y, O = x.props, P = O.children, j = O.accessibilityLayer, T = br(P, dr);
        if (!T)
          return null;
        var I = x.state, R = I.isTooltipActive, F = I.activeCoordinate, $ = I.activePayload, Z = I.activeLabel, X = I.offset, K = (y = T.props.active) !== null && y !== void 0 ? y : R;
        return /* @__PURE__ */ Rt(T, {
          viewBox: re(re({}, X), {}, {
            x: X.left,
            y: X.top
          }),
          active: K,
          label: Z,
          payload: K ? $ : [],
          coordinate: F,
          accessibilityLayer: j
        });
      }), Oe(x, "renderBrush", function(y) {
        var O = x.props, P = O.margin, j = O.data, T = x.state, I = T.offset, R = T.dataStartIndex, F = T.dataEndIndex, $ = T.updateId;
        return /* @__PURE__ */ Rt(y, {
          key: y.key || "_recharts-brush",
          onChange: dl(x.handleBrushChange, y.props.onChange),
          data: j,
          x: oe(y.props.x) ? y.props.x : I.left,
          y: oe(y.props.y) ? y.props.y : I.top + I.height + I.brushBottom - (P.bottom || 0),
          width: oe(y.props.width) ? y.props.width : I.width,
          startIndex: R,
          endIndex: F,
          updateId: "brush-".concat($)
        });
      }), Oe(x, "renderReferenceElement", function(y, O, P) {
        if (!y)
          return null;
        var j = x, T = j.clipPathId, I = x.state, R = I.xAxisMap, F = I.yAxisMap, $ = I.offset, Z = y.type.defaultProps || {}, X = y.props, K = X.xAxisId, J = K === void 0 ? Z.xAxisId : K, ee = X.yAxisId, A = ee === void 0 ? Z.yAxisId : ee;
        return /* @__PURE__ */ Rt(y, {
          key: y.key || "".concat(O, "-").concat(P),
          xAxis: R[J],
          yAxis: F[A],
          viewBox: {
            x: $.left,
            y: $.top,
            width: $.width,
            height: $.height
          },
          clipPathId: T
        });
      }), Oe(x, "renderActivePoints", function(y) {
        var O = y.item, P = y.activePoint, j = y.basePoint, T = y.childIndex, I = y.isRange, R = [], F = O.props.key, $ = O.item.type.defaultProps !== void 0 ? re(re({}, O.item.type.defaultProps), O.item.props) : O.item.props, Z = $.activeDot, X = $.dataKey, K = re(re({
          index: T,
          dataKey: X,
          cx: P.x,
          cy: P.y,
          r: 4,
          fill: G6(O.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: P.payload,
          value: P.value
        }, he(Z, !1)), Jl(Z));
        return R.push(g.renderActiveDot(Z, K, "".concat(F, "-activePoint-").concat(T))), j ? R.push(g.renderActiveDot(Z, re(re({}, K), {}, {
          cx: j.x,
          cy: j.y
        }), "".concat(F, "-basePoint-").concat(T))) : I && R.push(null), R;
      }), Oe(x, "renderGraphicChild", function(y, O, P) {
        var j = x.filterFormatItem(y, O, P);
        if (!j)
          return null;
        var T = x.getTooltipEventType(), I = x.state, R = I.isTooltipActive, F = I.tooltipAxis, $ = I.activeTooltipIndex, Z = I.activeLabel, X = x.props.children, K = br(X, dr), J = j.props, ee = J.points, A = J.isRange, _ = J.baseLine, N = j.item.type.defaultProps !== void 0 ? re(re({}, j.item.type.defaultProps), j.item.props) : j.item.props, M = N.activeDot, S = N.hide, B = N.activeBar, G = N.activeShape, U = !!(!S && R && K && (M || B || G)), H = {};
        T !== "axis" && K && K.props.trigger === "click" ? H = {
          onClick: dl(x.handleItemMouseEnter, y.props.onClick)
        } : T !== "axis" && (H = {
          onMouseLeave: dl(x.handleItemMouseLeave, y.props.onMouseLeave),
          onMouseEnter: dl(x.handleItemMouseEnter, y.props.onMouseEnter)
        });
        var k = /* @__PURE__ */ Rt(y, re(re({}, j.props), H));
        function L(Te) {
          return typeof F.dataKey == "function" ? F.dataKey(Te.payload) : null;
        }
        if (U)
          if ($ >= 0) {
            var W, V;
            if (F.dataKey && !F.allowDuplicatedCategory) {
              var D = typeof F.dataKey == "function" ? L : "payload.".concat(F.dataKey.toString());
              W = Ql(ee, D, Z), V = A && _ && Ql(_, D, Z);
            } else
              W = ee == null ? void 0 : ee[$], V = A && _ && _[$];
            if (G || B) {
              var Q = y.props.activeIndex !== void 0 ? y.props.activeIndex : $;
              return [/* @__PURE__ */ Rt(y, re(re(re({}, j.props), H), {}, {
                activeIndex: Q
              })), null, null];
            }
            if (!xe(W))
              return [k].concat(xo(x.renderActivePoints({
                item: j,
                activePoint: W,
                basePoint: V,
                childIndex: $,
                isRange: A
              })));
          } else {
            var z, te = (z = x.getItemByXY(x.state.activeCoordinate)) !== null && z !== void 0 ? z : {
              graphicalItem: k
            }, ne = te.graphicalItem, ae = ne.item, se = ae === void 0 ? y : ae, pe = ne.childIndex, ue = re(re(re({}, j.props), H), {}, {
              activeIndex: pe
            });
            return [/* @__PURE__ */ Rt(se, ue), null, null];
          }
        return A ? [k, null, null] : [k, null];
      }), Oe(x, "renderCustomized", function(y, O, P) {
        return /* @__PURE__ */ Rt(y, re(re({
          key: "recharts-customized-".concat(P)
        }, x.props), x.state));
      }), Oe(x, "renderMap", {
        CartesianGrid: {
          handler: gl,
          once: !0
        },
        ReferenceArea: {
          handler: x.renderReferenceElement
        },
        ReferenceLine: {
          handler: gl
        },
        ReferenceDot: {
          handler: x.renderReferenceElement
        },
        XAxis: {
          handler: gl
        },
        YAxis: {
          handler: gl
        },
        Brush: {
          handler: x.renderBrush,
          once: !0
        },
        Bar: {
          handler: x.renderGraphicChild
        },
        Line: {
          handler: x.renderGraphicChild
        },
        Area: {
          handler: x.renderGraphicChild
        },
        Radar: {
          handler: x.renderGraphicChild
        },
        RadialBar: {
          handler: x.renderGraphicChild
        },
        Scatter: {
          handler: x.renderGraphicChild
        },
        Pie: {
          handler: x.renderGraphicChild
        },
        Funnel: {
          handler: x.renderGraphicChild
        },
        Tooltip: {
          handler: x.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: x.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: x.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: x.renderPolarAxis
        },
        Customized: {
          handler: x.renderCustomized
        }
      }), x.clipPathId = "".concat((C = b.id) !== null && C !== void 0 ? C : ga("recharts"), "-clip"), x.throttleTriggeredAfterMouseMove = xb(x.triggeredAfterMouseMove, (w = b.throttleDelay) !== null && w !== void 0 ? w : 1e3 / 60), x.state = {}, x;
    }
    return Hfe(g, v), kfe(g, [{
      key: "componentDidMount",
      value: function() {
        var C, w;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (C = this.props.margin.left) !== null && C !== void 0 ? C : 0,
            top: (w = this.props.margin.top) !== null && w !== void 0 ? w : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var C = this.props, w = C.children, x = C.data, y = C.height, O = C.layout, P = br(w, dr);
        if (P) {
          var j = P.props.defaultIndex;
          if (!(typeof j != "number" || j < 0 || j > this.state.tooltipTicks.length - 1)) {
            var T = this.state.tooltipTicks[j] && this.state.tooltipTicks[j].value, I = Gf(this.state, x, j, T), R = this.state.tooltipTicks[j].coordinate, F = (this.state.offset.top + y) / 2, $ = O === "horizontal", Z = $ ? {
              x: R,
              y: F
            } : {
              y: R,
              x: F
            }, X = this.state.formattedGraphicalItems.find(function(J) {
              var ee = J.item;
              return ee.type.name === "Scatter";
            });
            X && (Z = re(re({}, Z), X.props.points[j].tooltipPosition), I = X.props.points[j].tooltipPayload);
            var K = {
              activeTooltipIndex: j,
              isTooltipActive: !0,
              activeLabel: T,
              activePayload: I,
              activeCoordinate: Z
            };
            this.setState(K), this.renderCursor(P), this.accessibilityManager.setIndex(j);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(C, w) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== w.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== C.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== C.margin) {
          var x, y;
          this.accessibilityManager.setDetails({
            offset: {
              left: (x = this.props.margin.left) !== null && x !== void 0 ? x : 0,
              top: (y = this.props.margin.top) !== null && y !== void 0 ? y : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(C) {
        b0([br(C.children, dr)], [br(this.props.children, dr)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var C = br(this.props.children, dr);
        if (C && typeof C.props.shared == "boolean") {
          var w = C.props.shared ? "axis" : "item";
          return s.indexOf(w) >= 0 ? w : i;
        }
        return i;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(C) {
        if (!this.container)
          return null;
        var w = this.container, x = w.getBoundingClientRect(), y = Bte(x), O = {
          chartX: Math.round(C.pageX - y.left),
          chartY: Math.round(C.pageY - y.top)
        }, P = x.width / w.offsetWidth || 1, j = this.inRange(O.chartX, O.chartY, P);
        if (!j)
          return null;
        var T = this.state, I = T.xAxisMap, R = T.yAxisMap, F = this.getTooltipEventType();
        if (F !== "axis" && I && R) {
          var $ = Yn(I).scale, Z = Yn(R).scale, X = $ && $.invert ? $.invert(O.chartX) : null, K = Z && Z.invert ? Z.invert(O.chartY) : null;
          return re(re({}, O), {}, {
            xValue: X,
            yValue: K
          });
        }
        var J = sv(this.state, this.props.data, this.props.layout, j);
        return J ? re(re({}, O), J) : null;
      }
    }, {
      key: "inRange",
      value: function(C, w) {
        var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, y = this.props.layout, O = C / x, P = w / x;
        if (y === "horizontal" || y === "vertical") {
          var j = this.state.offset, T = O >= j.left && O <= j.left + j.width && P >= j.top && P <= j.top + j.height;
          return T ? {
            x: O,
            y: P
          } : null;
        }
        var I = this.state, R = I.angleAxisMap, F = I.radiusAxisMap;
        if (R && F) {
          var $ = Yn(R);
          return b9({
            x: O,
            y: P
          }, $);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var C = this.props.children, w = this.getTooltipEventType(), x = br(C, dr), y = {};
        x && w === "axis" && (x.props.trigger === "click" ? y = {
          onClick: this.handleClick
        } : y = {
          onMouseEnter: this.handleMouseEnter,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd
        });
        var O = Jl(this.props, this.handleOuterEvent);
        return re(re({}, O), y);
      }
    }, {
      key: "addListener",
      value: function() {
        A3.on(D3, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        A3.removeListener(D3, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(C, w, x) {
        for (var y = this.state.formattedGraphicalItems, O = 0, P = y.length; O < P; O++) {
          var j = y[O];
          if (j.item === C || j.props.key === C.key || w === Nn(j.item.type) && x === j.childIndex)
            return j;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var C = this.clipPathId, w = this.state.offset, x = w.left, y = w.top, O = w.height, P = w.width;
        return /* @__PURE__ */ E.createElement("defs", null, /* @__PURE__ */ E.createElement("clipPath", {
          id: C
        }, /* @__PURE__ */ E.createElement("rect", {
          x,
          y,
          height: O,
          width: P
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var C = this.state.xAxisMap;
        return C ? Object.entries(C).reduce(function(w, x) {
          var y = nv(x, 2), O = y[0], P = y[1];
          return re(re({}, w), {}, Oe({}, O, P.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var C = this.state.yAxisMap;
        return C ? Object.entries(C).reduce(function(w, x) {
          var y = nv(x, 2), O = y[0], P = y[1];
          return re(re({}, w), {}, Oe({}, O, P.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(C) {
        var w;
        return (w = this.state.xAxisMap) === null || w === void 0 || (w = w[C]) === null || w === void 0 ? void 0 : w.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(C) {
        var w;
        return (w = this.state.yAxisMap) === null || w === void 0 || (w = w[C]) === null || w === void 0 ? void 0 : w.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(C) {
        var w = this.state, x = w.formattedGraphicalItems, y = w.activeItem;
        if (x && x.length)
          for (var O = 0, P = x.length; O < P; O++) {
            var j = x[O], T = j.props, I = j.item, R = I.type.defaultProps !== void 0 ? re(re({}, I.type.defaultProps), I.props) : I.props, F = Nn(I.type);
            if (F === "Bar") {
              var $ = (T.data || []).find(function(J) {
                return ile(C, J);
              });
              if ($)
                return {
                  graphicalItem: j,
                  payload: $
                };
            } else if (F === "RadialBar") {
              var Z = (T.data || []).find(function(J) {
                return b9(C, J);
              });
              if (Z)
                return {
                  graphicalItem: j,
                  payload: Z
                };
            } else if (Ku(j, y) || Xu(j, y) || v1(j, y)) {
              var X = qce({
                graphicalItem: j,
                activeTooltipItem: y,
                itemData: R.data
              }), K = R.activeIndex === void 0 ? X : R.activeIndex;
              return {
                graphicalItem: re(re({}, j), {}, {
                  childIndex: K
                }),
                payload: v1(j, y) ? R.data[X] : j.props.data[X]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var C = this;
        if (!o4(this))
          return null;
        var w = this.props, x = w.children, y = w.className, O = w.width, P = w.height, j = w.style, T = w.compact, I = w.title, R = w.desc, F = av(w, Mfe), $ = he(F, !1);
        if (T)
          return /* @__PURE__ */ E.createElement(_h, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ E.createElement(x0, Ts({}, $, {
            width: O,
            height: P,
            title: I,
            desc: R
          }), this.renderClipPath(), l4(x, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var Z, X;
          $.tabIndex = (Z = this.props.tabIndex) !== null && Z !== void 0 ? Z : 0, $.role = (X = this.props.role) !== null && X !== void 0 ? X : "application", $.onKeyDown = function(J) {
            C.accessibilityManager.keyboardEvent(J);
          }, $.onFocus = function() {
            C.accessibilityManager.focus();
          };
        }
        var K = this.parseEventsOfWrapper();
        return /* @__PURE__ */ E.createElement(_h, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ E.createElement("div", Ts({
          className: De("recharts-wrapper", y),
          style: re({
            position: "relative",
            cursor: "default",
            width: O,
            height: P
          }, j)
        }, K, {
          ref: function(ee) {
            C.container = ee;
          }
        }), /* @__PURE__ */ E.createElement(x0, Ts({}, $, {
          width: O,
          height: P,
          title: I,
          desc: R,
          style: qfe
        }), this.renderClipPath(), l4(x, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  }(Kf);
  return Oe(m, "displayName", r), Oe(m, "defaultProps", re({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, d)), Oe(m, "getDerivedStateFromProps", function(v, g) {
    var b = v.dataKey, C = v.data, w = v.children, x = v.width, y = v.height, O = v.layout, P = v.stackOffset, j = v.margin, T = g.dataStartIndex, I = g.dataEndIndex;
    if (g.updateId === void 0) {
      var R = lv(v);
      return re(re(re({}, R), {}, {
        updateId: 0
      }, h(re(re({
        props: v
      }, R), {}, {
        updateId: 0
      }), g)), {}, {
        prevDataKey: b,
        prevData: C,
        prevWidth: x,
        prevHeight: y,
        prevLayout: O,
        prevStackOffset: P,
        prevMargin: j,
        prevChildren: w
      });
    }
    if (b !== g.prevDataKey || C !== g.prevData || x !== g.prevWidth || y !== g.prevHeight || O !== g.prevLayout || P !== g.prevStackOffset || !Ni(j, g.prevMargin)) {
      var F = lv(v), $ = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: g.chartX,
        chartY: g.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: g.isTooltipActive
      }, Z = re(re({}, sv(g, C, O)), {}, {
        updateId: g.updateId + 1
      }), X = re(re(re({}, F), $), Z);
      return re(re(re({}, X), h(re({
        props: v
      }, X), g)), {}, {
        prevDataKey: b,
        prevData: C,
        prevWidth: x,
        prevHeight: y,
        prevLayout: O,
        prevStackOffset: P,
        prevMargin: j,
        prevChildren: w
      });
    }
    if (!b0(w, g.prevChildren)) {
      var K, J, ee, A, _ = br(w, oo), N = _ && (K = (J = _.props) === null || J === void 0 ? void 0 : J.startIndex) !== null && K !== void 0 ? K : T, M = _ && (ee = (A = _.props) === null || A === void 0 ? void 0 : A.endIndex) !== null && ee !== void 0 ? ee : I, S = N !== T || M !== I, B = !xe(C), G = B && !S ? g.updateId : g.updateId + 1;
      return re(re({
        updateId: G
      }, h(re(re({
        props: v
      }, g), {}, {
        updateId: G,
        dataStartIndex: N,
        dataEndIndex: M
      }), g)), {}, {
        prevChildren: w,
        dataStartIndex: N,
        dataEndIndex: M
      });
    }
    return null;
  }), Oe(m, "renderActiveDot", function(v, g, b) {
    var C;
    return /* @__PURE__ */ Yr(v) ? C = /* @__PURE__ */ Rt(v, g) : we(v) ? C = v(g) : C = /* @__PURE__ */ E.createElement(W1, g), /* @__PURE__ */ E.createElement(Me, {
      className: "recharts-active-dot",
      key: b
    }, C);
  }), function(g) {
    return /* @__PURE__ */ E.createElement(m, g);
  };
}, ew = i5({
  chartName: "BarChart",
  GraphicalChild: Vr,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: ca
  }, {
    axisType: "yAxis",
    AxisComp: li
  }],
  formatAxisMap: lx
}), tw = i5({
  chartName: "PieChart",
  GraphicalChild: On,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: Yu
  }, {
    axisType: "radiusAxis",
    AxisComp: qu
  }],
  formatAxisMap: Noe,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
}), nde = i5({
  chartName: "ComposedChart",
  GraphicalChild: [z1, si, Vr, i2],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: ca
  }, {
    axisType: "yAxis",
    AxisComp: li
  }, {
    axisType: "zAxis",
    AxisComp: a2
  }],
  formatAxisMap: lx
});
const ade = E.forwardRef((e, t) => {
  const {
    data: r,
    onClickCellChart: n,
    onClickIconCard: a,
    onClickCard: i,
    chartColors: o,
    labelOne: s,
    labelTwo: l,
    isCurrency: c,
    titleIcon: u,
    ...d
  } = e;
  if (r == null || s == null)
    return null;
  const p = (y) => () => {
    n !== void 0 && n({ data: y });
  }, h = (y) => () => {
    a !== void 0 && a({ data: y });
  }, m = (y) => () => {
    i !== void 0 && i({ data: y });
  }, v = o.map((y) => je[y.colorCellChart]), g = o.map((y) => y.bgColorCards), b = o.map((y) => y.iconColor), C = o.map((y) => y.textColor), w = {
    gridTemplateColumns: "4fr 6fr"
  }, x = ({ labelTop: y, labelBottom: O }) => /* @__PURE__ */ f.jsxs("g", { children: [
    /* @__PURE__ */ f.jsx("text", { x: "50%", y: "50%", textAnchor: "middle", dominantBaseline: "middle", fontSize: 20, fontWeight: "700", fill: "#292929", children: y }),
    /* @__PURE__ */ f.jsx("text", { x: "50%", y: "60%", textAnchor: "middle", dominantBaseline: "middle", fontSize: 14, fontWeight: "400", fill: "#292929", children: O })
  ] });
  return /* @__PURE__ */ f.jsx("section", { ref: t, className: "flex justify-center items-center", ...d, children: /* @__PURE__ */ f.jsxs("div", { className: "w-full max-w-[1260px] flex flex-col gap-4 2s:grid 2s:gap-8 relative", style: w, children: [
    /* @__PURE__ */ f.jsx(R1, { width: "100%", height: 300, children: /* @__PURE__ */ f.jsxs(tw, { children: [
      /* @__PURE__ */ f.jsxs(
        On,
        {
          dataKey: "value",
          data: r,
          innerRadius: "55%",
          outerRadius: "100%",
          cursor: "pointer",
          children: [
            /* @__PURE__ */ f.jsx(
              Bt,
              {
                content: /* @__PURE__ */ f.jsx(x, { labelTop: s ?? "", labelBottom: l ?? "" }),
                position: "center"
              }
            ),
            r.map((y, O) => /* @__PURE__ */ f.jsx(
              en,
              {
                fill: v[O % v.length],
                onClick: p(y)
              },
              `cell-${O}`
            ))
          ]
        }
      ),
      /* @__PURE__ */ f.jsx(dr, {})
    ] }) }),
    /* @__PURE__ */ f.jsx("div", { className: "w-full grid 2s:grid-cols-2 gap-4 mx-auto", children: r.map((y, O) => /* @__PURE__ */ f.jsxs(Hi, { bg: g[O % g.length], gap: 4, spacing: 4, rounded: "md", children: [
      /* @__PURE__ */ f.jsxs(Qr, { justifyContent: "between", children: [
        /* @__PURE__ */ f.jsxs(Qr, { gap: 4, children: [
          /* @__PURE__ */ f.jsx("div", { className: `w-3 h-3 rounded-full bg-${b[O % b.length]}` }),
          /* @__PURE__ */ f.jsx(sr, { variant: "title-3", children: y.name })
        ] }),
        /* @__PURE__ */ f.jsx("div", { className: "cursor-pointer", onClick: h(y), title: u, children: /* @__PURE__ */ f.jsx(me, { variant: "viewvalue", color: b[O % b.length] }) })
      ] }),
      /* @__PURE__ */ f.jsxs("div", { onClick: m(y), children: [
        /* @__PURE__ */ f.jsx($n, { variant: "heading-5", color: C[O % C.length], children: c ? `$ ${new Intl.NumberFormat("de-DE").format(y.value)}` : y.value }),
        /* @__PURE__ */ f.jsx(hr, { variant: "description-3", color: C[O % C.length], children: y.date })
      ] })
    ] }, O)) })
  ] }) });
});
ade.displayName = "PieCharts";
const ide = E.forwardRef((e) => {
  const { containerName: t, numberOfAlerts: r, filterOneOptions: n = [], filterTwoOptions: a = [], onChangeValueFilteroOne: i, onChangeValueFilteroTwo: o, onChangeValueFilterDate: s, valueFilterOne: l, valueFilterTwo: c, valueFilterDate: u, onClickVerMas: d, clearFilters: p, graphicKeyName: h, placeholderFilterOne: m, placeholderFilterTwo: v } = e, g = () => `component_${h ?? "defaultKeyName"}_hidden`, [b, C] = ye(() => {
    const y = localStorage.getItem(g());
    return y !== null ? JSON.parse(y) : !1;
  }), w = () => {
    C((y) => {
      const O = !y;
      return localStorage.setItem(g(), JSON.stringify(O)), O;
    });
  }, x = (y) => {
    const O = y.option.startDate, P = y.option.endDate, j = P !== void 0 ? B3(P, "dd/MM/yyyy") : "Fecha de fin no disponible", I = [O !== void 0 ? B3(O, "dd/MM/yyyy") : "Fecha de inicio no disponible", j];
    s !== void 0 && s({ option: I });
  };
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsxs("div", { className: "border rounded-md shadow-s mb-8 max-w-[1260px] mx-auto", children: [
    /* @__PURE__ */ f.jsx("div", { className: "p-4", children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col 2s:justify-between 2s:items-center gap-4 2s:flex-row", children: [
      /* @__PURE__ */ f.jsxs(Qr, { gap: 4, alignItems: "center", children: [
        /* @__PURE__ */ f.jsx("button", { className: "cursor-pointer", onClick: w, children: /* @__PURE__ */ f.jsx(me, { variant: b ? "eye-hide" : "eye", color: "neutral-300" }) }),
        /* @__PURE__ */ f.jsx(sr, { variant: "title-2", children: t }),
        r !== void 0 ? /* @__PURE__ */ f.jsx("div", { className: "bg-error-600 rounded-lg py-2 px-4", children: /* @__PURE__ */ f.jsxs(sr, { variant: "title-4", color: "white", children: [
          r,
          " nuevas"
        ] }) }) : void 0
      ] }),
      /* @__PURE__ */ f.jsxs(Qr, { gap: 4, children: [
        /* @__PURE__ */ f.jsx("button", { onClick: d, className: "cursor-pointer text-white py-1 px-1 2s:px-6 2s:min-w-max font-bold bg-secondary-600 hover:bg-secondary-500 rounded-md flex-1 flex items-center justify-center text-sm", children: "Ver todas" }),
        /* @__PURE__ */ f.jsx("button", { onClick: p, className: "text-white py-1 px-1 2s:px-6 2s:min-w-max font-bold bg-error-500 hover:bg-error-400 rounded-md flex-1 flex items-center justify-center text-sm", children: "Limpiar filtros" })
      ] })
    ] }) }),
    /* @__PURE__ */ f.jsx("div", { className: `border-1 ${b ? "hidden" : "block"}` }),
    /* @__PURE__ */ f.jsx("div", { className: `p-4 ${b ? "hidden" : "block"}`, children: /* @__PURE__ */ f.jsxs("div", { className: "flex gap-4", children: [
      /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col flex-1 gap-4 2s:flex-row", children: [
        /* @__PURE__ */ f.jsx(
          I3,
          {
            variant: "default",
            value: l,
            options: n,
            placeholder: m ?? "Seleccione una opción",
            onChangeValue: i
          }
        ),
        /* @__PURE__ */ f.jsx(
          I3,
          {
            variant: "default",
            value: c,
            options: a,
            placeholder: v ?? "Seleccione una opción",
            onChangeValue: o
          }
        ),
        /* @__PURE__ */ f.jsx(
          vm,
          {
            valueFilterDate: u,
            onChangeValueFilterDate: x
          }
        )
      ] }),
      /* @__PURE__ */ f.jsx("div", { className: "hidden", children: /* @__PURE__ */ f.jsxs(vv, { variant: "actions", button: /* @__PURE__ */ f.jsx(gt, { variant: "secondary", size: "m", icon: "menu-context", onlyIcon: !0 }), children: [
        /* @__PURE__ */ f.jsx(N3, { icon: "trash", children: "Eliminar" }),
        /* @__PURE__ */ f.jsx(N3, { icon: "edit", children: "Editar" })
      ] }) })
    ] }) }),
    /* @__PURE__ */ f.jsx("div", { className: `border-1 ${b ? "hidden" : "block"}` }),
    /* @__PURE__ */ f.jsx("div", { className: `p-4 2s:p-8 mb-4 ${b ? "hidden" : "grid"}`, children: e.children })
  ] }) });
});
ide.displayName = "GraphicContainer";
const ode = E.forwardRef((e) => {
  const { handleLabelClick: t, data: r, chartColors: n } = e;
  if (r == null)
    return null;
  const a = r.filter((u) => u.value !== 0), i = (u) => () => {
    t !== void 0 && t({ data: u });
  }, o = n.map((u) => je[u.colorCellChart]), s = {
    gridTemplateColumns: "8fr 2fr"
  }, l = Math.PI / 180, c = ({
    cx: u,
    cy: d,
    midAngle: p,
    innerRadius: h,
    outerRadius: m,
    index: v
  }) => {
    const g = h + (m - h) * 0.5, b = u + g * Math.cos(-p * Number(l)), C = d + g * Math.sin(-p * Number(l));
    return /* @__PURE__ */ f.jsx(
      "text",
      {
        className: "text-md s:text-l font-bold",
        x: b,
        y: C,
        fill: "white",
        textAnchor: b > u ? "start" : "end",
        dominantBaseline: "central",
        children: `${a[v].value}`
      }
    );
  };
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col 2s:grid 2s:gap-8", style: s, children: [
    /* @__PURE__ */ f.jsx(R1, { width: "100%", aspect: 2, children: /* @__PURE__ */ f.jsx(tw, { children: /* @__PURE__ */ f.jsx(
      On,
      {
        dataKey: "value",
        startAngle: 180,
        endAngle: 0,
        data: a,
        labelLine: !1,
        label: c,
        cx: "50%",
        cy: "90%",
        innerRadius: "70%",
        outerRadius: "180%",
        fill: "#8884d8",
        stroke: "none",
        cursor: "pointer",
        children: a.map((u, d) => /* @__PURE__ */ f.jsx(
          en,
          {
            fill: o[d % o.length],
            onClick: i(u)
          },
          `cell-${d}`
        ))
      }
    ) }) }),
    /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col justify-center gap-4 rounded-md text-center", children: [
      /* @__PURE__ */ f.jsxs("div", { className: "rounded-md p-4 text-center bg-success-400", children: [
        /* @__PURE__ */ f.jsx(sr, { variant: "title-3", color: "white", children: "A tiempo" }),
        /* @__PURE__ */ f.jsx($n, { variant: "heading-4", color: "white", children: r[2].value !== null ? r[2].value : "0" }),
        /* @__PURE__ */ f.jsx(hr, { variant: "description-4", color: "white", children: "Operaciones" })
      ] }),
      /* @__PURE__ */ f.jsxs("div", { className: "rounded-md p-4 text-center bg-warning-400", children: [
        /* @__PURE__ */ f.jsx(sr, { variant: "title-3", color: "white", children: "Críticas" }),
        /* @__PURE__ */ f.jsx($n, { variant: "heading-4", color: "white", children: r[1].value !== null ? r[1].value : "0" }),
        /* @__PURE__ */ f.jsx(hr, { variant: "description-4", color: "white", children: "Operaciones" })
      ] }),
      /* @__PURE__ */ f.jsxs("div", { className: "rounded-md p-4 text-center bg-error-400", children: [
        /* @__PURE__ */ f.jsx(sr, { variant: "title-3", color: "white", children: "Muy críticas" }),
        /* @__PURE__ */ f.jsx($n, { variant: "heading-4", color: "white", children: r[0].value !== null ? r[0].value : "0" }),
        /* @__PURE__ */ f.jsx(hr, { variant: "description-4", color: "white", children: "Operaciones" })
      ] })
    ] })
  ] }) });
});
ode.displayName = "SemiPieChart";
const sde = E.forwardRef((e, t) => {
  const {
    data: r,
    chartColors: n,
    domainYAxis: a,
    ticksYAxis: i,
    onActivClick: o,
    ...s
  } = e;
  if (r == null)
    return null;
  const l = r.map((b) => ({
    name: b.name,
    [b.currentDate]: b.numCurrenDate,
    [b.previousDate]: b.numPreviousDate
  })), c = Object.keys(l[0]), u = n.map((b) => je[b.colorBar]), d = n.map((b) => je[b.colorLine]), p = (b) => () => {
    o !== void 0 && o({ data: b });
  }, [h, m] = ye(1), [v, g] = ye(0);
  return _e(() => {
    const b = () => {
      const C = document.getElementById("container-chart");
      C !== null && (C.getBoundingClientRect().width <= 650 ? (m(1), g(-45)) : (m(2), l.length >= 6 ? g(-45) : g(0)));
    };
    return b(), window.addEventListener("resize", b), () => {
      window.removeEventListener("resize", b);
    };
  }, [l]), /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx("section", { className: "w-full max-w-[1260px]", id: "container-chart", ref: t, ...s, children: /* @__PURE__ */ f.jsx(R1, { width: "100%", aspect: h, children: /* @__PURE__ */ f.jsxs(
    nde,
    {
      width: 500,
      height: 800,
      data: l,
      margin: {
        top: 20,
        right: 20,
        bottom: v === 0 ? 20 : 40,
        left: -20
      },
      children: [
        /* @__PURE__ */ f.jsx(n2, { stroke: "#f5f5f5" }),
        /* @__PURE__ */ f.jsx(ca, { dataKey: "name", className: "text-xs 2s:text-s", interval: 0, angle: v, textAnchor: v === 0 ? "middle" : "end" }),
        /* @__PURE__ */ f.jsx(
          li,
          {
            domain: a,
            ticks: i,
            className: "text-xs 2s:text-s"
          }
        ),
        /* @__PURE__ */ f.jsx(dr, { contentStyle: { fontSize: h === 2 ? "14px" : "13px" } }),
        /* @__PURE__ */ f.jsx(
          In,
          {
            wrapperStyle: { bottom: 0, left: 10 },
            iconType: "circle",
            formatter: (b) => /* @__PURE__ */ f.jsx("span", { style: { fontWeight: "bold", color: "black", marginTop: "40px", fontSize: h === 2 ? "14px" : "13px" }, children: b })
          }
        ),
        /* @__PURE__ */ f.jsx(Vr, { width: 65, dataKey: c[1], barSize: 65, fill: u[0], children: r.map((b, C) => /* @__PURE__ */ f.jsx(en, { onClick: p(b) }, `cell-${C}`)) }),
        /* @__PURE__ */ f.jsx(z1, { type: "monotone", dataKey: c[2], stroke: d[0], strokeWidth: 2 })
      ]
    }
  ) }) }) });
});
sde.displayName = "ComposedCharts";
const lde = E.forwardRef((e, t) => {
  const {
    data: r,
    chartColors: n,
    domainXAxis: a,
    ticksXAxis: i,
    onClickNegativeBar: o,
    onClickPositiveBar: s,
    ...l
  } = e;
  if (r == null)
    return null;
  const c = r.map((b) => ({
    name: b.name,
    [b.positiveBarName]: b.positiveBarNumber,
    [b.negativeBarName]: b.negativeBarNumber
  })), u = Object.keys(c[0]), d = n.map((b) => je[b.colorBarNegative]), p = n.map((b) => je[b.colorBarPositive]), h = (b) => () => {
    o !== void 0 && o({ data: b });
  }, m = (b) => () => {
    s !== void 0 && s({ data: b });
  }, [v, g] = ye(1);
  return _e(() => {
    const b = () => {
      const C = document.getElementById("container-chart-horizontal");
      C !== null && (C.getBoundingClientRect().width <= 550 ? g(1) : g(2));
    };
    return b(), window.addEventListener("resize", b), () => {
      window.removeEventListener("resize", b);
    };
  }, []), /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx("section", { id: "container-chart-horizontal", className: "w-full max-w-[1260px]", ref: t, ...l, children: /* @__PURE__ */ f.jsx(R1, { width: "100%", aspect: v, children: /* @__PURE__ */ f.jsxs(
    ew,
    {
      width: 500,
      height: 400,
      data: c,
      layout: "vertical",
      margin: {
        top: 5,
        right: 10,
        left: 0,
        bottom: 5
      },
      children: [
        /* @__PURE__ */ f.jsx(n2, { strokeDasharray: "3 3" }),
        /* @__PURE__ */ f.jsx(
          ca,
          {
            type: "number",
            domain: a,
            ticks: i,
            className: "text-xs 2s:text-s"
          }
        ),
        /* @__PURE__ */ f.jsx(li, { dataKey: "name", type: "category", className: "text-xs 2s:text-s", width: v === 2 ? 122 : void 0 }),
        /* @__PURE__ */ f.jsx(dr, { contentStyle: { fontSize: v === 2 ? "14px" : "13px" } }),
        /* @__PURE__ */ f.jsx(
          In,
          {
            iconType: "circle",
            formatter: (b) => /* @__PURE__ */ f.jsx("span", { style: { fontWeight: "bold", color: "black", marginTop: "40px", fontSize: v === 2 ? "14px" : "13px" }, children: b })
          }
        ),
        /* @__PURE__ */ f.jsx(Vr, { dataKey: u[2], barSize: 38, fill: d[0], children: r.map((b, C) => /* @__PURE__ */ f.jsx(en, { onClick: h(b) }, `cell-${C}`)) }),
        /* @__PURE__ */ f.jsx(Vr, { dataKey: u[1], barSize: 38, fill: p[0], children: r.map((b, C) => /* @__PURE__ */ f.jsx(en, { onClick: m(b) }, `cell-${C}`)) })
      ]
    }
  ) }) }) });
});
lde.displayName = "HorizontalChart";
const cde = E.forwardRef((e, t) => {
  const {
    data: r,
    chartColors: n,
    domainXAxis: a,
    ticksXAxis: i,
    onClickCurrentBar: o,
    onClickPreviousBar: s,
    image: l,
    ...c
  } = e;
  if (r == null || n == null || a == null || i == null || l == null)
    return null;
  const u = r.map((j) => ({
    name: j.name,
    [j.currentDate]: j.numCurrenDate,
    [j.previousDate]: j.numPreviousDate,
    url: j.url
  })), d = Object.keys(u[0]), p = n.map((j) => je[j.colorBarCurrent]), h = n.map((j) => je[j.colorBarPrevious]), m = (j) => () => {
    o !== void 0 && o({ data: j });
  }, v = (j) => () => {
    s !== void 0 && s({ data: j });
  }, g = ({ data: j, ...T }) => {
    const I = T.x, R = T.y, F = j == null ? void 0 : j.map(($) => $.name);
    return I == null || R == null ? null : /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsxs("g", { transform: `translate(${I},${R})`, radius: "100%", children: [
      F == null ? void 0 : F.map(($, Z) => /* @__PURE__ */ f.jsx("text", { x: 0, y: 10, transform: "rotate(-45)", textAnchor: "end", dominantBaseline: "middle", fontSize: 7, fontWeight: "400", fill: "#666666", children: $ }, Z)),
      /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "circleView", children: /* @__PURE__ */ f.jsx("circle", { cx: -5, cy: 65, r: 14 }) }) }),
      /* @__PURE__ */ f.jsx("image", { href: T.payload.value, clipPath: "url(#circleView)", x: -55, y: 50, height: "35px", width: "100px", radius: 100, textAnchor: "middle" })
    ] }) });
  }, [b, C] = ye(1), [w, x] = ye(0);
  _e(() => {
    const j = () => {
      const T = document.getElementById("container-chart-simple-bar");
      T !== null && (T.getBoundingClientRect().width <= 650 ? (C(1), x(-45)) : (C(2), u.length >= 6 ? x(-45) : x(0)));
    };
    return j(), window.addEventListener("resize", j), () => {
      window.removeEventListener("resize", j);
    };
  }, []);
  const y = ({ active: j, payload: T }) => j == null ? null : j && T != null && T.length > 0 ? /* @__PURE__ */ f.jsx("div", { className: "bg-neutral-100 p-3 border-white border-1", children: Object.keys(T[0].payload).map((I) => {
    if (I === "name") {
      const R = String(T[0].payload[I]);
      return /* @__PURE__ */ f.jsx("p", { children: `${R}` }, I);
    }
    if (I === "Mes actual") {
      const R = String(T[0].payload[I]);
      return /* @__PURE__ */ f.jsx("p", { style: { color: p[0] }, children: `${I}: ${R}` }, I);
    }
    if (I === "Mes anterior") {
      const R = String(T[0].payload[I]);
      return /* @__PURE__ */ f.jsx("p", { style: { color: h[0] }, children: `${I}: ${R}` }, I);
    }
    return null;
  }) }) : null, O = r.length > 10, P = O ? r.length * 80 : "100%";
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx("section", { id: "container-chart-simple-bar", className: "w-full max-w-[1260px]", ref: t, ...c, style: { overflowX: O ? "auto" : "visible" }, children: /* @__PURE__ */ f.jsx("div", { style: { width: P }, children: /* @__PURE__ */ f.jsx(R1, { width: "100%", aspect: b, children: /* @__PURE__ */ f.jsxs(
    ew,
    {
      width: 100,
      height: 100,
      data: u,
      margin: {
        top: 20,
        right: 20,
        bottom: w === 0 ? 20 : 50,
        left: -20
      },
      children: [
        /* @__PURE__ */ f.jsx(n2, { stroke: "#A3A3A3", strokeWidth: 0.5, horizontal: !0, vertical: !1 }),
        l ? /* @__PURE__ */ f.jsx(ca, { dataKey: "url", interval: 0, tick: /* @__PURE__ */ f.jsx(g, { data: r }) }) : /* @__PURE__ */ f.jsx(ca, { dataKey: "name", fontSize: 12, interval: 0, angle: -45, textAnchor: "end" }),
        /* @__PURE__ */ f.jsx(li, { className: "text-xs 2s:text-s", radius: "100%", domain: a, ticks: i }),
        l ? /* @__PURE__ */ f.jsx(dr, { contentStyle: { fontSize: b === 2 ? "14px" : "13px" }, content: /* @__PURE__ */ f.jsx(y, {}) }) : /* @__PURE__ */ f.jsx(dr, { contentStyle: { fontSize: b === 2 ? "14px" : "13px" } }),
        /* @__PURE__ */ f.jsx(
          In,
          {
            wrapperStyle: { bottom: l ? -15 : 0, left: 5 },
            iconType: "circle",
            formatter: (j) => /* @__PURE__ */ f.jsx("span", { style: { fontWeight: "bold", color: "black", marginTop: "40px", fontSize: b === 2 ? "14px" : "13px" }, children: j })
          }
        ),
        /* @__PURE__ */ f.jsx(Vr, { dataKey: d[1], fill: p[0], barSize: 37, children: r.map((j, T) => /* @__PURE__ */ f.jsx(en, { onClick: m(j) }, `cell-${T}`)) }),
        /* @__PURE__ */ f.jsx(Vr, { dataKey: d[2], fill: h[0], barSize: 37, children: r.map((j, T) => /* @__PURE__ */ f.jsx(en, { onClick: v(j) }, `cell-${T}`)) })
      ]
    }
  ) }) }) }) });
});
cde.displayName = "SimpleBarChart";
const ude = E.forwardRef((e) => {
  const { containerName: t, onClickVerMas: r, clearFilters: n, graphicKeyName: a } = e, i = () => `component_${a ?? "defaultKeyName"}_hidden`, [o, s] = ye(() => {
    const c = localStorage.getItem(i());
    return c !== null ? JSON.parse(c) : !1;
  }), l = () => {
    s((c) => {
      const u = !c;
      return localStorage.setItem(i(), JSON.stringify(u)), u;
    });
  };
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsxs("div", { className: "border rounded-md shadow-s mb-8 max-w-[1260px] mx-auto", children: [
    /* @__PURE__ */ f.jsx("div", { className: "p-4", children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col 2s:justify-between 2s:items-center gap-4 2s:flex-row", children: [
      /* @__PURE__ */ f.jsxs(Qr, { gap: 4, alignItems: "center", children: [
        /* @__PURE__ */ f.jsx("button", { className: "cursor-pointer", onClick: l, children: /* @__PURE__ */ f.jsx(me, { variant: o ? "eye-hide" : "eye", color: "neutral-300" }) }),
        /* @__PURE__ */ f.jsx(sr, { variant: "title-2", children: t })
      ] }),
      /* @__PURE__ */ f.jsxs(Qr, { gap: 4, children: [
        /* @__PURE__ */ f.jsx(
          "button",
          {
            onClick: r,
            className: "cursor-pointer text-white py-1 px-1 2s:px-6 2s:min-w-max font-bold bg-secondary-600 hover:bg-secondary-500 rounded-md flex-1 flex items-center justify-center text-sm",
            children: "Ver todas"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "button",
          {
            onClick: n,
            className: "text-white py-1 px-1 2s:px-6 2s:min-w-max font-bold bg-error-500 hover:bg-error-400 rounded-md flex-1 flex items-center justify-center text-sm",
            children: "Limpiar filtros"
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ f.jsx("div", { className: `border-1 ${o ? "hidden" : "block"}` }),
    /* @__PURE__ */ f.jsx("div", { className: `p-4 2s:p-8 mb-4 ${o ? "hidden" : "grid"}`, children: e.children })
  ] }) });
});
ude.displayName = "GraphicFilters";
const fde = E.forwardRef((e, t) => {
  const {
    selectFilter: r,
    onClickRefresh: n,
    search: a
  } = e, i = Yf(), {
    placeholder: o = "Search...",
    minLengthToSearch: s = 5,
    onSearch: l
  } = a;
  return /* @__PURE__ */ f.jsxs("div", { ref: t, className: "flex m:flex-grow m:max-w-[800px] justify-between h-[40px] border border-neutral-300 rounded-md bg-neutral-200 w-[100%]", children: [
    /* @__PURE__ */ f.jsx("div", { className: "w-[110px] min-w-[110px] s:w-[140px] s:min-w-[140px] 2s:min-w-[30%] relative h-full border-r border-neutral-300", children: r }),
    /* @__PURE__ */ f.jsx(
      Ig,
      {
        idSearch: i,
        placeholder: o,
        minLengthToSearch: s,
        onSearch: l,
        onClickRefresh: n
      }
    )
  ] });
});
fde.displayName = "TableScrollHeader";
const dde = (e) => {
  const {
    columns: t = [],
    isCheckedRow: r,
    setIndiceChecked: n,
    data: a = []
  } = e, i = (o) => {
    const s = [];
    if (o)
      for (const l of a.keys())
        s.push(l);
    n == null || n(s);
  };
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    (r ?? !1) && /* @__PURE__ */ f.jsx(
      "div",
      {
        style: { gridArea: "col-reserved-check" },
        className: "min-w-[50px] flex gap-2 justify-between items-center px-4",
        children: /* @__PURE__ */ f.jsx(
          "input",
          {
            type: "checkbox",
            id: "checkAll",
            title: "Seleccionar todos",
            className: "w-full",
            onClick: (o) => i(o.target.checked)
          }
        )
      }
    ),
    t.filter((o) => o.isShow).map((o) => /* @__PURE__ */ f.jsxs(
      "div",
      {
        style: {
          gridArea: `col-${o.id}`,
          textAlign: o.alignment || "left"
        },
        title: o.title,
        className: `flex gap-2 justify-between items-start px-2 2s:px-4 font-bold leading-[120%] select-none ${o.sorted && o.orderBy !== null ? "text-secondary-600" : "hover:text-secondary-500"}`,
        children: [
          /* @__PURE__ */ f.jsx(
            "p",
            {
              className: "flex gap-2 justify-between items-start",
              style: { textAlign: o.alignment || "left" },
              children: o.title
            }
          ),
          (o.sortable ?? !1) && /* @__PURE__ */ f.jsx(
            "button",
            {
              type: "button",
              "aria-label": "Ordenar",
              className: "w-6 h-6 flex items-center justify-center self-start",
              children: /* @__PURE__ */ f.jsxs(
                "svg",
                {
                  className: "w-5",
                  viewBox: "0 0 25 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: [
                    /* @__PURE__ */ f.jsx(
                      "path",
                      {
                        d: "M16.743 10L8.25505 10C8.1049 9.9994 7.95831 9.95665 7.83381 9.87715C7.70931 9.79765 7.6125 9.68497 7.55561 9.55336C7.49873 9.42176 7.48433 9.27713 7.51423 9.13777C7.54413 8.99841 7.61699 8.87057 7.7236 8.77043L11.96 4.75815C12.0306 4.69075 12.1145 4.63726 12.207 4.60075C12.2996 4.56425 12.3988 4.54545 12.499 4.54545C12.5992 4.54545 12.6985 4.56425 12.791 4.60075C12.8835 4.63726 12.9675 4.69075 13.0381 4.75815L17.2744 8.77043C17.3811 8.87057 17.4539 8.99841 17.4838 9.13777C17.5137 9.27713 17.4993 9.42176 17.4424 9.55337C17.3855 9.68497 17.2887 9.79765 17.1642 9.87715C17.0397 9.95665 16.8931 9.9994 16.743 10Z",
                        fill: o.sorted && o.orderBy === "asc" ? "#2875B4" : "#E6E6E6"
                      }
                    ),
                    /* @__PURE__ */ f.jsx(
                      "path",
                      {
                        d: "M8.25505 14H16.743C16.8931 14.0006 17.0397 14.0433 17.1642 14.1228C17.2887 14.2023 17.3855 14.315 17.4424 14.4466C17.4993 14.5782 17.5137 14.7229 17.4838 14.8622C17.4539 15.0016 17.3811 15.1294 17.2744 15.2296L13.0381 19.2419C12.9675 19.3092 12.8835 19.3627 12.791 19.3992C12.6985 19.4358 12.5992 19.4545 12.499 19.4545C12.3988 19.4545 12.2996 19.4358 12.207 19.3992C12.1145 19.3627 12.0306 19.3092 11.96 19.2419L7.7236 15.2296C7.61699 15.1294 7.54413 15.0016 7.51423 14.8622C7.48433 14.7229 7.49873 14.5782 7.55561 14.4466C7.6125 14.315 7.70931 14.2023 7.83381 14.1228C7.95831 14.0433 8.1049 14.0006 8.25505 14Z",
                        fill: o.sorted && o.orderBy === "desc" ? "#2875B4" : "#E6E6E6"
                      }
                    )
                  ]
                }
              )
            }
          )
        ]
      },
      o.id
    ))
  ] });
}, pde = (e) => {
  const {
    columns: t = [],
    data: r = [],
    isCheckedRow: n,
    activeRowValidation: a,
    handleCheckedRow: i,
    nextPageScroll: o,
    dataLength: s = 0,
    hasMore: l,
    onRowClick: c,
    colorColumn: u
  } = e, d = () => o !== void 0 ? o() : null, p = t.filter((O) => O.isShow), h = {
    sm: "minmax(120px, 0.45fr)",
    m: "minmax(205px, 1fr)",
    xl: "minmax(360px, 1.4fr)"
  }, m = (n ? "col-reserved-check " : "") + p.map((O) => `col-${O.id}`).concat("col-reserved-actions").join(" "), v = (n ? "50px " : "") + p.map((O) => h[O.size ?? "m"]).concat("150px").join(" "), g = { gridTemplateAreas: `'${m}'`, gridTemplateColumns: v }, b = [], [C, w] = ye(b), x = (O, P) => {
    w(O ? (j) => [...j, P] : (j) => j.filter((T) => T !== P));
  };
  _e(() => {
    const O = [];
    C.length > 0 && C.forEach((P) => {
      O.push(r[P]);
    }), i !== void 0 && i({ rows: O });
  }, [C]);
  const y = (O) => new Intl.NumberFormat("de-DE").format(O);
  return /* @__PURE__ */ f.jsx("div", { className: "grid gap-2 hidden 2s:block", children: /* @__PURE__ */ f.jsx(
    "div",
    {
      className: "table-max-height w-full overflow-x-auto overflow-y-auto table-main-scrollbar pb-1",
      id: "scrollableTable",
      children: /* @__PURE__ */ f.jsxs("div", { children: [
        /* @__PURE__ */ f.jsx(
          "div",
          {
            className: "bg-white grid w-full sticky top-0",
            style: { ...g, zIndex: r.length + 10, gridAutoRows: "auto" },
            children: /* @__PURE__ */ f.jsx(
              dde,
              {
                columns: t,
                data: r,
                isCheckedRow: n,
                setIndiceChecked: w
              }
            )
          }
        ),
        /* @__PURE__ */ f.jsx("div", { className: "min-w-[min-content]", children: /* @__PURE__ */ f.jsx(
          wu,
          {
            dataLength: s,
            hasMore: l,
            next: d,
            scrollableTarget: "scrollableTable",
            style: { overflow: "hidden" },
            loader: /* @__PURE__ */ f.jsx(dv, { variant: "loading", text: "Cargando información..." }),
            children: r.map((O, P) => {
              const j = P % 2 === 0, T = O != null && O.error ? "error" : "secondary", R = (a === void 0 || O[a.field] === void 0 ? !0 : O[a.field] === a.value) ? j ? `bg-${T}-200` : `bg-${T}-100` : "bg-neutral-200 text-neutral-400";
              return /* @__PURE__ */ f.jsx(gn, { children: /* @__PURE__ */ f.jsxs(
                "div",
                {
                  style: g,
                  className: `${R} hover:bg-${T}-300 hover:text-${T}-600 cursor-pointer border-b border-white last:border-none h-[48px] grid w-full`,
                  children: [
                    n && /* @__PURE__ */ f.jsx("div", { className: "min-w-[50px] flex justify-between items-center pr-1", children: /* @__PURE__ */ f.jsx(
                      "input",
                      {
                        type: "checkbox",
                        title: "Seleccionar",
                        checked: C.includes(P),
                        value: P,
                        className: "checkbox w-full overflow-hidden whitespace-nowrap",
                        onChange: (F) => {
                          x(F.target.checked, P);
                        }
                      }
                    ) }),
                    Object.entries(O).map(([F, $]) => {
                      const Z = t.find((ee) => ee.id === F);
                      if (Z === void 0 || !Z.isShow)
                        return null;
                      let X = !1, K = "", J = u ? u.filter((ee) => ee.title === F) : [];
                      if (J.length > 0) {
                        X = !0;
                        const ee = J[0].params.filter((_) => _.value === $), A = ee.length > 0 ? ee[0].color : "transparent";
                        K = je[A];
                      }
                      return /* @__PURE__ */ f.jsx(
                        "div",
                        {
                          style: { gridArea: `col-${Z.id}`, textAlign: Z.alignment ? Z.alignment : "left" },
                          title: $,
                          className: "flex items-center px-2 2s:px-4 border-l border-white first:border-none leading-[120%]",
                          onClick: () => {
                            c && !Z.onClickCell && c({ row: O });
                          },
                          children: X ? /* @__PURE__ */ f.jsx("div", { className: "w-full h-8 px-4 justify-center items-center gap-2 flex", style: { borderRadius: "8px", backgroundColor: K }, children: /* @__PURE__ */ f.jsx("div", { className: "grow text-center text-white text-xs font-bold leading-[14.40px]", children: $ }) }) : /* @__PURE__ */ f.jsx(f.Fragment, { children: Z.isInput ? /* @__PURE__ */ f.jsx(
                            Qf,
                            {
                              type: "number",
                              name: `${Z.id}`,
                              value: $,
                              onChange: (ee) => {
                                Z.handleInputChange && Z.handleInputChange(ee, P);
                              },
                              readOnly: !C.includes(P)
                            }
                          ) : /* @__PURE__ */ f.jsx(
                            "p",
                            {
                              className: `w-full text-ellipsis overflow-hidden whitespace-nowrap ${Z.onClickCell ? "underline text-secondary-600" : ""}`,
                              onClick: () => Z.onClickCell && Z.onClickCell(O),
                              children: Z.isCurrency ? `$ ${y($)}` : $
                            }
                          ) })
                        },
                        F
                      );
                    })
                  ]
                },
                O.id
              ) }, `fragment-${P}`);
            })
          }
        ) })
      ] })
    }
  ) });
}, hde = (e) => {
  const {
    columns: t = [],
    data: r = [],
    handleCheckedRow: n,
    nextPageScroll: a,
    dataLength: i,
    hasMore: o,
    onRowClick: s,
    colorColumn: l
  } = e, c = [], [u, d] = ye(c), p = (v, g) => {
    d(v ? (b) => [...b, g] : (b) => b.filter((C) => C !== g));
  };
  _e(() => {
    const v = [];
    u.length > 0 && u.forEach((g) => {
      v.push(r[g]);
    }), n !== void 0 && n({ rows: v });
  }, [u]);
  const h = () => a !== void 0 ? a() : null, m = (v) => new Intl.NumberFormat("de-DE").format(v);
  return /* @__PURE__ */ f.jsx("div", { className: "grid gap-2 2s:hidden", children: /* @__PURE__ */ f.jsx(
    "div",
    {
      className: `max-h-[calc(100vh-461px)] min-h-[calc(100vh-461px)] m:max-h-[calc(100vh-305px)] m:min-h-[calc(100vh-305px)]
      l:max-h-[calc(100vh-312px)] l:min-h-[calc(100vh-312px)] table-max-height w-full overflow-auto table-main-scrollbar pb-1`,
      children: /* @__PURE__ */ f.jsx(
        wu,
        {
          dataLength: i,
          hasMore: o,
          next: h,
          scrollableTarget: "scrollableTable",
          style: { overflow: "hidden" },
          loader: /* @__PURE__ */ f.jsx(Qr, { justifyContent: "center", children: /* @__PURE__ */ f.jsx(gt, { isLoading: !0, variant: "secondary", children: "Cargando... " }) }),
          children: r.map((v, g) => /* @__PURE__ */ f.jsx(gn, { children: /* @__PURE__ */ f.jsx(
            "div",
            {
              className: "relative p-4 rounded-md bg-secondary-100 hover:bg-secondary-200 hover:text-secondary-600 w-full cursor-pointer",
              onClick: () => {
                s && s({ row: v });
              },
              children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-wrap gap-y-1.5 gap-x-6", children: [
                /* @__PURE__ */ f.jsx(
                  "div",
                  {
                    style: { gridArea: "col-reserved-check" },
                    children: /* @__PURE__ */ f.jsx(
                      "input",
                      {
                        type: "checkbox",
                        id: "checkAll",
                        title: "Seleccionar todos",
                        className: "w-full overflow-hidden whitespace-nowrap",
                        onChange: (b) => {
                          p(b.target.checked, g);
                        }
                      }
                    )
                  }
                ),
                Object.entries(v).filter(([b]) => t.some((C) => C.id === b && C.isMobileShow)).map(([b, C]) => {
                  const w = t.find((T) => T.id === b);
                  if (w === void 0)
                    return null;
                  const {
                    isMobileShow: x = !1,
                    isTextBold: y = !1
                  } = w;
                  if (!x)
                    return null;
                  let O = !1, P = "", j = l ? l.filter((T) => T.title === b) : [];
                  if (j.length > 0) {
                    O = !0;
                    const T = j[0].params.filter((R) => R.value === C), I = T.length > 0 ? T[0].color : "transparent";
                    P = je[I];
                  }
                  return O ? /* @__PURE__ */ f.jsx("div", { className: "w-full h-8 px-4 justify-center items-center gap-2 flex", style: { borderRadius: "8px", backgroundColor: P }, children: /* @__PURE__ */ f.jsx("div", { className: "grow text-center text-white text-xs font-bold leading-[14.40px]", children: C }) }) : /* @__PURE__ */ f.jsx(
                    "p",
                    {
                      className: `leading-[120%] ${y ? "font-bold" : ""} w-full pr-12`,
                      children: w.isCurrency ? `$ ${m(C)}` : C
                    },
                    b
                  );
                })
              ] })
            },
            v.id
          ) }, `fragment-${g}`))
        }
      )
    }
  ) });
}, vde = E.forwardRef((e, t) => {
  const {
    columns: r = [],
    data: n = [],
    isCheckedRow: a = !1,
    className: i,
    nextPageScroll: o,
    dataLength: s = 1,
    hasMore: l,
    handleCheckedRow: c,
    onRowClick: u,
    colorColumn: d
  } = e;
  return /* @__PURE__ */ f.jsxs("div", { ref: t, className: $e(["block", i]), children: [
    /* @__PURE__ */ f.jsx(
      hde,
      {
        hasMore: l,
        columns: r,
        data: n,
        isCheckedRow: a,
        nextPageScroll: o,
        dataLength: s,
        handleCheckedRow: c,
        onRowClick: u
      }
    ),
    /* @__PURE__ */ f.jsx(
      pde,
      {
        hasMore: l,
        columns: r,
        data: n,
        isCheckedRow: a,
        nextPageScroll: o,
        dataLength: s,
        handleCheckedRow: c,
        onRowClick: u,
        colorColumn: d
      }
    )
  ] });
});
vde.displayName = "TableScrollMain";
const mde = (e) => {
  const {
    columns: t = [],
    data: r = [],
    onRowClick: n,
    textAlign: a = "left"
  } = e;
  return /* @__PURE__ */ f.jsx("div", { className: "grid gap-2 2s:hidden", children: r.map((i, o) => /* @__PURE__ */ f.jsx(gn, { children: /* @__PURE__ */ f.jsx(
    "div",
    {
      className: "relative p-4 rounded-md bg-secondary-100 hover:bg-secondary-200 hover:text-secondary-600 w-full cursor-pointer",
      onClick: () => {
        n !== void 0 && n({ row: i });
      },
      children: /* @__PURE__ */ f.jsx("div", { className: "flex flex-wrap gap-y-1.5 gap-x-6", children: Object.entries(i).filter(([s]) => t.some((l) => l.id === s && l.isMobileShow)).map(([s, l]) => {
        const c = t.find((p) => p.id === s);
        if (c === void 0)
          return null;
        const {
          isMobileShow: u = !1,
          isTextBold: d = !1
        } = c;
        return u ? /* @__PURE__ */ f.jsx(
          "p",
          {
            className: `leading-[120%] ${d ? "font-bold" : ""} w-full pr-12 text-${a}`,
            style: { textAlign: a },
            children: l
          },
          s
        ) : null;
      }) })
    },
    i.id
  ) }, `fragment-${o}`)) });
}, gde = ({ actions: e = [], row: t, onActionClick: r, onRowClick: n }) => {
  const [a, i] = ye(!1), o = ve(null), s = ve(null), l = (d) => {
    var p, h;
    (p = o.current) != null && p.contains(d.target) || (h = s.current) != null && h.contains(d.target) || i(!1);
  };
  _e(() => (document.addEventListener("click", l, !0), () => {
    document.removeEventListener("click", l, !0);
  }), []);
  const c = (d) => () => {
    r && r({ row: t, action: d }), i(!1);
  }, u = () => {
    n && n({ row: t });
  };
  return /* @__PURE__ */ f.jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ f.jsx(
      gt,
      {
        type: "button",
        variant: "secondary-light-bold",
        icon: "menu-context",
        tooltip: "Acciones",
        tooltipDirection: "left",
        disabled: e.length === 0,
        ref: o,
        size: "s",
        onlyIcon: !0,
        onClick: () => i((d) => !d)
      }
    ),
    a && /* @__PURE__ */ f.jsx(
      "div",
      {
        ref: s,
        className: "absolute top-[calc(100%+8px)] right-0 z-[20] cursor-default pb-[20px] pointer-events-none",
        children: /* @__PURE__ */ f.jsx("div", { className: "bg-white min-w-[165px] max-w-[250px] p-4 rounded-md shadow-l pointer-events-auto", children: /* @__PURE__ */ f.jsxs("ul", { children: [
          e.map((d) => /* @__PURE__ */ f.jsxs(
            "li",
            {
              onClick: c(d),
              className: "p-2 rounded-md font-bold text-secondary-600 cursor-pointer min-h-[40px] flex items-center gap-2 hover:bg-secondary-200",
              children: [
                /* @__PURE__ */ f.jsx("span", { className: "w-5 h-5 object-contain min-w-[20px]", children: /* @__PURE__ */ f.jsx(me, { variant: d.icon, isContain: !0 }) }),
                /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] grow w-full text-ellipsis overflow-hidden whitespace-nowrap", children: d.title })
              ]
            },
            d.id
          )),
          e.length === 0 && /* @__PURE__ */ f.jsxs(
            "li",
            {
              onClick: u,
              className: "p-2 rounded-md font-bold text-secondary-600 cursor-pointer min-h-[40px] flex items-center gap-2 hover:bg-secondary-200",
              children: [
                /* @__PURE__ */ f.jsx("span", { className: "w-5 h-5 object-contain min-w-[20px]", children: /* @__PURE__ */ f.jsx(me, { variant: "eye", isContain: !0 }) }),
                /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] grow w-full text-ellipsis overflow-hidden whitespace-nowrap", children: "Ver" })
              ]
            }
          )
        ] }) })
      }
    )
  ] });
}, yde = (e) => {
  const {
    actions: t = [],
    columns: r = [],
    data: n = [],
    activeRowValidation: a,
    onRowClick: i,
    handleDisplayDetail: o,
    showDetail: s,
    isCheckedRow: l,
    handleCheckedRow: c,
    colorColumn: u,
    intermediateContent: d,
    requestSort: p,
    sortConfig: h,
    textAlign: m = "left",
    onSelectChange: v,
    onActionClick: g,
    isButtonAcction: b
  } = e, C = E.useMemo(() => {
    if (!h)
      return n;
    const U = [...n];
    return U.sort((H, k) => {
      const L = H[h.key], W = k[h.key];
      return typeof L == "string" && typeof W == "string" ? (L < W ? -1 : L > W ? 1 : 0) * (h.direction === "asc" ? 1 : -1) : 0;
    }), U;
  }, [n, h]), w = r.filter((U) => U.isShow).length, x = C.length, y = (U) => (h == null ? void 0 : h.key) === U.id && (h == null ? void 0 : h.direction) === "asc", O = (U) => (h == null ? void 0 : h.key) === U.id && (h == null ? void 0 : h.direction) === "desc", P = 55, j = 60, T = Math.min(x * P + j, 800), I = (l ? "col-reserved-check " : "") + r.filter((U) => U.isShow).map((U) => `col-${U.id}`).concat("col-reserved-actions").join(" "), R = (l ? "50px " : "") + Array.from({ length: w }, () => "1fr").join(" ").toString(), F = { gridTemplateAreas: `'${I}'`, gridTemplateColumns: R }, [$, Z] = ye(!0), [X, K] = ye([]), [J, ee] = ye(!1), A = (U) => {
    ee(U), K(U ? n.map((H, k) => k) : []);
  }, [_, N] = ye({}), [M, S] = ye(null);
  _e(() => {
    const U = n.reduce((H, k, L) => (r.forEach((W) => {
      if (W.isAnSelectColumn) {
        const V = k[W.id], D = typeof V == "object" && V !== null ? V.label : V;
        H[L] = D;
      }
    }), H), {});
    N(U);
  }, [n, r]);
  const B = (U, H, k) => {
    N((L) => ({
      ...L,
      [k]: U
    })), S({ value: U, row: H });
  };
  _e(() => {
    M && v && (console.log(M.row), v(M.value, M.row), S(null));
  }, [M]);
  const G = (U, H) => {
    K(U ? (k) => [...k, H] : (k) => k.filter((L) => L !== H));
  };
  return _e(() => {
    let U = [];
    X.length > 0 && X.forEach((H) => {
      U.push(n[H]);
    }), c && c({ rows: U });
  }, [X]), /* @__PURE__ */ f.jsx("div", { className: "grid gap-2 hidden 2s:block", children: /* @__PURE__ */ f.jsx(
    "div",
    {
      className: `${d ? "table-max-height" : ""} w-full overflow-x-auto overflow-y-auto table-main-scrollbar pb-1`,
      style: { maxHeight: `${T}px` },
      children: /* @__PURE__ */ f.jsxs("div", { className: "min-w-[min-content]", children: [
        /* @__PURE__ */ f.jsxs("div", { className: "bg-white grid w-full h-10 sticky top-0", style: { ...F, zIndex: 1 }, children: [
          l && /* @__PURE__ */ f.jsx("div", { className: "min-w-[50px] flex items-center pr-1", children: /* @__PURE__ */ f.jsx(
            "input",
            {
              type: "checkbox",
              title: "Seleccionar todas",
              checked: J,
              onChange: (U) => A(U.target.checked),
              className: "checkbox w-full overflow-hidden whitespace-nowrap"
            }
          ) }),
          r.filter((U) => U.isShow).map((U) => /* @__PURE__ */ f.jsxs(
            "div",
            {
              style: {
                gridArea: `col-${U.id}`,
                textAlign: m,
                display: "flex",
                alignItems: "center",
                padding: "0 12px",
                boxSizing: "border-box",
                cursor: U.sortable ?? !1 ? "pointer" : "default",
                fontWeight: "bold",
                userSelect: "none",
                gap: 8
              },
              onClick: () => {
                (U.sortable ?? !1) && p && p(U.id);
              },
              children: [
                /* @__PURE__ */ f.jsx("span", { children: U.title }),
                (U.sortable ?? !1) && /* @__PURE__ */ f.jsx(
                  "button",
                  {
                    type: "button",
                    "aria-label": "Ordenar",
                    className: "w-6 h-6 flex items-center justify-center self-start",
                    onClick: (H) => {
                      H.stopPropagation(), p && p(U.id);
                    },
                    children: /* @__PURE__ */ f.jsxs(
                      "svg",
                      {
                        className: "w-5",
                        viewBox: "0 0 25 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                          /* @__PURE__ */ f.jsx(
                            "path",
                            {
                              d: "M16.743 10L8.25505 10C8.1049 9.9994 7.95831 9.95665 7.83381 9.87715C7.70931 9.79765 7.6125 9.68497 7.55561 9.55336C7.49873 9.42176 7.48433 9.27713 7.51423 9.13777C7.54413 8.99841 7.61699 8.87057 7.7236 8.77043L11.96 4.75815C12.0306 4.69075 12.1145 4.63726 12.207 4.60075C12.2996 4.56425 12.3988 4.54545 12.499 4.54545C12.5992 4.54545 12.6985 4.56425 12.791 4.60075C12.8835 4.63726 12.9675 4.69075 13.0381 4.75815L17.2744 8.77043C17.3811 8.87057 17.4539 8.99841 17.4838 9.13777C17.5137 9.27713 17.4993 9.42176 17.4424 9.55337C17.3855 9.68497 17.2887 9.79765 17.1642 9.87715C17.0397 9.95665 16.8931 9.9994 16.743 10Z",
                              fill: y(U) ? "#2875B4" : "#E6E6E6"
                            }
                          ),
                          /* @__PURE__ */ f.jsx(
                            "path",
                            {
                              d: "M8.25505 14H16.743C16.8931 14.0006 17.0397 14.0433 17.1642 14.1228C17.2887 14.2023 17.3855 14.315 17.4424 14.4466C17.4993 14.5782 17.5137 14.7229 17.4838 14.8622C17.4539 15.0016 17.3811 15.1294 17.2744 15.2296L13.0381 19.2419C12.9675 19.3092 12.8835 19.3627 12.791 19.3992C12.6985 19.4358 12.5992 19.4545 12.499 19.4545C12.3988 19.4545 12.2996 19.4358 12.207 19.3992C12.1145 19.3627 12.0306 19.3092 11.96 19.2419L7.7236 15.2296C7.61699 15.1294 7.54413 15.0016 7.51423 14.8622C7.48433 14.7229 7.49873 14.5782 7.55561 14.4466C7.6125 14.315 7.70931 14.2023 7.83381 14.1228C7.95831 14.0433 8.1049 14.0006 8.25505 14Z",
                              fill: O(U) ? "#2875B4" : "#E6E6E6"
                            }
                          )
                        ]
                      }
                    )
                  }
                ),
                (h == null ? void 0 : h.key) === U.id && /* @__PURE__ */ f.jsx("span", { children: h.direction === "asc" ? "↑" : "↓" })
              ]
            },
            U.id
          )),
          /* @__PURE__ */ f.jsx(
            "div",
            {
              style: {
                gridArea: "col-reserved-actions",
                padding: "0 8px",
                boxSizing: "border-box"
              }
            }
          )
        ] }),
        /* @__PURE__ */ f.jsx("div", { className: "bg-secondary-100 w-full", children: /* @__PURE__ */ f.jsx("div", { children: C.map((U, H) => {
          const k = H % 2 === 0, W = (a === void 0 || U[a.field] === void 0 ? !0 : U[a.field] === a.value) ? k ? "bg-secondary-200" : "bg-secondary-100" : "bg-neutral-200 text-neutral-400";
          return /* @__PURE__ */ f.jsx(gn, { children: /* @__PURE__ */ f.jsxs(
            "div",
            {
              style: F,
              className: `${W} hover:bg-secondary-300 hover:text-secondary-600 cursor-pointer border-b border-white last:border-none h-[48px] grid w-full`,
              children: [
                l && /* @__PURE__ */ f.jsx("div", { className: "min-w-[50px] flex justify-between items-center pr-1", children: /* @__PURE__ */ f.jsx(
                  "input",
                  {
                    type: "checkbox",
                    title: "Seleccionar",
                    checked: X.includes(H),
                    value: H,
                    className: "checkbox w-full overflow-hidden whitespace-nowrap",
                    onChange: (V) => {
                      G(V.target.checked, H);
                    }
                  }
                ) }),
                Object.entries(U).map(([V, D]) => {
                  const Q = r.find((ue) => ue.id === V);
                  if (!Q || !Q.isShow)
                    return null;
                  const z = typeof D == "object" && D !== null ? D.label : D, te = typeof D == "object" && D !== null ? D.isHyperlink : Q.isHyperlink;
                  let ne = !1;
                  Q.isAnSelectColumn && (ne = typeof D == "object" && D !== null ? D.isDisabled : !1);
                  let ae = !1, se = "", pe = u ? u.filter((ue) => ue.title === V) : [];
                  if (pe.length > 0) {
                    ae = !0;
                    const ue = pe[0].params.filter((Be) => Be.value === D), Te = ue.length > 0 ? ue[0].color : "transparent";
                    se = je[Te];
                  }
                  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx(
                    "div",
                    {
                      style: { gridArea: `col-${Q.id}`, textAlign: m },
                      title: z,
                      className: `flex items-center px-4 border-l border-white first:border-none leading-[120%] ${ae ? `text-color-${se}` : ""} truncate`,
                      onClick: () => {
                        i && !Q.onClickCell && !Q.isAnSelectColumn && i({ row: U });
                      },
                      children: ae ? /* @__PURE__ */ f.jsx("div", { className: "w-full h-8 px-4 justify-center items-center gap-2 flex", style: { borderRadius: "8px", backgroundColor: se }, children: /* @__PURE__ */ f.jsx("div", { className: "grow text-center text-white text-xs font-bold leading-[14.40px]", children: z }) }) : Q.isAnSelectColumn ? /* @__PURE__ */ f.jsx(
                        "select",
                        {
                          value: _[H],
                          onChange: (ue) => B(ue.target.value, U, H),
                          className: "w-full border-none bg-transparent cursor-pointer text-ellipsis overflow-hidden whitespace-nowrap",
                          disabled: ne,
                          children: (Q.options || []).map((ue) => /* @__PURE__ */ f.jsx("option", { value: ue.value, children: ue.text }, ue.value))
                        }
                      ) : /* @__PURE__ */ f.jsx(
                        "p",
                        {
                          className: `w-full text-ellipsis overflow-hidden whitespace-nowrap ${te ? "underline text-secondary-600" : ""}`,
                          onClick: () => te && Q.onClickCell && Q.onClickCell(U),
                          children: z
                        }
                      )
                    },
                    V
                  ) });
                }),
                b && /* @__PURE__ */ f.jsx("div", { className: "bg-white sticky block right-0 border-l border-white cursor-default pr-1", style: { zIndex: n.length - H + 1 }, children: /* @__PURE__ */ f.jsx("div", { className: W, children: /* @__PURE__ */ f.jsx("div", { className: `flex items-center gap-2 h-[48px] px-4 ${H + 1 === n.length ? "" : "border-b border-white"}`, children: /* @__PURE__ */ f.jsx(
                  gde,
                  {
                    actions: t,
                    row: U,
                    onActionClick: g,
                    onRowClick: i
                  }
                ) }) }) }),
                s && /* @__PURE__ */ f.jsx(
                  gt,
                  {
                    type: "button",
                    variant: "secondary-light-bold",
                    icon: "arrow-down",
                    tooltip: "Ver Detalle",
                    tooltipDirection: "left",
                    size: "s",
                    onlyIcon: !0,
                    onClick: () => {
                      o && (o({ row: U, isShowDetail: $ }), Z((V) => !V));
                    }
                  }
                )
              ]
            },
            U.id
          ) }, `fragment-${H}`);
        }) }) })
      ] })
    }
  ) });
}, bde = E.forwardRef((e, t) => {
  const {
    actions: r = [],
    columns: n = [],
    data: a = [],
    activeRowValidation: i,
    className: o,
    onRowClick: s,
    onColumnClick: l,
    onChangeShowColumn: c,
    handleDisplayDetail: u,
    detailData: d = [],
    detailColumns: p = [],
    showDetail: h = !1,
    handleDeleteDetatail: m,
    isCheckedRow: v = !1,
    handleCheckedRow: g,
    colorColumn: b,
    intermediateContent: C,
    textAlign: w = "left",
    onSelectChange: x,
    onActionClick: y,
    requestSort: O,
    isButtonAcction: P
  } = e;
  return n.length < 1 ? null : /* @__PURE__ */ f.jsxs("div", { ref: t, className: $e(["block", o]), children: [
    /* @__PURE__ */ f.jsx(
      mde,
      {
        columns: n,
        data: a,
        onRowClick: s,
        handleDisplayDetail: u,
        detailData: d,
        detailColumns: p,
        showDetail: h,
        handleDeleteDetatail: m,
        textAlign: w
      }
    ),
    /* @__PURE__ */ f.jsx(
      yde,
      {
        actions: r,
        columns: n,
        data: a,
        activeRowValidation: i,
        onRowClick: s,
        onColumnClick: l,
        onChangeShowColumn: c,
        handleDisplayDetail: u,
        detailData: d,
        showDetail: h,
        handleDeleteDetatail: m,
        isCheckedRow: v,
        requestSort: O,
        handleCheckedRow: g,
        colorColumn: b,
        intermediateContent: C,
        textAlign: w,
        onSelectChange: x,
        onActionClick: y,
        isButtonAcction: P
      }
    )
  ] });
});
bde.displayName = "TableData";
const Cde = "_mainContainer_1mxor_1", xde = "_dragZone_1mxor_19", wde = "_dragBtn_1mxor_35", Ode = "_dragging_1mxor_45", Sde = "_dinamicButtons_1mxor_53", T3 = {
  mainContainer: Cde,
  dragZone: xde,
  dragBtn: wde,
  dragging: Ode,
  dinamicButtons: Sde
}, Pde = ({ buttons: e = [], ...t }) => {
  const [r, n] = ye({ x: 100, y: 100 }), [a, i] = ye(!1), o = ve(null), s = ve({ x: 0, y: 0 });
  _e(() => {
    const u = (p) => {
      if (a) {
        const h = p.clientX - s.current.x, m = p.clientY - s.current.y;
        n({ x: h, y: m });
      }
    }, d = () => {
      a && (i(!1), document.body.style.cursor = "default");
    };
    return window.addEventListener("mousemove", u), window.addEventListener("mouseup", d), () => {
      window.removeEventListener("mousemove", u), window.removeEventListener("mouseup", d);
    };
  }, [a]);
  const l = (u) => {
    if (o.current) {
      const d = o.current.getBoundingClientRect();
      s.current = {
        x: u.clientX - d.left,
        y: u.clientY - d.top
      }, i(!0), document.body.style.cursor = "grabbing";
    }
  }, c = (u) => {
    u.stopPropagation(), l(u);
  };
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: o,
      ...t,
      className: $e([T3.mainContainer, "bg-secondary-700", t.className]),
      style: { top: `${r.y}px`, left: `${r.x}px`, position: "absolute", ...t.style },
      onMouseDown: l,
      children: [
        /* @__PURE__ */ f.jsx("div", { className: T3.dragZone, children: /* @__PURE__ */ f.jsx(
          gt,
          {
            style: { cursor: a ? "grabbing" : "grab", color: "white" },
            icon: "drag",
            size: "m",
            onlyIcon: !0,
            variant: "terciary",
            onMouseDown: c
          }
        ) }),
        /* @__PURE__ */ f.jsx("div", { className: T3.dinamicButtons, children: e.map((u, d) => /* @__PURE__ */ f.jsx(
          gt,
          {
            size: "m",
            variant: u.variant,
            tooltip: a ? void 0 : u.tooltip,
            tooltipDirection: "bottom",
            icon: u.icon,
            onlyIcon: !0,
            onClick: a ? void 0 : u.onClick
          },
          d
        )) })
      ]
    }
  );
}, Ede = "_mainContainer_y03yz_1", jde = "_closed_y03yz_21", _de = "_open_y03yz_29", Ade = "_dragZone_y03yz_37", Dde = "_dragBtn_y03yz_53", Mde = "_dinamicButtons_y03yz_59", Tde = "_DinamicBtn_y03yz_71", $de = "_textButton_y03yz_77", Nde = "_dragging_y03yz_103", Aa = {
  mainContainer: Ede,
  closed: jde,
  open: _de,
  dragZone: Ade,
  dragBtn: Dde,
  dinamicButtons: Mde,
  DinamicBtn: Tde,
  textButton: $de,
  dragging: Nde
}, Ide = ({ buttons: e = [] }) => {
  const [t, r] = ye(!1), [n, a] = ye(!1), i = ve(null), o = ve({ x: 0, y: 0 }), s = ve(null), l = ve({ x: 50, y: 50 });
  _e(() => {
    const d = () => {
      var m, v;
      const p = window.innerWidth - (((m = i.current) == null ? void 0 : m.offsetWidth) || 0), h = window.innerHeight - (((v = i.current) == null ? void 0 : v.offsetHeight) || 0);
      l.current.x = Math.min(Math.max(l.current.x, 0), p), l.current.y = Math.min(Math.max(l.current.y, 0), h);
    };
    return window.addEventListener("resize", d), d(), () => {
      window.removeEventListener("resize", d);
    };
  }, []), _e(() => {
    const d = (h) => {
      if (n && i.current) {
        const m = h.touches[0], v = m.clientX - o.current.x, g = m.clientY - o.current.y;
        l.current = { x: v, y: g }, s.current === null && (s.current = requestAnimationFrame(() => {
          i.current && (i.current.style.top = `${l.current.y}px`, i.current.style.left = `${l.current.x}px`), s.current = null;
        }));
      }
    }, p = () => {
      n && (a(!1), document.body.style.cursor = "default");
    };
    return window.addEventListener("touchmove", d), window.addEventListener("touchend", p), () => {
      window.removeEventListener("touchmove", d), window.removeEventListener("touchend", p), s.current && cancelAnimationFrame(s.current);
    };
  }, [n]);
  const c = (d) => {
    if (i.current) {
      const p = i.current.getBoundingClientRect(), h = d.touches[0];
      o.current = {
        x: h.clientX - p.left,
        y: h.clientY - p.top
      }, a(!0), document.body.style.cursor = "grabbing";
    }
  }, u = () => {
    n || r(!t);
  };
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: i,
      className: $e([
        Aa.mainContainer,
        "bg-secondary-950",
        t ? Aa.open : Aa.closed,
        n ? Aa.dragging : ""
      ]),
      style: {
        top: `${l.current.y}px`,
        left: `${l.current.x}px`,
        position: "fixed",
        transition: n ? "none" : "top 0.2s ease, left 0.2s ease"
      },
      onTouchStart: c,
      onClick: u,
      children: [
        /* @__PURE__ */ f.jsx("div", { className: Aa.dragZone, children: /* @__PURE__ */ f.jsx(
          gt,
          {
            className: Aa.dragBtn,
            size: "m",
            variant: "white-secondary",
            icon: "drag",
            onlyIcon: !0,
            style: { cursor: n ? "grabbing" : "grab" }
          }
        ) }),
        t && /* @__PURE__ */ f.jsx("div", { className: Aa.dinamicButtons, children: e.map((d, p) => /* @__PURE__ */ f.jsx(
          gt,
          {
            size: "m",
            variant: "terciary",
            color: "white",
            icon: d.icon,
            onClick: d.onClick,
            onlyIcon: !0
          },
          p
        )) })
      ]
    }
  );
}, Lde = E.forwardRef((e, t) => {
  const { buttons: r } = e, [n, a] = ye(window.innerWidth <= 768);
  return _e(() => {
    const i = () => {
      a(window.innerWidth <= 768);
    };
    return window.addEventListener("resize", i), () => {
      window.removeEventListener("resize", i);
    };
  }, []), /* @__PURE__ */ f.jsx("div", { ref: t, children: n ? /* @__PURE__ */ f.jsx(Ide, { buttons: r }) : /* @__PURE__ */ f.jsx(Pde, { buttons: r }) });
});
Lde.displayName = "FloatingToolbox";
export {
  QR as Acordeon,
  iP as Autocomplete,
  x1 as Avatar,
  qR as Body,
  Tn as Box,
  Bde as BoxFile,
  Vde as BoxFileMultiple,
  dv as BoxStatus,
  Sw as Breadcrumb,
  gt as Button,
  gv as Checkbox,
  mm as CimaLogo,
  me as CodeIcon,
  sde as ComposedChart,
  XS as Dashboard,
  QS as DashboardMain,
  vm as DateRangeInput,
  hr as Description,
  JS as Divider,
  vv as Dropdown,
  N3 as DropdownAction,
  tP as ExportTable,
  rP as ExportTableCol,
  oP as FieldError,
  Qr as Flexbox,
  os as FlexboxRow,
  Lde as FloatingToolbox,
  yH as Genlingx,
  ide as GraphicContainer,
  ude as GraphicFilters,
  cT as HeaderBoxLeft,
  uT as HeaderBoxRight,
  fT as HeaderNotificationItem,
  dT as HeaderNotifications,
  pT as HeaderOldButton,
  hT as HeaderSearch,
  vT as HeaderUser,
  mT as HeaderUserItem,
  gT as HeaderWrapper,
  $n as Heading,
  lde as HorizontalChart,
  Qf as Input,
  hP as InputMask,
  Jf as Label,
  pR as MenuItems,
  hR as MenuWrapper,
  vR as Modal,
  mR as ModalBody,
  gR as ModalFocus,
  CR as ModalFocusContainer,
  bR as ModalFooter,
  yR as ModalHeader,
  ade as PieCharts,
  sP as Radio,
  yT as SaicoLogo,
  I3 as Select,
  mP as SelectGroup,
  ode as SemiPieChart,
  cde as SimpleBarChart,
  xR as Spreen,
  wR as SpreenBody,
  OR as SpreenFooter,
  ER as SpreenHeader,
  SR as SpreenLeft,
  PR as SpreenRight,
  Hi as Stack,
  Ei as StackRow,
  _R as StepperIcon,
  jR as StepperSimple,
  SH as TableBasic,
  bde as TableData,
  AR as TableEmpty,
  DR as TableFooter,
  MR as TableHeader,
  TR as TableLoader,
  BR as TableMain,
  VR as TablePagination,
  fde as TableScrollHeader,
  vde as TableScrollMain,
  HR as TableShowPages,
  YR as TarjetBody,
  XR as TarjetFooter,
  KR as TarjetTitle,
  GR as TextOther,
  vP as Textarea,
  sr as Title,
  ZR as Toast,
  bH as Visrlink,
  Hde as closeDropdown,
  Fde as shootToast
};
